window._bkpRequestAnimationFrame = window.requestAnimationFrame;
(function(b, c) {
  'object' === typeof exports && 'object' === typeof module
    ? (module.exports = c())
    : 'function' === typeof define && define.amd
    ? define('pdfjs-dist/web/compatibility', [], c)
    : 'object' === typeof exports
    ? (exports['pdfjs-dist/web/compatibility'] = c())
    : (b['pdfjs-dist/web/compatibility'] = c());
})(this, function() {
  return (function(b) {
    function c(e) {
      if (a[e]) return a[e].exports;
      var d = (a[e] = { i: e, l: !1, exports: {} });
      b[e].call(d.exports, d, d.exports, c);
      d.l = !0;
      return d.exports;
    }
    var a = {};
    c.m = b;
    c.c = a;
    c.d = function(a, d, b) {
      c.o(a, d) || Object.defineProperty(a, d, { configurable: !1, enumerable: !0, get: b });
    };
    c.n = function(a) {
      var d =
        a && a.__esModule
          ? function() {
              return a['default'];
            }
          : function() {
              return a;
            };
      c.d(d, 'a', d);
      return d;
    };
    c.o = function(a, d) {
      return Object.prototype.hasOwnProperty.call(a, d);
    };
    c.p = '';
    return c((c.s = 44));
  })([
    function(b, c, a) {
      var e = a(39)('wks'),
        d = a(8),
        h = a(1).Symbol,
        f = 'function' == typeof h;
      (b.exports = function(a) {
        return e[a] || (e[a] = (f && h[a]) || (f ? h : d)('Symbol.' + a));
      }).store = e;
    },
    function(b, c, a) {
      b = b.exports =
        'undefined' != typeof window && Math == Math
          ? window
          : 'undefined' != typeof self && self.Math == Math
          ? self
          : Function('return this')();
      'number' == typeof __g && (__g = b);
    },
    function(b, c, a) {
      b.exports = !a(12)(function() {
        return (
          7 !=
          Object.defineProperty({}, 'a', {
            get: function() {
              return 7;
            },
          }).a
        );
      });
    },
    function(b, c, a) {
      var e = a(6),
        d = a(15);
      b.exports = a(2)
        ? function(a, b, k) {
            return e.f(a, b, d(1, k));
          }
        : function(a, d, e) {
            a[d] = e;
            return a;
          };
    },
    function(b, c, a) {
      var e = {}.hasOwnProperty;
      b.exports = function(a, b) {
        return e.call(a, b);
      };
    },
    function(b, c, a) {
      var e = a(9),
        d = Math.min;
      b.exports = function(a) {
        return 0 < a ? d(e(a), 9007199254740991) : 0;
      };
    },
    function(b, c, a) {
      var e = a(14),
        d = a(27),
        h = a(19),
        f = Object.defineProperty;
      c.f = a(2)
        ? Object.defineProperty
        : function(a, b, c) {
            e(a);
            b = h(b, !0);
            e(c);
            if (d)
              try {
                return f(a, b, c);
              } catch (m) {}
            if ('get' in c || 'set' in c) throw TypeError('Accessors not supported!');
            'value' in c && (a[b] = c.value);
            return a;
          };
    },
    function(b, c, a) {
      var e =
        'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
          ? function(a) {
              return typeof a;
            }
          : function(a) {
              return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                ? 'symbol'
                : typeof a;
            };
      b.exports = function(a) {
        return 'object' === ('undefined' === typeof a ? 'undefined' : e(a)) ? null !== a : 'function' === typeof a;
      };
    },
    function(b, c, a) {
      var e = 0,
        d = Math.random();
      b.exports = function(a) {
        return 'Symbol('.concat(void 0 === a ? '' : a, ')_', (++e + d).toString(36));
      };
    },
    function(b, c, a) {
      var e = Math.ceil,
        d = Math.floor;
      b.exports = function(a) {
        return isNaN((a = +a)) ? 0 : (0 < a ? d : e)(a);
      };
    },
    function(b, c, a) {
      var e = a(37);
      b.exports = function(a) {
        return Object(e(a));
      };
    },
    function(b, c, a) {
      b.exports = {};
    },
    function(b, c, a) {
      b.exports = function(a) {
        try {
          return !!a();
        } catch (d) {
          return !0;
        }
      };
    },
    function(b, c, a) {
      b = b.exports = { version: '2.5.1' };
      'number' == typeof __e && (__e = b);
    },
    function(b, c, a) {
      var e = a(7);
      b.exports = function(a) {
        if (!e(a)) throw TypeError(a + ' is not an object!');
        return a;
      };
    },
    function(b, c, a) {
      b.exports = function(a, d) {
        return { enumerable: !(a & 1), configurable: !(a & 2), writable: !(a & 4), value: d };
      };
    },
    function(b, c, a) {
      var e = a(36),
        d = a(37);
      b.exports = function(a) {
        return e(d(a));
      };
    },
    function(b, c, a) {
      var e = a(9),
        d = Math.max,
        h = Math.min;
      b.exports = function(a, b) {
        a = e(a);
        return 0 > a ? d(a + b, 0) : h(a, b);
      };
    },
    function(b, c, a) {
      b.exports = !1;
    },
    function(b, c, a) {
      var e = a(7);
      b.exports = function(a, b) {
        if (!e(a)) return a;
        var d, c;
        if (
          (b && 'function' == typeof (d = a.toString) && !e((c = d.call(a)))) ||
          ('function' == typeof (d = a.valueOf) && !e((c = d.call(a)))) ||
          (!b && 'function' == typeof (d = a.toString) && !e((c = d.call(a))))
        )
          return c;
        throw TypeError("Can't convert object to primitive value");
      };
    },
    function(b, c, a) {
      var e = a(1),
        d = a(3),
        h = a(4),
        f = a(8)('src'),
        k = Function.toString,
        n = ('' + k).split('toString');
      a(13).inspectSource = function(a) {
        return k.call(a);
      };
      (b.exports = function(a, b, c, k) {
        var q = 'function' == typeof c;
        q && (h(c, 'name') || d(c, 'name', b));
        a[b] !== c &&
          (q && (h(c, f) || d(c, f, a[b] ? '' + a[b] : n.join(String(b)))),
          a === e ? (a[b] = c) : k ? (a[b] ? (a[b] = c) : d(a, b, c)) : (delete a[b], d(a, b, c)));
      })(Function.prototype, 'toString', function() {
        return ('function' == typeof this && this[f]) || k.call(this);
      });
    },
    function(b, c, a) {
      var e = a(29);
      b.exports = function(a, b, c) {
        e(a);
        if (void 0 === b) return a;
        switch (c) {
          case 1:
            return function(d) {
              return a.call(b, d);
            };
          case 2:
            return function(d, e) {
              return a.call(b, d, e);
            };
          case 3:
            return function(d, e, c) {
              return a.call(b, d, e, c);
            };
        }
        return function() {
          return a.apply(b, arguments);
        };
      };
    },
    function(b, c, a) {
      var e = {}.toString;
      b.exports = function(a) {
        return e.call(a).slice(8, -1);
      };
    },
    function(b, c, a) {
      var e = a(39)('keys'),
        d = a(8);
      b.exports = function(a) {
        return e[a] || (e[a] = d(a));
      };
    },
    function(b, c, a) {
      b.exports = 'constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf'.split(
        ' ',
      );
    },
    function(b, c, a) {
      var e = a(6).f,
        d = a(4),
        h = a(0)('toStringTag');
      b.exports = function(a, b, c) {
        a && !d((a = c ? a : a.prototype), h) && e(a, h, { configurable: !0, value: b });
      };
    },
    function(b, c, a) {
      var e = a(1),
        d = a(13),
        h = a(3),
        f = a(20),
        k = a(21);
      c = function p(a, b, c) {
        var q = a & p.F,
          m = a & p.G,
          l = a & p.S,
          F = a & p.P,
          u = a & p.B;
        l = m ? e : l ? e[b] || (e[b] = {}) : (e[b] || {}).prototype;
        var y = m ? d : d[b] || (d[b] = {}),
          A = y.prototype || (y.prototype = {}),
          C;
        m && (c = b);
        for (C in c)
          (m = !q && l && void 0 !== l[C]),
            (b = (m ? l : c)[C]),
            (m = u && m ? k(b, e) : F && 'function' == typeof b ? k(Function.call, b) : b),
            l && f(l, C, b, a & p.U),
            y[C] != b && h(y, C, m),
            F && A[C] != b && (A[C] = b);
      };
      e.core = d;
      c.F = 1;
      c.G = 2;
      c.S = 4;
      c.P = 8;
      c.B = 16;
      c.W = 32;
      c.U = 64;
      c.R = 128;
      b.exports = c;
    },
    function(b, c, a) {
      b.exports =
        !a(2) &&
        !a(12)(function() {
          return (
            7 !=
            Object.defineProperty(a(28)('div'), 'a', {
              get: function() {
                return 7;
              },
            }).a
          );
        });
    },
    function(b, c, a) {
      c = a(7);
      var e = a(1).document,
        d = c(e) && c(e.createElement);
      b.exports = function(a) {
        return d ? e.createElement(a) : {};
      };
    },
    function(b, c, a) {
      b.exports = function(a) {
        if ('function' != typeof a) throw TypeError(a + ' is not a function!');
        return a;
      };
    },
    function(b, c, a) {
      c = a(1);
      var e = a(3),
        d = a(8);
      a = d('typed_array');
      d = d('view');
      for (
        var h = !(!c.ArrayBuffer || !c.DataView),
          f = h,
          k = 0,
          n,
          q = 'Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array'.split(
            ' ',
          );
        9 > k;

      )
        (n = c[q[k++]]) ? (e(n.prototype, a, !0), e(n.prototype, d, !0)) : (f = !1);
      b.exports = { ABV: h, CONSTR: f, TYPED: a, VIEW: d };
    },
    function(b, c, a) {
      var e = a(20);
      b.exports = function(a, b, c) {
        for (var d in b) e(a, d, b[d], c);
        return a;
      };
    },
    function(b, c, a) {
      b.exports = function(a, b, c, f) {
        if (!(a instanceof b) || (void 0 !== f && f in a)) throw TypeError(c + ': incorrect invocation!');
        return a;
      };
    },
    function(b, c, a) {
      var e = a(9),
        d = a(5);
      b.exports = function(a) {
        if (void 0 === a) return 0;
        a = e(a);
        var b = d(a);
        if (a !== b) throw RangeError('Wrong length!');
        return b;
      };
    },
    function(b, c, a) {
      var e = a(35),
        d = a(24).concat('length', 'prototype');
      c.f =
        Object.getOwnPropertyNames ||
        function(a) {
          return e(a, d);
        };
    },
    function(b, c, a) {
      var e = a(4),
        d = a(16),
        h = a(38)(!1),
        f = a(23)('IE_PROTO');
      b.exports = function(a, b) {
        var c = d(a),
          k = 0,
          n = [],
          p;
        for (p in c) p != f && e(c, p) && n.push(p);
        for (; b.length > k; ) e(c, (p = b[k++])) && (~h(n, p) || n.push(p));
        return n;
      };
    },
    function(b, c, a) {
      var e = a(22);
      b.exports = Object('z').propertyIsEnumerable(0)
        ? Object
        : function(a) {
            return 'String' == e(a) ? a.split('') : Object(a);
          };
    },
    function(b, c, a) {
      b.exports = function(a) {
        if (void 0 == a) throw TypeError("Can't call method on  " + a);
        return a;
      };
    },
    function(b, c, a) {
      var e = a(16),
        d = a(5),
        h = a(17);
      b.exports = function(a) {
        return function(b, c, f) {
          b = e(b);
          var k = d(b.length);
          f = h(f, k);
          if (a && c != c)
            for (; k > f; ) {
              if (((c = b[f++]), c != c)) return !0;
            }
          else for (; k > f; f++) if ((a || f in b) && b[f] === c) return a || f || 0;
          return !a && -1;
        };
      };
    },
    function(b, c, a) {
      c = a(1);
      var e = c['__core-js_shared__'] || (c['__core-js_shared__'] = {});
      b.exports = function(a) {
        return e[a] || (e[a] = {});
      };
    },
    function(b, c, a) {
      var e = a(10),
        d = a(17),
        h = a(5);
      b.exports = function(a) {
        var b = e(this),
          c = h(b.length),
          f = arguments.length,
          m = d(1 < f ? arguments[1] : void 0, c);
        f = 2 < f ? arguments[2] : void 0;
        for (c = void 0 === f ? c : d(f, c); c > m; ) b[m++] = a;
        return b;
      };
    },
    function(b, c, a) {
      var e = a(22),
        d = a(0)('toStringTag'),
        h =
          'Arguments' ==
          e(
            (function() {
              return arguments;
            })(),
          );
      b.exports = function(a) {
        var b;
        if (void 0 === a) var c = 'Undefined';
        else {
          if (null === a) var f = 'Null';
          else {
            a: {
              var m = (a = Object(a));
              try {
                f = m[d];
                break a;
              } catch (t) {}
              f = void 0;
            }
            f =
              'string' == typeof (c = f)
                ? c
                : h
                ? e(a)
                : 'Object' == (b = e(a)) && 'function' == typeof a.callee
                ? 'Arguments'
                : b;
          }
          c = f;
        }
        return c;
      };
    },
    function(b, c, a) {
      var e = a(14),
        d = a(52),
        h = a(24),
        f = a(23)('IE_PROTO'),
        k = function() {},
        n = function() {
          var b = a(28)('iframe'),
            c = h.length;
          b.style.display = 'none';
          a(54).appendChild(b);
          b.src = 'javascript:';
          b = b.contentWindow.document;
          b.open();
          b.write('<script>document.F=Object\x3c/script>');
          b.close();
          for (n = b.F; c--; ) delete n.prototype[h[c]];
          return n();
        };
      b.exports =
        Object.create ||
        function(a, b) {
          if (null !== a) {
            k.prototype = e(a);
            var c = new k();
            k.prototype = null;
            c[f] = a;
          } else c = n();
          return void 0 === b ? c : d(c, b);
        };
    },
    function(b, c, a) {
      var e = a(4),
        d = a(10),
        h = a(23)('IE_PROTO'),
        f = Object.prototype;
      b.exports =
        Object.getPrototypeOf ||
        function(a) {
          a = d(a);
          return e(a, h)
            ? a[h]
            : 'function' == typeof a.constructor && a instanceof a.constructor
            ? a.constructor.prototype
            : a instanceof Object
            ? f
            : null;
        };
    },
    function(b, c, a) {
      a(45);
    },
    function(b, c, a) {
      var e =
        'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
          ? function(a) {
              return typeof a;
            }
          : function(a) {
              return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                ? 'symbol'
                : typeof a;
            };
      if ('undefined' === typeof PDFJS || !PDFJS.compatibilityChecked) {
        var d = a(46),
          h = ('undefined' !== typeof navigator && navigator.userAgent) || '',
          f = /Android/.test(h);
        b = /Android\s[0-2][^\d]/.test(h);
        var k = /Android\s[0-4][^\d]/.test(h),
          n = 0 <= h.indexOf('Chrom');
        c = /Chrome\/(39|40)\./.test(h);
        var q = 0 <= h.indexOf('CriOS'),
          m = 0 <= h.indexOf('Trident'),
          t = /\b(iPad|iPhone|iPod)(?=;)/.test(h),
          p = 0 <= h.indexOf('Opera'),
          v = /Safari\//.test(h) && !/(Chrome\/|Android\s)/.test(h),
          w =
            'object' === ('undefined' === typeof window ? 'undefined' : e(window)) &&
            'object' === ('undefined' === typeof document ? 'undefined' : e(document));
        'undefined' === typeof PDFJS && (d.PDFJS = {});
        PDFJS.compatibilityChecked = !0;
        (function() {
          function b(a, b) {
            return new f(this.slice(a, b));
          }
          function c(a, b) {
            2 > arguments.length && (b = 0);
            for (var c = 0, d = a.length; c < d; ++c, ++b) this[b] = a[c] & 255;
          }
          function u(a, b) {
            this.buffer = a;
            this.byteLength = a.length;
            for (var c = (this.length = b); k < c; ) Object.defineProperty(u.prototype, k, y(k)), k++;
          }
          function y(a) {
            return {
              get: function() {
                var b = this.buffer,
                  c = a << 2;
                return (b[c] | (b[c + 1] << 8) | (b[c + 2] << 16) | (b[c + 3] << 24)) >>> 0;
              },
              set: function(b) {
                var c = this.buffer,
                  d = a << 2;
                c[d] = b & 255;
                c[d + 1] = (b >> 8) & 255;
                c[d + 2] = (b >> 16) & 255;
                c[d + 3] = (b >>> 24) & 255;
              },
            };
          }
          function f(a) {
            var d, u;
            if ('number' === typeof a) {
              var l = [];
              for (d = 0; d < a; ++d) l[d] = 0;
            } else if ('slice' in a) l = a.slice(0);
            else for (l = [], d = 0, u = a.length; d < u; ++d) l[d] = a[d];
            l.subarray = b;
            l.buffer = l;
            l.byteLength = l.length;
            l.set = c;
            'object' === ('undefined' === typeof a ? 'undefined' : e(a)) && a.buffer && (l.buffer = a.buffer);
            return l;
          }
          'undefined' === typeof Uint8ClampedArray && (d.Uint8ClampedArray = a(47));
          if ('undefined' !== typeof Uint8Array)
            'undefined' === typeof Uint8Array.prototype.subarray &&
              ((Uint8Array.prototype.subarray = function(a, b) {
                return new Uint8Array(this.slice(a, b));
              }),
              (Float32Array.prototype.subarray = function(a, b) {
                return new Float32Array(this.slice(a, b));
              })),
              'undefined' === typeof Float64Array && (d.Float64Array = Float32Array);
          else {
            u.prototype = Object.create(null);
            var k = 0;
            d.Uint8Array = f;
            d.Int8Array = f;
            d.Int32Array = f;
            d.Uint16Array = f;
            d.Float32Array = f;
            d.Float64Array = f;
            d.Uint32Array = function() {
              if (3 === arguments.length) {
                if (0 !== arguments[1]) throw Error('offset !== 0 is not supported');
                return new u(arguments[0], arguments[2]);
              }
              return f.apply(this, arguments);
            };
          }
        })();
        (function() {
          if (w && window.CanvasPixelArray) {
            var a = window.CanvasPixelArray.prototype;
            'buffer' in a ||
              (Object.defineProperty(a, 'buffer', {
                get: function() {
                  return this;
                },
                enumerable: !1,
                configurable: !0,
              }),
              Object.defineProperty(a, 'byteLength', {
                get: function() {
                  return this.length;
                },
                enumerable: !1,
                configurable: !0,
              }));
          }
        })();
        d.URL || (d.URL = d.webkitURL);
        (function() {
          if ('undefined' !== typeof Object.defineProperty) {
            var a = !0;
            try {
              w && Object.defineProperty(new Image(), 'id', { value: 'test' });
              var b = function() {};
              b.prototype = { get id() {} };
              Object.defineProperty(new b(), 'id', { value: '', configurable: !0, enumerable: !0, writable: !1 });
            } catch (u) {
              a = !1;
            }
            if (a) return;
          }
          Object.defineProperty = function(a, b, c) {
            delete a[b];
            'get' in c && a.__defineGetter__(b, c.get);
            'set' in c && a.__defineSetter__(b, c.set);
            'value' in c &&
              (a.__defineSetter__(b, function(a) {
                this.__defineGetter__(b, function() {
                  return a;
                });
                return a;
              }),
              (a[b] = c.value));
          };
        })();
        (function() {
          if ('undefined' !== typeof XMLHttpRequest) {
            var a = XMLHttpRequest.prototype,
              b = new XMLHttpRequest();
            'overrideMimeType' in b || Object.defineProperty(a, 'overrideMimeType', { value: function(a) {} });
            'responseType' in b ||
              (Object.defineProperty(a, 'responseType', {
                get: function() {
                  return this._responseType || 'text';
                },
                set: function(a) {
                  if ('text' === a || 'arraybuffer' === a)
                    (this._responseType = a),
                      'arraybuffer' === a &&
                        'function' === typeof this.overrideMimeType &&
                        this.overrideMimeType('text/plain; charset=x-user-defined');
                },
              }),
              'undefined' !== typeof VBArray
                ? Object.defineProperty(a, 'response', {
                    get: function() {
                      return 'arraybuffer' === this.responseType
                        ? new Uint8Array(new VBArray(this.responseBody).toArray())
                        : this.responseText;
                    },
                  })
                : Object.defineProperty(a, 'response', {
                    get: function() {
                      if ('arraybuffer' !== this.responseType) return this.responseText;
                      var a = this.responseText,
                        b,
                        c = a.length,
                        d = new Uint8Array(c);
                      for (b = 0; b < c; ++b) d[b] = a.charCodeAt(b) & 255;
                      return d.buffer;
                    },
                  }));
          }
        })();
        (function() {
          'btoa' in d ||
            (d.btoa = function(a) {
              var b = '',
                c;
              var d = 0;
              for (c = a.length; d < c; d += 3) {
                var e = a.charCodeAt(d) & 255,
                  l = a.charCodeAt(d + 1) & 255,
                  f = a.charCodeAt(d + 2) & 255,
                  k = ((e & 3) << 4) | (l >> 4);
                l = d + 1 < c ? ((l & 15) << 2) | (f >> 6) : 64;
                f = d + 2 < c ? f & 63 : 64;
                b +=
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.charAt(e >> 2) +
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.charAt(k) +
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.charAt(l) +
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.charAt(f);
              }
              return b;
            });
        })();
        (function() {
          'atob' in d ||
            (d.atob = function(a) {
              a = a.replace(/=+$/, '');
              if (1 === a.length % 4) throw Error('bad atob input');
              for (
                var b = 0, c, d, e = 0, f = '';
                (d = a.charAt(e++));
                ~d && ((c = b % 4 ? 64 * c + d : d), b++ % 4)
                  ? (f += String.fromCharCode(255 & (c >> ((-2 * b) & 6))))
                  : 0
              )
                d = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.indexOf(d);
              return f;
            });
        })();
        (function() {
          'undefined' === typeof Function.prototype.bind &&
            (Function.prototype.bind = function(a) {
              var b = this,
                c = Array.prototype.slice.call(arguments, 1);
              return function() {
                var d = c.concat(Array.prototype.slice.call(arguments));
                return b.apply(a, d);
              };
            });
        })();
        (function() {
          w &&
            ('dataset' in document.createElement('div') ||
              Object.defineProperty(HTMLElement.prototype, 'dataset', {
                get: function() {
                  if (this._dataset) return this._dataset;
                  for (var a = {}, b = 0, c = this.attributes.length; b < c; b++) {
                    var d = this.attributes[b];
                    if ('data-' === d.name.substring(0, 5)) {
                      var e = d.name.substring(5).replace(/\-([a-z])/g, function(a, b) {
                        return b.toUpperCase();
                      });
                      a[e] = d.value;
                    }
                  }
                  Object.defineProperty(this, '_dataset', { value: a, writable: !1, enumerable: !1 });
                  return a;
                },
                enumerable: !0,
              }));
        })();
        (function() {
          function a(a, b, c, d) {
            var e = (a.className || '').split(/\s+/g);
            '' === e[0] && e.shift();
            var u = e.indexOf(b);
            0 > u && c && e.push(b);
            0 <= u && d && e.splice(u, 1);
            a.className = e.join(' ');
            return 0 <= u;
          }
          if (w && !('classList' in document.createElement('div'))) {
            var b = {
              add: function(b) {
                a(this.element, b, !0, !1);
              },
              contains: function(b) {
                return a(this.element, b, !1, !1);
              },
              remove: function(b) {
                a(this.element, b, !1, !0);
              },
              toggle: function(b) {
                a(this.element, b, !0, !0);
              },
            };
            Object.defineProperty(HTMLElement.prototype, 'classList', {
              get: function() {
                if (this._classList) return this._classList;
                var a = Object.create(b, { element: { value: this, writable: !1, enumerable: !0 } });
                Object.defineProperty(this, '_classList', { value: a, writable: !1, enumerable: !1 });
                return a;
              },
              enumerable: !0,
            });
          }
        })();
        (function() {
          if (!('undefined' === typeof importScripts || 'console' in d)) {
            var a = {};
            d.console = {
              log: function() {
                var a = Array.prototype.slice.call(arguments);
                d.postMessage({ targetName: 'main', action: 'console_log', data: a });
              },
              error: function() {
                var a = Array.prototype.slice.call(arguments);
                d.postMessage({ targetName: 'main', action: 'console_error', data: a });
              },
              time: function(b) {
                a[b] = Date.now();
              },
              timeEnd: function(b) {
                var c = a[b];
                if (!c) throw Error('Unknown timer name ' + b);
                this.log('Timer:', b, Date.now() - c);
              },
            };
          }
        })();
        (function() {
          w &&
            ('console' in window
              ? 'bind' in console.log ||
                ((console.log = (function(a) {
                  return function(b) {
                    return a(b);
                  };
                })(console.log)),
                (console.error = (function(a) {
                  return function(b) {
                    return a(b);
                  };
                })(console.error)),
                (console.warn = (function(a) {
                  return function(b) {
                    return a(b);
                  };
                })(console.warn)))
              : (window.console = { log: function() {}, error: function() {}, warn: function() {} }));
        })();
        (function() {
          function a(a) {
            b(a.target) && a.stopPropagation();
          }
          function b(a) {
            return a.disabled || (a.parentNode && b(a.parentNode));
          }
          p && document.addEventListener('click', a, !0);
        })();
        if (m || q) PDFJS.disableCreateObjectURL = !0;
        'undefined' === typeof navigator ||
          'language' in navigator ||
          (PDFJS.locale = navigator.userLanguage || 'en-US');
        if (v || b || c || t) (PDFJS.disableRange = !0), (PDFJS.disableStream = !0);
        !w || (history.pushState && !b) || (PDFJS.disableHistory = !0);
        (function() {
          if (w)
            if (window.CanvasPixelArray)
              'function' !== typeof window.CanvasPixelArray.prototype.set &&
                (window.CanvasPixelArray.prototype.set = function(a) {
                  for (var b = 0, c = this.length; b < c; b++) this[b] = a[b];
                });
            else {
              var a = !1;
              n
                ? (a = (a = h.match(/Chrom(e|ium)\/([0-9]+)\./)) && 21 > parseInt(a[2]))
                : f
                ? (a = k)
                : v && (a = (a = h.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//)) && 6 > parseInt(a[1]));
              if (a) {
                a = window.CanvasRenderingContext2D.prototype;
                var b = a.createImageData;
                a.createImageData = function(a, c) {
                  var d = b.call(this, a, c);
                  d.data.set = function(a) {
                    for (var b = 0, c = this.length; b < c; b++) this[b] = a[b];
                  };
                  return d;
                };
                a = null;
              }
            }
        })();
        (function() {
          function a() {
            window.requestAnimationFrame = function(a) {
              return window.setTimeout(a, 20);
            };
            window.cancelAnimationFrame = function(a) {
              window.clearTimeout(a);
            };
          }
          w &&
            (t
              ? a()
              : 'requestAnimationFrame' in window ||
                ((window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame),
                window.requestAnimationFrame || a()));
        })();
        if (t || f) PDFJS.maxCanvasPixels = 5242880;
        w && m && window.parent !== window && (PDFJS.disableFullscreen = !0);
        (function() {
          w &&
            ('currentScript' in document ||
              Object.defineProperty(document, 'currentScript', {
                get: function() {
                  var a = document.getElementsByTagName('script');
                  return a[a.length - 1];
                },
                enumerable: !0,
                configurable: !0,
              }));
        })();
        (function() {
          if (w) {
            var a = document.createElement('input');
            try {
              a.type = 'number';
            } catch (u) {
              a = a.constructor.prototype;
              var b = Object.getOwnPropertyDescriptor(a, 'type');
              Object.defineProperty(a, 'type', {
                get: function() {
                  return b.get.call(this);
                },
                set: function(a) {
                  b.set.call(this, 'number' === a ? 'text' : a);
                },
                enumerable: !0,
                configurable: !0,
              });
            }
          }
        })();
        (function() {
          if (w && document.attachEvent) {
            var a = document.constructor.prototype,
              b = Object.getOwnPropertyDescriptor(a, 'readyState');
            Object.defineProperty(a, 'readyState', {
              get: function() {
                var a = b.get.call(this);
                return 'interactive' === a ? 'loading' : a;
              },
              set: function(a) {
                b.set.call(this, a);
              },
              enumerable: !0,
              configurable: !0,
            });
          }
        })();
        (function() {
          w &&
            'undefined' === typeof Element.prototype.remove &&
            (Element.prototype.remove = function() {
              this.parentNode && this.parentNode.removeChild(this);
            });
        })();
        (function() {
          Number.isNaN ||
            (Number.isNaN = function(a) {
              return 'number' === typeof a && isNaN(a);
            });
        })();
        (function() {
          Number.isInteger ||
            (Number.isInteger = function(a) {
              return 'number' === typeof a && isFinite(a) && Math.floor(a) === a;
            });
        })();
        (function() {
          if (d.Promise)
            'function' !== typeof d.Promise.all &&
              (d.Promise.all = function(a) {
                var b = 0,
                  c = [],
                  e,
                  f,
                  k = new d.Promise(function(a, b) {
                    e = a;
                    f = b;
                  });
                a.forEach(function(a, d) {
                  b++;
                  a.then(function(a) {
                    c[d] = a;
                    b--;
                    0 === b && e(c);
                  }, f);
                });
                0 === b && e(c);
                return k;
              }),
              'function' !== typeof d.Promise.resolve &&
                (d.Promise.resolve = function(a) {
                  return new d.Promise(function(b) {
                    b(a);
                  });
                }),
              'function' !== typeof d.Promise.reject &&
                (d.Promise.reject = function(a) {
                  return new d.Promise(function(b, c) {
                    c(a);
                  });
                }),
              'function' !== typeof d.Promise.prototype['catch'] &&
                (d.Promise.prototype['catch'] = function(a) {
                  return d.Promise.prototype.then(void 0, a);
                });
          else {
            var a = {
                handlers: [],
                running: !1,
                unhandledRejections: [],
                pendingRejectionCheck: !1,
                scheduleHandlers: function(a) {
                  0 !== a._status &&
                    ((this.handlers = this.handlers.concat(a._handlers)),
                    (a._handlers = []),
                    this.running || ((this.running = !0), setTimeout(this.runHandlers.bind(this), 0)));
                },
                runHandlers: function() {
                  for (var a = Date.now() + 1; 0 < this.handlers.length; ) {
                    var b = this.handlers.shift(),
                      c = b.thisPromise._status,
                      d = b.thisPromise._value;
                    try {
                      1 === c
                        ? 'function' === typeof b.onResolve && (d = b.onResolve(d))
                        : 'function' === typeof b.onReject &&
                          ((d = b.onReject(d)),
                          (c = 1),
                          b.thisPromise._unhandledRejection && this.removeUnhandeledRejection(b.thisPromise));
                    } catch (H) {
                      (c = 2), (d = H);
                    }
                    b.nextPromise._updateStatus(c, d);
                    if (Date.now() >= a) break;
                  }
                  0 < this.handlers.length ? setTimeout(this.runHandlers.bind(this), 0) : (this.running = !1);
                },
                addUnhandledRejection: function(a) {
                  this.unhandledRejections.push({ promise: a, time: Date.now() });
                  this.scheduleRejectionCheck();
                },
                removeUnhandeledRejection: function(a) {
                  a._unhandledRejection = !1;
                  for (var b = 0; b < this.unhandledRejections.length; b++)
                    this.unhandledRejections[b].promise === a && (this.unhandledRejections.splice(b), b--);
                },
                scheduleRejectionCheck: function() {
                  var a = this;
                  this.pendingRejectionCheck ||
                    ((this.pendingRejectionCheck = !0),
                    setTimeout(function() {
                      a.pendingRejectionCheck = !1;
                      for (var b = Date.now(), c = 0; c < a.unhandledRejections.length; c++)
                        if (500 < b - a.unhandledRejections[c].time) {
                          var d = a.unhandledRejections[c].promise._value,
                            e = 'Unhandled rejection: ' + d;
                          d.stack && (e += '\n' + d.stack);
                          try {
                            throw Error(e);
                          } catch (U) {
                            console.warn(e);
                          }
                          a.unhandledRejections.splice(c);
                          c--;
                        }
                      a.unhandledRejections.length && a.scheduleRejectionCheck();
                    }, 500));
                },
              },
              b = function(a) {
                this._status = 0;
                this._handlers = [];
                try {
                  a.call(this, this._resolve.bind(this), this._reject.bind(this));
                } catch (y) {
                  this._reject(y);
                }
              };
            b.all = function(a) {
              function c(a) {
                2 !== f._status && ((h = []), e(a));
              }
              var d,
                e,
                f = new b(function(a, b) {
                  d = a;
                  e = b;
                }),
                k = a.length,
                h = [];
              if (0 === k) return d(h), f;
              for (var u = 0, n = a.length; u < n; ++u) {
                var l = a[u],
                  m = (function(a) {
                    return function(b) {
                      2 !== f._status && ((h[a] = b), k--, 0 === k && d(h));
                    };
                  })(u);
                b.isPromise(l) ? l.then(m, c) : m(l);
              }
              return f;
            };
            b.isPromise = function(a) {
              return a && 'function' === typeof a.then;
            };
            b.resolve = function(a) {
              return new b(function(b) {
                b(a);
              });
            };
            b.reject = function(a) {
              return new b(function(b, c) {
                c(a);
              });
            };
            b.prototype = {
              _status: null,
              _value: null,
              _handlers: null,
              _unhandledRejection: null,
              _updateStatus: function(c, d) {
                1 !== this._status &&
                  2 !== this._status &&
                  (1 === c && b.isPromise(d)
                    ? d.then(this._updateStatus.bind(this, 1), this._updateStatus.bind(this, 2))
                    : ((this._status = c),
                      (this._value = d),
                      2 === c &&
                        0 === this._handlers.length &&
                        ((this._unhandledRejection = !0), a.addUnhandledRejection(this)),
                      a.scheduleHandlers(this)));
              },
              _resolve: function(a) {
                this._updateStatus(1, a);
              },
              _reject: function(a) {
                this._updateStatus(2, a);
              },
              then: function(c, d) {
                var e = new b(function(a, b) {
                  this.resolve = a;
                  this.reject = b;
                });
                this._handlers.push({ thisPromise: this, onResolve: c, onReject: d, nextPromise: e });
                a.scheduleHandlers(this);
                return e;
              },
              catch: function(a) {
                return this.then(void 0, a);
              },
            };
            d.Promise = b;
          }
        })();
        (function() {
          function a() {
            this.id = '$weakmap' + b++;
          }
          if (!d.WeakMap) {
            var b = 0;
            a.prototype = {
              has: function(a) {
                return ('object' !== ('undefined' === typeof a ? 'undefined' : e(a)) && 'function' !== typeof a) ||
                  null === a
                  ? !1
                  : !!Object.getOwnPropertyDescriptor(a, this.id);
              },
              get: function(a) {
                return this.has(a) ? a[this.id] : void 0;
              },
              set: function(a, b) {
                Object.defineProperty(a, this.id, { value: b, enumerable: !1, configurable: !0 });
              },
              delete: function(a) {
                delete a[this.id];
              },
            };
            d.WeakMap = a;
          }
        })();
        (function() {
          function a(a) {
            '' === a && (k.call(this), (this._isInvalid = !0));
            return a.toLowerCase();
          }
          function b(a) {
            var b = a.charCodeAt(0);
            return 32 < b && 127 > b && -1 === [34, 35, 60, 62, 63, 96].indexOf(b) ? a : encodeURIComponent(a);
          }
          function c(a) {
            var b = a.charCodeAt(0);
            return 32 < b && 127 > b && -1 === [34, 35, 60, 62, 96].indexOf(b) ? a : encodeURIComponent(a);
          }
          function f(d, e, f) {
            function h(a) {
              w.push(a);
            }
            var n = e || 'scheme start',
              m = 0,
              l = '',
              D = !1,
              u = !1,
              w = [];
            a: for (; (d[m - 1] !== t || 0 === m) && !this._isInvalid; ) {
              var g = d[m];
              switch (n) {
                case 'scheme start':
                  if (g && v.test(g)) (l += g.toLowerCase()), (n = 'scheme');
                  else if (e) {
                    h('Invalid scheme.');
                    break a;
                  } else {
                    l = '';
                    n = 'no scheme';
                    continue;
                  }
                  break;
                case 'scheme':
                  if (g && x.test(g)) l += g.toLowerCase();
                  else if (':' === g) {
                    this._scheme = l;
                    l = '';
                    if (e) break a;
                    void 0 !== q[this._scheme] && (this._isRelative = !0);
                    n =
                      'file' === this._scheme
                        ? 'relative'
                        : this._isRelative && f && f._scheme === this._scheme
                        ? 'relative or authority'
                        : this._isRelative
                        ? 'authority first slash'
                        : 'scheme data';
                  } else if (e) {
                    g !== t && h('Code point not allowed in scheme: ' + g);
                    break a;
                  } else {
                    l = '';
                    m = 0;
                    n = 'no scheme';
                    continue;
                  }
                  break;
                case 'scheme data':
                  '?' === g
                    ? ((this._query = '?'), (n = 'query'))
                    : '#' === g
                    ? ((this._fragment = '#'), (n = 'fragment'))
                    : g !== t && '\t' !== g && '\n' !== g && '\r' !== g && (this._schemeData += b(g));
                  break;
                case 'no scheme':
                  if (f && void 0 !== q[f._scheme]) {
                    n = 'relative';
                    continue;
                  } else h('Missing scheme.'), k.call(this), (this._isInvalid = !0);
                  break;
                case 'relative or authority':
                  if ('/' === g && '/' === d[m + 1]) n = 'authority ignore slashes';
                  else {
                    h('Expected /, got: ' + g);
                    n = 'relative';
                    continue;
                  }
                  break;
                case 'relative':
                  this._isRelative = !0;
                  'file' !== this._scheme && (this._scheme = f._scheme);
                  if (g === t) {
                    this._host = f._host;
                    this._port = f._port;
                    this._path = f._path.slice();
                    this._query = f._query;
                    this._username = f._username;
                    this._password = f._password;
                    break a;
                  } else if ('/' === g || '\\' === g)
                    '\\' === g && h('\\ is an invalid code point.'), (n = 'relative slash');
                  else if ('?' === g)
                    (this._host = f._host),
                      (this._port = f._port),
                      (this._path = f._path.slice()),
                      (this._query = '?'),
                      (this._username = f._username),
                      (this._password = f._password),
                      (n = 'query');
                  else if ('#' === g)
                    (this._host = f._host),
                      (this._port = f._port),
                      (this._path = f._path.slice()),
                      (this._query = f._query),
                      (this._fragment = '#'),
                      (this._username = f._username),
                      (this._password = f._password),
                      (n = 'fragment');
                  else {
                    n = d[m + 1];
                    var r = d[m + 2];
                    if (
                      'file' !== this._scheme ||
                      !v.test(g) ||
                      (':' !== n && '|' !== n) ||
                      (r !== t && '/' !== r && '\\' !== r && '?' !== r && '#' !== r)
                    )
                      (this._host = f._host),
                        (this._port = f._port),
                        (this._username = f._username),
                        (this._password = f._password),
                        (this._path = f._path.slice()),
                        this._path.pop();
                    n = 'relative path';
                    continue;
                  }
                  break;
                case 'relative slash':
                  if ('/' === g || '\\' === g)
                    '\\' === g && h('\\ is an invalid code point.'),
                      (n = 'file' === this._scheme ? 'file host' : 'authority ignore slashes');
                  else {
                    'file' !== this._scheme &&
                      ((this._host = f._host),
                      (this._port = f._port),
                      (this._username = f._username),
                      (this._password = f._password));
                    n = 'relative path';
                    continue;
                  }
                  break;
                case 'authority first slash':
                  if ('/' === g) n = 'authority second slash';
                  else {
                    h("Expected '/', got: " + g);
                    n = 'authority ignore slashes';
                    continue;
                  }
                  break;
                case 'authority second slash':
                  n = 'authority ignore slashes';
                  if ('/' !== g) {
                    h("Expected '/', got: " + g);
                    continue;
                  }
                  break;
                case 'authority ignore slashes':
                  if ('/' !== g && '\\' !== g) {
                    n = 'authority';
                    continue;
                  } else h('Expected authority, got: ' + g);
                  break;
                case 'authority':
                  if ('@' === g) {
                    D && (h('@ already seen.'), (l += '%40'));
                    D = !0;
                    for (g = 0; g < l.length; g++)
                      (r = l[g]),
                        '\t' === r || '\n' === r || '\r' === r
                          ? h('Invalid whitespace in authority.')
                          : ':' === r && null === this._password
                          ? (this._password = '')
                          : ((r = b(r)), null !== this._password ? (this._password += r) : (this._username += r));
                    l = '';
                  } else if (g === t || '/' === g || '\\' === g || '?' === g || '#' === g) {
                    m -= l.length;
                    l = '';
                    n = 'host';
                    continue;
                  } else l += g;
                  break;
                case 'file host':
                  if (g === t || '/' === g || '\\' === g || '?' === g || '#' === g) {
                    2 !== l.length || !v.test(l[0]) || (':' !== l[1] && '|' !== l[1])
                      ? (0 !== l.length && ((this._host = a.call(this, l)), (l = '')), (n = 'relative path start'))
                      : (n = 'relative path');
                    continue;
                  } else '\t' === g || '\n' === g || '\r' === g ? h('Invalid whitespace in file host.') : (l += g);
                  break;
                case 'host':
                case 'hostname':
                  if (':' !== g || u)
                    if (g === t || '/' === g || '\\' === g || '?' === g || '#' === g) {
                      this._host = a.call(this, l);
                      l = '';
                      n = 'relative path start';
                      if (e) break a;
                      continue;
                    } else
                      '\t' !== g && '\n' !== g && '\r' !== g
                        ? ('[' === g ? (u = !0) : ']' === g && (u = !1), (l += g))
                        : h('Invalid code point in host/hostname: ' + g);
                  else if (((this._host = a.call(this, l)), (l = ''), (n = 'port'), 'hostname' === e)) break a;
                  break;
                case 'port':
                  if (/[0-9]/.test(g)) l += g;
                  else if (g === t || '/' === g || '\\' === g || '?' === g || '#' === g || e) {
                    '' !== l && ((l = parseInt(l, 10)), l !== q[this._scheme] && (this._port = l + ''), (l = ''));
                    if (e) break a;
                    n = 'relative path start';
                    continue;
                  } else
                    '\t' === g || '\n' === g || '\r' === g
                      ? h('Invalid code point in port: ' + g)
                      : (k.call(this), (this._isInvalid = !0));
                  break;
                case 'relative path start':
                  '\\' === g && h("'\\' not allowed in path.");
                  n = 'relative path';
                  if ('/' !== g && '\\' !== g) continue;
                  break;
                case 'relative path':
                  if (g !== t && '/' !== g && '\\' !== g && (e || ('?' !== g && '#' !== g)))
                    '\t' !== g && '\n' !== g && '\r' !== g && (l += b(g));
                  else {
                    '\\' === g && h('\\ not allowed in relative path.');
                    if ((r = p[l.toLowerCase()])) l = r;
                    '..' === l
                      ? (this._path.pop(), '/' !== g && '\\' !== g && this._path.push(''))
                      : '.' === l && '/' !== g && '\\' !== g
                      ? this._path.push('')
                      : '.' !== l &&
                        ('file' === this._scheme &&
                          0 === this._path.length &&
                          2 === l.length &&
                          v.test(l[0]) &&
                          '|' === l[1] &&
                          (l = l[0] + ':'),
                        this._path.push(l));
                    l = '';
                    '?' === g
                      ? ((this._query = '?'), (n = 'query'))
                      : '#' === g && ((this._fragment = '#'), (n = 'fragment'));
                  }
                  break;
                case 'query':
                  e || '#' !== g
                    ? g !== t && '\t' !== g && '\n' !== g && '\r' !== g && (this._query += c(g))
                    : ((this._fragment = '#'), (n = 'fragment'));
                  break;
                case 'fragment':
                  g !== t && '\t' !== g && '\n' !== g && '\r' !== g && (this._fragment += g);
              }
              m++;
            }
          }
          function k() {
            this._username = this._schemeData = this._scheme = '';
            this._password = null;
            this._port = this._host = '';
            this._path = [];
            this._fragment = this._query = '';
            this._isRelative = this._isInvalid = !1;
          }
          function h(a, b) {
            void 0 === b || b instanceof h || (b = new h(String(b)));
            this._url = a;
            k.call(this);
            var c = a.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
            f.call(this, c, null, b);
          }
          var n = !1;
          try {
            if ('function' === typeof URL && 'object' === e(URL.prototype) && 'origin' in URL.prototype) {
              var m = new URL('b', 'http://a');
              m.pathname = 'c%20d';
              n = 'http://a/c%20d' === m.href;
            }
          } catch (D) {}
          if (!n) {
            var q = Object.create(null);
            q.ftp = 21;
            q.file = 0;
            q.gopher = 70;
            q.http = 80;
            q.https = 443;
            q.ws = 80;
            q.wss = 443;
            var p = Object.create(null);
            p['%2e'] = '.';
            p['.%2e'] = '..';
            p['%2e.'] = '..';
            p['%2e%2e'] = '..';
            var t,
              v = /[a-zA-Z]/,
              x = /[a-zA-Z0-9\+\-\.]/;
            h.prototype = {
              toString: function() {
                return this.href;
              },
              get href() {
                if (this._isInvalid) return this._url;
                var a = '';
                if ('' !== this._username || null !== this._password)
                  a = this._username + (null !== this._password ? ':' + this._password : '') + '@';
                return (
                  this.protocol +
                  (this._isRelative ? '//' + a + this.host : '') +
                  this.pathname +
                  this._query +
                  this._fragment
                );
              },
              set href(a) {
                k.call(this);
                f.call(this, a);
              },
              get protocol() {
                return this._scheme + ':';
              },
              set protocol(a) {
                this._isInvalid || f.call(this, a + ':', 'scheme start');
              },
              get host() {
                return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
              },
              set host(a) {
                !this._isInvalid && this._isRelative && f.call(this, a, 'host');
              },
              get hostname() {
                return this._host;
              },
              set hostname(a) {
                !this._isInvalid && this._isRelative && f.call(this, a, 'hostname');
              },
              get port() {
                return this._port;
              },
              set port(a) {
                !this._isInvalid && this._isRelative && f.call(this, a, 'port');
              },
              get pathname() {
                return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
              },
              set pathname(a) {
                !this._isInvalid && this._isRelative && ((this._path = []), f.call(this, a, 'relative path start'));
              },
              get search() {
                return this._isInvalid || !this._query || '?' === this._query ? '' : this._query;
              },
              set search(a) {
                !this._isInvalid &&
                  this._isRelative &&
                  ((this._query = '?'), '?' === a[0] && (a = a.slice(1)), f.call(this, a, 'query'));
              },
              get hash() {
                return this._isInvalid || !this._fragment || '#' === this._fragment ? '' : this._fragment;
              },
              set hash(a) {
                this._isInvalid ||
                  ((this._fragment = '#'), '#' === a[0] && (a = a.slice(1)), f.call(this, a, 'fragment'));
              },
              get origin() {
                var a;
                if (this._isInvalid || !this._scheme) return '';
                switch (this._scheme) {
                  case 'data':
                  case 'file':
                  case 'javascript':
                  case 'mailto':
                    return 'null';
                  case 'blob':
                    try {
                      return new h(this._schemeData).origin || 'null';
                    } catch (r) {}
                    return 'null';
                }
                return (a = this.host) ? this._scheme + '://' + a : '';
              },
            };
            var w = d.URL;
            w &&
              ((h.createObjectURL = function(a) {
                return w.createObjectURL.apply(w, arguments);
              }),
              (h.revokeObjectURL = function(a) {
                w.revokeObjectURL(a);
              }));
            d.URL = h;
          }
        })();
      }
    },
    function(b, c, a) {
      b.exports =
        'undefined' !== typeof window && Math === Math
          ? window
          : 'undefined' !== typeof global && global.Math === Math
          ? global
          : 'undefined' !== typeof self && self.Math === Math
          ? self
          : {};
    },
    function(b, c, a) {
      a(48);
      b.exports = a(13).Uint8ClampedArray;
    },
    function(b, c, a) {
      a(49)(
        'Uint8',
        1,
        function(a) {
          return function(b, c, e) {
            return a(this, b, c, e);
          };
        },
        !0,
      );
    },
    function(b, c, a) {
      var e =
        'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
          ? function(a) {
              return typeof a;
            }
          : function(a) {
              return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                ? 'symbol'
                : typeof a;
            };
      if (a(2)) {
        var d = a(18),
          h = a(1),
          f = a(12),
          k = a(26),
          n = a(30),
          q = a(50),
          m = a(21),
          t = a(32),
          p = a(15),
          v = a(3);
        c = a(31);
        var w = a(9),
          l = a(5),
          F = a(33),
          u = a(17),
          y = a(19),
          A = a(4),
          C = a(41),
          H = a(7),
          U = a(10),
          R = a(51),
          S = a(42),
          G = a(43),
          I = a(34).f,
          x = a(55),
          B = a(8),
          D = a(0),
          r = a(56),
          J = a(38),
          O = a(60),
          W = a(61),
          K = a(11),
          ea = a(66),
          fa = a(67),
          ha = a(40),
          V = a(68),
          g = a(6);
        a = a(69);
        var M = g.f,
          L = a.f,
          P = h.RangeError,
          Y = h.TypeError,
          Q = h.Uint8Array,
          E = Array.prototype,
          ia = q.ArrayBuffer,
          ya = q.DataView,
          na = r(0),
          za = r(2),
          Aa = r(3),
          Ba = r(4),
          Ca = r(5),
          Da = r(6),
          Ea = J(!0),
          Fa = J(!1),
          Ga = W.values,
          Ha = W.keys,
          Ia = W.entries,
          Ja = E.lastIndexOf,
          Ka = E.reduce,
          La = E.reduceRight,
          oa = E.join,
          Ma = E.sort,
          pa = E.slice,
          X = E.toString,
          ja = E.toLocaleString,
          ka = D('iterator'),
          Z = D('toStringTag'),
          qa = B('typed_constructor'),
          aa = B('def_constructor');
        q = n.CONSTR;
        var T = n.TYPED,
          Na = n.VIEW,
          Oa = r(1, function(a, b) {
            return ba(O(a, a[aa]), b);
          }),
          ra = f(function() {
            return 1 === new Q(new Uint16Array([1]).buffer)[0];
          }),
          Pa =
            !!Q &&
            !!Q.prototype.set &&
            f(function() {
              new Q(1).set({});
            }),
          ca = function(a, b) {
            var c = w(a);
            if (0 > c || c % b) throw P('Wrong offset!');
            return c;
          },
          z = function(a) {
            if (H(a) && T in a) return a;
            throw Y(a + ' is not a typed array!');
          },
          ba = function(a, b) {
            if (!(H(a) && qa in a)) throw Y('It is not a typed array constructor!');
            return new a(b);
          },
          sa = function(a, b) {
            return la(O(a, a[aa]), b);
          },
          la = function(a, b) {
            for (var c = 0, d = b.length, e = ba(a, d); d > c; ) e[c] = b[c++];
            return e;
          };
        r = function(a, b, c) {
          M(a, b, {
            get: function() {
              return this._d[c];
            },
          });
        };
        var ma = function(a) {
            var b = U(a),
              c = arguments.length,
              d = 1 < c ? arguments[1] : void 0,
              e = void 0 !== d,
              f = x(b),
              g;
            if (void 0 != f && !R(f)) {
              var h = f.call(b);
              b = [];
              for (f = 0; !(g = h.next()).done; f++) b.push(g.value);
            }
            e && 2 < c && (d = m(d, arguments[2], 2));
            f = 0;
            c = l(b.length);
            for (g = ba(this, c); c > f; f++) g[f] = e ? d(b[f], f) : b[f];
            return g;
          },
          Qa = function() {
            for (var a = 0, b = arguments.length, c = ba(this, b); b > a; ) c[a] = arguments[a++];
            return c;
          },
          Ra =
            !!Q &&
            f(function() {
              ja.call(new Q(1));
            }),
          ta = function() {
            return ja.apply(Ra ? pa.call(z(this)) : z(this), arguments);
          },
          ua = {
            copyWithin: function(a, b) {
              return V.call(z(this), a, b, 2 < arguments.length ? arguments[2] : void 0);
            },
            every: function(a) {
              return Ba(z(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            fill: function(a) {
              return ha.apply(z(this), arguments);
            },
            filter: function(a) {
              return sa(this, za(z(this), a, 1 < arguments.length ? arguments[1] : void 0));
            },
            find: function(a) {
              return Ca(z(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            findIndex: function(a) {
              return Da(z(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            forEach: function(a) {
              na(z(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            indexOf: function(a) {
              return Fa(z(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            includes: function(a) {
              return Ea(z(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            join: function(a) {
              return oa.apply(z(this), arguments);
            },
            lastIndexOf: function(a) {
              return Ja.apply(z(this), arguments);
            },
            map: function(a) {
              return Oa(z(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            reduce: function(a) {
              return Ka.apply(z(this), arguments);
            },
            reduceRight: function(a) {
              return La.apply(z(this), arguments);
            },
            reverse: function() {
              for (var a = z(this).length, b = Math.floor(a / 2), c = 0, d; c < b; )
                (d = this[c]), (this[c++] = this[--a]), (this[a] = d);
              return this;
            },
            some: function(a) {
              return Aa(z(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            sort: function(a) {
              return Ma.call(z(this), a);
            },
            subarray: function(a, b) {
              var c = z(this),
                d = c.length,
                e = u(a, d);
              return new (O(c, c[aa]))(
                c.buffer,
                c.byteOffset + e * c.BYTES_PER_ELEMENT,
                l((void 0 === b ? d : u(b, d)) - e),
              );
            },
          },
          va = function(a, b) {
            return sa(this, pa.call(z(this), a, b));
          },
          wa = function(a, b) {
            z(this);
            var c = ca(b, 1),
              d = this.length,
              e = U(a),
              f = l(e.length),
              g = 0;
            if (f + c > d) throw P('Wrong length!');
            for (; g < f; ) this[c + g] = e[g++];
          },
          da = {
            entries: function() {
              return Ia.call(z(this));
            },
            keys: function() {
              return Ha.call(z(this));
            },
            values: function() {
              return Ga.call(z(this));
            },
          },
          xa = function(a, b) {
            return (
              H(a) &&
              a[T] &&
              'symbol' != ('undefined' === typeof b ? 'undefined' : e(b)) &&
              b in a &&
              String(+b) == String(b)
            );
          };
        B = function(a, b) {
          return xa(a, (b = y(b, !0))) ? p(2, a[b]) : L(a, b);
        };
        D = function(a, b, c) {
          return !(xa(a, (b = y(b, !0))) && H(c) && A(c, 'value')) ||
            A(c, 'get') ||
            A(c, 'set') ||
            c.configurable ||
            (A(c, 'writable') && !c.writable) ||
            (A(c, 'enumerable') && !c.enumerable)
            ? M(a, b, c)
            : ((a[b] = c.value), a);
        };
        q || ((a.f = B), (g.f = D));
        k(k.S + k.F * !q, 'Object', { getOwnPropertyDescriptor: B, defineProperty: D });
        f(function() {
          X.call({});
        }) &&
          (X = ja = function() {
            return oa.call(this);
          });
        var N = c({}, ua);
        c(N, da);
        v(N, ka, da.values);
        c(N, { slice: va, set: wa, constructor: function() {}, toString: X, toLocaleString: ta });
        r(N, 'buffer', 'b');
        r(N, 'byteOffset', 'o');
        r(N, 'byteLength', 'l');
        r(N, 'length', 'e');
        M(N, Z, {
          get: function() {
            return this[T];
          },
        });
        b.exports = function(a, b, c, e) {
          e = !!e;
          var g = a + (e ? 'Clamped' : '') + 'Array',
            Y = 'get' + a,
            Q = 'set' + a,
            m = h[g],
            E = m || {},
            q = m && G(m);
          a = {};
          var p = m && m.prototype,
            u = function(a, c) {
              M(a, c, {
                get: function() {
                  var a = this._d;
                  return a.v[Y](c * b + a.o, ra);
                },
                set: function(a) {
                  var d = this._d;
                  e && (a = 0 > (a = Math.round(a)) ? 0 : 255 < a ? 255 : a & 255);
                  d.v[Q](c * b + d.o, a, ra);
                },
                enumerable: !0,
              });
            };
          m && n.ABV
            ? (f(function() {
                m(1);
              }) &&
                f(function() {
                  new m(-1);
                }) &&
                ea(function(a) {
                  new m();
                  new m(null);
                  new m(1.5);
                  new m(a);
                }, !0)) ||
              ((m = c(function(a, c, d, e) {
                t(a, m, g);
                var f;
                return H(c)
                  ? c instanceof ia || 'ArrayBuffer' == (f = C(c)) || 'SharedArrayBuffer' == f
                    ? void 0 !== e
                      ? new E(c, ca(d, b), e)
                      : void 0 !== d
                      ? new E(c, ca(d, b))
                      : new E(c)
                    : T in c
                    ? la(m, c)
                    : ma.call(m, c)
                  : new E(F(c));
              })),
              na(q !== Function.prototype ? I(E).concat(I(q)) : I(E), function(a) {
                a in m || v(m, a, E[a]);
              }),
              (m.prototype = p),
              d || (p.constructor = m))
            : ((m = c(function(a, c, d, e) {
                t(a, m, g, '_d');
                var f = 0,
                  h = 0,
                  k;
                if (H(c))
                  if (c instanceof ia || 'ArrayBuffer' == (k = C(c)) || 'SharedArrayBuffer' == k) {
                    k = c;
                    h = ca(d, b);
                    c = c.byteLength;
                    if (void 0 === e) {
                      if (c % b) throw P('Wrong length!');
                      e = c - h;
                      if (0 > e) throw P('Wrong length!');
                    } else if (((e = l(e) * b), e + h > c)) throw P('Wrong length!');
                    c = e / b;
                  } else return T in c ? la(m, c) : ma.call(m, c);
                else (c = F(c)), (e = c * b), (k = new ia(e));
                for (v(a, '_d', { b: k, o: h, l: e, e: c, v: new ya(k) }); f < c; ) u(a, f++);
              })),
              (p = m.prototype = S(N)),
              v(p, 'constructor', m));
          c = p[ka];
          q = !!c && ('values' == c.name || void 0 == c.name);
          var r = da.values;
          v(m, qa, !0);
          v(p, T, g);
          v(p, Na, !0);
          v(p, aa, m);
          (e ? new m(1)[Z] == g : Z in p) ||
            M(p, Z, {
              get: function() {
                return g;
              },
            });
          a[g] = m;
          k(k.G + k.W + k.F * (m != E), a);
          k(k.S, g, { BYTES_PER_ELEMENT: b });
          k(
            k.S +
              k.F *
                f(function() {
                  E.of.call(m, 1);
                }),
            g,
            { from: ma, of: Qa },
          );
          'BYTES_PER_ELEMENT' in p || v(p, 'BYTES_PER_ELEMENT', b);
          k(k.P, g, ua);
          fa(g);
          k(k.P + k.F * Pa, g, { set: wa });
          k(k.P + k.F * !q, g, da);
          d || p.toString == X || (p.toString = X);
          k(
            k.P +
              k.F *
                f(function() {
                  new m(1).slice();
                }),
            g,
            { slice: va },
          );
          k(
            k.P +
              k.F *
                (f(function() {
                  return [1, 2].toLocaleString() != new m([1, 2]).toLocaleString();
                }) ||
                  !f(function() {
                    p.toLocaleString.call([1, 2]);
                  })),
            g,
            { toLocaleString: ta },
          );
          K[g] = q ? c : r;
          d || q || v(p, ka, r);
        };
      } else b.exports = function() {};
    },
    function(b, c, a) {
      function e(a, b, c) {
        var d = Array(c);
        c = 8 * c - b - 1;
        var e = (1 << c) - 1,
          f = e >> 1,
          g = 23 === b ? K(2, -24) - K(2, -77) : 0,
          h = 0,
          k = 0 > a || (0 === a && 0 > 1 / a) ? 1 : 0,
          n;
        a = W(a);
        if (a != a || a === J) {
          a = a != a ? 1 : 0;
          var l = e;
        } else
          (l = ea(fa(a) / ha)),
            1 > a * (n = K(2, -l)) && (l--, (n *= 2)),
            (a = 1 <= l + f ? a + g / n : a + g * K(2, 1 - f)),
            2 <= a * n && (l++, (n /= 2)),
            l + f >= e
              ? ((a = 0), (l = e))
              : 1 <= l + f
              ? ((a = (a * n - 1) * K(2, b)), (l += f))
              : ((a = a * K(2, f - 1) * K(2, b)), (l = 0));
        for (; 8 <= b; d[h++] = a & 255, a /= 256, b -= 8);
        l = (l << b) | a;
        for (c += b; 0 < c; d[h++] = l & 255, l /= 256, c -= 8);
        d[--h] |= 128 * k;
        return d;
      }
      function d(a, b, c) {
        var d = 8 * c - b - 1,
          e = (1 << d) - 1,
          f = e >> 1;
        d -= 7;
        --c;
        var g = a[c--],
          h = g & 127;
        for (g >>= 7; 0 < d; h = 256 * h + a[c], c--, d -= 8);
        var k = h & ((1 << -d) - 1);
        h >>= -d;
        for (d += b; 0 < d; k = 256 * k + a[c], c--, d -= 8);
        if (0 === h) h = 1 - f;
        else {
          if (h === e) return k ? NaN : g ? -J : J;
          k += K(2, b);
          h -= f;
        }
        return (g ? -1 : 1) * k * K(2, h - b);
      }
      function h(a) {
        return (a[3] << 24) | (a[2] << 16) | (a[1] << 8) | a[0];
      }
      function f(a) {
        return [a & 255];
      }
      function k(a) {
        return [a & 255, (a >> 8) & 255];
      }
      function n(a) {
        return [a & 255, (a >> 8) & 255, (a >> 16) & 255, (a >> 24) & 255];
      }
      function q(a) {
        return e(a, 52, 8);
      }
      function m(a) {
        return e(a, 23, 4);
      }
      function t(a, b, c) {
        G(a.prototype, b, {
          get: function() {
            return this[c];
          },
        });
      }
      function p(a, b, c, d) {
        c = R(+c);
        if (c + b > a[g]) throw r('Wrong index!');
        c += a[M];
        a = a[V]._b.slice(c, c + b);
        return d ? a : a.reverse();
      }
      function v(a, b, c, d, e, f) {
        var h = R(+c);
        if (h + b > a[g]) throw r('Wrong index!');
        c = a[V]._b;
        a = h + a[M];
        d = d(+e);
        for (e = 0; e < b; e++) c[a + e] = d[f ? e : b - e - 1];
      }
      var w = a(1),
        l = a(2),
        F = a(18);
      b = a(30);
      var u = a(3),
        y = a(31),
        A = a(12),
        C = a(32),
        H = a(9),
        U = a(5),
        R = a(33),
        S = a(34).f,
        G = a(6).f,
        I = a(40);
      a = a(25);
      var x = w.ArrayBuffer,
        B = w.DataView,
        D = w.Math,
        r = w.RangeError,
        J = w.Infinity,
        O = x,
        W = D.abs,
        K = D.pow,
        ea = D.floor,
        fa = D.log,
        ha = D.LN2,
        V = l ? '_b' : 'buffer',
        g = l ? '_l' : 'byteLength',
        M = l ? '_o' : 'byteOffset';
      if (b.ABV) {
        if (
          !A(function() {
            x(1);
          }) ||
          !A(function() {
            new x(-1);
          }) ||
          A(function() {
            new x();
            new x(1.5);
            new x(NaN);
            return 'ArrayBuffer' != x.name;
          })
        ) {
          x = function(a) {
            C(this, x);
            return new O(R(a));
          };
          w = x.prototype = O.prototype;
          S = S(O);
          l = 0;
          for (var L; S.length > l; ) (L = S[l++]) in x || u(x, L, O[L]);
          F || (w.constructor = x);
        }
        L = new B(new x(2));
        var P = B.prototype.setInt8;
        L.setInt8(0, 2147483648);
        L.setInt8(1, 2147483649);
        (!L.getInt8(0) && L.getInt8(1)) ||
          y(
            B.prototype,
            {
              setInt8: function(a, b) {
                P.call(this, a, (b << 24) >> 24);
              },
              setUint8: function(a, b) {
                P.call(this, a, (b << 24) >> 24);
              },
            },
            !0,
          );
      } else
        (x = function(a) {
          C(this, x, 'ArrayBuffer');
          a = R(a);
          this._b = I.call(Array(a), 0);
          this[g] = a;
        }),
          (B = function(a, b, c) {
            C(this, B, 'DataView');
            C(a, x, 'DataView');
            var d = a[g];
            b = H(b);
            if (0 > b || b > d) throw r('Wrong offset!');
            c = void 0 === c ? d - b : U(c);
            if (b + c > d) throw r('Wrong length!');
            this[V] = a;
            this[M] = b;
            this[g] = c;
          }),
          l && (t(x, 'byteLength', '_l'), t(B, 'buffer', '_b'), t(B, 'byteLength', '_l'), t(B, 'byteOffset', '_o')),
          y(B.prototype, {
            getInt8: function(a) {
              return (p(this, 1, a)[0] << 24) >> 24;
            },
            getUint8: function(a) {
              return p(this, 1, a)[0];
            },
            getInt16: function(a, b) {
              var c = p(this, 2, a, b);
              return (((c[1] << 8) | c[0]) << 16) >> 16;
            },
            getUint16: function(a, b) {
              var c = p(this, 2, a, b);
              return (c[1] << 8) | c[0];
            },
            getInt32: function(a, b) {
              return h(p(this, 4, a, b));
            },
            getUint32: function(a, b) {
              return h(p(this, 4, a, b)) >>> 0;
            },
            getFloat32: function(a, b) {
              return d(p(this, 4, a, b), 23, 4);
            },
            getFloat64: function(a, b) {
              return d(p(this, 8, a, b), 52, 8);
            },
            setInt8: function(a, b) {
              v(this, 1, a, f, b);
            },
            setUint8: function(a, b) {
              v(this, 1, a, f, b);
            },
            setInt16: function(a, b, c) {
              v(this, 2, a, k, b, c);
            },
            setUint16: function(a, b, c) {
              v(this, 2, a, k, b, c);
            },
            setInt32: function(a, b, c) {
              v(this, 4, a, n, b, c);
            },
            setUint32: function(a, b, c) {
              v(this, 4, a, n, b, c);
            },
            setFloat32: function(a, b, c) {
              v(this, 4, a, m, b, c);
            },
            setFloat64: function(a, b, c) {
              v(this, 8, a, q, b, c);
            },
          });
      a(x, 'ArrayBuffer');
      a(B, 'DataView');
      u(B.prototype, b.VIEW, !0);
      c.ArrayBuffer = x;
      c.DataView = B;
    },
    function(b, c, a) {
      var e = a(11),
        d = a(0)('iterator'),
        h = Array.prototype;
      b.exports = function(a) {
        return void 0 !== a && (e.Array === a || h[d] === a);
      };
    },
    function(b, c, a) {
      var e = a(6),
        d = a(14),
        h = a(53);
      b.exports = a(2)
        ? Object.defineProperties
        : function(a, b) {
            d(a);
            for (var c = h(b), f = c.length, k = 0, t; f > k; ) e.f(a, (t = c[k++]), b[t]);
            return a;
          };
    },
    function(b, c, a) {
      var e = a(35),
        d = a(24);
      b.exports =
        Object.keys ||
        function(a) {
          return e(a, d);
        };
    },
    function(b, c, a) {
      c = a(1).document;
      b.exports = c && c.documentElement;
    },
    function(b, c, a) {
      var e = a(41),
        d = a(0)('iterator'),
        h = a(11);
      b.exports = a(13).getIteratorMethod = function(a) {
        if (void 0 != a) return a[d] || a['@@iterator'] || h[e(a)];
      };
    },
    function(b, c, a) {
      var e = a(21),
        d = a(36),
        h = a(10),
        f = a(5),
        k = a(57);
      b.exports = function(a, b) {
        var c = 1 == a,
          n = 2 == a,
          p = 3 == a,
          q = 4 == a,
          w = 6 == a,
          l = 5 == a || w,
          F = b || k;
        return function(b, k, m) {
          var t = h(b),
            u = d(t);
          k = e(k, m, 3);
          m = f(u.length);
          var v = 0;
          b = c ? F(b, m) : n ? F(b, 0) : void 0;
          for (var y, A; m > v; v++)
            if (l || v in u)
              if (((y = u[v]), (A = k(y, v, t)), a))
                if (c) b[v] = A;
                else if (A)
                  switch (a) {
                    case 3:
                      return !0;
                    case 5:
                      return y;
                    case 6:
                      return v;
                    case 2:
                      b.push(y);
                  }
                else if (q) return !1;
          return w ? -1 : p || q ? q : b;
        };
      };
    },
    function(b, c, a) {
      var e = a(58);
      b.exports = function(a, b) {
        return new (e(a))(b);
      };
    },
    function(b, c, a) {
      var e = a(7),
        d = a(59),
        h = a(0)('species');
      b.exports = function(a) {
        if (d(a)) {
          var b = a.constructor;
          'function' != typeof b || (b !== Array && !d(b.prototype)) || (b = void 0);
          e(b) && ((b = b[h]), null === b && (b = void 0));
        }
        return void 0 === b ? Array : b;
      };
    },
    function(b, c, a) {
      var e = a(22);
      b.exports =
        Array.isArray ||
        function(a) {
          return 'Array' == e(a);
        };
    },
    function(b, c, a) {
      var e = a(14),
        d = a(29),
        h = a(0)('species');
      b.exports = function(a, b) {
        var c = e(a).constructor,
          f;
        return void 0 === c || void 0 == (f = e(c)[h]) ? b : d(f);
      };
    },
    function(b, c, a) {
      c = a(62);
      var e = a(63),
        d = a(11),
        h = a(16);
      b.exports = a(64)(
        Array,
        'Array',
        function(a, b) {
          this._t = h(a);
          this._i = 0;
          this._k = b;
        },
        function() {
          var a = this._t,
            b = this._k,
            c = this._i++;
          return !a || c >= a.length
            ? ((this._t = void 0), e(1))
            : 'keys' == b
            ? e(0, c)
            : 'values' == b
            ? e(0, a[c])
            : e(0, [c, a[c]]);
        },
        'values',
      );
      d.Arguments = d.Array;
      c('keys');
      c('values');
      c('entries');
    },
    function(b, c, a) {
      var e = a(0)('unscopables'),
        d = Array.prototype;
      void 0 == d[e] && a(3)(d, e, {});
      b.exports = function(a) {
        d[e][a] = !0;
      };
    },
    function(b, c, a) {
      b.exports = function(a, b) {
        return { value: b, done: !!a };
      };
    },
    function(b, c, a) {
      var e = a(18),
        d = a(26),
        h = a(20),
        f = a(3),
        k = a(4),
        n = a(11),
        q = a(65),
        m = a(25),
        t = a(43),
        p = a(0)('iterator'),
        v = !([].keys && 'next' in [].keys()),
        w = function() {
          return this;
        };
      b.exports = function(a, b, c, y, A, C, H) {
        q(c, b, y);
        y = function(a) {
          return !v && a in G
            ? G[a]
            : function() {
                return new c(this, a);
              };
        };
        var l = b + ' Iterator',
          u = 'values' == A,
          F = !1,
          G = a.prototype,
          I = G[p] || G['@@iterator'] || (A && G[A]),
          x = I || y(A),
          B = A ? (u ? y('entries') : x) : void 0,
          D = 'Array' == b ? G.entries || I : I,
          r;
        D && ((a = t(D.call(new a()))), a !== Object.prototype && a.next && (m(a, l, !0), e || k(a, p) || f(a, p, w)));
        u &&
          I &&
          'values' !== I.name &&
          ((F = !0),
          (x = function() {
            return I.call(this);
          }));
        (e && !H) || (!v && !F && G[p]) || f(G, p, x);
        n[b] = x;
        n[l] = w;
        if (A) {
          var J = { values: u ? x : y('values'), keys: C ? x : y('keys'), entries: B };
          if (H) for (r in J) r in G || h(G, r, J[r]);
          else d(d.P + d.F * (v || F), b, J);
        }
        return J;
      };
    },
    function(b, c, a) {
      var e = a(42),
        d = a(15),
        h = a(25),
        f = {};
      a(3)(f, a(0)('iterator'), function() {
        return this;
      });
      b.exports = function(a, b, c) {
        a.prototype = e(f, { next: d(1, c) });
        h(a, b + ' Iterator');
      };
    },
    function(b, c, a) {
      var e = a(0)('iterator'),
        d = !1;
      try {
        var h = [7][e]();
        h['return'] = function() {
          d = !0;
        };
        Array.from(h, function() {
          throw 2;
        });
      } catch (f) {}
      b.exports = function(a, b) {
        if (!b && !d) return !1;
        var c = !1;
        try {
          var f = [7],
            h = f[e]();
          h.next = function() {
            return { done: (c = !0) };
          };
          f[e] = function() {
            return h;
          };
          a(f);
        } catch (t) {}
        return c;
      };
    },
    function(b, c, a) {
      var e = a(1),
        d = a(6),
        h = a(2),
        f = a(0)('species');
      b.exports = function(a) {
        a = e[a];
        h &&
          a &&
          !a[f] &&
          d.f(a, f, {
            configurable: !0,
            get: function() {
              return this;
            },
          });
      };
    },
    function(b, c, a) {
      var e = a(10),
        d = a(17),
        h = a(5);
      b.exports =
        [].copyWithin ||
        function(a, b) {
          var c = e(this),
            f = h(c.length),
            k = d(a, f),
            t = d(b, f),
            p = 2 < arguments.length ? arguments[2] : void 0;
          f = Math.min((void 0 === p ? f : d(p, f)) - t, f - k);
          p = 1;
          t < k && k < t + f && ((p = -1), (t += f - 1), (k += f - 1));
          for (; 0 < f--; ) t in c ? (c[k] = c[t]) : delete c[k], (k += p), (t += p);
          return c;
        };
    },
    function(b, c, a) {
      var e = a(70),
        d = a(15),
        h = a(16),
        f = a(19),
        k = a(4),
        n = a(27),
        q = Object.getOwnPropertyDescriptor;
      c.f = a(2)
        ? q
        : function(a, b) {
            a = h(a);
            b = f(b, !0);
            if (n)
              try {
                return q(a, b);
              } catch (p) {}
            if (k(a, b)) return d(!e.f.call(a, b), a[b]);
          };
    },
    function(b, c, a) {
      c.f = {}.propertyIsEnumerable;
    },
  ]);
});
(function(a) {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    a = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    a = parseInt(a[1], 10);
    var b = 6 == a;
  }
  b ||
    window._bkpRequestAnimationFrame == window.requestAnimationFrame ||
    (window.requestAnimationFrame = window._bkpRequestAnimationFrame);
  delete window._bkpRequestAnimationFrame;
})();
(function(y, m) {
  'object' === typeof exports && 'object' === typeof module
    ? (module.exports = m())
    : 'function' === typeof define && define.amd
    ? define('pdfjs-dist/build/pdf.combined', [], m)
    : 'object' === typeof exports
    ? (exports['pdfjs-dist/build/pdf.combined'] = m())
    : (y['pdfjs-dist/build/pdf.combined'] = y.pdfjsDistBuildPdfCombined = m());
})(this, function() {
  return (function(y) {
    function m(a) {
      if (t[a]) return t[a].exports;
      var k = (t[a] = { i: a, l: !1, exports: {} });
      y[a].call(k.exports, k, k.exports, m);
      k.l = !0;
      return k.exports;
    }
    var t = {};
    m.m = y;
    m.c = t;
    m.d = function(a, k, b) {
      m.o(a, k) || Object.defineProperty(a, k, { configurable: !1, enumerable: !0, get: b });
    };
    m.n = function(a) {
      var k =
        a && a.__esModule
          ? function() {
              return a['default'];
            }
          : function() {
              return a;
            };
      m.d(k, 'a', k);
      return k;
    };
    m.o = function(a, k) {
      return Object.prototype.hasOwnProperty.call(a, k);
    };
    m.p = '';
    return m((m.s = 70));
  })([
    function(y, m, t) {
      function a(a) {
        c >= A.warnings && console.log('Warning: ' + a);
      }
      function k(a) {
        throw Error(a);
      }
      function b(a, b) {
        a || k(b);
      }
      function v(a) {
        b('string' === typeof a, 'Invalid argument for stringToBytes');
        for (var c = a.length, f = new Uint8Array(c), w = 0; w < c; ++w) f[w] = a.charCodeAt(w) & 255;
        return f;
      }
      function d(a) {
        if (void 0 !== a.length) return a.length;
        b(void 0 !== a.byteLength);
        return a.byteLength;
      }
      function u() {
        var a = {};
        a.promise = new Promise(function(b, c) {
          a.resolve = b;
          a.reject = c;
        });
        return a;
      }
      function z(a, b) {
        var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
        return a
          ? new Promise(function(f, w) {
              f(a.apply(c, b));
            })
          : Promise.resolve(void 0);
      }
      function C(a) {
        if ('object' !== ('undefined' === typeof a ? 'undefined' : h(a))) return a;
        switch (a.name) {
          case 'AbortException':
            return new r(a.message);
          case 'MissingPDFException':
            return new x(a.message);
          case 'UnexpectedResponseException':
            return new g(a.message, a.status);
          default:
            return new q(a.message, a.details);
        }
      }
      function B(a, b, c) {
        b ? a.resolve() : a.reject(c);
      }
      function n(a) {
        return Promise.resolve(a)['catch'](function() {});
      }
      function e(a, b, c) {
        var f = this;
        this.sourceName = a;
        this.targetName = b;
        this.comObj = c;
        this.streamId = this.callbackId = 1;
        this.postMessageTransfers = !0;
        this.streamSinks = Object.create(null);
        this.streamControllers = Object.create(null);
        var w = (this.callbacksCapabilities = Object.create(null)),
          l = (this.actionHandler = Object.create(null));
        this._onComObjOnMessage = function(a) {
          var b = a.data;
          if (b.targetName === f.sourceName)
            if (b.stream) f._processStreamMessage(b);
            else if (b.isReply)
              if (((a = b.callbackId), b.callbackId in w)) {
                var E = w[a];
                delete w[a];
                'error' in b ? E.reject(C(b.error)) : E.resolve(b.data);
              } else throw Error('Cannot resolve callback ' + a);
            else if (b.action in l) {
              var H = l[b.action];
              if (b.callbackId) {
                var d = f.sourceName,
                  D = b.sourceName;
                Promise.resolve()
                  .then(function() {
                    return H[0].call(H[1], b.data);
                  })
                  .then(
                    function(a) {
                      c.postMessage({ sourceName: d, targetName: D, isReply: !0, callbackId: b.callbackId, data: a });
                    },
                    function(a) {
                      c.postMessage({
                        sourceName: d,
                        targetName: D,
                        isReply: !0,
                        callbackId: b.callbackId,
                        error:
                          !(a instanceof Error) || a instanceof r || a instanceof x || a instanceof g || a instanceof q
                            ? a
                            : new q(a.message, a.toString()),
                      });
                    },
                  );
              } else b.streamId ? f._createStreamSink(b) : H[0].call(H[1], b.data);
            } else throw Error('Unknown action from worker: ' + b.action);
        };
        c.addEventListener('message', this._onComObjOnMessage);
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.unreachable = m.warn = m.utf8StringToString = m.stringToUTF8String = m.stringToPDFString = m.stringToBytes = m.string32 = m.shadow = m.setVerbosityLevel = m.ReadableStream = m.removeNullCharacters = m.readUint32 = m.readUint16 = m.readInt8 = m.log2 = m.loadJpegStream = m.isEvalSupported = m.isLittleEndian = m.createValidAbsoluteUrl = m.isSameOrigin = m.isNodeJS = m.isSpace = m.isString = m.isNum = m.isEmptyObj = m.isBool = m.isArrayBuffer = m.info = m.getVerbosityLevel = m.getLookupTableFactory = m.deprecated = m.createObjectURL = m.createPromiseCapability = m.createBlob = m.bytesToString = m.assert = m.arraysToBytes = m.arrayByteLength = m.FormatError = m.XRefParseException = m.Util = m.UnknownErrorException = m.UnexpectedResponseException = m.TextRenderingMode = m.StreamType = m.StatTimer = m.PasswordResponses = m.PasswordException = m.PageViewport = m.NotImplementedException = m.NativeImageDecoding = m.MissingPDFException = m.MissingDataException = m.MessageHandler = m.InvalidPDFException = m.AbortException = m.CMapCompressionType = m.ImageKind = m.FontType = m.AnnotationType = m.AnnotationFlag = m.AnnotationFieldFlag = m.AnnotationBorderStyleType = m.UNSUPPORTED_FEATURES = m.VERBOSITY_LEVELS = m.OPS = m.IDENTITY_MATRIX = m.FONT_IDENTITY_MATRIX = void 0;
      var h =
        'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
          ? function(a) {
              return typeof a;
            }
          : function(a) {
              return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                ? 'symbol'
                : typeof a;
            };
      t(71);
      var p = t(96),
        A = { errors: 0, warnings: 1, infos: 5 },
        c = A.warnings;
      y = (function() {
        function a(a, b) {
          this.name = 'PasswordException';
          this.message = a;
          this.code = b;
        }
        a.prototype = Error();
        return (a.constructor = a);
      })();
      var q = (function() {
        function a(a, b) {
          this.name = 'UnknownErrorException';
          this.message = a;
          this.details = b;
        }
        a.prototype = Error();
        return (a.constructor = a);
      })();
      t = (function() {
        function a(a) {
          this.name = 'InvalidPDFException';
          this.message = a;
        }
        a.prototype = Error();
        return (a.constructor = a);
      })();
      var x = (function() {
          function a(a) {
            this.name = 'MissingPDFException';
            this.message = a;
          }
          a.prototype = Error();
          return (a.constructor = a);
        })(),
        g = (function() {
          function a(a, b) {
            this.name = 'UnexpectedResponseException';
            this.message = a;
            this.status = b;
          }
          a.prototype = Error();
          return (a.constructor = a);
        })(),
        G = (function() {
          function a(a) {
            this.message = a;
          }
          a.prototype = Error();
          a.prototype.name = 'NotImplementedException';
          return (a.constructor = a);
        })(),
        l = (function() {
          function a(a, b) {
            this.begin = a;
            this.end = b;
            this.message = 'Missing data [' + a + ', ' + b + ')';
          }
          a.prototype = Error();
          a.prototype.name = 'MissingDataException';
          return (a.constructor = a);
        })(),
        J = (function() {
          function a(a) {
            this.message = a;
          }
          a.prototype = Error();
          a.prototype.name = 'XRefParseException';
          return (a.constructor = a);
        })(),
        f = (function() {
          function a(a) {
            this.message = a;
          }
          a.prototype = Error();
          a.prototype.name = 'FormatError';
          return (a.constructor = a);
        })(),
        r = (function() {
          function a(a) {
            this.name = 'AbortException';
            this.message = a;
          }
          a.prototype = Error();
          return (a.constructor = a);
        })(),
        D = /\x00/g,
        L = (function() {
          function a() {}
          var c = ['rgb(', 0, ',', 0, ',', 0, ')'];
          a.makeCssRgb = function(a, b, f) {
            c[1] = a;
            c[3] = b;
            c[5] = f;
            return c.join('');
          };
          a.transform = function(a, b) {
            return [
              a[0] * b[0] + a[2] * b[1],
              a[1] * b[0] + a[3] * b[1],
              a[0] * b[2] + a[2] * b[3],
              a[1] * b[2] + a[3] * b[3],
              a[0] * b[4] + a[2] * b[5] + a[4],
              a[1] * b[4] + a[3] * b[5] + a[5],
            ];
          };
          a.applyTransform = function(a, b) {
            return [a[0] * b[0] + a[1] * b[2] + b[4], a[0] * b[1] + a[1] * b[3] + b[5]];
          };
          a.applyInverseTransform = function(a, b) {
            var c = b[0] * b[3] - b[1] * b[2];
            return [
              (a[0] * b[3] - a[1] * b[2] + b[2] * b[5] - b[4] * b[3]) / c,
              (-a[0] * b[1] + a[1] * b[0] + b[4] * b[1] - b[5] * b[0]) / c,
            ];
          };
          a.getAxialAlignedBoundingBox = function(b, c) {
            var f = a.applyTransform(b, c),
              w = a.applyTransform(b.slice(2, 4), c),
              r = a.applyTransform([b[0], b[3]], c),
              l = a.applyTransform([b[2], b[1]], c);
            return [
              Math.min(f[0], w[0], r[0], l[0]),
              Math.min(f[1], w[1], r[1], l[1]),
              Math.max(f[0], w[0], r[0], l[0]),
              Math.max(f[1], w[1], r[1], l[1]),
            ];
          };
          a.inverseTransform = function(a) {
            var b = a[0] * a[3] - a[1] * a[2];
            return [
              a[3] / b,
              -a[1] / b,
              -a[2] / b,
              a[0] / b,
              (a[2] * a[5] - a[4] * a[3]) / b,
              (a[4] * a[1] - a[5] * a[0]) / b,
            ];
          };
          a.apply3dTransform = function(a, b) {
            return [
              a[0] * b[0] + a[1] * b[1] + a[2] * b[2],
              a[3] * b[0] + a[4] * b[1] + a[5] * b[2],
              a[6] * b[0] + a[7] * b[1] + a[8] * b[2],
            ];
          };
          a.singularValueDecompose2dScale = function(a) {
            var b = [a[0], a[2], a[1], a[3]],
              c = a[0] * b[0] + a[1] * b[2],
              f = a[2] * b[1] + a[3] * b[3],
              w = (c + f) / 2;
            a =
              Math.sqrt((c + f) * (c + f) - 4 * (c * f - (a[2] * b[0] + a[3] * b[2]) * (a[0] * b[1] + a[1] * b[3]))) /
              2;
            return [Math.sqrt(w + a || 1), Math.sqrt(w - a || 1)];
          };
          a.normalizeRect = function(a) {
            var b = a.slice(0);
            a[0] > a[2] && ((b[0] = a[2]), (b[2] = a[0]));
            a[1] > a[3] && ((b[1] = a[3]), (b[3] = a[1]));
            return b;
          };
          a.intersect = function(b, c) {
            function f(a, b) {
              return a - b;
            }
            var w = [b[0], b[2], c[0], c[2]].sort(f),
              r = [b[1], b[3], c[1], c[3]].sort(f),
              l = [];
            b = a.normalizeRect(b);
            c = a.normalizeRect(c);
            if ((w[0] === b[0] && w[1] === c[0]) || (w[0] === c[0] && w[1] === b[0])) (l[0] = w[1]), (l[2] = w[2]);
            else return !1;
            if ((r[0] === b[1] && r[1] === c[1]) || (r[0] === c[1] && r[1] === b[1])) (l[1] = r[1]), (l[3] = r[2]);
            else return !1;
            return l;
          };
          a.sign = function(a) {
            return 0 > a ? -1 : 1;
          };
          var f = ' C CC CCC CD D DC DCC DCCC CM  X XX XXX XL L LX LXX LXXX XC  I II III IV V VI VII VIII IX'.split(
            ' ',
          );
          a.toRoman = function(a, c) {
            b(Number.isInteger(a) && 0 < a, 'The number should be a positive integer.');
            for (var w, r = []; 1e3 <= a; ) (a -= 1e3), r.push('M');
            w = (a / 100) | 0;
            a %= 100;
            r.push(f[w]);
            w = (a / 10) | 0;
            a %= 10;
            r.push(f[10 + w]);
            r.push(f[20 + a]);
            w = r.join('');
            return c ? w.toLowerCase() : w;
          };
          a.appendToArray = function(a, b) {
            Array.prototype.push.apply(a, b);
          };
          a.prependToArray = function(a, b) {
            Array.prototype.unshift.apply(a, b);
          };
          a.extendObj = function(a, b) {
            for (var c in b) a[c] = b[c];
          };
          a.getInheritableProperty = function(a, b, c) {
            for (; a && !a.has(b); ) a = a.get('Parent');
            return a ? (c ? a.getArray(b) : a.get(b)) : null;
          };
          a.inherit = function(a, b, c) {
            a.prototype = Object.create(b.prototype);
            a.prototype.constructor = a;
            for (var f in c) a.prototype[f] = c[f];
          };
          a.loadScript = function(a, b) {
            var c = document.createElement('script'),
              f = !1;
            c.setAttribute('src', a);
            b &&
              (c.onload = function() {
                f || b();
                f = !0;
              });
            document.getElementsByTagName('head')[0].appendChild(c);
          };
          return a;
        })(),
        I = (function() {
          function a(a, b, c, f, w, r) {
            this.viewBox = a;
            this.scale = b;
            this.rotation = c;
            this.offsetX = f;
            this.offsetY = w;
            var l = (a[2] + a[0]) / 2,
              E = (a[3] + a[1]) / 2,
              g;
            c %= 360;
            switch (0 > c ? c + 360 : c) {
              case 180:
                c = -1;
                var d = (g = 0);
                var q = 1;
                break;
              case 90:
                c = 0;
                d = g = 1;
                q = 0;
                break;
              case 270:
                c = 0;
                d = g = -1;
                q = 0;
                break;
              default:
                (c = 1), (d = g = 0), (q = -1);
            }
            r && ((d = -d), (q = -q));
            0 === c
              ? ((f = Math.abs(E - a[1]) * b + f),
                (w = Math.abs(l - a[0]) * b + w),
                (r = Math.abs(a[3] - a[1]) * b),
                (a = Math.abs(a[2] - a[0]) * b))
              : ((f = Math.abs(l - a[0]) * b + f),
                (w = Math.abs(E - a[1]) * b + w),
                (r = Math.abs(a[2] - a[0]) * b),
                (a = Math.abs(a[3] - a[1]) * b));
            this.transform = [c * b, g * b, d * b, q * b, f - c * b * l - d * b * E, w - g * b * l - q * b * E];
            this.width = r;
            this.height = a;
            this.fontScale = b;
          }
          a.prototype = {
            clone: function(b) {
              b = b || {};
              var c = 'scale' in b ? b.scale : this.scale,
                f = 'rotation' in b ? b.rotation : this.rotation;
              return new a(this.viewBox.slice(), c, f, this.offsetX, this.offsetY, b.dontFlip);
            },
            convertToViewportPoint: function(a, b) {
              return L.applyTransform([a, b], this.transform);
            },
            convertToViewportRectangle: function(a) {
              var b = L.applyTransform([a[0], a[1]], this.transform);
              a = L.applyTransform([a[2], a[3]], this.transform);
              return [b[0], b[1], a[0], a[1]];
            },
            convertToPdfPoint: function(a, b) {
              return L.applyInverseTransform([a, b], this.transform);
            },
          };
          return a;
        })(),
        w = [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          728,
          711,
          710,
          729,
          733,
          731,
          730,
          732,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          8226,
          8224,
          8225,
          8230,
          8212,
          8211,
          402,
          8260,
          8249,
          8250,
          8722,
          8240,
          8222,
          8220,
          8221,
          8216,
          8217,
          8218,
          8482,
          64257,
          64258,
          321,
          338,
          352,
          376,
          381,
          305,
          322,
          339,
          353,
          382,
          0,
          8364,
        ],
        E = (function() {
          function b() {
            this.started = Object.create(null);
            this.times = [];
            this.enabled = !0;
          }
          b.prototype = {
            time: function(b) {
              this.enabled &&
                (b in this.started && a('Timer is already running for ' + b), (this.started[b] = Date.now()));
            },
            timeEnd: function(b) {
              this.enabled &&
                (b in this.started || a('Timer has not been started for ' + b),
                this.times.push({ name: b, start: this.started[b], end: Date.now() }),
                delete this.started[b]);
            },
            toString: function() {
              var a,
                b = this.times,
                c = '',
                f = 0;
              var w = 0;
              for (a = b.length; w < a; ++w) {
                var r = b[w].name;
                r.length > f && (f = r.length);
              }
              w = 0;
              for (a = b.length; w < a; ++w) {
                var l = b[w];
                r = l.end - l.start;
                for (l = l.name; l.length < f; ) l += ' ';
                c += l + ' ' + r + 'ms\n';
              }
              return c;
            },
          };
          return b;
        })(),
        F = function(a, b) {
          if ('undefined' !== typeof Blob) return new Blob([a], { type: b });
          throw Error('The "Blob" constructor is not supported.');
        },
        K = (function() {
          return function(a, b) {
            if (!(2 < arguments.length && void 0 !== arguments[2] && arguments[2]) && URL.createObjectURL) {
              var c = F(a, b);
              return URL.createObjectURL(c);
            }
            c = 'data:' + b + ';base64,';
            for (var f = 0, w = a.length; f < w; f += 3) {
              var r = a[f] & 255,
                l = a[f + 1] & 255,
                E = a[f + 2] & 255;
              c +=
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='[r >> 2] +
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='[((r & 3) << 4) | (l >> 4)] +
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='[
                  f + 1 < w ? ((l & 15) << 2) | (E >> 6) : 64
                ] +
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='[f + 2 < w ? E & 63 : 64];
            }
            return c;
          };
        })();
      e.prototype = {
        on: function(a, b, c) {
          var f = this.actionHandler;
          if (f[a]) throw Error('There is already an actionName called "' + a + '"');
          f[a] = [b, c];
        },
        send: function(a, b, c) {
          this.postMessage({ sourceName: this.sourceName, targetName: this.targetName, action: a, data: b }, c);
        },
        sendWithPromise: function(a, b, c) {
          var f = this.callbackId++;
          a = { sourceName: this.sourceName, targetName: this.targetName, action: a, data: b, callbackId: f };
          b = u();
          this.callbacksCapabilities[f] = b;
          try {
            this.postMessage(a, c);
          } catch (da) {
            b.reject(da);
          }
          return b.promise;
        },
        sendWithStream: function(a, b, c, f) {
          var w = this,
            r = this.streamId++,
            l = this.sourceName,
            E = this.targetName;
          return new p.ReadableStream(
            {
              start: function(c) {
                var f = u();
                w.streamControllers[r] = { controller: c, startCall: f, isClosed: !1 };
                w.postMessage({
                  sourceName: l,
                  targetName: E,
                  action: a,
                  streamId: r,
                  data: b,
                  desiredSize: c.desiredSize,
                });
                return f.promise;
              },
              pull: function(a) {
                var b = u();
                w.streamControllers[r].pullCall = b;
                w.postMessage({
                  sourceName: l,
                  targetName: E,
                  stream: 'pull',
                  streamId: r,
                  desiredSize: a.desiredSize,
                });
                return b.promise;
              },
              cancel: function(a) {
                var b = u();
                w.streamControllers[r].cancelCall = b;
                w.streamControllers[r].isClosed = !0;
                w.postMessage({ sourceName: l, targetName: E, stream: 'cancel', reason: a, streamId: r });
                return b.promise;
              },
            },
            c,
          );
        },
        _createStreamSink: function(a) {
          var b = this,
            c = this,
            f = this.actionHandler[a.action],
            w = a.streamId,
            r = a.desiredSize,
            l = this.sourceName,
            E = a.sourceName,
            g = function(a) {
              b.postMessage(
                {
                  sourceName: l,
                  targetName: E,
                  stream: a.stream,
                  streamId: w,
                  chunk: a.chunk,
                  success: a.success,
                  reason: a.reason,
                },
                a.transfers,
              );
            };
          r = {
            enqueue: function(a) {
              var b = arguments[2];
              if (!this.isCancelled) {
                var c = this.desiredSize;
                this.desiredSize -= 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 1;
                0 < c &&
                  0 >= this.desiredSize &&
                  ((this.sinkCapability = u()), (this.ready = this.sinkCapability.promise));
                g({ stream: 'enqueue', chunk: a, transfers: b });
              }
            },
            close: function() {
              this.isCancelled || ((this.isCancelled = !0), g({ stream: 'close' }), delete c.streamSinks[w]);
            },
            error: function(a) {
              this.isCancelled || ((this.isCancelled = !0), g({ stream: 'error', reason: a }));
            },
            sinkCapability: u(),
            onPull: null,
            onCancel: null,
            isCancelled: !1,
            desiredSize: r,
            ready: null,
          };
          r.sinkCapability.resolve();
          r.ready = r.sinkCapability.promise;
          this.streamSinks[w] = r;
          z(f[0], [a.data, r], f[1]).then(
            function() {
              g({ stream: 'start_complete', success: !0 });
            },
            function(a) {
              g({ stream: 'start_complete', success: !1, reason: a });
            },
          );
        },
        _processStreamMessage: function(a) {
          var c = this,
            f = this.sourceName,
            w = a.sourceName,
            r = a.streamId,
            l = function(a) {
              c.comObj.postMessage({
                sourceName: f,
                targetName: w,
                stream: a.stream,
                success: a.success,
                streamId: r,
                reason: a.reason,
              });
            },
            E = function() {
              Promise.all(
                [
                  c.streamControllers[a.streamId].startCall,
                  c.streamControllers[a.streamId].pullCall,
                  c.streamControllers[a.streamId].cancelCall,
                ].map(function(a) {
                  return a && n(a.promise);
                }),
              ).then(function() {
                delete c.streamControllers[a.streamId];
              });
            };
          switch (a.stream) {
            case 'start_complete':
              B(this.streamControllers[a.streamId].startCall, a.success, C(a.reason));
              break;
            case 'pull_complete':
              B(this.streamControllers[a.streamId].pullCall, a.success, C(a.reason));
              break;
            case 'pull':
              if (!this.streamSinks[a.streamId]) {
                l({ stream: 'pull_complete', success: !0 });
                break;
              }
              0 >= this.streamSinks[a.streamId].desiredSize &&
                0 < a.desiredSize &&
                this.streamSinks[a.streamId].sinkCapability.resolve();
              this.streamSinks[a.streamId].desiredSize = a.desiredSize;
              z(this.streamSinks[a.streamId].onPull).then(
                function() {
                  l({ stream: 'pull_complete', success: !0 });
                },
                function(a) {
                  l({ stream: 'pull_complete', success: !1, reason: a });
                },
              );
              break;
            case 'enqueue':
              b(this.streamControllers[a.streamId], 'enqueue should have stream controller');
              this.streamControllers[a.streamId].isClosed ||
                this.streamControllers[a.streamId].controller.enqueue(a.chunk);
              break;
            case 'close':
              b(this.streamControllers[a.streamId], 'close should have stream controller');
              if (this.streamControllers[a.streamId].isClosed) break;
              this.streamControllers[a.streamId].isClosed = !0;
              this.streamControllers[a.streamId].controller.close();
              E();
              break;
            case 'error':
              b(this.streamControllers[a.streamId], 'error should have stream controller');
              this.streamControllers[a.streamId].controller.error(C(a.reason));
              E();
              break;
            case 'cancel_complete':
              B(this.streamControllers[a.streamId].cancelCall, a.success, C(a.reason));
              E();
              break;
            case 'cancel':
              if (!this.streamSinks[a.streamId]) break;
              z(this.streamSinks[a.streamId].onCancel, [C(a.reason)]).then(
                function() {
                  l({ stream: 'cancel_complete', success: !0 });
                },
                function(a) {
                  l({ stream: 'cancel_complete', success: !1, reason: a });
                },
              );
              this.streamSinks[a.streamId].sinkCapability.reject(C(a.reason));
              this.streamSinks[a.streamId].isCancelled = !0;
              delete this.streamSinks[a.streamId];
              break;
            default:
              throw Error('Unexpected stream case');
          }
        },
        postMessage: function(a, b) {
          b && this.postMessageTransfers ? this.comObj.postMessage(a, b) : this.comObj.postMessage(a);
        },
        destroy: function() {
          this.comObj.removeEventListener('message', this._onComObjOnMessage);
        },
      };
      m.FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
      m.IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
      m.OPS = {
        dependency: 1,
        setLineWidth: 2,
        setLineCap: 3,
        setLineJoin: 4,
        setMiterLimit: 5,
        setDash: 6,
        setRenderingIntent: 7,
        setFlatness: 8,
        setGState: 9,
        save: 10,
        restore: 11,
        transform: 12,
        moveTo: 13,
        lineTo: 14,
        curveTo: 15,
        curveTo2: 16,
        curveTo3: 17,
        closePath: 18,
        rectangle: 19,
        stroke: 20,
        closeStroke: 21,
        fill: 22,
        eoFill: 23,
        fillStroke: 24,
        eoFillStroke: 25,
        closeFillStroke: 26,
        closeEOFillStroke: 27,
        endPath: 28,
        clip: 29,
        eoClip: 30,
        beginText: 31,
        endText: 32,
        setCharSpacing: 33,
        setWordSpacing: 34,
        setHScale: 35,
        setLeading: 36,
        setFont: 37,
        setTextRenderingMode: 38,
        setTextRise: 39,
        moveText: 40,
        setLeadingMoveText: 41,
        setTextMatrix: 42,
        nextLine: 43,
        showText: 44,
        showSpacedText: 45,
        nextLineShowText: 46,
        nextLineSetSpacingShowText: 47,
        setCharWidth: 48,
        setCharWidthAndBounds: 49,
        setStrokeColorSpace: 50,
        setFillColorSpace: 51,
        setStrokeColor: 52,
        setStrokeColorN: 53,
        setFillColor: 54,
        setFillColorN: 55,
        setStrokeGray: 56,
        setFillGray: 57,
        setStrokeRGBColor: 58,
        setFillRGBColor: 59,
        setStrokeCMYKColor: 60,
        setFillCMYKColor: 61,
        shadingFill: 62,
        beginInlineImage: 63,
        beginImageData: 64,
        endInlineImage: 65,
        paintXObject: 66,
        markPoint: 67,
        markPointProps: 68,
        beginMarkedContent: 69,
        beginMarkedContentProps: 70,
        endMarkedContent: 71,
        beginCompat: 72,
        endCompat: 73,
        paintFormXObjectBegin: 74,
        paintFormXObjectEnd: 75,
        beginGroup: 76,
        endGroup: 77,
        beginAnnotations: 78,
        endAnnotations: 79,
        beginAnnotation: 80,
        endAnnotation: 81,
        paintJpegXObject: 82,
        paintImageMaskXObject: 83,
        paintImageMaskXObjectGroup: 84,
        paintImageXObject: 85,
        paintInlineImageXObject: 86,
        paintInlineImageXObjectGroup: 87,
        paintImageXObjectRepeat: 88,
        paintImageMaskXObjectRepeat: 89,
        paintSolidColorImageMask: 90,
        constructPath: 91,
      };
      m.VERBOSITY_LEVELS = A;
      m.UNSUPPORTED_FEATURES = {
        unknown: 'unknown',
        forms: 'forms',
        javaScript: 'javaScript',
        smask: 'smask',
        shadingPattern: 'shadingPattern',
        font: 'font',
      };
      m.AnnotationBorderStyleType = { SOLID: 1, DASHED: 2, BEVELED: 3, INSET: 4, UNDERLINE: 5 };
      m.AnnotationFieldFlag = {
        READONLY: 1,
        REQUIRED: 2,
        NOEXPORT: 4,
        MULTILINE: 4096,
        PASSWORD: 8192,
        NOTOGGLETOOFF: 16384,
        RADIO: 32768,
        PUSHBUTTON: 65536,
        COMBO: 131072,
        EDIT: 262144,
        SORT: 524288,
        FILESELECT: 1048576,
        MULTISELECT: 2097152,
        DONOTSPELLCHECK: 4194304,
        DONOTSCROLL: 8388608,
        COMB: 16777216,
        RICHTEXT: 33554432,
        RADIOSINUNISON: 33554432,
        COMMITONSELCHANGE: 67108864,
      };
      m.AnnotationFlag = {
        INVISIBLE: 1,
        HIDDEN: 2,
        PRINT: 4,
        NOZOOM: 8,
        NOROTATE: 16,
        NOVIEW: 32,
        READONLY: 64,
        LOCKED: 128,
        TOGGLENOVIEW: 256,
        LOCKEDCONTENTS: 512,
      };
      m.AnnotationType = {
        TEXT: 1,
        LINK: 2,
        FREETEXT: 3,
        LINE: 4,
        SQUARE: 5,
        CIRCLE: 6,
        POLYGON: 7,
        POLYLINE: 8,
        HIGHLIGHT: 9,
        UNDERLINE: 10,
        SQUIGGLY: 11,
        STRIKEOUT: 12,
        STAMP: 13,
        CARET: 14,
        INK: 15,
        POPUP: 16,
        FILEATTACHMENT: 17,
        SOUND: 18,
        MOVIE: 19,
        WIDGET: 20,
        SCREEN: 21,
        PRINTERMARK: 22,
        TRAPNET: 23,
        WATERMARK: 24,
        THREED: 25,
        REDACT: 26,
      };
      m.FontType = {
        UNKNOWN: 0,
        TYPE1: 1,
        TYPE1C: 2,
        CIDFONTTYPE0: 3,
        CIDFONTTYPE0C: 4,
        TRUETYPE: 5,
        CIDFONTTYPE2: 6,
        TYPE3: 7,
        OPENTYPE: 8,
        TYPE0: 9,
        MMTYPE1: 10,
      };
      m.ImageKind = { GRAYSCALE_1BPP: 1, RGB_24BPP: 2, RGBA_32BPP: 3 };
      m.CMapCompressionType = { NONE: 0, BINARY: 1, STREAM: 2 };
      m.AbortException = r;
      m.InvalidPDFException = t;
      m.MessageHandler = e;
      m.MissingDataException = l;
      m.MissingPDFException = x;
      m.NativeImageDecoding = { NONE: 'none', DECODE: 'decode', DISPLAY: 'display' };
      m.NotImplementedException = G;
      m.PageViewport = I;
      m.PasswordException = y;
      m.PasswordResponses = { NEED_PASSWORD: 1, INCORRECT_PASSWORD: 2 };
      m.StatTimer = E;
      m.StreamType = { UNKNOWN: 0, FLATE: 1, LZW: 2, DCT: 3, JPX: 4, JBIG: 5, A85: 6, AHX: 7, CCF: 8, RL: 9 };
      m.TextRenderingMode = {
        FILL: 0,
        STROKE: 1,
        FILL_STROKE: 2,
        INVISIBLE: 3,
        FILL_ADD_TO_PATH: 4,
        STROKE_ADD_TO_PATH: 5,
        FILL_STROKE_ADD_TO_PATH: 6,
        ADD_TO_PATH: 7,
        FILL_STROKE_MASK: 3,
        ADD_TO_PATH_FLAG: 4,
      };
      m.UnexpectedResponseException = g;
      m.UnknownErrorException = q;
      m.Util = L;
      m.XRefParseException = J;
      m.FormatError = f;
      m.arrayByteLength = d;
      m.arraysToBytes = function(a) {
        if (1 === a.length && a[0] instanceof Uint8Array) return a[0];
        var b = 0,
          c,
          f = a.length;
        for (c = 0; c < f; c++) {
          var w = a[c];
          var r = d(w);
          b += r;
        }
        var l = 0;
        b = new Uint8Array(b);
        for (c = 0; c < f; c++)
          (w = a[c]),
            w instanceof Uint8Array || (w = 'string' === typeof w ? v(w) : new Uint8Array(w)),
            (r = w.byteLength),
            b.set(w, l),
            (l += r);
        return b;
      };
      m.assert = b;
      m.bytesToString = function(a) {
        b(
          null !== a && 'object' === ('undefined' === typeof a ? 'undefined' : h(a)) && void 0 !== a.length,
          'Invalid argument for bytesToString',
        );
        var c = a.length;
        if (8192 > c) return String.fromCharCode.apply(null, a);
        for (var f = [], w = 0; w < c; w += 8192) {
          var r = a.subarray(w, Math.min(w + 8192, c));
          f.push(String.fromCharCode.apply(null, r));
        }
        return f.join('');
      };
      m.createBlob = F;
      m.createPromiseCapability = u;
      m.createObjectURL = K;
      m.deprecated = function(a) {
        console.log('Deprecated API usage: ' + a);
      };
      m.getLookupTableFactory = function(a) {
        var b;
        return function() {
          a && ((b = Object.create(null)), a(b), (a = null));
          return b;
        };
      };
      m.getVerbosityLevel = function() {
        return c;
      };
      m.info = function(a) {
        c >= A.infos && console.log('Info: ' + a);
      };
      m.isArrayBuffer = function(a) {
        return 'object' === ('undefined' === typeof a ? 'undefined' : h(a)) && null !== a && void 0 !== a.byteLength;
      };
      m.isBool = function(a) {
        return 'boolean' === typeof a;
      };
      m.isEmptyObj = function(a) {
        for (var b in a) return !1;
        return !0;
      };
      m.isNum = function(a) {
        return 'number' === typeof a;
      };
      m.isString = function(a) {
        return 'string' === typeof a;
      };
      m.isSpace = function(a) {
        return 32 === a || 9 === a || 13 === a || 10 === a;
      };
      m.isNodeJS = function() {
        return (
          'object' === ('undefined' === typeof process ? 'undefined' : h(process)) &&
          '[object process]' === process + ''
        );
      };
      m.isSameOrigin = function(a, b) {
        try {
          var c = new URL(a);
          if (!c.origin || 'null' === c.origin) return !1;
        } catch (da) {
          return !1;
        }
        var f = new URL(b, c);
        return c.origin === f.origin;
      };
      m.createValidAbsoluteUrl = function(a, b) {
        if (!a) return null;
        try {
          var c = b ? new URL(a, b) : new URL(a);
          a: if (c)
            switch (c.protocol) {
              case 'http:':
              case 'https:':
              case 'ftp:':
              case 'mailto:':
              case 'tel:':
                var f = !0;
                break a;
              default:
                f = !1;
            }
          else f = !1;
          if (f) return c;
        } catch (da) {}
        return null;
      };
      m.isLittleEndian = function() {
        var a = new Uint8Array(4);
        a[0] = 1;
        return 1 === new Uint32Array(a.buffer, 0, 1)[0];
      };
      m.isEvalSupported = function() {
        try {
          return new Function(''), !0;
        } catch (H) {
          return !1;
        }
      };
      m.loadJpegStream = function(b, c, f) {
        var w = new Image();
        w.onload = function() {
          f.resolve(b, w);
        };
        w.onerror = function() {
          f.resolve(b, null);
          a('Error during JPEG image loading');
        };
        w.src = c;
      };
      m.log2 = function(a) {
        for (var b = 1, c = 0; a > b; ) (b <<= 1), c++;
        return c;
      };
      m.readInt8 = function(a, b) {
        return (a[b] << 24) >> 24;
      };
      m.readUint16 = function(a, b) {
        return (a[b] << 8) | a[b + 1];
      };
      m.readUint32 = function(a, b) {
        return ((a[b] << 24) | (a[b + 1] << 16) | (a[b + 2] << 8) | a[b + 3]) >>> 0;
      };
      m.removeNullCharacters = function(b) {
        return 'string' !== typeof b
          ? (a('The argument for removeNullCharacters must be a string.'), b)
          : b.replace(D, '');
      };
      m.ReadableStream = p.ReadableStream;
      m.setVerbosityLevel = function(a) {
        c = a;
      };
      m.shadow = function(a, b, c) {
        Object.defineProperty(a, b, { value: c, enumerable: !0, configurable: !0, writable: !1 });
        return c;
      };
      m.string32 = function(a) {
        return String.fromCharCode((a >> 24) & 255, (a >> 16) & 255, (a >> 8) & 255, a & 255);
      };
      m.stringToBytes = v;
      m.stringToPDFString = function(a) {
        var b,
          c = a.length,
          f = [];
        if ('\u00fe' === a[0] && '\u00ff' === a[1])
          for (b = 2; b < c; b += 2) f.push(String.fromCharCode((a.charCodeAt(b) << 8) | a.charCodeAt(b + 1)));
        else
          for (b = 0; b < c; ++b) {
            var r = w[a.charCodeAt(b)];
            f.push(r ? String.fromCharCode(r) : a.charAt(b));
          }
        return f.join('');
      };
      m.stringToUTF8String = function(a) {
        return decodeURIComponent(escape(a));
      };
      m.utf8StringToString = function(a) {
        return unescape(encodeURIComponent(a));
      };
      m.warn = a;
      m.unreachable = k;
    },
    function(y, m, t) {
      function a(a, b) {
        return a instanceof u && (void 0 === b || a.name === b);
      }
      function k(b, d) {
        return b instanceof C && (void 0 === d || a(b.get('Type'), d));
      }
      function b(a) {
        return a instanceof B;
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      var v =
          'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
            ? function(a) {
                return typeof a;
              }
            : function(a) {
                return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                  ? 'symbol'
                  : typeof a;
              },
        d = {},
        u = (function() {
          function a(a) {
            this.name = a;
          }
          a.prototype = {};
          var b = Object.create(null);
          a.get = function(d) {
            var e = b[d];
            return e ? e : (b[d] = new a(d));
          };
          return a;
        })(),
        z = (function() {
          function a(a) {
            this.cmd = a;
          }
          a.prototype = {};
          var b = Object.create(null);
          a.get = function(d) {
            var e = b[d];
            return e ? e : (b[d] = new a(d));
          };
          return a;
        })(),
        C = (function() {
          function a(a) {
            this._map = Object.create(null);
            this.xref = a;
            this.objId = null;
            this.suppressEncryption = !1;
            this.__nonSerializable__ = d;
          }
          var d = function() {
            return d;
          };
          a.prototype = {
            assignXref: function(a) {
              this.xref = a;
            },
            get: function(a, b, d) {
              var c,
                q = this.xref,
                e = this.suppressEncryption;
              if (
                'undefined' !== typeof (c = this._map[a]) ||
                a in this._map ||
                'undefined' === typeof b ||
                'undefined' !== typeof (c = this._map[b]) ||
                b in this._map ||
                'undefined' === typeof d
              )
                return q ? q.fetchIfRef(c, e) : c;
              c = this._map[d] || null;
              return q ? q.fetchIfRef(c, e) : c;
            },
            getAsync: function(a, b, d) {
              var c,
                q = this.xref,
                e = this.suppressEncryption;
              if (
                'undefined' !== typeof (c = this._map[a]) ||
                a in this._map ||
                'undefined' === typeof b ||
                'undefined' !== typeof (c = this._map[b]) ||
                b in this._map ||
                'undefined' === typeof d
              )
                return q ? q.fetchIfRefAsync(c, e) : Promise.resolve(c);
              c = this._map[d] || null;
              return q ? q.fetchIfRefAsync(c, e) : Promise.resolve(c);
            },
            getArray: function(a, d, e) {
              a = this.get(a, d, e);
              d = this.xref;
              e = this.suppressEncryption;
              if (!Array.isArray(a) || !d) return a;
              a = a.slice();
              for (var c = 0, q = a.length; c < q; c++) b(a[c]) && (a[c] = d.fetch(a[c], e));
              return a;
            },
            getRaw: function(a) {
              return this._map[a];
            },
            getKeys: function() {
              return Object.keys(this._map);
            },
            set: function(a, b) {
              this._map[a] = b;
            },
            has: function(a) {
              return a in this._map;
            },
            forEach: function(a) {
              for (var b in this._map) a(b, this.get(b));
            },
          };
          a.empty = new a(null);
          a.merge = function(b, d) {
            for (var e = new a(b), c = 0, q = d.length; c < q; c++) {
              var x = d[c];
              if (k(x)) for (var g in x._map) void 0 === e._map[g] && (e._map[g] = x._map[g]);
            }
            return e;
          };
          return a;
        })(),
        B = (function() {
          function a(a, b) {
            this.num = a;
            this.gen = b;
          }
          a.prototype = {
            toString: function() {
              var a = this.num + 'R';
              0 !== this.gen && (a += this.gen);
              return a;
            },
          };
          return a;
        })();
      y = (function() {
        function a() {
          this.dict = Object.create(null);
        }
        a.prototype = {
          has: function(a) {
            return a.toString() in this.dict;
          },
          put: function(a) {
            this.dict[a.toString()] = !0;
          },
          remove: function(a) {
            delete this.dict[a.toString()];
          },
        };
        return a;
      })();
      t = (function() {
        function a() {
          this.dict = Object.create(null);
        }
        a.prototype = {
          get: function(a) {
            return this.dict[a.toString()];
          },
          has: function(a) {
            return a.toString() in this.dict;
          },
          put: function(a, b) {
            this.dict[a.toString()] = b;
          },
          putAlias: function(a, b) {
            this.dict[a.toString()] = this.get(b);
          },
          forEach: function(a, b) {
            for (var d in this.dict) a.call(b, this.dict[d]);
          },
          clear: function() {
            this.dict = Object.create(null);
          },
        };
        return a;
      })();
      m.EOF = d;
      m.Cmd = z;
      m.Dict = C;
      m.Name = u;
      m.Ref = B;
      m.RefSet = y;
      m.RefSetCache = t;
      m.isEOF = function(a) {
        return a === d;
      };
      m.isCmd = function(a, b) {
        return a instanceof z && (void 0 === b || a.cmd === b);
      };
      m.isDict = k;
      m.isName = a;
      m.isRef = b;
      m.isRefsEqual = function(a, b) {
        return a.num === b.num && a.gen === b.gen;
      };
      m.isStream = function(a) {
        return 'object' === ('undefined' === typeof a ? 'undefined' : v(a)) && null !== a && void 0 !== a.getBytes;
      };
    },
    function(y, m, t) {
      var a = t(50)('wks'),
        k = t(13),
        b = t(4).Symbol,
        v = 'function' == typeof b;
      (y.exports = function(d) {
        return a[d] || (a[d] = (v && b[d]) || (v ? b : k)('Symbol.' + d));
      }).store = a;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.LZWStream = m.StringStream = m.StreamsSequenceStream = m.Stream = m.RunLengthStream = m.PredictorStream = m.NullStream = m.JpxStream = m.JpegStream = m.Jbig2Stream = m.FlateStream = m.DecodeStream = m.DecryptStream = m.CCITTFaxStream = m.AsciiHexStream = m.Ascii85Stream = void 0;
      var a = t(0),
        k = t(1),
        b = t(106),
        v = t(107),
        d = t(61),
        u = (function() {
          function a(a, b, c, l) {
            this.bytes = a instanceof Uint8Array ? a : new Uint8Array(a);
            this.pos = this.start = b || 0;
            this.end = b + c || this.bytes.length;
            this.dict = l;
          }
          a.prototype = {
            get length() {
              return this.end - this.start;
            },
            get isEmpty() {
              return 0 === this.length;
            },
            getByte: function() {
              return this.pos >= this.end ? -1 : this.bytes[this.pos++];
            },
            getUint16: function() {
              var a = this.getByte(),
                b = this.getByte();
              return -1 === a || -1 === b ? -1 : (a << 8) + b;
            },
            getInt32: function() {
              var a = this.getByte(),
                b = this.getByte(),
                c = this.getByte(),
                l = this.getByte();
              return (a << 24) + (b << 16) + (c << 8) + l;
            },
            getBytes: function(a) {
              var b = this.bytes,
                c = this.pos,
                l = this.end;
              if (!a) return b.subarray(c, l);
              a = c + a;
              a > l && (a = l);
              this.pos = a;
              return b.subarray(c, a);
            },
            peekByte: function() {
              var a = this.getByte();
              this.pos--;
              return a;
            },
            peekBytes: function(a) {
              a = this.getBytes(a);
              this.pos -= a.length;
              return a;
            },
            skip: function(a) {
              a || (a = 1);
              this.pos += a;
            },
            reset: function() {
              this.pos = this.start;
            },
            moveStart: function() {
              this.start = this.pos;
            },
            makeSubStream: function(b, c, r) {
              return new a(this.bytes.buffer, b, c, r);
            },
          };
          return a;
        })();
      y = (function() {
        function a(a) {
          for (var b = a.length, c = new Uint8Array(b), l = 0; l < b; ++l) c[l] = a.charCodeAt(l);
          u.call(this, c);
        }
        a.prototype = u.prototype;
        return a;
      })();
      var z = (function() {
        function a(a) {
          this.bufferLength = this.pos = 0;
          this.eof = !1;
          this.buffer = b;
          this.minBufferLength = 512;
          if (a) for (; this.minBufferLength < a; ) this.minBufferLength *= 2;
        }
        var b = new Uint8Array(0);
        a.prototype = {
          get isEmpty() {
            for (; !this.eof && 0 === this.bufferLength; ) this.readBlock();
            return 0 === this.bufferLength;
          },
          ensureBuffer: function(a) {
            var b = this.buffer;
            if (a <= b.byteLength) return b;
            for (var c = this.minBufferLength; c < a; ) c *= 2;
            a = new Uint8Array(c);
            a.set(b);
            return (this.buffer = a);
          },
          getByte: function() {
            for (var a = this.pos; this.bufferLength <= a; ) {
              if (this.eof) return -1;
              this.readBlock();
            }
            return this.buffer[this.pos++];
          },
          getUint16: function() {
            var a = this.getByte(),
              b = this.getByte();
            return -1 === a || -1 === b ? -1 : (a << 8) + b;
          },
          getInt32: function() {
            var a = this.getByte(),
              b = this.getByte(),
              c = this.getByte(),
              l = this.getByte();
            return (a << 24) + (b << 16) + (c << 8) + l;
          },
          getBytes: function(a) {
            var b = this.pos;
            if (a) {
              this.ensureBuffer(b + a);
              for (a = b + a; !this.eof && this.bufferLength < a; ) this.readBlock();
              var c = this.bufferLength;
              a > c && (a = c);
            } else {
              for (; !this.eof; ) this.readBlock();
              a = this.bufferLength;
            }
            this.pos = a;
            return this.buffer.subarray(b, a);
          },
          peekByte: function() {
            var a = this.getByte();
            this.pos--;
            return a;
          },
          peekBytes: function(a) {
            a = this.getBytes(a);
            this.pos -= a.length;
            return a;
          },
          makeSubStream: function(a, b, c) {
            for (var f = a + b; this.bufferLength <= f && !this.eof; ) this.readBlock();
            return new u(this.buffer, a, b, c);
          },
          skip: function(a) {
            a || (a = 1);
            this.pos += a;
          },
          reset: function() {
            this.pos = 0;
          },
          getBaseStreams: function() {
            return this.str && this.str.getBaseStreams ? this.str.getBaseStreams() : [];
          },
        };
        return a;
      })();
      t = (function() {
        function b(a) {
          this.streams = a;
          z.call(this, null);
        }
        b.prototype = Object.create(z.prototype);
        b.prototype.readBlock = function() {
          var a = this.streams;
          if (0 === a.length) this.eof = !0;
          else {
            a = a.shift().getBytes();
            var b = this.bufferLength,
              c = b + a.length;
            this.ensureBuffer(c).set(a, b);
            this.bufferLength = c;
          }
        };
        b.prototype.getBaseStreams = function() {
          for (var b = [], c = 0, r = this.streams.length; c < r; c++) {
            var l = this.streams[c];
            l.getBaseStreams && a.Util.appendToArray(b, l.getBaseStreams());
          }
          return b;
        };
        return b;
      })();
      var C = (function() {
          function b(b, c) {
            this.str = b;
            this.dict = b.dict;
            var w = b.getByte(),
              f = b.getByte();
            if (-1 === w || -1 === f) throw new a.FormatError('Invalid header in flate stream: ' + w + ', ' + f);
            if (8 !== (w & 15)) throw new a.FormatError('Unknown compression method in flate stream: ' + w + ', ' + f);
            if (0 !== ((w << 8) + f) % 31) throw new a.FormatError('Bad FCHECK in flate stream: ' + w + ', ' + f);
            if (f & 32) throw new a.FormatError('FDICT bit set in flate stream: ' + w + ', ' + f);
            this.codeBuf = this.codeSize = 0;
            z.call(this, c);
          }
          var c = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
            f = new Int32Array([
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              65547,
              65549,
              65551,
              65553,
              131091,
              131095,
              131099,
              131103,
              196643,
              196651,
              196659,
              196667,
              262211,
              262227,
              262243,
              262259,
              327811,
              327843,
              327875,
              327907,
              258,
              258,
              258,
            ]),
            r = new Int32Array([
              1,
              2,
              3,
              4,
              65541,
              65543,
              131081,
              131085,
              196625,
              196633,
              262177,
              262193,
              327745,
              327777,
              393345,
              393409,
              459009,
              459137,
              524801,
              525057,
              590849,
              591361,
              657409,
              658433,
              724993,
              727041,
              794625,
              798721,
              868353,
              876545,
            ]),
            d = [
              new Int32Array([
                459008,
                524368,
                524304,
                524568,
                459024,
                524400,
                524336,
                590016,
                459016,
                524384,
                524320,
                589984,
                524288,
                524416,
                524352,
                590048,
                459012,
                524376,
                524312,
                589968,
                459028,
                524408,
                524344,
                590032,
                459020,
                524392,
                524328,
                59e4,
                524296,
                524424,
                524360,
                590064,
                459010,
                524372,
                524308,
                524572,
                459026,
                524404,
                524340,
                590024,
                459018,
                524388,
                524324,
                589992,
                524292,
                524420,
                524356,
                590056,
                459014,
                524380,
                524316,
                589976,
                459030,
                524412,
                524348,
                590040,
                459022,
                524396,
                524332,
                590008,
                524300,
                524428,
                524364,
                590072,
                459009,
                524370,
                524306,
                524570,
                459025,
                524402,
                524338,
                590020,
                459017,
                524386,
                524322,
                589988,
                524290,
                524418,
                524354,
                590052,
                459013,
                524378,
                524314,
                589972,
                459029,
                524410,
                524346,
                590036,
                459021,
                524394,
                524330,
                590004,
                524298,
                524426,
                524362,
                590068,
                459011,
                524374,
                524310,
                524574,
                459027,
                524406,
                524342,
                590028,
                459019,
                524390,
                524326,
                589996,
                524294,
                524422,
                524358,
                590060,
                459015,
                524382,
                524318,
                589980,
                459031,
                524414,
                524350,
                590044,
                459023,
                524398,
                524334,
                590012,
                524302,
                524430,
                524366,
                590076,
                459008,
                524369,
                524305,
                524569,
                459024,
                524401,
                524337,
                590018,
                459016,
                524385,
                524321,
                589986,
                524289,
                524417,
                524353,
                590050,
                459012,
                524377,
                524313,
                589970,
                459028,
                524409,
                524345,
                590034,
                459020,
                524393,
                524329,
                590002,
                524297,
                524425,
                524361,
                590066,
                459010,
                524373,
                524309,
                524573,
                459026,
                524405,
                524341,
                590026,
                459018,
                524389,
                524325,
                589994,
                524293,
                524421,
                524357,
                590058,
                459014,
                524381,
                524317,
                589978,
                459030,
                524413,
                524349,
                590042,
                459022,
                524397,
                524333,
                590010,
                524301,
                524429,
                524365,
                590074,
                459009,
                524371,
                524307,
                524571,
                459025,
                524403,
                524339,
                590022,
                459017,
                524387,
                524323,
                589990,
                524291,
                524419,
                524355,
                590054,
                459013,
                524379,
                524315,
                589974,
                459029,
                524411,
                524347,
                590038,
                459021,
                524395,
                524331,
                590006,
                524299,
                524427,
                524363,
                590070,
                459011,
                524375,
                524311,
                524575,
                459027,
                524407,
                524343,
                590030,
                459019,
                524391,
                524327,
                589998,
                524295,
                524423,
                524359,
                590062,
                459015,
                524383,
                524319,
                589982,
                459031,
                524415,
                524351,
                590046,
                459023,
                524399,
                524335,
                590014,
                524303,
                524431,
                524367,
                590078,
                459008,
                524368,
                524304,
                524568,
                459024,
                524400,
                524336,
                590017,
                459016,
                524384,
                524320,
                589985,
                524288,
                524416,
                524352,
                590049,
                459012,
                524376,
                524312,
                589969,
                459028,
                524408,
                524344,
                590033,
                459020,
                524392,
                524328,
                590001,
                524296,
                524424,
                524360,
                590065,
                459010,
                524372,
                524308,
                524572,
                459026,
                524404,
                524340,
                590025,
                459018,
                524388,
                524324,
                589993,
                524292,
                524420,
                524356,
                590057,
                459014,
                524380,
                524316,
                589977,
                459030,
                524412,
                524348,
                590041,
                459022,
                524396,
                524332,
                590009,
                524300,
                524428,
                524364,
                590073,
                459009,
                524370,
                524306,
                524570,
                459025,
                524402,
                524338,
                590021,
                459017,
                524386,
                524322,
                589989,
                524290,
                524418,
                524354,
                590053,
                459013,
                524378,
                524314,
                589973,
                459029,
                524410,
                524346,
                590037,
                459021,
                524394,
                524330,
                590005,
                524298,
                524426,
                524362,
                590069,
                459011,
                524374,
                524310,
                524574,
                459027,
                524406,
                524342,
                590029,
                459019,
                524390,
                524326,
                589997,
                524294,
                524422,
                524358,
                590061,
                459015,
                524382,
                524318,
                589981,
                459031,
                524414,
                524350,
                590045,
                459023,
                524398,
                524334,
                590013,
                524302,
                524430,
                524366,
                590077,
                459008,
                524369,
                524305,
                524569,
                459024,
                524401,
                524337,
                590019,
                459016,
                524385,
                524321,
                589987,
                524289,
                524417,
                524353,
                590051,
                459012,
                524377,
                524313,
                589971,
                459028,
                524409,
                524345,
                590035,
                459020,
                524393,
                524329,
                590003,
                524297,
                524425,
                524361,
                590067,
                459010,
                524373,
                524309,
                524573,
                459026,
                524405,
                524341,
                590027,
                459018,
                524389,
                524325,
                589995,
                524293,
                524421,
                524357,
                590059,
                459014,
                524381,
                524317,
                589979,
                459030,
                524413,
                524349,
                590043,
                459022,
                524397,
                524333,
                590011,
                524301,
                524429,
                524365,
                590075,
                459009,
                524371,
                524307,
                524571,
                459025,
                524403,
                524339,
                590023,
                459017,
                524387,
                524323,
                589991,
                524291,
                524419,
                524355,
                590055,
                459013,
                524379,
                524315,
                589975,
                459029,
                524411,
                524347,
                590039,
                459021,
                524395,
                524331,
                590007,
                524299,
                524427,
                524363,
                590071,
                459011,
                524375,
                524311,
                524575,
                459027,
                524407,
                524343,
                590031,
                459019,
                524391,
                524327,
                589999,
                524295,
                524423,
                524359,
                590063,
                459015,
                524383,
                524319,
                589983,
                459031,
                524415,
                524351,
                590047,
                459023,
                524399,
                524335,
                590015,
                524303,
                524431,
                524367,
                590079,
              ]),
              9,
            ],
            g = [
              new Int32Array([
                327680,
                327696,
                327688,
                327704,
                327684,
                327700,
                327692,
                327708,
                327682,
                327698,
                327690,
                327706,
                327686,
                327702,
                327694,
                0,
                327681,
                327697,
                327689,
                327705,
                327685,
                327701,
                327693,
                327709,
                327683,
                327699,
                327691,
                327707,
                327687,
                327703,
                327695,
                0,
              ]),
              5,
            ];
          b.prototype = Object.create(z.prototype);
          b.prototype.getBits = function(b) {
            for (var c = this.str, f = this.codeSize, r = this.codeBuf, l; f < b; ) {
              if (-1 === (l = c.getByte())) throw new a.FormatError('Bad encoding in flate stream');
              r |= l << f;
              f += 8;
            }
            this.codeBuf = r >> b;
            this.codeSize = f - b;
            return r & ((1 << b) - 1);
          };
          b.prototype.getCode = function(b) {
            var c = this.str,
              f = b[0],
              r = b[1];
            b = this.codeSize;
            for (var l = this.codeBuf, d; b < r && -1 !== (d = c.getByte()); ) (l |= d << b), (b += 8);
            f = f[l & ((1 << r) - 1)];
            c = f >> 16;
            f &= 65535;
            if (1 > c || b < c) throw new a.FormatError('Bad encoding in flate stream');
            this.codeBuf = l >> c;
            this.codeSize = b - c;
            return f;
          };
          b.prototype.generateHuffmanTable = function(a) {
            var b = a.length,
              c = 0,
              f;
            for (f = 0; f < b; ++f) a[f] > c && (c = a[f]);
            for (var r = 1 << c, l = new Int32Array(r), d = 1, g = 0, q = 2; d <= c; ++d, g <<= 1, q <<= 1)
              for (var D = 0; D < b; ++D)
                if (a[D] === d) {
                  var e = 0,
                    x = g;
                  for (f = 0; f < d; ++f) (e = (e << 1) | (x & 1)), (x >>= 1);
                  for (f = e; f < r; f += q) l[f] = (d << 16) | D;
                  ++g;
                }
            return [l, c];
          };
          b.prototype.readBlock = function() {
            var b = this.str;
            var w = this.getBits(3);
            w & 1 && (this.eof = !0);
            w >>= 1;
            if (0 === w) {
              var l;
              if (-1 === (l = b.getByte())) throw new a.FormatError('Bad block header in flate stream');
              var q = l;
              if (-1 === (l = b.getByte())) throw new a.FormatError('Bad block header in flate stream');
              q |= l << 8;
              if (-1 === (l = b.getByte())) throw new a.FormatError('Bad block header in flate stream');
              w = l;
              if (-1 === (l = b.getByte())) throw new a.FormatError('Bad block header in flate stream');
              w |= l << 8;
              if (w !== (~q & 65535) && (0 !== q || 0 !== w))
                throw new a.FormatError('Bad uncompressed block length in flate stream');
              this.codeSize = this.codeBuf = 0;
              l = this.bufferLength;
              w = this.ensureBuffer(l + q);
              var D = l + q;
              this.bufferLength = D;
              if (0 === q) -1 === b.peekByte() && (this.eof = !0);
              else
                for (q = l; q < D; ++q) {
                  if (-1 === (l = b.getByte())) {
                    this.eof = !0;
                    break;
                  }
                  w[q] = l;
                }
            } else {
              if (1 === w) (l = d), (q = g);
              else if (2 === w) {
                w = this.getBits(5) + 257;
                D = this.getBits(5) + 1;
                b = this.getBits(4) + 4;
                q = new Uint8Array(c.length);
                for (l = 0; l < b; ++l) q[c[l]] = this.getBits(3);
                q = this.generateHuffmanTable(q);
                l = b = 0;
                D = w + D;
                for (var e = new Uint8Array(D), x, p, h; l < D; ) {
                  h = this.getCode(q);
                  if (16 === h) (x = 2), (p = 3), (h = b);
                  else if (17 === h) (p = x = 3), (h = b = 0);
                  else if (18 === h) (x = 7), (p = 11), (h = b = 0);
                  else {
                    e[l++] = b = h;
                    continue;
                  }
                  for (x = this.getBits(x) + p; 0 < x--; ) e[l++] = h;
                }
                l = this.generateHuffmanTable(e.subarray(0, w));
                q = this.generateHuffmanTable(e.subarray(w, D));
              } else throw new a.FormatError('Unknown block type in flate stream');
              D = (w = this.buffer) ? w.length : 0;
              for (e = this.bufferLength; ; )
                if (((h = this.getCode(l)), 256 > h))
                  e + 1 >= D && ((w = this.ensureBuffer(e + 1)), (D = w.length)), (w[e++] = h);
                else {
                  if (256 === h) {
                    this.bufferLength = e;
                    break;
                  }
                  h -= 257;
                  h = f[h];
                  x = h >> 16;
                  0 < x && (x = this.getBits(x));
                  b = (h & 65535) + x;
                  h = this.getCode(q);
                  h = r[h];
                  x = h >> 16;
                  0 < x && (x = this.getBits(x));
                  h = (h & 65535) + x;
                  e + b >= D && ((w = this.ensureBuffer(e + b)), (D = w.length));
                  for (x = 0; x < b; ++x, ++e) w[e] = w[e - h];
                }
            }
          };
          return b;
        })(),
        B = (function() {
          function b(b, c, r) {
            if (!(0, k.isDict)(r)) return b;
            var f = (this.predictor = r.get('Predictor') || 1);
            if (1 >= f) return b;
            if (2 !== f && (10 > f || 15 < f)) throw new a.FormatError('Unsupported predictor: ' + f);
            this.readBlock = 2 === f ? this.readBlockTiff : this.readBlockPng;
            this.str = b;
            this.dict = b.dict;
            b = this.colors = r.get('Colors') || 1;
            f = this.bits = r.get('BitsPerComponent') || 8;
            r = this.columns = r.get('Columns') || 1;
            this.pixBytes = (b * f + 7) >> 3;
            this.rowBytes = (r * b * f + 7) >> 3;
            z.call(this, c);
            return this;
          }
          b.prototype = Object.create(z.prototype);
          b.prototype.readBlockTiff = function() {
            var a = this.rowBytes,
              b = this.bufferLength,
              c = this.ensureBuffer(b + a),
              l = this.bits,
              d = this.colors,
              g = this.str.getBytes(a);
            this.eof = !g.length;
            if (!this.eof) {
              var w = 0,
                q = 0,
                e = 0,
                x = 0,
                p = b;
              if (1 === l && 1 === d)
                for (b = 0; b < a; ++b)
                  (l = g[b] ^ w), (l ^= l >> 1), (l ^= l >> 2), (l ^= l >> 4), (w = (l & 1) << 7), (c[p++] = l);
              else if (8 === l) {
                for (b = 0; b < d; ++b) c[p++] = g[b];
                for (; b < a; ++b) (c[p] = c[p - d] + g[b]), p++;
              } else if (16 === l) {
                w = 2 * d;
                for (b = 0; b < w; ++b) c[p++] = g[b];
                for (; b < a; b += 2)
                  (l = ((g[b] & 255) << 8) + (g[b + 1] & 255) + ((c[p - w] & 255) << 8) + (c[p - w + 1] & 255)),
                    (c[p++] = (l >> 8) & 255),
                    (c[p++] = l & 255);
              } else {
                p = new Uint8Array(d + 1);
                var h = (1 << l) - 1,
                  n = 0,
                  A = b,
                  G = this.columns;
                for (b = 0; b < G; ++b)
                  for (var k = 0; k < d; ++k)
                    e < l && ((w = (w << 8) | (g[n++] & 255)), (e += 8)),
                      (p[k] = (p[k] + (w >> (e - l))) & h),
                      (e -= l),
                      (q = (q << l) | p[k]),
                      (x += l),
                      8 <= x && ((c[A++] = (q >> (x - 8)) & 255), (x -= 8));
                0 < x && (c[A++] = (q << (8 - x)) + (w & ((1 << (8 - x)) - 1)));
              }
              this.bufferLength += a;
            }
          };
          b.prototype.readBlockPng = function() {
            var b = this.rowBytes,
              c = this.pixBytes,
              r = this.str.getByte(),
              l = this.str.getBytes(b);
            this.eof = !l.length;
            if (!this.eof) {
              var d = this.bufferLength,
                g = this.ensureBuffer(d + b),
                w = g.subarray(d - b, d);
              0 === w.length && (w = new Uint8Array(b));
              switch (r) {
                case 0:
                  for (r = 0; r < b; ++r) g[d++] = l[r];
                  break;
                case 1:
                  for (r = 0; r < c; ++r) g[d++] = l[r];
                  for (; r < b; ++r) (g[d] = (g[d - c] + l[r]) & 255), d++;
                  break;
                case 2:
                  for (r = 0; r < b; ++r) g[d++] = (w[r] + l[r]) & 255;
                  break;
                case 3:
                  for (r = 0; r < c; ++r) g[d++] = (w[r] >> 1) + l[r];
                  for (; r < b; ++r) (g[d] = (((w[r] + g[d - c]) >> 1) + l[r]) & 255), d++;
                  break;
                case 4:
                  for (r = 0; r < c; ++r) {
                    var q = w[r];
                    var e = l[r];
                    g[d++] = q + e;
                  }
                  for (; r < b; ++r) {
                    q = w[r];
                    var x = w[r - c],
                      p = g[d - c];
                    e = p + q - x;
                    var h = e - p;
                    0 > h && (h = -h);
                    var n = e - q;
                    0 > n && (n = -n);
                    var A = e - x;
                    0 > A && (A = -A);
                    e = l[r];
                    h <= n && h <= A ? (g[d++] = p + e) : n <= A ? (g[d++] = q + e) : (g[d++] = x + e);
                  }
                  break;
                default:
                  throw new a.FormatError('Unsupported predictor: ' + r);
              }
              this.bufferLength += b;
            }
          };
          return b;
        })(),
        n = (function() {
          function b(a, b, c, l) {
            for (var f; -1 !== (f = a.getByte()); )
              if (255 === f) {
                a.skip(-1);
                break;
              }
            this.stream = a;
            this.maybeLength = b;
            this.dict = c;
            this.params = l;
            z.call(this, b);
          }
          b.prototype = Object.create(z.prototype);
          Object.defineProperty(b.prototype, 'bytes', {
            get: function() {
              return (0, a.shadow)(this, 'bytes', this.stream.getBytes(this.maybeLength));
            },
            configurable: !0,
          });
          b.prototype.ensureBuffer = function(a) {
            if (!this.bufferLength) {
              a = new v.JpegImage();
              var b = this.dict.getArray('Decode', 'D');
              if (this.forceRGB && Array.isArray(b)) {
                var c = this.dict.get('BitsPerComponent') || 8,
                  l = b.length,
                  d = new Int32Array(l),
                  g = !1;
                c = (1 << c) - 1;
                for (var w = 0; w < l; w += 2)
                  if (
                    ((d[w] = (256 * (b[w + 1] - b[w])) | 0),
                    (d[w + 1] = (b[w] * c) | 0),
                    256 !== d[w] || 0 !== d[w + 1])
                  )
                    g = !0;
                g && (a.decodeTransform = d);
              }
              (0, k.isDict)(this.params) &&
                ((b = this.params.get('ColorTransform')), Number.isInteger(b) && (a.colorTransform = b));
              a.parse(this.bytes);
              this.buffer = a = a.getData(this.drawWidth, this.drawHeight, this.forceRGB);
              this.bufferLength = a.length;
              this.eof = !0;
            }
          };
          b.prototype.getBytes = function(a) {
            this.ensureBuffer();
            return this.buffer;
          };
          b.prototype.getIR = function(b) {
            return (0, a.createObjectURL)(this.bytes, 'image/jpeg', b);
          };
          return b;
        })(),
        e = (function() {
          function b(a, b, c, l) {
            this.stream = a;
            this.maybeLength = b;
            this.dict = c;
            this.params = l;
            z.call(this, b);
          }
          b.prototype = Object.create(z.prototype);
          Object.defineProperty(b.prototype, 'bytes', {
            get: function() {
              return (0, a.shadow)(this, 'bytes', this.stream.getBytes(this.maybeLength));
            },
            configurable: !0,
          });
          b.prototype.ensureBuffer = function(a) {
            if (!this.bufferLength) {
              a = new d.JpxImage();
              a.parse(this.bytes);
              var b = a.width,
                c = a.height,
                l = a.componentsCount,
                g = a.tiles.length;
              if (1 === g) this.buffer = a.tiles[0].items;
              else {
                c = new Uint8ClampedArray(b * c * l);
                for (var q = 0; q < g; q++) {
                  var w = a.tiles[q],
                    E = w.height,
                    e = w.items,
                    x = 0,
                    p = (b * w.top + w.left) * l,
                    h = b * l;
                  w = w.width * l;
                  for (var n = 0; n < E; n++) {
                    var A = e.subarray(x, x + w);
                    c.set(A, p);
                    x += w;
                    p += h;
                  }
                }
                this.buffer = c;
              }
              this.bufferLength = this.buffer.length;
              this.eof = !0;
            }
          };
          return b;
        })(),
        h = (function() {
          function c(a, b, c, l) {
            this.stream = a;
            this.maybeLength = b;
            this.dict = c;
            this.params = l;
            z.call(this, b);
          }
          c.prototype = Object.create(z.prototype);
          Object.defineProperty(c.prototype, 'bytes', {
            get: function() {
              return (0, a.shadow)(this, 'bytes', this.stream.getBytes(this.maybeLength));
            },
            configurable: !0,
          });
          c.prototype.ensureBuffer = function(a) {
            if (!this.bufferLength) {
              a = new b.Jbig2Image();
              var c = [];
              if ((0, k.isDict)(this.params)) {
                var r = this.params.get('JBIG2Globals');
                (0, k.isStream)(r) && ((r = r.getBytes()), c.push({ data: r, start: 0, end: r.length }));
              }
              c.push({ data: this.bytes, start: 0, end: this.bytes.length });
              a = a.parseChunks(c);
              c = a.length;
              for (r = 0; r < c; r++) a[r] ^= 255;
              this.buffer = a;
              this.bufferLength = c;
              this.eof = !0;
            }
          };
          return c;
        })(),
        p = (function() {
          function a(a, b, c) {
            this.str = a;
            this.dict = a.dict;
            this.decrypt = c;
            this.nextChunk = null;
            this.initialized = !1;
            z.call(this, b);
          }
          a.prototype = Object.create(z.prototype);
          a.prototype.readBlock = function() {
            if (this.initialized) var a = this.nextChunk;
            else (a = this.str.getBytes(512)), (this.initialized = !0);
            if (a && 0 !== a.length) {
              this.nextChunk = this.str.getBytes(512);
              var b = this.decrypt;
              a = b(a, !(this.nextChunk && 0 < this.nextChunk.length));
              b = this.bufferLength;
              var c,
                l = a.length,
                d = this.ensureBuffer(b + l);
              for (c = 0; c < l; c++) d[b++] = a[c];
              this.bufferLength = b;
            } else this.eof = !0;
          };
          return a;
        })(),
        A = (function() {
          function b(a, b) {
            this.str = a;
            this.dict = a.dict;
            this.input = new Uint8Array(5);
            b && (b *= 0.8);
            z.call(this, b);
          }
          b.prototype = Object.create(z.prototype);
          b.prototype.readBlock = function() {
            for (var b = this.str, c = b.getByte(); (0, a.isSpace)(c); ) c = b.getByte();
            if (-1 === c || 126 === c) this.eof = !0;
            else {
              var r = this.bufferLength,
                l;
              if (122 === c) {
                b = this.ensureBuffer(r + 4);
                for (l = 0; 4 > l; ++l) b[r + l] = 0;
                this.bufferLength += 4;
              } else {
                var d = this.input;
                d[0] = c;
                for (l = 1; 5 > l; ++l) {
                  for (c = b.getByte(); (0, a.isSpace)(c); ) c = b.getByte();
                  d[l] = c;
                  if (-1 === c || 126 === c) break;
                }
                b = this.ensureBuffer(r + l - 1);
                this.bufferLength += l - 1;
                if (5 > l) {
                  for (; 5 > l; ++l) d[l] = 117;
                  this.eof = !0;
                }
                for (l = c = 0; 5 > l; ++l) c = 85 * c + (d[l] - 33);
                for (l = 3; 0 <= l; --l) (b[r + l] = c & 255), (c >>= 8);
              }
            }
          };
          return b;
        })(),
        c = (function() {
          function a(a, b) {
            this.str = a;
            this.dict = a.dict;
            this.firstDigit = -1;
            b && (b *= 0.5);
            z.call(this, b);
          }
          a.prototype = Object.create(z.prototype);
          a.prototype.readBlock = function() {
            var a = this.str.getBytes(8e3);
            if (a.length) {
              for (
                var b = this.ensureBuffer(this.bufferLength + ((a.length + 1) >> 1)),
                  c = this.bufferLength,
                  l = this.firstDigit,
                  d = 0,
                  g = a.length;
                d < g;
                d++
              ) {
                var w = a[d];
                if (48 <= w && 57 >= w) w &= 15;
                else if ((65 <= w && 70 >= w) || (97 <= w && 102 >= w)) w = (w & 15) + 9;
                else if (62 === w) {
                  this.eof = !0;
                  break;
                } else continue;
                0 > l ? (l = w) : ((b[c++] = (l << 4) | w), (l = -1));
              }
              0 <= l && this.eof && ((b[c++] = l << 4), (l = -1));
              this.firstDigit = l;
              this.bufferLength = c;
            } else this.eof = !0;
          };
          return a;
        })(),
        q = (function() {
          function a(a, b) {
            this.str = a;
            this.dict = a.dict;
            z.call(this, b);
          }
          a.prototype = Object.create(z.prototype);
          a.prototype.readBlock = function() {
            var a = this.str.getBytes(2);
            if (!a || 2 > a.length || 128 === a[0]) this.eof = !0;
            else {
              var b = this.bufferLength,
                c = a[0];
              if (128 > c) {
                var l = this.ensureBuffer(b + c + 1);
                l[b++] = a[1];
                0 < c && ((a = this.str.getBytes(c)), l.set(a, b), (b += c));
              } else {
                c = 257 - c;
                a = a[1];
                l = this.ensureBuffer(b + c + 1);
                for (var d = 0; d < c; d++) l[b++] = a;
              }
              this.bufferLength = b;
            }
          };
          return a;
        })(),
        x = (function() {
          function b(a, b, c) {
            this.str = a;
            this.dict = a.dict;
            (0, k.isDict)(c) || (c = k.Dict.empty);
            this.encoding = c.get('K') || 0;
            this.eoline = c.get('EndOfLine') || !1;
            this.byteAlign = c.get('EncodedByteAlign') || !1;
            this.columns = c.get('Columns') || 1728;
            this.rows = c.get('Rows') || 0;
            a = c.get('EndOfBlock');
            if (null === a || void 0 === a) a = !0;
            this.eoblock = a;
            this.black = c.get('BlackIs1') || !1;
            this.codingLine = new Uint32Array(this.columns + 1);
            this.refLine = new Uint32Array(this.columns + 2);
            this.codingLine[0] = this.columns;
            this.row = this.codingPos = 0;
            this.nextLine2D = 0 > this.encoding;
            this.outputBits = this.inputBuf = this.inputBits = 0;
            for (this.rowsDone = !1; 0 === (c = this.lookBits(12)); ) this.eatBits(1);
            1 === c && this.eatBits(12);
            0 < this.encoding && ((this.nextLine2D = !this.lookBits(1)), this.eatBits(1));
            z.call(this, b);
          }
          var c = [
              [-1, -1],
              [-1, -1],
              [7, 8],
              [7, 7],
              [6, 6],
              [6, 6],
              [6, 5],
              [6, 5],
              [4, 0],
              [4, 0],
              [4, 0],
              [4, 0],
              [4, 0],
              [4, 0],
              [4, 0],
              [4, 0],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [3, 3],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
              [1, 2],
            ],
            f = [
              [-1, -1],
              [12, -2],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [11, 1792],
              [11, 1792],
              [12, 1984],
              [12, 2048],
              [12, 2112],
              [12, 2176],
              [12, 2240],
              [12, 2304],
              [11, 1856],
              [11, 1856],
              [11, 1920],
              [11, 1920],
              [12, 2368],
              [12, 2432],
              [12, 2496],
              [12, 2560],
            ],
            r = [
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [8, 29],
              [8, 29],
              [8, 30],
              [8, 30],
              [8, 45],
              [8, 45],
              [8, 46],
              [8, 46],
              [7, 22],
              [7, 22],
              [7, 22],
              [7, 22],
              [7, 23],
              [7, 23],
              [7, 23],
              [7, 23],
              [8, 47],
              [8, 47],
              [8, 48],
              [8, 48],
              [6, 13],
              [6, 13],
              [6, 13],
              [6, 13],
              [6, 13],
              [6, 13],
              [6, 13],
              [6, 13],
              [7, 20],
              [7, 20],
              [7, 20],
              [7, 20],
              [8, 33],
              [8, 33],
              [8, 34],
              [8, 34],
              [8, 35],
              [8, 35],
              [8, 36],
              [8, 36],
              [8, 37],
              [8, 37],
              [8, 38],
              [8, 38],
              [7, 19],
              [7, 19],
              [7, 19],
              [7, 19],
              [8, 31],
              [8, 31],
              [8, 32],
              [8, 32],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 1],
              [6, 12],
              [6, 12],
              [6, 12],
              [6, 12],
              [6, 12],
              [6, 12],
              [6, 12],
              [6, 12],
              [8, 53],
              [8, 53],
              [8, 54],
              [8, 54],
              [7, 26],
              [7, 26],
              [7, 26],
              [7, 26],
              [8, 39],
              [8, 39],
              [8, 40],
              [8, 40],
              [8, 41],
              [8, 41],
              [8, 42],
              [8, 42],
              [8, 43],
              [8, 43],
              [8, 44],
              [8, 44],
              [7, 21],
              [7, 21],
              [7, 21],
              [7, 21],
              [7, 28],
              [7, 28],
              [7, 28],
              [7, 28],
              [8, 61],
              [8, 61],
              [8, 62],
              [8, 62],
              [8, 63],
              [8, 63],
              [8, 0],
              [8, 0],
              [8, 320],
              [8, 320],
              [8, 384],
              [8, 384],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 10],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [5, 11],
              [7, 27],
              [7, 27],
              [7, 27],
              [7, 27],
              [8, 59],
              [8, 59],
              [8, 60],
              [8, 60],
              [9, 1472],
              [9, 1536],
              [9, 1600],
              [9, 1728],
              [7, 18],
              [7, 18],
              [7, 18],
              [7, 18],
              [7, 24],
              [7, 24],
              [7, 24],
              [7, 24],
              [8, 49],
              [8, 49],
              [8, 50],
              [8, 50],
              [8, 51],
              [8, 51],
              [8, 52],
              [8, 52],
              [7, 25],
              [7, 25],
              [7, 25],
              [7, 25],
              [8, 55],
              [8, 55],
              [8, 56],
              [8, 56],
              [8, 57],
              [8, 57],
              [8, 58],
              [8, 58],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 192],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [6, 1664],
              [8, 448],
              [8, 448],
              [8, 512],
              [8, 512],
              [9, 704],
              [9, 768],
              [8, 640],
              [8, 640],
              [8, 576],
              [8, 576],
              [9, 832],
              [9, 896],
              [9, 960],
              [9, 1024],
              [9, 1088],
              [9, 1152],
              [9, 1216],
              [9, 1280],
              [9, 1344],
              [9, 1408],
              [7, 256],
              [7, 256],
              [7, 256],
              [7, 256],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 2],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [4, 3],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 128],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 8],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [5, 9],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 16],
              [6, 17],
              [6, 17],
              [6, 17],
              [6, 17],
              [6, 17],
              [6, 17],
              [6, 17],
              [6, 17],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 4],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 14],
              [6, 15],
              [6, 15],
              [6, 15],
              [6, 15],
              [6, 15],
              [6, 15],
              [6, 15],
              [6, 15],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [5, 64],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
              [4, 7],
            ],
            d = [
              [-1, -1],
              [-1, -1],
              [12, -2],
              [12, -2],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [11, 1792],
              [11, 1792],
              [11, 1792],
              [11, 1792],
              [12, 1984],
              [12, 1984],
              [12, 2048],
              [12, 2048],
              [12, 2112],
              [12, 2112],
              [12, 2176],
              [12, 2176],
              [12, 2240],
              [12, 2240],
              [12, 2304],
              [12, 2304],
              [11, 1856],
              [11, 1856],
              [11, 1856],
              [11, 1856],
              [11, 1920],
              [11, 1920],
              [11, 1920],
              [11, 1920],
              [12, 2368],
              [12, 2368],
              [12, 2432],
              [12, 2432],
              [12, 2496],
              [12, 2496],
              [12, 2560],
              [12, 2560],
              [10, 18],
              [10, 18],
              [10, 18],
              [10, 18],
              [10, 18],
              [10, 18],
              [10, 18],
              [10, 18],
              [12, 52],
              [12, 52],
              [13, 640],
              [13, 704],
              [13, 768],
              [13, 832],
              [12, 55],
              [12, 55],
              [12, 56],
              [12, 56],
              [13, 1280],
              [13, 1344],
              [13, 1408],
              [13, 1472],
              [12, 59],
              [12, 59],
              [12, 60],
              [12, 60],
              [13, 1536],
              [13, 1600],
              [11, 24],
              [11, 24],
              [11, 24],
              [11, 24],
              [11, 25],
              [11, 25],
              [11, 25],
              [11, 25],
              [13, 1664],
              [13, 1728],
              [12, 320],
              [12, 320],
              [12, 384],
              [12, 384],
              [12, 448],
              [12, 448],
              [13, 512],
              [13, 576],
              [12, 53],
              [12, 53],
              [12, 54],
              [12, 54],
              [13, 896],
              [13, 960],
              [13, 1024],
              [13, 1088],
              [13, 1152],
              [13, 1216],
              [10, 64],
              [10, 64],
              [10, 64],
              [10, 64],
              [10, 64],
              [10, 64],
              [10, 64],
              [10, 64],
            ],
            g = [
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [8, 13],
              [11, 23],
              [11, 23],
              [12, 50],
              [12, 51],
              [12, 44],
              [12, 45],
              [12, 46],
              [12, 47],
              [12, 57],
              [12, 58],
              [12, 61],
              [12, 256],
              [10, 16],
              [10, 16],
              [10, 16],
              [10, 16],
              [10, 17],
              [10, 17],
              [10, 17],
              [10, 17],
              [12, 48],
              [12, 49],
              [12, 62],
              [12, 63],
              [12, 30],
              [12, 31],
              [12, 32],
              [12, 33],
              [12, 40],
              [12, 41],
              [11, 22],
              [11, 22],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [8, 14],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 10],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [7, 11],
              [9, 15],
              [9, 15],
              [9, 15],
              [9, 15],
              [9, 15],
              [9, 15],
              [9, 15],
              [9, 15],
              [12, 128],
              [12, 192],
              [12, 26],
              [12, 27],
              [12, 28],
              [12, 29],
              [11, 19],
              [11, 19],
              [11, 20],
              [11, 20],
              [12, 34],
              [12, 35],
              [12, 36],
              [12, 37],
              [12, 38],
              [12, 39],
              [11, 21],
              [11, 21],
              [12, 42],
              [12, 43],
              [10, 0],
              [10, 0],
              [10, 0],
              [10, 0],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
              [7, 12],
            ],
            q = [
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [-1, -1],
              [6, 9],
              [6, 8],
              [5, 7],
              [5, 7],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 6],
              [4, 5],
              [4, 5],
              [4, 5],
              [4, 5],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 1],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [3, 4],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 3],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
              [2, 2],
            ];
          b.prototype = Object.create(z.prototype);
          b.prototype.readBlock = function() {
            for (; !this.eof; ) {
              var a = this.lookChar();
              this.ensureBuffer(this.bufferLength + 1);
              this.buffer[this.bufferLength++] = a;
            }
          };
          b.prototype.addPixels = function(b, c) {
            var w = this.codingLine,
              f = this.codingPos;
            b > w[f] &&
              (b > this.columns && ((0, a.info)('row is wrong length'), (this.err = !0), (b = this.columns)),
              (f & 1) ^ c && ++f,
              (w[f] = b));
            this.codingPos = f;
          };
          b.prototype.addPixelsNeg = function(b, c) {
            var w = this.codingLine,
              f = this.codingPos;
            if (b > w[f])
              b > this.columns && ((0, a.info)('row is wrong length'), (this.err = !0), (b = this.columns)),
                (f & 1) ^ c && ++f,
                (w[f] = b);
            else if (b < w[f]) {
              0 > b && ((0, a.info)('invalid code'), (this.err = !0), (b = 0));
              for (; 0 < f && b < w[f - 1]; ) --f;
              w[f] = b;
            }
            this.codingPos = f;
          };
          b.prototype.lookChar = function() {
            var b = this.refLine,
              c = this.codingLine,
              f = this.columns,
              r,
              l;
            if (0 === this.outputBits) {
              this.rowsDone && (this.eof = !0);
              if (this.eof) return null;
              this.err = !1;
              var d, g;
              if (this.nextLine2D) {
                for (r = 0; c[r] < f; ++r) b[r] = c[r];
                b[r++] = f;
                b[r] = f;
                for (l = r = this.codingPos = c[0] = 0; c[this.codingPos] < f; ) {
                  var q = this.getTwoDimCode();
                  switch (q) {
                    case 0:
                      this.addPixels(b[r + 1], l);
                      b[r + 1] < f && (r += 2);
                      break;
                    case 1:
                      q = d = 0;
                      if (l) {
                        do q += g = this.getBlackCode();
                        while (64 <= g);
                        do d += g = this.getWhiteCode();
                        while (64 <= g);
                      } else {
                        do q += g = this.getWhiteCode();
                        while (64 <= g);
                        do d += g = this.getBlackCode();
                        while (64 <= g);
                      }
                      this.addPixels(c[this.codingPos] + q, l);
                      for (
                        c[this.codingPos] < f && this.addPixels(c[this.codingPos] + d, l ^ 1);
                        b[r] <= c[this.codingPos] && b[r] < f;

                      )
                        r += 2;
                      break;
                    case 7:
                      this.addPixels(b[r] + 3, l);
                      l ^= 1;
                      if (c[this.codingPos] < f) for (++r; b[r] <= c[this.codingPos] && b[r] < f; ) r += 2;
                      break;
                    case 5:
                      this.addPixels(b[r] + 2, l);
                      l ^= 1;
                      if (c[this.codingPos] < f) for (++r; b[r] <= c[this.codingPos] && b[r] < f; ) r += 2;
                      break;
                    case 3:
                      this.addPixels(b[r] + 1, l);
                      l ^= 1;
                      if (c[this.codingPos] < f) for (++r; b[r] <= c[this.codingPos] && b[r] < f; ) r += 2;
                      break;
                    case 2:
                      this.addPixels(b[r], l);
                      l ^= 1;
                      if (c[this.codingPos] < f) for (++r; b[r] <= c[this.codingPos] && b[r] < f; ) r += 2;
                      break;
                    case 8:
                      this.addPixelsNeg(b[r] - 3, l);
                      l ^= 1;
                      if (c[this.codingPos] < f)
                        for (0 < r ? --r : ++r; b[r] <= c[this.codingPos] && b[r] < f; ) r += 2;
                      break;
                    case 6:
                      this.addPixelsNeg(b[r] - 2, l);
                      l ^= 1;
                      if (c[this.codingPos] < f)
                        for (0 < r ? --r : ++r; b[r] <= c[this.codingPos] && b[r] < f; ) r += 2;
                      break;
                    case 4:
                      this.addPixelsNeg(b[r] - 1, l);
                      l ^= 1;
                      if (c[this.codingPos] < f)
                        for (0 < r ? --r : ++r; b[r] <= c[this.codingPos] && b[r] < f; ) r += 2;
                      break;
                    case -1:
                      this.addPixels(f, 0);
                      this.eof = !0;
                      break;
                    default:
                      (0, a.info)('bad 2d code'), this.addPixels(f, 0), (this.err = !0);
                  }
                }
              } else
                for (l = this.codingPos = c[0] = 0; c[this.codingPos] < f; ) {
                  q = 0;
                  if (l) {
                    do q += g = this.getBlackCode();
                    while (64 <= g);
                  } else {
                    do q += g = this.getWhiteCode();
                    while (64 <= g);
                  }
                  this.addPixels(c[this.codingPos] + q, l);
                  l ^= 1;
                }
              b = !1;
              this.byteAlign && (this.inputBits &= -8);
              if (this.eoblock || this.row !== this.rows - 1) {
                q = this.lookBits(12);
                if (this.eoline) for (; -1 !== q && 1 !== q; ) this.eatBits(1), (q = this.lookBits(12));
                else for (; 0 === q; ) this.eatBits(1), (q = this.lookBits(12));
                1 === q ? (this.eatBits(12), (b = !0)) : -1 === q && (this.eof = !0);
              } else this.rowsDone = !0;
              !this.eof &&
                0 < this.encoding &&
                !this.rowsDone &&
                ((this.nextLine2D = !this.lookBits(1)), this.eatBits(1));
              if (this.eoblock && b && this.byteAlign) {
                if (((q = this.lookBits(12)), 1 === q)) {
                  this.eatBits(12);
                  0 < this.encoding && (this.lookBits(1), this.eatBits(1));
                  if (0 <= this.encoding)
                    for (r = 0; 4 > r; ++r)
                      (q = this.lookBits(12)),
                        1 !== q && (0, a.info)('bad rtc code: ' + q),
                        this.eatBits(12),
                        0 < this.encoding && (this.lookBits(1), this.eatBits(1));
                  this.eof = !0;
                }
              } else if (this.err && this.eoline) {
                for (;;) {
                  q = this.lookBits(13);
                  if (-1 === q) return (this.eof = !0), null;
                  if (1 === q >> 1) break;
                  this.eatBits(1);
                }
                this.eatBits(12);
                0 < this.encoding && (this.eatBits(1), (this.nextLine2D = !(q & 1)));
              }
              this.outputBits = 0 < c[0] ? c[(this.codingPos = 0)] : c[(this.codingPos = 1)];
              this.row++;
            }
            if (8 <= this.outputBits)
              (b = this.codingPos & 1 ? 0 : 255),
                (this.outputBits -= 8),
                0 === this.outputBits &&
                  c[this.codingPos] < f &&
                  (this.codingPos++, (this.outputBits = c[this.codingPos] - c[this.codingPos - 1]));
            else {
              q = 8;
              b = 0;
              do
                this.outputBits > q
                  ? ((b <<= q), this.codingPos & 1 || (b |= 255 >> (8 - q)), (this.outputBits -= q), (q = 0))
                  : ((b <<= this.outputBits),
                    this.codingPos & 1 || (b |= 255 >> (8 - this.outputBits)),
                    (q -= this.outputBits),
                    (this.outputBits = 0),
                    c[this.codingPos] < f
                      ? (this.codingPos++, (this.outputBits = c[this.codingPos] - c[this.codingPos - 1]))
                      : 0 < q && ((b <<= q), (q = 0)));
              while (q);
            }
            this.black && (b ^= 255);
            return b;
          };
          b.prototype.findTableCode = function(a, b, c, f) {
            for (f = f || 0; a <= b; ++a) {
              var w = this.lookBits(a);
              if (-1 === w) return [!0, 1, !1];
              a < b && (w <<= b - a);
              if (!f || w >= f) if (((w = c[w - f]), w[0] === a)) return this.eatBits(a), [!0, w[1], !0];
            }
            return [!1, 0, !1];
          };
          b.prototype.getTwoDimCode = function() {
            if (this.eoblock) {
              var b = this.lookBits(7);
              if ((b = c[b]) && 0 < b[0]) return this.eatBits(b[0]), b[1];
            } else if (((b = this.findTableCode(1, 7, c)), b[0] && b[2])) return b[1];
            (0, a.info)('Bad two dim code');
            return -1;
          };
          b.prototype.getWhiteCode = function() {
            if (this.eoblock) {
              var b = this.lookBits(12);
              if (-1 === b) return 1;
              b = 0 === b >> 5 ? f[b] : r[b >> 3];
              if (0 < b[0]) return this.eatBits(b[0]), b[1];
            } else {
              b = this.findTableCode(1, 9, r);
              if (b[0]) return b[1];
              b = this.findTableCode(11, 12, f);
              if (b[0]) return b[1];
            }
            (0, a.info)('bad white code');
            this.eatBits(1);
            return 1;
          };
          b.prototype.getBlackCode = function() {
            if (this.eoblock) {
              var b = this.lookBits(13);
              if (-1 === b) return 1;
              b = 0 === b >> 7 ? d[b] : 0 === b >> 9 && 0 !== b >> 7 ? g[(b >> 1) - 64] : q[b >> 7];
              if (0 < b[0]) return this.eatBits(b[0]), b[1];
            } else {
              b = this.findTableCode(2, 6, q);
              if (b[0]) return b[1];
              b = this.findTableCode(7, 12, g, 64);
              if (b[0]) return b[1];
              b = this.findTableCode(10, 13, d);
              if (b[0]) return b[1];
            }
            (0, a.info)('bad black code');
            this.eatBits(1);
            return 1;
          };
          b.prototype.lookBits = function(a) {
            for (var b; this.inputBits < a; ) {
              if (-1 === (b = this.str.getByte()))
                return 0 === this.inputBits ? -1 : (this.inputBuf << (a - this.inputBits)) & (65535 >> (16 - a));
              this.inputBuf = (this.inputBuf << 8) | b;
              this.inputBits += 8;
            }
            return (this.inputBuf >> (this.inputBits - a)) & (65535 >> (16 - a));
          };
          b.prototype.eatBits = function(a) {
            0 > (this.inputBits -= a) && (this.inputBits = 0);
          };
          return b;
        })(),
        g = (function() {
          function a(a, b, c) {
            this.str = a;
            this.dict = a.dict;
            this.bitsCached = this.cachedData = 0;
            a = {
              earlyChange: c,
              codeLength: 9,
              nextCode: 258,
              dictionaryValues: new Uint8Array(4096),
              dictionaryLengths: new Uint16Array(4096),
              dictionaryPrevCodes: new Uint16Array(4096),
              currentSequence: new Uint8Array(4096),
              currentSequenceLength: 0,
            };
            for (c = 0; 256 > c; ++c) (a.dictionaryValues[c] = c), (a.dictionaryLengths[c] = 1);
            this.lzwState = a;
            z.call(this, b);
          }
          a.prototype = Object.create(z.prototype);
          a.prototype.readBits = function(a) {
            for (var b = this.bitsCached, c = this.cachedData; b < a; ) {
              var l = this.str.getByte();
              if (-1 === l) return (this.eof = !0), null;
              c = (c << 8) | l;
              b += 8;
            }
            this.bitsCached = b -= a;
            this.cachedData = c;
            this.lastCode = null;
            return (c >>> b) & ((1 << a) - 1);
          };
          a.prototype.readBlock = function() {
            var a = 1024,
              b,
              c,
              l = this.lzwState;
            if (l) {
              var d = l.earlyChange,
                g = l.nextCode,
                w = l.dictionaryValues,
                q = l.dictionaryLengths,
                e = l.dictionaryPrevCodes,
                x = l.codeLength,
                p = l.prevCode,
                h = l.currentSequence,
                n = l.currentSequenceLength,
                A = 0,
                G = this.bufferLength,
                k = this.ensureBuffer(this.bufferLength + a);
              for (b = 0; 512 > b; b++) {
                var B = this.readBits(x),
                  u = 0 < n;
                if (256 > B) (h[0] = B), (n = 1);
                else if (258 <= B)
                  if (B < g) {
                    n = q[B];
                    var z = n - 1;
                    for (c = B; 0 <= z; z--) (h[z] = w[c]), (c = e[c]);
                  } else h[n++] = h[0];
                else if (256 === B) {
                  x = 9;
                  g = 258;
                  n = 0;
                  continue;
                } else {
                  this.eof = !0;
                  delete this.lzwState;
                  break;
                }
                u &&
                  ((e[g] = p),
                  (q[g] = q[p] + 1),
                  (w[g] = h[0]),
                  g++,
                  (x = (g + d) & (g + d - 1) ? x : Math.min(Math.log(g + d) / 0.6931471805599453 + 1, 12) | 0));
                p = B;
                A += n;
                if (a < A) {
                  do a += 512;
                  while (a < A);
                  k = this.ensureBuffer(this.bufferLength + a);
                }
                for (z = 0; z < n; z++) k[G++] = h[z];
              }
              l.nextCode = g;
              l.codeLength = x;
              l.prevCode = p;
              l.currentSequenceLength = n;
              this.bufferLength = G;
            }
          };
          return a;
        })(),
        G = (function() {
          function a() {
            u.call(this, new Uint8Array(0));
          }
          a.prototype = u.prototype;
          return a;
        })();
      m.Ascii85Stream = A;
      m.AsciiHexStream = c;
      m.CCITTFaxStream = x;
      m.DecryptStream = p;
      m.DecodeStream = z;
      m.FlateStream = C;
      m.Jbig2Stream = h;
      m.JpegStream = n;
      m.JpxStream = e;
      m.NullStream = G;
      m.PredictorStream = B;
      m.RunLengthStream = q;
      m.Stream = u;
      m.StreamsSequenceStream = t;
      m.StringStream = y;
      m.LZWStream = g;
    },
    function(y, m, t) {
      y = y.exports =
        'undefined' != typeof window && Math == Math
          ? window
          : 'undefined' != typeof self && self.Math == Math
          ? self
          : Function('return this')();
      'number' == typeof __g && (__g = y);
    },
    function(y, m, t) {
      y.exports = !t(19)(function() {
        return (
          7 !=
          Object.defineProperty({}, 'a', {
            get: function() {
              return 7;
            },
          }).a
        );
      });
    },
    function(y, m, t) {
      var a = t(10),
        k = t(22);
      y.exports = t(5)
        ? function(b, v, d) {
            return a.f(b, v, k(1, d));
          }
        : function(a, k, d) {
            a[k] = d;
            return a;
          };
    },
    function(y, m, t) {
      function a(a, b) {
        if (!(a instanceof b)) throw new TypeError('Cannot call a class as a function');
      }
      function k(a) {
        var b = d['default'].PDFJS;
        switch (a) {
          case 'pdfBug':
            return b ? b.pdfBug : !1;
          case 'disableAutoFetch':
            return b ? b.disableAutoFetch : !1;
          case 'disableStream':
            return b ? b.disableStream : !1;
          case 'disableRange':
            return b ? b.disableRange : !1;
          case 'disableFontFace':
            return b ? b.disableFontFace : !1;
          case 'disableCreateObjectURL':
            return b ? b.disableCreateObjectURL : !1;
          case 'disableWebGL':
            return b ? b.disableWebGL : !0;
          case 'cMapUrl':
            return b ? b.cMapUrl : null;
          case 'cMapPacked':
            return b ? b.cMapPacked : !1;
          case 'postMessageTransfers':
            return b ? b.postMessageTransfers : !0;
          case 'workerPort':
            return b ? b.workerPort : null;
          case 'workerSrc':
            return b ? b.workerSrc : null;
          case 'disableWorker':
            return b ? b.disableWorker : !1;
          case 'maxImageSize':
            return b ? b.maxImageSize : -1;
          case 'imageResourcesPath':
            return b ? b.imageResourcesPath : '';
          case 'isEvalSupported':
            return b ? b.isEvalSupported : !0;
          case 'externalLinkTarget':
            if (!b) return e.NONE;
            switch (b.externalLinkTarget) {
              case e.NONE:
              case e.SELF:
              case e.BLANK:
              case e.PARENT:
              case e.TOP:
                return b.externalLinkTarget;
            }
            (0, v.warn)('PDFJS.externalLinkTarget is invalid: ' + b.externalLinkTarget);
            return (b.externalLinkTarget = e.NONE);
          case 'externalLinkRel':
            return b ? b.externalLinkRel : 'noopener noreferrer nofollow';
          case 'enableStats':
            return !(!b || !b.enableStats);
          case 'pdfjsNext':
            return !(!b || !b.pdfjsNext);
          default:
            throw Error('Unknown default setting: ' + a);
        }
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.SimpleXMLParser = m.DOMSVGFactory = m.DOMCMapReaderFactory = m.DOMCanvasFactory = m.DEFAULT_LINK_REL = m.getDefaultSetting = m.LinkTarget = m.getFilenameFromUrl = m.isValidUrl = m.isExternalLinkTargetSet = m.addLinkAttributes = m.RenderingCancelledException = m.CustomStyle = void 0;
      var b = (function() {
          function a(a, b) {
            for (var c = 0; c < b.length; c++) {
              var d = b[c];
              d.enumerable = d.enumerable || !1;
              d.configurable = !0;
              'value' in d && (d.writable = !0);
              Object.defineProperty(a, d.key, d);
            }
          }
          return function(b, c, d) {
            c && a(b.prototype, c);
            d && a(b, d);
            return b;
          };
        })(),
        v = t(0),
        d = (y = t(11)) && y.__esModule ? y : { default: y };
      y = (function() {
        function d() {
          a(this, d);
        }
        b(d, [
          {
            key: 'create',
            value: function(a, b) {
              if (0 >= a || 0 >= b) throw Error('invalid canvas size');
              var c = document.createElement('canvas'),
                d = c.getContext('2d');
              c.width = a;
              c.height = b;
              return { canvas: c, context: d };
            },
          },
          {
            key: 'reset',
            value: function(a, b, d) {
              if (!a.canvas) throw Error('canvas is not specified');
              if (0 >= b || 0 >= d) throw Error('invalid canvas size');
              a.canvas.width = b;
              a.canvas.height = d;
            },
          },
          {
            key: 'destroy',
            value: function(a) {
              if (!a.canvas) throw Error('canvas is not specified');
              a.canvas.width = 0;
              a.canvas.height = 0;
              a.canvas = null;
              a.context = null;
            },
          },
        ]);
        return d;
      })();
      t = (function() {
        function d(b) {
          var c = b.baseUrl;
          c = void 0 === c ? null : c;
          b = b.isCompressed;
          b = void 0 === b ? !1 : b;
          a(this, d);
          this.baseUrl = c;
          this.isCompressed = b;
        }
        b(d, [
          {
            key: 'fetch',
            value: function(a) {
              var b = this,
                d = a.name;
              return d
                ? new Promise(function(a, c) {
                    var g = b.baseUrl + d + (b.isCompressed ? '.bcmap' : ''),
                      l = new XMLHttpRequest();
                    l.open('GET', g, !0);
                    b.isCompressed && (l.responseType = 'arraybuffer');
                    l.onreadystatechange = function() {
                      if (l.readyState === XMLHttpRequest.DONE) {
                        if (200 === l.status || 0 === l.status) {
                          var d = void 0;
                          b.isCompressed && l.response
                            ? (d = new Uint8Array(l.response))
                            : !b.isCompressed && l.responseText && (d = (0, v.stringToBytes)(l.responseText));
                          if (d) {
                            a({
                              cMapData: d,
                              compressionType: b.isCompressed
                                ? v.CMapCompressionType.BINARY
                                : v.CMapCompressionType.NONE,
                            });
                            return;
                          }
                        }
                        c(Error('Unable to load ' + (b.isCompressed ? 'binary ' : '') + 'CMap at: ' + g));
                      }
                    };
                    l.send(null);
                  })
                : Promise.reject(Error('CMap name must be specified.'));
            },
          },
        ]);
        return d;
      })();
      var u = (function() {
          function d() {
            a(this, d);
          }
          b(d, [
            {
              key: 'create',
              value: function(a, b) {
                (0, v.assert)(0 < a && 0 < b, 'Invalid SVG dimensions');
                var c = document.createElementNS('http://www.w3.org/2000/svg', 'svg:svg');
                c.setAttribute('version', '1.1');
                c.setAttribute('width', a + 'px');
                c.setAttribute('height', b + 'px');
                c.setAttribute('preserveAspectRatio', 'none');
                c.setAttribute('viewBox', '0 0 ' + a + ' ' + b);
                return c;
              },
            },
            {
              key: 'createElement',
              value: function(a) {
                (0, v.assert)('string' === typeof a, 'Invalid SVG element type');
                return document.createElementNS('http://www.w3.org/2000/svg', a);
              },
            },
          ]);
          return d;
        })(),
        z = (function() {
          function d(b, c) {
            a(this, d);
            this.nodeName = b;
            this.nodeValue = c;
            Object.defineProperty(this, 'parentNode', { value: null, writable: !0 });
          }
          b(d, [
            {
              key: 'hasChildNodes',
              value: function() {
                return this.childNodes && 0 < this.childNodes.length;
              },
            },
            {
              key: 'firstChild',
              get: function() {
                return this.childNodes[0];
              },
            },
            {
              key: 'nextSibling',
              get: function() {
                var a = this.parentNode.childNodes.indexOf(this);
                return this.parentNode.childNodes[a + 1];
              },
            },
            {
              key: 'textContent',
              get: function() {
                return this.childNodes
                  ? this.childNodes
                      .map(function(a) {
                        return a.textContent;
                      })
                      .join('')
                  : this.nodeValue || '';
              },
            },
          ]);
          return d;
        })(),
        C = (function() {
          function d() {
            a(this, d);
          }
          b(d, [
            {
              key: 'parseFromString',
              value: function(a) {
                var b = this,
                  d = [];
                a = a.replace(/<\?[\s\S]*?\?>|\x3c!--[\s\S]*?--\x3e/g, '').trim();
                a = a.replace(/<!DOCTYPE[^>\[]+(\[[^\]]+)?[^>]+>/g, '').trim();
                a = a.replace(/>([^<][\s\S]*?)</g, function(a, c) {
                  var l = d.length,
                    f = new z('#text', b._decodeXML(c));
                  d.push(f);
                  return 0 === f.textContent.trim().length ? '><' : '>' + l + ',<';
                });
                a = a.replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, function(a, b) {
                  var c = d.length,
                    f = new z('#text', b);
                  d.push(f);
                  return c + ',';
                });
                var e = /<([\w:]+)((?:[\s\w:=]|'[^']*'|"[^"]*")*)(?:\/>|>([\d,]*)<\/[^>]+>)/g,
                  g = void 0;
                do
                  (g = d.length),
                    (a = a.replace(e, function(a, b, c, f) {
                      a = d.length;
                      var r = new z(b),
                        l = [];
                      f &&
                        ((f = f.split(',')),
                        f.pop(),
                        f.forEach(function(a) {
                          a = d[+a];
                          a.parentNode = r;
                          l.push(a);
                        }));
                      r.childNodes = l;
                      d.push(r);
                      return a + ',';
                    }));
                while (g < d.length);
                return { documentElement: d.pop() };
              },
            },
            {
              key: '_decodeXML',
              value: function(a) {
                return 0 > a.indexOf('&')
                  ? a
                  : a.replace(/&(#(x[0-9a-f]+|\d+)|\w+);/gi, function(a, b, d) {
                      if (d) return (d = 'x' === d[0] ? parseInt(d.substring(1), 16) : +d), String.fromCharCode(d);
                      switch (b) {
                        case 'amp':
                          return '&';
                        case 'lt':
                          return '<';
                        case 'gt':
                          return '>';
                        case 'quot':
                          return '"';
                        case 'apos':
                          return "'";
                      }
                      return '&' + b + ';';
                    });
              },
            },
          ]);
          return d;
        })(),
        B = (function() {
          function a() {}
          var b = ['ms', 'Moz', 'Webkit', 'O'],
            c = Object.create(null);
          a.getProp = function(a, d) {
            if (1 === arguments.length && 'string' === typeof c[a]) return c[a];
            d = d || document.documentElement;
            var g = d.style;
            if ('string' === typeof g[a]) return (c[a] = a);
            var q = a.charAt(0).toUpperCase() + a.slice(1);
            for (var l = 0, e = b.length; l < e; l++) {
              var f = b[l] + q;
              if ('string' === typeof g[f]) return (c[a] = f);
            }
            return (c[a] = 'undefined');
          };
          a.setProp = function(a, b, c) {
            a = this.getProp(a);
            'undefined' !== a && (b.style[a] = c);
          };
          return a;
        })(),
        n = (function() {
          function a(a, b) {
            this.message = a;
            this.type = b;
          }
          a.prototype = Error();
          a.prototype.name = 'RenderingCancelledException';
          return (a.constructor = a);
        })(),
        e = { NONE: 0, SELF: 1, BLANK: 2, PARENT: 3, TOP: 4 },
        h = ['', '_self', '_blank', '_parent', '_top'];
      m.CustomStyle = B;
      m.RenderingCancelledException = n;
      m.addLinkAttributes = function(a, b) {
        var c = b && b.url;
        a.href = a.title = c ? (0, v.removeNullCharacters)(c) : '';
        c &&
          ((c = b.target),
          'undefined' === typeof c && (c = k('externalLinkTarget')),
          (a.target = h[c]),
          (c = b.rel),
          'undefined' === typeof c && (c = k('externalLinkRel')),
          (a.rel = c));
      };
      m.isExternalLinkTargetSet = function() {
        switch (k('externalLinkTarget')) {
          case e.NONE:
            return !1;
          case e.SELF:
          case e.BLANK:
          case e.PARENT:
          case e.TOP:
            return !0;
        }
      };
      m.isValidUrl = function(a, b) {
        (0, v.deprecated)('isValidUrl(), please use createValidAbsoluteUrl() instead.');
        var c = b ? 'http://example.com' : null;
        return null !== (0, v.createValidAbsoluteUrl)(a, c);
      };
      m.getFilenameFromUrl = function(a) {
        var b = a.indexOf('#'),
          c = a.indexOf('?');
        b = Math.min(0 < b ? b : a.length, 0 < c ? c : a.length);
        return a.substring(a.lastIndexOf('/', b) + 1, b);
      };
      m.LinkTarget = e;
      m.getDefaultSetting = k;
      m.DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
      m.DOMCanvasFactory = y;
      m.DOMCMapReaderFactory = t;
      m.DOMSVGFactory = u;
      m.SimpleXMLParser = C;
    },
    function(y, m, t) {
      var a = {}.hasOwnProperty;
      y.exports = function(k, b) {
        return a.call(k, b);
      };
    },
    function(y, m, t) {
      var a = t(14),
        k = Math.min;
      y.exports = function(b) {
        return 0 < b ? k(a(b), 9007199254740991) : 0;
      };
    },
    function(y, m, t) {
      var a = t(21),
        k = t(38),
        b = t(28),
        v = Object.defineProperty;
      m.f = t(5)
        ? Object.defineProperty
        : function(d, u, z) {
            a(d);
            u = b(u, !0);
            a(z);
            if (k)
              try {
                return v(d, u, z);
              } catch (C) {}
            if ('get' in z || 'set' in z) throw TypeError('Accessors not supported!');
            'value' in z && (d[u] = z.value);
            return d;
          };
    },
    function(y, m, t) {
      y.exports =
        'undefined' !== typeof window && Math === Math
          ? window
          : 'undefined' !== typeof global && global.Math === Math
          ? global
          : 'undefined' !== typeof self && self.Math === Math
          ? self
          : {};
    },
    function(y, m, t) {
      var a =
        'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
          ? function(a) {
              return typeof a;
            }
          : function(a) {
              return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                ? 'symbol'
                : typeof a;
            };
      y.exports = function(k) {
        return 'object' === ('undefined' === typeof k ? 'undefined' : a(k)) ? null !== k : 'function' === typeof k;
      };
    },
    function(y, m, t) {
      var a = 0,
        k = Math.random();
      y.exports = function(b) {
        return 'Symbol('.concat(void 0 === b ? '' : b, ')_', (++a + k).toString(36));
      };
    },
    function(y, m, t) {
      var a = Math.ceil,
        k = Math.floor;
      y.exports = function(b) {
        return isNaN((b = +b)) ? 0 : (0 < b ? k : a)(b);
      };
    },
    function(y, m, t) {
      var a = t(48);
      y.exports = function(k) {
        return Object(a(k));
      };
    },
    function(y, m, t) {
      y.exports = {};
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.ColorSpace = void 0;
      var a = t(0),
        k = t(1),
        b = t(26),
        v = (function() {
          function A() {
            throw Error('should not call ColorSpace constructor');
          }
          A.prototype = {
            getRgb: function(a, b) {
              var c = new Uint8Array(3);
              this.getRgbItem(a, b, c, 0);
              return c;
            },
            getRgbItem: function(a, b, d, g) {
              throw Error('Should not call ColorSpace.getRgbItem');
            },
            getRgbBuffer: function(a, b, d, g, e, l, h) {
              throw Error('Should not call ColorSpace.getRgbBuffer');
            },
            getOutputLength: function(a, b) {
              throw Error('Should not call ColorSpace.getOutputLength');
            },
            isPassthrough: function(a) {
              return !1;
            },
            fillRgb: function(a, b, d, g, e, l, h, f, r) {
              var c = b * d,
                q = null,
                x = 1 << h,
                w = d !== e || b !== g,
                E;
              if (this.isPassthrough(h)) q = f;
              else if (1 === this.numComps && c > x && 'DeviceGray' !== this.name && 'DeviceRGB' !== this.name) {
                var F = 8 >= h ? new Uint8Array(x) : new Uint16Array(x);
                for (E = 0; E < x; E++) F[E] = E;
                var p = new Uint8Array(3 * x);
                this.getRgbBuffer(F, 0, x, p, 0, h, 0);
                if (w)
                  for (q = new Uint8Array(3 * c), E = x = 0; E < c; ++E)
                    (F = 3 * f[E]), (q[x++] = p[F]), (q[x++] = p[F + 1]), (q[x++] = p[F + 2]);
                else
                  for (E = h = 0; E < c; ++E)
                    (F = 3 * f[E]), (a[h++] = p[F]), (a[h++] = p[F + 1]), (a[h++] = p[F + 2]), (h += r);
              } else
                w
                  ? ((q = new Uint8Array(3 * c)), this.getRgbBuffer(f, 0, c, q, 0, h, 0))
                  : this.getRgbBuffer(f, 0, g * l, a, 0, h, r);
              if (q)
                if (w) {
                  r = 1 !== r ? 0 : r;
                  c = b / g;
                  d /= e;
                  E = 0;
                  l = new Uint16Array(g);
                  f = 3 * b;
                  for (b = 0; b < g; b++) l[b] = 3 * Math.floor(b * c);
                  for (b = 0; b < e; b++)
                    for (w = Math.floor(b * d) * f, c = 0; c < g; c++)
                      (p = w + l[c]), (a[E++] = q[p++]), (a[E++] = q[p++]), (a[E++] = q[p++]), (E += r);
                } else
                  for (E = h = x = 0, g *= l; E < g; E++)
                    (a[h++] = q[x++]), (a[h++] = q[x++]), (a[h++] = q[x++]), (h += r);
            },
            usesZeroToOneRange: !0,
          };
          A.parse = function(a, b, d) {
            a = A.parseToIR(a, b, d);
            return A.fromIR(a);
          };
          A.fromIR = function(c) {
            var q = Array.isArray(c) ? c[0] : c;
            switch (q) {
              case 'DeviceGrayCS':
                return this.singletons.gray;
              case 'DeviceRgbCS':
                return this.singletons.rgb;
              case 'DeviceCmykCS':
                return this.singletons.cmyk;
              case 'CalGrayCS':
                q = c[1];
                var x = c[2];
                var g = c[3];
                return new e(q, x, g);
              case 'CalRGBCS':
                return (q = c[1]), (x = c[2]), (g = c[3]), new h(q, x, g, c[4]);
              case 'PatternCS':
                return (c = c[1]) && (c = A.fromIR(c)), new u(c);
              case 'IndexedCS':
                return (q = c[2]), (x = c[3]), new z(A.fromIR(c[1]), q, x);
              case 'AlternateCS':
                return (q = c[3]), new d(c[1], A.fromIR(c[2]), b.PDFFunction.fromIR(q));
              case 'LabCS':
                return (q = c[1]), (x = c[2]), new p(q, x, c[3]);
              default:
                throw new a.FormatError('Unknown colorspace name: ' + q);
            }
          };
          A.parseToIR = function(c, d, e) {
            if ((0, k.isName)(c)) {
              var g = e.get('ColorSpace');
              (0, k.isDict)(g) && (g = g.get(c.name)) && (c = g);
            }
            c = d.fetchIfRef(c);
            if ((0, k.isName)(c))
              switch (c.name) {
                case 'DeviceGray':
                case 'G':
                  return 'DeviceGrayCS';
                case 'DeviceRGB':
                case 'RGB':
                  return 'DeviceRgbCS';
                case 'DeviceCMYK':
                case 'CMYK':
                  return 'DeviceCmykCS';
                case 'Pattern':
                  return ['PatternCS', null];
                default:
                  throw new a.FormatError('unrecognized colorspace ' + c.name);
              }
            if (Array.isArray(c))
              switch (((g = d.fetchIfRef(c[0]).name), g)) {
                case 'DeviceGray':
                case 'G':
                  return 'DeviceGrayCS';
                case 'DeviceRGB':
                case 'RGB':
                  return 'DeviceRgbCS';
                case 'DeviceCMYK':
                case 'CMYK':
                  return 'DeviceCmykCS';
                case 'CalGray':
                  return (
                    (g = d.fetchIfRef(c[1])),
                    (c = g.getArray('WhitePoint')),
                    (d = g.getArray('BlackPoint')),
                    (e = g.get('Gamma')),
                    ['CalGrayCS', c, d, e]
                  );
                case 'CalRGB':
                  return (
                    (g = d.fetchIfRef(c[1])),
                    (c = g.getArray('WhitePoint')),
                    (d = g.getArray('BlackPoint')),
                    (e = g.getArray('Gamma')),
                    (g = g.getArray('Matrix')),
                    ['CalRGBCS', c, d, e, g]
                  );
                case 'ICCBased':
                  var q = d.fetchIfRef(c[1]).dict;
                  g = q.get('N');
                  if ((q = q.get('Alternate'))) {
                    d = A.parseToIR(q, d, e);
                    if (A.fromIR(d).numComps === g) return d;
                    (0, a.warn)('ICCBased color space: Ignoring incorrect /Alternate entry.');
                  }
                  if (1 === g) return 'DeviceGrayCS';
                  if (3 === g) return 'DeviceRgbCS';
                  if (4 === g) return 'DeviceCmykCS';
                  break;
                case 'Pattern':
                  return (c = c[1] || null) && (c = A.parseToIR(c, d, e)), ['PatternCS', c];
                case 'Indexed':
                case 'I':
                  return (
                    (e = A.parseToIR(c[1], d, e)),
                    (g = d.fetchIfRef(c[2]) + 1),
                    (c = d.fetchIfRef(c[3])),
                    (0, k.isStream)(c) && (c = c.getBytes()),
                    ['IndexedCS', e, g, c]
                  );
                case 'Separation':
                case 'DeviceN':
                  return (
                    (g = d.fetchIfRef(c[1])),
                    (g = Array.isArray(g) ? g.length : 1),
                    (q = A.parseToIR(c[2], d, e)),
                    (c = b.PDFFunction.getIR(d, d.fetchIfRef(c[3]))),
                    ['AlternateCS', g, q, c]
                  );
                case 'Lab':
                  return (
                    (g = d.fetchIfRef(c[1])),
                    (c = g.getArray('WhitePoint')),
                    (d = g.getArray('BlackPoint')),
                    (e = g.getArray('Range')),
                    ['LabCS', c, d, e]
                  );
                default:
                  throw new a.FormatError('unimplemented color space object "' + g + '"');
              }
            throw new a.FormatError('unrecognized color space object: "' + c + '"');
          };
          A.isDefaultDecode = function(b, d) {
            if (!Array.isArray(b)) return !0;
            if (2 * d !== b.length) return (0, a.warn)('The decode map is not the correct length'), !0;
            for (var c = 0, g = b.length; c < g; c += 2) if (0 !== b[c] || 1 !== b[c + 1]) return !1;
            return !0;
          };
          A.singletons = {
            get gray() {
              return (0, a.shadow)(this, 'gray', new C());
            },
            get rgb() {
              return (0, a.shadow)(this, 'rgb', new B());
            },
            get cmyk() {
              return (0, a.shadow)(this, 'cmyk', new n());
            },
          };
          return A;
        })(),
        d = (function() {
          function a(a, b, d) {
            this.name = 'Alternate';
            this.numComps = a;
            this.defaultColor = new Float32Array(a);
            for (var c = 0; c < a; ++c) this.defaultColor[c] = 1;
            this.base = b;
            this.tintFn = d;
            this.tmpBuf = new Float32Array(b.numComps);
          }
          a.prototype = {
            getRgb: v.prototype.getRgb,
            getRgbItem: function(a, b, d, g) {
              var c = this.tmpBuf;
              this.tintFn(a, b, c, 0);
              this.base.getRgbItem(c, 0, d, g);
            },
            getRgbBuffer: function(a, b, d, g, e, l, h) {
              var c = this.tintFn,
                r = this.base;
              l = 1 / ((1 << l) - 1);
              var q = r.numComps,
                x = r.usesZeroToOneRange,
                p = (r.isPassthrough(8) || !x) && 0 === h,
                w = p ? e : 0,
                E = p ? g : new Uint8Array(q * d),
                F = this.numComps,
                n = new Float32Array(F),
                H = new Float32Array(q),
                M,
                A;
              for (M = 0; M < d; M++) {
                for (A = 0; A < F; A++) n[A] = a[b++] * l;
                c(n, 0, H, 0);
                if (x) for (A = 0; A < q; A++) E[w++] = 255 * H[A];
                else r.getRgbItem(H, 0, E, w), (w += q);
              }
              p || r.getRgbBuffer(E, 0, d, g, e, 8, h);
            },
            getOutputLength: function(a, b) {
              return this.base.getOutputLength((a * this.base.numComps) / this.numComps, b);
            },
            isPassthrough: v.prototype.isPassthrough,
            fillRgb: v.prototype.fillRgb,
            isDefaultDecode: function(a) {
              return v.isDefaultDecode(a, this.numComps);
            },
            usesZeroToOneRange: !0,
          };
          return a;
        })(),
        u = (function() {
          function a(a) {
            this.name = 'Pattern';
            this.base = a;
          }
          a.prototype = {};
          return a;
        })(),
        z = (function() {
          function b(b, d, e) {
            this.name = 'Indexed';
            this.numComps = 1;
            this.defaultColor = new Uint8Array(this.numComps);
            this.base = b;
            this.highVal = d;
            b = b.numComps * d;
            if ((0, k.isStream)(e)) (this.lookup = new Uint8Array(b)), (e = e.getBytes(b)), this.lookup.set(e);
            else if ((0, a.isString)(e))
              for (this.lookup = new Uint8Array(b), d = 0; d < b; ++d) this.lookup[d] = e.charCodeAt(d);
            else if (e instanceof Uint8Array || e instanceof Array) this.lookup = e;
            else throw new a.FormatError('Unrecognized lookup table: ' + e);
          }
          b.prototype = {
            getRgb: v.prototype.getRgb,
            getRgbItem: function(a, b, d, g) {
              this.base.getRgbBuffer(this.lookup, a[b] * this.base.numComps, 1, d, g, 8, 0);
            },
            getRgbBuffer: function(a, b, d, g, e, l, h) {
              l = this.base;
              for (var c = l.numComps, r = l.getOutputLength(c, h), q = this.lookup, x = 0; x < d; ++x) {
                var p = a[b++] * c;
                l.getRgbBuffer(q, p, 1, g, e, 8, h);
                e += r;
              }
            },
            getOutputLength: function(a, b) {
              return this.base.getOutputLength(a * this.base.numComps, b);
            },
            isPassthrough: v.prototype.isPassthrough,
            fillRgb: v.prototype.fillRgb,
            isDefaultDecode: function(a) {
              return !0;
            },
            usesZeroToOneRange: !0,
          };
          return b;
        })(),
        C = (function() {
          function a() {
            this.name = 'DeviceGray';
            this.numComps = 1;
            this.defaultColor = new Float32Array(this.numComps);
          }
          a.prototype = {
            getRgb: v.prototype.getRgb,
            getRgbItem: function(a, b, d, g) {
              a = (255 * a[b]) | 0;
              d[g] = d[g + 1] = d[g + 2] = 0 > a ? 0 : 255 < a ? 255 : a;
            },
            getRgbBuffer: function(a, b, d, g, e, l, h) {
              l = 255 / ((1 << l) - 1);
              for (var c = 0; c < d; ++c) {
                var r = (l * a[b++]) | 0;
                g[e++] = r;
                g[e++] = r;
                g[e++] = r;
                e += h;
              }
            },
            getOutputLength: function(a, b) {
              return a * (3 + b);
            },
            isPassthrough: v.prototype.isPassthrough,
            fillRgb: v.prototype.fillRgb,
            isDefaultDecode: function(a) {
              return v.isDefaultDecode(a, this.numComps);
            },
            usesZeroToOneRange: !0,
          };
          return a;
        })(),
        B = (function() {
          function a() {
            this.name = 'DeviceRGB';
            this.numComps = 3;
            this.defaultColor = new Float32Array(this.numComps);
          }
          a.prototype = {
            getRgb: v.prototype.getRgb,
            getRgbItem: function(a, b, d, g) {
              var c = (255 * a[b]) | 0,
                l = (255 * a[b + 1]) | 0;
              a = (255 * a[b + 2]) | 0;
              d[g] = 0 > c ? 0 : 255 < c ? 255 : c;
              d[g + 1] = 0 > l ? 0 : 255 < l ? 255 : l;
              d[g + 2] = 0 > a ? 0 : 255 < a ? 255 : a;
            },
            getRgbBuffer: function(a, b, d, g, e, l, h) {
              if (8 === l && 0 === h) g.set(a.subarray(b, b + 3 * d), e);
              else {
                l = 255 / ((1 << l) - 1);
                for (var c = 0; c < d; ++c)
                  (g[e++] = (l * a[b++]) | 0), (g[e++] = (l * a[b++]) | 0), (g[e++] = (l * a[b++]) | 0), (e += h);
              }
            },
            getOutputLength: function(a, b) {
              return ((a * (3 + b)) / 3) | 0;
            },
            isPassthrough: function(a) {
              return 8 === a;
            },
            fillRgb: v.prototype.fillRgb,
            isDefaultDecode: function(a) {
              return v.isDefaultDecode(a, this.numComps);
            },
            usesZeroToOneRange: !0,
          };
          return a;
        })(),
        n = (function() {
          function a(a, b, c, d, l) {
            var g = a[b + 0] * c,
              f = a[b + 1] * c,
              r = a[b + 2] * c;
            c *= a[b + 3];
            a =
              (g *
                (-4.387332384609988 * g +
                  54.48615194189176 * f +
                  18.82290502165302 * r +
                  212.25662451639585 * c +
                  -285.2331026137004) +
                f * (1.7149763477362134 * f - 5.6096736904047315 * r + -17.873870861415444 * c - 5.497006427196366) +
                r * (-2.5217340131683033 * r - 21.248923337353073 * c + 17.5119270841813) +
                c * (-21.86122147463605 * c - 189.48180835922747) +
                255) |
              0;
            b =
              (g *
                (8.841041422036149 * g +
                  60.118027045597366 * f +
                  6.871425592049007 * r +
                  31.159100130055922 * c +
                  -79.2970844816548) +
                f * (-15.310361306967817 * f + 17.575251261109482 * r + 131.35250912493976 * c - 190.9453302588951) +
                r * (4.444339102852739 * r + 9.8632861493405 * c - 24.86741582555878) +
                c * (-20.737325471181034 * c - 187.80453709719578) +
                255) |
              0;
            g =
              (g *
                (0.8842522430003296 * g +
                  8.078677503112928 * f +
                  30.89978309703729 * r -
                  0.23883238689178934 * c +
                  -14.183576799673286) +
                f * (10.49593273432072 * f + 63.02378494754052 * r + 50.606957656360734 * c - 112.23884253719248) +
                r * (0.03296041114873217 * r + 115.60384449646641 * c + -193.58209356861505) +
                c * (-22.33816807309886 * c - 180.12613974708367) +
                255) |
              0;
            d[l] = 255 < a ? 255 : 0 > a ? 0 : a;
            d[l + 1] = 255 < b ? 255 : 0 > b ? 0 : b;
            d[l + 2] = 255 < g ? 255 : 0 > g ? 0 : g;
          }
          function b() {
            this.name = 'DeviceCMYK';
            this.numComps = 4;
            this.defaultColor = new Float32Array(this.numComps);
            this.defaultColor[3] = 1;
          }
          b.prototype = {
            getRgb: v.prototype.getRgb,
            getRgbItem: function(b, c, d, e) {
              a(b, c, 1, d, e);
            },
            getRgbBuffer: function(b, c, d, e, l, h, f) {
              h = 1 / ((1 << h) - 1);
              for (var r = 0; r < d; r++) a(b, c, h, e, l), (c += 4), (l += 3 + f);
            },
            getOutputLength: function(a, b) {
              return ((a / 4) * (3 + b)) | 0;
            },
            isPassthrough: v.prototype.isPassthrough,
            fillRgb: v.prototype.fillRgb,
            isDefaultDecode: function(a) {
              return v.isDefaultDecode(a, this.numComps);
            },
            usesZeroToOneRange: !0,
          };
          return b;
        })(),
        e = (function() {
          function b(b, c, d) {
            this.name = 'CalGray';
            this.numComps = 1;
            this.defaultColor = new Float32Array(this.numComps);
            if (!b) throw new a.FormatError('WhitePoint missing - required for color space CalGray');
            c = c || [0, 0, 0];
            this.XW = b[0];
            this.YW = b[1];
            this.ZW = b[2];
            this.XB = c[0];
            this.YB = c[1];
            this.ZB = c[2];
            this.G = d || 1;
            if (0 > this.XW || 0 > this.ZW || 1 !== this.YW)
              throw new a.FormatError('Invalid WhitePoint components for ' + this.name + ', no fallback available');
            if (0 > this.XB || 0 > this.YB || 0 > this.ZB)
              (0, a.info)('Invalid BlackPoint for ' + this.name + ', falling back to default'),
                (this.XB = this.YB = this.ZB = 0);
            (0 === this.XB && 0 === this.YB && 0 === this.ZB) ||
              (0, a.warn)(
                this.name +
                  ', BlackPoint: XB: ' +
                  this.XB +
                  ', YB: ' +
                  this.YB +
                  ', ZB: ' +
                  this.ZB +
                  ', only default values are supported.',
              );
            1 > this.G &&
              ((0, a.info)('Invalid Gamma: ' + this.G + ' for ' + this.name + ', falling back to default'),
              (this.G = 1));
          }
          function c(a, b, c, d, l, e) {
            a = Math.max(295.8 * Math.pow(a.YW * Math.pow(b[c] * e, a.G), 0.3333333333333333) - 40.8, 0) | 0;
            d[l] = a;
            d[l + 1] = a;
            d[l + 2] = a;
          }
          b.prototype = {
            getRgb: v.prototype.getRgb,
            getRgbItem: function(a, b, d, e) {
              c(this, a, b, d, e, 1);
            },
            getRgbBuffer: function(a, b, d, e, l, h, f) {
              h = 1 / ((1 << h) - 1);
              for (var r = 0; r < d; ++r) c(this, a, b, e, l, h), (b += 1), (l += 3 + f);
            },
            getOutputLength: function(a, b) {
              return a * (3 + b);
            },
            isPassthrough: v.prototype.isPassthrough,
            fillRgb: v.prototype.fillRgb,
            isDefaultDecode: function(a) {
              return v.isDefaultDecode(a, this.numComps);
            },
            usesZeroToOneRange: !0,
          };
          return b;
        })(),
        h = (function() {
          function b(b, c, d, f) {
            this.name = 'CalRGB';
            this.numComps = 3;
            this.defaultColor = new Float32Array(this.numComps);
            if (!b) throw new a.FormatError('WhitePoint missing - required for color space CalRGB');
            c = c || new Float32Array(3);
            d = d || new Float32Array([1, 1, 1]);
            f = f || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);
            var r = b[0],
              l = b[1],
              w = b[2];
            this.whitePoint = b;
            b = c[0];
            var g = c[1],
              e = c[2];
            this.blackPoint = c;
            this.GR = d[0];
            this.GG = d[1];
            this.GB = d[2];
            this.MXA = f[0];
            this.MYA = f[1];
            this.MZA = f[2];
            this.MXB = f[3];
            this.MYB = f[4];
            this.MZB = f[5];
            this.MXC = f[6];
            this.MYC = f[7];
            this.MZC = f[8];
            if (0 > r || 0 > w || 1 !== l)
              throw new a.FormatError('Invalid WhitePoint components for ' + this.name + ', no fallback available');
            if (0 > b || 0 > g || 0 > e)
              (0, a.info)(
                'Invalid BlackPoint for ' + this.name + ' [' + b + ', ' + g + ', ' + e + '], falling back to default',
              ),
                (this.blackPoint = new Float32Array(3));
            if (0 > this.GR || 0 > this.GG || 0 > this.GB)
              (0, a.info)(
                'Invalid Gamma [' +
                  this.GR +
                  ', ' +
                  this.GG +
                  ', ' +
                  this.GB +
                  '] for ' +
                  this.name +
                  ', falling back to default',
              ),
                (this.GR = this.GG = this.GB = 1);
            if (
              0 > this.MXA ||
              0 > this.MYA ||
              0 > this.MZA ||
              0 > this.MXB ||
              0 > this.MYB ||
              0 > this.MZB ||
              0 > this.MXC ||
              0 > this.MYC ||
              0 > this.MZC
            )
              (0, a.info)(
                'Invalid Matrix for ' +
                  this.name +
                  ' [' +
                  this.MXA +
                  ', ' +
                  this.MYA +
                  ', ' +
                  this.MZA +
                  this.MXB +
                  ', ' +
                  this.MYB +
                  ', ' +
                  this.MZB +
                  this.MXC +
                  ', ' +
                  this.MYC +
                  ', ' +
                  this.MZC +
                  '], falling back to default',
              ),
                (this.MXA = this.MYB = this.MZC = 1),
                (this.MXB = this.MYA = this.MZA = this.MXC = this.MYC = this.MZB = 0);
          }
          function c(a, b, c) {
            c[0] = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
            c[1] = a[3] * b[0] + a[4] * b[1] + a[5] * b[2];
            c[2] = a[6] * b[0] + a[7] * b[1] + a[8] * b[2];
          }
          function d(a) {
            return 0.0031308 >= a
              ? Math.max(0, Math.min(1, 12.92 * a))
              : Math.max(0, Math.min(1, 1.055 * Math.pow(a, 1 / 2.4) - 0.055));
          }
          function e(a) {
            return 0 > a ? -e(-a) : 8 < a ? Math.pow((a + 16) / 116, 3) : a * I;
          }
          function g(a, b, g, q, x, M) {
            var w = Math.pow(Math.max(0, Math.min(1, b[g] * M)), a.GR),
              E = Math.pow(Math.max(0, Math.min(1, b[g + 1] * M)), a.GG);
            g = Math.pow(Math.max(0, Math.min(1, b[g + 2] * M)), a.GB);
            M = a.MYA * w + a.MYB * E + a.MYC * g;
            var F = a.MZA * w + a.MZB * E + a.MZC * g;
            b = D;
            b[0] = a.MXA * w + a.MXB * E + a.MXC * g;
            b[1] = M;
            b[2] = F;
            w = n;
            E = a.whitePoint;
            1 === E[0] && 1 === E[2]
              ? ((w[0] = b[0]), (w[1] = b[1]), (w[2] = b[2]))
              : (c(h, b, w),
                (b = r),
                (b[0] = (1 * w[0]) / E[0]),
                (b[1] = (1 * w[1]) / E[1]),
                (b[2] = (1 * w[2]) / E[2]),
                c(l, b, w));
            E = D;
            g = a.blackPoint;
            0 === g[0] && 0 === g[1] && 0 === g[2]
              ? ((E[0] = w[0]), (E[1] = w[1]), (E[2] = w[2]))
              : ((a = e(0)),
                (M = e(g[0])),
                (b = e(g[1])),
                (g = e(g[2])),
                (M = (1 - a) / (1 - M)),
                (b = (1 - a) / (1 - b)),
                (a = (1 - a) / (1 - g)),
                (E[0] = w[0] * M + (1 - M)),
                (E[1] = w[1] * b + (1 - b)),
                (E[2] = w[2] * a + (1 - a)));
            a = n;
            w = f;
            c(h, E, a);
            E = r;
            E[0] = (0.95047 * a[0]) / w[0];
            E[1] = (1 * a[1]) / w[1];
            E[2] = (1.08883 * a[2]) / w[2];
            c(l, E, a);
            w = D;
            c(p, a, w);
            a = d(w[0]);
            E = d(w[1]);
            w = d(w[2]);
            q[x] = Math.round(255 * a);
            q[x + 1] = Math.round(255 * E);
            q[x + 2] = Math.round(255 * w);
          }
          var h = new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296]),
            l = new Float32Array([
              0.9869929,
              -0.1470543,
              0.1599627,
              0.4323053,
              0.5183603,
              0.0492912,
              -0.0085287,
              0.0400428,
              0.9684867,
            ]),
            p = new Float32Array([
              3.2404542,
              -1.5371385,
              -0.4985314,
              -0.969266,
              1.8760108,
              0.041556,
              0.0556434,
              -0.2040259,
              1.0572252,
            ]),
            f = new Float32Array([1, 1, 1]),
            r = new Float32Array(3),
            D = new Float32Array(3),
            n = new Float32Array(3),
            I = Math.pow(24 / 116, 3) / 8;
          b.prototype = {
            getRgb: v.prototype.getRgb,
            getRgbItem: function(a, b, c, d) {
              g(this, a, b, c, d, 1);
            },
            getRgbBuffer: function(a, b, c, d, f, r, l) {
              r = 1 / ((1 << r) - 1);
              for (var w = 0; w < c; ++w) g(this, a, b, d, f, r), (b += 3), (f += 3 + l);
            },
            getOutputLength: function(a, b) {
              return ((a * (3 + b)) / 3) | 0;
            },
            isPassthrough: v.prototype.isPassthrough,
            fillRgb: v.prototype.fillRgb,
            isDefaultDecode: function(a) {
              return v.isDefaultDecode(a, this.numComps);
            },
            usesZeroToOneRange: !0,
          };
          return b;
        })(),
        p = (function() {
          function b(b, c, d) {
            this.name = 'Lab';
            this.numComps = 3;
            this.defaultColor = new Float32Array(this.numComps);
            if (!b) throw new a.FormatError('WhitePoint missing - required for color space Lab');
            c = c || [0, 0, 0];
            d = d || [-100, 100, -100, 100];
            this.XW = b[0];
            this.YW = b[1];
            this.ZW = b[2];
            this.amin = d[0];
            this.amax = d[1];
            this.bmin = d[2];
            this.bmax = d[3];
            this.XB = c[0];
            this.YB = c[1];
            this.ZB = c[2];
            if (0 > this.XW || 0 > this.ZW || 1 !== this.YW)
              throw new a.FormatError('Invalid WhitePoint components, no fallback available');
            if (0 > this.XB || 0 > this.YB || 0 > this.ZB)
              (0, a.info)('Invalid BlackPoint, falling back to default'), (this.XB = this.YB = this.ZB = 0);
            if (this.amin > this.amax || this.bmin > this.bmax)
              (0, a.info)('Invalid Range, falling back to defaults'),
                (this.amin = -100),
                (this.amax = 100),
                (this.bmin = -100),
                (this.bmax = 100);
          }
          function c(a) {
            return a >= 6 / 29 ? a * a * a : (108 / 841) * (a - 4 / 29);
          }
          function d(a, b, d, l, e, f) {
            var r = b[d],
              g = b[d + 1];
            b = b[d + 2];
            !1 !== l &&
              ((r = (100 * r) / l),
              (d = a.amin),
              (g = d + (g * (a.amax - d)) / l),
              (d = a.bmin),
              (b = d + (b * (a.bmax - d)) / l));
            g = g > a.amax ? a.amax : g < a.amin ? a.amin : g;
            b = b > a.bmax ? a.bmax : b < a.bmin ? a.bmin : b;
            l = (r + 16) / 116;
            r = l - b / 200;
            g = a.XW * c(l + g / 500);
            l = a.YW * c(l);
            r = a.ZW * c(r);
            1 > a.ZW
              ? ((a = 3.1339 * g + -1.617 * l + -0.4906 * r),
                (b = -0.9785 * g + 1.916 * l + 0.0333 * r),
                (g = 0.072 * g + -0.229 * l + 1.4057 * r))
              : ((a = 3.2406 * g + -1.5372 * l + -0.4986 * r),
                (b = -0.9689 * g + 1.8758 * l + 0.0415 * r),
                (g = 0.0557 * g + -0.204 * l + 1.057 * r));
            e[f] = 0 >= a ? 0 : 1 <= a ? 255 : (255 * Math.sqrt(a)) | 0;
            e[f + 1] = 0 >= b ? 0 : 1 <= b ? 255 : (255 * Math.sqrt(b)) | 0;
            e[f + 2] = 0 >= g ? 0 : 1 <= g ? 255 : (255 * Math.sqrt(g)) | 0;
          }
          b.prototype = {
            getRgb: v.prototype.getRgb,
            getRgbItem: function(a, b, c, l) {
              d(this, a, b, !1, c, l);
            },
            getRgbBuffer: function(a, b, c, l, e, f, r) {
              f = (1 << f) - 1;
              for (var g = 0; g < c; g++) d(this, a, b, f, l, e), (b += 3), (e += 3 + r);
            },
            getOutputLength: function(a, b) {
              return ((a * (3 + b)) / 3) | 0;
            },
            isPassthrough: v.prototype.isPassthrough,
            fillRgb: v.prototype.fillRgb,
            isDefaultDecode: function(a) {
              return !0;
            },
            usesZeroToOneRange: !1,
          };
          return b;
        })();
      m.ColorSpace = v;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      var a = '                                space exclamsmall Hungarumlautsmall  dollaroldstyle dollarsuperior ampersandsmall Acutesmall parenleftsuperior parenrightsuperior twodotenleader onedotenleader comma hyphen period fraction zerooldstyle oneoldstyle twooldstyle threeoldstyle fouroldstyle fiveoldstyle sixoldstyle sevenoldstyle eightoldstyle nineoldstyle colon semicolon commasuperior threequartersemdash periodsuperior questionsmall  asuperior bsuperior centsuperior dsuperior esuperior    isuperior   lsuperior msuperior nsuperior osuperior   rsuperior ssuperior tsuperior  ff fi fl ffi ffl parenleftinferior  parenrightinferior Circumflexsmall hyphensuperior Gravesmall Asmall Bsmall Csmall Dsmall Esmall Fsmall Gsmall Hsmall Ismall Jsmall Ksmall Lsmall Msmall Nsmall Osmall Psmall Qsmall Rsmall Ssmall Tsmall Usmall Vsmall Wsmall Xsmall Ysmall Zsmall colonmonetary onefitted rupiah Tildesmall                                   exclamdownsmall centoldstyle Lslashsmall   Scaronsmall Zcaronsmall Dieresissmall Brevesmall Caronsmall  Dotaccentsmall   Macronsmall   figuredash hypheninferior   Ogoneksmall Ringsmall Cedillasmall    onequarter onehalf threequarters questiondownsmall oneeighth threeeighths fiveeighths seveneighths onethird twothirds   zerosuperior onesuperior twosuperior threesuperior foursuperior fivesuperior sixsuperior sevensuperior eightsuperior ninesuperior zeroinferior oneinferior twoinferior threeinferior fourinferior fiveinferior sixinferior seveninferior eightinferior nineinferior centinferior dollarinferior periodinferior commainferior Agravesmall Aacutesmall Acircumflexsmall Atildesmall Adieresissmall Aringsmall AEsmall Ccedillasmall Egravesmall Eacutesmall Ecircumflexsmall Edieresissmall Igravesmall Iacutesmall Icircumflexsmall Idieresissmall Ethsmall Ntildesmall Ogravesmall Oacutesmall Ocircumflexsmall Otildesmall Odieresissmall OEsmall Oslashsmall Ugravesmall Uacutesmall Ucircumflexsmall Udieresissmall Yacutesmall Thornsmall Ydieresissmall'.split(
          ' ',
        ),
        k = '                                space exclamsmall Hungarumlautsmall centoldstyle dollaroldstyle dollarsuperior ampersandsmall Acutesmall parenleftsuperior parenrightsuperior twodotenleader onedotenleader comma hyphen period fraction zerooldstyle oneoldstyle twooldstyle threeoldstyle fouroldstyle fiveoldstyle sixoldstyle sevenoldstyle eightoldstyle nineoldstyle colon semicolon  threequartersemdash  questionsmall     Ethsmall   onequarter onehalf threequarters oneeighth threeeighths fiveeighths seveneighths onethird twothirds       ff fi fl ffi ffl parenleftinferior  parenrightinferior Circumflexsmall hypheninferior Gravesmall Asmall Bsmall Csmall Dsmall Esmall Fsmall Gsmall Hsmall Ismall Jsmall Ksmall Lsmall Msmall Nsmall Osmall Psmall Qsmall Rsmall Ssmall Tsmall Usmall Vsmall Wsmall Xsmall Ysmall Zsmall colonmonetary onefitted rupiah Tildesmall   asuperior centsuperior     Aacutesmall Agravesmall Acircumflexsmall Adieresissmall Atildesmall Aringsmall Ccedillasmall Eacutesmall Egravesmall Ecircumflexsmall Edieresissmall Iacutesmall Igravesmall Icircumflexsmall Idieresissmall Ntildesmall Oacutesmall Ogravesmall Ocircumflexsmall Odieresissmall Otildesmall Uacutesmall Ugravesmall Ucircumflexsmall Udieresissmall  eightsuperior fourinferior threeinferior sixinferior eightinferior seveninferior Scaronsmall  centinferior twoinferior  Dieresissmall  Caronsmall osuperior fiveinferior  commainferior periodinferior Yacutesmall  dollarinferior  Thornsmall  nineinferior zeroinferior Zcaronsmall AEsmall Oslashsmall questiondownsmall oneinferior Lslashsmall       Cedillasmall      OEsmall figuredash hyphensuperior     exclamdownsmall  Ydieresissmall  onesuperior twosuperior threesuperior foursuperior fivesuperior sixsuperior sevensuperior ninesuperior zerosuperior  esuperior rsuperior tsuperior   isuperior ssuperior dsuperior      lsuperior Ogoneksmall Brevesmall Macronsmall bsuperior nsuperior msuperior commasuperior periodsuperior Dotaccentsmall Ringsmall'.split(
          ' ',
        ),
        b = '                                space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde  Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis space Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron'.split(
          ' ',
        ),
        v = '                                space exclam quotedbl numbersign dollar percent ampersand quoteright parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore quoteleft a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde                                   exclamdown cent sterling fraction yen florin section currency quotesingle quotedblleft guillemotleft guilsinglleft guilsinglright fi fl  endash dagger daggerdbl periodcentered  paragraph bullet quotesinglbase quotedblbase quotedblright guillemotright ellipsis perthousand  questiondown  grave acute circumflex tilde macron breve dotaccent dieresis  ring cedilla  hungarumlaut ogonek caron emdash                 AE  ordfeminine     Lslash Oslash OE ordmasculine      ae    dotlessi   lslash oslash oe germandbls'.split(
          ' ',
        ),
        d = '                                space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde bullet Euro bullet quotesinglbase florin quotedblbase ellipsis dagger daggerdbl circumflex perthousand Scaron guilsinglleft OE bullet Zcaron bullet bullet quoteleft quoteright quotedblleft quotedblright bullet endash emdash tilde trademark scaron guilsinglright oe bullet zcaron Ydieresis space exclamdown cent sterling currency yen brokenbar section dieresis copyright ordfeminine guillemotleft logicalnot hyphen registered macron degree plusminus twosuperior threesuperior acute mu paragraph periodcentered cedilla onesuperior ordmasculine guillemotright onequarter onehalf threequarters questiondown Agrave Aacute Acircumflex Atilde Adieresis Aring AE Ccedilla Egrave Eacute Ecircumflex Edieresis Igrave Iacute Icircumflex Idieresis Eth Ntilde Ograve Oacute Ocircumflex Otilde Odieresis multiply Oslash Ugrave Uacute Ucircumflex Udieresis Yacute Thorn germandbls agrave aacute acircumflex atilde adieresis aring ae ccedilla egrave eacute ecircumflex edieresis igrave iacute icircumflex idieresis eth ntilde ograve oacute ocircumflex otilde odieresis divide oslash ugrave uacute ucircumflex udieresis yacute thorn ydieresis'.split(
          ' ',
        ),
        u = '                                space exclam universal numbersign existential percent ampersand suchthat parenleft parenright asteriskmath plus comma minus period slash zero one two three four five six seven eight nine colon semicolon less equal greater question congruent Alpha Beta Chi Delta Epsilon Phi Gamma Eta Iota theta1 Kappa Lambda Mu Nu Omicron Pi Theta Rho Sigma Tau Upsilon sigma1 Omega Xi Psi Zeta bracketleft therefore bracketright perpendicular underscore radicalex alpha beta chi delta epsilon phi gamma eta iota phi1 kappa lambda mu nu omicron pi theta rho sigma tau upsilon omega1 omega xi psi zeta braceleft bar braceright similar                                  Euro Upsilon1 minute lessequal fraction infinity florin club diamond heart spade arrowboth arrowleft arrowup arrowright arrowdown degree plusminus second greaterequal multiply proportional partialdiff bullet divide notequal equivalence approxequal ellipsis arrowvertex arrowhorizex carriagereturn aleph Ifraktur Rfraktur weierstrass circlemultiply circleplus emptyset intersection union propersuperset reflexsuperset notsubset propersubset reflexsubset element notelement angle gradient registerserif copyrightserif trademarkserif product radical dotmath logicalnot logicaland logicalor arrowdblboth arrowdblleft arrowdblup arrowdblright arrowdbldown lozenge angleleft registersans copyrightsans trademarksans summation parenlefttp parenleftex parenleftbt bracketlefttp bracketleftex bracketleftbt bracelefttp braceleftmid braceleftbt braceex  angleright integral integraltp integralex integralbt parenrighttp parenrightex parenrightbt bracketrighttp bracketrightex bracketrightbt bracerighttp bracerightmid bracerightbt'.split(
          ' ',
        ),
        z = '                                space a1 a2 a202 a3 a4 a5 a119 a118 a117 a11 a12 a13 a14 a15 a16 a105 a17 a18 a19 a20 a21 a22 a23 a24 a25 a26 a27 a28 a6 a7 a8 a9 a10 a29 a30 a31 a32 a33 a34 a35 a36 a37 a38 a39 a40 a41 a42 a43 a44 a45 a46 a47 a48 a49 a50 a51 a52 a53 a54 a55 a56 a57 a58 a59 a60 a61 a62 a63 a64 a65 a66 a67 a68 a69 a70 a71 a72 a73 a74 a203 a75 a204 a76 a77 a78 a79 a81 a82 a83 a84 a97 a98 a99 a100  a89 a90 a93 a94 a91 a92 a205 a85 a206 a86 a87 a88 a95 a96                    a101 a102 a103 a104 a106 a107 a108 a112 a111 a110 a109 a120 a121 a122 a123 a124 a125 a126 a127 a128 a129 a130 a131 a132 a133 a134 a135 a136 a137 a138 a139 a140 a141 a142 a143 a144 a145 a146 a147 a148 a149 a150 a151 a152 a153 a154 a155 a156 a157 a158 a159 a160 a161 a163 a164 a196 a165 a192 a166 a167 a168 a169 a170 a171 a172 a173 a162 a174 a175 a176 a177 a178 a179 a193 a180 a199 a181 a200 a182  a201 a183 a184 a197 a185 a194 a198 a186 a195 a187 a188 a189 a190 a191'.split(
          ' ',
        );
      m.WinAnsiEncoding = d;
      m.StandardEncoding = v;
      m.MacRomanEncoding = b;
      m.SymbolSetEncoding = u;
      m.ZapfDingbatsEncoding = z;
      m.ExpertEncoding = a;
      m.getEncoding = function(C) {
        switch (C) {
          case 'WinAnsiEncoding':
            return d;
          case 'StandardEncoding':
            return v;
          case 'MacRomanEncoding':
            return b;
          case 'SymbolSetEncoding':
            return u;
          case 'ZapfDingbatsEncoding':
            return z;
          case 'ExpertEncoding':
            return a;
          case 'MacExpertEncoding':
            return k;
          default:
            return null;
        }
      };
    },
    function(y, m, t) {
      y.exports = function(a) {
        try {
          return !!a();
        } catch (k) {
          return !0;
        }
      };
    },
    function(y, m, t) {
      y = y.exports = { version: '2.5.1' };
      'number' == typeof __e && (__e = y);
    },
    function(y, m, t) {
      var a = t(12);
      y.exports = function(k) {
        if (!a(k)) throw TypeError(k + ' is not an object!');
        return k;
      };
    },
    function(y, m, t) {
      y.exports = function(a, k) {
        return { enumerable: !(a & 1), configurable: !(a & 2), writable: !(a & 4), value: k };
      };
    },
    function(y, m, t) {
      var a = t(47),
        k = t(48);
      y.exports = function(b) {
        return a(k(b));
      };
    },
    function(y, m, t) {
      var a = t(14),
        k = Math.max,
        b = Math.min;
      y.exports = function(v, d) {
        v = a(v);
        return 0 > v ? k(v + d, 0) : b(v, d);
      };
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.Parser = m.Linearization = m.Lexer = void 0;
      var a = t(3),
        k = t(0),
        b = t(1),
        v = (function() {
          function d(a, b, d, n) {
            this.lexer = a;
            this.allowStreams = b;
            this.xref = d;
            this.recoveryMode = n || !1;
            this.imageCache = Object.create(null);
            this.refill();
          }
          d.prototype = {
            refill: function() {
              this.buf1 = this.lexer.getObj();
              this.buf2 = this.lexer.getObj();
            },
            shift: function() {
              (0, b.isCmd)(this.buf2, 'ID')
                ? ((this.buf1 = this.buf2), (this.buf2 = null))
                : ((this.buf1 = this.buf2), (this.buf2 = this.lexer.getObj()));
            },
            tryShift: function() {
              try {
                return this.shift(), !0;
              } catch (z) {
                if (z instanceof k.MissingDataException) throw z;
                return !1;
              }
            },
            getObj: function(a) {
              var d = this.buf1;
              this.shift();
              if (d instanceof b.Cmd)
                switch (d.cmd) {
                  case 'BI':
                    return this.makeInlineImage(a);
                  case '[':
                    for (d = []; !(0, b.isCmd)(this.buf1, ']') && !(0, b.isEOF)(this.buf1); ) d.push(this.getObj(a));
                    if ((0, b.isEOF)(this.buf1)) {
                      if (!this.recoveryMode) throw new k.FormatError('End of file inside array');
                      return d;
                    }
                    this.shift();
                    return d;
                  case '<<':
                    for (d = new b.Dict(this.xref); !(0, b.isCmd)(this.buf1, '>>') && !(0, b.isEOF)(this.buf1); )
                      if ((0, b.isName)(this.buf1)) {
                        var B = this.buf1.name;
                        this.shift();
                        if ((0, b.isEOF)(this.buf1)) break;
                        d.set(B, this.getObj(a));
                      } else (0, k.info)('Malformed dictionary: key must be a name object'), this.shift();
                    if ((0, b.isEOF)(this.buf1)) {
                      if (!this.recoveryMode) throw new k.FormatError('End of file inside dictionary');
                      return d;
                    }
                    if ((0, b.isCmd)(this.buf2, 'stream')) return this.allowStreams ? this.makeStream(d, a) : d;
                    this.shift();
                    return d;
                  default:
                    return d;
                }
              if (Number.isInteger(d))
                return Number.isInteger(this.buf1) && (0, b.isCmd)(this.buf2, 'R')
                  ? ((a = new b.Ref(d, this.buf1)), this.shift(), this.shift(), a)
                  : d;
              (0, k.isString)(d) && a && (d = a.decryptString(d));
              return d;
            },
            findDefaultInlineStreamEnd: function(a) {
              for (var b = a.pos, d = 0, n, e = void 0; -1 !== (n = a.getByte()); )
                if (0 === d) d = 69 === n ? 1 : 0;
                else if (1 === d) d = 73 === n ? 2 : 0;
                else if (((0, k.assert)(2 === d), 32 === n || 10 === n || 13 === n)) {
                  e = a.pos;
                  for (var h = a.peekBytes(10), p = 0, A = h.length; p < A; p++)
                    if (((n = h[p]), (0 !== n || 0 === h[p + 1]) && 10 !== n && 13 !== n && (32 > n || 127 < n))) {
                      d = 0;
                      break;
                    }
                  if (2 === d) break;
                } else d = 0;
              -1 === n &&
                ((0, k.warn)(
                  'findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker',
                ),
                e && ((0, k.warn)('... trying to recover by using the last "EI" occurrence.'), a.skip(-(a.pos - e))));
              return a.pos - 4 - b;
            },
            findDCTDecodeInlineStreamEnd: function(a) {
              for (var b = a.pos, d = !1, n, e; -1 !== (n = a.getByte()); )
                if (255 === n) {
                  switch (a.getByte()) {
                    case 255:
                      a.skip(-1);
                      break;
                    case 217:
                      d = !0;
                      break;
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 197:
                    case 198:
                    case 199:
                    case 201:
                    case 202:
                    case 203:
                    case 205:
                    case 206:
                    case 207:
                    case 196:
                    case 204:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 224:
                    case 225:
                    case 226:
                    case 227:
                    case 228:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 239:
                    case 254:
                      (e = a.getUint16()), 2 < e ? a.skip(e - 2) : a.skip(-2);
                  }
                  if (d) break;
                }
              b = a.pos - b;
              if (-1 === n)
                return (
                  (0, k.warn)('Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead.'),
                  a.skip(-b),
                  this.findDefaultInlineStreamEnd(a)
                );
              this.inlineStreamSkipEI(a);
              return b;
            },
            findASCII85DecodeInlineStreamEnd: function(a) {
              for (var b = a.pos, d; -1 !== (d = a.getByte()); )
                if (126 === d && 62 === a.peekByte()) {
                  a.skip();
                  break;
                }
              b = a.pos - b;
              if (-1 === d)
                return (
                  (0, k.warn)('Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead.'),
                  a.skip(-b),
                  this.findDefaultInlineStreamEnd(a)
                );
              this.inlineStreamSkipEI(a);
              return b;
            },
            findASCIIHexDecodeInlineStreamEnd: function(a) {
              for (var b = a.pos, d; -1 !== (d = a.getByte()) && 62 !== d; );
              b = a.pos - b;
              if (-1 === d)
                return (
                  (0, k.warn)('Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead.'),
                  a.skip(-b),
                  this.findDefaultInlineStreamEnd(a)
                );
              this.inlineStreamSkipEI(a);
              return b;
            },
            inlineStreamSkipEI: function(a) {
              for (var b = 0, d; -1 !== (d = a.getByte()); )
                if (0 === b) b = 69 === d ? 1 : 0;
                else if (1 === b) b = 73 === d ? 2 : 0;
                else if (2 === b) break;
            },
            makeInlineImage: function(a) {
              for (
                var d = this.lexer.stream, B = new b.Dict(this.xref);
                !(0, b.isCmd)(this.buf1, 'ID') && !(0, b.isEOF)(this.buf1);

              ) {
                if (!(0, b.isName)(this.buf1)) throw new k.FormatError('Dictionary key must be a name object');
                var n = this.buf1.name;
                this.shift();
                if ((0, b.isEOF)(this.buf1)) break;
                B.set(n, this.getObj(a));
              }
              n = B.get('Filter', 'F');
              if ((0, b.isName)(n)) var e = n.name;
              else Array.isArray(n) && ((n = this.xref.fetchIfRef(n[0])), (0, b.isName)(n) && (e = n.name));
              n = d.pos;
              e =
                'DCTDecode' === e || 'DCT' === e
                  ? this.findDCTDecodeInlineStreamEnd(d)
                  : 'ASCII85Decode' === e || 'A85' === e
                  ? this.findASCII85DecodeInlineStreamEnd(d)
                  : 'ASCIIHexDecode' === e || 'AHx' === e
                  ? this.findASCIIHexDecodeInlineStreamEnd(d)
                  : this.findDefaultInlineStreamEnd(d);
              d = d.makeSubStream(n, e, B);
              if (1e3 > e) {
                var h = d.getBytes();
                d.reset();
                var p = 1,
                  A = 0;
                var c = 0;
                for (n = h.length; c < n; ++c) (p += h[c] & 255), (A += p);
                c = (A % 65521 << 16) | p % 65521;
                n = this.imageCache[c];
                if (void 0 !== n) return (this.buf2 = b.Cmd.get('EI')), this.shift(), n.reset(), n;
              }
              a && (d = a.createStream(d, e));
              d = this.filter(d, B, e);
              d.dict = B;
              void 0 !== c && ((d.cacheKey = 'inline_' + e + '_' + c), (this.imageCache[c] = d));
              this.buf2 = b.Cmd.get('EI');
              this.shift();
              return d;
            },
            makeStream: function(a, d) {
              var B = this.lexer,
                n = B.stream;
              B.skipToNextLine();
              var e = n.pos - 1,
                h = a.get('Length');
              Number.isInteger(h) || ((0, k.info)('Bad ' + h + ' attribute in stream'), (h = 0));
              n.pos = e + h;
              B.nextChar();
              if (!this.tryShift() || !(0, b.isCmd)(this.buf2, 'endstream')) {
                n.pos = e;
                h = [101, 110, 100, 115, 116, 114, 101, 97, 109];
                for (var p = 0, A = !1, c, q; n.pos < n.end; ) {
                  var x = n.peekBytes(2048),
                    g = x.length - 9;
                  if (0 >= g) break;
                  A = !1;
                  for (c = 0; c < g; ) {
                    for (q = 0; 9 > q && x[c + q] === h[q]; ) q++;
                    if (9 <= q) {
                      A = !0;
                      break;
                    }
                    c++;
                  }
                  if (A) {
                    p += c;
                    n.pos += c;
                    break;
                  }
                  p += g;
                  n.pos += g;
                }
                if (!A) throw new k.FormatError('Missing endstream');
                h = p;
                B.nextChar();
                this.shift();
              }
              this.shift();
              this.shift();
              n = n.makeSubStream(e, h, a);
              d && (n = d.createStream(n, h));
              n = this.filter(n, a, h);
              n.dict = a;
              return n;
            },
            filter: function(a, d, B) {
              var n = d.get('Filter', 'F');
              d = d.get('DecodeParms', 'DP');
              if ((0, b.isName)(n))
                return (
                  Array.isArray(d) &&
                    (0, k.warn)('/DecodeParms should not contain an Array, when /Filter contains a Name.'),
                  this.makeFilter(a, n.name, B, d)
                );
              if (Array.isArray(n))
                for (var e = n, h = d, p = 0, A = e.length; p < A; ++p) {
                  n = this.xref.fetchIfRef(e[p]);
                  if (!(0, b.isName)(n)) throw new k.FormatError('Bad filter name: ' + n);
                  d = null;
                  Array.isArray(h) && p in h && (d = this.xref.fetchIfRef(h[p]));
                  a = this.makeFilter(a, n.name, B, d);
                  B = null;
                }
              return a;
            },
            makeFilter: function(b, d, B, n) {
              if (0 === B) return (0, k.warn)('Empty "' + d + '" stream.'), new a.NullStream(b);
              try {
                var e = this.xref.stats.streamTypes;
                if ('FlateDecode' === d || 'Fl' === d)
                  return (
                    (e[k.StreamType.FLATE] = !0),
                    n ? new a.PredictorStream(new a.FlateStream(b, B), B, n) : new a.FlateStream(b, B)
                  );
                if ('LZWDecode' === d || 'LZW' === d)
                  return (
                    (e[k.StreamType.LZW] = !0),
                    (d = 1),
                    n
                      ? (n.has('EarlyChange') && (d = n.get('EarlyChange')),
                        new a.PredictorStream(new a.LZWStream(b, B, d), B, n))
                      : new a.LZWStream(b, B, d)
                  );
                if ('DCTDecode' === d || 'DCT' === d)
                  return (e[k.StreamType.DCT] = !0), new a.JpegStream(b, B, b.dict, n);
                if ('JPXDecode' === d || 'JPX' === d)
                  return (e[k.StreamType.JPX] = !0), new a.JpxStream(b, B, b.dict, n);
                if ('ASCII85Decode' === d || 'A85' === d) return (e[k.StreamType.A85] = !0), new a.Ascii85Stream(b, B);
                if ('ASCIIHexDecode' === d || 'AHx' === d)
                  return (e[k.StreamType.AHX] = !0), new a.AsciiHexStream(b, B);
                if ('CCITTFaxDecode' === d || 'CCF' === d)
                  return (e[k.StreamType.CCF] = !0), new a.CCITTFaxStream(b, B, n);
                if ('RunLengthDecode' === d || 'RL' === d)
                  return (e[k.StreamType.RL] = !0), new a.RunLengthStream(b, B);
                if ('JBIG2Decode' === d) return (e[k.StreamType.JBIG] = !0), new a.Jbig2Stream(b, B, b.dict, n);
                (0, k.warn)('filter "' + d + '" not supported yet');
                return b;
              } catch (h) {
                if (h instanceof k.MissingDataException) throw h;
                (0, k.warn)('Invalid stream: "' + h + '"');
                return new a.NullStream(b);
              }
            },
          };
          return d;
        })(),
        d = (function() {
          function a(a, b) {
            this.stream = a;
            this.nextChar();
            this.strBuf = [];
            this.knownCommands = b;
          }
          function d(a) {
            return 48 <= a && 57 >= a ? a & 15 : (65 <= a && 70 >= a) || (97 <= a && 102 >= a) ? (a & 15) + 9 : -1;
          }
          var v = [
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            2,
            0,
            0,
            2,
            2,
            0,
            0,
            0,
            0,
            0,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            0,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            0,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            0,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
          ];
          a.prototype = {
            nextChar: function() {
              return (this.currentChar = this.stream.getByte());
            },
            peekChar: function() {
              return this.stream.peekByte();
            },
            getNumber: function() {
              var a = this.currentChar,
                b = !1,
                d = 0,
                h = 1;
              45 === a
                ? ((h = -1), (a = this.nextChar()), 45 === a && (a = this.nextChar()))
                : 43 === a && (a = this.nextChar());
              46 === a && ((d = 10), (a = this.nextChar()));
              if (10 === a || 13 === a) {
                do a = this.nextChar();
                while (10 === a || 13 === a);
              }
              if (48 > a || 57 < a)
                throw new k.FormatError('Invalid number: ' + String.fromCharCode(a) + ' (charCode ' + a + ')');
              for (var p = a - 48, A = 0, c = 1; 0 <= (a = this.nextChar()); )
                if (48 <= a && 57 >= a) (a -= 48), b ? (A = 10 * A + a) : (0 !== d && (d *= 10), (p = 10 * p + a));
                else if (46 === a)
                  if (0 === d) d = 1;
                  else break;
                else if (45 === a) (0, k.warn)('Badly formatted number');
                else if (69 === a || 101 === a) {
                  a = this.peekChar();
                  if (43 === a || 45 === a) (c = 45 === a ? -1 : 1), this.nextChar();
                  else if (48 > a || 57 < a) break;
                  b = !0;
                } else break;
              0 !== d && (p /= d);
              b && (p *= Math.pow(10, c * A));
              return h * p;
            },
            getString: function() {
              var a = 1,
                b = !1,
                d = this.strBuf;
              d.length = 0;
              for (var h = this.nextChar(); ; ) {
                var p = !1;
                switch (h | 0) {
                  case -1:
                    (0, k.warn)('Unterminated string');
                    b = !0;
                    break;
                  case 40:
                    ++a;
                    d.push('(');
                    break;
                  case 41:
                    0 === --a ? (this.nextChar(), (b = !0)) : d.push(')');
                    break;
                  case 92:
                    h = this.nextChar();
                    switch (h) {
                      case -1:
                        (0, k.warn)('Unterminated string');
                        b = !0;
                        break;
                      case 110:
                        d.push('\n');
                        break;
                      case 114:
                        d.push('\r');
                        break;
                      case 116:
                        d.push('\t');
                        break;
                      case 98:
                        d.push('\b');
                        break;
                      case 102:
                        d.push('\f');
                        break;
                      case 92:
                      case 40:
                      case 41:
                        d.push(String.fromCharCode(h));
                        break;
                      case 48:
                      case 49:
                      case 50:
                      case 51:
                      case 52:
                      case 53:
                      case 54:
                      case 55:
                        var A = h & 15;
                        h = this.nextChar();
                        p = !0;
                        48 <= h &&
                          55 >= h &&
                          ((A = (A << 3) + (h & 15)),
                          (h = this.nextChar()),
                          48 <= h && 55 >= h && ((p = !1), (A = (A << 3) + (h & 15))));
                        d.push(String.fromCharCode(A));
                        break;
                      case 13:
                        10 === this.peekChar() && this.nextChar();
                        break;
                      case 10:
                        break;
                      default:
                        d.push(String.fromCharCode(h));
                    }
                    break;
                  default:
                    d.push(String.fromCharCode(h));
                }
                if (b) break;
                p || (h = this.nextChar());
              }
              return d.join('');
            },
            getName: function() {
              var a,
                n = this.strBuf;
              for (n.length = 0; 0 <= (a = this.nextChar()) && !v[a]; )
                if (35 === a) {
                  a = this.nextChar();
                  if (v[a]) {
                    (0, k.warn)('Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number.');
                    n.push('#');
                    break;
                  }
                  var e = d(a);
                  if (-1 !== e) {
                    var h = a;
                    a = this.nextChar();
                    var p = d(a);
                    if (-1 === p) {
                      (0, k.warn)(
                        'Lexer_getName: Illegal digit (' + String.fromCharCode(a) + ') in hexadecimal number.',
                      );
                      n.push('#', String.fromCharCode(h));
                      if (v[a]) break;
                      n.push(String.fromCharCode(a));
                    } else n.push(String.fromCharCode((e << 4) | p));
                  } else n.push('#', String.fromCharCode(a));
                } else n.push(String.fromCharCode(a));
              127 < n.length && (0, k.warn)('name token is longer than allowed by the spec: ' + n.length);
              return b.Name.get(n.join(''));
            },
            getHexString: function() {
              var a = this.strBuf;
              a.length = 0;
              for (var b = this.currentChar, e = !0, h, p; ; )
                if (0 > b) {
                  (0, k.warn)('Unterminated hex string');
                  break;
                } else if (62 === b) {
                  this.nextChar();
                  break;
                } else {
                  if (1 !== v[b]) {
                    if (e) {
                      if (((h = d(b)), -1 === h)) {
                        (0, k.warn)('Ignoring invalid character "' + b + '" in hex string');
                        b = this.nextChar();
                        continue;
                      }
                    } else {
                      p = d(b);
                      if (-1 === p) {
                        (0, k.warn)('Ignoring invalid character "' + b + '" in hex string');
                        b = this.nextChar();
                        continue;
                      }
                      a.push(String.fromCharCode((h << 4) | p));
                    }
                    e = !e;
                  }
                  b = this.nextChar();
                }
              return a.join('');
            },
            getObj: function() {
              for (var a = !1, d = this.currentChar; ; ) {
                if (0 > d) return b.EOF;
                if (a) {
                  if (10 === d || 13 === d) a = !1;
                } else if (37 === d) a = !0;
                else if (1 !== v[d]) break;
                d = this.nextChar();
              }
              switch (d | 0) {
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 43:
                case 45:
                case 46:
                  return this.getNumber();
                case 40:
                  return this.getString();
                case 47:
                  return this.getName();
                case 91:
                  return this.nextChar(), b.Cmd.get('[');
                case 93:
                  return this.nextChar(), b.Cmd.get(']');
                case 60:
                  return (d = this.nextChar()), 60 === d ? (this.nextChar(), b.Cmd.get('<<')) : this.getHexString();
                case 62:
                  return (d = this.nextChar()), 62 === d ? (this.nextChar(), b.Cmd.get('>>')) : b.Cmd.get('>');
                case 123:
                  return this.nextChar(), b.Cmd.get('{');
                case 125:
                  return this.nextChar(), b.Cmd.get('}');
                case 41:
                  throw (this.nextChar(), new k.FormatError('Illegal character: ' + d));
              }
              a = String.fromCharCode(d);
              for (var e = this.knownCommands, h = e && void 0 !== e[a]; 0 <= (d = this.nextChar()) && !v[d]; ) {
                var p = a + String.fromCharCode(d);
                if (h && void 0 === e[p]) break;
                if (128 === a.length) throw new k.FormatError('Command token too long: ' + a.length);
                a = p;
                h = e && void 0 !== e[a];
              }
              return 'true' === a ? !0 : 'false' === a ? !1 : 'null' === a ? null : b.Cmd.get(a);
            },
            skipToNextLine: function() {
              for (var a = this.currentChar; 0 <= a; ) {
                if (13 === a) {
                  a = this.nextChar();
                  10 === a && this.nextChar();
                  break;
                } else if (10 === a) {
                  this.nextChar();
                  break;
                }
                a = this.nextChar();
              }
            },
          };
          return a;
        })();
      m.Lexer = d;
      m.Linearization = {
        create: function(a) {
          function u(a, b) {
            var c = h.get(a);
            if (Number.isInteger(c) && (b ? 0 <= c : 0 < c)) return c;
            throw Error('The "' + a + '" parameter in the linearization dictionary is invalid.');
          }
          var m = new v(new d(a), !1, null),
            B = m.getObj(),
            n = m.getObj(),
            e = m.getObj(),
            h = m.getObj(),
            p;
          if (
            !(
              Number.isInteger(B) &&
              Number.isInteger(n) &&
              (0, b.isCmd)(e, 'obj') &&
              (0, b.isDict)(h) &&
              (0, k.isNum)((p = h.get('Linearized'))) &&
              0 < p
            )
          )
            return null;
          if ((m = u('L')) !== a.length)
            throw Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
          return {
            length: m,
            hints: (function() {
              var a = h.get('H'),
                b,
                d;
              if (Array.isArray(a) && (2 === (b = a.length) || 4 === b)) {
                for (var e = 0; e < b; e++)
                  if (!(Number.isInteger((d = a[e])) && 0 < d))
                    throw Error('Hint (' + e + ') in the linearization dictionary is invalid.');
                return a;
              }
              throw Error('Hint array in the linearization dictionary is invalid.');
            })(),
            objectNumberFirst: u('O'),
            endFirst: u('E'),
            numPages: u('N'),
            mainXRefEntriesOffset: u('T'),
            pageFirst: h.has('P') ? u('P', !0) : 0,
          };
        },
      };
      m.Parser = v;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.PostScriptCompiler = m.PostScriptEvaluator = m.PDFFunction = m.isPDFFunction = void 0;
      var a =
          'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
            ? function(a) {
                return typeof a;
              }
            : function(a) {
                return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                  ? 'symbol'
                  : typeof a;
              },
        k = t(0),
        b = t(1),
        v = t(108),
        d = {
          get value() {
            return (0, k.shadow)(this, 'value', (0, k.isEvalSupported)());
          },
        },
        u = (function() {
          var a = !0;
          return {
            setIsEvalSupported: function() {
              a = !1 !== (0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : !0);
            },
            getSampleArray: function(a, b, d, n) {
              var c,
                e = 1;
              var h = 0;
              for (c = a.length; h < c; h++) e *= a[h];
              e *= b;
              a = Array(e);
              c = b = 0;
              var g = 1 / (Math.pow(2, d) - 1);
              n = n.getBytes((e * d + 7) / 8);
              var p = 0;
              for (h = 0; h < e; h++) {
                for (; b < d; ) (c <<= 8), (c |= n[p++]), (b += 8);
                b -= d;
                a[h] = (c >> b) * g;
                c &= (1 << b) - 1;
              }
              return a;
            },
            getIR: function(a, b) {
              var d = b.dict;
              d || (d = b);
              var e = [
                  this.constructSampled,
                  null,
                  this.constructInterpolated,
                  this.constructStiched,
                  this.constructPostScript,
                ],
                c = d.get('FunctionType');
              e = e[c];
              if (!e) throw new k.FormatError('Unknown type of function');
              return e.call(this, b, d, a);
            },
            fromIR: function(a) {
              switch (a[0]) {
                case 0:
                  return this.constructSampledFromIR(a);
                case 2:
                  return this.constructInterpolatedFromIR(a);
                case 3:
                  return this.constructStichedFromIR(a);
                default:
                  return this.constructPostScriptFromIR(a);
              }
            },
            parse: function(a, b) {
              var d = this.getIR(a, b);
              return this.fromIR(d);
            },
            parseArray: function(a, b) {
              if (!Array.isArray(b)) return this.parse(a, b);
              for (var d = [], e = 0, c = b.length; e < c; e++) {
                var q = a.fetchIfRef(b[e]);
                d.push(u.parse(a, q));
              }
              return function(a, b, c, l) {
                for (var g = 0, f = d.length; g < f; g++) d[g](a, b, c, l + g);
              };
            },
            constructSampled: function(a, b) {
              function d(a) {
                for (var b = a.length, c = [], d = 0, f = 0; f < b; f += 2) (c[d] = [a[f], a[f + 1]]), ++d;
                return c;
              }
              var e = b.getArray('Domain'),
                c = b.getArray('Range');
              if (!e || !c) throw new k.FormatError('No domain or range');
              var q = e.length / 2,
                h = c.length / 2;
              e = d(e);
              c = d(c);
              var g = b.get('Size'),
                n = b.get('BitsPerSample'),
                l = b.get('Order') || 1;
              1 !== l && (0, k.info)('No support for cubic spline interpolation: ' + l);
              l = b.getArray('Encode');
              if (!l) {
                l = [];
                for (var J = 0; J < q; ++J) l.push(0), l.push(g[J] - 1);
              }
              l = d(l);
              J = (J = b.getArray('Decode')) ? d(J) : c;
              var f = this.getSampleArray(g, h, n, a);
              return [0, q, e, l, J, f, g, h, Math.pow(2, n) - 1, c];
            },
            constructSampledFromIR: function(a) {
              return function(b, d, e, c) {
                var q = a[1],
                  h = a[2],
                  g = a[3],
                  p = a[4],
                  l = a[5],
                  n = a[6],
                  f = a[7],
                  r = a[9],
                  D = 1 << q,
                  L = new Float64Array(D),
                  I = new Uint32Array(D),
                  w,
                  E;
                for (E = 0; E < D; E++) L[E] = 1;
                var F = f,
                  K = 1;
                for (w = 0; w < q; ++w) {
                  E = h[w][0];
                  var H = h[w][1],
                    M = g[w][0];
                  var A = M + ((g[w][1] - M) / (H - E)) * (Math.min(Math.max(b[d + w], E), H) - E);
                  H = n[w];
                  A = Math.min(Math.max(A, 0), H - 1);
                  E = A < H - 1 ? Math.floor(A) : A - 1;
                  M = E + 1 - A;
                  A -= E;
                  var N = E * F,
                    k = N + F;
                  for (E = 0; E < D; E++) E & K ? ((L[E] *= A), (I[E] += k)) : ((L[E] *= M), (I[E] += N));
                  F *= H;
                  K <<= 1;
                }
                for (E = 0; E < f; ++E) {
                  for (w = b = 0; w < D; w++) b += l[I[w] + E] * L[w];
                  w = p[E][0];
                  b = w + (b - 0) * (p[E][1] - w);
                  e[c + E] = Math.min(Math.max(b, r[E][0]), r[E][1]);
                }
              };
            },
            constructInterpolated: function(a, b) {
              var d = b.getArray('C0') || [0],
                e = b.getArray('C1') || [1],
                c = b.get('N');
              if (!Array.isArray(d) || !Array.isArray(e))
                throw new k.FormatError('Illegal dictionary for interpolated function');
              for (var q = d.length, h = [], g = 0; g < q; ++g) h.push(e[g] - d[g]);
              return [2, d, h, c];
            },
            constructInterpolatedFromIR: function(a) {
              var b = a[1],
                d = a[2],
                e = a[3],
                c = d.length;
              return function(a, h, g, p) {
                a = 1 === e ? a[h] : Math.pow(a[h], e);
                for (h = 0; h < c; ++h) g[p + h] = b[h] + a * d[h];
              };
            },
            constructStiched: function(a, b, d) {
              a = b.getArray('Domain');
              if (!a) throw new k.FormatError('No domain');
              if (1 !== a.length / 2) throw new k.FormatError('Bad domain for stiched function');
              for (var e = b.get('Functions'), c = [], q = 0, h = e.length; q < h; ++q)
                c.push(u.getIR(d, d.fetchIfRef(e[q])));
              d = b.getArray('Bounds');
              b = b.getArray('Encode');
              return [3, a, d, b, c];
            },
            constructStichedFromIR: function(a) {
              var b = a[1],
                d = a[2],
                e = a[3];
              a = a[4];
              for (var c = [], q = new Float32Array(1), x = 0, g = a.length; x < g; x++) c.push(u.fromIR(a[x]));
              return function(a, l, g, f) {
                a = a[l];
                l = b[0];
                var r = b[1];
                a > r ? (a = r) : a < l && (a = l);
                l = 0;
                for (r = d.length; l < r && !(a < d[l]); ++l);
                r = b[0];
                0 < l && (r = d[l - 1]);
                var h = b[1];
                l < d.length && (h = d[l]);
                var p = e[2 * l],
                  x = e[2 * l + 1];
                q[0] = r === h ? p : p + ((a - r) * (x - p)) / (h - r);
                c[l](q, 0, g, f);
              };
            },
            constructPostScript: function(a, b, d) {
              d = b.getArray('Domain');
              b = b.getArray('Range');
              if (!d) throw new k.FormatError('No domain.');
              if (!b) throw new k.FormatError('No range.');
              a = new v.PostScriptLexer(a);
              a = new v.PostScriptParser(a).parse();
              return [4, d, b, a];
            },
            constructPostScriptFromIR: function(b) {
              var e = b[1],
                p = b[2];
              b = b[3];
              if (a && d.value) {
                var n = new B().compile(b, e, p);
                if (n) return new Function('src', 'srcOffset', 'dest', 'destOffset', n);
              }
              (0, k.info)('Unable to compile PS function');
              var c = p.length >> 1,
                q = e.length >> 1,
                x = new C(b),
                g = Object.create(null),
                G = 8192,
                l = new Float32Array(q);
              return function(a, b, d, e) {
                var f,
                  r = '';
                for (f = 0; f < q; f++) {
                  var w = a[b + f];
                  l[f] = w;
                  r += w + '_';
                }
                f = g[r];
                if (void 0 !== f) d.set(f, e);
                else {
                  a = new Float32Array(c);
                  b = x.execute(l);
                  var E = b.length - c;
                  for (f = 0; f < c; f++) {
                    w = b[E + f];
                    var F = p[2 * f];
                    w < F ? (w = F) : ((F = p[2 * f + 1]), w > F && (w = F));
                    a[f] = w;
                  }
                  0 < G && (G--, (g[r] = a));
                  d.set(a, e);
                }
              };
            },
          };
        })(),
        z = (function() {
          function a(a) {
            this.stack = a ? Array.prototype.slice.call(a, 0) : [];
          }
          a.prototype = {
            push: function(a) {
              if (100 <= this.stack.length) throw Error('PostScript function stack overflow.');
              this.stack.push(a);
            },
            pop: function() {
              if (0 >= this.stack.length) throw Error('PostScript function stack underflow.');
              return this.stack.pop();
            },
            copy: function(a) {
              if (100 <= this.stack.length + a) throw Error('PostScript function stack overflow.');
              var b = this.stack,
                d = b.length - a;
              for (--a; 0 <= a; a--, d++) b.push(b[d]);
            },
            index: function(a) {
              this.push(this.stack[this.stack.length - a - 1]);
            },
            roll: function(a, b) {
              var d = this.stack,
                e = d.length - a,
                c = d.length - 1,
                q = e + (b - Math.floor(b / a) * a),
                h;
              var g = e;
              for (h = c; g < h; g++, h--) {
                var n = d[g];
                d[g] = d[h];
                d[h] = n;
              }
              g = e;
              for (h = q - 1; g < h; g++, h--) (n = d[g]), (d[g] = d[h]), (d[h] = n);
              g = q;
              for (h = c; g < h; g++, h--) (n = d[g]), (d[g] = d[h]), (d[h] = n);
            },
          };
          return a;
        })(),
        C = (function() {
          function a(a) {
            this.operators = a;
          }
          a.prototype = {
            execute: function(a) {
              a = new z(a);
              for (var b = 0, d = this.operators, e = d.length, c, q; b < e; )
                if (((c = d[b++]), 'number' === typeof c)) a.push(c);
                else
                  switch (c) {
                    case 'jz':
                      q = a.pop();
                      (c = a.pop()) || (b = q);
                      break;
                    case 'j':
                      b = c = a.pop();
                      break;
                    case 'abs':
                      c = a.pop();
                      a.push(Math.abs(c));
                      break;
                    case 'add':
                      q = a.pop();
                      c = a.pop();
                      a.push(c + q);
                      break;
                    case 'and':
                      q = a.pop();
                      c = a.pop();
                      (0, k.isBool)(c) && (0, k.isBool)(q) ? a.push(c && q) : a.push(c & q);
                      break;
                    case 'atan':
                      c = a.pop();
                      a.push(Math.atan(c));
                      break;
                    case 'bitshift':
                      q = a.pop();
                      c = a.pop();
                      0 < c ? a.push(c << q) : a.push(c >> q);
                      break;
                    case 'ceiling':
                      c = a.pop();
                      a.push(Math.ceil(c));
                      break;
                    case 'copy':
                      c = a.pop();
                      a.copy(c);
                      break;
                    case 'cos':
                      c = a.pop();
                      a.push(Math.cos(c));
                      break;
                    case 'cvi':
                      c = a.pop() | 0;
                      a.push(c);
                      break;
                    case 'cvr':
                      break;
                    case 'div':
                      q = a.pop();
                      c = a.pop();
                      a.push(c / q);
                      break;
                    case 'dup':
                      a.copy(1);
                      break;
                    case 'eq':
                      q = a.pop();
                      c = a.pop();
                      a.push(c === q);
                      break;
                    case 'exch':
                      a.roll(2, 1);
                      break;
                    case 'exp':
                      q = a.pop();
                      c = a.pop();
                      a.push(Math.pow(c, q));
                      break;
                    case 'false':
                      a.push(!1);
                      break;
                    case 'floor':
                      c = a.pop();
                      a.push(Math.floor(c));
                      break;
                    case 'ge':
                      q = a.pop();
                      c = a.pop();
                      a.push(c >= q);
                      break;
                    case 'gt':
                      q = a.pop();
                      c = a.pop();
                      a.push(c > q);
                      break;
                    case 'idiv':
                      q = a.pop();
                      c = a.pop();
                      a.push((c / q) | 0);
                      break;
                    case 'index':
                      c = a.pop();
                      a.index(c);
                      break;
                    case 'le':
                      q = a.pop();
                      c = a.pop();
                      a.push(c <= q);
                      break;
                    case 'ln':
                      c = a.pop();
                      a.push(Math.log(c));
                      break;
                    case 'log':
                      c = a.pop();
                      a.push(Math.log(c) / Math.LN10);
                      break;
                    case 'lt':
                      q = a.pop();
                      c = a.pop();
                      a.push(c < q);
                      break;
                    case 'mod':
                      q = a.pop();
                      c = a.pop();
                      a.push(c % q);
                      break;
                    case 'mul':
                      q = a.pop();
                      c = a.pop();
                      a.push(c * q);
                      break;
                    case 'ne':
                      q = a.pop();
                      c = a.pop();
                      a.push(c !== q);
                      break;
                    case 'neg':
                      c = a.pop();
                      a.push(-c);
                      break;
                    case 'not':
                      c = a.pop();
                      (0, k.isBool)(c) ? a.push(!c) : a.push(~c);
                      break;
                    case 'or':
                      q = a.pop();
                      c = a.pop();
                      (0, k.isBool)(c) && (0, k.isBool)(q) ? a.push(c || q) : a.push(c | q);
                      break;
                    case 'pop':
                      a.pop();
                      break;
                    case 'roll':
                      q = a.pop();
                      c = a.pop();
                      a.roll(c, q);
                      break;
                    case 'round':
                      c = a.pop();
                      a.push(Math.round(c));
                      break;
                    case 'sin':
                      c = a.pop();
                      a.push(Math.sin(c));
                      break;
                    case 'sqrt':
                      c = a.pop();
                      a.push(Math.sqrt(c));
                      break;
                    case 'sub':
                      q = a.pop();
                      c = a.pop();
                      a.push(c - q);
                      break;
                    case 'true':
                      a.push(!0);
                      break;
                    case 'truncate':
                      c = a.pop();
                      c = 0 > c ? Math.ceil(c) : Math.floor(c);
                      a.push(c);
                      break;
                    case 'xor':
                      q = a.pop();
                      c = a.pop();
                      (0, k.isBool)(c) && (0, k.isBool)(q) ? a.push(c !== q) : a.push(c ^ q);
                      break;
                    default:
                      throw new k.FormatError('Unknown operator ' + c);
                  }
              return a.stack;
            },
          };
          return a;
        })(),
        B = (function() {
          function a(a) {
            this.type = a;
          }
          function b(a, b, c) {
            this.type = 'args';
            this.index = a;
            this.min = b;
            this.max = c;
          }
          function d(a) {
            this.type = 'literal';
            this.max = this.min = this.number = a;
          }
          function p(a, b, c, d, f) {
            this.type = 'binary';
            this.op = a;
            this.arg1 = b;
            this.arg2 = c;
            this.min = d;
            this.max = f;
          }
          function A(a, b) {
            this.type = 'max';
            this.arg = a;
            this.min = a.min;
            this.max = b;
          }
          function c(a, b, c) {
            this.type = 'var';
            this.index = a;
            this.min = b;
            this.max = c;
          }
          function q(a, b) {
            this.type = 'definition';
            this.variable = a;
            this.arg = b;
          }
          function x() {
            this.parts = [];
          }
          function g(a, b) {
            return 'literal' === b.type && 0 === b.number
              ? a
              : 'literal' === a.type && 0 === a.number
              ? b
              : 'literal' === b.type && 'literal' === a.type
              ? new d(a.number + b.number)
              : new p('+', a, b, a.min + b.min, a.max + b.max);
          }
          function G(a, b) {
            if ('literal' === b.type) {
              if (0 === b.number) return new d(0);
              if (1 === b.number) return a;
              if ('literal' === a.type) return new d(a.number * b.number);
            }
            if ('literal' === a.type) {
              if (0 === a.number) return new d(0);
              if (1 === a.number) return b;
            }
            return new p(
              '*',
              a,
              b,
              Math.min(a.min * b.min, a.min * b.max, a.max * b.min, a.max * b.max),
              Math.max(a.min * b.min, a.min * b.max, a.max * b.min, a.max * b.max),
            );
          }
          function l(a, b) {
            if ('literal' === b.type) {
              if (0 === b.number) return a;
              if ('literal' === a.type) return new d(a.number - b.number);
            }
            return 'binary' === b.type &&
              '-' === b.op &&
              'literal' === a.type &&
              1 === a.number &&
              'literal' === b.arg1.type &&
              1 === b.arg1.number
              ? b.arg2
              : new p('-', a, b, a.min - b.max, a.max - b.min);
          }
          function k(a, b) {
            return a.min >= b ? new d(b) : a.max <= b ? a : new A(a, b);
          }
          function f() {}
          a.prototype.visit = function(a) {
            throw Error('abstract method');
          };
          b.prototype = Object.create(a.prototype);
          b.prototype.visit = function(a) {
            a.visitArgument(this);
          };
          d.prototype = Object.create(a.prototype);
          d.prototype.visit = function(a) {
            a.visitLiteral(this);
          };
          p.prototype = Object.create(a.prototype);
          p.prototype.visit = function(a) {
            a.visitBinaryOperation(this);
          };
          A.prototype = Object.create(a.prototype);
          A.prototype.visit = function(a) {
            a.visitMin(this);
          };
          c.prototype = Object.create(a.prototype);
          c.prototype.visit = function(a) {
            a.visitVariable(this);
          };
          q.prototype = Object.create(a.prototype);
          q.prototype.visit = function(a) {
            a.visitVariableDefinition(this);
          };
          x.prototype = {
            visitArgument: function(a) {
              this.parts.push('Math.max(', a.min, ', Math.min(', a.max, ', src[srcOffset + ', a.index, ']))');
            },
            visitVariable: function(a) {
              this.parts.push('v', a.index);
            },
            visitLiteral: function(a) {
              this.parts.push(a.number);
            },
            visitBinaryOperation: function(a) {
              this.parts.push('(');
              a.arg1.visit(this);
              this.parts.push(' ', a.op, ' ');
              a.arg2.visit(this);
              this.parts.push(')');
            },
            visitVariableDefinition: function(a) {
              this.parts.push('var ');
              a.variable.visit(this);
              this.parts.push(' = ');
              a.arg.visit(this);
              this.parts.push(';');
            },
            visitMin: function(a) {
              this.parts.push('Math.min(');
              a.arg.visit(this);
              this.parts.push(', ', a.max, ')');
            },
            toString: function() {
              return this.parts.join('');
            },
          };
          f.prototype = {
            compile: function(a, f, e) {
              var r = [],
                w,
                E = [],
                F = f.length >> 1,
                h = e.length >> 1,
                p = 0;
              for (w = 0; w < F; w++) r.push(new b(w, f[2 * w], f[2 * w + 1]));
              w = 0;
              for (f = a.length; w < f; w++)
                if (((F = a[w]), 'number' === typeof F)) r.push(new d(F));
                else
                  switch (F) {
                    case 'add':
                      if (2 > r.length) return null;
                      var D = r.pop();
                      F = r.pop();
                      r.push(g(F, D));
                      break;
                    case 'cvr':
                      if (1 > r.length) return null;
                      break;
                    case 'mul':
                      if (2 > r.length) return null;
                      D = r.pop();
                      F = r.pop();
                      r.push(G(F, D));
                      break;
                    case 'sub':
                      if (2 > r.length) return null;
                      D = r.pop();
                      F = r.pop();
                      r.push(l(F, D));
                      break;
                    case 'exch':
                      if (2 > r.length) return null;
                      D = r.pop();
                      F = r.pop();
                      r.push(D, F);
                      break;
                    case 'pop':
                      if (1 > r.length) return null;
                      r.pop();
                      break;
                    case 'index':
                      if (1 > r.length) return null;
                      F = r.pop();
                      if ('literal' !== F.type) return null;
                      F = F.number;
                      if (0 > F || !Number.isInteger(F) || r.length < F) return null;
                      D = r[r.length - F - 1];
                      if ('literal' === D.type || 'var' === D.type) {
                        r.push(D);
                        break;
                      }
                      var n = new c(p++, D.min, D.max);
                      r[r.length - F - 1] = n;
                      r.push(n);
                      E.push(new q(n, D));
                      break;
                    case 'dup':
                      if (1 > r.length) return null;
                      if (
                        'number' === typeof a[w + 1] &&
                        'gt' === a[w + 2] &&
                        a[w + 3] === w + 7 &&
                        'jz' === a[w + 4] &&
                        'pop' === a[w + 5] &&
                        a[w + 6] === a[w + 1]
                      ) {
                        F = r.pop();
                        r.push(k(F, a[w + 1]));
                        w += 6;
                        break;
                      }
                      D = r[r.length - 1];
                      if ('literal' === D.type || 'var' === D.type) {
                        r.push(D);
                        break;
                      }
                      n = new c(p++, D.min, D.max);
                      r[r.length - 1] = n;
                      r.push(n);
                      E.push(new q(n, D));
                      break;
                    case 'roll':
                      if (2 > r.length) return null;
                      D = r.pop();
                      F = r.pop();
                      if ('literal' !== D.type || 'literal' !== F.type) return null;
                      D = D.number;
                      F = F.number;
                      if (0 >= F || !Number.isInteger(F) || !Number.isInteger(D) || r.length < F) return null;
                      D = ((D % F) + F) % F;
                      if (0 === D) break;
                      Array.prototype.push.apply(r, r.splice(r.length - F, F - D));
                      break;
                    default:
                      return null;
                  }
              if (r.length !== h) return null;
              var L = [];
              E.forEach(function(a) {
                var b = new x();
                a.visit(b);
                L.push(b.toString());
              });
              r.forEach(function(a, b) {
                var c = new x();
                a.visit(c);
                var d = e[2 * b],
                  f = e[2 * b + 1];
                c = [c.toString()];
                d > a.min && (c.unshift('Math.max(', d, ', '), c.push(')'));
                f < a.max && (c.unshift('Math.min(', f, ', '), c.push(')'));
                c.unshift('dest[destOffset + ', b, '] = ');
                c.push(';');
                L.push(c.join(''));
              });
              return L.join('\n');
            },
          };
          return f;
        })();
      m.isPDFFunction = function(d) {
        if ('object' !== ('undefined' === typeof d ? 'undefined' : a(d))) return !1;
        if (!(0, b.isDict)(d))
          if ((0, b.isStream)(d)) d = d.dict;
          else return !1;
        return d.has('FunctionType');
      };
      m.PDFFunction = u;
      m.PostScriptEvaluator = C;
      m.PostScriptCompiler = B;
    },
    function(y, m, t) {
      y.exports = !1;
    },
    function(y, m, t) {
      var a = t(12);
      y.exports = function(k, b) {
        if (!a(k)) return k;
        var v, d;
        if (
          (b && 'function' == typeof (v = k.toString) && !a((d = v.call(k)))) ||
          ('function' == typeof (v = k.valueOf) && !a((d = v.call(k)))) ||
          (!b && 'function' == typeof (v = k.toString) && !a((d = v.call(k))))
        )
          return d;
        throw TypeError("Can't convert object to primitive value");
      };
    },
    function(y, m, t) {
      var a = t(4),
        k = t(6),
        b = t(8),
        v = t(13)('src'),
        d = Function.toString,
        u = ('' + d).split('toString');
      t(20).inspectSource = function(a) {
        return d.call(a);
      };
      (y.exports = function(d, m, B, n) {
        var e = 'function' == typeof B;
        e && (b(B, 'name') || k(B, 'name', m));
        d[m] !== B &&
          (e && (b(B, v) || k(B, v, d[m] ? '' + d[m] : u.join(String(m)))),
          d === a ? (d[m] = B) : n ? (d[m] ? (d[m] = B) : k(d, m, B)) : (delete d[m], k(d, m, B)));
      })(Function.prototype, 'toString', function() {
        return ('function' == typeof this && this[v]) || d.call(this);
      });
    },
    function(y, m, t) {
      var a = t(40);
      y.exports = function(k, b, v) {
        a(k);
        if (void 0 === b) return k;
        switch (v) {
          case 1:
            return function(a) {
              return k.call(b, a);
            };
          case 2:
            return function(a, u) {
              return k.call(b, a, u);
            };
          case 3:
            return function(a, u, v) {
              return k.call(b, a, u, v);
            };
        }
        return function() {
          return k.apply(b, arguments);
        };
      };
    },
    function(y, m, t) {
      var a = {}.toString;
      y.exports = function(k) {
        return a.call(k).slice(8, -1);
      };
    },
    function(y, m, t) {
      var a = t(50)('keys'),
        k = t(13);
      y.exports = function(b) {
        return a[b] || (a[b] = k(b));
      };
    },
    function(y, m, t) {
      y.exports = 'constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf'.split(
        ' ',
      );
    },
    function(y, m, t) {
      var a = t(10).f,
        k = t(8),
        b = t(2)('toStringTag');
      y.exports = function(v, d, u) {
        v && !k((v = u ? v : v.prototype), b) && a(v, b, { configurable: !0, value: d });
      };
    },
    function(y, m, t) {
      t = t(0).getLookupTableFactory;
      y = t(function(a) {
        a.A = 65;
        a.AE = 198;
        a.AEacute = 508;
        a.AEmacron = 482;
        a.AEsmall = 63462;
        a.Aacute = 193;
        a.Aacutesmall = 63457;
        a.Abreve = 258;
        a.Abreveacute = 7854;
        a.Abrevecyrillic = 1232;
        a.Abrevedotbelow = 7862;
        a.Abrevegrave = 7856;
        a.Abrevehookabove = 7858;
        a.Abrevetilde = 7860;
        a.Acaron = 461;
        a.Acircle = 9398;
        a.Acircumflex = 194;
        a.Acircumflexacute = 7844;
        a.Acircumflexdotbelow = 7852;
        a.Acircumflexgrave = 7846;
        a.Acircumflexhookabove = 7848;
        a.Acircumflexsmall = 63458;
        a.Acircumflextilde = 7850;
        a.Acute = 63177;
        a.Acutesmall = 63412;
        a.Acyrillic = 1040;
        a.Adblgrave = 512;
        a.Adieresis = 196;
        a.Adieresiscyrillic = 1234;
        a.Adieresismacron = 478;
        a.Adieresissmall = 63460;
        a.Adotbelow = 7840;
        a.Adotmacron = 480;
        a.Agrave = 192;
        a.Agravesmall = 63456;
        a.Ahookabove = 7842;
        a.Aiecyrillic = 1236;
        a.Ainvertedbreve = 514;
        a.Alpha = 913;
        a.Alphatonos = 902;
        a.Amacron = 256;
        a.Amonospace = 65313;
        a.Aogonek = 260;
        a.Aring = 197;
        a.Aringacute = 506;
        a.Aringbelow = 7680;
        a.Aringsmall = 63461;
        a.Asmall = 63329;
        a.Atilde = 195;
        a.Atildesmall = 63459;
        a.Aybarmenian = 1329;
        a.B = 66;
        a.Bcircle = 9399;
        a.Bdotaccent = 7682;
        a.Bdotbelow = 7684;
        a.Becyrillic = 1041;
        a.Benarmenian = 1330;
        a.Beta = 914;
        a.Bhook = 385;
        a.Blinebelow = 7686;
        a.Bmonospace = 65314;
        a.Brevesmall = 63220;
        a.Bsmall = 63330;
        a.Btopbar = 386;
        a.C = 67;
        a.Caarmenian = 1342;
        a.Cacute = 262;
        a.Caron = 63178;
        a.Caronsmall = 63221;
        a.Ccaron = 268;
        a.Ccedilla = 199;
        a.Ccedillaacute = 7688;
        a.Ccedillasmall = 63463;
        a.Ccircle = 9400;
        a.Ccircumflex = 264;
        a.Cdot = 266;
        a.Cdotaccent = 266;
        a.Cedillasmall = 63416;
        a.Chaarmenian = 1353;
        a.Cheabkhasiancyrillic = 1212;
        a.Checyrillic = 1063;
        a.Chedescenderabkhasiancyrillic = 1214;
        a.Chedescendercyrillic = 1206;
        a.Chedieresiscyrillic = 1268;
        a.Cheharmenian = 1347;
        a.Chekhakassiancyrillic = 1227;
        a.Cheverticalstrokecyrillic = 1208;
        a.Chi = 935;
        a.Chook = 391;
        a.Circumflexsmall = 63222;
        a.Cmonospace = 65315;
        a.Coarmenian = 1361;
        a.Csmall = 63331;
        a.D = 68;
        a.DZ = 497;
        a.DZcaron = 452;
        a.Daarmenian = 1332;
        a.Dafrican = 393;
        a.Dcaron = 270;
        a.Dcedilla = 7696;
        a.Dcircle = 9401;
        a.Dcircumflexbelow = 7698;
        a.Dcroat = 272;
        a.Ddotaccent = 7690;
        a.Ddotbelow = 7692;
        a.Decyrillic = 1044;
        a.Deicoptic = 1006;
        a.Delta = 8710;
        a.Deltagreek = 916;
        a.Dhook = 394;
        a.Dieresis = 63179;
        a.DieresisAcute = 63180;
        a.DieresisGrave = 63181;
        a.Dieresissmall = 63400;
        a.Digammagreek = 988;
        a.Djecyrillic = 1026;
        a.Dlinebelow = 7694;
        a.Dmonospace = 65316;
        a.Dotaccentsmall = 63223;
        a.Dslash = 272;
        a.Dsmall = 63332;
        a.Dtopbar = 395;
        a.Dz = 498;
        a.Dzcaron = 453;
        a.Dzeabkhasiancyrillic = 1248;
        a.Dzecyrillic = 1029;
        a.Dzhecyrillic = 1039;
        a.E = 69;
        a.Eacute = 201;
        a.Eacutesmall = 63465;
        a.Ebreve = 276;
        a.Ecaron = 282;
        a.Ecedillabreve = 7708;
        a.Echarmenian = 1333;
        a.Ecircle = 9402;
        a.Ecircumflex = 202;
        a.Ecircumflexacute = 7870;
        a.Ecircumflexbelow = 7704;
        a.Ecircumflexdotbelow = 7878;
        a.Ecircumflexgrave = 7872;
        a.Ecircumflexhookabove = 7874;
        a.Ecircumflexsmall = 63466;
        a.Ecircumflextilde = 7876;
        a.Ecyrillic = 1028;
        a.Edblgrave = 516;
        a.Edieresis = 203;
        a.Edieresissmall = 63467;
        a.Edot = 278;
        a.Edotaccent = 278;
        a.Edotbelow = 7864;
        a.Efcyrillic = 1060;
        a.Egrave = 200;
        a.Egravesmall = 63464;
        a.Eharmenian = 1335;
        a.Ehookabove = 7866;
        a.Eightroman = 8551;
        a.Einvertedbreve = 518;
        a.Eiotifiedcyrillic = 1124;
        a.Elcyrillic = 1051;
        a.Elevenroman = 8554;
        a.Emacron = 274;
        a.Emacronacute = 7702;
        a.Emacrongrave = 7700;
        a.Emcyrillic = 1052;
        a.Emonospace = 65317;
        a.Encyrillic = 1053;
        a.Endescendercyrillic = 1186;
        a.Eng = 330;
        a.Enghecyrillic = 1188;
        a.Enhookcyrillic = 1223;
        a.Eogonek = 280;
        a.Eopen = 400;
        a.Epsilon = 917;
        a.Epsilontonos = 904;
        a.Ercyrillic = 1056;
        a.Ereversed = 398;
        a.Ereversedcyrillic = 1069;
        a.Escyrillic = 1057;
        a.Esdescendercyrillic = 1194;
        a.Esh = 425;
        a.Esmall = 63333;
        a.Eta = 919;
        a.Etarmenian = 1336;
        a.Etatonos = 905;
        a.Eth = 208;
        a.Ethsmall = 63472;
        a.Etilde = 7868;
        a.Etildebelow = 7706;
        a.Euro = 8364;
        a.Ezh = 439;
        a.Ezhcaron = 494;
        a.Ezhreversed = 440;
        a.F = 70;
        a.Fcircle = 9403;
        a.Fdotaccent = 7710;
        a.Feharmenian = 1366;
        a.Feicoptic = 996;
        a.Fhook = 401;
        a.Fitacyrillic = 1138;
        a.Fiveroman = 8548;
        a.Fmonospace = 65318;
        a.Fourroman = 8547;
        a.Fsmall = 63334;
        a.G = 71;
        a.GBsquare = 13191;
        a.Gacute = 500;
        a.Gamma = 915;
        a.Gammaafrican = 404;
        a.Gangiacoptic = 1002;
        a.Gbreve = 286;
        a.Gcaron = 486;
        a.Gcedilla = 290;
        a.Gcircle = 9404;
        a.Gcircumflex = 284;
        a.Gcommaaccent = 290;
        a.Gdot = 288;
        a.Gdotaccent = 288;
        a.Gecyrillic = 1043;
        a.Ghadarmenian = 1346;
        a.Ghemiddlehookcyrillic = 1172;
        a.Ghestrokecyrillic = 1170;
        a.Gheupturncyrillic = 1168;
        a.Ghook = 403;
        a.Gimarmenian = 1331;
        a.Gjecyrillic = 1027;
        a.Gmacron = 7712;
        a.Gmonospace = 65319;
        a.Grave = 63182;
        a.Gravesmall = 63328;
        a.Gsmall = 63335;
        a.Gsmallhook = 667;
        a.Gstroke = 484;
        a.H = 72;
        a.H18533 = 9679;
        a.H18543 = 9642;
        a.H18551 = 9643;
        a.H22073 = 9633;
        a.HPsquare = 13259;
        a.Haabkhasiancyrillic = 1192;
        a.Hadescendercyrillic = 1202;
        a.Hardsigncyrillic = 1066;
        a.Hbar = 294;
        a.Hbrevebelow = 7722;
        a.Hcedilla = 7720;
        a.Hcircle = 9405;
        a.Hcircumflex = 292;
        a.Hdieresis = 7718;
        a.Hdotaccent = 7714;
        a.Hdotbelow = 7716;
        a.Hmonospace = 65320;
        a.Hoarmenian = 1344;
        a.Horicoptic = 1e3;
        a.Hsmall = 63336;
        a.Hungarumlaut = 63183;
        a.Hungarumlautsmall = 63224;
        a.Hzsquare = 13200;
        a.I = 73;
        a.IAcyrillic = 1071;
        a.IJ = 306;
        a.IUcyrillic = 1070;
        a.Iacute = 205;
        a.Iacutesmall = 63469;
        a.Ibreve = 300;
        a.Icaron = 463;
        a.Icircle = 9406;
        a.Icircumflex = 206;
        a.Icircumflexsmall = 63470;
        a.Icyrillic = 1030;
        a.Idblgrave = 520;
        a.Idieresis = 207;
        a.Idieresisacute = 7726;
        a.Idieresiscyrillic = 1252;
        a.Idieresissmall = 63471;
        a.Idot = 304;
        a.Idotaccent = 304;
        a.Idotbelow = 7882;
        a.Iebrevecyrillic = 1238;
        a.Iecyrillic = 1045;
        a.Ifraktur = 8465;
        a.Igrave = 204;
        a.Igravesmall = 63468;
        a.Ihookabove = 7880;
        a.Iicyrillic = 1048;
        a.Iinvertedbreve = 522;
        a.Iishortcyrillic = 1049;
        a.Imacron = 298;
        a.Imacroncyrillic = 1250;
        a.Imonospace = 65321;
        a.Iniarmenian = 1339;
        a.Iocyrillic = 1025;
        a.Iogonek = 302;
        a.Iota = 921;
        a.Iotaafrican = 406;
        a.Iotadieresis = 938;
        a.Iotatonos = 906;
        a.Ismall = 63337;
        a.Istroke = 407;
        a.Itilde = 296;
        a.Itildebelow = 7724;
        a.Izhitsacyrillic = 1140;
        a.Izhitsadblgravecyrillic = 1142;
        a.J = 74;
        a.Jaarmenian = 1345;
        a.Jcircle = 9407;
        a.Jcircumflex = 308;
        a.Jecyrillic = 1032;
        a.Jheharmenian = 1355;
        a.Jmonospace = 65322;
        a.Jsmall = 63338;
        a.K = 75;
        a.KBsquare = 13189;
        a.KKsquare = 13261;
        a.Kabashkircyrillic = 1184;
        a.Kacute = 7728;
        a.Kacyrillic = 1050;
        a.Kadescendercyrillic = 1178;
        a.Kahookcyrillic = 1219;
        a.Kappa = 922;
        a.Kastrokecyrillic = 1182;
        a.Kaverticalstrokecyrillic = 1180;
        a.Kcaron = 488;
        a.Kcedilla = 310;
        a.Kcircle = 9408;
        a.Kcommaaccent = 310;
        a.Kdotbelow = 7730;
        a.Keharmenian = 1364;
        a.Kenarmenian = 1343;
        a.Khacyrillic = 1061;
        a.Kheicoptic = 998;
        a.Khook = 408;
        a.Kjecyrillic = 1036;
        a.Klinebelow = 7732;
        a.Kmonospace = 65323;
        a.Koppacyrillic = 1152;
        a.Koppagreek = 990;
        a.Ksicyrillic = 1134;
        a.Ksmall = 63339;
        a.L = 76;
        a.LJ = 455;
        a.LL = 63167;
        a.Lacute = 313;
        a.Lambda = 923;
        a.Lcaron = 317;
        a.Lcedilla = 315;
        a.Lcircle = 9409;
        a.Lcircumflexbelow = 7740;
        a.Lcommaaccent = 315;
        a.Ldot = 319;
        a.Ldotaccent = 319;
        a.Ldotbelow = 7734;
        a.Ldotbelowmacron = 7736;
        a.Liwnarmenian = 1340;
        a.Lj = 456;
        a.Ljecyrillic = 1033;
        a.Llinebelow = 7738;
        a.Lmonospace = 65324;
        a.Lslash = 321;
        a.Lslashsmall = 63225;
        a.Lsmall = 63340;
        a.M = 77;
        a.MBsquare = 13190;
        a.Macron = 63184;
        a.Macronsmall = 63407;
        a.Macute = 7742;
        a.Mcircle = 9410;
        a.Mdotaccent = 7744;
        a.Mdotbelow = 7746;
        a.Menarmenian = 1348;
        a.Mmonospace = 65325;
        a.Msmall = 63341;
        a.Mturned = 412;
        a.Mu = 924;
        a.N = 78;
        a.NJ = 458;
        a.Nacute = 323;
        a.Ncaron = 327;
        a.Ncedilla = 325;
        a.Ncircle = 9411;
        a.Ncircumflexbelow = 7754;
        a.Ncommaaccent = 325;
        a.Ndotaccent = 7748;
        a.Ndotbelow = 7750;
        a.Nhookleft = 413;
        a.Nineroman = 8552;
        a.Nj = 459;
        a.Njecyrillic = 1034;
        a.Nlinebelow = 7752;
        a.Nmonospace = 65326;
        a.Nowarmenian = 1350;
        a.Nsmall = 63342;
        a.Ntilde = 209;
        a.Ntildesmall = 63473;
        a.Nu = 925;
        a.O = 79;
        a.OE = 338;
        a.OEsmall = 63226;
        a.Oacute = 211;
        a.Oacutesmall = 63475;
        a.Obarredcyrillic = 1256;
        a.Obarreddieresiscyrillic = 1258;
        a.Obreve = 334;
        a.Ocaron = 465;
        a.Ocenteredtilde = 415;
        a.Ocircle = 9412;
        a.Ocircumflex = 212;
        a.Ocircumflexacute = 7888;
        a.Ocircumflexdotbelow = 7896;
        a.Ocircumflexgrave = 7890;
        a.Ocircumflexhookabove = 7892;
        a.Ocircumflexsmall = 63476;
        a.Ocircumflextilde = 7894;
        a.Ocyrillic = 1054;
        a.Odblacute = 336;
        a.Odblgrave = 524;
        a.Odieresis = 214;
        a.Odieresiscyrillic = 1254;
        a.Odieresissmall = 63478;
        a.Odotbelow = 7884;
        a.Ogoneksmall = 63227;
        a.Ograve = 210;
        a.Ogravesmall = 63474;
        a.Oharmenian = 1365;
        a.Ohm = 8486;
        a.Ohookabove = 7886;
        a.Ohorn = 416;
        a.Ohornacute = 7898;
        a.Ohorndotbelow = 7906;
        a.Ohorngrave = 7900;
        a.Ohornhookabove = 7902;
        a.Ohorntilde = 7904;
        a.Ohungarumlaut = 336;
        a.Oi = 418;
        a.Oinvertedbreve = 526;
        a.Omacron = 332;
        a.Omacronacute = 7762;
        a.Omacrongrave = 7760;
        a.Omega = 8486;
        a.Omegacyrillic = 1120;
        a.Omegagreek = 937;
        a.Omegaroundcyrillic = 1146;
        a.Omegatitlocyrillic = 1148;
        a.Omegatonos = 911;
        a.Omicron = 927;
        a.Omicrontonos = 908;
        a.Omonospace = 65327;
        a.Oneroman = 8544;
        a.Oogonek = 490;
        a.Oogonekmacron = 492;
        a.Oopen = 390;
        a.Oslash = 216;
        a.Oslashacute = 510;
        a.Oslashsmall = 63480;
        a.Osmall = 63343;
        a.Ostrokeacute = 510;
        a.Otcyrillic = 1150;
        a.Otilde = 213;
        a.Otildeacute = 7756;
        a.Otildedieresis = 7758;
        a.Otildesmall = 63477;
        a.P = 80;
        a.Pacute = 7764;
        a.Pcircle = 9413;
        a.Pdotaccent = 7766;
        a.Pecyrillic = 1055;
        a.Peharmenian = 1354;
        a.Pemiddlehookcyrillic = 1190;
        a.Phi = 934;
        a.Phook = 420;
        a.Pi = 928;
        a.Piwrarmenian = 1363;
        a.Pmonospace = 65328;
        a.Psi = 936;
        a.Psicyrillic = 1136;
        a.Psmall = 63344;
        a.Q = 81;
        a.Qcircle = 9414;
        a.Qmonospace = 65329;
        a.Qsmall = 63345;
        a.R = 82;
        a.Raarmenian = 1356;
        a.Racute = 340;
        a.Rcaron = 344;
        a.Rcedilla = 342;
        a.Rcircle = 9415;
        a.Rcommaaccent = 342;
        a.Rdblgrave = 528;
        a.Rdotaccent = 7768;
        a.Rdotbelow = 7770;
        a.Rdotbelowmacron = 7772;
        a.Reharmenian = 1360;
        a.Rfraktur = 8476;
        a.Rho = 929;
        a.Ringsmall = 63228;
        a.Rinvertedbreve = 530;
        a.Rlinebelow = 7774;
        a.Rmonospace = 65330;
        a.Rsmall = 63346;
        a.Rsmallinverted = 641;
        a.Rsmallinvertedsuperior = 694;
        a.S = 83;
        a.SF010000 = 9484;
        a.SF020000 = 9492;
        a.SF030000 = 9488;
        a.SF040000 = 9496;
        a.SF050000 = 9532;
        a.SF060000 = 9516;
        a.SF070000 = 9524;
        a.SF080000 = 9500;
        a.SF090000 = 9508;
        a.SF100000 = 9472;
        a.SF110000 = 9474;
        a.SF190000 = 9569;
        a.SF200000 = 9570;
        a.SF210000 = 9558;
        a.SF220000 = 9557;
        a.SF230000 = 9571;
        a.SF240000 = 9553;
        a.SF250000 = 9559;
        a.SF260000 = 9565;
        a.SF270000 = 9564;
        a.SF280000 = 9563;
        a.SF360000 = 9566;
        a.SF370000 = 9567;
        a.SF380000 = 9562;
        a.SF390000 = 9556;
        a.SF400000 = 9577;
        a.SF410000 = 9574;
        a.SF420000 = 9568;
        a.SF430000 = 9552;
        a.SF440000 = 9580;
        a.SF450000 = 9575;
        a.SF460000 = 9576;
        a.SF470000 = 9572;
        a.SF480000 = 9573;
        a.SF490000 = 9561;
        a.SF500000 = 9560;
        a.SF510000 = 9554;
        a.SF520000 = 9555;
        a.SF530000 = 9579;
        a.SF540000 = 9578;
        a.Sacute = 346;
        a.Sacutedotaccent = 7780;
        a.Sampigreek = 992;
        a.Scaron = 352;
        a.Scarondotaccent = 7782;
        a.Scaronsmall = 63229;
        a.Scedilla = 350;
        a.Schwa = 399;
        a.Schwacyrillic = 1240;
        a.Schwadieresiscyrillic = 1242;
        a.Scircle = 9416;
        a.Scircumflex = 348;
        a.Scommaaccent = 536;
        a.Sdotaccent = 7776;
        a.Sdotbelow = 7778;
        a.Sdotbelowdotaccent = 7784;
        a.Seharmenian = 1357;
        a.Sevenroman = 8550;
        a.Shaarmenian = 1351;
        a.Shacyrillic = 1064;
        a.Shchacyrillic = 1065;
        a.Sheicoptic = 994;
        a.Shhacyrillic = 1210;
        a.Shimacoptic = 1004;
        a.Sigma = 931;
        a.Sixroman = 8549;
        a.Smonospace = 65331;
        a.Softsigncyrillic = 1068;
        a.Ssmall = 63347;
        a.Stigmagreek = 986;
        a.T = 84;
        a.Tau = 932;
        a.Tbar = 358;
        a.Tcaron = 356;
        a.Tcedilla = 354;
        a.Tcircle = 9417;
        a.Tcircumflexbelow = 7792;
        a.Tcommaaccent = 354;
        a.Tdotaccent = 7786;
        a.Tdotbelow = 7788;
        a.Tecyrillic = 1058;
        a.Tedescendercyrillic = 1196;
        a.Tenroman = 8553;
        a.Tetsecyrillic = 1204;
        a.Theta = 920;
        a.Thook = 428;
        a.Thorn = 222;
        a.Thornsmall = 63486;
        a.Threeroman = 8546;
        a.Tildesmall = 63230;
        a.Tiwnarmenian = 1359;
        a.Tlinebelow = 7790;
        a.Tmonospace = 65332;
        a.Toarmenian = 1337;
        a.Tonefive = 444;
        a.Tonesix = 388;
        a.Tonetwo = 423;
        a.Tretroflexhook = 430;
        a.Tsecyrillic = 1062;
        a.Tshecyrillic = 1035;
        a.Tsmall = 63348;
        a.Twelveroman = 8555;
        a.Tworoman = 8545;
        a.U = 85;
        a.Uacute = 218;
        a.Uacutesmall = 63482;
        a.Ubreve = 364;
        a.Ucaron = 467;
        a.Ucircle = 9418;
        a.Ucircumflex = 219;
        a.Ucircumflexbelow = 7798;
        a.Ucircumflexsmall = 63483;
        a.Ucyrillic = 1059;
        a.Udblacute = 368;
        a.Udblgrave = 532;
        a.Udieresis = 220;
        a.Udieresisacute = 471;
        a.Udieresisbelow = 7794;
        a.Udieresiscaron = 473;
        a.Udieresiscyrillic = 1264;
        a.Udieresisgrave = 475;
        a.Udieresismacron = 469;
        a.Udieresissmall = 63484;
        a.Udotbelow = 7908;
        a.Ugrave = 217;
        a.Ugravesmall = 63481;
        a.Uhookabove = 7910;
        a.Uhorn = 431;
        a.Uhornacute = 7912;
        a.Uhorndotbelow = 7920;
        a.Uhorngrave = 7914;
        a.Uhornhookabove = 7916;
        a.Uhorntilde = 7918;
        a.Uhungarumlaut = 368;
        a.Uhungarumlautcyrillic = 1266;
        a.Uinvertedbreve = 534;
        a.Ukcyrillic = 1144;
        a.Umacron = 362;
        a.Umacroncyrillic = 1262;
        a.Umacrondieresis = 7802;
        a.Umonospace = 65333;
        a.Uogonek = 370;
        a.Upsilon = 933;
        a.Upsilon1 = 978;
        a.Upsilonacutehooksymbolgreek = 979;
        a.Upsilonafrican = 433;
        a.Upsilondieresis = 939;
        a.Upsilondieresishooksymbolgreek = 980;
        a.Upsilonhooksymbol = 978;
        a.Upsilontonos = 910;
        a.Uring = 366;
        a.Ushortcyrillic = 1038;
        a.Usmall = 63349;
        a.Ustraightcyrillic = 1198;
        a.Ustraightstrokecyrillic = 1200;
        a.Utilde = 360;
        a.Utildeacute = 7800;
        a.Utildebelow = 7796;
        a.V = 86;
        a.Vcircle = 9419;
        a.Vdotbelow = 7806;
        a.Vecyrillic = 1042;
        a.Vewarmenian = 1358;
        a.Vhook = 434;
        a.Vmonospace = 65334;
        a.Voarmenian = 1352;
        a.Vsmall = 63350;
        a.Vtilde = 7804;
        a.W = 87;
        a.Wacute = 7810;
        a.Wcircle = 9420;
        a.Wcircumflex = 372;
        a.Wdieresis = 7812;
        a.Wdotaccent = 7814;
        a.Wdotbelow = 7816;
        a.Wgrave = 7808;
        a.Wmonospace = 65335;
        a.Wsmall = 63351;
        a.X = 88;
        a.Xcircle = 9421;
        a.Xdieresis = 7820;
        a.Xdotaccent = 7818;
        a.Xeharmenian = 1341;
        a.Xi = 926;
        a.Xmonospace = 65336;
        a.Xsmall = 63352;
        a.Y = 89;
        a.Yacute = 221;
        a.Yacutesmall = 63485;
        a.Yatcyrillic = 1122;
        a.Ycircle = 9422;
        a.Ycircumflex = 374;
        a.Ydieresis = 376;
        a.Ydieresissmall = 63487;
        a.Ydotaccent = 7822;
        a.Ydotbelow = 7924;
        a.Yericyrillic = 1067;
        a.Yerudieresiscyrillic = 1272;
        a.Ygrave = 7922;
        a.Yhook = 435;
        a.Yhookabove = 7926;
        a.Yiarmenian = 1349;
        a.Yicyrillic = 1031;
        a.Yiwnarmenian = 1362;
        a.Ymonospace = 65337;
        a.Ysmall = 63353;
        a.Ytilde = 7928;
        a.Yusbigcyrillic = 1130;
        a.Yusbigiotifiedcyrillic = 1132;
        a.Yuslittlecyrillic = 1126;
        a.Yuslittleiotifiedcyrillic = 1128;
        a.Z = 90;
        a.Zaarmenian = 1334;
        a.Zacute = 377;
        a.Zcaron = 381;
        a.Zcaronsmall = 63231;
        a.Zcircle = 9423;
        a.Zcircumflex = 7824;
        a.Zdot = 379;
        a.Zdotaccent = 379;
        a.Zdotbelow = 7826;
        a.Zecyrillic = 1047;
        a.Zedescendercyrillic = 1176;
        a.Zedieresiscyrillic = 1246;
        a.Zeta = 918;
        a.Zhearmenian = 1338;
        a.Zhebrevecyrillic = 1217;
        a.Zhecyrillic = 1046;
        a.Zhedescendercyrillic = 1174;
        a.Zhedieresiscyrillic = 1244;
        a.Zlinebelow = 7828;
        a.Zmonospace = 65338;
        a.Zsmall = 63354;
        a.Zstroke = 437;
        a.a = 97;
        a.aabengali = 2438;
        a.aacute = 225;
        a.aadeva = 2310;
        a.aagujarati = 2694;
        a.aagurmukhi = 2566;
        a.aamatragurmukhi = 2622;
        a.aarusquare = 13059;
        a.aavowelsignbengali = 2494;
        a.aavowelsigndeva = 2366;
        a.aavowelsigngujarati = 2750;
        a.abbreviationmarkarmenian = 1375;
        a.abbreviationsigndeva = 2416;
        a.abengali = 2437;
        a.abopomofo = 12570;
        a.abreve = 259;
        a.abreveacute = 7855;
        a.abrevecyrillic = 1233;
        a.abrevedotbelow = 7863;
        a.abrevegrave = 7857;
        a.abrevehookabove = 7859;
        a.abrevetilde = 7861;
        a.acaron = 462;
        a.acircle = 9424;
        a.acircumflex = 226;
        a.acircumflexacute = 7845;
        a.acircumflexdotbelow = 7853;
        a.acircumflexgrave = 7847;
        a.acircumflexhookabove = 7849;
        a.acircumflextilde = 7851;
        a.acute = 180;
        a.acutebelowcmb = 791;
        a.acutecmb = 769;
        a.acutecomb = 769;
        a.acutedeva = 2388;
        a.acutelowmod = 719;
        a.acutetonecmb = 833;
        a.acyrillic = 1072;
        a.adblgrave = 513;
        a.addakgurmukhi = 2673;
        a.adeva = 2309;
        a.adieresis = 228;
        a.adieresiscyrillic = 1235;
        a.adieresismacron = 479;
        a.adotbelow = 7841;
        a.adotmacron = 481;
        a.ae = 230;
        a.aeacute = 509;
        a.aekorean = 12624;
        a.aemacron = 483;
        a.afii00208 = 8213;
        a.afii08941 = 8356;
        a.afii10017 = 1040;
        a.afii10018 = 1041;
        a.afii10019 = 1042;
        a.afii10020 = 1043;
        a.afii10021 = 1044;
        a.afii10022 = 1045;
        a.afii10023 = 1025;
        a.afii10024 = 1046;
        a.afii10025 = 1047;
        a.afii10026 = 1048;
        a.afii10027 = 1049;
        a.afii10028 = 1050;
        a.afii10029 = 1051;
        a.afii10030 = 1052;
        a.afii10031 = 1053;
        a.afii10032 = 1054;
        a.afii10033 = 1055;
        a.afii10034 = 1056;
        a.afii10035 = 1057;
        a.afii10036 = 1058;
        a.afii10037 = 1059;
        a.afii10038 = 1060;
        a.afii10039 = 1061;
        a.afii10040 = 1062;
        a.afii10041 = 1063;
        a.afii10042 = 1064;
        a.afii10043 = 1065;
        a.afii10044 = 1066;
        a.afii10045 = 1067;
        a.afii10046 = 1068;
        a.afii10047 = 1069;
        a.afii10048 = 1070;
        a.afii10049 = 1071;
        a.afii10050 = 1168;
        a.afii10051 = 1026;
        a.afii10052 = 1027;
        a.afii10053 = 1028;
        a.afii10054 = 1029;
        a.afii10055 = 1030;
        a.afii10056 = 1031;
        a.afii10057 = 1032;
        a.afii10058 = 1033;
        a.afii10059 = 1034;
        a.afii10060 = 1035;
        a.afii10061 = 1036;
        a.afii10062 = 1038;
        a.afii10063 = 63172;
        a.afii10064 = 63173;
        a.afii10065 = 1072;
        a.afii10066 = 1073;
        a.afii10067 = 1074;
        a.afii10068 = 1075;
        a.afii10069 = 1076;
        a.afii10070 = 1077;
        a.afii10071 = 1105;
        a.afii10072 = 1078;
        a.afii10073 = 1079;
        a.afii10074 = 1080;
        a.afii10075 = 1081;
        a.afii10076 = 1082;
        a.afii10077 = 1083;
        a.afii10078 = 1084;
        a.afii10079 = 1085;
        a.afii10080 = 1086;
        a.afii10081 = 1087;
        a.afii10082 = 1088;
        a.afii10083 = 1089;
        a.afii10084 = 1090;
        a.afii10085 = 1091;
        a.afii10086 = 1092;
        a.afii10087 = 1093;
        a.afii10088 = 1094;
        a.afii10089 = 1095;
        a.afii10090 = 1096;
        a.afii10091 = 1097;
        a.afii10092 = 1098;
        a.afii10093 = 1099;
        a.afii10094 = 1100;
        a.afii10095 = 1101;
        a.afii10096 = 1102;
        a.afii10097 = 1103;
        a.afii10098 = 1169;
        a.afii10099 = 1106;
        a.afii10100 = 1107;
        a.afii10101 = 1108;
        a.afii10102 = 1109;
        a.afii10103 = 1110;
        a.afii10104 = 1111;
        a.afii10105 = 1112;
        a.afii10106 = 1113;
        a.afii10107 = 1114;
        a.afii10108 = 1115;
        a.afii10109 = 1116;
        a.afii10110 = 1118;
        a.afii10145 = 1039;
        a.afii10146 = 1122;
        a.afii10147 = 1138;
        a.afii10148 = 1140;
        a.afii10192 = 63174;
        a.afii10193 = 1119;
        a.afii10194 = 1123;
        a.afii10195 = 1139;
        a.afii10196 = 1141;
        a.afii10831 = 63175;
        a.afii10832 = 63176;
        a.afii10846 = 1241;
        a.afii299 = 8206;
        a.afii300 = 8207;
        a.afii301 = 8205;
        a.afii57381 = 1642;
        a.afii57388 = 1548;
        a.afii57392 = 1632;
        a.afii57393 = 1633;
        a.afii57394 = 1634;
        a.afii57395 = 1635;
        a.afii57396 = 1636;
        a.afii57397 = 1637;
        a.afii57398 = 1638;
        a.afii57399 = 1639;
        a.afii57400 = 1640;
        a.afii57401 = 1641;
        a.afii57403 = 1563;
        a.afii57407 = 1567;
        a.afii57409 = 1569;
        a.afii57410 = 1570;
        a.afii57411 = 1571;
        a.afii57412 = 1572;
        a.afii57413 = 1573;
        a.afii57414 = 1574;
        a.afii57415 = 1575;
        a.afii57416 = 1576;
        a.afii57417 = 1577;
        a.afii57418 = 1578;
        a.afii57419 = 1579;
        a.afii57420 = 1580;
        a.afii57421 = 1581;
        a.afii57422 = 1582;
        a.afii57423 = 1583;
        a.afii57424 = 1584;
        a.afii57425 = 1585;
        a.afii57426 = 1586;
        a.afii57427 = 1587;
        a.afii57428 = 1588;
        a.afii57429 = 1589;
        a.afii57430 = 1590;
        a.afii57431 = 1591;
        a.afii57432 = 1592;
        a.afii57433 = 1593;
        a.afii57434 = 1594;
        a.afii57440 = 1600;
        a.afii57441 = 1601;
        a.afii57442 = 1602;
        a.afii57443 = 1603;
        a.afii57444 = 1604;
        a.afii57445 = 1605;
        a.afii57446 = 1606;
        a.afii57448 = 1608;
        a.afii57449 = 1609;
        a.afii57450 = 1610;
        a.afii57451 = 1611;
        a.afii57452 = 1612;
        a.afii57453 = 1613;
        a.afii57454 = 1614;
        a.afii57455 = 1615;
        a.afii57456 = 1616;
        a.afii57457 = 1617;
        a.afii57458 = 1618;
        a.afii57470 = 1607;
        a.afii57505 = 1700;
        a.afii57506 = 1662;
        a.afii57507 = 1670;
        a.afii57508 = 1688;
        a.afii57509 = 1711;
        a.afii57511 = 1657;
        a.afii57512 = 1672;
        a.afii57513 = 1681;
        a.afii57514 = 1722;
        a.afii57519 = 1746;
        a.afii57534 = 1749;
        a.afii57636 = 8362;
        a.afii57645 = 1470;
        a.afii57658 = 1475;
        a.afii57664 = 1488;
        a.afii57665 = 1489;
        a.afii57666 = 1490;
        a.afii57667 = 1491;
        a.afii57668 = 1492;
        a.afii57669 = 1493;
        a.afii57670 = 1494;
        a.afii57671 = 1495;
        a.afii57672 = 1496;
        a.afii57673 = 1497;
        a.afii57674 = 1498;
        a.afii57675 = 1499;
        a.afii57676 = 1500;
        a.afii57677 = 1501;
        a.afii57678 = 1502;
        a.afii57679 = 1503;
        a.afii57680 = 1504;
        a.afii57681 = 1505;
        a.afii57682 = 1506;
        a.afii57683 = 1507;
        a.afii57684 = 1508;
        a.afii57685 = 1509;
        a.afii57686 = 1510;
        a.afii57687 = 1511;
        a.afii57688 = 1512;
        a.afii57689 = 1513;
        a.afii57690 = 1514;
        a.afii57694 = 64298;
        a.afii57695 = 64299;
        a.afii57700 = 64331;
        a.afii57705 = 64287;
        a.afii57716 = 1520;
        a.afii57717 = 1521;
        a.afii57718 = 1522;
        a.afii57723 = 64309;
        a.afii57793 = 1460;
        a.afii57794 = 1461;
        a.afii57795 = 1462;
        a.afii57796 = 1467;
        a.afii57797 = 1464;
        a.afii57798 = 1463;
        a.afii57799 = 1456;
        a.afii57800 = 1458;
        a.afii57801 = 1457;
        a.afii57802 = 1459;
        a.afii57803 = 1474;
        a.afii57804 = 1473;
        a.afii57806 = 1465;
        a.afii57807 = 1468;
        a.afii57839 = 1469;
        a.afii57841 = 1471;
        a.afii57842 = 1472;
        a.afii57929 = 700;
        a.afii61248 = 8453;
        a.afii61289 = 8467;
        a.afii61352 = 8470;
        a.afii61573 = 8236;
        a.afii61574 = 8237;
        a.afii61575 = 8238;
        a.afii61664 = 8204;
        a.afii63167 = 1645;
        a.afii64937 = 701;
        a.agrave = 224;
        a.agujarati = 2693;
        a.agurmukhi = 2565;
        a.ahiragana = 12354;
        a.ahookabove = 7843;
        a.aibengali = 2448;
        a.aibopomofo = 12574;
        a.aideva = 2320;
        a.aiecyrillic = 1237;
        a.aigujarati = 2704;
        a.aigurmukhi = 2576;
        a.aimatragurmukhi = 2632;
        a.ainarabic = 1593;
        a.ainfinalarabic = 65226;
        a.aininitialarabic = 65227;
        a.ainmedialarabic = 65228;
        a.ainvertedbreve = 515;
        a.aivowelsignbengali = 2504;
        a.aivowelsigndeva = 2376;
        a.aivowelsigngujarati = 2760;
        a.akatakana = 12450;
        a.akatakanahalfwidth = 65393;
        a.akorean = 12623;
        a.alef = 1488;
        a.alefarabic = 1575;
        a.alefdageshhebrew = 64304;
        a.aleffinalarabic = 65166;
        a.alefhamzaabovearabic = 1571;
        a.alefhamzaabovefinalarabic = 65156;
        a.alefhamzabelowarabic = 1573;
        a.alefhamzabelowfinalarabic = 65160;
        a.alefhebrew = 1488;
        a.aleflamedhebrew = 64335;
        a.alefmaddaabovearabic = 1570;
        a.alefmaddaabovefinalarabic = 65154;
        a.alefmaksuraarabic = 1609;
        a.alefmaksurafinalarabic = 65264;
        a.alefmaksurainitialarabic = 65267;
        a.alefmaksuramedialarabic = 65268;
        a.alefpatahhebrew = 64302;
        a.alefqamatshebrew = 64303;
        a.aleph = 8501;
        a.allequal = 8780;
        a.alpha = 945;
        a.alphatonos = 940;
        a.amacron = 257;
        a.amonospace = 65345;
        a.ampersand = 38;
        a.ampersandmonospace = 65286;
        a.ampersandsmall = 63270;
        a.amsquare = 13250;
        a.anbopomofo = 12578;
        a.angbopomofo = 12580;
        a.angbracketleft = 12296;
        a.angbracketright = 12297;
        a.angkhankhuthai = 3674;
        a.angle = 8736;
        a.anglebracketleft = 12296;
        a.anglebracketleftvertical = 65087;
        a.anglebracketright = 12297;
        a.anglebracketrightvertical = 65088;
        a.angleleft = 9001;
        a.angleright = 9002;
        a.angstrom = 8491;
        a.anoteleia = 903;
        a.anudattadeva = 2386;
        a.anusvarabengali = 2434;
        a.anusvaradeva = 2306;
        a.anusvaragujarati = 2690;
        a.aogonek = 261;
        a.apaatosquare = 13056;
        a.aparen = 9372;
        a.apostrophearmenian = 1370;
        a.apostrophemod = 700;
        a.apple = 63743;
        a.approaches = 8784;
        a.approxequal = 8776;
        a.approxequalorimage = 8786;
        a.approximatelyequal = 8773;
        a.araeaekorean = 12686;
        a.araeakorean = 12685;
        a.arc = 8978;
        a.arighthalfring = 7834;
        a.aring = 229;
        a.aringacute = 507;
        a.aringbelow = 7681;
        a.arrowboth = 8596;
        a.arrowdashdown = 8675;
        a.arrowdashleft = 8672;
        a.arrowdashright = 8674;
        a.arrowdashup = 8673;
        a.arrowdblboth = 8660;
        a.arrowdbldown = 8659;
        a.arrowdblleft = 8656;
        a.arrowdblright = 8658;
        a.arrowdblup = 8657;
        a.arrowdown = 8595;
        a.arrowdownleft = 8601;
        a.arrowdownright = 8600;
        a.arrowdownwhite = 8681;
        a.arrowheaddownmod = 709;
        a.arrowheadleftmod = 706;
        a.arrowheadrightmod = 707;
        a.arrowheadupmod = 708;
        a.arrowhorizex = 63719;
        a.arrowleft = 8592;
        a.arrowleftdbl = 8656;
        a.arrowleftdblstroke = 8653;
        a.arrowleftoverright = 8646;
        a.arrowleftwhite = 8678;
        a.arrowright = 8594;
        a.arrowrightdblstroke = 8655;
        a.arrowrightheavy = 10142;
        a.arrowrightoverleft = 8644;
        a.arrowrightwhite = 8680;
        a.arrowtableft = 8676;
        a.arrowtabright = 8677;
        a.arrowup = 8593;
        a.arrowupdn = 8597;
        a.arrowupdnbse = 8616;
        a.arrowupdownbase = 8616;
        a.arrowupleft = 8598;
        a.arrowupleftofdown = 8645;
        a.arrowupright = 8599;
        a.arrowupwhite = 8679;
        a.arrowvertex = 63718;
        a.asciicircum = 94;
        a.asciicircummonospace = 65342;
        a.asciitilde = 126;
        a.asciitildemonospace = 65374;
        a.ascript = 593;
        a.ascriptturned = 594;
        a.asmallhiragana = 12353;
        a.asmallkatakana = 12449;
        a.asmallkatakanahalfwidth = 65383;
        a.asterisk = 42;
        a.asteriskaltonearabic = 1645;
        a.asteriskarabic = 1645;
        a.asteriskmath = 8727;
        a.asteriskmonospace = 65290;
        a.asterisksmall = 65121;
        a.asterism = 8258;
        a.asuperior = 63209;
        a.asymptoticallyequal = 8771;
        a.at = 64;
        a.atilde = 227;
        a.atmonospace = 65312;
        a.atsmall = 65131;
        a.aturned = 592;
        a.aubengali = 2452;
        a.aubopomofo = 12576;
        a.audeva = 2324;
        a.augujarati = 2708;
        a.augurmukhi = 2580;
        a.aulengthmarkbengali = 2519;
        a.aumatragurmukhi = 2636;
        a.auvowelsignbengali = 2508;
        a.auvowelsigndeva = 2380;
        a.auvowelsigngujarati = 2764;
        a.avagrahadeva = 2365;
        a.aybarmenian = 1377;
        a.ayin = 1506;
        a.ayinaltonehebrew = 64288;
        a.ayinhebrew = 1506;
        a.b = 98;
        a.babengali = 2476;
        a.backslash = 92;
        a.backslashmonospace = 65340;
        a.badeva = 2348;
        a.bagujarati = 2732;
        a.bagurmukhi = 2604;
        a.bahiragana = 12400;
        a.bahtthai = 3647;
        a.bakatakana = 12496;
        a.bar = 124;
        a.barmonospace = 65372;
        a.bbopomofo = 12549;
        a.bcircle = 9425;
        a.bdotaccent = 7683;
        a.bdotbelow = 7685;
        a.beamedsixteenthnotes = 9836;
        a.because = 8757;
        a.becyrillic = 1073;
        a.beharabic = 1576;
        a.behfinalarabic = 65168;
        a.behinitialarabic = 65169;
        a.behiragana = 12409;
        a.behmedialarabic = 65170;
        a.behmeeminitialarabic = 64671;
        a.behmeemisolatedarabic = 64520;
        a.behnoonfinalarabic = 64621;
        a.bekatakana = 12505;
        a.benarmenian = 1378;
        a.bet = 1489;
        a.beta = 946;
        a.betasymbolgreek = 976;
        a.betdagesh = 64305;
        a.betdageshhebrew = 64305;
        a.bethebrew = 1489;
        a.betrafehebrew = 64332;
        a.bhabengali = 2477;
        a.bhadeva = 2349;
        a.bhagujarati = 2733;
        a.bhagurmukhi = 2605;
        a.bhook = 595;
        a.bihiragana = 12403;
        a.bikatakana = 12499;
        a.bilabialclick = 664;
        a.bindigurmukhi = 2562;
        a.birusquare = 13105;
        a.blackcircle = 9679;
        a.blackdiamond = 9670;
        a.blackdownpointingtriangle = 9660;
        a.blackleftpointingpointer = 9668;
        a.blackleftpointingtriangle = 9664;
        a.blacklenticularbracketleft = 12304;
        a.blacklenticularbracketleftvertical = 65083;
        a.blacklenticularbracketright = 12305;
        a.blacklenticularbracketrightvertical = 65084;
        a.blacklowerlefttriangle = 9699;
        a.blacklowerrighttriangle = 9698;
        a.blackrectangle = 9644;
        a.blackrightpointingpointer = 9658;
        a.blackrightpointingtriangle = 9654;
        a.blacksmallsquare = 9642;
        a.blacksmilingface = 9787;
        a.blacksquare = 9632;
        a.blackstar = 9733;
        a.blackupperlefttriangle = 9700;
        a.blackupperrighttriangle = 9701;
        a.blackuppointingsmalltriangle = 9652;
        a.blackuppointingtriangle = 9650;
        a.blank = 9251;
        a.blinebelow = 7687;
        a.block = 9608;
        a.bmonospace = 65346;
        a.bobaimaithai = 3610;
        a.bohiragana = 12412;
        a.bokatakana = 12508;
        a.bparen = 9373;
        a.bqsquare = 13251;
        a.braceex = 63732;
        a.braceleft = 123;
        a.braceleftbt = 63731;
        a.braceleftmid = 63730;
        a.braceleftmonospace = 65371;
        a.braceleftsmall = 65115;
        a.bracelefttp = 63729;
        a.braceleftvertical = 65079;
        a.braceright = 125;
        a.bracerightbt = 63742;
        a.bracerightmid = 63741;
        a.bracerightmonospace = 65373;
        a.bracerightsmall = 65116;
        a.bracerighttp = 63740;
        a.bracerightvertical = 65080;
        a.bracketleft = 91;
        a.bracketleftbt = 63728;
        a.bracketleftex = 63727;
        a.bracketleftmonospace = 65339;
        a.bracketlefttp = 63726;
        a.bracketright = 93;
        a.bracketrightbt = 63739;
        a.bracketrightex = 63738;
        a.bracketrightmonospace = 65341;
        a.bracketrighttp = 63737;
        a.breve = 728;
        a.brevebelowcmb = 814;
        a.brevecmb = 774;
        a.breveinvertedbelowcmb = 815;
        a.breveinvertedcmb = 785;
        a.breveinverteddoublecmb = 865;
        a.bridgebelowcmb = 810;
        a.bridgeinvertedbelowcmb = 826;
        a.brokenbar = 166;
        a.bstroke = 384;
        a.bsuperior = 63210;
        a.btopbar = 387;
        a.buhiragana = 12406;
        a.bukatakana = 12502;
        a.bullet = 8226;
        a.bulletinverse = 9688;
        a.bulletoperator = 8729;
        a.bullseye = 9678;
        a.c = 99;
        a.caarmenian = 1390;
        a.cabengali = 2458;
        a.cacute = 263;
        a.cadeva = 2330;
        a.cagujarati = 2714;
        a.cagurmukhi = 2586;
        a.calsquare = 13192;
        a.candrabindubengali = 2433;
        a.candrabinducmb = 784;
        a.candrabindudeva = 2305;
        a.candrabindugujarati = 2689;
        a.capslock = 8682;
        a.careof = 8453;
        a.caron = 711;
        a.caronbelowcmb = 812;
        a.caroncmb = 780;
        a.carriagereturn = 8629;
        a.cbopomofo = 12568;
        a.ccaron = 269;
        a.ccedilla = 231;
        a.ccedillaacute = 7689;
        a.ccircle = 9426;
        a.ccircumflex = 265;
        a.ccurl = 597;
        a.cdot = 267;
        a.cdotaccent = 267;
        a.cdsquare = 13253;
        a.cedilla = 184;
        a.cedillacmb = 807;
        a.cent = 162;
        a.centigrade = 8451;
        a.centinferior = 63199;
        a.centmonospace = 65504;
        a.centoldstyle = 63394;
        a.centsuperior = 63200;
        a.chaarmenian = 1401;
        a.chabengali = 2459;
        a.chadeva = 2331;
        a.chagujarati = 2715;
        a.chagurmukhi = 2587;
        a.chbopomofo = 12564;
        a.cheabkhasiancyrillic = 1213;
        a.checkmark = 10003;
        a.checyrillic = 1095;
        a.chedescenderabkhasiancyrillic = 1215;
        a.chedescendercyrillic = 1207;
        a.chedieresiscyrillic = 1269;
        a.cheharmenian = 1395;
        a.chekhakassiancyrillic = 1228;
        a.cheverticalstrokecyrillic = 1209;
        a.chi = 967;
        a.chieuchacirclekorean = 12919;
        a.chieuchaparenkorean = 12823;
        a.chieuchcirclekorean = 12905;
        a.chieuchkorean = 12618;
        a.chieuchparenkorean = 12809;
        a.chochangthai = 3594;
        a.chochanthai = 3592;
        a.chochingthai = 3593;
        a.chochoethai = 3596;
        a.chook = 392;
        a.cieucacirclekorean = 12918;
        a.cieucaparenkorean = 12822;
        a.cieuccirclekorean = 12904;
        a.cieuckorean = 12616;
        a.cieucparenkorean = 12808;
        a.cieucuparenkorean = 12828;
        a.circle = 9675;
        a.circlecopyrt = 169;
        a.circlemultiply = 8855;
        a.circleot = 8857;
        a.circleplus = 8853;
        a.circlepostalmark = 12342;
        a.circlewithlefthalfblack = 9680;
        a.circlewithrighthalfblack = 9681;
        a.circumflex = 710;
        a.circumflexbelowcmb = 813;
        a.circumflexcmb = 770;
        a.clear = 8999;
        a.clickalveolar = 450;
        a.clickdental = 448;
        a.clicklateral = 449;
        a.clickretroflex = 451;
        a.club = 9827;
        a.clubsuitblack = 9827;
        a.clubsuitwhite = 9831;
        a.cmcubedsquare = 13220;
        a.cmonospace = 65347;
        a.cmsquaredsquare = 13216;
        a.coarmenian = 1409;
        a.colon = 58;
        a.colonmonetary = 8353;
        a.colonmonospace = 65306;
        a.colonsign = 8353;
        a.colonsmall = 65109;
        a.colontriangularhalfmod = 721;
        a.colontriangularmod = 720;
        a.comma = 44;
        a.commaabovecmb = 787;
        a.commaaboverightcmb = 789;
        a.commaaccent = 63171;
        a.commaarabic = 1548;
        a.commaarmenian = 1373;
        a.commainferior = 63201;
        a.commamonospace = 65292;
        a.commareversedabovecmb = 788;
        a.commareversedmod = 701;
        a.commasmall = 65104;
        a.commasuperior = 63202;
        a.commaturnedabovecmb = 786;
        a.commaturnedmod = 699;
        a.compass = 9788;
        a.congruent = 8773;
        a.contourintegral = 8750;
        a.control = 8963;
        a.controlACK = 6;
        a.controlBEL = 7;
        a.controlBS = 8;
        a.controlCAN = 24;
        a.controlCR = 13;
        a.controlDC1 = 17;
        a.controlDC2 = 18;
        a.controlDC3 = 19;
        a.controlDC4 = 20;
        a.controlDEL = 127;
        a.controlDLE = 16;
        a.controlEM = 25;
        a.controlENQ = 5;
        a.controlEOT = 4;
        a.controlESC = 27;
        a.controlETB = 23;
        a.controlETX = 3;
        a.controlFF = 12;
        a.controlFS = 28;
        a.controlGS = 29;
        a.controlHT = 9;
        a.controlLF = 10;
        a.controlNAK = 21;
        a.controlNULL = 0;
        a.controlRS = 30;
        a.controlSI = 15;
        a.controlSO = 14;
        a.controlSOT = 2;
        a.controlSTX = 1;
        a.controlSUB = 26;
        a.controlSYN = 22;
        a.controlUS = 31;
        a.controlVT = 11;
        a.copyright = 169;
        a.copyrightsans = 63721;
        a.copyrightserif = 63193;
        a.cornerbracketleft = 12300;
        a.cornerbracketlefthalfwidth = 65378;
        a.cornerbracketleftvertical = 65089;
        a.cornerbracketright = 12301;
        a.cornerbracketrighthalfwidth = 65379;
        a.cornerbracketrightvertical = 65090;
        a.corporationsquare = 13183;
        a.cosquare = 13255;
        a.coverkgsquare = 13254;
        a.cparen = 9374;
        a.cruzeiro = 8354;
        a.cstretched = 663;
        a.curlyand = 8911;
        a.curlyor = 8910;
        a.currency = 164;
        a.cyrBreve = 63185;
        a.cyrFlex = 63186;
        a.cyrbreve = 63188;
        a.cyrflex = 63189;
        a.d = 100;
        a.daarmenian = 1380;
        a.dabengali = 2470;
        a.dadarabic = 1590;
        a.dadeva = 2342;
        a.dadfinalarabic = 65214;
        a.dadinitialarabic = 65215;
        a.dadmedialarabic = 65216;
        a.dagesh = 1468;
        a.dageshhebrew = 1468;
        a.dagger = 8224;
        a.daggerdbl = 8225;
        a.dagujarati = 2726;
        a.dagurmukhi = 2598;
        a.dahiragana = 12384;
        a.dakatakana = 12480;
        a.dalarabic = 1583;
        a.dalet = 1491;
        a.daletdagesh = 64307;
        a.daletdageshhebrew = 64307;
        a.dalethebrew = 1491;
        a.dalfinalarabic = 65194;
        a.dammaarabic = 1615;
        a.dammalowarabic = 1615;
        a.dammatanaltonearabic = 1612;
        a.dammatanarabic = 1612;
        a.danda = 2404;
        a.dargahebrew = 1447;
        a.dargalefthebrew = 1447;
        a.dasiapneumatacyrilliccmb = 1157;
        a.dblGrave = 63187;
        a.dblanglebracketleft = 12298;
        a.dblanglebracketleftvertical = 65085;
        a.dblanglebracketright = 12299;
        a.dblanglebracketrightvertical = 65086;
        a.dblarchinvertedbelowcmb = 811;
        a.dblarrowleft = 8660;
        a.dblarrowright = 8658;
        a.dbldanda = 2405;
        a.dblgrave = 63190;
        a.dblgravecmb = 783;
        a.dblintegral = 8748;
        a.dbllowline = 8215;
        a.dbllowlinecmb = 819;
        a.dbloverlinecmb = 831;
        a.dblprimemod = 698;
        a.dblverticalbar = 8214;
        a.dblverticallineabovecmb = 782;
        a.dbopomofo = 12553;
        a.dbsquare = 13256;
        a.dcaron = 271;
        a.dcedilla = 7697;
        a.dcircle = 9427;
        a.dcircumflexbelow = 7699;
        a.dcroat = 273;
        a.ddabengali = 2465;
        a.ddadeva = 2337;
        a.ddagujarati = 2721;
        a.ddagurmukhi = 2593;
        a.ddalarabic = 1672;
        a.ddalfinalarabic = 64393;
        a.dddhadeva = 2396;
        a.ddhabengali = 2466;
        a.ddhadeva = 2338;
        a.ddhagujarati = 2722;
        a.ddhagurmukhi = 2594;
        a.ddotaccent = 7691;
        a.ddotbelow = 7693;
        a.decimalseparatorarabic = 1643;
        a.decimalseparatorpersian = 1643;
        a.decyrillic = 1076;
        a.degree = 176;
        a.dehihebrew = 1453;
        a.dehiragana = 12391;
        a.deicoptic = 1007;
        a.dekatakana = 12487;
        a.deleteleft = 9003;
        a.deleteright = 8998;
        a.delta = 948;
        a.deltaturned = 397;
        a.denominatorminusonenumeratorbengali = 2552;
        a.dezh = 676;
        a.dhabengali = 2471;
        a.dhadeva = 2343;
        a.dhagujarati = 2727;
        a.dhagurmukhi = 2599;
        a.dhook = 599;
        a.dialytikatonos = 901;
        a.dialytikatonoscmb = 836;
        a.diamond = 9830;
        a.diamondsuitwhite = 9826;
        a.dieresis = 168;
        a.dieresisacute = 63191;
        a.dieresisbelowcmb = 804;
        a.dieresiscmb = 776;
        a.dieresisgrave = 63192;
        a.dieresistonos = 901;
        a.dihiragana = 12386;
        a.dikatakana = 12482;
        a.dittomark = 12291;
        a.divide = 247;
        a.divides = 8739;
        a.divisionslash = 8725;
        a.djecyrillic = 1106;
        a.dkshade = 9619;
        a.dlinebelow = 7695;
        a.dlsquare = 13207;
        a.dmacron = 273;
        a.dmonospace = 65348;
        a.dnblock = 9604;
        a.dochadathai = 3598;
        a.dodekthai = 3604;
        a.dohiragana = 12393;
        a.dokatakana = 12489;
        a.dollar = 36;
        a.dollarinferior = 63203;
        a.dollarmonospace = 65284;
        a.dollaroldstyle = 63268;
        a.dollarsmall = 65129;
        a.dollarsuperior = 63204;
        a.dong = 8363;
        a.dorusquare = 13094;
        a.dotaccent = 729;
        a.dotaccentcmb = 775;
        a.dotbelowcmb = 803;
        a.dotbelowcomb = 803;
        a.dotkatakana = 12539;
        a.dotlessi = 305;
        a.dotlessj = 63166;
        a.dotlessjstrokehook = 644;
        a.dotmath = 8901;
        a.dottedcircle = 9676;
        a.doubleyodpatah = 64287;
        a.doubleyodpatahhebrew = 64287;
        a.downtackbelowcmb = 798;
        a.downtackmod = 725;
        a.dparen = 9375;
        a.dsuperior = 63211;
        a.dtail = 598;
        a.dtopbar = 396;
        a.duhiragana = 12389;
        a.dukatakana = 12485;
        a.dz = 499;
        a.dzaltone = 675;
        a.dzcaron = 454;
        a.dzcurl = 677;
        a.dzeabkhasiancyrillic = 1249;
        a.dzecyrillic = 1109;
        a.dzhecyrillic = 1119;
        a.e = 101;
        a.eacute = 233;
        a.earth = 9793;
        a.ebengali = 2447;
        a.ebopomofo = 12572;
        a.ebreve = 277;
        a.ecandradeva = 2317;
        a.ecandragujarati = 2701;
        a.ecandravowelsigndeva = 2373;
        a.ecandravowelsigngujarati = 2757;
        a.ecaron = 283;
        a.ecedillabreve = 7709;
        a.echarmenian = 1381;
        a.echyiwnarmenian = 1415;
        a.ecircle = 9428;
        a.ecircumflex = 234;
        a.ecircumflexacute = 7871;
        a.ecircumflexbelow = 7705;
        a.ecircumflexdotbelow = 7879;
        a.ecircumflexgrave = 7873;
        a.ecircumflexhookabove = 7875;
        a.ecircumflextilde = 7877;
        a.ecyrillic = 1108;
        a.edblgrave = 517;
        a.edeva = 2319;
        a.edieresis = 235;
        a.edot = 279;
        a.edotaccent = 279;
        a.edotbelow = 7865;
        a.eegurmukhi = 2575;
        a.eematragurmukhi = 2631;
        a.efcyrillic = 1092;
        a.egrave = 232;
        a.egujarati = 2703;
        a.eharmenian = 1383;
        a.ehbopomofo = 12573;
        a.ehiragana = 12360;
        a.ehookabove = 7867;
        a.eibopomofo = 12575;
        a.eight = 56;
        a.eightarabic = 1640;
        a.eightbengali = 2542;
        a.eightcircle = 9319;
        a.eightcircleinversesansserif = 10129;
        a.eightdeva = 2414;
        a.eighteencircle = 9329;
        a.eighteenparen = 9349;
        a.eighteenperiod = 9369;
        a.eightgujarati = 2798;
        a.eightgurmukhi = 2670;
        a.eighthackarabic = 1640;
        a.eighthangzhou = 12328;
        a.eighthnotebeamed = 9835;
        a.eightideographicparen = 12839;
        a.eightinferior = 8328;
        a.eightmonospace = 65304;
        a.eightoldstyle = 63288;
        a.eightparen = 9339;
        a.eightperiod = 9359;
        a.eightpersian = 1784;
        a.eightroman = 8567;
        a.eightsuperior = 8312;
        a.eightthai = 3672;
        a.einvertedbreve = 519;
        a.eiotifiedcyrillic = 1125;
        a.ekatakana = 12456;
        a.ekatakanahalfwidth = 65396;
        a.ekonkargurmukhi = 2676;
        a.ekorean = 12628;
        a.elcyrillic = 1083;
        a.element = 8712;
        a.elevencircle = 9322;
        a.elevenparen = 9342;
        a.elevenperiod = 9362;
        a.elevenroman = 8570;
        a.ellipsis = 8230;
        a.ellipsisvertical = 8942;
        a.emacron = 275;
        a.emacronacute = 7703;
        a.emacrongrave = 7701;
        a.emcyrillic = 1084;
        a.emdash = 8212;
        a.emdashvertical = 65073;
        a.emonospace = 65349;
        a.emphasismarkarmenian = 1371;
        a.emptyset = 8709;
        a.enbopomofo = 12579;
        a.encyrillic = 1085;
        a.endash = 8211;
        a.endashvertical = 65074;
        a.endescendercyrillic = 1187;
        a.eng = 331;
        a.engbopomofo = 12581;
        a.enghecyrillic = 1189;
        a.enhookcyrillic = 1224;
        a.enspace = 8194;
        a.eogonek = 281;
        a.eokorean = 12627;
        a.eopen = 603;
        a.eopenclosed = 666;
        a.eopenreversed = 604;
        a.eopenreversedclosed = 606;
        a.eopenreversedhook = 605;
        a.eparen = 9376;
        a.epsilon = 949;
        a.epsilontonos = 941;
        a.equal = 61;
        a.equalmonospace = 65309;
        a.equalsmall = 65126;
        a.equalsuperior = 8316;
        a.equivalence = 8801;
        a.erbopomofo = 12582;
        a.ercyrillic = 1088;
        a.ereversed = 600;
        a.ereversedcyrillic = 1101;
        a.escyrillic = 1089;
        a.esdescendercyrillic = 1195;
        a.esh = 643;
        a.eshcurl = 646;
        a.eshortdeva = 2318;
        a.eshortvowelsigndeva = 2374;
        a.eshreversedloop = 426;
        a.eshsquatreversed = 645;
        a.esmallhiragana = 12359;
        a.esmallkatakana = 12455;
        a.esmallkatakanahalfwidth = 65386;
        a.estimated = 8494;
        a.esuperior = 63212;
        a.eta = 951;
        a.etarmenian = 1384;
        a.etatonos = 942;
        a.eth = 240;
        a.etilde = 7869;
        a.etildebelow = 7707;
        a.etnahtafoukhhebrew = 1425;
        a.etnahtafoukhlefthebrew = 1425;
        a.etnahtahebrew = 1425;
        a.etnahtalefthebrew = 1425;
        a.eturned = 477;
        a.eukorean = 12641;
        a.euro = 8364;
        a.evowelsignbengali = 2503;
        a.evowelsigndeva = 2375;
        a.evowelsigngujarati = 2759;
        a.exclam = 33;
        a.exclamarmenian = 1372;
        a.exclamdbl = 8252;
        a.exclamdown = 161;
        a.exclamdownsmall = 63393;
        a.exclammonospace = 65281;
        a.exclamsmall = 63265;
        a.existential = 8707;
        a.ezh = 658;
        a.ezhcaron = 495;
        a.ezhcurl = 659;
        a.ezhreversed = 441;
        a.ezhtail = 442;
        a.f = 102;
        a.fadeva = 2398;
        a.fagurmukhi = 2654;
        a.fahrenheit = 8457;
        a.fathaarabic = 1614;
        a.fathalowarabic = 1614;
        a.fathatanarabic = 1611;
        a.fbopomofo = 12552;
        a.fcircle = 9429;
        a.fdotaccent = 7711;
        a.feharabic = 1601;
        a.feharmenian = 1414;
        a.fehfinalarabic = 65234;
        a.fehinitialarabic = 65235;
        a.fehmedialarabic = 65236;
        a.feicoptic = 997;
        a.female = 9792;
        a.ff = 64256;
        a.ffi = 64259;
        a.ffl = 64260;
        a.fi = 64257;
        a.fifteencircle = 9326;
        a.fifteenparen = 9346;
        a.fifteenperiod = 9366;
        a.figuredash = 8210;
        a.filledbox = 9632;
        a.filledrect = 9644;
        a.finalkaf = 1498;
        a.finalkafdagesh = 64314;
        a.finalkafdageshhebrew = 64314;
        a.finalkafhebrew = 1498;
        a.finalmem = 1501;
        a.finalmemhebrew = 1501;
        a.finalnun = 1503;
        a.finalnunhebrew = 1503;
        a.finalpe = 1507;
        a.finalpehebrew = 1507;
        a.finaltsadi = 1509;
        a.finaltsadihebrew = 1509;
        a.firsttonechinese = 713;
        a.fisheye = 9673;
        a.fitacyrillic = 1139;
        a.five = 53;
        a.fivearabic = 1637;
        a.fivebengali = 2539;
        a.fivecircle = 9316;
        a.fivecircleinversesansserif = 10126;
        a.fivedeva = 2411;
        a.fiveeighths = 8541;
        a.fivegujarati = 2795;
        a.fivegurmukhi = 2667;
        a.fivehackarabic = 1637;
        a.fivehangzhou = 12325;
        a.fiveideographicparen = 12836;
        a.fiveinferior = 8325;
        a.fivemonospace = 65301;
        a.fiveoldstyle = 63285;
        a.fiveparen = 9336;
        a.fiveperiod = 9356;
        a.fivepersian = 1781;
        a.fiveroman = 8564;
        a.fivesuperior = 8309;
        a.fivethai = 3669;
        a.fl = 64258;
        a.florin = 402;
        a.fmonospace = 65350;
        a.fmsquare = 13209;
        a.fofanthai = 3615;
        a.fofathai = 3613;
        a.fongmanthai = 3663;
        a.forall = 8704;
        a.four = 52;
        a.fourarabic = 1636;
        a.fourbengali = 2538;
        a.fourcircle = 9315;
        a.fourcircleinversesansserif = 10125;
        a.fourdeva = 2410;
        a.fourgujarati = 2794;
        a.fourgurmukhi = 2666;
        a.fourhackarabic = 1636;
        a.fourhangzhou = 12324;
        a.fourideographicparen = 12835;
        a.fourinferior = 8324;
        a.fourmonospace = 65300;
        a.fournumeratorbengali = 2551;
        a.fouroldstyle = 63284;
        a.fourparen = 9335;
        a.fourperiod = 9355;
        a.fourpersian = 1780;
        a.fourroman = 8563;
        a.foursuperior = 8308;
        a.fourteencircle = 9325;
        a.fourteenparen = 9345;
        a.fourteenperiod = 9365;
        a.fourthai = 3668;
        a.fourthtonechinese = 715;
        a.fparen = 9377;
        a.fraction = 8260;
        a.franc = 8355;
        a.g = 103;
        a.gabengali = 2455;
        a.gacute = 501;
        a.gadeva = 2327;
        a.gafarabic = 1711;
        a.gaffinalarabic = 64403;
        a.gafinitialarabic = 64404;
        a.gafmedialarabic = 64405;
        a.gagujarati = 2711;
        a.gagurmukhi = 2583;
        a.gahiragana = 12364;
        a.gakatakana = 12460;
        a.gamma = 947;
        a.gammalatinsmall = 611;
        a.gammasuperior = 736;
        a.gangiacoptic = 1003;
        a.gbopomofo = 12557;
        a.gbreve = 287;
        a.gcaron = 487;
        a.gcedilla = 291;
        a.gcircle = 9430;
        a.gcircumflex = 285;
        a.gcommaaccent = 291;
        a.gdot = 289;
        a.gdotaccent = 289;
        a.gecyrillic = 1075;
        a.gehiragana = 12370;
        a.gekatakana = 12466;
        a.geometricallyequal = 8785;
        a.gereshaccenthebrew = 1436;
        a.gereshhebrew = 1523;
        a.gereshmuqdamhebrew = 1437;
        a.germandbls = 223;
        a.gershayimaccenthebrew = 1438;
        a.gershayimhebrew = 1524;
        a.getamark = 12307;
        a.ghabengali = 2456;
        a.ghadarmenian = 1394;
        a.ghadeva = 2328;
        a.ghagujarati = 2712;
        a.ghagurmukhi = 2584;
        a.ghainarabic = 1594;
        a.ghainfinalarabic = 65230;
        a.ghaininitialarabic = 65231;
        a.ghainmedialarabic = 65232;
        a.ghemiddlehookcyrillic = 1173;
        a.ghestrokecyrillic = 1171;
        a.gheupturncyrillic = 1169;
        a.ghhadeva = 2394;
        a.ghhagurmukhi = 2650;
        a.ghook = 608;
        a.ghzsquare = 13203;
        a.gihiragana = 12366;
        a.gikatakana = 12462;
        a.gimarmenian = 1379;
        a.gimel = 1490;
        a.gimeldagesh = 64306;
        a.gimeldageshhebrew = 64306;
        a.gimelhebrew = 1490;
        a.gjecyrillic = 1107;
        a.glottalinvertedstroke = 446;
        a.glottalstop = 660;
        a.glottalstopinverted = 662;
        a.glottalstopmod = 704;
        a.glottalstopreversed = 661;
        a.glottalstopreversedmod = 705;
        a.glottalstopreversedsuperior = 740;
        a.glottalstopstroke = 673;
        a.glottalstopstrokereversed = 674;
        a.gmacron = 7713;
        a.gmonospace = 65351;
        a.gohiragana = 12372;
        a.gokatakana = 12468;
        a.gparen = 9378;
        a.gpasquare = 13228;
        a.gradient = 8711;
        a.grave = 96;
        a.gravebelowcmb = 790;
        a.gravecmb = 768;
        a.gravecomb = 768;
        a.gravedeva = 2387;
        a.gravelowmod = 718;
        a.gravemonospace = 65344;
        a.gravetonecmb = 832;
        a.greater = 62;
        a.greaterequal = 8805;
        a.greaterequalorless = 8923;
        a.greatermonospace = 65310;
        a.greaterorequivalent = 8819;
        a.greaterorless = 8823;
        a.greateroverequal = 8807;
        a.greatersmall = 65125;
        a.gscript = 609;
        a.gstroke = 485;
        a.guhiragana = 12368;
        a.guillemotleft = 171;
        a.guillemotright = 187;
        a.guilsinglleft = 8249;
        a.guilsinglright = 8250;
        a.gukatakana = 12464;
        a.guramusquare = 13080;
        a.gysquare = 13257;
        a.h = 104;
        a.haabkhasiancyrillic = 1193;
        a.haaltonearabic = 1729;
        a.habengali = 2489;
        a.hadescendercyrillic = 1203;
        a.hadeva = 2361;
        a.hagujarati = 2745;
        a.hagurmukhi = 2617;
        a.haharabic = 1581;
        a.hahfinalarabic = 65186;
        a.hahinitialarabic = 65187;
        a.hahiragana = 12399;
        a.hahmedialarabic = 65188;
        a.haitusquare = 13098;
        a.hakatakana = 12495;
        a.hakatakanahalfwidth = 65418;
        a.halantgurmukhi = 2637;
        a.hamzaarabic = 1569;
        a.hamzalowarabic = 1569;
        a.hangulfiller = 12644;
        a.hardsigncyrillic = 1098;
        a.harpoonleftbarbup = 8636;
        a.harpoonrightbarbup = 8640;
        a.hasquare = 13258;
        a.hatafpatah = 1458;
        a.hatafpatah16 = 1458;
        a.hatafpatah23 = 1458;
        a.hatafpatah2f = 1458;
        a.hatafpatahhebrew = 1458;
        a.hatafpatahnarrowhebrew = 1458;
        a.hatafpatahquarterhebrew = 1458;
        a.hatafpatahwidehebrew = 1458;
        a.hatafqamats = 1459;
        a.hatafqamats1b = 1459;
        a.hatafqamats28 = 1459;
        a.hatafqamats34 = 1459;
        a.hatafqamatshebrew = 1459;
        a.hatafqamatsnarrowhebrew = 1459;
        a.hatafqamatsquarterhebrew = 1459;
        a.hatafqamatswidehebrew = 1459;
        a.hatafsegol = 1457;
        a.hatafsegol17 = 1457;
        a.hatafsegol24 = 1457;
        a.hatafsegol30 = 1457;
        a.hatafsegolhebrew = 1457;
        a.hatafsegolnarrowhebrew = 1457;
        a.hatafsegolquarterhebrew = 1457;
        a.hatafsegolwidehebrew = 1457;
        a.hbar = 295;
        a.hbopomofo = 12559;
        a.hbrevebelow = 7723;
        a.hcedilla = 7721;
        a.hcircle = 9431;
        a.hcircumflex = 293;
        a.hdieresis = 7719;
        a.hdotaccent = 7715;
        a.hdotbelow = 7717;
        a.he = 1492;
        a.heart = 9829;
        a.heartsuitblack = 9829;
        a.heartsuitwhite = 9825;
        a.hedagesh = 64308;
        a.hedageshhebrew = 64308;
        a.hehaltonearabic = 1729;
        a.heharabic = 1607;
        a.hehebrew = 1492;
        a.hehfinalaltonearabic = 64423;
        a.hehfinalalttwoarabic = 65258;
        a.hehfinalarabic = 65258;
        a.hehhamzaabovefinalarabic = 64421;
        a.hehhamzaaboveisolatedarabic = 64420;
        a.hehinitialaltonearabic = 64424;
        a.hehinitialarabic = 65259;
        a.hehiragana = 12408;
        a.hehmedialaltonearabic = 64425;
        a.hehmedialarabic = 65260;
        a.heiseierasquare = 13179;
        a.hekatakana = 12504;
        a.hekatakanahalfwidth = 65421;
        a.hekutaarusquare = 13110;
        a.henghook = 615;
        a.herutusquare = 13113;
        a.het = 1495;
        a.hethebrew = 1495;
        a.hhook = 614;
        a.hhooksuperior = 689;
        a.hieuhacirclekorean = 12923;
        a.hieuhaparenkorean = 12827;
        a.hieuhcirclekorean = 12909;
        a.hieuhkorean = 12622;
        a.hieuhparenkorean = 12813;
        a.hihiragana = 12402;
        a.hikatakana = 12498;
        a.hikatakanahalfwidth = 65419;
        a.hiriq = 1460;
        a.hiriq14 = 1460;
        a.hiriq21 = 1460;
        a.hiriq2d = 1460;
        a.hiriqhebrew = 1460;
        a.hiriqnarrowhebrew = 1460;
        a.hiriqquarterhebrew = 1460;
        a.hiriqwidehebrew = 1460;
        a.hlinebelow = 7830;
        a.hmonospace = 65352;
        a.hoarmenian = 1392;
        a.hohipthai = 3627;
        a.hohiragana = 12411;
        a.hokatakana = 12507;
        a.hokatakanahalfwidth = 65422;
        a.holam = 1465;
        a.holam19 = 1465;
        a.holam26 = 1465;
        a.holam32 = 1465;
        a.holamhebrew = 1465;
        a.holamnarrowhebrew = 1465;
        a.holamquarterhebrew = 1465;
        a.holamwidehebrew = 1465;
        a.honokhukthai = 3630;
        a.hookabovecomb = 777;
        a.hookcmb = 777;
        a.hookpalatalizedbelowcmb = 801;
        a.hookretroflexbelowcmb = 802;
        a.hoonsquare = 13122;
        a.horicoptic = 1001;
        a.horizontalbar = 8213;
        a.horncmb = 795;
        a.hotsprings = 9832;
        a.house = 8962;
        a.hparen = 9379;
        a.hsuperior = 688;
        a.hturned = 613;
        a.huhiragana = 12405;
        a.huiitosquare = 13107;
        a.hukatakana = 12501;
        a.hukatakanahalfwidth = 65420;
        a.hungarumlaut = 733;
        a.hungarumlautcmb = 779;
        a.hv = 405;
        a.hyphen = 45;
        a.hypheninferior = 63205;
        a.hyphenmonospace = 65293;
        a.hyphensmall = 65123;
        a.hyphensuperior = 63206;
        a.hyphentwo = 8208;
        a.i = 105;
        a.iacute = 237;
        a.iacyrillic = 1103;
        a.ibengali = 2439;
        a.ibopomofo = 12583;
        a.ibreve = 301;
        a.icaron = 464;
        a.icircle = 9432;
        a.icircumflex = 238;
        a.icyrillic = 1110;
        a.idblgrave = 521;
        a.ideographearthcircle = 12943;
        a.ideographfirecircle = 12939;
        a.ideographicallianceparen = 12863;
        a.ideographiccallparen = 12858;
        a.ideographiccentrecircle = 12965;
        a.ideographicclose = 12294;
        a.ideographiccomma = 12289;
        a.ideographiccommaleft = 65380;
        a.ideographiccongratulationparen = 12855;
        a.ideographiccorrectcircle = 12963;
        a.ideographicearthparen = 12847;
        a.ideographicenterpriseparen = 12861;
        a.ideographicexcellentcircle = 12957;
        a.ideographicfestivalparen = 12864;
        a.ideographicfinancialcircle = 12950;
        a.ideographicfinancialparen = 12854;
        a.ideographicfireparen = 12843;
        a.ideographichaveparen = 12850;
        a.ideographichighcircle = 12964;
        a.ideographiciterationmark = 12293;
        a.ideographiclaborcircle = 12952;
        a.ideographiclaborparen = 12856;
        a.ideographicleftcircle = 12967;
        a.ideographiclowcircle = 12966;
        a.ideographicmedicinecircle = 12969;
        a.ideographicmetalparen = 12846;
        a.ideographicmoonparen = 12842;
        a.ideographicnameparen = 12852;
        a.ideographicperiod = 12290;
        a.ideographicprintcircle = 12958;
        a.ideographicreachparen = 12867;
        a.ideographicrepresentparen = 12857;
        a.ideographicresourceparen = 12862;
        a.ideographicrightcircle = 12968;
        a.ideographicsecretcircle = 12953;
        a.ideographicselfparen = 12866;
        a.ideographicsocietyparen = 12851;
        a.ideographicspace = 12288;
        a.ideographicspecialparen = 12853;
        a.ideographicstockparen = 12849;
        a.ideographicstudyparen = 12859;
        a.ideographicsunparen = 12848;
        a.ideographicsuperviseparen = 12860;
        a.ideographicwaterparen = 12844;
        a.ideographicwoodparen = 12845;
        a.ideographiczero = 12295;
        a.ideographmetalcircle = 12942;
        a.ideographmooncircle = 12938;
        a.ideographnamecircle = 12948;
        a.ideographsuncircle = 12944;
        a.ideographwatercircle = 12940;
        a.ideographwoodcircle = 12941;
        a.ideva = 2311;
        a.idieresis = 239;
        a.idieresisacute = 7727;
        a.idieresiscyrillic = 1253;
        a.idotbelow = 7883;
        a.iebrevecyrillic = 1239;
        a.iecyrillic = 1077;
        a.ieungacirclekorean = 12917;
        a.ieungaparenkorean = 12821;
        a.ieungcirclekorean = 12903;
        a.ieungkorean = 12615;
        a.ieungparenkorean = 12807;
        a.igrave = 236;
        a.igujarati = 2695;
        a.igurmukhi = 2567;
        a.ihiragana = 12356;
        a.ihookabove = 7881;
        a.iibengali = 2440;
        a.iicyrillic = 1080;
        a.iideva = 2312;
        a.iigujarati = 2696;
        a.iigurmukhi = 2568;
        a.iimatragurmukhi = 2624;
        a.iinvertedbreve = 523;
        a.iishortcyrillic = 1081;
        a.iivowelsignbengali = 2496;
        a.iivowelsigndeva = 2368;
        a.iivowelsigngujarati = 2752;
        a.ij = 307;
        a.ikatakana = 12452;
        a.ikatakanahalfwidth = 65394;
        a.ikorean = 12643;
        a.ilde = 732;
        a.iluyhebrew = 1452;
        a.imacron = 299;
        a.imacroncyrillic = 1251;
        a.imageorapproximatelyequal = 8787;
        a.imatragurmukhi = 2623;
        a.imonospace = 65353;
        a.increment = 8710;
        a.infinity = 8734;
        a.iniarmenian = 1387;
        a.integral = 8747;
        a.integralbottom = 8993;
        a.integralbt = 8993;
        a.integralex = 63733;
        a.integraltop = 8992;
        a.integraltp = 8992;
        a.intersection = 8745;
        a.intisquare = 13061;
        a.invbullet = 9688;
        a.invcircle = 9689;
        a.invsmileface = 9787;
        a.iocyrillic = 1105;
        a.iogonek = 303;
        a.iota = 953;
        a.iotadieresis = 970;
        a.iotadieresistonos = 912;
        a.iotalatin = 617;
        a.iotatonos = 943;
        a.iparen = 9380;
        a.irigurmukhi = 2674;
        a.ismallhiragana = 12355;
        a.ismallkatakana = 12451;
        a.ismallkatakanahalfwidth = 65384;
        a.issharbengali = 2554;
        a.istroke = 616;
        a.isuperior = 63213;
        a.iterationhiragana = 12445;
        a.iterationkatakana = 12541;
        a.itilde = 297;
        a.itildebelow = 7725;
        a.iubopomofo = 12585;
        a.iucyrillic = 1102;
        a.ivowelsignbengali = 2495;
        a.ivowelsigndeva = 2367;
        a.ivowelsigngujarati = 2751;
        a.izhitsacyrillic = 1141;
        a.izhitsadblgravecyrillic = 1143;
        a.j = 106;
        a.jaarmenian = 1393;
        a.jabengali = 2460;
        a.jadeva = 2332;
        a.jagujarati = 2716;
        a.jagurmukhi = 2588;
        a.jbopomofo = 12560;
        a.jcaron = 496;
        a.jcircle = 9433;
        a.jcircumflex = 309;
        a.jcrossedtail = 669;
        a.jdotlessstroke = 607;
        a.jecyrillic = 1112;
        a.jeemarabic = 1580;
        a.jeemfinalarabic = 65182;
        a.jeeminitialarabic = 65183;
        a.jeemmedialarabic = 65184;
        a.jeharabic = 1688;
        a.jehfinalarabic = 64395;
        a.jhabengali = 2461;
        a.jhadeva = 2333;
        a.jhagujarati = 2717;
        a.jhagurmukhi = 2589;
        a.jheharmenian = 1403;
        a.jis = 12292;
        a.jmonospace = 65354;
        a.jparen = 9381;
        a.jsuperior = 690;
        a.k = 107;
        a.kabashkircyrillic = 1185;
        a.kabengali = 2453;
        a.kacute = 7729;
        a.kacyrillic = 1082;
        a.kadescendercyrillic = 1179;
        a.kadeva = 2325;
        a.kaf = 1499;
        a.kafarabic = 1603;
        a.kafdagesh = 64315;
        a.kafdageshhebrew = 64315;
        a.kaffinalarabic = 65242;
        a.kafhebrew = 1499;
        a.kafinitialarabic = 65243;
        a.kafmedialarabic = 65244;
        a.kafrafehebrew = 64333;
        a.kagujarati = 2709;
        a.kagurmukhi = 2581;
        a.kahiragana = 12363;
        a.kahookcyrillic = 1220;
        a.kakatakana = 12459;
        a.kakatakanahalfwidth = 65398;
        a.kappa = 954;
        a.kappasymbolgreek = 1008;
        a.kapyeounmieumkorean = 12657;
        a.kapyeounphieuphkorean = 12676;
        a.kapyeounpieupkorean = 12664;
        a.kapyeounssangpieupkorean = 12665;
        a.karoriisquare = 13069;
        a.kashidaautoarabic = 1600;
        a.kashidaautonosidebearingarabic = 1600;
        a.kasmallkatakana = 12533;
        a.kasquare = 13188;
        a.kasraarabic = 1616;
        a.kasratanarabic = 1613;
        a.kastrokecyrillic = 1183;
        a.katahiraprolongmarkhalfwidth = 65392;
        a.kaverticalstrokecyrillic = 1181;
        a.kbopomofo = 12558;
        a.kcalsquare = 13193;
        a.kcaron = 489;
        a.kcedilla = 311;
        a.kcircle = 9434;
        a.kcommaaccent = 311;
        a.kdotbelow = 7731;
        a.keharmenian = 1412;
        a.kehiragana = 12369;
        a.kekatakana = 12465;
        a.kekatakanahalfwidth = 65401;
        a.kenarmenian = 1391;
        a.kesmallkatakana = 12534;
        a.kgreenlandic = 312;
        a.khabengali = 2454;
        a.khacyrillic = 1093;
        a.khadeva = 2326;
        a.khagujarati = 2710;
        a.khagurmukhi = 2582;
        a.khaharabic = 1582;
        a.khahfinalarabic = 65190;
        a.khahinitialarabic = 65191;
        a.khahmedialarabic = 65192;
        a.kheicoptic = 999;
        a.khhadeva = 2393;
        a.khhagurmukhi = 2649;
        a.khieukhacirclekorean = 12920;
        a.khieukhaparenkorean = 12824;
        a.khieukhcirclekorean = 12906;
        a.khieukhkorean = 12619;
        a.khieukhparenkorean = 12810;
        a.khokhaithai = 3586;
        a.khokhonthai = 3589;
        a.khokhuatthai = 3587;
        a.khokhwaithai = 3588;
        a.khomutthai = 3675;
        a.khook = 409;
        a.khorakhangthai = 3590;
        a.khzsquare = 13201;
        a.kihiragana = 12365;
        a.kikatakana = 12461;
        a.kikatakanahalfwidth = 65399;
        a.kiroguramusquare = 13077;
        a.kiromeetorusquare = 13078;
        a.kirosquare = 13076;
        a.kiyeokacirclekorean = 12910;
        a.kiyeokaparenkorean = 12814;
        a.kiyeokcirclekorean = 12896;
        a.kiyeokkorean = 12593;
        a.kiyeokparenkorean = 12800;
        a.kiyeoksioskorean = 12595;
        a.kjecyrillic = 1116;
        a.klinebelow = 7733;
        a.klsquare = 13208;
        a.kmcubedsquare = 13222;
        a.kmonospace = 65355;
        a.kmsquaredsquare = 13218;
        a.kohiragana = 12371;
        a.kohmsquare = 13248;
        a.kokaithai = 3585;
        a.kokatakana = 12467;
        a.kokatakanahalfwidth = 65402;
        a.kooposquare = 13086;
        a.koppacyrillic = 1153;
        a.koreanstandardsymbol = 12927;
        a.koroniscmb = 835;
        a.kparen = 9382;
        a.kpasquare = 13226;
        a.ksicyrillic = 1135;
        a.ktsquare = 13263;
        a.kturned = 670;
        a.kuhiragana = 12367;
        a.kukatakana = 12463;
        a.kukatakanahalfwidth = 65400;
        a.kvsquare = 13240;
        a.kwsquare = 13246;
        a.l = 108;
        a.labengali = 2482;
        a.lacute = 314;
        a.ladeva = 2354;
        a.lagujarati = 2738;
        a.lagurmukhi = 2610;
        a.lakkhangyaothai = 3653;
        a.lamaleffinalarabic = 65276;
        a.lamalefhamzaabovefinalarabic = 65272;
        a.lamalefhamzaaboveisolatedarabic = 65271;
        a.lamalefhamzabelowfinalarabic = 65274;
        a.lamalefhamzabelowisolatedarabic = 65273;
        a.lamalefisolatedarabic = 65275;
        a.lamalefmaddaabovefinalarabic = 65270;
        a.lamalefmaddaaboveisolatedarabic = 65269;
        a.lamarabic = 1604;
        a.lambda = 955;
        a.lambdastroke = 411;
        a.lamed = 1500;
        a.lameddagesh = 64316;
        a.lameddageshhebrew = 64316;
        a.lamedhebrew = 1500;
        a.lamfinalarabic = 65246;
        a.lamhahinitialarabic = 64714;
        a.laminitialarabic = 65247;
        a.lamjeeminitialarabic = 64713;
        a.lamkhahinitialarabic = 64715;
        a.lamlamhehisolatedarabic = 65010;
        a.lammedialarabic = 65248;
        a.lammeemhahinitialarabic = 64904;
        a.lammeeminitialarabic = 64716;
        a.largecircle = 9711;
        a.lbar = 410;
        a.lbelt = 620;
        a.lbopomofo = 12556;
        a.lcaron = 318;
        a.lcedilla = 316;
        a.lcircle = 9435;
        a.lcircumflexbelow = 7741;
        a.lcommaaccent = 316;
        a.ldot = 320;
        a.ldotaccent = 320;
        a.ldotbelow = 7735;
        a.ldotbelowmacron = 7737;
        a.leftangleabovecmb = 794;
        a.lefttackbelowcmb = 792;
        a.less = 60;
        a.lessequal = 8804;
        a.lessequalorgreater = 8922;
        a.lessmonospace = 65308;
        a.lessorequivalent = 8818;
        a.lessorgreater = 8822;
        a.lessoverequal = 8806;
        a.lesssmall = 65124;
        a.lezh = 622;
        a.lfblock = 9612;
        a.lhookretroflex = 621;
        a.lira = 8356;
        a.liwnarmenian = 1388;
        a.lj = 457;
        a.ljecyrillic = 1113;
        a.ll = 63168;
        a.lladeva = 2355;
        a.llagujarati = 2739;
        a.llinebelow = 7739;
        a.llladeva = 2356;
        a.llvocalicbengali = 2529;
        a.llvocalicdeva = 2401;
        a.llvocalicvowelsignbengali = 2531;
        a.llvocalicvowelsigndeva = 2403;
        a.lmiddletilde = 619;
        a.lmonospace = 65356;
        a.lmsquare = 13264;
        a.lochulathai = 3628;
        a.logicaland = 8743;
        a.logicalnot = 172;
        a.logicalnotreversed = 8976;
        a.logicalor = 8744;
        a.lolingthai = 3621;
        a.longs = 383;
        a.lowlinecenterline = 65102;
        a.lowlinecmb = 818;
        a.lowlinedashed = 65101;
        a.lozenge = 9674;
        a.lparen = 9383;
        a.lslash = 322;
        a.lsquare = 8467;
        a.lsuperior = 63214;
        a.ltshade = 9617;
        a.luthai = 3622;
        a.lvocalicbengali = 2444;
        a.lvocalicdeva = 2316;
        a.lvocalicvowelsignbengali = 2530;
        a.lvocalicvowelsigndeva = 2402;
        a.lxsquare = 13267;
        a.m = 109;
        a.mabengali = 2478;
        a.macron = 175;
        a.macronbelowcmb = 817;
        a.macroncmb = 772;
        a.macronlowmod = 717;
        a.macronmonospace = 65507;
        a.macute = 7743;
        a.madeva = 2350;
        a.magujarati = 2734;
        a.magurmukhi = 2606;
        a.mahapakhhebrew = 1444;
        a.mahapakhlefthebrew = 1444;
        a.mahiragana = 12414;
        a.maichattawalowleftthai = 63637;
        a.maichattawalowrightthai = 63636;
        a.maichattawathai = 3659;
        a.maichattawaupperleftthai = 63635;
        a.maieklowleftthai = 63628;
        a.maieklowrightthai = 63627;
        a.maiekthai = 3656;
        a.maiekupperleftthai = 63626;
        a.maihanakatleftthai = 63620;
        a.maihanakatthai = 3633;
        a.maitaikhuleftthai = 63625;
        a.maitaikhuthai = 3655;
        a.maitholowleftthai = 63631;
        a.maitholowrightthai = 63630;
        a.maithothai = 3657;
        a.maithoupperleftthai = 63629;
        a.maitrilowleftthai = 63634;
        a.maitrilowrightthai = 63633;
        a.maitrithai = 3658;
        a.maitriupperleftthai = 63632;
        a.maiyamokthai = 3654;
        a.makatakana = 12510;
        a.makatakanahalfwidth = 65423;
        a.male = 9794;
        a.mansyonsquare = 13127;
        a.maqafhebrew = 1470;
        a.mars = 9794;
        a.masoracirclehebrew = 1455;
        a.masquare = 13187;
        a.mbopomofo = 12551;
        a.mbsquare = 13268;
        a.mcircle = 9436;
        a.mcubedsquare = 13221;
        a.mdotaccent = 7745;
        a.mdotbelow = 7747;
        a.meemarabic = 1605;
        a.meemfinalarabic = 65250;
        a.meeminitialarabic = 65251;
        a.meemmedialarabic = 65252;
        a.meemmeeminitialarabic = 64721;
        a.meemmeemisolatedarabic = 64584;
        a.meetorusquare = 13133;
        a.mehiragana = 12417;
        a.meizierasquare = 13182;
        a.mekatakana = 12513;
        a.mekatakanahalfwidth = 65426;
        a.mem = 1502;
        a.memdagesh = 64318;
        a.memdageshhebrew = 64318;
        a.memhebrew = 1502;
        a.menarmenian = 1396;
        a.merkhahebrew = 1445;
        a.merkhakefulahebrew = 1446;
        a.merkhakefulalefthebrew = 1446;
        a.merkhalefthebrew = 1445;
        a.mhook = 625;
        a.mhzsquare = 13202;
        a.middledotkatakanahalfwidth = 65381;
        a.middot = 183;
        a.mieumacirclekorean = 12914;
        a.mieumaparenkorean = 12818;
        a.mieumcirclekorean = 12900;
        a.mieumkorean = 12609;
        a.mieumpansioskorean = 12656;
        a.mieumparenkorean = 12804;
        a.mieumpieupkorean = 12654;
        a.mieumsioskorean = 12655;
        a.mihiragana = 12415;
        a.mikatakana = 12511;
        a.mikatakanahalfwidth = 65424;
        a.minus = 8722;
        a.minusbelowcmb = 800;
        a.minuscircle = 8854;
        a.minusmod = 727;
        a.minusplus = 8723;
        a.minute = 8242;
        a.miribaarusquare = 13130;
        a.mirisquare = 13129;
        a.mlonglegturned = 624;
        a.mlsquare = 13206;
        a.mmcubedsquare = 13219;
        a.mmonospace = 65357;
        a.mmsquaredsquare = 13215;
        a.mohiragana = 12418;
        a.mohmsquare = 13249;
        a.mokatakana = 12514;
        a.mokatakanahalfwidth = 65427;
        a.molsquare = 13270;
        a.momathai = 3617;
        a.moverssquare = 13223;
        a.moverssquaredsquare = 13224;
        a.mparen = 9384;
        a.mpasquare = 13227;
        a.mssquare = 13235;
        a.msuperior = 63215;
        a.mturned = 623;
        a.mu = 181;
        a.mu1 = 181;
        a.muasquare = 13186;
        a.muchgreater = 8811;
        a.muchless = 8810;
        a.mufsquare = 13196;
        a.mugreek = 956;
        a.mugsquare = 13197;
        a.muhiragana = 12416;
        a.mukatakana = 12512;
        a.mukatakanahalfwidth = 65425;
        a.mulsquare = 13205;
        a.multiply = 215;
        a.mumsquare = 13211;
        a.munahhebrew = 1443;
        a.munahlefthebrew = 1443;
        a.musicalnote = 9834;
        a.musicalnotedbl = 9835;
        a.musicflatsign = 9837;
        a.musicsharpsign = 9839;
        a.mussquare = 13234;
        a.muvsquare = 13238;
        a.muwsquare = 13244;
        a.mvmegasquare = 13241;
        a.mvsquare = 13239;
        a.mwmegasquare = 13247;
        a.mwsquare = 13245;
        a.n = 110;
        a.nabengali = 2472;
        a.nabla = 8711;
        a.nacute = 324;
        a.nadeva = 2344;
        a.nagujarati = 2728;
        a.nagurmukhi = 2600;
        a.nahiragana = 12394;
        a.nakatakana = 12490;
        a.nakatakanahalfwidth = 65413;
        a.napostrophe = 329;
        a.nasquare = 13185;
        a.nbopomofo = 12555;
        a.nbspace = 160;
        a.ncaron = 328;
        a.ncedilla = 326;
        a.ncircle = 9437;
        a.ncircumflexbelow = 7755;
        a.ncommaaccent = 326;
        a.ndotaccent = 7749;
        a.ndotbelow = 7751;
        a.nehiragana = 12397;
        a.nekatakana = 12493;
        a.nekatakanahalfwidth = 65416;
        a.newsheqelsign = 8362;
        a.nfsquare = 13195;
        a.ngabengali = 2457;
        a.ngadeva = 2329;
        a.ngagujarati = 2713;
        a.ngagurmukhi = 2585;
        a.ngonguthai = 3591;
        a.nhiragana = 12435;
        a.nhookleft = 626;
        a.nhookretroflex = 627;
        a.nieunacirclekorean = 12911;
        a.nieunaparenkorean = 12815;
        a.nieuncieuckorean = 12597;
        a.nieuncirclekorean = 12897;
        a.nieunhieuhkorean = 12598;
        a.nieunkorean = 12596;
        a.nieunpansioskorean = 12648;
        a.nieunparenkorean = 12801;
        a.nieunsioskorean = 12647;
        a.nieuntikeutkorean = 12646;
        a.nihiragana = 12395;
        a.nikatakana = 12491;
        a.nikatakanahalfwidth = 65414;
        a.nikhahitleftthai = 63641;
        a.nikhahitthai = 3661;
        a.nine = 57;
        a.ninearabic = 1641;
        a.ninebengali = 2543;
        a.ninecircle = 9320;
        a.ninecircleinversesansserif = 10130;
        a.ninedeva = 2415;
        a.ninegujarati = 2799;
        a.ninegurmukhi = 2671;
        a.ninehackarabic = 1641;
        a.ninehangzhou = 12329;
        a.nineideographicparen = 12840;
        a.nineinferior = 8329;
        a.ninemonospace = 65305;
        a.nineoldstyle = 63289;
        a.nineparen = 9340;
        a.nineperiod = 9360;
        a.ninepersian = 1785;
        a.nineroman = 8568;
        a.ninesuperior = 8313;
        a.nineteencircle = 9330;
        a.nineteenparen = 9350;
        a.nineteenperiod = 9370;
        a.ninethai = 3673;
        a.nj = 460;
        a.njecyrillic = 1114;
        a.nkatakana = 12531;
        a.nkatakanahalfwidth = 65437;
        a.nlegrightlong = 414;
        a.nlinebelow = 7753;
        a.nmonospace = 65358;
        a.nmsquare = 13210;
        a.nnabengali = 2467;
        a.nnadeva = 2339;
        a.nnagujarati = 2723;
        a.nnagurmukhi = 2595;
        a.nnnadeva = 2345;
        a.nohiragana = 12398;
        a.nokatakana = 12494;
        a.nokatakanahalfwidth = 65417;
        a.nonbreakingspace = 160;
        a.nonenthai = 3603;
        a.nonuthai = 3609;
        a.noonarabic = 1606;
        a.noonfinalarabic = 65254;
        a.noonghunnaarabic = 1722;
        a.noonghunnafinalarabic = 64415;
        a.nooninitialarabic = 65255;
        a.noonjeeminitialarabic = 64722;
        a.noonjeemisolatedarabic = 64587;
        a.noonmedialarabic = 65256;
        a.noonmeeminitialarabic = 64725;
        a.noonmeemisolatedarabic = 64590;
        a.noonnoonfinalarabic = 64653;
        a.notcontains = 8716;
        a.notelement = 8713;
        a.notelementof = 8713;
        a.notequal = 8800;
        a.notgreater = 8815;
        a.notgreaternorequal = 8817;
        a.notgreaternorless = 8825;
        a.notidentical = 8802;
        a.notless = 8814;
        a.notlessnorequal = 8816;
        a.notparallel = 8742;
        a.notprecedes = 8832;
        a.notsubset = 8836;
        a.notsucceeds = 8833;
        a.notsuperset = 8837;
        a.nowarmenian = 1398;
        a.nparen = 9385;
        a.nssquare = 13233;
        a.nsuperior = 8319;
        a.ntilde = 241;
        a.nu = 957;
        a.nuhiragana = 12396;
        a.nukatakana = 12492;
        a.nukatakanahalfwidth = 65415;
        a.nuktabengali = 2492;
        a.nuktadeva = 2364;
        a.nuktagujarati = 2748;
        a.nuktagurmukhi = 2620;
        a.numbersign = 35;
        a.numbersignmonospace = 65283;
        a.numbersignsmall = 65119;
        a.numeralsigngreek = 884;
        a.numeralsignlowergreek = 885;
        a.numero = 8470;
        a.nun = 1504;
        a.nundagesh = 64320;
        a.nundageshhebrew = 64320;
        a.nunhebrew = 1504;
        a.nvsquare = 13237;
        a.nwsquare = 13243;
        a.nyabengali = 2462;
        a.nyadeva = 2334;
        a.nyagujarati = 2718;
        a.nyagurmukhi = 2590;
        a.o = 111;
        a.oacute = 243;
        a.oangthai = 3629;
        a.obarred = 629;
        a.obarredcyrillic = 1257;
        a.obarreddieresiscyrillic = 1259;
        a.obengali = 2451;
        a.obopomofo = 12571;
        a.obreve = 335;
        a.ocandradeva = 2321;
        a.ocandragujarati = 2705;
        a.ocandravowelsigndeva = 2377;
        a.ocandravowelsigngujarati = 2761;
        a.ocaron = 466;
        a.ocircle = 9438;
        a.ocircumflex = 244;
        a.ocircumflexacute = 7889;
        a.ocircumflexdotbelow = 7897;
        a.ocircumflexgrave = 7891;
        a.ocircumflexhookabove = 7893;
        a.ocircumflextilde = 7895;
        a.ocyrillic = 1086;
        a.odblacute = 337;
        a.odblgrave = 525;
        a.odeva = 2323;
        a.odieresis = 246;
        a.odieresiscyrillic = 1255;
        a.odotbelow = 7885;
        a.oe = 339;
        a.oekorean = 12634;
        a.ogonek = 731;
        a.ogonekcmb = 808;
        a.ograve = 242;
        a.ogujarati = 2707;
        a.oharmenian = 1413;
        a.ohiragana = 12362;
        a.ohookabove = 7887;
        a.ohorn = 417;
        a.ohornacute = 7899;
        a.ohorndotbelow = 7907;
        a.ohorngrave = 7901;
        a.ohornhookabove = 7903;
        a.ohorntilde = 7905;
        a.ohungarumlaut = 337;
        a.oi = 419;
        a.oinvertedbreve = 527;
        a.okatakana = 12458;
        a.okatakanahalfwidth = 65397;
        a.okorean = 12631;
        a.olehebrew = 1451;
        a.omacron = 333;
        a.omacronacute = 7763;
        a.omacrongrave = 7761;
        a.omdeva = 2384;
        a.omega = 969;
        a.omega1 = 982;
        a.omegacyrillic = 1121;
        a.omegalatinclosed = 631;
        a.omegaroundcyrillic = 1147;
        a.omegatitlocyrillic = 1149;
        a.omegatonos = 974;
        a.omgujarati = 2768;
        a.omicron = 959;
        a.omicrontonos = 972;
        a.omonospace = 65359;
        a.one = 49;
        a.onearabic = 1633;
        a.onebengali = 2535;
        a.onecircle = 9312;
        a.onecircleinversesansserif = 10122;
        a.onedeva = 2407;
        a.onedotenleader = 8228;
        a.oneeighth = 8539;
        a.onefitted = 63196;
        a.onegujarati = 2791;
        a.onegurmukhi = 2663;
        a.onehackarabic = 1633;
        a.onehalf = 189;
        a.onehangzhou = 12321;
        a.oneideographicparen = 12832;
        a.oneinferior = 8321;
        a.onemonospace = 65297;
        a.onenumeratorbengali = 2548;
        a.oneoldstyle = 63281;
        a.oneparen = 9332;
        a.oneperiod = 9352;
        a.onepersian = 1777;
        a.onequarter = 188;
        a.oneroman = 8560;
        a.onesuperior = 185;
        a.onethai = 3665;
        a.onethird = 8531;
        a.oogonek = 491;
        a.oogonekmacron = 493;
        a.oogurmukhi = 2579;
        a.oomatragurmukhi = 2635;
        a.oopen = 596;
        a.oparen = 9386;
        a.openbullet = 9702;
        a.option = 8997;
        a.ordfeminine = 170;
        a.ordmasculine = 186;
        a.orthogonal = 8735;
        a.oshortdeva = 2322;
        a.oshortvowelsigndeva = 2378;
        a.oslash = 248;
        a.oslashacute = 511;
        a.osmallhiragana = 12361;
        a.osmallkatakana = 12457;
        a.osmallkatakanahalfwidth = 65387;
        a.ostrokeacute = 511;
        a.osuperior = 63216;
        a.otcyrillic = 1151;
        a.otilde = 245;
        a.otildeacute = 7757;
        a.otildedieresis = 7759;
        a.oubopomofo = 12577;
        a.overline = 8254;
        a.overlinecenterline = 65098;
        a.overlinecmb = 773;
        a.overlinedashed = 65097;
        a.overlinedblwavy = 65100;
        a.overlinewavy = 65099;
        a.overscore = 175;
        a.ovowelsignbengali = 2507;
        a.ovowelsigndeva = 2379;
        a.ovowelsigngujarati = 2763;
        a.p = 112;
        a.paampssquare = 13184;
        a.paasentosquare = 13099;
        a.pabengali = 2474;
        a.pacute = 7765;
        a.padeva = 2346;
        a.pagedown = 8671;
        a.pageup = 8670;
        a.pagujarati = 2730;
        a.pagurmukhi = 2602;
        a.pahiragana = 12401;
        a.paiyannoithai = 3631;
        a.pakatakana = 12497;
        a.palatalizationcyrilliccmb = 1156;
        a.palochkacyrillic = 1216;
        a.pansioskorean = 12671;
        a.paragraph = 182;
        a.parallel = 8741;
        a.parenleft = 40;
        a.parenleftaltonearabic = 64830;
        a.parenleftbt = 63725;
        a.parenleftex = 63724;
        a.parenleftinferior = 8333;
        a.parenleftmonospace = 65288;
        a.parenleftsmall = 65113;
        a.parenleftsuperior = 8317;
        a.parenlefttp = 63723;
        a.parenleftvertical = 65077;
        a.parenright = 41;
        a.parenrightaltonearabic = 64831;
        a.parenrightbt = 63736;
        a.parenrightex = 63735;
        a.parenrightinferior = 8334;
        a.parenrightmonospace = 65289;
        a.parenrightsmall = 65114;
        a.parenrightsuperior = 8318;
        a.parenrighttp = 63734;
        a.parenrightvertical = 65078;
        a.partialdiff = 8706;
        a.paseqhebrew = 1472;
        a.pashtahebrew = 1433;
        a.pasquare = 13225;
        a.patah = 1463;
        a.patah11 = 1463;
        a.patah1d = 1463;
        a.patah2a = 1463;
        a.patahhebrew = 1463;
        a.patahnarrowhebrew = 1463;
        a.patahquarterhebrew = 1463;
        a.patahwidehebrew = 1463;
        a.pazerhebrew = 1441;
        a.pbopomofo = 12550;
        a.pcircle = 9439;
        a.pdotaccent = 7767;
        a.pe = 1508;
        a.pecyrillic = 1087;
        a.pedagesh = 64324;
        a.pedageshhebrew = 64324;
        a.peezisquare = 13115;
        a.pefinaldageshhebrew = 64323;
        a.peharabic = 1662;
        a.peharmenian = 1402;
        a.pehebrew = 1508;
        a.pehfinalarabic = 64343;
        a.pehinitialarabic = 64344;
        a.pehiragana = 12410;
        a.pehmedialarabic = 64345;
        a.pekatakana = 12506;
        a.pemiddlehookcyrillic = 1191;
        a.perafehebrew = 64334;
        a.percent = 37;
        a.percentarabic = 1642;
        a.percentmonospace = 65285;
        a.percentsmall = 65130;
        a.period = 46;
        a.periodarmenian = 1417;
        a.periodcentered = 183;
        a.periodhalfwidth = 65377;
        a.periodinferior = 63207;
        a.periodmonospace = 65294;
        a.periodsmall = 65106;
        a.periodsuperior = 63208;
        a.perispomenigreekcmb = 834;
        a.perpendicular = 8869;
        a.perthousand = 8240;
        a.peseta = 8359;
        a.pfsquare = 13194;
        a.phabengali = 2475;
        a.phadeva = 2347;
        a.phagujarati = 2731;
        a.phagurmukhi = 2603;
        a.phi = 966;
        a.phi1 = 981;
        a.phieuphacirclekorean = 12922;
        a.phieuphaparenkorean = 12826;
        a.phieuphcirclekorean = 12908;
        a.phieuphkorean = 12621;
        a.phieuphparenkorean = 12812;
        a.philatin = 632;
        a.phinthuthai = 3642;
        a.phisymbolgreek = 981;
        a.phook = 421;
        a.phophanthai = 3614;
        a.phophungthai = 3612;
        a.phosamphaothai = 3616;
        a.pi = 960;
        a.pieupacirclekorean = 12915;
        a.pieupaparenkorean = 12819;
        a.pieupcieuckorean = 12662;
        a.pieupcirclekorean = 12901;
        a.pieupkiyeokkorean = 12658;
        a.pieupkorean = 12610;
        a.pieupparenkorean = 12805;
        a.pieupsioskiyeokkorean = 12660;
        a.pieupsioskorean = 12612;
        a.pieupsiostikeutkorean = 12661;
        a.pieupthieuthkorean = 12663;
        a.pieuptikeutkorean = 12659;
        a.pihiragana = 12404;
        a.pikatakana = 12500;
        a.pisymbolgreek = 982;
        a.piwrarmenian = 1411;
        a.plus = 43;
        a.plusbelowcmb = 799;
        a.pluscircle = 8853;
        a.plusminus = 177;
        a.plusmod = 726;
        a.plusmonospace = 65291;
        a.plussmall = 65122;
        a.plussuperior = 8314;
        a.pmonospace = 65360;
        a.pmsquare = 13272;
        a.pohiragana = 12413;
        a.pointingindexdownwhite = 9759;
        a.pointingindexleftwhite = 9756;
        a.pointingindexrightwhite = 9758;
        a.pointingindexupwhite = 9757;
        a.pokatakana = 12509;
        a.poplathai = 3611;
        a.postalmark = 12306;
        a.postalmarkface = 12320;
        a.pparen = 9387;
        a.precedes = 8826;
        a.prescription = 8478;
        a.primemod = 697;
        a.primereversed = 8245;
        a.product = 8719;
        a.projective = 8965;
        a.prolongedkana = 12540;
        a.propellor = 8984;
        a.propersubset = 8834;
        a.propersuperset = 8835;
        a.proportion = 8759;
        a.proportional = 8733;
        a.psi = 968;
        a.psicyrillic = 1137;
        a.psilipneumatacyrilliccmb = 1158;
        a.pssquare = 13232;
        a.puhiragana = 12407;
        a.pukatakana = 12503;
        a.pvsquare = 13236;
        a.pwsquare = 13242;
        a.q = 113;
        a.qadeva = 2392;
        a.qadmahebrew = 1448;
        a.qafarabic = 1602;
        a.qaffinalarabic = 65238;
        a.qafinitialarabic = 65239;
        a.qafmedialarabic = 65240;
        a.qamats = 1464;
        a.qamats10 = 1464;
        a.qamats1a = 1464;
        a.qamats1c = 1464;
        a.qamats27 = 1464;
        a.qamats29 = 1464;
        a.qamats33 = 1464;
        a.qamatsde = 1464;
        a.qamatshebrew = 1464;
        a.qamatsnarrowhebrew = 1464;
        a.qamatsqatanhebrew = 1464;
        a.qamatsqatannarrowhebrew = 1464;
        a.qamatsqatanquarterhebrew = 1464;
        a.qamatsqatanwidehebrew = 1464;
        a.qamatsquarterhebrew = 1464;
        a.qamatswidehebrew = 1464;
        a.qarneyparahebrew = 1439;
        a.qbopomofo = 12561;
        a.qcircle = 9440;
        a.qhook = 672;
        a.qmonospace = 65361;
        a.qof = 1511;
        a.qofdagesh = 64327;
        a.qofdageshhebrew = 64327;
        a.qofhebrew = 1511;
        a.qparen = 9388;
        a.quarternote = 9833;
        a.qubuts = 1467;
        a.qubuts18 = 1467;
        a.qubuts25 = 1467;
        a.qubuts31 = 1467;
        a.qubutshebrew = 1467;
        a.qubutsnarrowhebrew = 1467;
        a.qubutsquarterhebrew = 1467;
        a.qubutswidehebrew = 1467;
        a.question = 63;
        a.questionarabic = 1567;
        a.questionarmenian = 1374;
        a.questiondown = 191;
        a.questiondownsmall = 63423;
        a.questiongreek = 894;
        a.questionmonospace = 65311;
        a.questionsmall = 63295;
        a.quotedbl = 34;
        a.quotedblbase = 8222;
        a.quotedblleft = 8220;
        a.quotedblmonospace = 65282;
        a.quotedblprime = 12318;
        a.quotedblprimereversed = 12317;
        a.quotedblright = 8221;
        a.quoteleft = 8216;
        a.quoteleftreversed = 8219;
        a.quotereversed = 8219;
        a.quoteright = 8217;
        a.quoterightn = 329;
        a.quotesinglbase = 8218;
        a.quotesingle = 39;
        a.quotesinglemonospace = 65287;
        a.r = 114;
        a.raarmenian = 1404;
        a.rabengali = 2480;
        a.racute = 341;
        a.radeva = 2352;
        a.radical = 8730;
        a.radicalex = 63717;
        a.radoverssquare = 13230;
        a.radoverssquaredsquare = 13231;
        a.radsquare = 13229;
        a.rafe = 1471;
        a.rafehebrew = 1471;
        a.ragujarati = 2736;
        a.ragurmukhi = 2608;
        a.rahiragana = 12425;
        a.rakatakana = 12521;
        a.rakatakanahalfwidth = 65431;
        a.ralowerdiagonalbengali = 2545;
        a.ramiddlediagonalbengali = 2544;
        a.ramshorn = 612;
        a.ratio = 8758;
        a.rbopomofo = 12566;
        a.rcaron = 345;
        a.rcedilla = 343;
        a.rcircle = 9441;
        a.rcommaaccent = 343;
        a.rdblgrave = 529;
        a.rdotaccent = 7769;
        a.rdotbelow = 7771;
        a.rdotbelowmacron = 7773;
        a.referencemark = 8251;
        a.reflexsubset = 8838;
        a.reflexsuperset = 8839;
        a.registered = 174;
        a.registersans = 63720;
        a.registerserif = 63194;
        a.reharabic = 1585;
        a.reharmenian = 1408;
        a.rehfinalarabic = 65198;
        a.rehiragana = 12428;
        a.rekatakana = 12524;
        a.rekatakanahalfwidth = 65434;
        a.resh = 1512;
        a.reshdageshhebrew = 64328;
        a.reshhebrew = 1512;
        a.reversedtilde = 8765;
        a.reviahebrew = 1431;
        a.reviamugrashhebrew = 1431;
        a.revlogicalnot = 8976;
        a.rfishhook = 638;
        a.rfishhookreversed = 639;
        a.rhabengali = 2525;
        a.rhadeva = 2397;
        a.rho = 961;
        a.rhook = 637;
        a.rhookturned = 635;
        a.rhookturnedsuperior = 693;
        a.rhosymbolgreek = 1009;
        a.rhotichookmod = 734;
        a.rieulacirclekorean = 12913;
        a.rieulaparenkorean = 12817;
        a.rieulcirclekorean = 12899;
        a.rieulhieuhkorean = 12608;
        a.rieulkiyeokkorean = 12602;
        a.rieulkiyeoksioskorean = 12649;
        a.rieulkorean = 12601;
        a.rieulmieumkorean = 12603;
        a.rieulpansioskorean = 12652;
        a.rieulparenkorean = 12803;
        a.rieulphieuphkorean = 12607;
        a.rieulpieupkorean = 12604;
        a.rieulpieupsioskorean = 12651;
        a.rieulsioskorean = 12605;
        a.rieulthieuthkorean = 12606;
        a.rieultikeutkorean = 12650;
        a.rieulyeorinhieuhkorean = 12653;
        a.rightangle = 8735;
        a.righttackbelowcmb = 793;
        a.righttriangle = 8895;
        a.rihiragana = 12426;
        a.rikatakana = 12522;
        a.rikatakanahalfwidth = 65432;
        a.ring = 730;
        a.ringbelowcmb = 805;
        a.ringcmb = 778;
        a.ringhalfleft = 703;
        a.ringhalfleftarmenian = 1369;
        a.ringhalfleftbelowcmb = 796;
        a.ringhalfleftcentered = 723;
        a.ringhalfright = 702;
        a.ringhalfrightbelowcmb = 825;
        a.ringhalfrightcentered = 722;
        a.rinvertedbreve = 531;
        a.rittorusquare = 13137;
        a.rlinebelow = 7775;
        a.rlongleg = 636;
        a.rlonglegturned = 634;
        a.rmonospace = 65362;
        a.rohiragana = 12429;
        a.rokatakana = 12525;
        a.rokatakanahalfwidth = 65435;
        a.roruathai = 3619;
        a.rparen = 9389;
        a.rrabengali = 2524;
        a.rradeva = 2353;
        a.rragurmukhi = 2652;
        a.rreharabic = 1681;
        a.rrehfinalarabic = 64397;
        a.rrvocalicbengali = 2528;
        a.rrvocalicdeva = 2400;
        a.rrvocalicgujarati = 2784;
        a.rrvocalicvowelsignbengali = 2500;
        a.rrvocalicvowelsigndeva = 2372;
        a.rrvocalicvowelsigngujarati = 2756;
        a.rsuperior = 63217;
        a.rtblock = 9616;
        a.rturned = 633;
        a.rturnedsuperior = 692;
        a.ruhiragana = 12427;
        a.rukatakana = 12523;
        a.rukatakanahalfwidth = 65433;
        a.rupeemarkbengali = 2546;
        a.rupeesignbengali = 2547;
        a.rupiah = 63197;
        a.ruthai = 3620;
        a.rvocalicbengali = 2443;
        a.rvocalicdeva = 2315;
        a.rvocalicgujarati = 2699;
        a.rvocalicvowelsignbengali = 2499;
        a.rvocalicvowelsigndeva = 2371;
        a.rvocalicvowelsigngujarati = 2755;
        a.s = 115;
        a.sabengali = 2488;
        a.sacute = 347;
        a.sacutedotaccent = 7781;
        a.sadarabic = 1589;
        a.sadeva = 2360;
        a.sadfinalarabic = 65210;
        a.sadinitialarabic = 65211;
        a.sadmedialarabic = 65212;
        a.sagujarati = 2744;
        a.sagurmukhi = 2616;
        a.sahiragana = 12373;
        a.sakatakana = 12469;
        a.sakatakanahalfwidth = 65403;
        a.sallallahoualayhewasallamarabic = 65018;
        a.samekh = 1505;
        a.samekhdagesh = 64321;
        a.samekhdageshhebrew = 64321;
        a.samekhhebrew = 1505;
        a.saraaathai = 3634;
        a.saraaethai = 3649;
        a.saraaimaimalaithai = 3652;
        a.saraaimaimuanthai = 3651;
        a.saraamthai = 3635;
        a.saraathai = 3632;
        a.saraethai = 3648;
        a.saraiileftthai = 63622;
        a.saraiithai = 3637;
        a.saraileftthai = 63621;
        a.saraithai = 3636;
        a.saraothai = 3650;
        a.saraueeleftthai = 63624;
        a.saraueethai = 3639;
        a.saraueleftthai = 63623;
        a.sarauethai = 3638;
        a.sarauthai = 3640;
        a.sarauuthai = 3641;
        a.sbopomofo = 12569;
        a.scaron = 353;
        a.scarondotaccent = 7783;
        a.scedilla = 351;
        a.schwa = 601;
        a.schwacyrillic = 1241;
        a.schwadieresiscyrillic = 1243;
        a.schwahook = 602;
        a.scircle = 9442;
        a.scircumflex = 349;
        a.scommaaccent = 537;
        a.sdotaccent = 7777;
        a.sdotbelow = 7779;
        a.sdotbelowdotaccent = 7785;
        a.seagullbelowcmb = 828;
        a.second = 8243;
        a.secondtonechinese = 714;
        a.section = 167;
        a.seenarabic = 1587;
        a.seenfinalarabic = 65202;
        a.seeninitialarabic = 65203;
        a.seenmedialarabic = 65204;
        a.segol = 1462;
        a.segol13 = 1462;
        a.segol1f = 1462;
        a.segol2c = 1462;
        a.segolhebrew = 1462;
        a.segolnarrowhebrew = 1462;
        a.segolquarterhebrew = 1462;
        a.segoltahebrew = 1426;
        a.segolwidehebrew = 1462;
        a.seharmenian = 1405;
        a.sehiragana = 12379;
        a.sekatakana = 12475;
        a.sekatakanahalfwidth = 65406;
        a.semicolon = 59;
        a.semicolonarabic = 1563;
        a.semicolonmonospace = 65307;
        a.semicolonsmall = 65108;
        a.semivoicedmarkkana = 12444;
        a.semivoicedmarkkanahalfwidth = 65439;
        a.sentisquare = 13090;
        a.sentosquare = 13091;
        a.seven = 55;
        a.sevenarabic = 1639;
        a.sevenbengali = 2541;
        a.sevencircle = 9318;
        a.sevencircleinversesansserif = 10128;
        a.sevendeva = 2413;
        a.seveneighths = 8542;
        a.sevengujarati = 2797;
        a.sevengurmukhi = 2669;
        a.sevenhackarabic = 1639;
        a.sevenhangzhou = 12327;
        a.sevenideographicparen = 12838;
        a.seveninferior = 8327;
        a.sevenmonospace = 65303;
        a.sevenoldstyle = 63287;
        a.sevenparen = 9338;
        a.sevenperiod = 9358;
        a.sevenpersian = 1783;
        a.sevenroman = 8566;
        a.sevensuperior = 8311;
        a.seventeencircle = 9328;
        a.seventeenparen = 9348;
        a.seventeenperiod = 9368;
        a.seventhai = 3671;
        a.sfthyphen = 173;
        a.shaarmenian = 1399;
        a.shabengali = 2486;
        a.shacyrillic = 1096;
        a.shaddaarabic = 1617;
        a.shaddadammaarabic = 64609;
        a.shaddadammatanarabic = 64606;
        a.shaddafathaarabic = 64608;
        a.shaddakasraarabic = 64610;
        a.shaddakasratanarabic = 64607;
        a.shade = 9618;
        a.shadedark = 9619;
        a.shadelight = 9617;
        a.shademedium = 9618;
        a.shadeva = 2358;
        a.shagujarati = 2742;
        a.shagurmukhi = 2614;
        a.shalshelethebrew = 1427;
        a.shbopomofo = 12565;
        a.shchacyrillic = 1097;
        a.sheenarabic = 1588;
        a.sheenfinalarabic = 65206;
        a.sheeninitialarabic = 65207;
        a.sheenmedialarabic = 65208;
        a.sheicoptic = 995;
        a.sheqel = 8362;
        a.sheqelhebrew = 8362;
        a.sheva = 1456;
        a.sheva115 = 1456;
        a.sheva15 = 1456;
        a.sheva22 = 1456;
        a.sheva2e = 1456;
        a.shevahebrew = 1456;
        a.shevanarrowhebrew = 1456;
        a.shevaquarterhebrew = 1456;
        a.shevawidehebrew = 1456;
        a.shhacyrillic = 1211;
        a.shimacoptic = 1005;
        a.shin = 1513;
        a.shindagesh = 64329;
        a.shindageshhebrew = 64329;
        a.shindageshshindot = 64300;
        a.shindageshshindothebrew = 64300;
        a.shindageshsindot = 64301;
        a.shindageshsindothebrew = 64301;
        a.shindothebrew = 1473;
        a.shinhebrew = 1513;
        a.shinshindot = 64298;
        a.shinshindothebrew = 64298;
        a.shinsindot = 64299;
        a.shinsindothebrew = 64299;
        a.shook = 642;
        a.sigma = 963;
        a.sigma1 = 962;
        a.sigmafinal = 962;
        a.sigmalunatesymbolgreek = 1010;
        a.sihiragana = 12375;
        a.sikatakana = 12471;
        a.sikatakanahalfwidth = 65404;
        a.siluqhebrew = 1469;
        a.siluqlefthebrew = 1469;
        a.similar = 8764;
        a.sindothebrew = 1474;
        a.siosacirclekorean = 12916;
        a.siosaparenkorean = 12820;
        a.sioscieuckorean = 12670;
        a.sioscirclekorean = 12902;
        a.sioskiyeokkorean = 12666;
        a.sioskorean = 12613;
        a.siosnieunkorean = 12667;
        a.siosparenkorean = 12806;
        a.siospieupkorean = 12669;
        a.siostikeutkorean = 12668;
        a.six = 54;
        a.sixarabic = 1638;
        a.sixbengali = 2540;
        a.sixcircle = 9317;
        a.sixcircleinversesansserif = 10127;
        a.sixdeva = 2412;
        a.sixgujarati = 2796;
        a.sixgurmukhi = 2668;
        a.sixhackarabic = 1638;
        a.sixhangzhou = 12326;
        a.sixideographicparen = 12837;
        a.sixinferior = 8326;
        a.sixmonospace = 65302;
        a.sixoldstyle = 63286;
        a.sixparen = 9337;
        a.sixperiod = 9357;
        a.sixpersian = 1782;
        a.sixroman = 8565;
        a.sixsuperior = 8310;
        a.sixteencircle = 9327;
        a.sixteencurrencydenominatorbengali = 2553;
        a.sixteenparen = 9347;
        a.sixteenperiod = 9367;
        a.sixthai = 3670;
        a.slash = 47;
        a.slashmonospace = 65295;
        a.slong = 383;
        a.slongdotaccent = 7835;
        a.smileface = 9786;
        a.smonospace = 65363;
        a.sofpasuqhebrew = 1475;
        a.softhyphen = 173;
        a.softsigncyrillic = 1100;
        a.sohiragana = 12381;
        a.sokatakana = 12477;
        a.sokatakanahalfwidth = 65407;
        a.soliduslongoverlaycmb = 824;
        a.solidusshortoverlaycmb = 823;
        a.sorusithai = 3625;
        a.sosalathai = 3624;
        a.sosothai = 3595;
        a.sosuathai = 3626;
        a.space = 32;
        a.spacehackarabic = 32;
        a.spade = 9824;
        a.spadesuitblack = 9824;
        a.spadesuitwhite = 9828;
        a.sparen = 9390;
        a.squarebelowcmb = 827;
        a.squarecc = 13252;
        a.squarecm = 13213;
        a.squarediagonalcrosshatchfill = 9641;
        a.squarehorizontalfill = 9636;
        a.squarekg = 13199;
        a.squarekm = 13214;
        a.squarekmcapital = 13262;
        a.squareln = 13265;
        a.squarelog = 13266;
        a.squaremg = 13198;
        a.squaremil = 13269;
        a.squaremm = 13212;
        a.squaremsquared = 13217;
        a.squareorthogonalcrosshatchfill = 9638;
        a.squareupperlefttolowerrightfill = 9639;
        a.squareupperrighttolowerleftfill = 9640;
        a.squareverticalfill = 9637;
        a.squarewhitewithsmallblack = 9635;
        a.srsquare = 13275;
        a.ssabengali = 2487;
        a.ssadeva = 2359;
        a.ssagujarati = 2743;
        a.ssangcieuckorean = 12617;
        a.ssanghieuhkorean = 12677;
        a.ssangieungkorean = 12672;
        a.ssangkiyeokkorean = 12594;
        a.ssangnieunkorean = 12645;
        a.ssangpieupkorean = 12611;
        a.ssangsioskorean = 12614;
        a.ssangtikeutkorean = 12600;
        a.ssuperior = 63218;
        a.sterling = 163;
        a.sterlingmonospace = 65505;
        a.strokelongoverlaycmb = 822;
        a.strokeshortoverlaycmb = 821;
        a.subset = 8834;
        a.subsetnotequal = 8842;
        a.subsetorequal = 8838;
        a.succeeds = 8827;
        a.suchthat = 8715;
        a.suhiragana = 12377;
        a.sukatakana = 12473;
        a.sukatakanahalfwidth = 65405;
        a.sukunarabic = 1618;
        a.summation = 8721;
        a.sun = 9788;
        a.superset = 8835;
        a.supersetnotequal = 8843;
        a.supersetorequal = 8839;
        a.svsquare = 13276;
        a.syouwaerasquare = 13180;
        a.t = 116;
        a.tabengali = 2468;
        a.tackdown = 8868;
        a.tackleft = 8867;
        a.tadeva = 2340;
        a.tagujarati = 2724;
        a.tagurmukhi = 2596;
        a.taharabic = 1591;
        a.tahfinalarabic = 65218;
        a.tahinitialarabic = 65219;
        a.tahiragana = 12383;
        a.tahmedialarabic = 65220;
        a.taisyouerasquare = 13181;
        a.takatakana = 12479;
        a.takatakanahalfwidth = 65408;
        a.tatweelarabic = 1600;
        a.tau = 964;
        a.tav = 1514;
        a.tavdages = 64330;
        a.tavdagesh = 64330;
        a.tavdageshhebrew = 64330;
        a.tavhebrew = 1514;
        a.tbar = 359;
        a.tbopomofo = 12554;
        a.tcaron = 357;
        a.tccurl = 680;
        a.tcedilla = 355;
        a.tcheharabic = 1670;
        a.tchehfinalarabic = 64379;
        a.tchehinitialarabic = 64380;
        a.tchehmedialarabic = 64381;
        a.tcircle = 9443;
        a.tcircumflexbelow = 7793;
        a.tcommaaccent = 355;
        a.tdieresis = 7831;
        a.tdotaccent = 7787;
        a.tdotbelow = 7789;
        a.tecyrillic = 1090;
        a.tedescendercyrillic = 1197;
        a.teharabic = 1578;
        a.tehfinalarabic = 65174;
        a.tehhahinitialarabic = 64674;
        a.tehhahisolatedarabic = 64524;
        a.tehinitialarabic = 65175;
        a.tehiragana = 12390;
        a.tehjeeminitialarabic = 64673;
        a.tehjeemisolatedarabic = 64523;
        a.tehmarbutaarabic = 1577;
        a.tehmarbutafinalarabic = 65172;
        a.tehmedialarabic = 65176;
        a.tehmeeminitialarabic = 64676;
        a.tehmeemisolatedarabic = 64526;
        a.tehnoonfinalarabic = 64627;
        a.tekatakana = 12486;
        a.tekatakanahalfwidth = 65411;
        a.telephone = 8481;
        a.telephoneblack = 9742;
        a.telishagedolahebrew = 1440;
        a.telishaqetanahebrew = 1449;
        a.tencircle = 9321;
        a.tenideographicparen = 12841;
        a.tenparen = 9341;
        a.tenperiod = 9361;
        a.tenroman = 8569;
        a.tesh = 679;
        a.tet = 1496;
        a.tetdagesh = 64312;
        a.tetdageshhebrew = 64312;
        a.tethebrew = 1496;
        a.tetsecyrillic = 1205;
        a.tevirhebrew = 1435;
        a.tevirlefthebrew = 1435;
        a.thabengali = 2469;
        a.thadeva = 2341;
        a.thagujarati = 2725;
        a.thagurmukhi = 2597;
        a.thalarabic = 1584;
        a.thalfinalarabic = 65196;
        a.thanthakhatlowleftthai = 63640;
        a.thanthakhatlowrightthai = 63639;
        a.thanthakhatthai = 3660;
        a.thanthakhatupperleftthai = 63638;
        a.theharabic = 1579;
        a.thehfinalarabic = 65178;
        a.thehinitialarabic = 65179;
        a.thehmedialarabic = 65180;
        a.thereexists = 8707;
        a.therefore = 8756;
        a.theta = 952;
        a.theta1 = 977;
        a.thetasymbolgreek = 977;
        a.thieuthacirclekorean = 12921;
        a.thieuthaparenkorean = 12825;
        a.thieuthcirclekorean = 12907;
        a.thieuthkorean = 12620;
        a.thieuthparenkorean = 12811;
        a.thirteencircle = 9324;
        a.thirteenparen = 9344;
        a.thirteenperiod = 9364;
        a.thonangmonthothai = 3601;
        a.thook = 429;
        a.thophuthaothai = 3602;
        a.thorn = 254;
        a.thothahanthai = 3607;
        a.thothanthai = 3600;
        a.thothongthai = 3608;
        a.thothungthai = 3606;
        a.thousandcyrillic = 1154;
        a.thousandsseparatorarabic = 1644;
        a.thousandsseparatorpersian = 1644;
        a.three = 51;
        a.threearabic = 1635;
        a.threebengali = 2537;
        a.threecircle = 9314;
        a.threecircleinversesansserif = 10124;
        a.threedeva = 2409;
        a.threeeighths = 8540;
        a.threegujarati = 2793;
        a.threegurmukhi = 2665;
        a.threehackarabic = 1635;
        a.threehangzhou = 12323;
        a.threeideographicparen = 12834;
        a.threeinferior = 8323;
        a.threemonospace = 65299;
        a.threenumeratorbengali = 2550;
        a.threeoldstyle = 63283;
        a.threeparen = 9334;
        a.threeperiod = 9354;
        a.threepersian = 1779;
        a.threequarters = 190;
        a.threequartersemdash = 63198;
        a.threeroman = 8562;
        a.threesuperior = 179;
        a.threethai = 3667;
        a.thzsquare = 13204;
        a.tihiragana = 12385;
        a.tikatakana = 12481;
        a.tikatakanahalfwidth = 65409;
        a.tikeutacirclekorean = 12912;
        a.tikeutaparenkorean = 12816;
        a.tikeutcirclekorean = 12898;
        a.tikeutkorean = 12599;
        a.tikeutparenkorean = 12802;
        a.tilde = 732;
        a.tildebelowcmb = 816;
        a.tildecmb = 771;
        a.tildecomb = 771;
        a.tildedoublecmb = 864;
        a.tildeoperator = 8764;
        a.tildeoverlaycmb = 820;
        a.tildeverticalcmb = 830;
        a.timescircle = 8855;
        a.tipehahebrew = 1430;
        a.tipehalefthebrew = 1430;
        a.tippigurmukhi = 2672;
        a.titlocyrilliccmb = 1155;
        a.tiwnarmenian = 1407;
        a.tlinebelow = 7791;
        a.tmonospace = 65364;
        a.toarmenian = 1385;
        a.tohiragana = 12392;
        a.tokatakana = 12488;
        a.tokatakanahalfwidth = 65412;
        a.tonebarextrahighmod = 741;
        a.tonebarextralowmod = 745;
        a.tonebarhighmod = 742;
        a.tonebarlowmod = 744;
        a.tonebarmidmod = 743;
        a.tonefive = 445;
        a.tonesix = 389;
        a.tonetwo = 424;
        a.tonos = 900;
        a.tonsquare = 13095;
        a.topatakthai = 3599;
        a.tortoiseshellbracketleft = 12308;
        a.tortoiseshellbracketleftsmall = 65117;
        a.tortoiseshellbracketleftvertical = 65081;
        a.tortoiseshellbracketright = 12309;
        a.tortoiseshellbracketrightsmall = 65118;
        a.tortoiseshellbracketrightvertical = 65082;
        a.totaothai = 3605;
        a.tpalatalhook = 427;
        a.tparen = 9391;
        a.trademark = 8482;
        a.trademarksans = 63722;
        a.trademarkserif = 63195;
        a.tretroflexhook = 648;
        a.triagdn = 9660;
        a.triaglf = 9668;
        a.triagrt = 9658;
        a.triagup = 9650;
        a.ts = 678;
        a.tsadi = 1510;
        a.tsadidagesh = 64326;
        a.tsadidageshhebrew = 64326;
        a.tsadihebrew = 1510;
        a.tsecyrillic = 1094;
        a.tsere = 1461;
        a.tsere12 = 1461;
        a.tsere1e = 1461;
        a.tsere2b = 1461;
        a.tserehebrew = 1461;
        a.tserenarrowhebrew = 1461;
        a.tserequarterhebrew = 1461;
        a.tserewidehebrew = 1461;
        a.tshecyrillic = 1115;
        a.tsuperior = 63219;
        a.ttabengali = 2463;
        a.ttadeva = 2335;
        a.ttagujarati = 2719;
        a.ttagurmukhi = 2591;
        a.tteharabic = 1657;
        a.ttehfinalarabic = 64359;
        a.ttehinitialarabic = 64360;
        a.ttehmedialarabic = 64361;
        a.tthabengali = 2464;
        a.tthadeva = 2336;
        a.tthagujarati = 2720;
        a.tthagurmukhi = 2592;
        a.tturned = 647;
        a.tuhiragana = 12388;
        a.tukatakana = 12484;
        a.tukatakanahalfwidth = 65410;
        a.tusmallhiragana = 12387;
        a.tusmallkatakana = 12483;
        a.tusmallkatakanahalfwidth = 65391;
        a.twelvecircle = 9323;
        a.twelveparen = 9343;
        a.twelveperiod = 9363;
        a.twelveroman = 8571;
        a.twentycircle = 9331;
        a.twentyhangzhou = 21316;
        a.twentyparen = 9351;
        a.twentyperiod = 9371;
        a.two = 50;
        a.twoarabic = 1634;
        a.twobengali = 2536;
        a.twocircle = 9313;
        a.twocircleinversesansserif = 10123;
        a.twodeva = 2408;
        a.twodotenleader = 8229;
        a.twodotleader = 8229;
        a.twodotleadervertical = 65072;
        a.twogujarati = 2792;
        a.twogurmukhi = 2664;
        a.twohackarabic = 1634;
        a.twohangzhou = 12322;
        a.twoideographicparen = 12833;
        a.twoinferior = 8322;
        a.twomonospace = 65298;
        a.twonumeratorbengali = 2549;
        a.twooldstyle = 63282;
        a.twoparen = 9333;
        a.twoperiod = 9353;
        a.twopersian = 1778;
        a.tworoman = 8561;
        a.twostroke = 443;
        a.twosuperior = 178;
        a.twothai = 3666;
        a.twothirds = 8532;
        a.u = 117;
        a.uacute = 250;
        a.ubar = 649;
        a.ubengali = 2441;
        a.ubopomofo = 12584;
        a.ubreve = 365;
        a.ucaron = 468;
        a.ucircle = 9444;
        a.ucircumflex = 251;
        a.ucircumflexbelow = 7799;
        a.ucyrillic = 1091;
        a.udattadeva = 2385;
        a.udblacute = 369;
        a.udblgrave = 533;
        a.udeva = 2313;
        a.udieresis = 252;
        a.udieresisacute = 472;
        a.udieresisbelow = 7795;
        a.udieresiscaron = 474;
        a.udieresiscyrillic = 1265;
        a.udieresisgrave = 476;
        a.udieresismacron = 470;
        a.udotbelow = 7909;
        a.ugrave = 249;
        a.ugujarati = 2697;
        a.ugurmukhi = 2569;
        a.uhiragana = 12358;
        a.uhookabove = 7911;
        a.uhorn = 432;
        a.uhornacute = 7913;
        a.uhorndotbelow = 7921;
        a.uhorngrave = 7915;
        a.uhornhookabove = 7917;
        a.uhorntilde = 7919;
        a.uhungarumlaut = 369;
        a.uhungarumlautcyrillic = 1267;
        a.uinvertedbreve = 535;
        a.ukatakana = 12454;
        a.ukatakanahalfwidth = 65395;
        a.ukcyrillic = 1145;
        a.ukorean = 12636;
        a.umacron = 363;
        a.umacroncyrillic = 1263;
        a.umacrondieresis = 7803;
        a.umatragurmukhi = 2625;
        a.umonospace = 65365;
        a.underscore = 95;
        a.underscoredbl = 8215;
        a.underscoremonospace = 65343;
        a.underscorevertical = 65075;
        a.underscorewavy = 65103;
        a.union = 8746;
        a.universal = 8704;
        a.uogonek = 371;
        a.uparen = 9392;
        a.upblock = 9600;
        a.upperdothebrew = 1476;
        a.upsilon = 965;
        a.upsilondieresis = 971;
        a.upsilondieresistonos = 944;
        a.upsilonlatin = 650;
        a.upsilontonos = 973;
        a.uptackbelowcmb = 797;
        a.uptackmod = 724;
        a.uragurmukhi = 2675;
        a.uring = 367;
        a.ushortcyrillic = 1118;
        a.usmallhiragana = 12357;
        a.usmallkatakana = 12453;
        a.usmallkatakanahalfwidth = 65385;
        a.ustraightcyrillic = 1199;
        a.ustraightstrokecyrillic = 1201;
        a.utilde = 361;
        a.utildeacute = 7801;
        a.utildebelow = 7797;
        a.uubengali = 2442;
        a.uudeva = 2314;
        a.uugujarati = 2698;
        a.uugurmukhi = 2570;
        a.uumatragurmukhi = 2626;
        a.uuvowelsignbengali = 2498;
        a.uuvowelsigndeva = 2370;
        a.uuvowelsigngujarati = 2754;
        a.uvowelsignbengali = 2497;
        a.uvowelsigndeva = 2369;
        a.uvowelsigngujarati = 2753;
        a.v = 118;
        a.vadeva = 2357;
        a.vagujarati = 2741;
        a.vagurmukhi = 2613;
        a.vakatakana = 12535;
        a.vav = 1493;
        a.vavdagesh = 64309;
        a.vavdagesh65 = 64309;
        a.vavdageshhebrew = 64309;
        a.vavhebrew = 1493;
        a.vavholam = 64331;
        a.vavholamhebrew = 64331;
        a.vavvavhebrew = 1520;
        a.vavyodhebrew = 1521;
        a.vcircle = 9445;
        a.vdotbelow = 7807;
        a.vecyrillic = 1074;
        a.veharabic = 1700;
        a.vehfinalarabic = 64363;
        a.vehinitialarabic = 64364;
        a.vehmedialarabic = 64365;
        a.vekatakana = 12537;
        a.venus = 9792;
        a.verticalbar = 124;
        a.verticallineabovecmb = 781;
        a.verticallinebelowcmb = 809;
        a.verticallinelowmod = 716;
        a.verticallinemod = 712;
        a.vewarmenian = 1406;
        a.vhook = 651;
        a.vikatakana = 12536;
        a.viramabengali = 2509;
        a.viramadeva = 2381;
        a.viramagujarati = 2765;
        a.visargabengali = 2435;
        a.visargadeva = 2307;
        a.visargagujarati = 2691;
        a.vmonospace = 65366;
        a.voarmenian = 1400;
        a.voicediterationhiragana = 12446;
        a.voicediterationkatakana = 12542;
        a.voicedmarkkana = 12443;
        a.voicedmarkkanahalfwidth = 65438;
        a.vokatakana = 12538;
        a.vparen = 9393;
        a.vtilde = 7805;
        a.vturned = 652;
        a.vuhiragana = 12436;
        a.vukatakana = 12532;
        a.w = 119;
        a.wacute = 7811;
        a.waekorean = 12633;
        a.wahiragana = 12431;
        a.wakatakana = 12527;
        a.wakatakanahalfwidth = 65436;
        a.wakorean = 12632;
        a.wasmallhiragana = 12430;
        a.wasmallkatakana = 12526;
        a.wattosquare = 13143;
        a.wavedash = 12316;
        a.wavyunderscorevertical = 65076;
        a.wawarabic = 1608;
        a.wawfinalarabic = 65262;
        a.wawhamzaabovearabic = 1572;
        a.wawhamzaabovefinalarabic = 65158;
        a.wbsquare = 13277;
        a.wcircle = 9446;
        a.wcircumflex = 373;
        a.wdieresis = 7813;
        a.wdotaccent = 7815;
        a.wdotbelow = 7817;
        a.wehiragana = 12433;
        a.weierstrass = 8472;
        a.wekatakana = 12529;
        a.wekorean = 12638;
        a.weokorean = 12637;
        a.wgrave = 7809;
        a.whitebullet = 9702;
        a.whitecircle = 9675;
        a.whitecircleinverse = 9689;
        a.whitecornerbracketleft = 12302;
        a.whitecornerbracketleftvertical = 65091;
        a.whitecornerbracketright = 12303;
        a.whitecornerbracketrightvertical = 65092;
        a.whitediamond = 9671;
        a.whitediamondcontainingblacksmalldiamond = 9672;
        a.whitedownpointingsmalltriangle = 9663;
        a.whitedownpointingtriangle = 9661;
        a.whiteleftpointingsmalltriangle = 9667;
        a.whiteleftpointingtriangle = 9665;
        a.whitelenticularbracketleft = 12310;
        a.whitelenticularbracketright = 12311;
        a.whiterightpointingsmalltriangle = 9657;
        a.whiterightpointingtriangle = 9655;
        a.whitesmallsquare = 9643;
        a.whitesmilingface = 9786;
        a.whitesquare = 9633;
        a.whitestar = 9734;
        a.whitetelephone = 9743;
        a.whitetortoiseshellbracketleft = 12312;
        a.whitetortoiseshellbracketright = 12313;
        a.whiteuppointingsmalltriangle = 9653;
        a.whiteuppointingtriangle = 9651;
        a.wihiragana = 12432;
        a.wikatakana = 12528;
        a.wikorean = 12639;
        a.wmonospace = 65367;
        a.wohiragana = 12434;
        a.wokatakana = 12530;
        a.wokatakanahalfwidth = 65382;
        a.won = 8361;
        a.wonmonospace = 65510;
        a.wowaenthai = 3623;
        a.wparen = 9394;
        a.wring = 7832;
        a.wsuperior = 695;
        a.wturned = 653;
        a.wynn = 447;
        a.x = 120;
        a.xabovecmb = 829;
        a.xbopomofo = 12562;
        a.xcircle = 9447;
        a.xdieresis = 7821;
        a.xdotaccent = 7819;
        a.xeharmenian = 1389;
        a.xi = 958;
        a.xmonospace = 65368;
        a.xparen = 9395;
        a.xsuperior = 739;
        a.y = 121;
        a.yaadosquare = 13134;
        a.yabengali = 2479;
        a.yacute = 253;
        a.yadeva = 2351;
        a.yaekorean = 12626;
        a.yagujarati = 2735;
        a.yagurmukhi = 2607;
        a.yahiragana = 12420;
        a.yakatakana = 12516;
        a.yakatakanahalfwidth = 65428;
        a.yakorean = 12625;
        a.yamakkanthai = 3662;
        a.yasmallhiragana = 12419;
        a.yasmallkatakana = 12515;
        a.yasmallkatakanahalfwidth = 65388;
        a.yatcyrillic = 1123;
        a.ycircle = 9448;
        a.ycircumflex = 375;
        a.ydieresis = 255;
        a.ydotaccent = 7823;
        a.ydotbelow = 7925;
        a.yeharabic = 1610;
        a.yehbarreearabic = 1746;
        a.yehbarreefinalarabic = 64431;
        a.yehfinalarabic = 65266;
        a.yehhamzaabovearabic = 1574;
        a.yehhamzaabovefinalarabic = 65162;
        a.yehhamzaaboveinitialarabic = 65163;
        a.yehhamzaabovemedialarabic = 65164;
        a.yehinitialarabic = 65267;
        a.yehmedialarabic = 65268;
        a.yehmeeminitialarabic = 64733;
        a.yehmeemisolatedarabic = 64600;
        a.yehnoonfinalarabic = 64660;
        a.yehthreedotsbelowarabic = 1745;
        a.yekorean = 12630;
        a.yen = 165;
        a.yenmonospace = 65509;
        a.yeokorean = 12629;
        a.yeorinhieuhkorean = 12678;
        a.yerahbenyomohebrew = 1450;
        a.yerahbenyomolefthebrew = 1450;
        a.yericyrillic = 1099;
        a.yerudieresiscyrillic = 1273;
        a.yesieungkorean = 12673;
        a.yesieungpansioskorean = 12675;
        a.yesieungsioskorean = 12674;
        a.yetivhebrew = 1434;
        a.ygrave = 7923;
        a.yhook = 436;
        a.yhookabove = 7927;
        a.yiarmenian = 1397;
        a.yicyrillic = 1111;
        a.yikorean = 12642;
        a.yinyang = 9775;
        a.yiwnarmenian = 1410;
        a.ymonospace = 65369;
        a.yod = 1497;
        a.yoddagesh = 64313;
        a.yoddageshhebrew = 64313;
        a.yodhebrew = 1497;
        a.yodyodhebrew = 1522;
        a.yodyodpatahhebrew = 64287;
        a.yohiragana = 12424;
        a.yoikorean = 12681;
        a.yokatakana = 12520;
        a.yokatakanahalfwidth = 65430;
        a.yokorean = 12635;
        a.yosmallhiragana = 12423;
        a.yosmallkatakana = 12519;
        a.yosmallkatakanahalfwidth = 65390;
        a.yotgreek = 1011;
        a.yoyaekorean = 12680;
        a.yoyakorean = 12679;
        a.yoyakthai = 3618;
        a.yoyingthai = 3597;
        a.yparen = 9396;
        a.ypogegrammeni = 890;
        a.ypogegrammenigreekcmb = 837;
        a.yr = 422;
        a.yring = 7833;
        a.ysuperior = 696;
        a.ytilde = 7929;
        a.yturned = 654;
        a.yuhiragana = 12422;
        a.yuikorean = 12684;
        a.yukatakana = 12518;
        a.yukatakanahalfwidth = 65429;
        a.yukorean = 12640;
        a.yusbigcyrillic = 1131;
        a.yusbigiotifiedcyrillic = 1133;
        a.yuslittlecyrillic = 1127;
        a.yuslittleiotifiedcyrillic = 1129;
        a.yusmallhiragana = 12421;
        a.yusmallkatakana = 12517;
        a.yusmallkatakanahalfwidth = 65389;
        a.yuyekorean = 12683;
        a.yuyeokorean = 12682;
        a.yyabengali = 2527;
        a.yyadeva = 2399;
        a.z = 122;
        a.zaarmenian = 1382;
        a.zacute = 378;
        a.zadeva = 2395;
        a.zagurmukhi = 2651;
        a.zaharabic = 1592;
        a.zahfinalarabic = 65222;
        a.zahinitialarabic = 65223;
        a.zahiragana = 12374;
        a.zahmedialarabic = 65224;
        a.zainarabic = 1586;
        a.zainfinalarabic = 65200;
        a.zakatakana = 12470;
        a.zaqefgadolhebrew = 1429;
        a.zaqefqatanhebrew = 1428;
        a.zarqahebrew = 1432;
        a.zayin = 1494;
        a.zayindagesh = 64310;
        a.zayindageshhebrew = 64310;
        a.zayinhebrew = 1494;
        a.zbopomofo = 12567;
        a.zcaron = 382;
        a.zcircle = 9449;
        a.zcircumflex = 7825;
        a.zcurl = 657;
        a.zdot = 380;
        a.zdotaccent = 380;
        a.zdotbelow = 7827;
        a.zecyrillic = 1079;
        a.zedescendercyrillic = 1177;
        a.zedieresiscyrillic = 1247;
        a.zehiragana = 12380;
        a.zekatakana = 12476;
        a.zero = 48;
        a.zeroarabic = 1632;
        a.zerobengali = 2534;
        a.zerodeva = 2406;
        a.zerogujarati = 2790;
        a.zerogurmukhi = 2662;
        a.zerohackarabic = 1632;
        a.zeroinferior = 8320;
        a.zeromonospace = 65296;
        a.zerooldstyle = 63280;
        a.zeropersian = 1776;
        a.zerosuperior = 8304;
        a.zerothai = 3664;
        a.zerowidthjoiner = 65279;
        a.zerowidthnonjoiner = 8204;
        a.zerowidthspace = 8203;
        a.zeta = 950;
        a.zhbopomofo = 12563;
        a.zhearmenian = 1386;
        a.zhebrevecyrillic = 1218;
        a.zhecyrillic = 1078;
        a.zhedescendercyrillic = 1175;
        a.zhedieresiscyrillic = 1245;
        a.zihiragana = 12376;
        a.zikatakana = 12472;
        a.zinorhebrew = 1454;
        a.zlinebelow = 7829;
        a.zmonospace = 65370;
        a.zohiragana = 12382;
        a.zokatakana = 12478;
        a.zparen = 9397;
        a.zretroflexhook = 656;
        a.zstroke = 438;
        a.zuhiragana = 12378;
        a.zukatakana = 12474;
        a['.notdef'] = 0;
        a.angbracketleftbig = 9001;
        a.angbracketleftBig = 9001;
        a.angbracketleftbigg = 9001;
        a.angbracketleftBigg = 9001;
        a.angbracketrightBig = 9002;
        a.angbracketrightbig = 9002;
        a.angbracketrightBigg = 9002;
        a.angbracketrightbigg = 9002;
        a.arrowhookleft = 8618;
        a.arrowhookright = 8617;
        a.arrowlefttophalf = 8636;
        a.arrowleftbothalf = 8637;
        a.arrownortheast = 8599;
        a.arrownorthwest = 8598;
        a.arrowrighttophalf = 8640;
        a.arrowrightbothalf = 8641;
        a.arrowsoutheast = 8600;
        a.arrowsouthwest = 8601;
        a.backslashbig = 8726;
        a.backslashBig = 8726;
        a.backslashBigg = 8726;
        a.backslashbigg = 8726;
        a.bardbl = 8214;
        a.bracehtipdownleft = 65079;
        a.bracehtipdownright = 65079;
        a.bracehtipupleft = 65080;
        a.bracehtipupright = 65080;
        a.braceleftBig = 123;
        a.braceleftbig = 123;
        a.braceleftbigg = 123;
        a.braceleftBigg = 123;
        a.bracerightBig = 125;
        a.bracerightbig = 125;
        a.bracerightbigg = 125;
        a.bracerightBigg = 125;
        a.bracketleftbig = 91;
        a.bracketleftBig = 91;
        a.bracketleftbigg = 91;
        a.bracketleftBigg = 91;
        a.bracketrightBig = 93;
        a.bracketrightbig = 93;
        a.bracketrightbigg = 93;
        a.bracketrightBigg = 93;
        a.ceilingleftbig = 8968;
        a.ceilingleftBig = 8968;
        a.ceilingleftBigg = 8968;
        a.ceilingleftbigg = 8968;
        a.ceilingrightbig = 8969;
        a.ceilingrightBig = 8969;
        a.ceilingrightbigg = 8969;
        a.ceilingrightBigg = 8969;
        a.circledotdisplay = 8857;
        a.circledottext = 8857;
        a.circlemultiplydisplay = 8855;
        a.circlemultiplytext = 8855;
        a.circleplusdisplay = 8853;
        a.circleplustext = 8853;
        a.contintegraldisplay = 8750;
        a.contintegraltext = 8750;
        a.coproductdisplay = 8720;
        a.coproducttext = 8720;
        a.floorleftBig = 8970;
        a.floorleftbig = 8970;
        a.floorleftbigg = 8970;
        a.floorleftBigg = 8970;
        a.floorrightbig = 8971;
        a.floorrightBig = 8971;
        a.floorrightBigg = 8971;
        a.floorrightbigg = 8971;
        a.hatwide = 770;
        a.hatwider = 770;
        a.hatwidest = 770;
        a.intercal = 7488;
        a.integraldisplay = 8747;
        a.integraltext = 8747;
        a.intersectiondisplay = 8898;
        a.intersectiontext = 8898;
        a.logicalanddisplay = 8743;
        a.logicalandtext = 8743;
        a.logicalordisplay = 8744;
        a.logicalortext = 8744;
        a.parenleftBig = 40;
        a.parenleftbig = 40;
        a.parenleftBigg = 40;
        a.parenleftbigg = 40;
        a.parenrightBig = 41;
        a.parenrightbig = 41;
        a.parenrightBigg = 41;
        a.parenrightbigg = 41;
        a.prime = 8242;
        a.productdisplay = 8719;
        a.producttext = 8719;
        a.radicalbig = 8730;
        a.radicalBig = 8730;
        a.radicalBigg = 8730;
        a.radicalbigg = 8730;
        a.radicalbt = 8730;
        a.radicaltp = 8730;
        a.radicalvertex = 8730;
        a.slashbig = 47;
        a.slashBig = 47;
        a.slashBigg = 47;
        a.slashbigg = 47;
        a.summationdisplay = 8721;
        a.summationtext = 8721;
        a.tildewide = 732;
        a.tildewider = 732;
        a.tildewidest = 732;
        a.uniondisplay = 8899;
        a.unionmultidisplay = 8846;
        a.unionmultitext = 8846;
        a.unionsqdisplay = 8852;
        a.unionsqtext = 8852;
        a.uniontext = 8899;
        a.vextenddouble = 8741;
        a.vextendsingle = 8739;
      });
      t = t(function(a) {
        a.space = 32;
        a.a1 = 9985;
        a.a2 = 9986;
        a.a202 = 9987;
        a.a3 = 9988;
        a.a4 = 9742;
        a.a5 = 9990;
        a.a119 = 9991;
        a.a118 = 9992;
        a.a117 = 9993;
        a.a11 = 9755;
        a.a12 = 9758;
        a.a13 = 9996;
        a.a14 = 9997;
        a.a15 = 9998;
        a.a16 = 9999;
        a.a105 = 1e4;
        a.a17 = 10001;
        a.a18 = 10002;
        a.a19 = 10003;
        a.a20 = 10004;
        a.a21 = 10005;
        a.a22 = 10006;
        a.a23 = 10007;
        a.a24 = 10008;
        a.a25 = 10009;
        a.a26 = 10010;
        a.a27 = 10011;
        a.a28 = 10012;
        a.a6 = 10013;
        a.a7 = 10014;
        a.a8 = 10015;
        a.a9 = 10016;
        a.a10 = 10017;
        a.a29 = 10018;
        a.a30 = 10019;
        a.a31 = 10020;
        a.a32 = 10021;
        a.a33 = 10022;
        a.a34 = 10023;
        a.a35 = 9733;
        a.a36 = 10025;
        a.a37 = 10026;
        a.a38 = 10027;
        a.a39 = 10028;
        a.a40 = 10029;
        a.a41 = 10030;
        a.a42 = 10031;
        a.a43 = 10032;
        a.a44 = 10033;
        a.a45 = 10034;
        a.a46 = 10035;
        a.a47 = 10036;
        a.a48 = 10037;
        a.a49 = 10038;
        a.a50 = 10039;
        a.a51 = 10040;
        a.a52 = 10041;
        a.a53 = 10042;
        a.a54 = 10043;
        a.a55 = 10044;
        a.a56 = 10045;
        a.a57 = 10046;
        a.a58 = 10047;
        a.a59 = 10048;
        a.a60 = 10049;
        a.a61 = 10050;
        a.a62 = 10051;
        a.a63 = 10052;
        a.a64 = 10053;
        a.a65 = 10054;
        a.a66 = 10055;
        a.a67 = 10056;
        a.a68 = 10057;
        a.a69 = 10058;
        a.a70 = 10059;
        a.a71 = 9679;
        a.a72 = 10061;
        a.a73 = 9632;
        a.a74 = 10063;
        a.a203 = 10064;
        a.a75 = 10065;
        a.a204 = 10066;
        a.a76 = 9650;
        a.a77 = 9660;
        a.a78 = 9670;
        a.a79 = 10070;
        a.a81 = 9687;
        a.a82 = 10072;
        a.a83 = 10073;
        a.a84 = 10074;
        a.a97 = 10075;
        a.a98 = 10076;
        a.a99 = 10077;
        a.a100 = 10078;
        a.a101 = 10081;
        a.a102 = 10082;
        a.a103 = 10083;
        a.a104 = 10084;
        a.a106 = 10085;
        a.a107 = 10086;
        a.a108 = 10087;
        a.a112 = 9827;
        a.a111 = 9830;
        a.a110 = 9829;
        a.a109 = 9824;
        a.a120 = 9312;
        a.a121 = 9313;
        a.a122 = 9314;
        a.a123 = 9315;
        a.a124 = 9316;
        a.a125 = 9317;
        a.a126 = 9318;
        a.a127 = 9319;
        a.a128 = 9320;
        a.a129 = 9321;
        a.a130 = 10102;
        a.a131 = 10103;
        a.a132 = 10104;
        a.a133 = 10105;
        a.a134 = 10106;
        a.a135 = 10107;
        a.a136 = 10108;
        a.a137 = 10109;
        a.a138 = 10110;
        a.a139 = 10111;
        a.a140 = 10112;
        a.a141 = 10113;
        a.a142 = 10114;
        a.a143 = 10115;
        a.a144 = 10116;
        a.a145 = 10117;
        a.a146 = 10118;
        a.a147 = 10119;
        a.a148 = 10120;
        a.a149 = 10121;
        a.a150 = 10122;
        a.a151 = 10123;
        a.a152 = 10124;
        a.a153 = 10125;
        a.a154 = 10126;
        a.a155 = 10127;
        a.a156 = 10128;
        a.a157 = 10129;
        a.a158 = 10130;
        a.a159 = 10131;
        a.a160 = 10132;
        a.a161 = 8594;
        a.a163 = 8596;
        a.a164 = 8597;
        a.a196 = 10136;
        a.a165 = 10137;
        a.a192 = 10138;
        a.a166 = 10139;
        a.a167 = 10140;
        a.a168 = 10141;
        a.a169 = 10142;
        a.a170 = 10143;
        a.a171 = 10144;
        a.a172 = 10145;
        a.a173 = 10146;
        a.a162 = 10147;
        a.a174 = 10148;
        a.a175 = 10149;
        a.a176 = 10150;
        a.a177 = 10151;
        a.a178 = 10152;
        a.a179 = 10153;
        a.a193 = 10154;
        a.a180 = 10155;
        a.a199 = 10156;
        a.a181 = 10157;
        a.a200 = 10158;
        a.a182 = 10159;
        a.a201 = 10161;
        a.a183 = 10162;
        a.a184 = 10163;
        a.a197 = 10164;
        a.a185 = 10165;
        a.a194 = 10166;
        a.a198 = 10167;
        a.a186 = 10168;
        a.a195 = 10169;
        a.a187 = 10170;
        a.a188 = 10171;
        a.a189 = 10172;
        a.a190 = 10173;
        a.a191 = 10174;
        a.a89 = 10088;
        a.a90 = 10089;
        a.a93 = 10090;
        a.a94 = 10091;
        a.a91 = 10092;
        a.a92 = 10093;
        a.a205 = 10094;
        a.a85 = 10095;
        a.a206 = 10096;
        a.a86 = 10097;
        a.a87 = 10098;
        a.a88 = 10099;
        a.a95 = 10100;
        a.a96 = 10101;
        a['.notdef'] = 0;
      });
      m.getGlyphsUnicode = y;
      m.getDingbatsGlyphsUnicode = t;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.validateResponseStatus = m.validateRangeRequestCapabilities = m.createResponseStatusError = void 0;
      var a = t(0);
      m.createResponseStatusError = function(k, b) {
        return 404 === k || (0 === k && /^file:/.test(b))
          ? new a.MissingPDFException('Missing PDF "' + b + '".')
          : new a.UnexpectedResponseException(
              'Unexpected server response (' + k + ') while retrieving PDF "' + b + '".',
              k,
            );
      };
      m.validateRangeRequestCapabilities = function(k) {
        var b = k.getResponseHeader,
          v = k.isHttp,
          d = k.rangeChunkSize,
          u = k.disableRange;
        (0, a.assert)(0 < d);
        k = { allowRangeRequests: !1, suggestedLength: void 0 };
        if (u || !v || 'bytes' !== b('Accept-Ranges') || 'identity' !== (b('Content-Encoding') || 'identity')) return k;
        b = parseInt(b('Content-Length'), 10);
        if (!Number.isInteger(b)) return k;
        k.suggestedLength = b;
        if (b <= 2 * d) return k;
        k.allowRangeRequests = !0;
        return k;
      };
      m.validateResponseStatus = function(a) {
        return 200 === a || 206 === a;
      };
    },
    function(y, m, t) {
      var a = t(4),
        k = t(20),
        b = t(6),
        v = t(29),
        d = t(30);
      m = function n(z, m, B) {
        var e = z & n.F,
          h = z & n.G,
          p = z & n.S,
          A = z & n.P,
          c = z & n.B;
        p = h ? a : p ? a[m] || (a[m] = {}) : (a[m] || {}).prototype;
        var q = h ? k : k[m] || (k[m] = {}),
          x = q.prototype || (q.prototype = {}),
          g;
        h && (B = m);
        for (g in B)
          (h = !e && p && void 0 !== p[g]),
            (m = (h ? p : B)[g]),
            (h = c && h ? d(m, a) : A && 'function' == typeof m ? d(Function.call, m) : m),
            p && v(p, g, m, z & n.U),
            q[g] != m && b(q, g, h),
            A && x[g] != m && (x[g] = m);
      };
      a.core = k;
      m.F = 1;
      m.G = 2;
      m.S = 4;
      m.P = 8;
      m.B = 16;
      m.W = 32;
      m.U = 64;
      m.R = 128;
      y.exports = m;
    },
    function(y, m, t) {
      y.exports =
        !t(5) &&
        !t(19)(function() {
          return (
            7 !=
            Object.defineProperty(t(39)('div'), 'a', {
              get: function() {
                return 7;
              },
            }).a
          );
        });
    },
    function(y, m, t) {
      m = t(12);
      var a = t(4).document,
        k = m(a) && m(a.createElement);
      y.exports = function(b) {
        return k ? a.createElement(b) : {};
      };
    },
    function(y, m, t) {
      y.exports = function(a) {
        if ('function' != typeof a) throw TypeError(a + ' is not a function!');
        return a;
      };
    },
    function(y, m, t) {
      m = t(4);
      var a = t(6),
        k = t(13);
      t = k('typed_array');
      k = k('view');
      for (
        var b = !(!m.ArrayBuffer || !m.DataView),
          v = b,
          d = 0,
          u,
          z = 'Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array'.split(
            ' ',
          );
        9 > d;

      )
        (u = m[z[d++]]) ? (a(u.prototype, t, !0), a(u.prototype, k, !0)) : (v = !1);
      y.exports = { ABV: b, CONSTR: v, TYPED: t, VIEW: k };
    },
    function(y, m, t) {
      var a = t(29);
      y.exports = function(k, b, v) {
        for (var d in b) a(k, d, b[d], v);
        return k;
      };
    },
    function(y, m, t) {
      y.exports = function(a, k, b, v) {
        if (!(a instanceof k) || (void 0 !== v && v in a)) throw TypeError(b + ': incorrect invocation!');
        return a;
      };
    },
    function(y, m, t) {
      var a = t(14),
        k = t(9);
      y.exports = function(b) {
        if (void 0 === b) return 0;
        b = a(b);
        var v = k(b);
        if (b !== v) throw RangeError('Wrong length!');
        return v;
      };
    },
    function(y, m, t) {
      var a = t(46),
        k = t(33).concat('length', 'prototype');
      m.f =
        Object.getOwnPropertyNames ||
        function(b) {
          return a(b, k);
        };
    },
    function(y, m, t) {
      var a = t(8),
        k = t(23),
        b = t(49)(!1),
        v = t(32)('IE_PROTO');
      y.exports = function(d, u) {
        var m = k(d),
          C = 0,
          B = [],
          n;
        for (n in m) n != v && a(m, n) && B.push(n);
        for (; u.length > C; ) a(m, (n = u[C++])) && (~b(B, n) || B.push(n));
        return B;
      };
    },
    function(y, m, t) {
      var a = t(31);
      y.exports = Object('z').propertyIsEnumerable(0)
        ? Object
        : function(k) {
            return 'String' == a(k) ? k.split('') : Object(k);
          };
    },
    function(y, m, t) {
      y.exports = function(a) {
        if (void 0 == a) throw TypeError("Can't call method on  " + a);
        return a;
      };
    },
    function(y, m, t) {
      var a = t(23),
        k = t(9),
        b = t(24);
      y.exports = function(v) {
        return function(d, u, m) {
          d = a(d);
          var z = k(d.length);
          m = b(m, z);
          if (v && u != u)
            for (; z > m; ) {
              if (((u = d[m++]), u != u)) return !0;
            }
          else for (; z > m; m++) if ((v || m in d) && d[m] === u) return v || m || 0;
          return !v && -1;
        };
      };
    },
    function(y, m, t) {
      m = t(4);
      var a = m['__core-js_shared__'] || (m['__core-js_shared__'] = {});
      y.exports = function(k) {
        return a[k] || (a[k] = {});
      };
    },
    function(y, m, t) {
      var a = t(15),
        k = t(24),
        b = t(9);
      y.exports = function(v) {
        var d = a(this),
          u = b(d.length),
          m = arguments.length,
          C = k(1 < m ? arguments[1] : void 0, u);
        m = 2 < m ? arguments[2] : void 0;
        for (u = void 0 === m ? u : k(m, u); u > C; ) d[C++] = v;
        return d;
      };
    },
    function(y, m, t) {
      var a = t(31),
        k = t(2)('toStringTag'),
        b =
          'Arguments' ==
          a(
            (function() {
              return arguments;
            })(),
          );
      y.exports = function(v) {
        var d;
        if (void 0 === v) var u = 'Undefined';
        else {
          if (null === v) var m = 'Null';
          else {
            a: {
              var C = (v = Object(v));
              try {
                m = C[k];
                break a;
              } catch (B) {}
              m = void 0;
            }
            m =
              'string' == typeof (u = m)
                ? u
                : b
                ? a(v)
                : 'Object' == (d = a(v)) && 'function' == typeof v.callee
                ? 'Arguments'
                : d;
          }
          u = m;
        }
        return u;
      };
    },
    function(y, m, t) {
      var a = t(21),
        k = t(77),
        b = t(33),
        v = t(32)('IE_PROTO'),
        d = function() {},
        u = function() {
          var a = t(39)('iframe'),
            d = b.length;
          a.style.display = 'none';
          t(79).appendChild(a);
          a.src = 'javascript:';
          a = a.contentWindow.document;
          a.open();
          a.write('<script>document.F=Object\x3c/script>');
          a.close();
          for (u = a.F; d--; ) delete u.prototype[b[d]];
          return u();
        };
      y.exports =
        Object.create ||
        function(b, m) {
          if (null !== b) {
            d.prototype = a(b);
            var B = new d();
            d.prototype = null;
            B[v] = b;
          } else B = u();
          return void 0 === m ? B : k(B, m);
        };
    },
    function(y, m, t) {
      var a = t(8),
        k = t(15),
        b = t(32)('IE_PROTO'),
        v = Object.prototype;
      y.exports =
        Object.getPrototypeOf ||
        function(d) {
          d = k(d);
          return a(d, b)
            ? d[b]
            : 'function' == typeof d.constructor && d instanceof d.constructor
            ? d.constructor.prototype
            : d instanceof Object
            ? v
            : null;
        };
    },
    function(y, m, t) {
      function a(a, b, c, f) {
        if (a.destroyed) return Promise.reject(Error('Worker was destroyed'));
        b.disableAutoFetch = (0, d.getDefaultSetting)('disableAutoFetch');
        b.disableStream = (0, d.getDefaultSetting)('disableStream');
        b.chunkedViewerLoading = !!c;
        c && ((b.length = c.length), (b.initialData = c.initialData));
        return a.messageHandler
          .sendWithPromise('GetDocRequest', {
            docId: f,
            source: {
              data: b.data,
              url: b.url,
              password: b.password,
              disableAutoFetch: b.disableAutoFetch,
              rangeChunkSize: b.rangeChunkSize,
              length: b.length,
            },
            maxImageSize: (0, d.getDefaultSetting)('maxImageSize'),
            disableFontFace: (0, d.getDefaultSetting)('disableFontFace'),
            disableCreateObjectURL: (0, d.getDefaultSetting)('disableCreateObjectURL'),
            postMessageTransfers: (0, d.getDefaultSetting)('postMessageTransfers') && !0,
            docBaseUrl: b.docBaseUrl,
            nativeImageDecoderSupport: b.nativeImageDecoderSupport,
            ignoreErrors: b.ignoreErrors,
            isEvalSupported: (0, d.getDefaultSetting)('isEvalSupported'),
          })
          .then(function(b) {
            if (a.destroyed) throw Error('Worker was destroyed');
            return b;
          });
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.build = m.version = m._UnsupportedManager = m.setPDFNetworkStreamClass = m.PDFPageProxy = m.PDFDocumentProxy = m.PDFWorker = m.PDFDataRangeTransport = m.LoopbackPort = m.getDocument = void 0;
      var k = (function() {
          function a(a, b) {
            for (var c = 0; c < b.length; c++) {
              var d = b[c];
              d.enumerable = d.enumerable || !1;
              d.configurable = !0;
              'value' in d && (d.writable = !0);
              Object.defineProperty(a, d.key, d);
            }
          }
          return function(b, c, d) {
            c && a(b.prototype, c);
            d && a(b, d);
            return b;
          };
        })(),
        b =
          'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
            ? function(a) {
                return typeof a;
              }
            : function(a) {
                return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                  ? 'symbol'
                  : typeof a;
              },
        v = t(0),
        d = t(7),
        u = t(99),
        z = t(100),
        C = (y = t(11)) && y.__esModule ? y : { default: y },
        B = t(57),
        n = t(102),
        e = !1,
        h,
        p = (function() {
          function a() {
            this._capability = (0, v.createPromiseCapability)();
            this._worker = this._transport = null;
            this.docId = 'd' + b++;
            this.destroyed = !1;
            this.onUnsupportedFeature = this.onProgress = this.onPassword = null;
          }
          var b = 0;
          a.prototype = {
            get promise() {
              return this._capability.promise;
            },
            destroy: function() {
              var a = this;
              this.destroyed = !0;
              return (this._transport ? this._transport.destroy() : Promise.resolve()).then(function() {
                a._transport = null;
                a._worker && (a._worker.destroy(), (a._worker = null));
              });
            },
            then: function(a, b) {
              return this.promise.then.apply(this.promise, arguments);
            },
          };
          return a;
        })(),
        A = (function() {
          function a(a, b) {
            this.length = a;
            this.initialData = b;
            this._rangeListeners = [];
            this._progressListeners = [];
            this._progressiveReadListeners = [];
            this._readyCapability = (0, v.createPromiseCapability)();
          }
          a.prototype = {
            addRangeListener: function(a) {
              this._rangeListeners.push(a);
            },
            addProgressListener: function(a) {
              this._progressListeners.push(a);
            },
            addProgressiveReadListener: function(a) {
              this._progressiveReadListeners.push(a);
            },
            onDataRange: function(a, b) {
              for (var c = this._rangeListeners, d = 0, f = c.length; d < f; ++d) c[d](a, b);
            },
            onDataProgress: function(a) {
              var b = this;
              this._readyCapability.promise.then(function() {
                for (var c = b._progressListeners, d = 0, f = c.length; d < f; ++d) c[d](a);
              });
            },
            onDataProgressiveRead: function(a) {
              var b = this;
              this._readyCapability.promise.then(function() {
                for (var c = b._progressiveReadListeners, d = 0, f = c.length; d < f; ++d) c[d](a);
              });
            },
            transportReady: function() {
              this._readyCapability.resolve();
            },
            requestDataRange: function(a, b) {
              throw Error('Abstract method PDFDataRangeTransport.requestDataRange');
            },
            abort: function() {},
          };
          return a;
        })(),
        c = (function() {
          function a(a, b, c) {
            this.pdfInfo = a;
            this.transport = b;
            this.loadingTask = c;
          }
          a.prototype = {
            get numPages() {
              return this.pdfInfo.numPages;
            },
            get fingerprint() {
              return this.pdfInfo.fingerprint;
            },
            getPage: function(a) {
              return this.transport.getPage(a);
            },
            getPageIndex: function(a) {
              return this.transport.getPageIndex(a);
            },
            getDestinations: function() {
              return this.transport.getDestinations();
            },
            getDestination: function(a) {
              return this.transport.getDestination(a);
            },
            getPageLabels: function() {
              return this.transport.getPageLabels();
            },
            getPageMode: function() {
              return this.transport.getPageMode();
            },
            getAttachments: function() {
              return this.transport.getAttachments();
            },
            getJavaScript: function() {
              return this.transport.getJavaScript();
            },
            getOutline: function() {
              return this.transport.getOutline();
            },
            getMetadata: function() {
              return this.transport.getMetadata();
            },
            getData: function() {
              return this.transport.getData();
            },
            getDownloadInfo: function() {
              return this.transport.downloadInfoCapability.promise;
            },
            getStats: function() {
              return this.transport.getStats();
            },
            cleanup: function() {
              this.transport.startCleanup();
            },
            destroy: function() {
              return this.loadingTask.destroy();
            },
          };
          return a;
        })(),
        q = (function() {
          function a(a, b, c) {
            this.pageIndex = a;
            this.pageInfo = b;
            this.transport = c;
            this.stats = new v.StatTimer();
            this.stats.enabled = (0, d.getDefaultSetting)('enableStats');
            this.commonObjs = c.commonObjs;
            this.objs = new l();
            this.pendingCleanup = this.cleanupAfterRender = !1;
            this.intentStates = Object.create(null);
            this.destroyed = !1;
          }
          a.prototype = {
            get pageNumber() {
              return this.pageIndex + 1;
            },
            get rotate() {
              return this.pageInfo.rotate;
            },
            get ref() {
              return this.pageInfo.ref;
            },
            get userUnit() {
              return this.pageInfo.userUnit;
            },
            get view() {
              return this.pageInfo.view;
            },
            getViewport: function(a, b) {
              2 > arguments.length && (b = this.rotate);
              return new v.PageViewport(this.view, a, b, 0, 0);
            },
            getAnnotations: function(a) {
              a = (a && a.intent) || null;
              (this.annotationsPromise && this.annotationsIntent === a) ||
                ((this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, a)),
                (this.annotationsIntent = a));
              return this.annotationsPromise;
            },
            render: function(a) {
              var b = this,
                c = this.stats;
              c.time('Overall');
              this.pendingCleanup = !1;
              var l = 'print' === a.intent ? 'print' : 'display',
                r = a.canvasFactory || new d.DOMCanvasFactory();
              this.intentStates[l] || (this.intentStates[l] = Object.create(null));
              var g = this.intentStates[l];
              g.displayReadyCapability ||
                ((g.receivingOperatorList = !0),
                (g.displayReadyCapability = (0, v.createPromiseCapability)()),
                (g.operatorList = { fnArray: [], argsArray: [], lastChunk: !1 }),
                this.stats.time('Page Request'),
                this.transport.messageHandler.send('RenderPageRequest', {
                  pageIndex: this.pageNumber - 1,
                  intent: l,
                  renderInteractiveForms: !0 === a.renderInteractiveForms,
                }));
              var q = function(a) {
                  var d = g.renderTasks.indexOf(e);
                  0 <= d && g.renderTasks.splice(d, 1);
                  b.cleanupAfterRender && (b.pendingCleanup = !0);
                  b._tryCleanup();
                  a ? e.capability.reject(a) : e.capability.resolve();
                  c.timeEnd('Rendering');
                  c.timeEnd('Overall');
                },
                e = new f(q, a, this.objs, this.commonObjs, g.operatorList, this.pageNumber, r);
              e.useRequestAnimationFrame = 'print' !== l;
              g.renderTasks || (g.renderTasks = []);
              g.renderTasks.push(e);
              l = e.task;
              a.continueCallback &&
                ((0, v.deprecated)('render is used with continueCallback parameter'),
                (l.onContinue = a.continueCallback));
              g.displayReadyCapability.promise
                .then(function(a) {
                  b.pendingCleanup ? q() : (c.time('Rendering'), e.initializeGraphics(a), e.operatorListChanged());
                })
                ['catch'](q);
              return l;
            },
            getOperatorList: function() {
              function a() {
                if (b.operatorList.lastChunk) {
                  b.opListReadCapability.resolve(b.operatorList);
                  var a = b.renderTasks.indexOf(c);
                  0 <= a && b.renderTasks.splice(a, 1);
                }
              }
              this.intentStates.oplist || (this.intentStates.oplist = Object.create(null));
              var b = this.intentStates.oplist;
              if (!b.opListReadCapability) {
                var c = {};
                c.operatorListChanged = a;
                b.receivingOperatorList = !0;
                b.opListReadCapability = (0, v.createPromiseCapability)();
                b.renderTasks = [];
                b.renderTasks.push(c);
                b.operatorList = { fnArray: [], argsArray: [], lastChunk: !1 };
                this.transport.messageHandler.send('RenderPageRequest', {
                  pageIndex: this.pageIndex,
                  intent: 'oplist',
                });
              }
              return b.opListReadCapability.promise;
            },
            streamTextContent: function() {
              var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
              return this.transport.messageHandler.sendWithStream(
                'GetTextContent',
                {
                  pageIndex: this.pageNumber - 1,
                  normalizeWhitespace: !0 === a.normalizeWhitespace,
                  combineTextItems: !0 !== a.disableCombineTextItems,
                },
                {
                  highWaterMark: 100,
                  size: function(a) {
                    return a.items.length;
                  },
                },
              );
            },
            getTextContent: function(a) {
              a = a || {};
              var b = this.streamTextContent(a);
              return new Promise(function(a, c) {
                function d() {
                  f.read().then(function(b) {
                    var c = b.value;
                    b.done ? a(l) : (v.Util.extendObj(l.styles, c.styles), v.Util.appendToArray(l.items, c.items), d());
                  }, c);
                }
                var f = b.getReader(),
                  l = { items: [], styles: Object.create(null) };
                d();
              });
            },
            _destroy: function() {
              this.destroyed = !0;
              this.transport.pageCache[this.pageIndex] = null;
              var a = [];
              Object.keys(this.intentStates).forEach(function(b) {
                'oplist' !== b &&
                  this.intentStates[b].renderTasks.forEach(function(b) {
                    var c = b.capability.promise['catch'](function() {});
                    a.push(c);
                    b.cancel();
                  });
              }, this);
              this.objs.clear();
              this.annotationsPromise = null;
              this.pendingCleanup = !1;
              return Promise.all(a);
            },
            destroy: function() {
              (0, v.deprecated)('page destroy method, use cleanup() instead');
              this.cleanup();
            },
            cleanup: function() {
              this.pendingCleanup = !0;
              this._tryCleanup();
            },
            _tryCleanup: function() {
              this.pendingCleanup &&
                !Object.keys(this.intentStates).some(function(a) {
                  a = this.intentStates[a];
                  return 0 !== a.renderTasks.length || a.receivingOperatorList;
                }, this) &&
                (Object.keys(this.intentStates).forEach(function(a) {
                  delete this.intentStates[a];
                }, this),
                this.objs.clear(),
                (this.annotationsPromise = null),
                (this.pendingCleanup = !1));
            },
            _startRenderPage: function(a, b) {
              var c = this.intentStates[b];
              c.displayReadyCapability && c.displayReadyCapability.resolve(a);
            },
            _renderPageChunk: function(a, b) {
              var c = this.intentStates[b],
                d;
              var f = 0;
              for (d = a.length; f < d; f++)
                c.operatorList.fnArray.push(a.fnArray[f]), c.operatorList.argsArray.push(a.argsArray[f]);
              c.operatorList.lastChunk = a.lastChunk;
              for (f = 0; f < c.renderTasks.length; f++) c.renderTasks[f].operatorListChanged();
              a.lastChunk && ((c.receivingOperatorList = !1), this._tryCleanup());
            },
          };
          return a;
        })(),
        x = (function() {
          function a(b) {
            if (!(this instanceof a)) throw new TypeError('Cannot call a class as a function');
            this._listeners = [];
            this._defer = b;
            this._deferred = Promise.resolve(void 0);
          }
          k(a, [
            {
              key: 'postMessage',
              value: function(a, c) {
                function d(a) {
                  if ('object' !== ('undefined' === typeof a ? 'undefined' : b(a)) || null === a) return a;
                  if (l.has(a)) return l.get(a);
                  var f;
                  if ((f = a.buffer) && (0, v.isArrayBuffer)(f)) {
                    var r = c && 0 <= c.indexOf(f);
                    f = a === f ? a : r ? new a.constructor(f, a.byteOffset, a.byteLength) : new a.constructor(a);
                    l.set(a, f);
                    return f;
                  }
                  f = Array.isArray(a) ? [] : {};
                  l.set(a, f);
                  for (r in a) {
                    for (var g, w = a; !(g = Object.getOwnPropertyDescriptor(w, r)); ) w = Object.getPrototypeOf(w);
                    'undefined' !== typeof g.value && 'function' !== typeof g.value && (f[r] = d(g.value));
                  }
                  return f;
                }
                var f = this;
                if (this._defer) {
                  var l = new WeakMap(),
                    r = { data: d(a) };
                  this._deferred.then(function() {
                    f._listeners.forEach(function(a) {
                      a.call(this, r);
                    }, f);
                  });
                } else
                  this._listeners.forEach(function(b) {
                    b.call(this, { data: a });
                  }, this);
              },
            },
            {
              key: 'addEventListener',
              value: function(a, b) {
                this._listeners.push(b);
              },
            },
            {
              key: 'removeEventListener',
              value: function(a, b) {
                var c = this._listeners.indexOf(b);
                this._listeners.splice(c, 1);
              },
            },
            {
              key: 'terminate',
              value: function() {
                this._listeners = [];
              },
            },
          ]);
          return a;
        })(),
        g = (function() {
          function a() {
            if (f) return f.promise;
            f = (0, v.createPromiseCapability)();
            var a = t(103);
            f.resolve(a.WorkerMessageHandler);
            return f.promise;
          }
          function b(a, b) {
            if (b && l.has(b)) throw Error('Cannot use more than one PDFWorker per port');
            this.name = a;
            this.destroyed = !1;
            this.postMessageTransfers = !0;
            this._readyCapability = (0, v.createPromiseCapability)();
            this._messageHandler = this._webWorker = this._port = null;
            b ? (l.set(b, this), this._initializeFromPort(b)) : this._initialize();
          }
          var c = 0,
            f = void 0,
            l = new WeakMap();
          b.prototype = {
            get promise() {
              return this._readyCapability.promise;
            },
            get port() {
              return this._port;
            },
            get messageHandler() {
              return this._messageHandler;
            },
            _initializeFromPort: function(a) {
              this._port = a;
              this._messageHandler = new v.MessageHandler('main', 'worker', a);
              this._messageHandler.on('ready', function() {});
              this._readyCapability.resolve();
            },
            _initialize: function() {
              this._setupFakeWorker();
            },
            _setupFakeWorker: function() {
              var b = this;
              e || (0, d.getDefaultSetting)('disableWorker') || ((0, v.warn)('Setting up fake worker.'), (e = !0));
              a().then(function(a) {
                if (b.destroyed) b._readyCapability.reject(Error('Worker was destroyed'));
                else {
                  var d = new x(Uint8Array !== Float32Array);
                  b._port = d;
                  var f = 'fake' + c++,
                    l = new v.MessageHandler(f + '_worker', f, d);
                  a.setup(l, d);
                  a = new v.MessageHandler(f, f + '_worker', d);
                  b._messageHandler = a;
                  b._readyCapability.resolve();
                }
              });
            },
            destroy: function() {
              this.destroyed = !0;
              this._webWorker && (this._webWorker.terminate(), (this._webWorker = null));
              l['delete'](this._port);
              this._port = null;
              this._messageHandler && (this._messageHandler.destroy(), (this._messageHandler = null));
            },
          };
          b.fromPort = function(a) {
            return l.has(a) ? l.get(a) : new b(null, a);
          };
          return b;
        })(),
        G = (function() {
          function a(a, b, c, f) {
            this.messageHandler = a;
            this.loadingTask = b;
            this.commonObjs = new l();
            this.fontLoader = new u.FontLoader(b.docId);
            this.CMapReaderFactory = new f({
              baseUrl: (0, d.getDefaultSetting)('cMapUrl'),
              isCompressed: (0, d.getDefaultSetting)('cMapPacked'),
            });
            this.destroyed = !1;
            this._passwordCapability = this.destroyCapability = null;
            this._networkStream = c;
            this._lastProgress = this._fullReader = null;
            this.pageCache = [];
            this.pagePromises = [];
            this.downloadInfoCapability = (0, v.createPromiseCapability)();
            this.setupMessageHandler();
          }
          a.prototype = {
            destroy: function() {
              var a = this;
              if (this.destroyCapability) return this.destroyCapability.promise;
              this.destroyed = !0;
              this.destroyCapability = (0, v.createPromiseCapability)();
              this._passwordCapability &&
                this._passwordCapability.reject(Error('Worker was destroyed during onPassword callback'));
              var b = [];
              this.pageCache.forEach(function(a) {
                a && b.push(a._destroy());
              });
              this.pageCache = [];
              this.pagePromises = [];
              var c = this.messageHandler.sendWithPromise('Terminate', null);
              b.push(c);
              Promise.all(b).then(function() {
                a.fontLoader.clear();
                a._networkStream && a._networkStream.cancelAllRequests();
                a.messageHandler && (a.messageHandler.destroy(), (a.messageHandler = null));
                a.destroyCapability.resolve();
              }, this.destroyCapability.reject);
              return this.destroyCapability.promise;
            },
            setupMessageHandler: function() {
              var a = this.messageHandler,
                b = this.loadingTask;
              a.on(
                'GetReader',
                function(a, b) {
                  var c = this;
                  (0, v.assert)(this._networkStream);
                  this._fullReader = this._networkStream.getFullReader();
                  this._fullReader.onProgress = function(a) {
                    c._lastProgress = { loaded: a.loaded, total: a.total };
                  };
                  b.onPull = function() {
                    c._fullReader
                      .read()
                      .then(function(a) {
                        var c = a.value;
                        a.done
                          ? b.close()
                          : ((0, v.assert)((0, v.isArrayBuffer)(c)), b.enqueue(new Uint8Array(c), 1, [c]));
                      })
                      ['catch'](function(a) {
                        b.error(a);
                      });
                  };
                  b.onCancel = function(a) {
                    c._fullReader.cancel(a);
                  };
                },
                this,
              );
              a.on(
                'ReaderHeadersReady',
                function(a) {
                  var b = this,
                    c = (0, v.createPromiseCapability)(),
                    d = this._fullReader;
                  d.headersReady.then(function() {
                    if (!d.isStreamingSupported || !d.isRangeSupported) {
                      if (b._lastProgress) {
                        var a = b.loadingTask;
                        if (a.onProgress) a.onProgress(b._lastProgress);
                      }
                      d.onProgress = function(a) {
                        var c = b.loadingTask;
                        if (c.onProgress) c.onProgress({ loaded: a.loaded, total: a.total });
                      };
                    }
                    c.resolve({
                      isStreamingSupported: d.isStreamingSupported,
                      isRangeSupported: d.isRangeSupported,
                      contentLength: d.contentLength,
                    });
                  }, c.reject);
                  return c.promise;
                },
                this,
              );
              a.on(
                'GetRangeReader',
                function(a, b) {
                  (0, v.assert)(this._networkStream);
                  var c = this._networkStream.getRangeReader(a.begin, a.end);
                  b.onPull = function() {
                    c.read()
                      .then(function(a) {
                        var c = a.value;
                        a.done
                          ? b.close()
                          : ((0, v.assert)((0, v.isArrayBuffer)(c)), b.enqueue(new Uint8Array(c), 1, [c]));
                      })
                      ['catch'](function(a) {
                        b.error(a);
                      });
                  };
                  b.onCancel = function(a) {
                    c.cancel(a);
                  };
                },
                this,
              );
              a.on(
                'GetDoc',
                function(a) {
                  var b = a.pdfInfo;
                  this.numPages = a.pdfInfo.numPages;
                  a = this.loadingTask;
                  this.pdfDocument = b = new c(b, this, a);
                  a._capability.resolve(b);
                },
                this,
              );
              a.on(
                'PasswordRequest',
                function(a) {
                  var c = this;
                  this._passwordCapability = (0, v.createPromiseCapability)();
                  if (b.onPassword)
                    b.onPassword(function(a) {
                      c._passwordCapability.resolve({ password: a });
                    }, a.code);
                  else this._passwordCapability.reject(new v.PasswordException(a.message, a.code));
                  return this._passwordCapability.promise;
                },
                this,
              );
              a.on(
                'PasswordException',
                function(a) {
                  b._capability.reject(new v.PasswordException(a.message, a.code));
                },
                this,
              );
              a.on(
                'InvalidPDF',
                function(a) {
                  this.loadingTask._capability.reject(new v.InvalidPDFException(a.message));
                },
                this,
              );
              a.on(
                'MissingPDF',
                function(a) {
                  this.loadingTask._capability.reject(new v.MissingPDFException(a.message));
                },
                this,
              );
              a.on(
                'UnexpectedResponse',
                function(a) {
                  this.loadingTask._capability.reject(new v.UnexpectedResponseException(a.message, a.status));
                },
                this,
              );
              a.on(
                'UnknownError',
                function(a) {
                  this.loadingTask._capability.reject(new v.UnknownErrorException(a.message, a.details));
                },
                this,
              );
              a.on(
                'DataLoaded',
                function(a) {
                  this.downloadInfoCapability.resolve(a);
                },
                this,
              );
              a.on('PDFManagerReady', function(a) {}, this);
              a.on(
                'StartRenderPage',
                function(a) {
                  if (!this.destroyed) {
                    var b = this.pageCache[a.pageIndex];
                    b.stats.timeEnd('Page Request');
                    b._startRenderPage(a.transparency, a.intent);
                  }
                },
                this,
              );
              a.on(
                'RenderPageChunk',
                function(a) {
                  this.destroyed || this.pageCache[a.pageIndex]._renderPageChunk(a.operatorList, a.intent);
                },
                this,
              );
              a.on(
                'commonobj',
                function(a) {
                  var b = this;
                  if (!this.destroyed) {
                    var c = a[0],
                      f = a[1];
                    if (!this.commonObjs.hasData(c))
                      switch (f) {
                        case 'Font':
                          a = a[2];
                          if ('error' in a) {
                            a = a.error;
                            (0, v.warn)('Error during font loading: ' + a);
                            this.commonObjs.resolve(c, a);
                            break;
                          }
                          f = null;
                          (0, d.getDefaultSetting)('pdfBug') &&
                            C['default'].FontInspector &&
                            C['default'].FontInspector.enabled &&
                            (f = {
                              registerFont: function(a, b) {
                                C['default'].FontInspector.fontAdded(a, b);
                              },
                            });
                          var l = new u.FontFaceObject(a, {
                            isEvalSuported: (0, d.getDefaultSetting)('isEvalSupported'),
                            disableFontFace: (0, d.getDefaultSetting)('disableFontFace'),
                            fontRegistry: f,
                          });
                          this.fontLoader.bind([l], function(a) {
                            b.commonObjs.resolve(c, l);
                          });
                          break;
                        case 'FontPath':
                          this.commonObjs.resolve(c, a[2]);
                          break;
                        default:
                          throw Error('Got unknown common object type ' + f);
                      }
                  }
                },
                this,
              );
              a.on(
                'obj',
                function(a) {
                  if (!this.destroyed) {
                    var b = a[0],
                      c = a[2],
                      d = this.pageCache[a[1]];
                    if (!d.objs.hasData(b))
                      switch (c) {
                        case 'JpegStream':
                          a = a[3];
                          (0, v.loadJpegStream)(b, a, d.objs);
                          break;
                        case 'Image':
                          a = a[3];
                          d.objs.resolve(b, a);
                          a && 'data' in a && 8e6 < a.data.length && (d.cleanupAfterRender = !0);
                          break;
                        default:
                          throw Error('Got unknown object type ' + c);
                      }
                  }
                },
                this,
              );
              a.on(
                'DocProgress',
                function(a) {
                  if (!this.destroyed) {
                    var b = this.loadingTask;
                    if (b.onProgress) b.onProgress({ loaded: a.loaded, total: a.total });
                  }
                },
                this,
              );
              a.on(
                'PageError',
                function(a) {
                  if (!this.destroyed) {
                    var b = this.pageCache[a.pageNum - 1].intentStates[a.intent];
                    if (b.displayReadyCapability) b.displayReadyCapability.reject(a.error);
                    else throw Error(a.error);
                    if (b.operatorList)
                      for (b.operatorList.lastChunk = !0, a = 0; a < b.renderTasks.length; a++)
                        b.renderTasks[a].operatorListChanged();
                  }
                },
                this,
              );
              a.on(
                'UnsupportedFeature',
                function(a) {
                  if (!this.destroyed) {
                    a = a.featureId;
                    var b = this.loadingTask;
                    if (b.onUnsupportedFeature) b.onUnsupportedFeature(a);
                    r.notify(a);
                  }
                },
                this,
              );
              a.on(
                'JpegDecode',
                function(a) {
                  if (this.destroyed) return Promise.reject(Error('Worker was destroyed'));
                  if ('undefined' === typeof document) return Promise.reject(Error('"document" is not defined.'));
                  var b = a[0],
                    c = a[1];
                  return 3 !== c && 1 !== c
                    ? Promise.reject(Error('Only 3 components or 1 component can be returned'))
                    : new Promise(function(a, d) {
                        var f = new Image();
                        f.onload = function() {
                          var b = f.width,
                            d = f.height,
                            l = b * d,
                            r = 4 * l;
                          l = new Uint8Array(l * c);
                          var g = document.createElement('canvas');
                          g.width = b;
                          g.height = d;
                          g = g.getContext('2d');
                          g.drawImage(f, 0, 0);
                          g = g.getImageData(0, 0, b, d).data;
                          var w, q;
                          if (3 === c)
                            for (q = w = 0; w < r; w += 4, q += 3)
                              (l[q] = g[w]), (l[q + 1] = g[w + 1]), (l[q + 2] = g[w + 2]);
                          else if (1 === c) for (q = w = 0; w < r; w += 4, q++) l[q] = g[w];
                          a({ data: l, width: b, height: d });
                        };
                        f.onerror = function() {
                          d(Error('JpegDecode failed to load image'));
                        };
                        f.src = b;
                      });
                },
                this,
              );
              a.on(
                'FetchBuiltInCMap',
                function(a) {
                  return this.destroyed
                    ? Promise.reject(Error('Worker was destroyed'))
                    : this.CMapReaderFactory.fetch({ name: a.name });
                },
                this,
              );
            },
            getData: function() {
              return this.messageHandler.sendWithPromise('GetData', null);
            },
            getPage: function(a, b) {
              var c = this;
              if (!Number.isInteger(a) || 0 >= a || a > this.numPages)
                return Promise.reject(Error('Invalid page request'));
              var d = a - 1;
              if (d in this.pagePromises) return this.pagePromises[d];
              var f = this.messageHandler.sendWithPromise('GetPage', { pageIndex: d }).then(function(a) {
                if (c.destroyed) throw Error('Transport destroyed');
                a = new q(d, a, c);
                return (c.pageCache[d] = a);
              });
              return (this.pagePromises[d] = f);
            },
            getPageIndex: function(a) {
              return this.messageHandler.sendWithPromise('GetPageIndex', { ref: a })['catch'](function(a) {
                return Promise.reject(Error(a));
              });
            },
            getAnnotations: function(a, b) {
              return this.messageHandler.sendWithPromise('GetAnnotations', { pageIndex: a, intent: b });
            },
            getDestinations: function() {
              return this.messageHandler.sendWithPromise('GetDestinations', null);
            },
            getDestination: function(a) {
              return this.messageHandler.sendWithPromise('GetDestination', { id: a });
            },
            getPageLabels: function() {
              return this.messageHandler.sendWithPromise('GetPageLabels', null);
            },
            getPageMode: function() {
              return this.messageHandler.sendWithPromise('GetPageMode', null);
            },
            getAttachments: function() {
              return this.messageHandler.sendWithPromise('GetAttachments', null);
            },
            getJavaScript: function() {
              return this.messageHandler.sendWithPromise('GetJavaScript', null);
            },
            getOutline: function() {
              return this.messageHandler.sendWithPromise('GetOutline', null);
            },
            getMetadata: function() {
              return this.messageHandler.sendWithPromise('GetMetadata', null).then(function(a) {
                return { info: a[0], metadata: a[1] ? new B.Metadata(a[1]) : null };
              });
            },
            getStats: function() {
              return this.messageHandler.sendWithPromise('GetStats', null);
            },
            startCleanup: function() {
              var a = this;
              this.messageHandler.sendWithPromise('Cleanup', null).then(function() {
                for (var b = 0, c = a.pageCache.length; b < c; b++) {
                  var d = a.pageCache[b];
                  d && d.cleanup();
                }
                a.commonObjs.clear();
                a.fontLoader.clear();
              });
            },
          };
          return a;
        })(),
        l = (function() {
          function a() {
            this.objs = Object.create(null);
          }
          a.prototype = {
            ensureObj: function(a) {
              if (this.objs[a]) return this.objs[a];
              var b = { capability: (0, v.createPromiseCapability)(), data: null, resolved: !1 };
              return (this.objs[a] = b);
            },
            get: function(a, b) {
              if (b) return this.ensureObj(a).capability.promise.then(b), null;
              var c = this.objs[a];
              if (!c || !c.resolved) throw Error("Requesting object that isn't resolved yet " + a);
              return c.data;
            },
            resolve: function(a, b) {
              var c = this.ensureObj(a);
              c.resolved = !0;
              c.data = b;
              c.capability.resolve(b);
            },
            isResolved: function(a) {
              var b = this.objs;
              return b[a] ? b[a].resolved : !1;
            },
            hasData: function(a) {
              return this.isResolved(a);
            },
            getData: function(a) {
              var b = this.objs;
              return b[a] && b[a].resolved ? b[a].data : null;
            },
            clear: function() {
              this.objs = Object.create(null);
            },
          };
          return a;
        })(),
        J = (function() {
          function a(a) {
            this._internalRenderTask = a;
            this.onContinue = null;
          }
          a.prototype = {
            get promise() {
              return this._internalRenderTask.capability.promise;
            },
            cancel: function() {
              this._internalRenderTask.cancel();
            },
            then: function(a, b) {
              return this.promise.then.apply(this.promise, arguments);
            },
          };
          return a;
        })(),
        f = (function() {
          function a(a, b, c, d, f, l, r) {
            this.callback = a;
            this.params = b;
            this.objs = c;
            this.commonObjs = d;
            this.operatorListIdx = null;
            this.operatorList = f;
            this.pageNumber = l;
            this.canvasFactory = r;
            this.running = !1;
            this.graphicsReadyCallback = null;
            this.cancelled = this.useRequestAnimationFrame = this.graphicsReady = !1;
            this.capability = (0, v.createPromiseCapability)();
            this.task = new J(this);
            this._continueBound = this._continue.bind(this);
            this._scheduleNextBound = this._scheduleNext.bind(this);
            this._nextBound = this._next.bind(this);
            this._canvas = b.canvasContext.canvas;
          }
          var b = new WeakMap();
          a.prototype = {
            initializeGraphics: function(a) {
              if (this._canvas) {
                if (b.has(this._canvas))
                  throw Error(
                    'Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.',
                  );
                b.set(this._canvas, this);
              }
              if (!this.cancelled) {
                (0, d.getDefaultSetting)('pdfBug') &&
                  C['default'].StepperManager &&
                  C['default'].StepperManager.enabled &&
                  ((this.stepper = C['default'].StepperManager.create(this.pageNumber - 1)),
                  this.stepper.init(this.operatorList),
                  (this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint()));
                var c = this.params;
                this.gfx = new z.CanvasGraphics(
                  c.canvasContext,
                  this.commonObjs,
                  this.objs,
                  this.canvasFactory,
                  c.imageLayer,
                );
                this.gfx.beginDrawing({
                  transform: c.transform,
                  viewport: c.viewport,
                  transparency: a,
                  background: c.background,
                });
                this.operatorListIdx = 0;
                this.graphicsReady = !0;
                this.graphicsReadyCallback && this.graphicsReadyCallback();
              }
            },
            cancel: function() {
              this.running = !1;
              this.cancelled = !0;
              this._canvas && b['delete'](this._canvas);
              (0, d.getDefaultSetting)('pdfjsNext')
                ? this.callback(
                    new d.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'),
                  )
                : this.callback('cancelled');
            },
            operatorListChanged: function() {
              this.graphicsReady
                ? (this.stepper && this.stepper.updateOperatorList(this.operatorList), this.running || this._continue())
                : this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
            },
            _continue: function() {
              this.running = !0;
              if (!this.cancelled)
                if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                else this._scheduleNext();
            },
            _scheduleNext: function() {
              this.useRequestAnimationFrame && 'undefined' !== typeof window
                ? window.requestAnimationFrame(this._nextBound)
                : Promise.resolve(void 0).then(this._nextBound);
            },
            _next: function() {
              this.cancelled ||
                ((this.operatorListIdx = this.gfx.executeOperatorList(
                  this.operatorList,
                  this.operatorListIdx,
                  this._continueBound,
                  this.stepper,
                )),
                this.operatorListIdx === this.operatorList.argsArray.length &&
                  ((this.running = !1),
                  this.operatorList.lastChunk &&
                    (this.gfx.endDrawing(), this._canvas && b['delete'](this._canvas), this.callback())));
            },
          };
          return a;
        })(),
        r = (function() {
          var a = [];
          return {
            listen: function(b) {
              (0, v.deprecated)(
                'Global UnsupportedManager.listen is used:  use PDFDocumentLoadingTask.onUnsupportedFeature instead',
              );
              a.push(b);
            },
            notify: function(b) {
              for (var c = 0, d = a.length; c < d; c++) a[c](b);
            },
          };
        })();
      m.version = '1.9.597';
      m.build = 'f3987bba';
      m.getDocument = function(c, f, l, r) {
        var w = new p();
        1 < arguments.length &&
          (0, v.deprecated)(
            'getDocument is called with pdfDataRangeTransport, passwordCallback or progressCallback argument',
          );
        f &&
          (f instanceof A ||
            ((f = Object.create(f)),
            (f.length = c.length),
            (f.initialData = c.initialData),
            f.abort || (f.abort = function() {})),
          (c = Object.create(c)),
          (c.range = f));
        w.onPassword = l || null;
        w.onProgress = r || null;
        if ('string' === typeof c) var q = { url: c };
        else if ((0, v.isArrayBuffer)(c)) q = { data: c };
        else if (c instanceof A) q = { range: c };
        else {
          if ('object' !== ('undefined' === typeof c ? 'undefined' : b(c)))
            throw Error('Invalid parameter in getDocument, need either Uint8Array, string or a parameter object');
          if (!c.url && !c.data && !c.range) throw Error('Invalid parameter object: need either .data, .range or .url');
          q = c;
        }
        var e = {},
          x = null,
          D = null,
          O = d.DOMCMapReaderFactory,
          N;
        for (N in q)
          if ('url' === N && 'undefined' !== typeof window) e[N] = new URL(q[N], window.location).href;
          else if ('range' === N) x = q[N];
          else if ('worker' === N) D = q[N];
          else if ('data' !== N || q[N] instanceof Uint8Array) 'CMapReaderFactory' === N ? (O = q[N]) : (e[N] = q[N]);
          else {
            var I = q[N];
            if ('string' === typeof I) e[N] = (0, v.stringToBytes)(I);
            else if ('object' !== ('undefined' === typeof I ? 'undefined' : b(I)) || null === I || isNaN(I.length))
              if ((0, v.isArrayBuffer)(I)) e[N] = new Uint8Array(I);
              else
                throw Error(
                  'Invalid PDF binary data: either typed array, string or array-like object is expected in the data property.',
                );
            else e[N] = new Uint8Array(I);
          }
        e.rangeChunkSize = e.rangeChunkSize || 65536;
        e.ignoreErrors = !0 !== e.stopAtErrors;
        void 0 !== e.disableNativeImageDecoder &&
          (0, v.deprecated)('parameter disableNativeImageDecoder, use nativeImageDecoderSupport instead');
        e.nativeImageDecoderSupport =
          e.nativeImageDecoderSupport ||
          (!0 === e.disableNativeImageDecoder ? v.NativeImageDecoding.NONE : v.NativeImageDecoding.DECODE);
        e.nativeImageDecoderSupport !== v.NativeImageDecoding.DECODE &&
          e.nativeImageDecoderSupport !== v.NativeImageDecoding.NONE &&
          e.nativeImageDecoderSupport !== v.NativeImageDecoding.DISPLAY &&
          ((0, v.warn)('Invalid parameter nativeImageDecoderSupport: need a state of enum {NativeImageDecoding}'),
          (e.nativeImageDecoderSupport = v.NativeImageDecoding.DECODE));
        D || ((D = (q = (0, d.getDefaultSetting)('workerPort')) ? g.fromPort(q) : new g()), (w._worker = D));
        var k = w.docId;
        D.promise
          .then(function() {
            if (w.destroyed) throw Error('Loading aborted');
            return a(D, e, x, k).then(function(a) {
              if (w.destroyed) throw Error('Loading aborted');
              var b = void 0;
              x
                ? (b = new n.PDFDataTransportStream(e, x))
                : e.data || (b = new h({ source: e, disableRange: (0, d.getDefaultSetting)('disableRange') }));
              a = new v.MessageHandler(k, a, D.port);
              a.postMessageTransfers = D.postMessageTransfers;
              b = new G(a, w, b, O);
              w._transport = b;
              a.send('Ready', null);
            });
          })
          ['catch'](w._capability.reject);
        return w;
      };
      m.LoopbackPort = x;
      m.PDFDataRangeTransport = A;
      m.PDFWorker = g;
      m.PDFDocumentProxy = c;
      m.PDFPageProxy = q;
      m.setPDFNetworkStreamClass = function(a) {
        h = a;
      };
      m._UnsupportedManager = r;
      m.version = '1.9.597';
      m.build = 'f3987bba';
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.WebGLUtils = void 0;
      var a = t(7),
        k = t(0);
      y = (function() {
        function b(a, b, d) {
          d = a.createShader(d);
          a.shaderSource(d, b);
          a.compileShader(d);
          if (!a.getShaderParameter(d, a.COMPILE_STATUS))
            throw ((a = a.getShaderInfoLog(d)), Error('Error during shader compilation: ' + a));
          return d;
        }
        function v(a, b) {
          for (var d = a.createProgram(), e = 0, c = b.length; e < c; ++e) a.attachShader(d, b[e]);
          a.linkProgram(d);
          if (!a.getProgramParameter(d, a.LINK_STATUS))
            throw ((d = a.getProgramInfoLog(d)), Error('Error during program linking: ' + d));
          return d;
        }
        function d(a, b, d) {
          a.activeTexture(d);
          d = a.createTexture();
          a.bindTexture(a.TEXTURE_2D, d);
          a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE);
          a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE);
          a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.NEAREST);
          a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, a.NEAREST);
          a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, b);
          return d;
        }
        function u() {
          m || ((C = document.createElement('canvas')), (m = C.getContext('webgl', { premultipliedalpha: !1 })));
        }
        var m,
          C,
          B = null,
          n = null;
        return {
          get isEnabled() {
            if ((0, a.getDefaultSetting)('disableWebGL')) return !1;
            var b = !1;
            try {
              u(), (b = !!m);
            } catch (h) {}
            return (0, k.shadow)(this, 'isEnabled', b);
          },
          composeSMask: function(a, h, n) {
            var e = a.width,
              c = a.height;
            if (!B) {
              u();
              var q = C;
              C = null;
              var x = m;
              m = null;
              var g = b(
                  x,
                  '  attribute vec2 a_position;                                      attribute vec2 a_texCoord;                                                                                                      uniform vec2 u_resolution;                                                                                                      varying vec2 v_texCoord;                                                                                                        void main() {                                                     vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;       gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);                                                                              v_texCoord = a_texCoord;                                      }                                                             ',
                  x.VERTEX_SHADER,
                ),
                p = b(
                  x,
                  '  precision mediump float;                                                                                                        uniform vec4 u_backdrop;                                        uniform int u_subtype;                                          uniform sampler2D u_image;                                      uniform sampler2D u_mask;                                                                                                       varying vec2 v_texCoord;                                                                                                        void main() {                                                     vec4 imageColor = texture2D(u_image, v_texCoord);               vec4 maskColor = texture2D(u_mask, v_texCoord);                 if (u_backdrop.a > 0.0) {                                         maskColor.rgb = maskColor.rgb * maskColor.a +                                   u_backdrop.rgb * (1.0 - maskColor.a);         }                                                               float lum;                                                      if (u_subtype == 0) {                                             lum = maskColor.a;                                            } else {                                                          lum = maskColor.r * 0.3 + maskColor.g * 0.59 +                        maskColor.b * 0.11;                                     }                                                               imageColor.a *= lum;                                            imageColor.rgb *= imageColor.a;                                 gl_FragColor = imageColor;                                    }                                                             ',
                  x.FRAGMENT_SHADER,
                ),
                l = v(x, [g, p]);
              x.useProgram(l);
              g = {};
              g.gl = x;
              g.canvas = q;
              g.resolutionLocation = x.getUniformLocation(l, 'u_resolution');
              g.positionLocation = x.getAttribLocation(l, 'a_position');
              g.backdropLocation = x.getUniformLocation(l, 'u_backdrop');
              g.subtypeLocation = x.getUniformLocation(l, 'u_subtype');
              q = x.getAttribLocation(l, 'a_texCoord');
              p = x.getUniformLocation(l, 'u_image');
              l = x.getUniformLocation(l, 'u_mask');
              var k = x.createBuffer();
              x.bindBuffer(x.ARRAY_BUFFER, k);
              x.bufferData(x.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]), x.STATIC_DRAW);
              x.enableVertexAttribArray(q);
              x.vertexAttribPointer(q, 2, x.FLOAT, !1, 0, 0);
              x.uniform1i(p, 0);
              x.uniform1i(l, 1);
              B = g;
            }
            x = B;
            g = x.canvas;
            q = x.gl;
            g.width = e;
            g.height = c;
            q.viewport(0, 0, q.drawingBufferWidth, q.drawingBufferHeight);
            q.uniform2f(x.resolutionLocation, e, c);
            n.backdrop
              ? q.uniform4f(x.resolutionLocation, n.backdrop[0], n.backdrop[1], n.backdrop[2], 1)
              : q.uniform4f(x.resolutionLocation, 0, 0, 0, 0);
            q.uniform1i(x.subtypeLocation, 'Luminosity' === n.subtype ? 1 : 0);
            a = d(q, a, q.TEXTURE0);
            h = d(q, h, q.TEXTURE1);
            n = q.createBuffer();
            q.bindBuffer(q.ARRAY_BUFFER, n);
            q.bufferData(q.ARRAY_BUFFER, new Float32Array([0, 0, e, 0, 0, c, 0, c, e, 0, e, c]), q.STATIC_DRAW);
            q.enableVertexAttribArray(x.positionLocation);
            q.vertexAttribPointer(x.positionLocation, 2, q.FLOAT, !1, 0, 0);
            q.clearColor(0, 0, 0, 0);
            q.enable(q.BLEND);
            q.blendFunc(q.ONE, q.ONE_MINUS_SRC_ALPHA);
            q.clear(q.COLOR_BUFFER_BIT);
            q.drawArrays(q.TRIANGLES, 0, 6);
            q.flush();
            q.deleteTexture(a);
            q.deleteTexture(h);
            q.deleteBuffer(n);
            return g;
          },
          drawFigures: function(a, d, p, A, c) {
            if (!n) {
              u();
              var q = C;
              C = null;
              var e = m;
              m = null;
              var g = b(
                  e,
                  '  attribute vec2 a_position;                                      attribute vec3 a_color;                                                                                                         uniform vec2 u_resolution;                                      uniform vec2 u_scale;                                           uniform vec2 u_offset;                                                                                                          varying vec4 v_color;                                                                                                           void main() {                                                     vec2 position = (a_position + u_offset) * u_scale;              vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;         gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);                                                                              v_color = vec4(a_color / 255.0, 1.0);                         }                                                             ',
                  e.VERTEX_SHADER,
                ),
                h = b(
                  e,
                  '  precision mediump float;                                                                                                        varying vec4 v_color;                                                                                                           void main() {                                                     gl_FragColor = v_color;                                       }                                                             ',
                  e.FRAGMENT_SHADER,
                );
              g = v(e, [g, h]);
              e.useProgram(g);
              h = {};
              h.gl = e;
              h.canvas = q;
              h.resolutionLocation = e.getUniformLocation(g, 'u_resolution');
              h.scaleLocation = e.getUniformLocation(g, 'u_scale');
              h.offsetLocation = e.getUniformLocation(g, 'u_offset');
              h.positionLocation = e.getAttribLocation(g, 'a_position');
              h.colorLocation = e.getAttribLocation(g, 'a_color');
              n = h;
            }
            q = n;
            e = q.canvas;
            g = q.gl;
            e.width = a;
            e.height = d;
            g.viewport(0, 0, g.drawingBufferWidth, g.drawingBufferHeight);
            g.uniform2f(q.resolutionLocation, a, d);
            a = 0;
            var l;
            var k = 0;
            for (l = A.length; k < l; k++)
              switch (A[k].type) {
                case 'lattice':
                  var f = (A[k].coords.length / A[k].verticesPerRow) | 0;
                  a += (f - 1) * (A[k].verticesPerRow - 1) * 6;
                  break;
                case 'triangles':
                  a += A[k].coords.length;
              }
            h = new Float32Array(2 * a);
            d = new Uint8Array(3 * a);
            var r = c.coords,
              D = c.colors,
              L = 0,
              I = 0;
            k = 0;
            for (l = A.length; k < l; k++) {
              f = A[k];
              var w = f.coords,
                E = f.colors;
              switch (f.type) {
                case 'lattice':
                  var F = f.verticesPerRow;
                  f = (w.length / F) | 0;
                  for (var K = 1; K < f; K++)
                    for (var H = K * F + 1, M = 1; M < F; M++, H++)
                      (h[L] = r[w[H - F - 1]]),
                        (h[L + 1] = r[w[H - F - 1] + 1]),
                        (h[L + 2] = r[w[H - F]]),
                        (h[L + 3] = r[w[H - F] + 1]),
                        (h[L + 4] = r[w[H - 1]]),
                        (h[L + 5] = r[w[H - 1] + 1]),
                        (d[I] = D[E[H - F - 1]]),
                        (d[I + 1] = D[E[H - F - 1] + 1]),
                        (d[I + 2] = D[E[H - F - 1] + 2]),
                        (d[I + 3] = D[E[H - F]]),
                        (d[I + 4] = D[E[H - F] + 1]),
                        (d[I + 5] = D[E[H - F] + 2]),
                        (d[I + 6] = D[E[H - 1]]),
                        (d[I + 7] = D[E[H - 1] + 1]),
                        (d[I + 8] = D[E[H - 1] + 2]),
                        (h[L + 6] = h[L + 2]),
                        (h[L + 7] = h[L + 3]),
                        (h[L + 8] = h[L + 4]),
                        (h[L + 9] = h[L + 5]),
                        (h[L + 10] = r[w[H]]),
                        (h[L + 11] = r[w[H] + 1]),
                        (d[I + 9] = d[I + 3]),
                        (d[I + 10] = d[I + 4]),
                        (d[I + 11] = d[I + 5]),
                        (d[I + 12] = d[I + 6]),
                        (d[I + 13] = d[I + 7]),
                        (d[I + 14] = d[I + 8]),
                        (d[I + 15] = D[E[H]]),
                        (d[I + 16] = D[E[H] + 1]),
                        (d[I + 17] = D[E[H] + 2]),
                        (L += 12),
                        (I += 18);
                  break;
                case 'triangles':
                  for (f = 0, F = w.length; f < F; f++)
                    (h[L] = r[w[f]]),
                      (h[L + 1] = r[w[f] + 1]),
                      (d[I] = D[E[f]]),
                      (d[I + 1] = D[E[f] + 1]),
                      (d[I + 2] = D[E[f] + 2]),
                      (L += 2),
                      (I += 3);
              }
            }
            p ? g.clearColor(p[0] / 255, p[1] / 255, p[2] / 255, 1) : g.clearColor(0, 0, 0, 0);
            g.clear(g.COLOR_BUFFER_BIT);
            p = g.createBuffer();
            g.bindBuffer(g.ARRAY_BUFFER, p);
            g.bufferData(g.ARRAY_BUFFER, h, g.STATIC_DRAW);
            g.enableVertexAttribArray(q.positionLocation);
            g.vertexAttribPointer(q.positionLocation, 2, g.FLOAT, !1, 0, 0);
            A = g.createBuffer();
            g.bindBuffer(g.ARRAY_BUFFER, A);
            g.bufferData(g.ARRAY_BUFFER, d, g.STATIC_DRAW);
            g.enableVertexAttribArray(q.colorLocation);
            g.vertexAttribPointer(q.colorLocation, 3, g.UNSIGNED_BYTE, !1, 0, 0);
            g.uniform2f(q.scaleLocation, c.scaleX, c.scaleY);
            g.uniform2f(q.offsetLocation, c.offsetX, c.offsetY);
            g.drawArrays(g.TRIANGLES, 0, a);
            g.flush();
            g.deleteBuffer(p);
            g.deleteBuffer(A);
            return e;
          },
          clear: function() {
            B && B.canvas && ((B.canvas.width = 0), (B.canvas.height = 0));
            n && n.canvas && ((n.canvas.width = 0), (n.canvas.height = 0));
            n = B = null;
          },
        };
      })();
      m.WebGLUtils = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.Metadata = void 0;
      var a = (function() {
          function a(a, b) {
            for (var d = 0; d < b.length; d++) {
              var k = b[d];
              k.enumerable = k.enumerable || !1;
              k.configurable = !0;
              'value' in k && (k.writable = !0);
              Object.defineProperty(a, k.key, k);
            }
          }
          return function(b, k, v) {
            k && a(b.prototype, k);
            v && a(b, v);
            return b;
          };
        })(),
        k = t(0),
        b = t(7);
      y = (function() {
        function v(a) {
          if (!(this instanceof v)) throw new TypeError('Cannot call a class as a function');
          (0, k.assert)('string' === typeof a, 'Metadata: input is not a string');
          a = this._repair(a);
          a = new b.SimpleXMLParser().parseFromString(a);
          this._metadata = Object.create(null);
          this._parse(a);
        }
        a(v, [
          {
            key: '_repair',
            value: function(a) {
              return a.replace(/>\\376\\377([^<]+)/g, function(a, b) {
                for (
                  var d = b.replace(/\\([0-3])([0-7])([0-7])/g, function(a, b, c, d) {
                      return String.fromCharCode(64 * b + 8 * c + 1 * d);
                    }),
                    k = '',
                    n = 0,
                    e = d.length;
                  n < e;
                  n += 2
                ) {
                  var h = 256 * d.charCodeAt(n) + d.charCodeAt(n + 1);
                  k =
                    32 <= h && 127 > h && 60 !== h && 62 !== h && 38 !== h
                      ? k + String.fromCharCode(h)
                      : k + ('&#x' + (65536 + h).toString(16).substring(1) + ';');
                }
                return '>' + k;
              });
            },
          },
          {
            key: '_parse',
            value: function(a) {
              a = a.documentElement;
              if ('rdf:rdf' !== a.nodeName.toLowerCase())
                for (a = a.firstChild; a && 'rdf:rdf' !== a.nodeName.toLowerCase(); ) a = a.nextSibling;
              var b = a ? a.nodeName.toLowerCase() : null;
              if (a && 'rdf:rdf' === b && a.hasChildNodes()) {
                a = a.childNodes;
                b = 0;
                for (var d = a.length; b < d; b++) {
                  var k = a[b];
                  if ('rdf:description' === k.nodeName.toLowerCase())
                    for (var v = 0, n = k.childNodes.length; v < n; v++)
                      if ('#text' !== k.childNodes[v].nodeName.toLowerCase()) {
                        var e = k.childNodes[v],
                          h = e.nodeName.toLowerCase();
                        this._metadata[h] = e.textContent.trim();
                      }
                }
              }
            },
          },
          {
            key: 'get',
            value: function(a) {
              return this._metadata[a] || null;
            },
          },
          {
            key: 'getAll',
            value: function() {
              return this._metadata;
            },
          },
          {
            key: 'has',
            value: function(a) {
              return 'undefined' !== typeof this._metadata[a];
            },
          },
          {
            key: 'metadata',
            get: function() {
              (0, k.deprecated)('`metadata` getter; use `getAll()` instead.');
              return this.getAll();
            },
          },
        ]);
        return v;
      })();
      m.Metadata = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.ChunkedStreamManager = m.ChunkedStream = void 0;
      var a = t(0),
        k = (function() {
          function b(a, b, k) {
            this.bytes = new Uint8Array(a);
            this.pos = this.start = 0;
            this.end = a;
            this.chunkSize = b;
            this.loadedChunks = [];
            this.numChunksLoaded = 0;
            this.numChunks = Math.ceil(a / b);
            this.manager = k;
            this.progressiveDataLength = 0;
            this.lastSuccessfulEnsureByteChunk = -1;
          }
          b.prototype = {
            getMissingChunks: function() {
              for (var a = [], b = 0, k = this.numChunks; b < k; ++b) this.loadedChunks[b] || a.push(b);
              return a;
            },
            getBaseStreams: function() {
              return [this];
            },
            allChunksLoaded: function() {
              return this.numChunksLoaded === this.numChunks;
            },
            onReceiveData: function(a, b) {
              var d = a + b.byteLength;
              if (0 !== a % this.chunkSize) throw Error('Bad begin offset: ' + a);
              var k = this.bytes.length;
              if (0 !== d % this.chunkSize && d !== k) throw Error('Bad end offset: ' + d);
              this.bytes.set(new Uint8Array(b), a);
              k = this.chunkSize;
              d = Math.floor((d - 1) / k) + 1;
              for (k = Math.floor(a / k); k < d; ++k)
                this.loadedChunks[k] || ((this.loadedChunks[k] = !0), ++this.numChunksLoaded);
            },
            onReceiveProgressiveData: function(a) {
              var b = this.progressiveDataLength,
                k = Math.floor(b / this.chunkSize);
              this.bytes.set(new Uint8Array(a), b);
              this.progressiveDataLength = b += a.byteLength;
              for (a = b >= this.end ? this.numChunks : Math.floor(b / this.chunkSize); k < a; ++k)
                this.loadedChunks[k] || ((this.loadedChunks[k] = !0), ++this.numChunksLoaded);
            },
            ensureByte: function(b) {
              var d = Math.floor(b / this.chunkSize);
              if (d !== this.lastSuccessfulEnsureByteChunk) {
                if (!this.loadedChunks[d]) throw new a.MissingDataException(b, b + 1);
                this.lastSuccessfulEnsureByteChunk = d;
              }
            },
            ensureRange: function(b, d) {
              if (!(b >= d || d <= this.progressiveDataLength)) {
                var k = this.chunkSize,
                  v = Math.floor((d - 1) / k) + 1;
                for (k = Math.floor(b / k); k < v; ++k)
                  if (!this.loadedChunks[k]) throw new a.MissingDataException(b, d);
              }
            },
            nextEmptyChunk: function(a) {
              for (var b, k = this.numChunks, v = 0; v < k; ++v)
                if (((b = (a + v) % k), !this.loadedChunks[b])) return b;
              return null;
            },
            hasChunk: function(a) {
              return !!this.loadedChunks[a];
            },
            get length() {
              return this.end - this.start;
            },
            get isEmpty() {
              return 0 === this.length;
            },
            getByte: function() {
              var a = this.pos;
              if (a >= this.end) return -1;
              this.ensureByte(a);
              return this.bytes[this.pos++];
            },
            getUint16: function() {
              var a = this.getByte(),
                b = this.getByte();
              return -1 === a || -1 === b ? -1 : (a << 8) + b;
            },
            getInt32: function() {
              var a = this.getByte(),
                b = this.getByte(),
                k = this.getByte(),
                m = this.getByte();
              return (a << 24) + (b << 16) + (k << 8) + m;
            },
            getBytes: function(a) {
              var b = this.bytes,
                k = this.pos,
                m = this.end;
              if (!a) return this.ensureRange(k, m), b.subarray(k, m);
              a = k + a;
              a > m && (a = m);
              this.ensureRange(k, a);
              this.pos = a;
              return b.subarray(k, a);
            },
            peekByte: function() {
              var a = this.getByte();
              this.pos--;
              return a;
            },
            peekBytes: function(a) {
              a = this.getBytes(a);
              this.pos -= a.length;
              return a;
            },
            getByteRange: function(a, b) {
              this.ensureRange(a, b);
              return this.bytes.subarray(a, b);
            },
            skip: function(a) {
              a || (a = 1);
              this.pos += a;
            },
            reset: function() {
              this.pos = this.start;
            },
            moveStart: function() {
              this.start = this.pos;
            },
            makeSubStream: function(a, b, k) {
              function d() {}
              this.ensureRange(a, a + b);
              d.prototype = Object.create(this);
              d.prototype.getMissingChunks = function() {
                var a = this.chunkSize,
                  b = Math.floor((this.end - 1) / a) + 1,
                  d = [];
                for (a = Math.floor(this.start / a); a < b; ++a) this.loadedChunks[a] || d.push(a);
                return d;
              };
              var u = new d();
              u.pos = u.start = a;
              u.end = a + b || this.end;
              u.dict = k;
              return u;
            },
          };
          return b;
        })();
      y = (function() {
        function b(b, d) {
          var u = d.rangeChunkSize,
            m = d.length;
          this.stream = new k(m, u, this);
          this.length = m;
          this.chunkSize = u;
          this.pdfNetworkStream = b;
          this.url = d.url;
          this.disableAutoFetch = d.disableAutoFetch;
          this.msgHandler = d.msgHandler;
          this.currRequestId = 0;
          this.chunksNeededByRequest = Object.create(null);
          this.requestsByChunk = Object.create(null);
          this.promisesByRequest = Object.create(null);
          this.progressiveDataLength = 0;
          this.aborted = !1;
          this._loadedStreamCapability = (0, a.createPromiseCapability)();
        }
        b.prototype = {
          onLoadedStream: function() {
            return this._loadedStreamCapability.promise;
          },
          sendRequest: function(b, d) {
            var k = this,
              m = this.pdfNetworkStream.getRangeReader(b, d);
            m.isStreamingSupported || (m.onProgress = this.onProgress.bind(this));
            var v = [],
              B = 0,
              n = this;
            new Promise(function(b, d) {
              m.read().then(function c(e) {
                try {
                  if (e.done) {
                    var q = (0, a.arraysToBytes)(v);
                    v = null;
                    b(q);
                  } else {
                    var h = e.value;
                    v.push(h);
                    B += (0, a.arrayByteLength)(h);
                    if (m.isStreamingSupported) n.onProgress({ loaded: B });
                    m.read().then(c, d);
                  }
                } catch (g) {
                  d(g);
                }
              }, d);
            }).then(function(a) {
              if (!k.aborted) k.onReceiveData({ chunk: a, begin: b });
            });
          },
          requestAllChunks: function() {
            var a = this.stream.getMissingChunks();
            this._requestChunks(a);
            return this._loadedStreamCapability.promise;
          },
          _requestChunks: function(b) {
            var d = this.currRequestId++,
              k,
              m = Object.create(null);
            this.chunksNeededByRequest[d] = m;
            var v = 0;
            for (k = b.length; v < k; v++) this.stream.hasChunk(b[v]) || (m[b[v]] = !0);
            if ((0, a.isEmptyObj)(m)) return Promise.resolve();
            b = (0, a.createPromiseCapability)();
            this.promisesByRequest[d] = b;
            v = [];
            for (var B in m)
              (B |= 0),
                B in this.requestsByChunk || ((this.requestsByChunk[B] = []), v.push(B)),
                this.requestsByChunk[B].push(d);
            if (!v.length) return b.promise;
            d = this.groupChunks(v);
            for (v = 0; v < d.length; ++v)
              (m = d[v]),
                this.sendRequest(m.beginChunk * this.chunkSize, Math.min(m.endChunk * this.chunkSize, this.length));
            return b.promise;
          },
          getStream: function() {
            return this.stream;
          },
          requestRange: function(a, b) {
            b = Math.min(b, this.length);
            for (var d = this.getBeginChunk(a), k = this.getEndChunk(b), m = []; d < k; ++d) m.push(d);
            return this._requestChunks(m);
          },
          requestRanges: function(a) {
            a = a || [];
            for (var b = [], k = 0; k < a.length; k++)
              for (var m = this.getBeginChunk(a[k].begin), v = this.getEndChunk(a[k].end); m < v; ++m)
                0 > b.indexOf(m) && b.push(m);
            b.sort(function(a, b) {
              return a - b;
            });
            return this._requestChunks(b);
          },
          groupChunks: function(a) {
            for (var b = [], k = -1, m = -1, v = 0; v < a.length; ++v) {
              var B = a[v];
              0 > k && (k = B);
              0 <= m && m + 1 !== B && (b.push({ beginChunk: k, endChunk: m + 1 }), (k = B));
              v + 1 === a.length && b.push({ beginChunk: k, endChunk: B + 1 });
              m = B;
            }
            return b;
          },
          onProgress: function(a) {
            this.msgHandler.send('DocProgress', {
              loaded: this.stream.numChunksLoaded * this.chunkSize + a.loaded,
              total: this.length,
            });
          },
          onReceiveData: function(b) {
            var d = b.chunk,
              k = void 0 === b.begin,
              m = k ? this.progressiveDataLength : b.begin,
              v = m + d.byteLength,
              B = Math.floor(m / this.chunkSize);
            b = v < this.length ? Math.floor(v / this.chunkSize) : Math.ceil(v / this.chunkSize);
            if (k) this.stream.onReceiveProgressiveData(d), (this.progressiveDataLength = v);
            else this.stream.onReceiveData(m, d);
            this.stream.allChunksLoaded() && this._loadedStreamCapability.resolve(this.stream);
            k = [];
            for (d = B; d < b; ++d)
              for (v = this.requestsByChunk[d] || [], delete this.requestsByChunk[d], B = 0; B < v.length; ++B) {
                m = v[B];
                var n = this.chunksNeededByRequest[m];
                d in n && delete n[d];
                (0, a.isEmptyObj)(n) && k.push(m);
              }
            if (!this.disableAutoFetch && (0, a.isEmptyObj)(this.requestsByChunk)) {
              var e;
              1 === this.stream.numChunksLoaded
                ? ((d = this.stream.numChunks - 1), this.stream.hasChunk(d) || (e = d))
                : (e = this.stream.nextEmptyChunk(b));
              Number.isInteger(e) && this._requestChunks([e]);
            }
            for (B = 0; B < k.length; ++B)
              (m = k[B]), (e = this.promisesByRequest[m]), delete this.promisesByRequest[m], e.resolve();
            this.msgHandler.send('DocProgress', {
              loaded: this.stream.numChunksLoaded * this.chunkSize,
              total: this.length,
            });
          },
          onError: function(a) {
            this._loadedStreamCapability.reject(a);
          },
          getBeginChunk: function(a) {
            return Math.floor(a / this.chunkSize);
          },
          getEndChunk: function(a) {
            return Math.floor((a - 1) / this.chunkSize) + 1;
          },
          abort: function() {
            this.aborted = !0;
            this.pdfNetworkStream && this.pdfNetworkStream.cancelAllRequests('abort');
            for (var a in this.promisesByRequest) this.promisesByRequest[a].reject(Error('Request was aborted'));
          },
        };
        return b;
      })();
      m.ChunkedStream = k;
      m.ChunkedStreamManager = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.FileSpec = m.XRef = m.ObjectLoader = m.Catalog = void 0;
      var a =
          'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
            ? function(a) {
                return typeof a;
              }
            : function(a) {
                return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                  ? 'symbol'
                  : typeof a;
              },
        k = (function() {
          return function(a, b) {
            if (Array.isArray(a)) return a;
            if (Symbol.iterator in Object(a)) {
              var c = [],
                d = !0,
                g = !1,
                e = void 0;
              try {
                for (
                  var l = a[Symbol.iterator](), h;
                  !(d = (h = l.next()).done) && (c.push(h.value), !b || c.length !== b);
                  d = !0
                );
              } catch (f) {
                (g = !0), (e = f);
              } finally {
                try {
                  if (!d && l['return']) l['return']();
                } finally {
                  if (g) throw e;
                }
              }
              return c;
            }
            throw new TypeError('Invalid attempt to destructure non-iterable instance');
          };
        })(),
        b = t(0),
        v = t(1),
        d = t(25),
        u = t(58),
        z = t(62),
        C = t(17);
      y = (function() {
        function d(a, d, e) {
          this.pdfManager = a;
          this.xref = d;
          this.catDict = d.getCatalogObj();
          if (!(0, v.isDict)(this.catDict)) throw new b.FormatError('catalog object is not a dictionary');
          this.fontCache = new v.RefSetCache();
          this.builtInCMapCache = Object.create(null);
          this.pageKidsCountCache = new v.RefSetCache();
          this.pageFactory = e;
          this.pagePromises = [];
        }
        d.prototype = {
          get metadata() {
            var a = this.catDict.getRaw('Metadata');
            if (!(0, v.isRef)(a)) return (0, b.shadow)(this, 'metadata', null);
            a = this.xref.fetch(a, !(this.xref.encrypt && this.xref.encrypt.encryptMetadata));
            if (a && (0, v.isDict)(a.dict)) {
              var d = a.dict.get('Type'),
                e = a.dict.get('Subtype');
              if ((0, v.isName)(d, 'Metadata') && (0, v.isName)(e, 'XML'))
                try {
                  var g = (0, b.stringToUTF8String)((0, b.bytesToString)(a.getBytes()));
                } catch (G) {
                  if (G instanceof b.MissingDataException) throw G;
                  (0, b.info)('Skipping invalid metadata.');
                }
            }
            return (0, b.shadow)(this, 'metadata', g);
          },
          get toplevelPagesDict() {
            var a = this.catDict.get('Pages');
            if (!(0, v.isDict)(a)) throw new b.FormatError('invalid top-level pages dictionary');
            return (0, b.shadow)(this, 'toplevelPagesDict', a);
          },
          get documentOutline() {
            var a = null;
            try {
              a = this.readDocumentOutline();
            } catch (q) {
              if (q instanceof b.MissingDataException) throw q;
              (0, b.warn)('Unable to read document outline');
            }
            return (0, b.shadow)(this, 'documentOutline', a);
          },
          readDocumentOutline: function() {
            var a = this.catDict.get('Outlines');
            if (!(0, v.isDict)(a)) return null;
            a = a.getRaw('First');
            if (!(0, v.isRef)(a)) return null;
            var q = { items: [] },
              e = [{ obj: a, parent: q }],
              g = new v.RefSet();
            g.put(a);
            for (var h = this.xref, l = new Uint8Array(3); 0 < e.length; ) {
              var n = e.shift(),
                f = h.fetchIfRef(n.obj);
              if (null !== f) {
                if (!f.has('Title')) throw new b.FormatError('Invalid outline item');
                a = { url: null, dest: null };
                d.parseDestDictionary({ destDict: f, resultObj: a, docBaseUrl: this.pdfManager.docBaseUrl });
                var r = f.get('Title'),
                  p = f.get('F') || 0,
                  k = f.getArray('C'),
                  A = l;
                !Array.isArray(k) ||
                  3 !== k.length ||
                  (0 === k[0] && 0 === k[1] && 0 === k[2]) ||
                  (A = C.ColorSpace.singletons.rgb.getRgb(k, 0));
                r = {
                  dest: a.dest,
                  url: a.url,
                  unsafeUrl: a.unsafeUrl,
                  newWindow: a.newWindow,
                  title: (0, b.stringToPDFString)(r),
                  color: A,
                  count: f.get('Count'),
                  bold: !!(p & 2),
                  italic: !!(p & 1),
                  items: [],
                };
                n.parent.items.push(r);
                a = f.getRaw('First');
                (0, v.isRef)(a) && !g.has(a) && (e.push({ obj: a, parent: r }), g.put(a));
                a = f.getRaw('Next');
                (0, v.isRef)(a) && !g.has(a) && (e.push({ obj: a, parent: n.parent }), g.put(a));
              }
            }
            return 0 < q.items.length ? q.items : null;
          },
          get numPages() {
            var a = this.toplevelPagesDict.get('Count');
            if (!Number.isInteger(a)) throw new b.FormatError('page count in top level pages object is not an integer');
            return (0, b.shadow)(this, 'numPages', a);
          },
          get destinations() {
            function a(a) {
              return (0, v.isDict)(a) ? a.get('D') : a;
            }
            var d = this.xref,
              e = {},
              g,
              h,
              l = this.catDict.get('Names');
            l && l.has('Dests')
              ? (g = l.getRaw('Dests'))
              : this.catDict.has('Dests') && (h = this.catDict.get('Dests'));
            h &&
              h.forEach(function(b, c) {
                c && (e[b] = a(c));
              });
            if (g) {
              d = new n(g, d).getAll();
              for (var p in d) e[p] = a(d[p]);
            }
            return (0, b.shadow)(this, 'destinations', e);
          },
          getDestination: function(a) {
            function b(a) {
              return (0, v.isDict)(a) ? a.get('D') : a;
            }
            var c = this.xref,
              d = null,
              e,
              l,
              h = this.catDict.get('Names');
            h && h.has('Dests')
              ? (e = h.getRaw('Dests'))
              : this.catDict.has('Dests') && (l = this.catDict.get('Dests'));
            l && (l = l.get(a)) && (d = b(l));
            e && ((c = new n(e, c)), (d = b(c.get(a))));
            return d;
          },
          get pageLabels() {
            var a = null;
            try {
              a = this.readPageLabels();
            } catch (q) {
              if (q instanceof b.MissingDataException) throw q;
              (0, b.warn)('Unable to read page labels.');
            }
            return (0, b.shadow)(this, 'pageLabels', a);
          },
          readPageLabels: function() {
            var a = this.catDict.getRaw('PageLabels');
            if (!a) return null;
            var d = Array(this.numPages),
              h = null,
              g = '';
            a = new e(a, this.xref).getAll();
            for (var n = '', l = 1, p = 0, f = this.numPages; p < f; p++) {
              if (p in a) {
                l = a[p];
                if (!(0, v.isDict)(l)) throw new b.FormatError('The PageLabel is not a dictionary.');
                if ((h = l.get('Type')) && !(0, v.isName)(h, 'PageLabel'))
                  throw new b.FormatError('Invalid type in PageLabel dictionary.');
                if ((h = l.get('S')) && !(0, v.isName)(h))
                  throw new b.FormatError('Invalid style in PageLabel dictionary.');
                h = h ? h.name : null;
                if ((g = l.get('P')) && !(0, b.isString)(g))
                  throw new b.FormatError('Invalid prefix in PageLabel dictionary.');
                g = g ? (0, b.stringToPDFString)(g) : '';
                if ((l = l.get('St')) && !(Number.isInteger(l) && 1 <= l))
                  throw new b.FormatError('Invalid start in PageLabel dictionary.');
                l = l || 1;
              }
              switch (h) {
                case 'D':
                  n = l;
                  break;
                case 'R':
                case 'r':
                  n = b.Util.toRoman(l, 'r' === h);
                  break;
                case 'A':
                case 'a':
                  var r = l - 1;
                  n = String.fromCharCode(('a' === h ? 97 : 65) + (r % 26));
                  var D = [],
                    k = 0;
                  for (r = (r / 26) | 0; k <= r; k++) D.push(n);
                  n = D.join('');
                  break;
                default:
                  if (h) throw new b.FormatError('Invalid style "' + h + '" in PageLabel dictionary.');
              }
              d[p] = g + n;
              n = '';
              l++;
            }
            return d;
          },
          get pageMode() {
            var a = this.catDict.get('PageMode'),
              d = 'UseNone';
            if ((0, v.isName)(a))
              switch (a.name) {
                case 'UseNone':
                case 'UseOutlines':
                case 'UseThumbs':
                case 'FullScreen':
                case 'UseOC':
                case 'UseAttachments':
                  d = a.name;
              }
            return (0, b.shadow)(this, 'pageMode', d);
          },
          get attachments() {
            var a = this.xref,
              d = null,
              e,
              g = this.catDict.get('Names');
            g && (e = g.getRaw('EmbeddedFiles'));
            if (e) {
              e = new n(e, a).getAll();
              for (var p in e)
                (g = new h(e[p], a)), d || (d = Object.create(null)), (d[(0, b.stringToPDFString)(p)] = g.serializable);
            }
            return (0, b.shadow)(this, 'attachments', d);
          },
          get javaScript() {
            function a(a) {
              var c = a.get('S');
              if ((0, v.isName)(c, 'JavaScript')) {
                a = a.get('JS');
                if ((0, v.isStream)(a)) a = (0, b.bytesToString)(a.getBytes());
                else if (!(0, b.isString)(a)) return;
                g.push((0, b.stringToPDFString)(a));
              }
            }
            var d = this.xref,
              e = this.catDict.get('Names'),
              g = [];
            if (e && e.has('JavaScript')) {
              d = new n(e.getRaw('JavaScript'), d).getAll();
              for (var h in d) (e = d[h]), (0, v.isDict)(e) && a(e);
            }
            h = this.catDict.get('OpenAction');
            (0, v.isDict)(h, 'Action') &&
              ((d = h.get('S')),
              (0, v.isName)(d, 'Named') ? ((h = h.get('N')), (0, v.isName)(h, 'Print') && g.push('print({});')) : a(h));
            return (0, b.shadow)(this, 'javaScript', g);
          },
          cleanup: function() {
            var a = this;
            this.pageKidsCountCache.clear();
            var b = [];
            this.fontCache.forEach(function(a) {
              b.push(a);
            });
            return Promise.all(b).then(function(b) {
              for (var c = 0, d = b.length; c < d; c++) delete b[c].dict.translated;
              a.fontCache.clear();
              a.builtInCMapCache = Object.create(null);
            });
          },
          getPage: function(a) {
            var b = this;
            a in this.pagePromises ||
              (this.pagePromises[a] = this.getPageDict(a).then(function(c) {
                c = k(c, 2);
                return b.pageFactory.createPage(a, c[0], c[1], b.fontCache, b.builtInCMapCache);
              }));
            return this.pagePromises[a];
          },
          getPageDict: function(a) {
            function c() {
              for (; g.length; ) {
                var r = g.pop();
                if ((0, v.isRef)(r)) {
                  e = f.get(r);
                  if (0 < e && l + e < a) {
                    l += e;
                    continue;
                  }
                  h.fetchAsync(r).then(function(b) {
                    (0, v.isDict)(b, 'Page') || ((0, v.isDict)(b) && !b.has('Kids'))
                      ? a === l
                        ? (r && !f.has(r) && f.put(r, 1), d.resolve([b, r]))
                        : (l++, c())
                      : (g.push(b), c());
                  }, d.reject);
                  return;
                }
                if (!(0, v.isDict)(r)) {
                  d.reject(new b.FormatError('page dictionary kid reference points to wrong type of object'));
                  return;
                }
                e = r.get('Count');
                var q = r.objId;
                q && !f.has(q) && f.put(q, e);
                if (l + e <= a) l += e;
                else {
                  q = r.get('Kids');
                  if (!Array.isArray(q)) {
                    d.reject(new b.FormatError('page dictionary kids object is not an array'));
                    return;
                  }
                  for (var n = q.length - 1; 0 <= n; n--) g.push(q[n]);
                }
              }
              d.reject(Error('Page index ' + a + ' not found.'));
            }
            var d = (0, b.createPromiseCapability)(),
              g = [this.catDict.getRaw('Pages')],
              e,
              l = 0,
              h = this.xref,
              f = this.pageKidsCountCache;
            c();
            return d.promise;
          },
          getPageIndex: function(a) {
            function c(c) {
              var d = 0,
                f;
              return g
                .fetchAsync(c)
                .then(function(d) {
                  if (
                    (0, v.isRefsEqual)(c, a) &&
                    !(0, v.isDict)(d, 'Page') &&
                    (!(0, v.isDict)(d) || d.has('Type') || !d.has('Contents'))
                  )
                    throw new b.FormatError('The reference does not point to a /Page Dict.');
                  if (!d) return null;
                  if (!(0, v.isDict)(d)) throw new b.FormatError('node must be a Dict.');
                  f = d.getRaw('Parent');
                  return d.getAsync('Parent');
                })
                .then(function(a) {
                  if (!a) return null;
                  if (!(0, v.isDict)(a)) throw new b.FormatError('parent must be a Dict.');
                  return a.getAsync('Kids');
                })
                .then(function(a) {
                  if (!a) return null;
                  for (var l = [], r = !1, e = 0; e < a.length; e++) {
                    var w = a[e];
                    if (!(0, v.isRef)(w)) throw new b.FormatError('kid must be a Ref.');
                    if (w.num === c.num) {
                      r = !0;
                      break;
                    }
                    l.push(
                      g.fetchAsync(w).then(function(a) {
                        a.has('Count') ? ((a = a.get('Count')), (d += a)) : d++;
                      }),
                    );
                  }
                  if (!r) throw new b.FormatError('kid ref not found in parents kids');
                  return Promise.all(l).then(function() {
                    return [d, f];
                  });
                });
            }
            function d(a) {
              return c(a).then(function(a) {
                if (!a) return e;
                var b = a[1];
                e += a[0];
                return d(b);
              });
            }
            var g = this.xref,
              e = 0;
            return d(a);
          },
        };
        d.parseDestDictionary = function(c) {
          function d(a) {
            return 0 === a.indexOf('www.') ? 'http://' + a : a;
          }
          function e(a) {
            try {
              return (0, b.stringToUTF8String)(a);
            } catch (L) {
              return a;
            }
          }
          var g = c.destDict;
          if ((0, v.isDict)(g)) {
            var h = c.resultObj;
            if ('object' !== ('undefined' === typeof h ? 'undefined' : a(h)))
              (0, b.warn)('parseDestDictionary: "resultObj" must be an object.');
            else {
              c = c.docBaseUrl || null;
              var l = g.get('A');
              !(0, v.isDict)(l) && g.has('Dest') && (l = g.get('Dest'));
              if ((0, v.isDict)(l)) {
                g = l.get('S');
                if (!(0, v.isName)(g)) {
                  (0, b.warn)('parseDestDictionary: Invalid type in Action dictionary.');
                  return;
                }
                g = g.name;
                switch (g) {
                  case 'URI':
                    var n = l.get('URI');
                    (0, v.isName)(n) ? (n = '/' + n.name) : (0, b.isString)(n) && (n = d(n));
                    break;
                  case 'GoTo':
                    var f = l.get('D');
                    break;
                  case 'Launch':
                  case 'GoToR':
                    var r = l.get('F');
                    (0, v.isDict)(r) ? (n = r.get('F') || null) : (0, b.isString)(r) && (n = r);
                    if ((r = l.get('D')))
                      (0, v.isName)(r) && (r = r.name),
                        (0, b.isString)(n) &&
                          ((g = n.split('#')[0]),
                          (0, b.isString)(r)
                            ? (n = g + '#' + r)
                            : Array.isArray(r) && (n = g + '#' + JSON.stringify(r)));
                    l = l.get('NewWindow');
                    (0, b.isBool)(l) && (h.newWindow = l);
                    break;
                  case 'Named':
                    l = l.get('N');
                    (0, v.isName)(l) && (h.action = l.name);
                    break;
                  case 'JavaScript':
                    if (
                      ((l = l.get('JS')),
                      (0, v.isStream)(l) ? (r = (0, b.bytesToString)(l.getBytes())) : (0, b.isString)(l) && (r = l),
                      r &&
                        (l = /^\s*(app\.launchURL|window\.open)\((?:'|")([^'"]*)(?:'|")(?:,\s*(\w+)\)|\))/i.exec(
                          (0, b.stringToPDFString)(r),
                        )) &&
                        l[2])
                    ) {
                      n = l[2];
                      'true' === l[3] && 'app.launchURL' === l[1] && (h.newWindow = !0);
                      break;
                    }
                  default:
                    (0, b.warn)('parseDestDictionary: Unsupported Action type "' + g + '".');
                }
              } else g.has('Dest') && (f = g.get('Dest'));
              if ((0, b.isString)(n)) {
                n = e(n);
                if ((c = (0, b.createValidAbsoluteUrl)(n, c))) h.url = c.href;
                h.unsafeUrl = n;
              }
              f && ((0, v.isName)(f) && (f = f.name), (0, b.isString)(f) || Array.isArray(f)) && (h.dest = f);
            }
          } else (0, b.warn)('parseDestDictionary: "destDict" must be a dictionary.');
        };
        return d;
      })();
      t = (function() {
        function a(a, b) {
          this.stream = a;
          this.pdfManager = b;
          this.entries = [];
          this.xrefstms = Object.create(null);
          this.cache = [];
          this.stats = { streamTypes: [], fontTypes: [] };
        }
        a.prototype = {
          setStartXRef: function(a) {
            this.startXRefQueue = [a];
          },
          parse: function(a) {
            a ? ((0, b.warn)('Indexing all PDF objects'), (a = this.indexObjects())) : (a = this.readXRef());
            a.assignXref(this);
            this.trailer = a;
            var c = a.get('Encrypt');
            if ((0, v.isDict)(c)) {
              var d = a.get('ID');
              d = d && d.length ? d[0] : '';
              c.suppressEncryption = !0;
              this.encrypt = new z.CipherTransformFactory(c, d, this.pdfManager.password);
            }
            if (!(this.root = a.get('Root'))) throw new b.FormatError('Invalid root reference');
          },
          processXRefTable: function(a) {
            'tableState' in this ||
              (this.tableState = {
                entryNum: 0,
                streamPos: a.lexer.stream.pos,
                parserBuf1: a.buf1,
                parserBuf2: a.buf2,
              });
            var c = this.readXRefTable(a);
            if (!(0, v.isCmd)(c, 'trailer'))
              throw new b.FormatError('Invalid XRef table: could not find trailer dictionary');
            a = a.getObj();
            !(0, v.isDict)(a) && a.dict && (a = a.dict);
            if (!(0, v.isDict)(a)) throw new b.FormatError('Invalid XRef table: could not parse trailer dictionary');
            delete this.tableState;
            return a;
          },
          readXRefTable: function(a) {
            var c = a.lexer.stream,
              d = this.tableState;
            c.pos = d.streamPos;
            a.buf1 = d.parserBuf1;
            a.buf2 = d.parserBuf2;
            for (var g; ; ) {
              if (!('firstEntryNum' in d && 'entryCount' in d)) {
                if ((0, v.isCmd)((g = a.getObj()), 'trailer')) break;
                d.firstEntryNum = g;
                d.entryCount = a.getObj();
              }
              g = d.firstEntryNum;
              var e = d.entryCount;
              if (!Number.isInteger(g) || !Number.isInteger(e))
                throw new b.FormatError('Invalid XRef table: wrong types in subsection header');
              for (var l = d.entryNum; l < e; l++) {
                d.streamPos = c.pos;
                d.entryNum = l;
                d.parserBuf1 = a.buf1;
                d.parserBuf2 = a.buf2;
                var h = {};
                h.offset = a.getObj();
                h.gen = a.getObj();
                var f = a.getObj();
                (0, v.isCmd)(f, 'f') ? (h.free = !0) : (0, v.isCmd)(f, 'n') && (h.uncompressed = !0);
                if (!Number.isInteger(h.offset) || !Number.isInteger(h.gen) || (!h.free && !h.uncompressed))
                  throw new b.FormatError('Invalid entry in XRef subsection: ' + g + ', ' + e);
                0 === l && h.free && 1 === g && (g = 0);
                this.entries[l + g] || (this.entries[l + g] = h);
              }
              d.entryNum = 0;
              d.streamPos = c.pos;
              d.parserBuf1 = a.buf1;
              d.parserBuf2 = a.buf2;
              delete d.firstEntryNum;
              delete d.entryCount;
            }
            if (this.entries[0] && !this.entries[0].free)
              throw new b.FormatError('Invalid XRef table: unexpected first object');
            return g;
          },
          processXRefStream: function(a) {
            if (!('streamState' in this)) {
              var b = a.dict,
                d = b.get('W'),
                c = b.get('Index');
              c || (c = [0, b.get('Size')]);
              this.streamState = { entryRanges: c, byteWidths: d, entryNum: 0, streamPos: a.pos };
            }
            this.readXRefStream(a);
            delete this.streamState;
            return a.dict;
          },
          readXRefStream: function(a) {
            var d,
              c = this.streamState;
            a.pos = c.streamPos;
            var g = c.byteWidths;
            for (var e = g[0], l = g[1], h = g[2], f = c.entryRanges; 0 < f.length; ) {
              var r = f[0],
                n = f[1];
              if (!Number.isInteger(r) || !Number.isInteger(n))
                throw new b.FormatError('Invalid XRef range fields: ' + r + ', ' + n);
              if (!Number.isInteger(e) || !Number.isInteger(l) || !Number.isInteger(h))
                throw new b.FormatError('Invalid XRef entry fields length: ' + r + ', ' + n);
              for (g = c.entryNum; g < n; ++g) {
                c.entryNum = g;
                c.streamPos = a.pos;
                var p = 0,
                  k = 0,
                  w = 0;
                for (d = 0; d < e; ++d) p = (p << 8) | a.getByte();
                0 === e && (p = 1);
                for (d = 0; d < l; ++d) k = (k << 8) | a.getByte();
                for (d = 0; d < h; ++d) w = (w << 8) | a.getByte();
                d = {};
                d.offset = k;
                d.gen = w;
                switch (p) {
                  case 0:
                    d.free = !0;
                    break;
                  case 1:
                    d.uncompressed = !0;
                    break;
                  case 2:
                    break;
                  default:
                    throw new b.FormatError('Invalid XRef entry type: ' + p);
                }
                this.entries[r + g] || (this.entries[r + g] = d);
              }
              c.entryNum = 0;
              c.streamPos = a.pos;
              f.splice(0, 2);
            }
          },
          indexObjects: function() {
            function a(a, b) {
              for (var d = '', c = a[b]; 10 !== c && 13 !== c && 60 !== c && !(++b >= a.length); )
                (d += String.fromCharCode(c)), (c = a[b]);
              return d;
            }
            function e(a, b, d) {
              for (var c = d.length, f = a.length, l = 0; b < f; ) {
                for (var r = 0; r < c && a[b + r] === d[r]; ) ++r;
                if (r >= c) break;
                b++;
                l++;
              }
              return l;
            }
            var h = /^(\d+)\s+(\d+)\s+obj\b/,
              g = new Uint8Array([116, 114, 97, 105, 108, 101, 114]),
              n = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]),
              l = new Uint8Array([101, 110, 100, 111, 98, 106]),
              p = new Uint8Array([47, 88, 82, 101, 102]);
            this.entries.length = 0;
            var f = this.stream;
            f.pos = 0;
            for (var r = f.getBytes(), D = f.start, k = r.length, A = [], w = []; D < k; ) {
              var E = r[D];
              if (9 === E || 10 === E || 13 === E || 32 === E) ++D;
              else if (37 === E) {
                do {
                  ++D;
                  if (D >= k) break;
                  E = r[D];
                } while (10 !== E && 13 !== E);
              } else {
                E = a(r, D);
                var F;
                if (0 !== E.indexOf('xref') || (4 !== E.length && !/\s/.test(E[4])))
                  if ((F = h.exec(E))) {
                    'undefined' === typeof this.entries[F[1]] &&
                      (this.entries[F[1]] = { offset: D - f.start, gen: F[2] | 0, uncompressed: !0 });
                    E = e(r, D, l) + 7;
                    F = r.subarray(D, D + E);
                    var K = e(F, 0, p);
                    K < E && 64 > F[K + 5] && (w.push(D - f.start), (this.xrefstms[D - f.start] = 1));
                    D += E;
                  } else
                    0 !== E.indexOf('trailer') || (7 !== E.length && !/\s/.test(E[7]))
                      ? (D += E.length + 1)
                      : (A.push(D), (D += e(r, D, n)));
                else (D += e(r, D, g)), A.push(D), (D += e(r, D, n));
              }
            }
            h = 0;
            for (g = w.length; h < g; ++h) this.startXRefQueue.push(w[h]), this.readXRef(!0);
            h = 0;
            for (g = A.length; h < g; ++h)
              if (
                ((f.pos = A[h]),
                (w = new d.Parser(new d.Lexer(f), !0, this, !0)),
                (n = w.getObj()),
                (0, v.isCmd)(n, 'trailer'))
              ) {
                var H = w.getObj();
                if ((0, v.isDict)(H) && H.has('ID')) return H;
              }
            if (H) return H;
            throw new b.InvalidPDFException('Invalid PDF structure');
          },
          readXRef: function(a) {
            var c = this.stream,
              e = Object.create(null);
            try {
              for (; this.startXRefQueue.length; ) {
                var g = this.startXRefQueue[0];
                if (e[g]) (0, b.warn)('readXRef - skipping XRef table since it was already parsed.');
                else {
                  e[g] = !0;
                  c.pos = g + c.start;
                  var h = new d.Parser(new d.Lexer(c), !0, this),
                    l = h.getObj();
                  if ((0, v.isCmd)(l, 'xref')) {
                    var n = this.processXRefTable(h);
                    this.topDict || (this.topDict = n);
                    l = n.get('XRefStm');
                    if (Number.isInteger(l)) {
                      var f = l;
                      f in this.xrefstms || ((this.xrefstms[f] = 1), this.startXRefQueue.push(f));
                    }
                  } else if (Number.isInteger(l)) {
                    if (
                      !Number.isInteger(h.getObj()) ||
                      !(0, v.isCmd)(h.getObj(), 'obj') ||
                      !(0, v.isStream)((l = h.getObj()))
                    )
                      throw new b.FormatError('Invalid XRef stream');
                    n = this.processXRefStream(l);
                    this.topDict || (this.topDict = n);
                    if (!n) throw new b.FormatError('Failed to read XRef stream');
                  } else throw new b.FormatError('Invalid XRef stream header');
                  l = n.get('Prev');
                  Number.isInteger(l)
                    ? this.startXRefQueue.push(l)
                    : (0, v.isRef)(l) && this.startXRefQueue.push(l.num);
                }
                this.startXRefQueue.shift();
              }
              return this.topDict;
            } catch (r) {
              if (r instanceof b.MissingDataException) throw r;
              (0, b.info)('(while reading XRef): ' + r);
            }
            if (!a) throw new b.XRefParseException();
          },
          getEntry: function(a) {
            return (a = this.entries[a]) && !a.free && a.offset ? a : null;
          },
          fetchIfRef: function(a, b) {
            return (0, v.isRef)(a) ? this.fetch(a, b) : a;
          },
          fetch: function(a, b) {
            if (!(0, v.isRef)(a)) throw Error('ref object is not a reference');
            var d = a.num;
            if (d in this.cache)
              return (d = this.cache[d]), d instanceof v.Dict && !d.objId && (d.objId = a.toString()), d;
            var c = this.getEntry(d);
            if (null === c) return (this.cache[d] = null);
            c = c.uncompressed ? this.fetchUncompressed(a, c, b) : this.fetchCompressed(c, b);
            (0, v.isDict)(c) ? (c.objId = a.toString()) : (0, v.isStream)(c) && (c.dict.objId = a.toString());
            return c;
          },
          fetchUncompressed: function(a, e, h) {
            var c = a.gen;
            a = a.num;
            if (e.gen !== c) throw new b.FormatError('inconsistent generation in XRef');
            e = this.stream.makeSubStream(e.offset + this.stream.start);
            e = new d.Parser(new d.Lexer(e), !0, this);
            var q = e.getObj(),
              l = e.getObj(),
              n = e.getObj();
            Number.isInteger(q) || (q = parseInt(q, 10));
            Number.isInteger(l) || (l = parseInt(l, 10));
            if (q !== a || l !== c || !(0, v.isCmd)(n)) throw new b.FormatError('bad XRef entry');
            if ('obj' !== n.cmd) {
              if (0 === n.cmd.indexOf('obj') && ((a = parseInt(n.cmd.substring(3), 10)), !Number.isNaN(a))) return a;
              throw new b.FormatError('bad XRef entry');
            }
            e = this.encrypt && !h ? e.getObj(this.encrypt.createCipherTransform(a, c)) : e.getObj();
            (0, v.isStream)(e) || (this.cache[a] = e);
            return e;
          },
          fetchCompressed: function(a, e) {
            var c = a.offset,
              g = this.fetch(new v.Ref(c, 0));
            if (!(0, v.isStream)(g)) throw new b.FormatError('bad ObjStm stream');
            var h = g.dict.get('First'),
              l = g.dict.get('N');
            if (!Number.isInteger(h) || !Number.isInteger(l))
              throw new b.FormatError('invalid first and n parameters for ObjStm stream');
            g = new d.Parser(new d.Lexer(g), !1, this);
            g.allowStreams = !0;
            var q = [],
              f = [];
            for (h = 0; h < l; ++h) {
              var r = g.getObj();
              if (!Number.isInteger(r)) throw new b.FormatError('invalid object number in the ObjStm stream: ' + r);
              f.push(r);
              r = g.getObj();
              if (!Number.isInteger(r)) throw new b.FormatError('invalid object offset in the ObjStm stream: ' + r);
            }
            for (h = 0; h < l; ++h) {
              q.push(g.getObj());
              (0, v.isCmd)(g.buf1, 'endobj') && g.shift();
              r = f[h];
              var n = this.entries[r];
              n && n.offset === c && n.gen === h && (this.cache[r] = q[h]);
            }
            a = q[a.gen];
            if (void 0 === a) throw new b.FormatError('bad XRef entry for compressed object');
            return a;
          },
          fetchIfRefAsync: function(a, b) {
            return (0, v.isRef)(a) ? this.fetchAsync(a, b) : Promise.resolve(a);
          },
          fetchAsync: function(a, d) {
            var c = this.stream.manager,
              g = this;
            return new Promise(function f(l, e) {
              try {
                l(g.fetch(a, d));
              } catch (r) {
                r instanceof b.MissingDataException
                  ? c.requestRange(r.begin, r.end).then(function() {
                      f(l, e);
                    }, e)
                  : e(r);
              }
            });
          },
          getCatalogObj: function() {
            return this.root;
          },
        };
        return a;
      })();
      var B = (function() {
          function a(a, b) {
            throw Error('Cannot initialize NameOrNumberTree.');
          }
          a.prototype = {
            getAll: function() {
              var a = Object.create(null);
              if (!this.root) return a;
              var d = this.xref,
                e = new v.RefSet();
              e.put(this.root);
              for (var g = [this.root]; 0 < g.length; ) {
                var h;
                var l = d.fetchIfRef(g.shift());
                if ((0, v.isDict)(l))
                  if (l.has('Kids')) {
                    var n = l.get('Kids');
                    l = 0;
                    for (h = n.length; l < h; l++) {
                      var f = n[l];
                      if (e.has(f)) throw new b.FormatError('Duplicate entry in "' + this._type + '" tree.');
                      g.push(f);
                      e.put(f);
                    }
                  } else if (((n = l.get(this._type)), Array.isArray(n)))
                    for (l = 0, h = n.length; l < h; l += 2) a[d.fetchIfRef(n[l])] = d.fetchIfRef(n[l + 1]);
              }
              return a;
            },
            get: function(a) {
              if (!this.root) return null;
              for (var d = this.xref, c = d.fetchIfRef(this.root), g = 0, e, l, h; c.has('Kids'); ) {
                if (10 < ++g) return (0, b.warn)('Search depth limit reached for "' + this._type + '" tree.'), null;
                var f = c.get('Kids');
                if (!Array.isArray(f)) return null;
                e = 0;
                for (l = f.length - 1; e <= l; ) {
                  h = (e + l) >> 1;
                  var r = d.fetchIfRef(f[h]).get('Limits');
                  if (a < d.fetchIfRef(r[0])) l = h - 1;
                  else if (a > d.fetchIfRef(r[1])) e = h + 1;
                  else {
                    c = d.fetchIfRef(f[h]);
                    break;
                  }
                }
                if (e > l) return null;
              }
              c = c.get(this._type);
              if (Array.isArray(c))
                for (e = 0, l = c.length - 2; e <= l; )
                  if (((h = (e + l) & -2), (g = d.fetchIfRef(c[h])), a < g)) l = h - 2;
                  else if (a > g) e = h + 2;
                  else return d.fetchIfRef(c[h + 1]);
              return null;
            },
          };
          return a;
        })(),
        n = (function() {
          function a(a, b) {
            this.root = a;
            this.xref = b;
            this._type = 'Names';
          }
          b.Util.inherit(a, B, {});
          return a;
        })(),
        e = (function() {
          function a(a, b) {
            this.root = a;
            this.xref = b;
            this._type = 'Nums';
          }
          b.Util.inherit(a, B, {});
          return a;
        })(),
        h = (function() {
          function a(a, d) {
            a &&
              (0, v.isDict)(a) &&
              ((this.xref = d),
              (this.root = a),
              a.has('FS') && (this.fs = a.get('FS')),
              (this.description = a.has('Desc') ? (0, b.stringToPDFString)(a.get('Desc')) : ''),
              a.has('RF') && (0, b.warn)('Related file specifications are not supported'),
              (this.contentAvailable = !0),
              a.has('EF') ||
                ((this.contentAvailable = !1), (0, b.warn)('Non-embedded file specifications are not supported')));
          }
          function d(a) {
            return a.has('UF')
              ? a.get('UF')
              : a.has('F')
              ? a.get('F')
              : a.has('Unix')
              ? a.get('Unix')
              : a.has('Mac')
              ? a.get('Mac')
              : a.has('DOS')
              ? a.get('DOS')
              : null;
          }
          a.prototype = {
            get filename() {
              if (!this._filename && this.root) {
                var a = d(this.root) || 'unnamed';
                this._filename = (0, b.stringToPDFString)(a)
                  .replace(/\\\\/g, '\\')
                  .replace(/\\\//g, '/')
                  .replace(/\\/g, '/');
              }
              return this._filename;
            },
            get content() {
              if (!this.contentAvailable) return null;
              !this.contentRef && this.root && (this.contentRef = d(this.root.get('EF')));
              var a = null;
              if (this.contentRef) {
                var c = this.xref.fetchIfRef(this.contentRef);
                c && (0, v.isStream)(c)
                  ? (a = c.getBytes())
                  : (0, b.warn)('Embedded file specification points to non-existing/invalid content');
              } else (0, b.warn)('Embedded file specification does not have a content');
              return a;
            },
            get serializable() {
              return { filename: this.filename, content: this.content };
            },
          };
          return a;
        })(),
        p = (function() {
          function a(a) {
            return (0, v.isRef)(a) || (0, v.isDict)(a) || Array.isArray(a) || (0, v.isStream)(a);
          }
          function d(b, d) {
            if ((0, v.isDict)(b) || (0, v.isStream)(b))
              for (var c = (0, v.isDict)(b) ? b : b.dict, l = c.getKeys(), g = 0, f = l.length; g < f; g++) {
                var r = c.getRaw(l[g]);
                a(r) && d.push(r);
              }
            else if (Array.isArray(b)) for (c = 0, l = b.length; c < l; c++) (g = b[c]), a(g) && d.push(g);
          }
          function e(a, b, d) {
            this.dict = a;
            this.keys = b;
            this.xref = d;
            this.capability = this.refSet = null;
          }
          e.prototype = {
            load: function() {
              this.capability = (0, b.createPromiseCapability)();
              if (!(this.xref.stream instanceof u.ChunkedStream) || 0 === this.xref.stream.getMissingChunks().length)
                return this.capability.resolve(), this.capability.promise;
              var a = this.keys,
                d = this.dict;
              this.refSet = new v.RefSet();
              for (var c = [], l = 0, e = a.length; l < e; l++) {
                var f = d.getRaw(a[l]);
                void 0 !== f && c.push(f);
              }
              this._walk(c);
              return this.capability.promise;
            },
            _walk: function(a) {
              for (var c = this, e = [], l = []; a.length; ) {
                var h = a.pop();
                if ((0, v.isRef)(h)) {
                  if (this.refSet.has(h)) continue;
                  try {
                    this.refSet.put(h), (h = this.xref.fetch(h));
                  } catch (w) {
                    if (!(w instanceof b.MissingDataException)) throw w;
                    e.push(h);
                    l.push({ begin: w.begin, end: w.end });
                  }
                }
                if (h && h.getBaseStreams) {
                  for (var f = h.getBaseStreams(), r = !1, n = 0, q = f.length; n < q; n++) {
                    var p = f[n];
                    p.getMissingChunks &&
                      p.getMissingChunks().length &&
                      ((r = !0), l.push({ begin: p.start, end: p.end }));
                  }
                  r && e.push(h);
                }
                d(h, a);
              }
              l.length
                ? this.xref.stream.manager.requestRanges(l).then(function() {
                    for (var a = 0, b = e.length; a < b; a++) {
                      var d = e[a];
                      (0, v.isRef)(d) && c.refSet.remove(d);
                    }
                    c._walk(e);
                  }, this.capability.reject)
                : ((this.refSet = null), this.capability.resolve());
            },
          };
          return e;
        })();
      m.Catalog = y;
      m.ObjectLoader = p;
      m.XRef = t;
      m.FileSpec = h;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      y = (function() {
        function a(a, k, d) {
          this.data = a;
          this.bp = k;
          this.dataEnd = d;
          this.chigh = a[k];
          this.clow = 0;
          this.byteIn();
          this.chigh = ((this.chigh << 7) & 65535) | ((this.clow >> 9) & 127);
          this.clow = (this.clow << 7) & 65535;
          this.ct -= 7;
          this.a = 32768;
        }
        var k = [
          { qe: 22017, nmps: 1, nlps: 1, switchFlag: 1 },
          { qe: 13313, nmps: 2, nlps: 6, switchFlag: 0 },
          { qe: 6145, nmps: 3, nlps: 9, switchFlag: 0 },
          { qe: 2753, nmps: 4, nlps: 12, switchFlag: 0 },
          { qe: 1313, nmps: 5, nlps: 29, switchFlag: 0 },
          { qe: 545, nmps: 38, nlps: 33, switchFlag: 0 },
          { qe: 22017, nmps: 7, nlps: 6, switchFlag: 1 },
          { qe: 21505, nmps: 8, nlps: 14, switchFlag: 0 },
          { qe: 18433, nmps: 9, nlps: 14, switchFlag: 0 },
          { qe: 14337, nmps: 10, nlps: 14, switchFlag: 0 },
          { qe: 12289, nmps: 11, nlps: 17, switchFlag: 0 },
          { qe: 9217, nmps: 12, nlps: 18, switchFlag: 0 },
          { qe: 7169, nmps: 13, nlps: 20, switchFlag: 0 },
          { qe: 5633, nmps: 29, nlps: 21, switchFlag: 0 },
          { qe: 22017, nmps: 15, nlps: 14, switchFlag: 1 },
          { qe: 21505, nmps: 16, nlps: 14, switchFlag: 0 },
          { qe: 20737, nmps: 17, nlps: 15, switchFlag: 0 },
          { qe: 18433, nmps: 18, nlps: 16, switchFlag: 0 },
          { qe: 14337, nmps: 19, nlps: 17, switchFlag: 0 },
          { qe: 13313, nmps: 20, nlps: 18, switchFlag: 0 },
          { qe: 12289, nmps: 21, nlps: 19, switchFlag: 0 },
          { qe: 10241, nmps: 22, nlps: 19, switchFlag: 0 },
          { qe: 9217, nmps: 23, nlps: 20, switchFlag: 0 },
          { qe: 8705, nmps: 24, nlps: 21, switchFlag: 0 },
          { qe: 7169, nmps: 25, nlps: 22, switchFlag: 0 },
          { qe: 6145, nmps: 26, nlps: 23, switchFlag: 0 },
          { qe: 5633, nmps: 27, nlps: 24, switchFlag: 0 },
          { qe: 5121, nmps: 28, nlps: 25, switchFlag: 0 },
          { qe: 4609, nmps: 29, nlps: 26, switchFlag: 0 },
          { qe: 4353, nmps: 30, nlps: 27, switchFlag: 0 },
          { qe: 2753, nmps: 31, nlps: 28, switchFlag: 0 },
          { qe: 2497, nmps: 32, nlps: 29, switchFlag: 0 },
          { qe: 2209, nmps: 33, nlps: 30, switchFlag: 0 },
          { qe: 1313, nmps: 34, nlps: 31, switchFlag: 0 },
          { qe: 1089, nmps: 35, nlps: 32, switchFlag: 0 },
          { qe: 673, nmps: 36, nlps: 33, switchFlag: 0 },
          { qe: 545, nmps: 37, nlps: 34, switchFlag: 0 },
          { qe: 321, nmps: 38, nlps: 35, switchFlag: 0 },
          { qe: 273, nmps: 39, nlps: 36, switchFlag: 0 },
          { qe: 133, nmps: 40, nlps: 37, switchFlag: 0 },
          { qe: 73, nmps: 41, nlps: 38, switchFlag: 0 },
          { qe: 37, nmps: 42, nlps: 39, switchFlag: 0 },
          { qe: 21, nmps: 43, nlps: 40, switchFlag: 0 },
          { qe: 9, nmps: 44, nlps: 41, switchFlag: 0 },
          { qe: 5, nmps: 45, nlps: 42, switchFlag: 0 },
          { qe: 1, nmps: 45, nlps: 43, switchFlag: 0 },
          { qe: 22017, nmps: 46, nlps: 46, switchFlag: 0 },
        ];
        a.prototype = {
          byteIn: function() {
            var a = this.data,
              k = this.bp;
            255 === a[k]
              ? 143 < a[k + 1]
                ? ((this.clow += 65280), (this.ct = 8))
                : (k++, (this.clow += a[k] << 9), (this.ct = 7), (this.bp = k))
              : (k++, (this.clow += k < this.dataEnd ? a[k] << 8 : 65280), (this.ct = 8), (this.bp = k));
            65535 < this.clow && ((this.chigh += this.clow >> 16), (this.clow &= 65535));
          },
          readBit: function(a, m) {
            var b = a[m] >> 1,
              u = a[m] & 1;
            b = k[b];
            var v = b.qe,
              C = this.a - v;
            if (this.chigh < v)
              C < v
                ? ((C = v), (v = u), (b = b.nmps))
                : ((C = v), (v = 1 ^ u), 1 === b.switchFlag && (u = v), (b = b.nlps));
            else {
              this.chigh -= v;
              if (0 !== (C & 32768)) return (this.a = C), u;
              C < v ? ((v = 1 ^ u), 1 === b.switchFlag && (u = v), (b = b.nlps)) : ((v = u), (b = b.nmps));
            }
            do
              0 === this.ct && this.byteIn(),
                (C <<= 1),
                (this.chigh = ((this.chigh << 1) & 65535) | ((this.clow >> 15) & 1)),
                (this.clow = (this.clow << 1) & 65535),
                this.ct--;
            while (0 === (C & 32768));
            this.a = C;
            a[m] = (b << 1) | u;
            return v;
          },
        };
        return a;
      })();
      m.ArithmeticDecoder = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.JpxImage = void 0;
      var a = t(0),
        k = t(60),
        b = (function() {
          function a(a) {
            this.message = 'JPX error: ' + a;
          }
          a.prototype = Error();
          a.prototype.name = 'JpxError';
          return (a.constructor = a);
        })();
      y = (function() {
        function m() {
          this.failOnCorruptedImage = !1;
        }
        function d(a, b, d) {
          a = d.xcb_;
          d = d.ycb_;
          var c = 1 << a,
            f = 1 << d,
            l = b.tbx0 >> a,
            r = b.tby0 >> d,
            g = (b.tbx1 + c - 1) >> a,
            e = (b.tby1 + f - 1) >> d,
            h = b.resolution.precinctParameters,
            n = [],
            q = [],
            p,
            D;
          for (D = r; D < e; D++)
            for (p = l; p < g; p++) {
              var k = { cbx: p, cby: D, tbx0: c * p, tby0: f * D, tbx1: c * (p + 1), tby1: f * (D + 1) };
              k.tbx0_ = Math.max(b.tbx0, k.tbx0);
              k.tby0_ = Math.max(b.tby0, k.tby0);
              k.tbx1_ = Math.min(b.tbx1, k.tbx1);
              k.tby1_ = Math.min(b.tby1, k.tby1);
              var x =
                Math.floor((k.tbx0_ - b.tbx0) / h.precinctWidthInSubband) +
                Math.floor((k.tby0_ - b.tby0) / h.precinctHeightInSubband) * h.numprecinctswide;
              k.precinctNumber = x;
              k.subbandType = b.type;
              k.Lblock = 3;
              if (!(k.tbx1_ <= k.tbx0_ || k.tby1_ <= k.tby0_)) {
                n.push(k);
                var A = q[x];
                void 0 !== A
                  ? (p < A.cbxMin ? (A.cbxMin = p) : p > A.cbxMax && (A.cbxMax = p),
                    D < A.cbyMin ? (A.cbxMin = D) : D > A.cbyMax && (A.cbyMax = D))
                  : (q[x] = A = { cbxMin: p, cbyMin: D, cbxMax: p, cbyMax: D });
                k.precinct = A;
              }
            }
          b.codeblockParameters = {
            codeblockWidth: a,
            codeblockHeight: d,
            numcodeblockwide: g - l + 1,
            numcodeblockhigh: e - r + 1,
          };
          b.codeblocks = n;
          b.precincts = q;
        }
        function u(a, b, d) {
          var c = [];
          a = a.subbands;
          for (var f = 0, l = a.length; f < l; f++)
            for (var r = a[f].codeblocks, g = 0, e = r.length; g < e; g++) {
              var h = r[g];
              h.precinctNumber === b && c.push(h);
            }
          return { layerNumber: d, codeblocks: c };
        }
        function z(a) {
          var d = a.tiles[a.currentTile.index],
            c = d.codingStyleDefaultParameters.layersCount,
            f = a.SIZ.Csiz,
            l = 0;
          for (a = 0; a < f; a++) l = Math.max(l, d.components[a].codingStyleParameters.decompositionLevelsCount);
          var g = 0,
            e = 0,
            h = 0,
            n = 0;
          this.nextPacket = function() {
            for (; g < c; g++) {
              for (; e <= l; e++) {
                for (; h < f; h++) {
                  var a = d.components[h];
                  if (!(e > a.codingStyleParameters.decompositionLevelsCount)) {
                    a = a.resolutions[e];
                    for (var r = a.precinctParameters.numprecincts; n < r; ) return (a = u(a, n, g)), n++, a;
                    n = 0;
                  }
                }
                h = 0;
              }
              e = 0;
            }
            throw new b('Out of packets');
          };
        }
        function C(a) {
          var d = a.tiles[a.currentTile.index],
            c = d.codingStyleDefaultParameters.layersCount,
            f = a.SIZ.Csiz,
            l = 0;
          for (a = 0; a < f; a++) l = Math.max(l, d.components[a].codingStyleParameters.decompositionLevelsCount);
          var g = 0,
            e = 0,
            h = 0,
            n = 0;
          this.nextPacket = function() {
            for (; g <= l; g++) {
              for (; e < c; e++) {
                for (; h < f; h++) {
                  var a = d.components[h];
                  if (!(g > a.codingStyleParameters.decompositionLevelsCount)) {
                    a = a.resolutions[g];
                    for (var r = a.precinctParameters.numprecincts; n < r; ) return (a = u(a, n, e)), n++, a;
                    n = 0;
                  }
                }
                h = 0;
              }
              e = 0;
            }
            throw new b('Out of packets');
          };
        }
        function B(a) {
          var d = a.tiles[a.currentTile.index],
            c = d.codingStyleDefaultParameters.layersCount,
            f = a.SIZ.Csiz,
            l,
            g,
            e,
            h = 0;
          for (e = 0; e < f; e++) h = Math.max(h, d.components[e].codingStyleParameters.decompositionLevelsCount);
          var n = new Int32Array(h + 1);
          for (g = 0; g <= h; ++g) {
            for (e = a = 0; e < f; ++e) {
              var q = d.components[e].resolutions;
              g < q.length && (a = Math.max(a, q[g].precinctParameters.numprecincts));
            }
            n[g] = a;
          }
          var p = (e = g = l = 0);
          this.nextPacket = function() {
            for (; g <= h; g++) {
              for (; p < n[g]; p++) {
                for (; e < f; e++) {
                  var a = d.components[e];
                  if (
                    !(
                      g > a.codingStyleParameters.decompositionLevelsCount ||
                      ((a = a.resolutions[g]), p >= a.precinctParameters.numprecincts)
                    )
                  ) {
                    for (; l < c; ) return (a = u(a, p, l)), l++, a;
                    l = 0;
                  }
                }
                e = 0;
              }
              p = 0;
            }
            throw new b('Out of packets');
          };
        }
        function n(a) {
          var d = a.tiles[a.currentTile.index],
            c = d.codingStyleDefaultParameters.layersCount,
            f = a.SIZ.Csiz,
            l = p(d),
            g = 0,
            e = 0,
            n = 0,
            q = 0,
            H = 0;
          this.nextPacket = function() {
            for (; H < l.maxNumHigh; H++) {
              for (; q < l.maxNumWide; q++) {
                for (; n < f; n++) {
                  for (var a = d.components[n], r = a.codingStyleParameters.decompositionLevelsCount; e <= r; e++) {
                    var w = a.resolutions[e],
                      E = h(q, H, l.components[n].resolutions[e], l, w);
                    if (null !== E) {
                      for (; g < c; ) return (a = u(w, E, g)), g++, a;
                      g = 0;
                    }
                  }
                  e = 0;
                }
                n = 0;
              }
              q = 0;
            }
            throw new b('Out of packets');
          };
        }
        function e(a) {
          var d = a.tiles[a.currentTile.index],
            c = d.codingStyleDefaultParameters.layersCount,
            f = a.SIZ.Csiz,
            l = p(d),
            g = 0,
            e = 0,
            n = 0,
            q = 0,
            H = 0;
          this.nextPacket = function() {
            for (; n < f; ++n) {
              for (
                var a = d.components[n], r = l.components[n], w = a.codingStyleParameters.decompositionLevelsCount;
                H < r.maxNumHigh;
                H++
              ) {
                for (; q < r.maxNumWide; q++) {
                  for (; e <= w; e++) {
                    var E = a.resolutions[e],
                      p = h(q, H, r.resolutions[e], r, E);
                    if (null !== p) {
                      for (; g < c; ) return (a = u(E, p, g)), g++, a;
                      g = 0;
                    }
                  }
                  e = 0;
                }
                q = 0;
              }
              H = 0;
            }
            throw new b('Out of packets');
          };
        }
        function h(a, b, d, c, l) {
          a *= c.minWidth;
          b *= c.minHeight;
          return 0 !== a % d.width || 0 !== b % d.height
            ? null
            : a / d.height + (b / d.width) * l.precinctParameters.numprecinctswide;
        }
        function p(a) {
          for (
            var b = a.components.length, d = Number.MAX_VALUE, c = Number.MAX_VALUE, f = 0, l = 0, g = Array(b), e = 0;
            e < b;
            e++
          ) {
            for (
              var h = a.components[e],
                n = h.codingStyleParameters.decompositionLevelsCount,
                q = Array(n + 1),
                p = Number.MAX_VALUE,
                k = Number.MAX_VALUE,
                x = 0,
                A = 0,
                m = 1;
              0 <= n;
              --n
            ) {
              var u = h.resolutions[n],
                G = m * u.precinctParameters.precinctWidth,
                B = m * u.precinctParameters.precinctHeight;
              p = Math.min(p, G);
              k = Math.min(k, B);
              x = Math.max(x, u.precinctParameters.numprecinctswide);
              A = Math.max(A, u.precinctParameters.numprecinctshigh);
              q[n] = { width: G, height: B };
              m <<= 1;
            }
            d = Math.min(d, p);
            c = Math.min(c, k);
            f = Math.max(f, x);
            l = Math.max(l, A);
            g[e] = { resolutions: q, minWidth: p, minHeight: k, maxNumWide: x, maxNumHigh: A };
          }
          return { components: g, minWidth: d, minHeight: c, maxNumWide: f, maxNumHigh: l };
        }
        function A(b, d, c, l) {
          function f(a) {
            for (; n < a; ) {
              var b = d[c + e];
              e++;
              p ? ((h = (h << 7) | b), (n += 7), (p = !1)) : ((h = (h << 8) | b), (n += 8));
              255 === b && (p = !0);
            }
            n -= a;
            return (h >>> n) & ((1 << a) - 1);
          }
          function g(a) {
            return 255 === d[c + e - 1] && d[c + e] === a
              ? ((e += 1), !0)
              : 255 === d[c + e] && d[c + e + 1] === a
              ? ((e += 2), !0)
              : !1;
          }
          function r() {
            if (0 === f(1)) return 1;
            if (0 === f(1)) return 2;
            var a = f(2);
            if (3 > a) return a + 3;
            a = f(5);
            if (31 > a) return a + 6;
            a = f(7);
            return a + 37;
          }
          var e = 0,
            h,
            n = 0,
            p = !1,
            D = b.COD.sopMarkerUsed,
            k = b.COD.ephMarkerUsed;
          for (b = b.tiles[b.currentTile.index].packetsIterator; e < l; ) {
            n = 0;
            p && (e++, (p = !1));
            D && g(145) && (e += 4);
            var A = b.nextPacket();
            if (f(1)) {
              for (var m = A.layerNumber, L = [], u, G = 0, B = A.codeblocks.length; G < B; G++) {
                u = A.codeblocks[G];
                var J = u.precinct,
                  v = u.cbx - J.cbxMin,
                  z = u.cby - J.cbyMin,
                  C = !1,
                  t = !1;
                if (void 0 !== u.included) C = !!f(1);
                else {
                  J = u.precinct;
                  if (void 0 !== J.inclusionTree) var y = J.inclusionTree;
                  else {
                    var V = J.cbxMax - J.cbxMin + 1;
                    var P = J.cbyMax - J.cbyMin + 1;
                    y = new x(V, P, m);
                    P = new q(V, P);
                    J.inclusionTree = y;
                    J.zeroBitPlanesTree = P;
                  }
                  if (y.reset(v, z, m))
                    for (;;)
                      if (f(1)) {
                        if ((V = !y.nextLevel())) {
                          C = t = u.included = !0;
                          break;
                        }
                      } else {
                        y.incrementValue(m);
                        break;
                      }
                }
                if (C) {
                  if (t) {
                    P = J.zeroBitPlanesTree;
                    for (P.reset(v, z); ; )
                      if (f(1)) {
                        if ((V = !P.nextLevel())) break;
                      } else P.incrementValue();
                    u.zeroBitPlanes = P.value;
                  }
                  for (J = r(); f(1); ) u.Lblock++;
                  v = (0, a.log2)(J);
                  v = f((J < 1 << v ? v - 1 : v) + u.Lblock);
                  L.push({ codeblock: u, codingpasses: J, dataLength: v });
                }
              }
              n = 0;
              p && (e++, (p = !1));
              for (k && g(146); 0 < L.length; )
                (A = L.shift()),
                  (u = A.codeblock),
                  void 0 === u.data && (u.data = []),
                  u.data.push({ data: d, start: c + e, end: c + e + A.dataLength, codingpasses: A.codingpasses }),
                  (e += A.dataLength);
            }
          }
          return e;
        }
        var c = { LL: 0, LH: 1, HL: 1, HH: 2 };
        m.prototype = {
          parse: function(d) {
            if (65359 === (0, a.readUint16)(d, 0)) this.parseCodestream(d, 0, d.length);
            else
              for (var c = 0, f = d.length; c < f; ) {
                var l = 8,
                  g = (0, a.readUint32)(d, c),
                  e = (0, a.readUint32)(d, c + 4);
                c += l;
                1 === g &&
                  ((g = 4294967296 * (0, a.readUint32)(d, c) + (0, a.readUint32)(d, c + 4)), (c += 8), (l += 8));
                0 === g && (g = f - c + l);
                if (g < l) throw new b('Invalid box field size');
                l = g - l;
                g = !0;
                switch (e) {
                  case 1785737832:
                    g = !1;
                    break;
                  case 1668246642:
                    e = d[c];
                    if (1 === e)
                      switch (((e = (0, a.readUint32)(d, c + 3)), e)) {
                        case 16:
                        case 17:
                        case 18:
                          break;
                        default:
                          (0, a.warn)('Unknown colorspace ' + e);
                      }
                    else 2 === e && (0, a.info)('ICC profile not supported');
                    break;
                  case 1785737827:
                    this.parseCodestream(d, c, c + l);
                    break;
                  case 1783636e3:
                    218793738 !== (0, a.readUint32)(d, c) && (0, a.warn)('Invalid JP2 signature');
                    break;
                  case 1783634458:
                  case 1718909296:
                  case 1920099697:
                  case 1919251232:
                  case 1768449138:
                    break;
                  default:
                    var h = String.fromCharCode((e >> 24) & 255, (e >> 16) & 255, (e >> 8) & 255, e & 255);
                    (0, a.warn)('Unsupported header type ' + e + ' (' + h + ')');
                }
                g && (c += l);
              }
          },
          parseImageProperties: function(a) {
            for (var d = a.getByte(); 0 <= d; ) {
              var c = d;
              d = a.getByte();
              if (65361 === ((c << 8) | d)) {
                a.skip(4);
                d = a.getInt32() >>> 0;
                c = a.getInt32() >>> 0;
                var f = a.getInt32() >>> 0,
                  l = a.getInt32() >>> 0;
                a.skip(16);
                a = a.getUint16();
                this.width = d - f;
                this.height = c - l;
                this.componentsCount = a;
                this.bitsPerComponent = 8;
                return;
              }
            }
            throw new b('No size marker found in JPX stream');
          },
          parseCodestream: function(f, r, h) {
            var q = {},
              p = !1;
            try {
              for (var w = r; w + 1 < h; ) {
                var E = (0, a.readUint16)(f, w);
                w += 2;
                var F = 0,
                  D;
                switch (E) {
                  case 65359:
                    q.mainHeader = !0;
                    break;
                  case 65497:
                    break;
                  case 65361:
                    F = (0, a.readUint16)(f, w);
                    var H = {};
                    H.Xsiz = (0, a.readUint32)(f, w + 4);
                    H.Ysiz = (0, a.readUint32)(f, w + 8);
                    H.XOsiz = (0, a.readUint32)(f, w + 12);
                    H.YOsiz = (0, a.readUint32)(f, w + 16);
                    H.XTsiz = (0, a.readUint32)(f, w + 20);
                    H.YTsiz = (0, a.readUint32)(f, w + 24);
                    H.XTOsiz = (0, a.readUint32)(f, w + 28);
                    H.YTOsiz = (0, a.readUint32)(f, w + 32);
                    var M = (0, a.readUint16)(f, w + 36);
                    H.Csiz = M;
                    var x = [];
                    var N = w + 38;
                    for (var m = 0; m < M; m++) {
                      var u = {
                          precision: (f[N] & 127) + 1,
                          isSigned: !!(f[N] & 128),
                          XRsiz: f[N + 1],
                          YRsiz: f[N + 1],
                        },
                        G = u,
                        v = H;
                      G.x0 = Math.ceil(v.XOsiz / G.XRsiz);
                      G.x1 = Math.ceil(v.Xsiz / G.XRsiz);
                      G.y0 = Math.ceil(v.YOsiz / G.YRsiz);
                      G.y1 = Math.ceil(v.Ysiz / G.YRsiz);
                      G.width = G.x1 - G.x0;
                      G.height = G.y1 - G.y0;
                      x.push(u);
                    }
                    q.SIZ = H;
                    q.components = x;
                    for (
                      var t = void 0,
                        X = q,
                        ba = x,
                        ca = X.SIZ,
                        y = [],
                        S = Math.ceil((ca.Xsiz - ca.XTOsiz) / ca.XTsiz),
                        Y = Math.ceil((ca.Ysiz - ca.YTOsiz) / ca.YTsiz),
                        U = 0;
                      U < Y;
                      U++
                    )
                      for (var V = 0; V < S; V++)
                        (t = {}),
                          (t.tx0 = Math.max(ca.XTOsiz + V * ca.XTsiz, ca.XOsiz)),
                          (t.ty0 = Math.max(ca.YTOsiz + U * ca.YTsiz, ca.YOsiz)),
                          (t.tx1 = Math.min(ca.XTOsiz + (V + 1) * ca.XTsiz, ca.Xsiz)),
                          (t.ty1 = Math.min(ca.YTOsiz + (U + 1) * ca.YTsiz, ca.Ysiz)),
                          (t.width = t.tx1 - t.tx0),
                          (t.height = t.ty1 - t.ty0),
                          (t.components = []),
                          y.push(t);
                    X.tiles = y;
                    for (var P = 0, Ha = ca.Csiz; P < Ha; P++)
                      for (var Aa = ba[P], Ca = 0, Wa = y.length; Ca < Wa; Ca++) {
                        var na = {};
                        t = y[Ca];
                        na.tcx0 = Math.ceil(t.tx0 / Aa.XRsiz);
                        na.tcy0 = Math.ceil(t.ty0 / Aa.YRsiz);
                        na.tcx1 = Math.ceil(t.tx1 / Aa.XRsiz);
                        na.tcy1 = Math.ceil(t.ty1 / Aa.YRsiz);
                        na.width = na.tcx1 - na.tcx0;
                        na.height = na.tcy1 - na.tcy0;
                        t.components[P] = na;
                      }
                    q.QCC = [];
                    q.COC = [];
                    break;
                  case 65372:
                    F = (0, a.readUint16)(f, w);
                    var Oa = {};
                    N = w + 2;
                    var Ia = f[N++];
                    switch (Ia & 31) {
                      case 0:
                        var wa = 8;
                        var Q = !0;
                        break;
                      case 1:
                        wa = 16;
                        Q = !1;
                        break;
                      case 2:
                        wa = 16;
                        Q = !0;
                        break;
                      default:
                        throw Error('Invalid SQcd value ' + Ia);
                    }
                    Oa.noQuantization = 8 === wa;
                    Oa.scalarExpounded = Q;
                    Oa.guardBits = Ia >> 5;
                    for (D = []; N < F + w; ) {
                      var ua = {};
                      8 === wa
                        ? ((ua.epsilon = f[N++] >> 3), (ua.mu = 0))
                        : ((ua.epsilon = f[N] >> 3), (ua.mu = ((f[N] & 7) << 8) | f[N + 1]), (N += 2));
                      D.push(ua);
                    }
                    Oa.SPqcds = D;
                    q.mainHeader ? (q.QCD = Oa) : ((q.currentTile.QCD = Oa), (q.currentTile.QCC = []));
                    break;
                  case 65373:
                    F = (0, a.readUint16)(f, w);
                    var Ja = {};
                    N = w + 2;
                    if (257 > q.SIZ.Csiz) var Sa = f[N++];
                    else (Sa = (0, a.readUint16)(f, N)), (N += 2);
                    Ia = f[N++];
                    switch (Ia & 31) {
                      case 0:
                        wa = 8;
                        Q = !0;
                        break;
                      case 1:
                        wa = 16;
                        Q = !1;
                        break;
                      case 2:
                        wa = 16;
                        Q = !0;
                        break;
                      default:
                        throw Error('Invalid SQcd value ' + Ia);
                    }
                    Ja.noQuantization = 8 === wa;
                    Ja.scalarExpounded = Q;
                    Ja.guardBits = Ia >> 5;
                    for (D = []; N < F + w; )
                      (ua = {}),
                        8 === wa
                          ? ((ua.epsilon = f[N++] >> 3), (ua.mu = 0))
                          : ((ua.epsilon = f[N] >> 3), (ua.mu = ((f[N] & 7) << 8) | f[N + 1]), (N += 2)),
                        D.push(ua);
                    Ja.SPqcds = D;
                    q.mainHeader ? (q.QCC[Sa] = Ja) : (q.currentTile.QCC[Sa] = Ja);
                    break;
                  case 65362:
                    F = (0, a.readUint16)(f, w);
                    var ja = {};
                    N = w + 2;
                    var oa = f[N++];
                    ja.entropyCoderWithCustomPrecincts = !!(oa & 1);
                    ja.sopMarkerUsed = !!(oa & 2);
                    ja.ephMarkerUsed = !!(oa & 4);
                    ja.progressionOrder = f[N++];
                    ja.layersCount = (0, a.readUint16)(f, N);
                    N += 2;
                    ja.multipleComponentTransform = f[N++];
                    ja.decompositionLevelsCount = f[N++];
                    ja.xcb = (f[N++] & 15) + 2;
                    ja.ycb = (f[N++] & 15) + 2;
                    var Da = f[N++];
                    ja.selectiveArithmeticCodingBypass = !!(Da & 1);
                    ja.resetContextProbabilities = !!(Da & 2);
                    ja.terminationOnEachCodingPass = !!(Da & 4);
                    ja.verticalyStripe = !!(Da & 8);
                    ja.predictableTermination = !!(Da & 16);
                    ja.segmentationSymbolUsed = !!(Da & 32);
                    ja.reversibleTransformation = f[N++];
                    if (ja.entropyCoderWithCustomPrecincts) {
                      for (var Ka = []; N < F + w; ) {
                        var ya = f[N++];
                        Ka.push({ PPx: ya & 15, PPy: ya >> 4 });
                      }
                      ja.precinctsSizes = Ka;
                    }
                    var ma = [];
                    ja.selectiveArithmeticCodingBypass && ma.push('selectiveArithmeticCodingBypass');
                    ja.resetContextProbabilities && ma.push('resetContextProbabilities');
                    ja.terminationOnEachCodingPass && ma.push('terminationOnEachCodingPass');
                    ja.verticalyStripe && ma.push('verticalyStripe');
                    ja.predictableTermination && ma.push('predictableTermination');
                    if (0 < ma.length) throw ((p = !0), Error('Unsupported COD options (' + ma.join(', ') + ')'));
                    q.mainHeader ? (q.COD = ja) : ((q.currentTile.COD = ja), (q.currentTile.COC = []));
                    break;
                  case 65424:
                    F = (0, a.readUint16)(f, w);
                    var la = {};
                    la.index = (0, a.readUint16)(f, w + 2);
                    la.length = (0, a.readUint32)(f, w + 4);
                    la.dataEnd = la.length + w - 2;
                    la.partIndex = f[w + 8];
                    la.partsCount = f[w + 9];
                    q.mainHeader = !1;
                    0 === la.partIndex &&
                      ((la.COD = q.COD), (la.COC = q.COC.slice(0)), (la.QCD = q.QCD), (la.QCC = q.QCC.slice(0)));
                    q.currentTile = la;
                    break;
                  case 65427:
                    la = q.currentTile;
                    if (0 === la.partIndex) {
                      for (var pa = q, va = pa.SIZ.Csiz, Ba = pa.tiles[la.index], ta = 0; ta < va; ta++) {
                        var Ta = Ba.components[ta];
                        Ta.quantizationParameters =
                          void 0 !== pa.currentTile.QCC[ta] ? pa.currentTile.QCC[ta] : pa.currentTile.QCD;
                        Ta.codingStyleParameters =
                          void 0 !== pa.currentTile.COC[ta] ? pa.currentTile.COC[ta] : pa.currentTile.COD;
                      }
                      Ba.codingStyleDefaultParameters = pa.currentTile.COD;
                      for (var qa = q, ra = qa.tiles[qa.currentTile.index], ia = qa.SIZ.Csiz, R = 0; R < ia; R++) {
                        for (
                          var fa = ra.components[R],
                            Ya = fa.codingStyleParameters.decompositionLevelsCount,
                            bb = [],
                            Ea = [],
                            Ua = 0;
                          Ua <= Ya;
                          Ua++
                        ) {
                          var Za = Ua,
                            Pa = fa.codingStyleParameters,
                            za = {};
                          Pa.entropyCoderWithCustomPrecincts
                            ? ((za.PPx = Pa.precinctsSizes[Za].PPx), (za.PPy = Pa.precinctsSizes[Za].PPy))
                            : ((za.PPx = 15), (za.PPy = 15));
                          za.xcb_ = 0 < Za ? Math.min(Pa.xcb, za.PPx - 1) : Math.min(Pa.xcb, za.PPx);
                          za.ycb_ = 0 < Za ? Math.min(Pa.ycb, za.PPy - 1) : Math.min(Pa.ycb, za.PPy);
                          var La = za;
                          var ka = {},
                            Ma = 1 << (Ya - Ua);
                          ka.trx0 = Math.ceil(fa.tcx0 / Ma);
                          ka.try0 = Math.ceil(fa.tcy0 / Ma);
                          ka.trx1 = Math.ceil(fa.tcx1 / Ma);
                          ka.try1 = Math.ceil(fa.tcy1 / Ma);
                          ka.resLevel = Ua;
                          var xa = 1 << La.PPx,
                            $a = 1 << La.PPy,
                            jb = 0 === ka.resLevel,
                            ub = ka.trx1 > ka.trx0 ? Math.ceil(ka.trx1 / xa) - Math.floor(ka.trx0 / xa) : 0,
                            vb = ka.try1 > ka.try0 ? Math.ceil(ka.try1 / $a) - Math.floor(ka.try0 / $a) : 0;
                          ka.precinctParameters = {
                            precinctWidth: xa,
                            precinctHeight: $a,
                            numprecinctswide: ub,
                            numprecinctshigh: vb,
                            numprecincts: ub * vb,
                            precinctWidthInSubband: 1 << (La.PPx + (jb ? 0 : -1)),
                            precinctHeightInSubband: 1 << (La.PPy + (jb ? 0 : -1)),
                          };
                          bb.push(ka);
                          if (0 === Ua) {
                            var ha = { type: 'LL' };
                            ha.tbx0 = Math.ceil(fa.tcx0 / Ma);
                            ha.tby0 = Math.ceil(fa.tcy0 / Ma);
                            ha.tbx1 = Math.ceil(fa.tcx1 / Ma);
                            ha.tby1 = Math.ceil(fa.tcy1 / Ma);
                            ha.resolution = ka;
                            d(qa, ha, La);
                            Ea.push(ha);
                            ka.subbands = [ha];
                          } else {
                            var Fa = 1 << (Ya - Ua + 1),
                              wb = [];
                            ha = { type: 'HL' };
                            ha.tbx0 = Math.ceil(fa.tcx0 / Fa - 0.5);
                            ha.tby0 = Math.ceil(fa.tcy0 / Fa);
                            ha.tbx1 = Math.ceil(fa.tcx1 / Fa - 0.5);
                            ha.tby1 = Math.ceil(fa.tcy1 / Fa);
                            ha.resolution = ka;
                            d(qa, ha, La);
                            Ea.push(ha);
                            wb.push(ha);
                            ha = { type: 'LH' };
                            ha.tbx0 = Math.ceil(fa.tcx0 / Fa);
                            ha.tby0 = Math.ceil(fa.tcy0 / Fa - 0.5);
                            ha.tbx1 = Math.ceil(fa.tcx1 / Fa);
                            ha.tby1 = Math.ceil(fa.tcy1 / Fa - 0.5);
                            ha.resolution = ka;
                            d(qa, ha, La);
                            Ea.push(ha);
                            wb.push(ha);
                            ha = { type: 'HH' };
                            ha.tbx0 = Math.ceil(fa.tcx0 / Fa - 0.5);
                            ha.tby0 = Math.ceil(fa.tcy0 / Fa - 0.5);
                            ha.tbx1 = Math.ceil(fa.tcx1 / Fa - 0.5);
                            ha.tby1 = Math.ceil(fa.tcy1 / Fa - 0.5);
                            ha.resolution = ka;
                            d(qa, ha, La);
                            Ea.push(ha);
                            wb.push(ha);
                            ka.subbands = wb;
                          }
                        }
                        fa.resolutions = bb;
                        fa.subbands = Ea;
                      }
                      var Cb = ra.codingStyleDefaultParameters.progressionOrder;
                      switch (Cb) {
                        case 0:
                          ra.packetsIterator = new z(qa);
                          break;
                        case 1:
                          ra.packetsIterator = new C(qa);
                          break;
                        case 2:
                          ra.packetsIterator = new B(qa);
                          break;
                        case 3:
                          ra.packetsIterator = new n(qa);
                          break;
                        case 4:
                          ra.packetsIterator = new e(qa);
                          break;
                        default:
                          throw new b('Unsupported progression order ' + Cb);
                      }
                    }
                    F = la.dataEnd - w;
                    A(q, f, w, F);
                    break;
                  case 65365:
                  case 65367:
                  case 65368:
                  case 65380:
                    F = (0, a.readUint16)(f, w);
                    break;
                  case 65363:
                    throw Error('Codestream code 0xFF53 (COC) is not implemented');
                  default:
                    throw Error('Unknown codestream code: ' + E.toString(16));
                }
                w += F;
              }
            } catch (Vb) {
              if (p || this.failOnCorruptedImage) throw new b(Vb.message);
              (0, a.warn)('JPX: Trying to recover from: ' + Vb.message);
            }
            for (var Wb = q.components, kb = q.SIZ.Csiz, Qa = [], Db = 0, nc = q.tiles.length; Db < nc; Db++) {
              var Eb = q.tiles[Db],
                eb = [],
                Ra;
              for (Ra = 0; Ra < kb; Ra++) {
                for (
                  var oc = eb,
                    pc = Ra,
                    fb = Eb.components[Ra],
                    Fb = fb.codingStyleParameters,
                    Gb = fb.quantizationParameters,
                    qc = Fb.decompositionLevelsCount,
                    xb = Gb.SPqcds,
                    rc = Gb.scalarExpounded,
                    sc = Gb.guardBits,
                    tc = Fb.segmentationSymbolUsed,
                    uc = q.components[Ra].precision,
                    Hb = Fb.reversibleTransformation,
                    vc = Hb ? new J() : new l(),
                    Xb = [],
                    Ib = 0,
                    mb = 0;
                  mb <= qc;
                  mb++
                ) {
                  for (
                    var lb = fb.resolutions[mb],
                      Jb = lb.trx1 - lb.trx0,
                      Yb = lb.try1 - lb.try0,
                      Zb = new Float32Array(Jb * Yb),
                      Kb = 0,
                      wc = lb.subbands.length;
                    Kb < wc;
                    Kb++
                  ) {
                    if (rc) {
                      var $b = xb[Ib].mu;
                      var Lb = xb[Ib].epsilon;
                      Ib++;
                    } else ($b = xb[0].mu), (Lb = xb[0].epsilon + (0 < mb ? 1 - mb : 0));
                    for (
                      var ac = lb.subbands[Kb],
                        xc = c[ac.type],
                        yc = Zb,
                        bc = Jb,
                        cb = ac,
                        zc = Hb ? 1 : Math.pow(2, uc + xc - Lb) * (1 + $b / 2048),
                        Mb = sc + Lb - 1,
                        cc = Hb,
                        Ac = tc,
                        Bc = cb.tbx0,
                        Cc = cb.tby0,
                        yb = cb.tbx1 - cb.tbx0,
                        dc = cb.codeblocks,
                        Dc = 'H' === cb.type.charAt(0) ? 1 : 0,
                        Ec = 'H' === cb.type.charAt(1) ? bc : 0,
                        Nb = 0,
                        Fc = dc.length;
                      Nb < Fc;
                      ++Nb
                    ) {
                      var Xa = dc[Nb],
                        zb = Xa.tbx1_ - Xa.tbx0_,
                        Ob = Xa.tby1_ - Xa.tby0_;
                      if (0 !== zb && 0 !== Ob && void 0 !== Xa.data) {
                        var db = new g(zb, Ob, Xa.subbandType, Xa.zeroBitPlanes, Mb);
                        var Pb = 2;
                        var Ab = Xa.data,
                          Qb = 0,
                          ec = 0,
                          Bb;
                        var Na = 0;
                        for (Bb = Ab.length; Na < Bb; Na++) {
                          var gb = Ab[Na];
                          Qb += gb.end - gb.start;
                          ec += gb.codingpasses;
                        }
                        var fc = new Uint8Array(Qb),
                          hb = 0;
                        Na = 0;
                        for (Bb = Ab.length; Na < Bb; Na++) {
                          gb = Ab[Na];
                          var gc = gb.data.subarray(gb.start, gb.end);
                          fc.set(gc, hb);
                          hb += gc.length;
                        }
                        var Gc = new k.ArithmeticDecoder(fc, 0, Qb);
                        db.setDecoder(Gc);
                        for (Na = 0; Na < ec; Na++) {
                          switch (Pb) {
                            case 0:
                              db.runSignificancePropagationPass();
                              break;
                            case 1:
                              db.runMagnitudeRefinementPass();
                              break;
                            case 2:
                              db.runCleanupPass(), Ac && db.checkSegmentationSymbol();
                          }
                          Pb = (Pb + 1) % 3;
                        }
                        var nb = Xa.tbx0_ - Bc + (Xa.tby0_ - Cc) * yb,
                          Hc = db.coefficentsSign,
                          Ic = db.coefficentsMagnitude,
                          Jc = db.bitsDecoded,
                          Kc = cc ? 0 : 0.5,
                          Rb;
                        hb = 0;
                        var Lc = 'LL' !== cb.type;
                        for (Na = 0; Na < Ob; Na++) {
                          var Mc = 2 * ((nb / yb) | 0) * (bc - yb) + Dc + Ec;
                          for (Rb = 0; Rb < zb; Rb++) {
                            var ib = Ic[hb];
                            if (0 !== ib) {
                              ib = (ib + Kc) * zc;
                              0 !== Hc[hb] && (ib = -ib);
                              var hc = Jc[hb];
                              yc[Lc ? Mc + (nb << 1) : nb] = cc && hc >= Mb ? ib : ib * (1 << (Mb - hc));
                            }
                            nb++;
                            hb++;
                          }
                          nb += yb - zb;
                        }
                      }
                    }
                  }
                  Xb.push({ width: Jb, height: Yb, items: Zb });
                }
                var Sb = vc.calculate(Xb, fb.tcx0, fb.tcy0);
                oc[pc] = { left: fb.tcx0, top: fb.tcy0, width: Sb.width, height: Sb.height, items: Sb.items };
              }
              var ob = eb[0],
                ab = new Uint8ClampedArray(ob.items.length * kb),
                Nc = { left: ob.left, top: ob.top, width: ob.width, height: ob.height, items: ab },
                Ga = 0,
                sa;
              if (Eb.codingStyleDefaultParameters.multipleComponentTransform) {
                var ic = 4 === kb,
                  Tb = eb[0].items,
                  jc = eb[1].items,
                  kc = eb[2].items,
                  Oc = ic ? eb[3].items : null;
                var Va = Wb[0].precision - 8;
                var pb = (128 << Va) + 0.5;
                var Pc = Eb.components[0],
                  lc = kb - 3;
                var qb = Tb.length;
                if (Pc.codingStyleParameters.reversibleTransformation)
                  for (sa = 0; sa < qb; sa++, Ga += lc) {
                    var rb = Tb[sa] + pb;
                    var sb = jc[sa];
                    var tb = kc[sa];
                    var Ub = rb - ((tb + sb) >> 2);
                    ab[Ga++] = (Ub + tb) >> Va;
                    ab[Ga++] = Ub >> Va;
                    ab[Ga++] = (Ub + sb) >> Va;
                  }
                else
                  for (sa = 0; sa < qb; sa++, Ga += lc)
                    (rb = Tb[sa] + pb),
                      (sb = jc[sa]),
                      (tb = kc[sa]),
                      (ab[Ga++] = (rb + 1.402 * tb) >> Va),
                      (ab[Ga++] = (rb - 0.34413 * sb - 0.71414 * tb) >> Va),
                      (ab[Ga++] = (rb + 1.772 * sb) >> Va);
                if (ic) for (sa = 0, Ga = 3; sa < qb; sa++, Ga += 4) ab[Ga] = (Oc[sa] + pb) >> Va;
              } else
                for (Ra = 0; Ra < kb; Ra++) {
                  var mc = eb[Ra].items;
                  Va = Wb[Ra].precision - 8;
                  pb = (128 << Va) + 0.5;
                  Ga = Ra;
                  sa = 0;
                  for (qb = mc.length; sa < qb; sa++) (ab[Ga] = (mc[sa] + pb) >> Va), (Ga += kb);
                }
              Qa.push(Nc);
            }
            this.tiles = Qa;
            this.width = q.SIZ.Xsiz - q.SIZ.XOsiz;
            this.height = q.SIZ.Ysiz - q.SIZ.YOsiz;
            this.componentsCount = q.SIZ.Csiz;
          },
        };
        var q = (function() {
            function b(b, d) {
              var c = (0, a.log2)(Math.max(b, d)) + 1;
              this.levels = [];
              for (var f = 0; f < c; f++)
                this.levels.push({ width: b, height: d, items: [] }), (b = Math.ceil(b / 2)), (d = Math.ceil(d / 2));
            }
            b.prototype = {
              reset: function(a, b) {
                for (var d = 0, c = 0, f; d < this.levels.length; ) {
                  f = this.levels[d];
                  var l = a + b * f.width;
                  if (void 0 !== f.items[l]) {
                    c = f.items[l];
                    break;
                  }
                  f.index = l;
                  a >>= 1;
                  b >>= 1;
                  d++;
                }
                d--;
                f = this.levels[d];
                f.items[f.index] = c;
                this.currentLevel = d;
                delete this.value;
              },
              incrementValue: function() {
                var a = this.levels[this.currentLevel];
                a.items[a.index]++;
              },
              nextLevel: function() {
                var a = this.currentLevel,
                  b = this.levels[a],
                  d = b.items[b.index];
                a--;
                if (0 > a) return (this.value = d), !1;
                this.currentLevel = a;
                b = this.levels[a];
                b.items[b.index] = d;
                return !0;
              },
            };
            return b;
          })(),
          x = (function() {
            function b(b, d, c) {
              var f = (0, a.log2)(Math.max(b, d)) + 1;
              this.levels = [];
              for (var l = 0; l < f; l++) {
                for (var g = new Uint8Array(b * d), r = 0, e = g.length; r < e; r++) g[r] = c;
                this.levels.push({ width: b, height: d, items: g });
                b = Math.ceil(b / 2);
                d = Math.ceil(d / 2);
              }
            }
            b.prototype = {
              reset: function(a, b, d) {
                for (var c = 0; c < this.levels.length; ) {
                  var f = this.levels[c],
                    l = a + b * f.width;
                  f.index = l;
                  f = f.items[l];
                  if (255 === f) break;
                  if (f > d) return (this.currentLevel = c), this.propagateValues(), !1;
                  a >>= 1;
                  b >>= 1;
                  c++;
                }
                this.currentLevel = c - 1;
                return !0;
              },
              incrementValue: function(a) {
                var b = this.levels[this.currentLevel];
                b.items[b.index] = a + 1;
                this.propagateValues();
              },
              propagateValues: function() {
                for (var a = this.currentLevel, b = this.levels[a], d = b.items[b.index]; 0 <= --a; )
                  (b = this.levels[a]), (b.items[b.index] = d);
              },
              nextLevel: function() {
                var a = this.currentLevel,
                  b = this.levels[a],
                  d = b.items[b.index];
                b.items[b.index] = 255;
                a--;
                if (0 > a) return !1;
                this.currentLevel = a;
                b = this.levels[a];
                b.items[b.index] = d;
                return !0;
              },
            };
            return b;
          })(),
          g = (function() {
            function a(a, b, f, g, r) {
              this.width = a;
              this.height = b;
              this.contextLabelTable = 'HH' === f ? l : 'HL' === f ? c : d;
              a *= b;
              this.neighborsSignificance = new Uint8Array(a);
              this.coefficentsSign = new Uint8Array(a);
              this.coefficentsMagnitude = 14 < r ? new Uint32Array(a) : 6 < r ? new Uint16Array(a) : new Uint8Array(a);
              this.processingFlags = new Uint8Array(a);
              r = new Uint8Array(a);
              if (0 !== g) for (b = 0; b < a; b++) r[b] = g;
              this.bitsDecoded = r;
              this.reset();
            }
            var d = new Uint8Array([
                0,
                5,
                8,
                0,
                3,
                7,
                8,
                0,
                4,
                7,
                8,
                0,
                0,
                0,
                0,
                0,
                1,
                6,
                8,
                0,
                3,
                7,
                8,
                0,
                4,
                7,
                8,
                0,
                0,
                0,
                0,
                0,
                2,
                6,
                8,
                0,
                3,
                7,
                8,
                0,
                4,
                7,
                8,
                0,
                0,
                0,
                0,
                0,
                2,
                6,
                8,
                0,
                3,
                7,
                8,
                0,
                4,
                7,
                8,
                0,
                0,
                0,
                0,
                0,
                2,
                6,
                8,
                0,
                3,
                7,
                8,
                0,
                4,
                7,
                8,
              ]),
              c = new Uint8Array([
                0,
                3,
                4,
                0,
                5,
                7,
                7,
                0,
                8,
                8,
                8,
                0,
                0,
                0,
                0,
                0,
                1,
                3,
                4,
                0,
                6,
                7,
                7,
                0,
                8,
                8,
                8,
                0,
                0,
                0,
                0,
                0,
                2,
                3,
                4,
                0,
                6,
                7,
                7,
                0,
                8,
                8,
                8,
                0,
                0,
                0,
                0,
                0,
                2,
                3,
                4,
                0,
                6,
                7,
                7,
                0,
                8,
                8,
                8,
                0,
                0,
                0,
                0,
                0,
                2,
                3,
                4,
                0,
                6,
                7,
                7,
                0,
                8,
                8,
                8,
              ]),
              l = new Uint8Array([
                0,
                1,
                2,
                0,
                1,
                2,
                2,
                0,
                2,
                2,
                2,
                0,
                0,
                0,
                0,
                0,
                3,
                4,
                5,
                0,
                4,
                5,
                5,
                0,
                5,
                5,
                5,
                0,
                0,
                0,
                0,
                0,
                6,
                7,
                7,
                0,
                7,
                7,
                7,
                0,
                7,
                7,
                7,
                0,
                0,
                0,
                0,
                0,
                8,
                8,
                8,
                0,
                8,
                8,
                8,
                0,
                8,
                8,
                8,
                0,
                0,
                0,
                0,
                0,
                8,
                8,
                8,
                0,
                8,
                8,
                8,
                0,
                8,
                8,
                8,
              ]);
            a.prototype = {
              setDecoder: function(a) {
                this.decoder = a;
              },
              reset: function() {
                this.contexts = new Int8Array(19);
                this.contexts[0] = 8;
                this.contexts[17] = 92;
                this.contexts[18] = 6;
              },
              setNeighborsSignificance: function(a, b, d) {
                var c = this.neighborsSignificance,
                  f = this.width,
                  l = this.height,
                  g = 0 < b;
                b = b + 1 < f;
                if (0 < a) {
                  var r = d - f;
                  g && (c[r - 1] += 16);
                  b && (c[r + 1] += 16);
                  c[r] += 4;
                }
                a + 1 < l && ((r = d + f), g && (c[r - 1] += 16), b && (c[r + 1] += 16), (c[r] += 4));
                g && (c[d - 1] += 1);
                b && (c[d + 1] += 1);
                c[d] |= 128;
              },
              runSignificancePropagationPass: function() {
                for (
                  var a = this.decoder,
                    b = this.width,
                    d = this.height,
                    c = this.coefficentsMagnitude,
                    f = this.coefficentsSign,
                    l = this.neighborsSignificance,
                    g = this.processingFlags,
                    r = this.contexts,
                    e = this.contextLabelTable,
                    h = this.bitsDecoded,
                    q = 0;
                  q < d;
                  q += 4
                )
                  for (var n = 0; n < b; n++)
                    for (var p = q * b + n, D = 0; 4 > D; D++, p += b) {
                      var k = q + D;
                      if (k >= d) break;
                      g[p] &= -2;
                      if (!c[p] && l[p]) {
                        if (a.readBit(r, e[l[p]])) {
                          var x = this.decodeSignBit(k, n, p);
                          f[p] = x;
                          c[p] = 1;
                          this.setNeighborsSignificance(k, n, p);
                          g[p] |= 2;
                        }
                        h[p]++;
                        g[p] |= 1;
                      }
                    }
              },
              decodeSignBit: function(a, b, d) {
                var c = this.width,
                  f = this.height,
                  l = this.coefficentsMagnitude,
                  g = this.coefficentsSign;
                var r = 0 < b && 0 !== l[d - 1];
                b + 1 < c && 0 !== l[d + 1]
                  ? ((b = g[d + 1]), r ? ((r = g[d - 1]), (b = 1 - b - r)) : (b = 1 - b - b))
                  : r
                  ? ((r = g[d - 1]), (b = 1 - r - r))
                  : (b = 0);
                var e = 3 * b;
                r = 0 < a && 0 !== l[d - c];
                a + 1 < f && 0 !== l[d + c]
                  ? ((b = g[d + c]), r ? ((r = g[d - c]), (b = 1 - b - r + e)) : (b = 1 - b - b + e))
                  : r
                  ? ((r = g[d - c]), (b = 1 - r - r + e))
                  : (b = e);
                return 0 <= b
                  ? this.decoder.readBit(this.contexts, 9 + b)
                  : this.decoder.readBit(this.contexts, 9 - b) ^ 1;
              },
              runMagnitudeRefinementPass: function() {
                for (
                  var a = this.decoder,
                    b = this.width,
                    d = this.coefficentsMagnitude,
                    c = this.neighborsSignificance,
                    f = this.contexts,
                    l = this.bitsDecoded,
                    g = this.processingFlags,
                    r = b * this.height,
                    e = 4 * b,
                    h = 0,
                    q;
                  h < r;
                  h = q
                ) {
                  q = Math.min(r, h + e);
                  for (var n = 0; n < b; n++)
                    for (var p = h + n; p < q; p += b)
                      if (d[p] && 0 === (g[p] & 1)) {
                        var D = 16;
                        0 !== (g[p] & 2) && ((g[p] ^= 2), (D = 0 === (c[p] & 127) ? 15 : 14));
                        D = a.readBit(f, D);
                        d[p] = (d[p] << 1) | D;
                        l[p]++;
                        g[p] |= 1;
                      }
                }
              },
              runCleanupPass: function() {
                for (
                  var a = this.decoder,
                    b = this.width,
                    d = this.height,
                    c = this.neighborsSignificance,
                    f = this.coefficentsMagnitude,
                    l = this.coefficentsSign,
                    g = this.contexts,
                    r = this.contextLabelTable,
                    e = this.bitsDecoded,
                    h = this.processingFlags,
                    q = 2 * b,
                    n = 3 * b,
                    p,
                    D = 0;
                  D < d;
                  D = p
                ) {
                  p = Math.min(D + 4, d);
                  for (var k = D * b, x = D + 3 < d, A = 0; A < b; A++) {
                    var m = k + A,
                      u = 0,
                      G = m,
                      J = D;
                    if (
                      x &&
                      0 === h[m] &&
                      0 === h[m + b] &&
                      0 === h[m + q] &&
                      0 === h[m + n] &&
                      0 === c[m] &&
                      0 === c[m + b] &&
                      0 === c[m + q] &&
                      0 === c[m + n]
                    ) {
                      if (!a.readBit(g, 18)) {
                        e[m]++;
                        e[m + b]++;
                        e[m + q]++;
                        e[m + n]++;
                        continue;
                      }
                      u = (a.readBit(g, 17) << 1) | a.readBit(g, 17);
                      0 !== u && ((J = D + u), (G += u * b));
                      var v = this.decodeSignBit(J, A, G);
                      l[G] = v;
                      f[G] = 1;
                      this.setNeighborsSignificance(J, A, G);
                      h[G] |= 2;
                      G = m;
                      for (m = D; m <= J; m++, G += b) e[G]++;
                      u++;
                    }
                    for (J = D + u; J < p; J++, G += b)
                      f[G] ||
                        0 !== (h[G] & 1) ||
                        (1 === a.readBit(g, r[c[G]]) &&
                          ((v = this.decodeSignBit(J, A, G)),
                          (l[G] = v),
                          (f[G] = 1),
                          this.setNeighborsSignificance(J, A, G),
                          (h[G] |= 2)),
                        e[G]++);
                  }
                }
              },
              checkSegmentationSymbol: function() {
                var a = this.decoder,
                  d = this.contexts;
                if (
                  10 !==
                  ((a.readBit(d, 17) << 3) | (a.readBit(d, 17) << 2) | (a.readBit(d, 17) << 1) | a.readBit(d, 17))
                )
                  throw new b('Invalid segmentation symbol');
              },
            };
            return a;
          })(),
          G = (function() {
            function a() {}
            a.prototype.calculate = function(a, b, d) {
              for (var c = a[0], f = 1, l = a.length; f < l; f++) c = this.iterate(c, a[f], b, d);
              return c;
            };
            a.prototype.extend = function(a, b, d) {
              var c = b - 1,
                f = b + 1,
                l = b + d - 2;
              b += d;
              a[c--] = a[f++];
              a[b++] = a[l--];
              a[c--] = a[f++];
              a[b++] = a[l--];
              a[c--] = a[f++];
              a[b++] = a[l--];
              a[c] = a[f];
              a[b] = a[l];
            };
            a.prototype.iterate = function(a, b, d, c) {
              var f = a.width,
                l = a.height,
                g = a.items,
                r = b.width,
                e = b.height;
              b = b.items;
              var h, q, n;
              for (h = n = 0; h < l; h++) {
                var p = 2 * h * r;
                for (q = 0; q < f; q++, n++, p += 2) b[p] = g[n];
              }
              a.items = null;
              a = new Float32Array(r + 8);
              if (1 === r) {
                if (0 !== (d & 1)) for (n = p = 0; p < e; p++, n += r) b[n] *= 0.5;
              } else
                for (n = p = 0; p < e; p++, n += r)
                  a.set(b.subarray(n, n + r), 4),
                    this.extend(a, 4, r),
                    this.filter(a, 4, r),
                    b.set(a.subarray(4, 4 + r), n);
              d = 16;
              f = [];
              for (h = 0; h < d; h++) f.push(new Float32Array(e + 8));
              h = 0;
              a = 4 + e;
              if (1 === e) {
                if (0 !== (c & 1)) for (c = 0; c < r; c++) b[c] *= 0.5;
              } else
                for (c = 0; c < r; c++) {
                  if (0 === h) {
                    d = Math.min(r - c, d);
                    n = c;
                    for (p = 4; p < a; n += r, p++) for (l = 0; l < d; l++) f[l][p] = b[n + l];
                    h = d;
                  }
                  h--;
                  n = f[h];
                  this.extend(n, 4, e);
                  this.filter(n, 4, e);
                  if (0 === h)
                    for (n = c - d + 1, p = 4; p < a; n += r, p++) for (l = 0; l < d; l++) b[n + l] = f[l][p];
                }
              return { width: r, height: e, items: b };
            };
            return a;
          })(),
          l = (function() {
            function a() {
              G.call(this);
            }
            a.prototype = Object.create(G.prototype);
            a.prototype.filter = function(a, b, d) {
              d >>= 1;
              b |= 0;
              var c;
              var f = b - 3;
              for (c = d + 4; c--; f += 2) a[f] *= 0.8128930661159609;
              f = b - 2;
              var l = 0.443506852043971 * a[f - 1];
              for (c = d + 3; c--; f += 2) {
                var g = 0.443506852043971 * a[f + 1];
                a[f] = 1.230174104914001 * a[f] - l - g;
                if (c--) (f += 2), (l = 0.443506852043971 * a[f + 1]), (a[f] = 1.230174104914001 * a[f] - l - g);
                else break;
              }
              f = b - 1;
              l = 0.882911075530934 * a[f - 1];
              for (c = d + 2; c--; f += 2)
                if (((g = 0.882911075530934 * a[f + 1]), (a[f] -= l + g), c--))
                  (f += 2), (l = 0.882911075530934 * a[f + 1]), (a[f] -= l + g);
                else break;
              f = b;
              l = -0.052980118572961 * a[f - 1];
              for (c = d + 1; c--; f += 2)
                if (((g = -0.052980118572961 * a[f + 1]), (a[f] -= l + g), c--))
                  (f += 2), (l = -0.052980118572961 * a[f + 1]), (a[f] -= l + g);
                else break;
              if (0 !== d)
                for (f = b + 1, l = -1.586134342059924 * a[f - 1], c = d; c--; f += 2)
                  if (((g = -1.586134342059924 * a[f + 1]), (a[f] -= l + g), c--))
                    (f += 2), (l = -1.586134342059924 * a[f + 1]), (a[f] -= l + g);
                  else break;
            };
            return a;
          })(),
          J = (function() {
            function a() {
              G.call(this);
            }
            a.prototype = Object.create(G.prototype);
            a.prototype.filter = function(a, b, d) {
              d >>= 1;
              b |= 0;
              var c;
              var f = b;
              for (c = d + 1; c--; f += 2) a[f] -= (a[f - 1] + a[f + 1] + 2) >> 2;
              f = b + 1;
              for (c = d; c--; f += 2) a[f] += (a[f - 1] + a[f + 1]) >> 1;
            };
            return a;
          })();
        return m;
      })();
      m.JpxImage = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.calculateSHA512 = m.calculateSHA384 = m.calculateSHA256 = m.calculateMD5 = m.PDF20 = m.PDF17 = m.CipherTransformFactory = m.ARCFourCipher = m.AES256Cipher = m.AES128Cipher = void 0;
      var a = t(0),
        k = t(1),
        b = t(3),
        v = (function() {
          function a(a) {
            this.b = this.a = 0;
            var b = new Uint8Array(256),
              d,
              c = 0,
              e = a.length;
            for (d = 0; 256 > d; ++d) b[d] = d;
            for (d = 0; 256 > d; ++d) {
              var f = b[d];
              c = (c + f + a[d % e]) & 255;
              b[d] = b[c];
              b[c] = f;
            }
            this.s = b;
          }
          a.prototype = {
            encryptBlock: function(a) {
              var b,
                d = a.length,
                c = this.a,
                e = this.b,
                f = this.s,
                r = new Uint8Array(d);
              for (b = 0; b < d; ++b) {
                c = (c + 1) & 255;
                var h = f[c];
                e = (e + h) & 255;
                var n = f[e];
                f[c] = n;
                f[e] = h;
                r[b] = a[b] ^ f[(h + n) & 255];
              }
              this.a = c;
              this.b = e;
              return r;
            },
          };
          a.prototype.decryptBlock = a.prototype.encryptBlock;
          return a;
        })(),
        d = (function() {
          var a = new Uint8Array([
              7,
              12,
              17,
              22,
              7,
              12,
              17,
              22,
              7,
              12,
              17,
              22,
              7,
              12,
              17,
              22,
              5,
              9,
              14,
              20,
              5,
              9,
              14,
              20,
              5,
              9,
              14,
              20,
              5,
              9,
              14,
              20,
              4,
              11,
              16,
              23,
              4,
              11,
              16,
              23,
              4,
              11,
              16,
              23,
              4,
              11,
              16,
              23,
              6,
              10,
              15,
              21,
              6,
              10,
              15,
              21,
              6,
              10,
              15,
              21,
              6,
              10,
              15,
              21,
            ]),
            b = new Int32Array([
              -680876936,
              -389564586,
              606105819,
              -1044525330,
              -176418897,
              1200080426,
              -1473231341,
              -45705983,
              1770035416,
              -1958414417,
              -42063,
              -1990404162,
              1804603682,
              -40341101,
              -1502002290,
              1236535329,
              -165796510,
              -1069501632,
              643717713,
              -373897302,
              -701558691,
              38016083,
              -660478335,
              -405537848,
              568446438,
              -1019803690,
              -187363961,
              1163531501,
              -1444681467,
              -51403784,
              1735328473,
              -1926607734,
              -378558,
              -2022574463,
              1839030562,
              -35309556,
              -1530992060,
              1272893353,
              -155497632,
              -1094730640,
              681279174,
              -358537222,
              -722521979,
              76029189,
              -640364487,
              -421815835,
              530742520,
              -995338651,
              -198630844,
              1126891415,
              -1416354905,
              -57434055,
              1700485571,
              -1894986606,
              -1051523,
              -2054922799,
              1873313359,
              -30611744,
              -1560198380,
              1309151649,
              -145523070,
              -1120210379,
              718787259,
              -343485551,
            ]);
          return function(d, c, l) {
            var g = 1732584193,
              f = -271733879,
              e = -1732584194,
              h = 271733878,
              n = (l + 72) & -64,
              q = new Uint8Array(n),
              p;
            for (p = 0; p < l; ++p) q[p] = d[c++];
            q[p++] = 128;
            for (d = n - 8; p < d; ) q[p++] = 0;
            q[p++] = (l << 3) & 255;
            q[p++] = (l >> 5) & 255;
            q[p++] = (l >> 13) & 255;
            q[p++] = (l >> 21) & 255;
            q[p++] = (l >>> 29) & 255;
            q[p++] = 0;
            q[p++] = 0;
            q[p++] = 0;
            d = new Int32Array(16);
            for (p = 0; p < n; ) {
              for (l = 0; 16 > l; ++l, p += 4) d[l] = q[p] | (q[p + 1] << 8) | (q[p + 2] << 16) | (q[p + 3] << 24);
              var E = g;
              c = f;
              var k = e,
                K = h;
              for (l = 0; 64 > l; ++l) {
                if (16 > l) {
                  var H = (c & k) | (~c & K);
                  var x = l;
                } else
                  32 > l
                    ? ((H = (K & c) | (~K & k)), (x = (5 * l + 1) & 15))
                    : 48 > l
                    ? ((H = c ^ k ^ K), (x = (3 * l + 5) & 15))
                    : ((H = k ^ (c | ~K)), (x = (7 * l) & 15));
                var A = K;
                E = (E + H + b[l] + d[x]) | 0;
                H = a[l];
                K = k;
                k = c;
                c = (c + ((E << H) | (E >>> (32 - H)))) | 0;
                E = A;
              }
              g = (g + E) | 0;
              f = (f + c) | 0;
              e = (e + k) | 0;
              h = (h + K) | 0;
            }
            return new Uint8Array([
              g & 255,
              (g >> 8) & 255,
              (g >> 16) & 255,
              (g >>> 24) & 255,
              f & 255,
              (f >> 8) & 255,
              (f >> 16) & 255,
              (f >>> 24) & 255,
              e & 255,
              (e >> 8) & 255,
              (e >> 16) & 255,
              (e >>> 24) & 255,
              h & 255,
              (h >> 8) & 255,
              (h >> 16) & 255,
              (h >>> 24) & 255,
            ]);
          };
        })(),
        u = (function() {
          function a(a, b) {
            this.high = a | 0;
            this.low = b | 0;
          }
          a.prototype = {
            and: function(a) {
              this.high &= a.high;
              this.low &= a.low;
            },
            xor: function(a) {
              this.high ^= a.high;
              this.low ^= a.low;
            },
            or: function(a) {
              this.high |= a.high;
              this.low |= a.low;
            },
            shiftRight: function(a) {
              32 <= a
                ? ((this.low = (this.high >>> (a - 32)) | 0), (this.high = 0))
                : ((this.low = (this.low >>> a) | (this.high << (32 - a))), (this.high = (this.high >>> a) | 0));
            },
            shiftLeft: function(a) {
              32 <= a
                ? ((this.high = this.low << (a - 32)), (this.low = 0))
                : ((this.high = (this.high << a) | (this.low >>> (32 - a))), (this.low <<= a));
            },
            rotateRight: function(a) {
              if (a & 32) {
                var b = this.low;
                var d = this.high;
              } else (d = this.low), (b = this.high);
              a &= 31;
              this.low = (d >>> a) | (b << (32 - a));
              this.high = (b >>> a) | (d << (32 - a));
            },
            not: function() {
              this.high = ~this.high;
              this.low = ~this.low;
            },
            add: function(a) {
              var b = (this.low >>> 0) + (a.low >>> 0);
              a = (this.high >>> 0) + (a.high >>> 0);
              4294967295 < b && (a += 1);
              this.low = b | 0;
              this.high = a | 0;
            },
            copyTo: function(a, b) {
              a[b] = (this.high >>> 24) & 255;
              a[b + 1] = (this.high >> 16) & 255;
              a[b + 2] = (this.high >> 8) & 255;
              a[b + 3] = this.high & 255;
              a[b + 4] = (this.low >>> 24) & 255;
              a[b + 5] = (this.low >> 16) & 255;
              a[b + 6] = (this.low >> 8) & 255;
              a[b + 7] = this.low & 255;
            },
            assign: function(a) {
              this.high = a.high;
              this.low = a.low;
            },
          };
          return a;
        })(),
        z = (function() {
          function a(a, b) {
            return (a >>> b) | (a << (32 - b));
          }
          var b = [
            1116352408,
            1899447441,
            3049323471,
            3921009573,
            961987163,
            1508970993,
            2453635748,
            2870763221,
            3624381080,
            310598401,
            607225278,
            1426881987,
            1925078388,
            2162078206,
            2614888103,
            3248222580,
            3835390401,
            4022224774,
            264347078,
            604807628,
            770255983,
            1249150122,
            1555081692,
            1996064986,
            2554220882,
            2821834349,
            2952996808,
            3210313671,
            3336571891,
            3584528711,
            113926993,
            338241895,
            666307205,
            773529912,
            1294757372,
            1396182291,
            1695183700,
            1986661051,
            2177026350,
            2456956037,
            2730485921,
            2820302411,
            3259730800,
            3345764771,
            3516065817,
            3600352804,
            4094571909,
            275423344,
            430227734,
            506948616,
            659060556,
            883997877,
            958139571,
            1322822218,
            1537002063,
            1747873779,
            1955562222,
            2024104815,
            2227730452,
            2361852424,
            2428436474,
            2756734187,
            3204031479,
            3329325298,
          ];
          return function(d, c, l) {
            var g = 1779033703,
              f = 3144134277,
              e = 1013904242,
              h = 2773480762,
              n = 1359893119,
              q = 2600822924,
              p = 528734635,
              E = 1541459225,
              k = 64 * Math.ceil((l + 9) / 64),
              K = new Uint8Array(k),
              H;
            for (H = 0; H < l; ++H) K[H] = d[c++];
            K[H++] = 128;
            for (d = k - 8; H < d; ) K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = (l >>> 29) & 255;
            K[H++] = (l >> 21) & 255;
            K[H++] = (l >> 13) & 255;
            K[H++] = (l >> 5) & 255;
            K[H++] = (l << 3) & 255;
            d = new Uint32Array(64);
            for (H = 0; H < k; ) {
              for (l = 0; 16 > l; ++l) (d[l] = (K[H] << 24) | (K[H + 1] << 16) | (K[H + 2] << 8) | K[H + 3]), (H += 4);
              for (l = 16; 64 > l; ++l) {
                c = l;
                var A = d[l - 2];
                A = (a(A, 17) ^ a(A, 19) ^ (A >>> 10)) + d[l - 7];
                var x = d[l - 15];
                x = a(x, 7) ^ a(x, 18) ^ (x >>> 3);
                d[c] = (A + x + d[l - 16]) | 0;
              }
              c = g;
              A = f;
              x = e;
              var m = h,
                u = n,
                G = q,
                v = p,
                B = E;
              for (l = 0; 64 > l; ++l) {
                var z = B;
                B = u;
                B = a(B, 6) ^ a(B, 11) ^ a(B, 25);
                z = z + B + ((u & G) ^ (~u & v)) + b[l] + d[l];
                B = c;
                var t = (a(B, 2) ^ a(B, 13) ^ a(B, 22)) + ((c & A) ^ (c & x) ^ (A & x));
                B = v;
                v = G;
                G = u;
                u = (m + z) | 0;
                m = x;
                x = A;
                A = c;
                c = (z + t) | 0;
              }
              g = (g + c) | 0;
              f = (f + A) | 0;
              e = (e + x) | 0;
              h = (h + m) | 0;
              n = (n + u) | 0;
              q = (q + G) | 0;
              p = (p + v) | 0;
              E = (E + B) | 0;
            }
            return new Uint8Array([
              (g >> 24) & 255,
              (g >> 16) & 255,
              (g >> 8) & 255,
              g & 255,
              (f >> 24) & 255,
              (f >> 16) & 255,
              (f >> 8) & 255,
              f & 255,
              (e >> 24) & 255,
              (e >> 16) & 255,
              (e >> 8) & 255,
              e & 255,
              (h >> 24) & 255,
              (h >> 16) & 255,
              (h >> 8) & 255,
              h & 255,
              (n >> 24) & 255,
              (n >> 16) & 255,
              (n >> 8) & 255,
              n & 255,
              (q >> 24) & 255,
              (q >> 16) & 255,
              (q >> 8) & 255,
              q & 255,
              (p >> 24) & 255,
              (p >> 16) & 255,
              (p >> 8) & 255,
              p & 255,
              (E >> 24) & 255,
              (E >> 16) & 255,
              (E >> 8) & 255,
              E & 255,
            ]);
          };
        })(),
        C = (function() {
          var a = [
            new u(1116352408, 3609767458),
            new u(1899447441, 602891725),
            new u(3049323471, 3964484399),
            new u(3921009573, 2173295548),
            new u(961987163, 4081628472),
            new u(1508970993, 3053834265),
            new u(2453635748, 2937671579),
            new u(2870763221, 3664609560),
            new u(3624381080, 2734883394),
            new u(310598401, 1164996542),
            new u(607225278, 1323610764),
            new u(1426881987, 3590304994),
            new u(1925078388, 4068182383),
            new u(2162078206, 991336113),
            new u(2614888103, 633803317),
            new u(3248222580, 3479774868),
            new u(3835390401, 2666613458),
            new u(4022224774, 944711139),
            new u(264347078, 2341262773),
            new u(604807628, 2007800933),
            new u(770255983, 1495990901),
            new u(1249150122, 1856431235),
            new u(1555081692, 3175218132),
            new u(1996064986, 2198950837),
            new u(2554220882, 3999719339),
            new u(2821834349, 766784016),
            new u(2952996808, 2566594879),
            new u(3210313671, 3203337956),
            new u(3336571891, 1034457026),
            new u(3584528711, 2466948901),
            new u(113926993, 3758326383),
            new u(338241895, 168717936),
            new u(666307205, 1188179964),
            new u(773529912, 1546045734),
            new u(1294757372, 1522805485),
            new u(1396182291, 2643833823),
            new u(1695183700, 2343527390),
            new u(1986661051, 1014477480),
            new u(2177026350, 1206759142),
            new u(2456956037, 344077627),
            new u(2730485921, 1290863460),
            new u(2820302411, 3158454273),
            new u(3259730800, 3505952657),
            new u(3345764771, 106217008),
            new u(3516065817, 3606008344),
            new u(3600352804, 1432725776),
            new u(4094571909, 1467031594),
            new u(275423344, 851169720),
            new u(430227734, 3100823752),
            new u(506948616, 1363258195),
            new u(659060556, 3750685593),
            new u(883997877, 3785050280),
            new u(958139571, 3318307427),
            new u(1322822218, 3812723403),
            new u(1537002063, 2003034995),
            new u(1747873779, 3602036899),
            new u(1955562222, 1575990012),
            new u(2024104815, 1125592928),
            new u(2227730452, 2716904306),
            new u(2361852424, 442776044),
            new u(2428436474, 593698344),
            new u(2756734187, 3733110249),
            new u(3204031479, 2999351573),
            new u(3329325298, 3815920427),
            new u(3391569614, 3928383900),
            new u(3515267271, 566280711),
            new u(3940187606, 3454069534),
            new u(4118630271, 4000239992),
            new u(116418474, 1914138554),
            new u(174292421, 2731055270),
            new u(289380356, 3203993006),
            new u(460393269, 320620315),
            new u(685471733, 587496836),
            new u(852142971, 1086792851),
            new u(1017036298, 365543100),
            new u(1126000580, 2618297676),
            new u(1288033470, 3409855158),
            new u(1501505948, 4234509866),
            new u(1607167915, 987167468),
            new u(1816402316, 1246189591),
          ];
          return function(b, d, c, l) {
            l = !!l;
            if (l) {
              var g = new u(3418070365, 3238371032);
              var f = new u(1654270250, 914150663);
              var e = new u(2438529370, 812702999);
              var h = new u(355462360, 4144912697);
              var n = new u(1731405415, 4290775857);
              var q = new u(2394180231, 1750603025);
              var p = new u(3675008525, 1694076839);
              var E = new u(1203062813, 3204075428);
            } else
              (g = new u(1779033703, 4089235720)),
                (f = new u(3144134277, 2227873595)),
                (e = new u(1013904242, 4271175723)),
                (h = new u(2773480762, 1595750129)),
                (n = new u(1359893119, 2917565137)),
                (q = new u(2600822924, 725511199)),
                (p = new u(528734635, 4215389547)),
                (E = new u(1541459225, 327033209));
            var k = 128 * Math.ceil((c + 17) / 128),
              K = new Uint8Array(k),
              H;
            for (H = 0; H < c; ++H) K[H] = b[d++];
            K[H++] = 128;
            for (b = k - 16; H < b; ) K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = 0;
            K[H++] = (c >>> 29) & 255;
            K[H++] = (c >> 21) & 255;
            K[H++] = (c >> 13) & 255;
            K[H++] = (c >> 5) & 255;
            K[H++] = (c << 3) & 255;
            b = Array(80);
            for (H = 0; 80 > H; H++) b[H] = new u(0, 0);
            d = new u(0, 0);
            var A = new u(0, 0),
              x = new u(0, 0),
              m = new u(0, 0),
              B = new u(0, 0),
              v = new u(0, 0),
              G = new u(0, 0),
              z = new u(0, 0),
              t = new u(0, 0),
              C = new u(0, 0),
              ba = new u(0, 0),
              y = new u(0, 0),
              T;
            for (H = 0; H < k; ) {
              for (c = 0; 16 > c; ++c)
                (b[c].high = (K[H] << 24) | (K[H + 1] << 16) | (K[H + 2] << 8) | K[H + 3]),
                  (b[c].low = (K[H + 4] << 24) | (K[H + 5] << 16) | (K[H + 6] << 8) | K[H + 7]),
                  (H += 8);
              for (c = 16; 80 > c; ++c) {
                var S = (T = b[c]),
                  Y = b[c - 2],
                  U = y;
                S.assign(Y);
                S.rotateRight(19);
                U.assign(Y);
                U.rotateRight(61);
                S.xor(U);
                U.assign(Y);
                U.shiftRight(6);
                S.xor(U);
                T.add(b[c - 7]);
                S = ba;
                Y = b[c - 15];
                U = y;
                S.assign(Y);
                S.rotateRight(1);
                U.assign(Y);
                U.rotateRight(8);
                S.xor(U);
                U.assign(Y);
                U.shiftRight(7);
                S.xor(U);
                T.add(ba);
                T.add(b[c - 16]);
              }
              d.assign(g);
              A.assign(f);
              x.assign(e);
              m.assign(h);
              B.assign(n);
              v.assign(q);
              G.assign(p);
              z.assign(E);
              for (c = 0; 80 > c; ++c) {
                t.assign(z);
                T = ba;
                S = B;
                Y = y;
                T.assign(S);
                T.rotateRight(14);
                Y.assign(S);
                Y.rotateRight(18);
                T.xor(Y);
                Y.assign(S);
                Y.rotateRight(41);
                T.xor(Y);
                t.add(ba);
                T = ba;
                S = B;
                Y = v;
                U = G;
                var V = y;
                T.assign(S);
                T.and(Y);
                V.assign(S);
                V.not();
                V.and(U);
                T.xor(V);
                t.add(ba);
                t.add(a[c]);
                t.add(b[c]);
                T = C;
                S = d;
                Y = y;
                T.assign(S);
                T.rotateRight(28);
                Y.assign(S);
                Y.rotateRight(34);
                T.xor(Y);
                Y.assign(S);
                Y.rotateRight(39);
                T.xor(Y);
                T = ba;
                S = d;
                Y = A;
                U = x;
                V = y;
                T.assign(S);
                T.and(Y);
                V.assign(S);
                V.and(U);
                T.xor(V);
                V.assign(Y);
                V.and(U);
                T.xor(V);
                C.add(ba);
                T = z;
                z = G;
                G = v;
                v = B;
                m.add(t);
                B = m;
                m = x;
                x = A;
                A = d;
                T.assign(t);
                T.add(C);
                d = T;
              }
              g.add(d);
              f.add(A);
              e.add(x);
              h.add(m);
              n.add(B);
              q.add(v);
              p.add(G);
              E.add(z);
            }
            l
              ? ((l = new Uint8Array(48)),
                g.copyTo(l, 0),
                f.copyTo(l, 8),
                e.copyTo(l, 16),
                h.copyTo(l, 24),
                n.copyTo(l, 32),
                q.copyTo(l, 40))
              : ((l = new Uint8Array(64)),
                g.copyTo(l, 0),
                f.copyTo(l, 8),
                e.copyTo(l, 16),
                h.copyTo(l, 24),
                n.copyTo(l, 32),
                q.copyTo(l, 40),
                p.copyTo(l, 48),
                E.copyTo(l, 56));
            return l;
          };
        })(),
        B = (function() {
          return function(a, b, d) {
            return C(a, b, d, !0);
          };
        })(),
        n = (function() {
          function a() {}
          a.prototype = {
            decryptBlock: function(a) {
              return a;
            },
          };
          return a;
        })(),
        e = (function() {
          function a(a) {
            var b = new Uint8Array(176);
            b.set(a);
            a = 16;
            for (var f = 1; 176 > a; ++f) {
              var l = b[a - 3],
                g = b[a - 2],
                e = b[a - 1],
                r = b[a - 4];
              l = c[l];
              g = c[g];
              e = c[e];
              r = c[r];
              l ^= d[f];
              for (var h = 0; 4 > h; ++h)
                (b[a] = l ^= b[a - 16]),
                  a++,
                  (b[a] = g ^= b[a - 16]),
                  a++,
                  (b[a] = e ^= b[a - 16]),
                  a++,
                  (b[a] = r ^= b[a - 16]),
                  a++;
            }
            this.key = b;
            this.buffer = new Uint8Array(16);
            this.bufferPosition = 0;
          }
          function b(a, b) {
            var d;
            var c = a.length;
            var f = this.buffer;
            var g = this.bufferPosition;
            var e = [],
              h = this.iv;
            for (d = 0; d < c; ++d)
              if (((f[g] = a[d]), ++g, !(16 > g))) {
                var n;
                var q = f;
                g = this.key;
                var p = new Uint8Array(16);
                p.set(q);
                var k = 0;
                for (n = 160; 16 > k; ++k, ++n) p[k] ^= g[n];
                for (q = 9; 1 <= q; --q) {
                  n = p[13];
                  p[13] = p[9];
                  p[9] = p[5];
                  p[5] = p[1];
                  p[1] = n;
                  n = p[14];
                  var A = p[10];
                  p[14] = p[6];
                  p[10] = p[2];
                  p[6] = n;
                  p[2] = A;
                  n = p[15];
                  A = p[11];
                  k = p[7];
                  p[15] = p[3];
                  p[11] = n;
                  p[7] = A;
                  p[3] = k;
                  for (k = 0; 16 > k; ++k) p[k] = l[p[k]];
                  k = 0;
                  for (n = 16 * q; 16 > k; ++k, ++n) p[k] ^= g[n];
                  for (k = 0; 16 > k; k += 4) {
                    n = r[p[k + 1]];
                    A = r[p[k + 2]];
                    var D = r[p[k + 3]];
                    n = r[p[k]] ^ (n >>> 8) ^ (n << 24) ^ (A >>> 16) ^ (A << 16) ^ (D >>> 24) ^ (D << 8);
                    p[k] = (n >>> 24) & 255;
                    p[k + 1] = (n >> 16) & 255;
                    p[k + 2] = (n >> 8) & 255;
                    p[k + 3] = n & 255;
                  }
                }
                n = p[13];
                p[13] = p[9];
                p[9] = p[5];
                p[5] = p[1];
                p[1] = n;
                n = p[14];
                A = p[10];
                p[14] = p[6];
                p[10] = p[2];
                p[6] = n;
                p[2] = A;
                n = p[15];
                A = p[11];
                k = p[7];
                p[15] = p[3];
                p[11] = n;
                p[7] = A;
                p[3] = k;
                for (k = 0; 16 > k; ++k) (p[k] = l[p[k]]), (p[k] ^= g[k]);
                for (g = 0; 16 > g; ++g) p[g] ^= h[g];
                h = f;
                e.push(p);
                f = new Uint8Array(16);
                g = 0;
              }
            this.buffer = f;
            this.bufferLength = g;
            this.iv = h;
            if (0 === e.length) return new Uint8Array([]);
            f = 16 * e.length;
            if (b && ((h = e[e.length - 1]), (g = h[15]), 16 >= g)) {
              d = 15;
              for (c = 16 - g; d >= c; --d)
                if (h[d] !== g) {
                  g = 0;
                  break;
                }
              f -= g;
              e[e.length - 1] = h.subarray(0, 16 - g);
            }
            f = new Uint8Array(f);
            g = d = 0;
            for (c = e.length; d < c; ++d, g += 16) f.set(e[d], g);
            return f;
          }
          for (
            var d = new Uint8Array([
                141,
                1,
                2,
                4,
                8,
                16,
                32,
                64,
                128,
                27,
                54,
                108,
                216,
                171,
                77,
                154,
                47,
                94,
                188,
                99,
                198,
                151,
                53,
                106,
                212,
                179,
                125,
                250,
                239,
                197,
                145,
                57,
                114,
                228,
                211,
                189,
                97,
                194,
                159,
                37,
                74,
                148,
                51,
                102,
                204,
                131,
                29,
                58,
                116,
                232,
                203,
                141,
                1,
                2,
                4,
                8,
                16,
                32,
                64,
                128,
                27,
                54,
                108,
                216,
                171,
                77,
                154,
                47,
                94,
                188,
                99,
                198,
                151,
                53,
                106,
                212,
                179,
                125,
                250,
                239,
                197,
                145,
                57,
                114,
                228,
                211,
                189,
                97,
                194,
                159,
                37,
                74,
                148,
                51,
                102,
                204,
                131,
                29,
                58,
                116,
                232,
                203,
                141,
                1,
                2,
                4,
                8,
                16,
                32,
                64,
                128,
                27,
                54,
                108,
                216,
                171,
                77,
                154,
                47,
                94,
                188,
                99,
                198,
                151,
                53,
                106,
                212,
                179,
                125,
                250,
                239,
                197,
                145,
                57,
                114,
                228,
                211,
                189,
                97,
                194,
                159,
                37,
                74,
                148,
                51,
                102,
                204,
                131,
                29,
                58,
                116,
                232,
                203,
                141,
                1,
                2,
                4,
                8,
                16,
                32,
                64,
                128,
                27,
                54,
                108,
                216,
                171,
                77,
                154,
                47,
                94,
                188,
                99,
                198,
                151,
                53,
                106,
                212,
                179,
                125,
                250,
                239,
                197,
                145,
                57,
                114,
                228,
                211,
                189,
                97,
                194,
                159,
                37,
                74,
                148,
                51,
                102,
                204,
                131,
                29,
                58,
                116,
                232,
                203,
                141,
                1,
                2,
                4,
                8,
                16,
                32,
                64,
                128,
                27,
                54,
                108,
                216,
                171,
                77,
                154,
                47,
                94,
                188,
                99,
                198,
                151,
                53,
                106,
                212,
                179,
                125,
                250,
                239,
                197,
                145,
                57,
                114,
                228,
                211,
                189,
                97,
                194,
                159,
                37,
                74,
                148,
                51,
                102,
                204,
                131,
                29,
                58,
                116,
                232,
                203,
                141,
              ]),
              c = new Uint8Array([
                99,
                124,
                119,
                123,
                242,
                107,
                111,
                197,
                48,
                1,
                103,
                43,
                254,
                215,
                171,
                118,
                202,
                130,
                201,
                125,
                250,
                89,
                71,
                240,
                173,
                212,
                162,
                175,
                156,
                164,
                114,
                192,
                183,
                253,
                147,
                38,
                54,
                63,
                247,
                204,
                52,
                165,
                229,
                241,
                113,
                216,
                49,
                21,
                4,
                199,
                35,
                195,
                24,
                150,
                5,
                154,
                7,
                18,
                128,
                226,
                235,
                39,
                178,
                117,
                9,
                131,
                44,
                26,
                27,
                110,
                90,
                160,
                82,
                59,
                214,
                179,
                41,
                227,
                47,
                132,
                83,
                209,
                0,
                237,
                32,
                252,
                177,
                91,
                106,
                203,
                190,
                57,
                74,
                76,
                88,
                207,
                208,
                239,
                170,
                251,
                67,
                77,
                51,
                133,
                69,
                249,
                2,
                127,
                80,
                60,
                159,
                168,
                81,
                163,
                64,
                143,
                146,
                157,
                56,
                245,
                188,
                182,
                218,
                33,
                16,
                255,
                243,
                210,
                205,
                12,
                19,
                236,
                95,
                151,
                68,
                23,
                196,
                167,
                126,
                61,
                100,
                93,
                25,
                115,
                96,
                129,
                79,
                220,
                34,
                42,
                144,
                136,
                70,
                238,
                184,
                20,
                222,
                94,
                11,
                219,
                224,
                50,
                58,
                10,
                73,
                6,
                36,
                92,
                194,
                211,
                172,
                98,
                145,
                149,
                228,
                121,
                231,
                200,
                55,
                109,
                141,
                213,
                78,
                169,
                108,
                86,
                244,
                234,
                101,
                122,
                174,
                8,
                186,
                120,
                37,
                46,
                28,
                166,
                180,
                198,
                232,
                221,
                116,
                31,
                75,
                189,
                139,
                138,
                112,
                62,
                181,
                102,
                72,
                3,
                246,
                14,
                97,
                53,
                87,
                185,
                134,
                193,
                29,
                158,
                225,
                248,
                152,
                17,
                105,
                217,
                142,
                148,
                155,
                30,
                135,
                233,
                206,
                85,
                40,
                223,
                140,
                161,
                137,
                13,
                191,
                230,
                66,
                104,
                65,
                153,
                45,
                15,
                176,
                84,
                187,
                22,
              ]),
              l = new Uint8Array([
                82,
                9,
                106,
                213,
                48,
                54,
                165,
                56,
                191,
                64,
                163,
                158,
                129,
                243,
                215,
                251,
                124,
                227,
                57,
                130,
                155,
                47,
                255,
                135,
                52,
                142,
                67,
                68,
                196,
                222,
                233,
                203,
                84,
                123,
                148,
                50,
                166,
                194,
                35,
                61,
                238,
                76,
                149,
                11,
                66,
                250,
                195,
                78,
                8,
                46,
                161,
                102,
                40,
                217,
                36,
                178,
                118,
                91,
                162,
                73,
                109,
                139,
                209,
                37,
                114,
                248,
                246,
                100,
                134,
                104,
                152,
                22,
                212,
                164,
                92,
                204,
                93,
                101,
                182,
                146,
                108,
                112,
                72,
                80,
                253,
                237,
                185,
                218,
                94,
                21,
                70,
                87,
                167,
                141,
                157,
                132,
                144,
                216,
                171,
                0,
                140,
                188,
                211,
                10,
                247,
                228,
                88,
                5,
                184,
                179,
                69,
                6,
                208,
                44,
                30,
                143,
                202,
                63,
                15,
                2,
                193,
                175,
                189,
                3,
                1,
                19,
                138,
                107,
                58,
                145,
                17,
                65,
                79,
                103,
                220,
                234,
                151,
                242,
                207,
                206,
                240,
                180,
                230,
                115,
                150,
                172,
                116,
                34,
                231,
                173,
                53,
                133,
                226,
                249,
                55,
                232,
                28,
                117,
                223,
                110,
                71,
                241,
                26,
                113,
                29,
                41,
                197,
                137,
                111,
                183,
                98,
                14,
                170,
                24,
                190,
                27,
                252,
                86,
                62,
                75,
                198,
                210,
                121,
                32,
                154,
                219,
                192,
                254,
                120,
                205,
                90,
                244,
                31,
                221,
                168,
                51,
                136,
                7,
                199,
                49,
                177,
                18,
                16,
                89,
                39,
                128,
                236,
                95,
                96,
                81,
                127,
                169,
                25,
                181,
                74,
                13,
                45,
                229,
                122,
                159,
                147,
                201,
                156,
                239,
                160,
                224,
                59,
                77,
                174,
                42,
                245,
                176,
                200,
                235,
                187,
                60,
                131,
                83,
                153,
                97,
                23,
                43,
                4,
                126,
                186,
                119,
                214,
                38,
                225,
                105,
                20,
                99,
                85,
                33,
                12,
                125,
              ]),
              e = new Uint8Array(256),
              f = 0;
            256 > f;
            f++
          )
            e[f] = 128 > f ? f << 1 : (f << 1) ^ 27;
          var r = new Uint32Array([
            0,
            235474187,
            470948374,
            303765277,
            941896748,
            908933415,
            607530554,
            708780849,
            1883793496,
            2118214995,
            1817866830,
            1649639237,
            1215061108,
            1181045119,
            1417561698,
            1517767529,
            3767586992,
            4003061179,
            4236429990,
            4069246893,
            3635733660,
            3602770327,
            3299278474,
            3400528769,
            2430122216,
            2664543715,
            2362090238,
            2193862645,
            2835123396,
            2801107407,
            3035535058,
            3135740889,
            3678124923,
            3576870512,
            3341394285,
            3374361702,
            3810496343,
            3977675356,
            4279080257,
            4043610186,
            2876494627,
            2776292904,
            3076639029,
            3110650942,
            2472011535,
            2640243204,
            2403728665,
            2169303058,
            1001089995,
            899835584,
            666464733,
            699432150,
            59727847,
            226906860,
            530400753,
            294930682,
            1273168787,
            1172967064,
            1475418501,
            1509430414,
            1942435775,
            2110667444,
            1876241833,
            1641816226,
            2910219766,
            2743034109,
            2976151520,
            3211623147,
            2505202138,
            2606453969,
            2302690252,
            2269728455,
            3711829422,
            3543599269,
            3240894392,
            3475313331,
            3843699074,
            3943906441,
            4178062228,
            4144047775,
            1306967366,
            1139781709,
            1374988112,
            1610459739,
            1975683434,
            2076935265,
            1775276924,
            1742315127,
            1034867998,
            866637845,
            566021896,
            800440835,
            92987698,
            193195065,
            429456164,
            395441711,
            1984812685,
            2017778566,
            1784663195,
            1683407248,
            1315562145,
            1080094634,
            1383856311,
            1551037884,
            101039829,
            135050206,
            437757123,
            337553864,
            1042385657,
            807962610,
            573804783,
            742039012,
            2531067453,
            2564033334,
            2328828971,
            2227573024,
            2935566865,
            2700099354,
            3001755655,
            3168937228,
            3868552805,
            3902563182,
            4203181171,
            4102977912,
            3736164937,
            3501741890,
            3265478751,
            3433712980,
            1106041591,
            1340463100,
            1576976609,
            1408749034,
            2043211483,
            2009195472,
            1708848333,
            1809054150,
            832877231,
            1068351396,
            766945465,
            599762354,
            159417987,
            126454664,
            361929877,
            463180190,
            2709260871,
            2943682380,
            3178106961,
            3009879386,
            2572697195,
            2538681184,
            2236228733,
            2336434550,
            3509871135,
            3745345300,
            3441850377,
            3274667266,
            3910161971,
            3877198648,
            4110568485,
            4211818798,
            2597806476,
            2497604743,
            2261089178,
            2295101073,
            2733856160,
            2902087851,
            3202437046,
            2968011453,
            3936291284,
            3835036895,
            4136440770,
            4169408201,
            3535486456,
            3702665459,
            3467192302,
            3231722213,
            2051518780,
            1951317047,
            1716890410,
            1750902305,
            1113818384,
            1282050075,
            1584504582,
            1350078989,
            168810852,
            67556463,
            371049330,
            404016761,
            841739592,
            1008918595,
            775550814,
            540080725,
            3969562369,
            3801332234,
            4035489047,
            4269907996,
            3569255213,
            3669462566,
            3366754619,
            3332740144,
            2631065433,
            2463879762,
            2160117071,
            2395588676,
            2767645557,
            2868897406,
            3102011747,
            3069049960,
            202008497,
            33778362,
            270040487,
            504459436,
            875451293,
            975658646,
            675039627,
            641025152,
            2084704233,
            1917518562,
            1615861247,
            1851332852,
            1147550661,
            1248802510,
            1484005843,
            1451044056,
            933301370,
            967311729,
            733156972,
            632953703,
            260388950,
            25965917,
            328671808,
            496906059,
            1206477858,
            1239443753,
            1543208500,
            1441952575,
            2144161806,
            1908694277,
            1675577880,
            1842759443,
            3610369226,
            3644379585,
            3408119516,
            3307916247,
            4011190502,
            3776767469,
            4077384432,
            4245618683,
            2809771154,
            2842737049,
            3144396420,
            3043140495,
            2673705150,
            2438237621,
            2203032232,
            2370213795,
          ]);
          a.prototype = {
            decryptBlock: function(a, d) {
              var c,
                f = a.length,
                l = this.buffer,
                g = this.bufferPosition;
              for (c = 0; 16 > g && c < f; ++c, ++g) l[g] = a[c];
              if (16 > g) return (this.bufferLength = g), new Uint8Array([]);
              this.iv = l;
              this.buffer = new Uint8Array(16);
              this.bufferLength = 0;
              this.decryptBlock = b;
              return this.decryptBlock(a.subarray(16), d);
            },
            encrypt: function(a, b) {
              var d;
              var l = a.length;
              var g = this.buffer;
              var r = this.bufferPosition;
              var h = [];
              b || (b = new Uint8Array(16));
              for (d = 0; d < l; ++d)
                if (((g[r] = a[d]), ++r, !(16 > r))) {
                  for (r = 0; 16 > r; ++r) g[r] ^= b[r];
                  var p;
                  var n = g;
                  r = this.key;
                  g = new Uint8Array(16);
                  g.set(n);
                  for (p = 0; 16 > p; ++p) g[p] ^= r[p];
                  for (f = 1; 10 > f; f++) {
                    for (p = 0; 16 > p; ++p) g[p] = c[g[p]];
                    p = g[1];
                    g[1] = g[5];
                    g[5] = g[9];
                    g[9] = g[13];
                    g[13] = p;
                    p = g[2];
                    var q = g[6];
                    g[2] = g[10];
                    g[6] = g[14];
                    g[10] = p;
                    g[14] = q;
                    p = g[3];
                    q = g[7];
                    n = g[11];
                    g[3] = g[15];
                    g[7] = p;
                    g[11] = q;
                    g[15] = n;
                    for (p = 0; 16 > p; p += 4) {
                      q = g[p + 0];
                      var k = g[p + 1],
                        A = g[p + 2],
                        D = g[p + 3];
                      n = q ^ k ^ A ^ D;
                      g[p + 0] = g[p + 0] ^ n ^ e[q ^ k];
                      g[p + 1] = g[p + 1] ^ n ^ e[k ^ A];
                      g[p + 2] = g[p + 2] ^ n ^ e[A ^ D];
                      g[p + 3] = g[p + 3] ^ n ^ e[D ^ q];
                    }
                    p = 0;
                    for (n = 16 * f; 16 > p; ++p, ++n) g[p] ^= r[n];
                  }
                  for (p = 0; 16 > p; ++p) g[p] = c[g[p]];
                  p = g[1];
                  g[1] = g[5];
                  g[5] = g[9];
                  g[9] = g[13];
                  g[13] = p;
                  p = g[2];
                  q = g[6];
                  g[2] = g[10];
                  g[6] = g[14];
                  g[10] = p;
                  g[14] = q;
                  p = g[3];
                  q = g[7];
                  n = g[11];
                  g[3] = g[15];
                  g[7] = p;
                  g[11] = q;
                  g[15] = n;
                  p = 0;
                  for (n = 160; 16 > p; ++p, ++n) g[p] ^= r[n];
                  b = r = g;
                  h.push(r);
                  g = new Uint8Array(16);
                  r = 0;
                }
              this.buffer = g;
              this.bufferLength = r;
              this.iv = b;
              if (0 === h.length) return new Uint8Array([]);
              g = new Uint8Array(16 * h.length);
              r = d = 0;
              for (l = h.length; d < l; ++d, r += 16) g.set(h[d], r);
              return g;
            },
          };
          return a;
        })(),
        h = (function() {
          function a(a) {
            var b = new Uint8Array(240),
              c = 1;
            b.set(a);
            a = 32;
            for (var f = 1; 240 > a; ++f) {
              if (16 === a % 32) (l = d[l]), (g = d[g]), (e = d[e]), (r = d[r]);
              else if (0 === a % 32) {
                var l = b[a - 3],
                  g = b[a - 2],
                  e = b[a - 1],
                  r = b[a - 4];
                l = d[l];
                g = d[g];
                e = d[e];
                r = d[r];
                l ^= c;
                256 <= (c <<= 1) && (c = (c ^ 27) & 255);
              }
              for (var h = 0; 4 > h; ++h)
                (b[a] = l ^= b[a - 32]),
                  a++,
                  (b[a] = g ^= b[a - 32]),
                  a++,
                  (b[a] = e ^= b[a - 32]),
                  a++,
                  (b[a] = r ^= b[a - 32]),
                  a++;
            }
            this.key = b;
            this.buffer = new Uint8Array(16);
            this.bufferPosition = 0;
          }
          function b(a, b) {
            var d;
            var l = a.length;
            var g = this.buffer;
            var e = this.bufferPosition;
            var r = [],
              h = this.iv;
            for (d = 0; d < l; ++d)
              if (((g[e] = a[d]), ++e, !(16 > e))) {
                var p;
                var n = g;
                e = this.key;
                var q = new Uint8Array(16);
                q.set(n);
                var k = 0;
                for (p = 224; 16 > k; ++k, ++p) q[k] ^= e[p];
                for (n = 13; 1 <= n; --n) {
                  p = q[13];
                  q[13] = q[9];
                  q[9] = q[5];
                  q[5] = q[1];
                  q[1] = p;
                  p = q[14];
                  var A = q[10];
                  q[14] = q[6];
                  q[10] = q[2];
                  q[6] = p;
                  q[2] = A;
                  p = q[15];
                  A = q[11];
                  k = q[7];
                  q[15] = q[3];
                  q[11] = p;
                  q[7] = A;
                  q[3] = k;
                  for (k = 0; 16 > k; ++k) q[k] = c[q[k]];
                  k = 0;
                  for (p = 16 * n; 16 > k; ++k, ++p) q[k] ^= e[p];
                  for (k = 0; 16 > k; k += 4) {
                    p = f[q[k + 1]];
                    A = f[q[k + 2]];
                    var D = f[q[k + 3]];
                    p = f[q[k]] ^ (p >>> 8) ^ (p << 24) ^ (A >>> 16) ^ (A << 16) ^ (D >>> 24) ^ (D << 8);
                    q[k] = (p >>> 24) & 255;
                    q[k + 1] = (p >> 16) & 255;
                    q[k + 2] = (p >> 8) & 255;
                    q[k + 3] = p & 255;
                  }
                }
                p = q[13];
                q[13] = q[9];
                q[9] = q[5];
                q[5] = q[1];
                q[1] = p;
                p = q[14];
                A = q[10];
                q[14] = q[6];
                q[10] = q[2];
                q[6] = p;
                q[2] = A;
                p = q[15];
                A = q[11];
                k = q[7];
                q[15] = q[3];
                q[11] = p;
                q[7] = A;
                q[3] = k;
                for (k = 0; 16 > k; ++k) (q[k] = c[q[k]]), (q[k] ^= e[k]);
                for (e = 0; 16 > e; ++e) q[e] ^= h[e];
                h = g;
                r.push(q);
                g = new Uint8Array(16);
                e = 0;
              }
            this.buffer = g;
            this.bufferLength = e;
            this.iv = h;
            if (0 === r.length) return new Uint8Array([]);
            g = 16 * r.length;
            if (b && ((h = r[r.length - 1]), (e = h[15]), 16 >= e)) {
              d = 15;
              for (l = 16 - e; d >= l; --d)
                if (h[d] !== e) {
                  e = 0;
                  break;
                }
              g -= e;
              r[r.length - 1] = h.subarray(0, 16 - e);
            }
            g = new Uint8Array(g);
            e = d = 0;
            for (l = r.length; d < l; ++d, e += 16) g.set(r[d], e);
            return g;
          }
          for (
            var d = new Uint8Array([
                99,
                124,
                119,
                123,
                242,
                107,
                111,
                197,
                48,
                1,
                103,
                43,
                254,
                215,
                171,
                118,
                202,
                130,
                201,
                125,
                250,
                89,
                71,
                240,
                173,
                212,
                162,
                175,
                156,
                164,
                114,
                192,
                183,
                253,
                147,
                38,
                54,
                63,
                247,
                204,
                52,
                165,
                229,
                241,
                113,
                216,
                49,
                21,
                4,
                199,
                35,
                195,
                24,
                150,
                5,
                154,
                7,
                18,
                128,
                226,
                235,
                39,
                178,
                117,
                9,
                131,
                44,
                26,
                27,
                110,
                90,
                160,
                82,
                59,
                214,
                179,
                41,
                227,
                47,
                132,
                83,
                209,
                0,
                237,
                32,
                252,
                177,
                91,
                106,
                203,
                190,
                57,
                74,
                76,
                88,
                207,
                208,
                239,
                170,
                251,
                67,
                77,
                51,
                133,
                69,
                249,
                2,
                127,
                80,
                60,
                159,
                168,
                81,
                163,
                64,
                143,
                146,
                157,
                56,
                245,
                188,
                182,
                218,
                33,
                16,
                255,
                243,
                210,
                205,
                12,
                19,
                236,
                95,
                151,
                68,
                23,
                196,
                167,
                126,
                61,
                100,
                93,
                25,
                115,
                96,
                129,
                79,
                220,
                34,
                42,
                144,
                136,
                70,
                238,
                184,
                20,
                222,
                94,
                11,
                219,
                224,
                50,
                58,
                10,
                73,
                6,
                36,
                92,
                194,
                211,
                172,
                98,
                145,
                149,
                228,
                121,
                231,
                200,
                55,
                109,
                141,
                213,
                78,
                169,
                108,
                86,
                244,
                234,
                101,
                122,
                174,
                8,
                186,
                120,
                37,
                46,
                28,
                166,
                180,
                198,
                232,
                221,
                116,
                31,
                75,
                189,
                139,
                138,
                112,
                62,
                181,
                102,
                72,
                3,
                246,
                14,
                97,
                53,
                87,
                185,
                134,
                193,
                29,
                158,
                225,
                248,
                152,
                17,
                105,
                217,
                142,
                148,
                155,
                30,
                135,
                233,
                206,
                85,
                40,
                223,
                140,
                161,
                137,
                13,
                191,
                230,
                66,
                104,
                65,
                153,
                45,
                15,
                176,
                84,
                187,
                22,
              ]),
              c = new Uint8Array([
                82,
                9,
                106,
                213,
                48,
                54,
                165,
                56,
                191,
                64,
                163,
                158,
                129,
                243,
                215,
                251,
                124,
                227,
                57,
                130,
                155,
                47,
                255,
                135,
                52,
                142,
                67,
                68,
                196,
                222,
                233,
                203,
                84,
                123,
                148,
                50,
                166,
                194,
                35,
                61,
                238,
                76,
                149,
                11,
                66,
                250,
                195,
                78,
                8,
                46,
                161,
                102,
                40,
                217,
                36,
                178,
                118,
                91,
                162,
                73,
                109,
                139,
                209,
                37,
                114,
                248,
                246,
                100,
                134,
                104,
                152,
                22,
                212,
                164,
                92,
                204,
                93,
                101,
                182,
                146,
                108,
                112,
                72,
                80,
                253,
                237,
                185,
                218,
                94,
                21,
                70,
                87,
                167,
                141,
                157,
                132,
                144,
                216,
                171,
                0,
                140,
                188,
                211,
                10,
                247,
                228,
                88,
                5,
                184,
                179,
                69,
                6,
                208,
                44,
                30,
                143,
                202,
                63,
                15,
                2,
                193,
                175,
                189,
                3,
                1,
                19,
                138,
                107,
                58,
                145,
                17,
                65,
                79,
                103,
                220,
                234,
                151,
                242,
                207,
                206,
                240,
                180,
                230,
                115,
                150,
                172,
                116,
                34,
                231,
                173,
                53,
                133,
                226,
                249,
                55,
                232,
                28,
                117,
                223,
                110,
                71,
                241,
                26,
                113,
                29,
                41,
                197,
                137,
                111,
                183,
                98,
                14,
                170,
                24,
                190,
                27,
                252,
                86,
                62,
                75,
                198,
                210,
                121,
                32,
                154,
                219,
                192,
                254,
                120,
                205,
                90,
                244,
                31,
                221,
                168,
                51,
                136,
                7,
                199,
                49,
                177,
                18,
                16,
                89,
                39,
                128,
                236,
                95,
                96,
                81,
                127,
                169,
                25,
                181,
                74,
                13,
                45,
                229,
                122,
                159,
                147,
                201,
                156,
                239,
                160,
                224,
                59,
                77,
                174,
                42,
                245,
                176,
                200,
                235,
                187,
                60,
                131,
                83,
                153,
                97,
                23,
                43,
                4,
                126,
                186,
                119,
                214,
                38,
                225,
                105,
                20,
                99,
                85,
                33,
                12,
                125,
              ]),
              l = new Uint8Array(256),
              e = 0;
            256 > e;
            e++
          )
            l[e] = 128 > e ? e << 1 : (e << 1) ^ 27;
          var f = new Uint32Array([
            0,
            235474187,
            470948374,
            303765277,
            941896748,
            908933415,
            607530554,
            708780849,
            1883793496,
            2118214995,
            1817866830,
            1649639237,
            1215061108,
            1181045119,
            1417561698,
            1517767529,
            3767586992,
            4003061179,
            4236429990,
            4069246893,
            3635733660,
            3602770327,
            3299278474,
            3400528769,
            2430122216,
            2664543715,
            2362090238,
            2193862645,
            2835123396,
            2801107407,
            3035535058,
            3135740889,
            3678124923,
            3576870512,
            3341394285,
            3374361702,
            3810496343,
            3977675356,
            4279080257,
            4043610186,
            2876494627,
            2776292904,
            3076639029,
            3110650942,
            2472011535,
            2640243204,
            2403728665,
            2169303058,
            1001089995,
            899835584,
            666464733,
            699432150,
            59727847,
            226906860,
            530400753,
            294930682,
            1273168787,
            1172967064,
            1475418501,
            1509430414,
            1942435775,
            2110667444,
            1876241833,
            1641816226,
            2910219766,
            2743034109,
            2976151520,
            3211623147,
            2505202138,
            2606453969,
            2302690252,
            2269728455,
            3711829422,
            3543599269,
            3240894392,
            3475313331,
            3843699074,
            3943906441,
            4178062228,
            4144047775,
            1306967366,
            1139781709,
            1374988112,
            1610459739,
            1975683434,
            2076935265,
            1775276924,
            1742315127,
            1034867998,
            866637845,
            566021896,
            800440835,
            92987698,
            193195065,
            429456164,
            395441711,
            1984812685,
            2017778566,
            1784663195,
            1683407248,
            1315562145,
            1080094634,
            1383856311,
            1551037884,
            101039829,
            135050206,
            437757123,
            337553864,
            1042385657,
            807962610,
            573804783,
            742039012,
            2531067453,
            2564033334,
            2328828971,
            2227573024,
            2935566865,
            2700099354,
            3001755655,
            3168937228,
            3868552805,
            3902563182,
            4203181171,
            4102977912,
            3736164937,
            3501741890,
            3265478751,
            3433712980,
            1106041591,
            1340463100,
            1576976609,
            1408749034,
            2043211483,
            2009195472,
            1708848333,
            1809054150,
            832877231,
            1068351396,
            766945465,
            599762354,
            159417987,
            126454664,
            361929877,
            463180190,
            2709260871,
            2943682380,
            3178106961,
            3009879386,
            2572697195,
            2538681184,
            2236228733,
            2336434550,
            3509871135,
            3745345300,
            3441850377,
            3274667266,
            3910161971,
            3877198648,
            4110568485,
            4211818798,
            2597806476,
            2497604743,
            2261089178,
            2295101073,
            2733856160,
            2902087851,
            3202437046,
            2968011453,
            3936291284,
            3835036895,
            4136440770,
            4169408201,
            3535486456,
            3702665459,
            3467192302,
            3231722213,
            2051518780,
            1951317047,
            1716890410,
            1750902305,
            1113818384,
            1282050075,
            1584504582,
            1350078989,
            168810852,
            67556463,
            371049330,
            404016761,
            841739592,
            1008918595,
            775550814,
            540080725,
            3969562369,
            3801332234,
            4035489047,
            4269907996,
            3569255213,
            3669462566,
            3366754619,
            3332740144,
            2631065433,
            2463879762,
            2160117071,
            2395588676,
            2767645557,
            2868897406,
            3102011747,
            3069049960,
            202008497,
            33778362,
            270040487,
            504459436,
            875451293,
            975658646,
            675039627,
            641025152,
            2084704233,
            1917518562,
            1615861247,
            1851332852,
            1147550661,
            1248802510,
            1484005843,
            1451044056,
            933301370,
            967311729,
            733156972,
            632953703,
            260388950,
            25965917,
            328671808,
            496906059,
            1206477858,
            1239443753,
            1543208500,
            1441952575,
            2144161806,
            1908694277,
            1675577880,
            1842759443,
            3610369226,
            3644379585,
            3408119516,
            3307916247,
            4011190502,
            3776767469,
            4077384432,
            4245618683,
            2809771154,
            2842737049,
            3144396420,
            3043140495,
            2673705150,
            2438237621,
            2203032232,
            2370213795,
          ]);
          a.prototype = {
            decryptBlock: function(a, d, c) {
              var f = a.length,
                l = this.buffer,
                g = this.bufferPosition;
              if (c) this.iv = c;
              else {
                for (c = 0; 16 > g && c < f; ++c, ++g) l[g] = a[c];
                if (16 > g) return (this.bufferLength = g), new Uint8Array([]);
                this.iv = l;
                a = a.subarray(16);
              }
              this.buffer = new Uint8Array(16);
              this.bufferLength = 0;
              this.decryptBlock = b;
              return this.decryptBlock(a, d);
            },
            encrypt: function(a, b) {
              var c;
              var f = a.length;
              var g = this.buffer;
              var r = this.bufferPosition;
              var h = [];
              b || (b = new Uint8Array(16));
              for (c = 0; c < f; ++c)
                if (((g[r] = a[c]), ++r, !(16 > r))) {
                  for (r = 0; 16 > r; ++r) g[r] ^= b[r];
                  var p;
                  var q = g;
                  r = this.key;
                  g = new Uint8Array(16);
                  g.set(q);
                  for (p = 0; 16 > p; ++p) g[p] ^= r[p];
                  for (e = 1; 14 > e; e++) {
                    for (p = 0; 16 > p; ++p) g[p] = d[g[p]];
                    p = g[1];
                    g[1] = g[5];
                    g[5] = g[9];
                    g[9] = g[13];
                    g[13] = p;
                    p = g[2];
                    var n = g[6];
                    g[2] = g[10];
                    g[6] = g[14];
                    g[10] = p;
                    g[14] = n;
                    p = g[3];
                    n = g[7];
                    q = g[11];
                    g[3] = g[15];
                    g[7] = p;
                    g[11] = n;
                    g[15] = q;
                    for (p = 0; 16 > p; p += 4) {
                      n = g[p + 0];
                      var k = g[p + 1],
                        A = g[p + 2],
                        D = g[p + 3];
                      q = n ^ k ^ A ^ D;
                      g[p + 0] = g[p + 0] ^ q ^ l[n ^ k];
                      g[p + 1] = g[p + 1] ^ q ^ l[k ^ A];
                      g[p + 2] = g[p + 2] ^ q ^ l[A ^ D];
                      g[p + 3] = g[p + 3] ^ q ^ l[D ^ n];
                    }
                    p = 0;
                    for (q = 16 * e; 16 > p; ++p, ++q) g[p] ^= r[q];
                  }
                  for (p = 0; 16 > p; ++p) g[p] = d[g[p]];
                  p = g[1];
                  g[1] = g[5];
                  g[5] = g[9];
                  g[9] = g[13];
                  g[13] = p;
                  p = g[2];
                  n = g[6];
                  g[2] = g[10];
                  g[6] = g[14];
                  g[10] = p;
                  g[14] = n;
                  p = g[3];
                  n = g[7];
                  q = g[11];
                  g[3] = g[15];
                  g[7] = p;
                  g[11] = n;
                  g[15] = q;
                  p = 0;
                  for (q = 224; 16 > p; ++p, ++q) g[p] ^= r[q];
                  this.iv = r = g;
                  h.push(r);
                  g = new Uint8Array(16);
                  r = 0;
                }
              this.buffer = g;
              this.bufferLength = r;
              this.iv = b;
              if (0 === h.length) return new Uint8Array([]);
              g = new Uint8Array(16 * h.length);
              r = c = 0;
              for (f = h.length; c < f; ++c, r += 16) g.set(h[c], r);
              return g;
            },
          };
          return a;
        })(),
        p = (function() {
          function a(a, b) {
            if (a.length !== b.length) return !1;
            for (var d = 0; d < a.length; d++) if (a[d] !== b[d]) return !1;
            return !0;
          }
          function b() {}
          b.prototype = {
            checkOwnerPassword: function(b, d, c, e) {
              var f = new Uint8Array(b.length + 56);
              f.set(b, 0);
              f.set(d, b.length);
              f.set(c, b.length + d.length);
              b = z(f, 0, f.length);
              return a(b, e);
            },
            checkUserPassword: function(b, d, c) {
              var g = new Uint8Array(b.length + 8);
              g.set(b, 0);
              g.set(d, b.length);
              b = z(g, 0, g.length);
              return a(b, c);
            },
            getOwnerKey: function(a, b, d, c) {
              var f = new Uint8Array(a.length + 56);
              f.set(a, 0);
              f.set(b, a.length);
              f.set(d, a.length + b.length);
              a = z(f, 0, f.length);
              return new h(a).decryptBlock(c, !1, new Uint8Array(16));
            },
            getUserKey: function(a, b, d) {
              var c = new Uint8Array(a.length + 8);
              c.set(a, 0);
              c.set(b, a.length);
              a = z(c, 0, c.length);
              return new h(a).decryptBlock(d, !1, new Uint8Array(16));
            },
          };
          return b;
        })(),
        A = (function() {
          function a(a, b) {
            var d = new Uint8Array(a.length + b.length);
            d.set(a, 0);
            d.set(b, a.length);
            return d;
          }
          function b(b, d, c) {
            d = z(d, 0, d.length).subarray(0, 32);
            for (var f = [0], g = 0; 64 > g || f[f.length - 1] > g - 32; ) {
              f = b.length + d.length + c.length;
              var l = new Uint8Array(64 * f),
                p = a(b, d);
              p = a(p, c);
              for (var h = 0, q = 0; 64 > h; h++, q += f) l.set(p, q);
              f = new e(d.subarray(0, 16)).encrypt(l, d.subarray(16, 32));
              for (p = l = 0; 16 > p; p++) (l *= 1), (l %= 3), (l += (f[p] >>> 0) % 3), (l %= 3);
              0 === l
                ? (d = z(f, 0, f.length))
                : 1 === l
                ? (d = B(f, 0, f.length))
                : 2 === l && (d = C(f, 0, f.length));
              g++;
            }
            return d.subarray(0, 32);
          }
          function d() {}
          function c(a, b) {
            if (a.length !== b.length) return !1;
            for (var d = 0; d < a.length; d++) if (a[d] !== b[d]) return !1;
            return !0;
          }
          d.prototype = {
            hash: function(a, d, c) {
              return b(a, d, c);
            },
            checkOwnerPassword: function(a, d, f, g) {
              var l = new Uint8Array(a.length + 56);
              l.set(a, 0);
              l.set(d, a.length);
              l.set(f, a.length + d.length);
              a = b(a, l, f);
              return c(a, g);
            },
            checkUserPassword: function(a, d, f) {
              var g = new Uint8Array(a.length + 8);
              g.set(a, 0);
              g.set(d, a.length);
              a = b(a, g, []);
              return c(a, f);
            },
            getOwnerKey: function(a, d, c, g) {
              var f = new Uint8Array(a.length + 56);
              f.set(a, 0);
              f.set(d, a.length);
              f.set(c, a.length + d.length);
              a = b(a, f, c);
              return new h(a).decryptBlock(g, !1, new Uint8Array(16));
            },
            getUserKey: function(a, d, c) {
              var f = new Uint8Array(a.length + 8);
              f.set(a, 0);
              f.set(d, a.length);
              a = b(a, f, []);
              return new h(a).decryptBlock(c, !1, new Uint8Array(16));
            },
          };
          return d;
        })(),
        c = (function() {
          function d(a, b) {
            this.StringCipherConstructor = a;
            this.StreamCipherConstructor = b;
          }
          d.prototype = {
            createStream: function(a, d) {
              var c = new this.StreamCipherConstructor();
              return new b.DecryptStream(a, d, function(a, b) {
                return c.decryptBlock(a, b);
              });
            },
            decryptString: function(b) {
              var d = new this.StringCipherConstructor();
              b = (0, a.stringToBytes)(b);
              b = d.decryptBlock(b, !0);
              return (0, a.bytesToString)(b);
            },
          };
          return d;
        })();
      y = (function() {
        function b(a, b, c, g, e, p, h, n) {
          var f = new Uint8Array(40 + c.length + a.length),
            r = 0,
            q;
          if (b) for (q = Math.min(32, b.length); r < q; ++r) f[r] = b[r];
          for (b = 0; 32 > r; ) f[r++] = l[b++];
          b = 0;
          for (q = c.length; b < q; ++b) f[r++] = c[b];
          f[r++] = e & 255;
          f[r++] = (e >> 8) & 255;
          f[r++] = (e >> 16) & 255;
          f[r++] = (e >>> 24) & 255;
          b = 0;
          for (q = a.length; b < q; ++b) f[r++] = a[b];
          4 <= p && !n && ((f[r++] = 255), (f[r++] = 255), (f[r++] = 255), (f[r++] = 255));
          q = d(f, 0, r);
          r = h >> 3;
          if (3 <= p) for (b = 0; 50 > b; ++b) q = d(q, 0, r);
          h = q.subarray(0, r);
          if (3 <= p) {
            for (r = 0; 32 > r; ++r) f[r] = l[r];
            b = 0;
            for (q = a.length; b < q; ++b) f[r++] = a[b];
            a = new v(h);
            f = a.encryptBlock(d(f, 0, r));
            q = h.length;
            p = new Uint8Array(q);
            for (b = 1; 19 >= b; ++b) {
              for (a = 0; a < q; ++a) p[a] = h[a] ^ b;
              a = new v(p);
              f = a.encryptBlock(f);
            }
          } else (a = new v(h)), (f = a.encryptBlock(l));
          b = 0;
          for (q = f.length; b < q; ++b) if (g[b] !== f[b]) return null;
          return h;
        }
        function x(c, g, e) {
          var f = c.get('Filter');
          if (!(0, k.isName)(f, 'Standard')) throw new a.FormatError('unknown encryption method');
          this.dict = c;
          f = c.get('V');
          if (!Number.isInteger(f) || (1 !== f && 2 !== f && 4 !== f && 5 !== f))
            throw new a.FormatError('unsupported encryption algorithm');
          this.algorithm = f;
          var r = c.get('Length');
          if (!r)
            if (3 >= f) r = 40;
            else {
              var h = c.get('CF'),
                q = c.get('StmF');
              (0, k.isDict)(h) &&
                (0, k.isName)(q) &&
                ((h.suppressEncryption = !0),
                (r = ((r = h.get(q.name)) && r.get('Length')) || 128),
                40 > r && (r <<= 3));
            }
          if (!Number.isInteger(r) || 40 > r || 0 !== r % 8) throw new a.FormatError('invalid key length');
          h = (0, a.stringToBytes)(c.get('O')).subarray(0, 32);
          q = (0, a.stringToBytes)(c.get('U')).subarray(0, 32);
          var n = c.get('P'),
            D = c.get('R'),
            x = (4 === f || 5 === f) && !1 !== c.get('EncryptMetadata');
          this.encryptMetadata = x;
          g = (0, a.stringToBytes)(g);
          if (e) {
            if (6 === D)
              try {
                e = (0, a.utf8StringToString)(e);
              } catch (ca) {
                (0, a.warn)('CipherTransformFactory: Unable to convert UTF8 encoded password.');
              }
            var m = (0, a.stringToBytes)(e);
          }
          if (5 !== f) var B = b(g, m, h, q, n, D, r, x);
          else {
            B = (0, a.stringToBytes)(c.get('O')).subarray(32, 40);
            var N = (0, a.stringToBytes)(c.get('O')).subarray(40, 48),
              G = (0, a.stringToBytes)(c.get('U')).subarray(0, 48),
              J = (0, a.stringToBytes)(c.get('U')).subarray(32, 40),
              Z = (0, a.stringToBytes)(c.get('U')).subarray(40, 48),
              z = (0, a.stringToBytes)(c.get('OE')),
              t = (0, a.stringToBytes)(c.get('UE'));
            (0, a.stringToBytes)(c.get('Perms'));
            var C = m;
            C = C ? C.subarray(0, Math.min(127, C.length)) : [];
            var ba = 6 === D ? new A() : new p();
            B = ba.checkUserPassword(C, J, q)
              ? ba.getUserKey(C, Z, t)
              : C.length && ba.checkOwnerPassword(C, B, G, h)
              ? ba.getOwnerKey(C, N, G, z)
              : null;
          }
          if (!B && !e) throw new a.PasswordException('No password given', a.PasswordResponses.NEED_PASSWORD);
          if (!B && e) {
            e = m;
            B = r;
            m = new Uint8Array(32);
            N = 0;
            for (G = Math.min(32, e.length); N < G; ++N) m[N] = e[N];
            for (e = 0; 32 > N; ) m[N++] = l[e++];
            m = d(m, 0, N);
            B >>= 3;
            if (3 <= D) for (e = 0; 50 > e; ++e) m = d(m, 0, m.length);
            if (3 <= D)
              for (N = h, G = new Uint8Array(B), e = 19; 0 <= e; e--) {
                for (J = 0; J < B; ++J) G[J] = m[J] ^ e;
                J = new v(G);
                N = J.encryptBlock(N);
              }
            else (J = new v(m.subarray(0, B))), (N = J.encryptBlock(h));
            B = b(g, N, h, q, n, D, r, x);
          }
          if (!B) throw new a.PasswordException('Incorrect Password', a.PasswordResponses.INCORRECT_PASSWORD);
          this.encryptionKey = B;
          4 <= f &&
            ((f = c.get('CF')),
            (0, k.isDict)(f) && (f.suppressEncryption = !0),
            (this.cf = f),
            (this.stmf = c.get('StmF') || u),
            (this.strf = c.get('StrF') || u),
            (this.eff = c.get('EFF') || this.stmf));
        }
        function g(a, b, c, g) {
          var f = new Uint8Array(c.length + 9),
            l;
          var e = 0;
          for (l = c.length; e < l; ++e) f[e] = c[e];
          f[e++] = a & 255;
          f[e++] = (a >> 8) & 255;
          f[e++] = (a >> 16) & 255;
          f[e++] = b & 255;
          f[e++] = (b >> 8) & 255;
          g && ((f[e++] = 115), (f[e++] = 65), (f[e++] = 108), (f[e++] = 84));
          return d(f, 0, e).subarray(0, Math.min(c.length + 5, 16));
        }
        function m(b, d, c, l, p) {
          if (!(0, k.isName)(d)) throw new a.FormatError('Invalid crypt filter name.');
          b = b.get(d.name);
          var f;
          null !== b && void 0 !== b && (f = b.get('CFM'));
          if (!f || 'None' === f.name)
            return function() {
              return new n();
            };
          if ('V2' === f.name)
            return function() {
              return new v(g(c, l, p, !1));
            };
          if ('AESV2' === f.name)
            return function() {
              return new e(g(c, l, p, !0));
            };
          if ('AESV3' === f.name)
            return function() {
              return new h(p);
            };
          throw new a.FormatError('Unknown crypto method');
        }
        var l = new Uint8Array([
            40,
            191,
            78,
            94,
            78,
            117,
            138,
            65,
            100,
            0,
            78,
            86,
            255,
            250,
            1,
            8,
            46,
            46,
            0,
            182,
            208,
            104,
            62,
            128,
            47,
            12,
            169,
            254,
            100,
            83,
            105,
            122,
          ]),
          u = k.Name.get('Identity');
        x.prototype = {
          createCipherTransform: function(a, b) {
            if (4 === this.algorithm || 5 === this.algorithm)
              return new c(
                m(this.cf, this.stmf, a, b, this.encryptionKey),
                m(this.cf, this.strf, a, b, this.encryptionKey),
              );
            var d = g(a, b, this.encryptionKey, !1),
              f = function() {
                return new v(d);
              };
            return new c(f, f);
          },
        };
        return x;
      })();
      m.AES128Cipher = e;
      m.AES256Cipher = h;
      m.ARCFourCipher = v;
      m.CipherTransformFactory = y;
      m.PDF17 = p;
      m.PDF20 = A;
      m.calculateMD5 = d;
      m.calculateSHA256 = z;
      m.calculateSHA384 = B;
      m.calculateSHA512 = C;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.PartialEvaluator = m.OperatorList = void 0;
      var a =
          'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
            ? function(a) {
                return typeof a;
              }
            : function(a) {
                return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                  ? 'symbol'
                  : typeof a;
              },
        k = t(0),
        b = t(109),
        v = t(3),
        d = t(1),
        u = t(110),
        z = t(18),
        C = t(66),
        B = t(65),
        n = t(114),
        e = t(26),
        h = t(25),
        p = t(115),
        A = t(17),
        c = t(35),
        q = t(116),
        x = t(117),
        g = t(118);
      y = (function() {
        function h(a, b, d, c) {
          this.xref = a;
          this.resources = b;
          this.handler = d;
          this.forceDataSchema = c;
        }
        function w(a) {
          var b = this,
            d = a.xref,
            c = a.handler,
            f = a.pageIndex,
            g = a.idFactory,
            l = a.fontCache,
            e = a.builtInCMapCache,
            p = a.options;
          this.pdfManager = a.pdfManager;
          this.xref = d;
          this.handler = c;
          this.pageIndex = f;
          this.idFactory = g;
          this.fontCache = l;
          this.builtInCMapCache = e;
          this.options = (void 0 === p ? null : p) || m;
          this.fetchBuiltInCMap = function(a) {
            var d = b.builtInCMapCache[a];
            return d
              ? Promise.resolve(d)
              : b.handler.sendWithPromise('FetchBuiltInCMap', { name: a }).then(function(d) {
                  d.compressionType !== k.CMapCompressionType.NONE && (b.builtInCMapCache[a] = d);
                  return d;
                });
          };
        }
        function E() {
          this.reset();
        }
        function F(a) {
          if (!(0, d.isName)(a)) return 'source-over';
          switch (a.name) {
            case 'Normal':
            case 'Compatible':
              return 'source-over';
            case 'Multiply':
              return 'multiply';
            case 'Screen':
              return 'screen';
            case 'Overlay':
              return 'overlay';
            case 'Darken':
              return 'darken';
            case 'Lighten':
              return 'lighten';
            case 'ColorDodge':
              return 'color-dodge';
            case 'ColorBurn':
              return 'color-burn';
            case 'HardLight':
              return 'hard-light';
            case 'SoftLight':
              return 'soft-light';
            case 'Difference':
              return 'difference';
            case 'Exclusion':
              return 'exclusion';
            case 'Hue':
              return 'hue';
            case 'Saturation':
              return 'saturation';
            case 'Color':
              return 'color';
            case 'Luminosity':
              return 'luminosity';
          }
          (0, k.warn)('Unsupported blend mode: ' + a.name);
          return 'source-over';
        }
        var m = {
          forceDataSchema: !1,
          maxImageSize: -1,
          disableFontFace: !1,
          nativeImageDecoderSupport: k.NativeImageDecoding.DECODE,
          ignoreErrors: !1,
          isEvalSupported: !0,
        };
        h.prototype = {
          canDecode: function(a) {
            return a instanceof v.JpegStream && h.isDecodable(a, this.xref, this.resources);
          },
          decode: function(a) {
            var b = a.dict.get('ColorSpace', 'CS');
            b = A.ColorSpace.parse(b, this.xref, this.resources);
            b = b.numComps;
            return this.handler.sendWithPromise('JpegDecode', [a.getIR(this.forceDataSchema), b]).then(function(b) {
              b = b.data;
              return new v.Stream(b, 0, b.length, a.dict);
            });
          },
        };
        h.isSupported = function(a, b, d) {
          a = a.dict;
          if (a.has('DecodeParms') || a.has('DP')) return !1;
          b = A.ColorSpace.parse(a.get('ColorSpace', 'CS'), b, d);
          return ('DeviceGray' === b.name || 'DeviceRGB' === b.name) && b.isDefaultDecode(a.getArray('Decode', 'D'));
        };
        h.isDecodable = function(a, b, d) {
          a = a.dict;
          if (a.has('DecodeParms') || a.has('DP')) return !1;
          b = A.ColorSpace.parse(a.get('ColorSpace', 'CS'), b, d);
          return (1 === b.numComps || 3 === b.numComps) && b.isDefaultDecode(a.getArray('Decode', 'D'));
        };
        E.prototype = {
          check: function() {
            if (100 > ++this.checked) return !1;
            this.checked = 0;
            return this.endTime <= Date.now();
          },
          reset: function() {
            this.endTime = Date.now() + 20;
            this.checked = 0;
          },
        };
        var H = Promise.resolve();
        w.prototype = {
          clone: function() {
            var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : m,
              b = Object.create(this);
            b.options = a;
            return b;
          },
          hasBlendModes: function(a) {
            if (!(0, d.isDict)(a)) return !1;
            var b = Object.create(null);
            a.objId && (b[a.objId] = !0);
            a = [a];
            for (var c = this.xref; a.length; ) {
              var f,
                g = a.shift(),
                l = g.get('ExtGState');
              if ((0, d.isDict)(l)) {
                var e = l.getKeys();
                var p = 0;
                for (f = e.length; p < f; p++) {
                  var r = e[p];
                  r = l.get(r).get('BM');
                  if ((0, d.isName)(r) && 'Normal' !== r.name) return !0;
                }
              }
              g = g.get('XObject');
              if ((0, d.isDict)(g))
                for (l = g.getKeys(), p = 0, f = l.length; p < f; p++) {
                  r = l[p];
                  r = g.getRaw(r);
                  if ((0, d.isRef)(r)) {
                    if (b[r.toString()]) continue;
                    r = c.fetch(r);
                  }
                  if ((0, d.isStream)(r)) {
                    if (r.dict.objId) {
                      if (b[r.dict.objId]) continue;
                      b[r.dict.objId] = !0;
                    }
                    r = r.dict.get('Resources');
                    !(0, d.isDict)(r) || (r.objId && b[r.objId]) || (a.push(r), r.objId && (b[r.objId] = !0));
                  }
                }
            }
            return !1;
          },
          buildFormXObject: function(a, b, c, f, g, l) {
            var e = b.dict,
              p = e.getArray('Matrix'),
              r = e.getArray('BBox'),
              h = e.get('Group');
            if (h) {
              var q = { matrix: p, bbox: r, smask: c, isolated: !1, knockout: !1 },
                n = h.get('S');
              if ((0, d.isName)(n, 'Transparency')) {
                q.isolated = h.get('I') || !1;
                q.knockout = h.get('K') || !1;
                var w = h.has('CS') ? A.ColorSpace.parse(h.get('CS'), this.xref, a) : null;
              }
              c && c.backdrop && ((w = w || A.ColorSpace.singletons.rgb), (c.backdrop = w.getRgb(c.backdrop, 0)));
              f.addOp(k.OPS.beginGroup, [q]);
            }
            f.addOp(k.OPS.paintFormXObjectBegin, [p, r]);
            return this.getOperatorList({
              stream: b,
              task: g,
              resources: e.get('Resources') || a,
              operatorList: f,
              initialState: l,
            }).then(function() {
              f.addOp(k.OPS.paintFormXObjectEnd, []);
              h && f.addOp(k.OPS.endGroup, [q]);
            });
          },
          buildPaintImageXObject: function(a, b, d, c, f, l) {
            var e = this,
              p = b.dict,
              r = p.get('Width', 'W'),
              q = p.get('Height', 'H');
            if (r && (0, k.isNum)(r) && q && (0, k.isNum)(q)) {
              var n = this.options.maxImageSize;
              if (-1 !== n && r * q > n) (0, k.warn)('Image exceeded maximum allowed size and was removed.');
              else if (p.get('ImageMask', 'IM'))
                (a = p.get('Width', 'W')),
                  (d = p.get('Height', 'H')),
                  (n = b.getBytes(((a + 7) >> 3) * d)),
                  (p = p.getArray('Decode', 'D')),
                  (b = g.PDFImage.createMask(n, a, d, b instanceof v.DecodeStream, !!p && 0 < p[0])),
                  (b.cached = !0),
                  (r = [b]),
                  c.addOp(k.OPS.paintImageMaskXObject, r),
                  f && (l[f] = { fn: k.OPS.paintImageMaskXObject, args: r });
              else if (
                ((n = p.get('SMask', 'SM') || !1),
                (p = p.get('Mask') || !1),
                !(!d || n || p || b instanceof v.JpegStream) && 200 > r + q)
              )
                (b = new g.PDFImage(this.xref, a, b, d, null, null).createImageData(!0)),
                  c.addOp(k.OPS.paintInlineImageXObject, [b]);
              else {
                var w = this.options.nativeImageDecoderSupport,
                  A = 'img_' + this.idFactory.createObjId();
                c.addDependency(A);
                r = [A, r, q];
                w !== k.NativeImageDecoding.NONE &&
                !n &&
                !p &&
                b instanceof v.JpegStream &&
                h.isSupported(b, this.xref, a)
                  ? (c.addOp(k.OPS.paintJpegXObject, r),
                    this.handler.send('obj', [A, this.pageIndex, 'JpegStream', b.getIR(this.options.forceDataSchema)]),
                    f && (l[f] = { fn: k.OPS.paintJpegXObject, args: r }))
                  : ((q = null),
                    w === k.NativeImageDecoding.DECODE &&
                      (b instanceof v.JpegStream || p instanceof v.JpegStream || n instanceof v.JpegStream) &&
                      (q = new h(this.xref, a, this.handler, this.options.forceDataSchema)),
                    g.PDFImage.buildImage(this.handler, this.xref, a, b, d, q)
                      .then(function(a) {
                        a = a.createImageData(!1);
                        e.handler.send('obj', [A, e.pageIndex, 'Image', a], [a.data.buffer]);
                      })
                      ['catch'](function(a) {
                        (0, k.warn)('Unable to decode image: ' + a);
                        e.handler.send('obj', [A, e.pageIndex, 'Image', null]);
                      }),
                    c.addOp(k.OPS.paintImageXObject, r),
                    f && (l[f] = { fn: k.OPS.paintImageXObject, args: r }));
              }
            } else (0, k.warn)('Image dimensions are missing, or not numbers.');
          },
          handleSMask: function(a, b, d, c, f) {
            var g = a.get('G'),
              l = { subtype: a.get('S').name, backdrop: a.get('BC') };
            a = a.get('TR');
            if ((0, e.isPDFFunction)(a)) {
              a = e.PDFFunction.parse(this.xref, a);
              for (var p = new Uint8Array(256), r = new Float32Array(1), h = 0; 256 > h; h++)
                (r[0] = h / 255), a(r, 0, r, 0), (p[h] = (255 * r[0]) | 0);
              l.transferMap = p;
            }
            return this.buildFormXObject(b, g, l, d, c, f.state.clone());
          },
          handleTilingType: function(a, b, c, f, g, e, p) {
            var r = this,
              h = new l();
            c = [g.get('Resources'), c];
            c = d.Dict.merge(this.xref, c);
            return this.getOperatorList({ stream: f, task: p, resources: c, operatorList: h })
              .then(function() {
                return (0, n.getTilingPatternIR)({ fnArray: h.fnArray, argsArray: h.argsArray }, g, b);
              })
              .then(
                function(b) {
                  e.addDependencies(h.dependencies);
                  e.addOp(a, b);
                },
                function(a) {
                  if (r.options.ignoreErrors)
                    r.handler.send('UnsupportedFeature', { featureId: k.UNSUPPORTED_FEATURES.unknown }),
                      (0, k.warn)('handleTilingType - ignoring pattern: "' + a + '".');
                  else throw a;
                },
              );
          },
          handleSetFont: function(a, b, d, c, f, g) {
            var l = this;
            if (b) {
              b = b.slice();
              var e = b[0].name;
            }
            return this.loadFont(e, d, a)
              .then(function(b) {
                return b.font.isType3Font
                  ? b
                      .loadType3Data(l, a, c, f)
                      .then(function() {
                        return b;
                      })
                      ['catch'](function(a) {
                        l.handler.send('UnsupportedFeature', { featureId: k.UNSUPPORTED_FEATURES.font });
                        return new G('g_font_error', new u.ErrorFont('Type3 font load error: ' + a), b.font);
                      })
                  : b;
              })
              .then(function(a) {
                g.font = a.font;
                a.send(l.handler);
                return a.loadedName;
              });
          },
          handleText: function(a, b) {
            var d = this,
              c = b.font,
              f = c.charsToGlyphs(a),
              g = !!(b.textRenderingMode & k.TextRenderingMode.ADD_TO_PATH_FLAG);
            if (c.data && (g || this.options.disableFontFace)) {
              g = function(a) {
                if (!c.renderer.hasBuiltPath(a)) {
                  var b = c.renderer.getPathJs(a);
                  d.handler.send('commonobj', [c.loadedName + '_path_' + a, 'FontPath', b]);
                }
              };
              for (var l = 0, e = f.length; l < e; l++) {
                var p = f[l];
                g(p.fontChar);
                (p = p.accent) && p.fontChar && g(p.fontChar);
              }
            }
            return f;
          },
          setGState: function(a, b, c, f, g) {
            for (
              var l = this,
                e = [],
                p = b.getKeys(),
                r = Promise.resolve(),
                h = function() {
                  var h = p[q],
                    n = b.get(h);
                  switch (h) {
                    case 'Type':
                      break;
                    case 'LW':
                    case 'LC':
                    case 'LJ':
                    case 'ML':
                    case 'D':
                    case 'RI':
                    case 'FL':
                    case 'CA':
                    case 'ca':
                      e.push([h, n]);
                      break;
                    case 'Font':
                      r = r.then(function() {
                        return l.handleSetFont(a, null, n[0], c, f, g.state).then(function(a) {
                          c.addDependency(a);
                          e.push([h, [a, n[1]]]);
                        });
                      });
                      break;
                    case 'BM':
                      e.push([h, F(n)]);
                      break;
                    case 'SMask':
                      if ((0, d.isName)(n, 'None')) {
                        e.push([h, !1]);
                        break;
                      }
                      (0, d.isDict)(n)
                        ? ((r = r.then(function() {
                            return l.handleSMask(n, a, c, f, g);
                          })),
                          e.push([h, !0]))
                        : (0, k.warn)('Unsupported SMask type');
                      break;
                    case 'OP':
                    case 'op':
                    case 'OPM':
                    case 'BG':
                    case 'BG2':
                    case 'UCR':
                    case 'UCR2':
                    case 'TR':
                    case 'TR2':
                    case 'HT':
                    case 'SM':
                    case 'SA':
                    case 'AIS':
                    case 'TK':
                      (0, k.info)('graphic state operator ' + h);
                      break;
                    default:
                      (0, k.info)('Unknown graphic state operator ' + h);
                  }
                },
                q = 0,
                n = p.length;
              q < n;
              q++
            )
              h();
            return r.then(function() {
              0 < e.length && c.addOp(k.OPS.setGState, [e]);
            });
          },
          loadFont: function(a, b, c) {
            function f() {
              return Promise.resolve(new G('g_font_error', new u.ErrorFont('Font ' + a + ' is not available'), b));
            }
            var g = this,
              l = this.xref;
            if (b) {
              if (!(0, d.isRef)(b)) throw Error('The "font" object should be a reference.');
              c = b;
            } else if ((c = c.get('Font'))) c = c.getRaw(a);
            else return (0, k.warn)('fontRes not available'), f();
            if (!c) return (0, k.warn)('fontRef not available'), f();
            if (this.fontCache.has(c)) return this.fontCache.get(c);
            b = l.fetchIfRef(c);
            if (!(0, d.isDict)(b)) return f();
            if (b.translated) return b.translated;
            var e = (0, k.createPromiseCapability)(),
              p = this.preEvaluateFont(b),
              r = p.descriptor,
              h = (0, d.isRef)(c),
              q;
            h && (q = c.toString());
            if ((0, d.isDict)(r)) {
              r.fontAliases || (r.fontAliases = Object.create(null));
              q = r.fontAliases;
              r = p.hash;
              if (q[r]) {
                var n = q[r].aliasRef;
                if (h && n && this.fontCache.has(n)) return this.fontCache.putAlias(c, n), this.fontCache.get(c);
              } else q[r] = { fontID: u.Font.getFontID() };
              h && (q[r].aliasRef = c);
              q = q[r].fontID;
            }
            h
              ? this.fontCache.put(c, e.promise)
              : (q || (q = this.idFactory.createObjId()), this.fontCache.put('id_' + q, e.promise));
            (0, k.assert)(q, 'The "fontID" must be defined.');
            b.loadedName = 'g_' + this.pdfManager.docId + '_f' + q;
            b.translated = e.promise;
            try {
              var w = this.translateFont(p);
            } catch (Y) {
              w = Promise.reject(Y);
            }
            w.then(function(a) {
              void 0 !== a.fontType && (l.stats.fontTypes[a.fontType] = !0);
              e.resolve(new G(b.loadedName, a, b));
            })['catch'](function(a) {
              g.handler.send('UnsupportedFeature', { featureId: k.UNSUPPORTED_FEATURES.font });
              try {
                var d = p.descriptor,
                  c = d && d.get('FontFile3'),
                  f = c && c.get('Subtype'),
                  r = (0, u.getFontType)(p.type, f && f.name);
                l.stats.fontTypes[r] = !0;
              } catch (Aa) {}
              e.resolve(new G(b.loadedName, new u.ErrorFont(a instanceof Error ? a.message : a), b));
            });
            return e.promise;
          },
          buildPath: function(a, b, d) {
            var c = a.length - 1;
            d || (d = []);
            0 > c || a.fnArray[c] !== k.OPS.constructPath
              ? a.addOp(k.OPS.constructPath, [[b], d])
              : ((a = a.argsArray[c]), a[0].push(b), Array.prototype.push.apply(a[1], d));
          },
          handleColorN: function(a, b, c, f, g, l, e) {
            var p = c[c.length - 1],
              r;
            if ((0, d.isName)(p) && (r = g.get(p.name)))
              return (
                (g = (0, d.isStream)(r) ? r.dict : r),
                (p = g.get('PatternType')),
                1 === p
                  ? ((c = f.base ? f.base.getRgb(c, 0) : null), this.handleTilingType(b, c, l, r, g, a, e))
                  : 2 === p
                  ? ((e = g.get('Shading')),
                    (r = g.getArray('Matrix')),
                    (r = n.Pattern.parseShading(e, r, this.xref, l, this.handler)),
                    a.addOp(b, r.getIR()),
                    Promise.resolve())
                  : Promise.reject(Error('Unknown PatternType: ' + p))
              );
            a.addOp(b, c);
            return Promise.resolve();
          },
          getOperatorList: function(a) {
            function b(a) {
              a = 0;
              for (var b = m.savedStatesDepth; a < b; a++) e.addOp(k.OPS.restore, []);
            }
            var c = this,
              f = a.stream,
              g = a.task,
              l = a.resources,
              e = a.operatorList;
            a = a.initialState;
            l = l || d.Dict.empty;
            a = (void 0 === a ? null : a) || new r();
            if (!e) throw Error('getOperatorList: missing "operatorList" parameter');
            var p = this,
              h = this.xref,
              q = Object.create(null),
              w = l.get('XObject') || d.Dict.empty,
              F = l.get('Pattern') || d.Dict.empty,
              x = new J(a),
              m = new D(f, h, x),
              K = new E();
            return new Promise(function Aa(a, c) {
              var f = function(b) {
                b.then(function() {
                  try {
                    Aa(a, c);
                  } catch (oa) {
                    c(oa);
                  }
                }, c);
              };
              g.ensureNotTerminated();
              K.reset();
              for (var r, E = {}, D, u; !(r = K.check()); ) {
                E.args = null;
                if (!m.read(E)) break;
                r = E.args;
                var B = E.fn;
                switch (B | 0) {
                  case k.OPS.paintXObject:
                    D = r[0].name;
                    if (!D) {
                      (0, k.warn)('XObject must be referred to by name.');
                      continue;
                    }
                    if (void 0 !== q[D]) {
                      e.addOp(q[D].fn, q[D].args);
                      r = null;
                      continue;
                    }
                    if ((u = w.get(D))) {
                      if (!(0, d.isStream)(u)) throw new k.FormatError('XObject should be a stream');
                      r = u.dict.get('Subtype');
                      if (!(0, d.isName)(r)) throw new k.FormatError('XObject should have a Name subtype');
                      if ('Form' === r.name) {
                        x.save();
                        f(
                          p.buildFormXObject(l, u, null, e, g, x.state.clone()).then(function() {
                            x.restore();
                          }),
                        );
                        return;
                      }
                      if ('Image' === r.name) {
                        p.buildPaintImageXObject(l, u, !1, e, D, q);
                        r = null;
                        continue;
                      } else if ('PS' === r.name) {
                        (0, k.info)('Ignored XObject subtype PS');
                        continue;
                      } else throw new k.FormatError('Unhandled XObject subtype ' + r.name);
                    }
                    break;
                  case k.OPS.setFont:
                    var v = r[1];
                    f(
                      p.handleSetFont(l, r, null, e, g, x.state).then(function(a) {
                        e.addDependency(a);
                        e.addOp(k.OPS.setFont, [a, v]);
                      }),
                    );
                    return;
                  case k.OPS.endInlineImage:
                    if ((D = r[0].cacheKey))
                      if (((B = q[D]), void 0 !== B)) {
                        e.addOp(B.fn, B.args);
                        r = null;
                        continue;
                      }
                    p.buildPaintImageXObject(l, r[0], !0, e, D, q);
                    r = null;
                    continue;
                  case k.OPS.showText:
                    r[0] = p.handleText(r[0], x.state);
                    break;
                  case k.OPS.showSpacedText:
                    B = r[0];
                    u = [];
                    var M = B.length,
                      G = x.state;
                    for (D = 0; D < M; ++D) {
                      var J = B[D];
                      (0, k.isString)(J)
                        ? Array.prototype.push.apply(u, p.handleText(J, G))
                        : (0, k.isNum)(J) && u.push(J);
                    }
                    r[0] = u;
                    B = k.OPS.showText;
                    break;
                  case k.OPS.nextLineShowText:
                    e.addOp(k.OPS.nextLine);
                    r[0] = p.handleText(r[0], x.state);
                    B = k.OPS.showText;
                    break;
                  case k.OPS.nextLineSetSpacingShowText:
                    e.addOp(k.OPS.nextLine);
                    e.addOp(k.OPS.setWordSpacing, [r.shift()]);
                    e.addOp(k.OPS.setCharSpacing, [r.shift()]);
                    r[0] = p.handleText(r[0], x.state);
                    B = k.OPS.showText;
                    break;
                  case k.OPS.setTextRenderingMode:
                    x.state.textRenderingMode = r[0];
                    break;
                  case k.OPS.setFillColorSpace:
                    x.state.fillColorSpace = A.ColorSpace.parse(r[0], h, l);
                    continue;
                  case k.OPS.setStrokeColorSpace:
                    x.state.strokeColorSpace = A.ColorSpace.parse(r[0], h, l);
                    continue;
                  case k.OPS.setFillColor:
                    D = x.state.fillColorSpace;
                    r = D.getRgb(r, 0);
                    B = k.OPS.setFillRGBColor;
                    break;
                  case k.OPS.setStrokeColor:
                    D = x.state.strokeColorSpace;
                    r = D.getRgb(r, 0);
                    B = k.OPS.setStrokeRGBColor;
                    break;
                  case k.OPS.setFillGray:
                    x.state.fillColorSpace = A.ColorSpace.singletons.gray;
                    r = A.ColorSpace.singletons.gray.getRgb(r, 0);
                    B = k.OPS.setFillRGBColor;
                    break;
                  case k.OPS.setStrokeGray:
                    x.state.strokeColorSpace = A.ColorSpace.singletons.gray;
                    r = A.ColorSpace.singletons.gray.getRgb(r, 0);
                    B = k.OPS.setStrokeRGBColor;
                    break;
                  case k.OPS.setFillCMYKColor:
                    x.state.fillColorSpace = A.ColorSpace.singletons.cmyk;
                    r = A.ColorSpace.singletons.cmyk.getRgb(r, 0);
                    B = k.OPS.setFillRGBColor;
                    break;
                  case k.OPS.setStrokeCMYKColor:
                    x.state.strokeColorSpace = A.ColorSpace.singletons.cmyk;
                    r = A.ColorSpace.singletons.cmyk.getRgb(r, 0);
                    B = k.OPS.setStrokeRGBColor;
                    break;
                  case k.OPS.setFillRGBColor:
                    x.state.fillColorSpace = A.ColorSpace.singletons.rgb;
                    r = A.ColorSpace.singletons.rgb.getRgb(r, 0);
                    break;
                  case k.OPS.setStrokeRGBColor:
                    x.state.strokeColorSpace = A.ColorSpace.singletons.rgb;
                    r = A.ColorSpace.singletons.rgb.getRgb(r, 0);
                    break;
                  case k.OPS.setFillColorN:
                    D = x.state.fillColorSpace;
                    if ('Pattern' === D.name) {
                      f(p.handleColorN(e, k.OPS.setFillColorN, r, D, F, l, g));
                      return;
                    }
                    r = D.getRgb(r, 0);
                    B = k.OPS.setFillRGBColor;
                    break;
                  case k.OPS.setStrokeColorN:
                    D = x.state.strokeColorSpace;
                    if ('Pattern' === D.name) {
                      f(p.handleColorN(e, k.OPS.setStrokeColorN, r, D, F, l, g));
                      return;
                    }
                    r = D.getRgb(r, 0);
                    B = k.OPS.setStrokeRGBColor;
                    break;
                  case k.OPS.shadingFill:
                    D = l.get('Shading');
                    if (!D) throw new k.FormatError('No shading resource found');
                    r = D.get(r[0].name);
                    if (!r) throw new k.FormatError('No shading object found');
                    r = [n.Pattern.parseShading(r, null, h, l, p.handler).getIR()];
                    B = k.OPS.shadingFill;
                    break;
                  case k.OPS.setGState:
                    D = r[0];
                    u = l.get('ExtGState');
                    if (!(0, d.isDict)(u) || !u.has(D.name)) break;
                    E = u.get(D.name);
                    f(p.setGState(l, E, e, g, x));
                    return;
                  case k.OPS.moveTo:
                  case k.OPS.lineTo:
                  case k.OPS.curveTo:
                  case k.OPS.curveTo2:
                  case k.OPS.curveTo3:
                  case k.OPS.closePath:
                    p.buildPath(e, B, r);
                    continue;
                  case k.OPS.rectangle:
                    p.buildPath(e, B, r);
                    continue;
                  case k.OPS.markPoint:
                  case k.OPS.markPointProps:
                  case k.OPS.beginMarkedContent:
                  case k.OPS.beginMarkedContentProps:
                  case k.OPS.endMarkedContent:
                  case k.OPS.beginCompat:
                  case k.OPS.endCompat:
                    continue;
                  default:
                    if (null !== r) {
                      D = 0;
                      for (u = r.length; D < u && !(r[D] instanceof d.Dict); D++);
                      if (D < u) {
                        (0, k.warn)('getOperatorList - ignoring operator: ' + B);
                        continue;
                      }
                    }
                }
                e.addOp(B, r);
              }
              r ? f(H) : (b(), a());
            })['catch'](function(a) {
              if (c.options.ignoreErrors)
                c.handler.send('UnsupportedFeature', { featureId: k.UNSUPPORTED_FEATURES.unknown }),
                  (0, k.warn)('getOperatorList - ignoring errors during task: ' + g.name),
                  b();
              else throw a;
            });
          },
          getTextContent: function(b) {
            function c() {
              if (I.initialized) return I;
              var a = Q.font;
              a.loadedName in v ||
                ((v[a.loadedName] = !0),
                (M.styles[a.loadedName] = {
                  fontFamily: a.fallbackName,
                  ascent: a.ascent,
                  descent: a.descent,
                  vertical: a.vertical,
                }));
              I.fontName = a.loadedName;
              var b = [Q.fontSize * Q.textHScale, 0, 0, Q.fontSize, 0, Q.textRise];
              if (a.isType3Font && Q.fontMatrix !== k.FONT_IDENTITY_MATRIX && 1 === Q.fontSize) {
                var d = a.bbox[3] - a.bbox[1];
                0 < d && ((d *= Q.fontMatrix[3]), (b[3] *= d));
              }
              b = k.Util.transform(Q.ctm, k.Util.transform(Q.textMatrix, b));
              I.transform = b;
              a.vertical
                ? ((I.width = Math.sqrt(b[0] * b[0] + b[1] * b[1])), (I.height = 0), (I.vertical = !0))
                : ((I.width = 0), (I.height = Math.sqrt(b[2] * b[2] + b[3] * b[3])), (I.vertical = !1));
              b = Q.textLineMatrix[0];
              d = Q.textLineMatrix[1];
              var c = Math.sqrt(b * b + d * d);
              b = Q.ctm[0];
              d = Q.ctm[1];
              I.textAdvanceScale = Math.sqrt(b * b + d * d) * c;
              I.lastAdvanceWidth = 0;
              I.lastAdvanceHeight = 0;
              (b = (a.spaceWidth / 1e3) * Q.fontSize)
                ? ((I.spaceWidth = b),
                  (I.fakeSpaceMin = 0.3 * b),
                  (I.fakeMultiSpaceMin = 1.5 * b),
                  (I.fakeMultiSpaceMax = 4 * b),
                  (I.textRunBreakAllowed = !a.isMonospace))
                : ((I.spaceWidth = 0),
                  (I.fakeSpaceMin = Infinity),
                  (I.fakeMultiSpaceMin = Infinity),
                  (I.fakeMultiSpaceMax = 0),
                  (I.textRunBreakAllowed = !1));
              I.initialized = !0;
              return I;
            }
            function g(a) {
              var b = a.str.join('');
              b = (0, p.bidi)(b, -1, a.vertical);
              var d;
              if (K) {
                for (var c = b.str, f = 0, g = c.length; f < g && 32 <= (d = c.charCodeAt(f)) && 127 >= d; ) f++;
                d = f < g ? c.replace(G, ' ') : c;
              } else d = b.str;
              return {
                str: d,
                dir: b.dir,
                width: a.width,
                height: a.height,
                transform: a.transform,
                fontName: a.fontName,
              };
            }
            function l(a, b) {
              return z.loadFont(a, b, F).then(function(a) {
                Q.font = a.font;
                Q.fontMatrix = a.font.fontMatrix || k.FONT_IDENTITY_MATRIX;
              });
            }
            function e(a) {
              var b = Q.font,
                d = c(),
                f = 0,
                g = 0;
              a = b.charsToGlyphs(a);
              for (var l = 0; l < a.length; l++) {
                var e = a[l];
                var p = b.vertical && e.vmetric ? e.vmetric[0] : e.width;
                var h = e.unicode,
                  q = (0, C.getNormalizedUnicodes)();
                void 0 !== q[h] && (h = q[h]);
                h = (0, C.reverseIfRtl)(h);
                q = Q.charSpacing;
                e.isSpace && ((e = Q.wordSpacing), (q += e), 0 < e && r(e, d.str));
                var n = (e = 0);
                b.vertical
                  ? ((n = p * Q.fontMatrix[0] * Q.fontSize + q), (g += n))
                  : ((e = (p * Q.fontMatrix[0] * Q.fontSize + q) * Q.textHScale), (f += e));
                Q.translateTextMatrix(e, n);
                d.str.push(h);
              }
              b.vertical
                ? ((d.lastAdvanceHeight = g), (d.height += Math.abs(g)))
                : ((d.lastAdvanceWidth = f), (d.width += f));
              return d;
            }
            function r(a, b) {
              if (!(a < I.fakeSpaceMin))
                if (a < I.fakeMultiSpaceMin) b.push(' ');
                else for (var d = Math.round(a / I.spaceWidth); 0 < d--; ) b.push(' ');
            }
            function h() {
              I.initialized &&
                ((I.width *= I.textAdvanceScale),
                (I.height *= I.textAdvanceScale),
                M.items.push(g(I)),
                (I.initialized = !1),
                (I.str.length = 0));
            }
            function q() {
              var a = M.items.length;
              0 < a && (B.enqueue(M, a), (M.items = []), (M.styles = Object.create(null)));
            }
            var n = this,
              w = b.stream,
              A = b.task,
              F = b.resources,
              x = b.stateManager,
              m = void 0 === x ? null : x;
            x = b.normalizeWhitespace;
            var K = void 0 === x ? !1 : x;
            x = b.combineTextItems;
            var u = void 0 === x ? !1 : x,
              B = b.sink;
            b = b.seenStyles;
            var v = void 0 === b ? Object.create(null) : b;
            F = F || d.Dict.empty;
            m = m || new J(new f());
            var G = /\s/g,
              M = { items: [], styles: Object.create(null) },
              I = {
                initialized: !1,
                str: [],
                width: 0,
                height: 0,
                vertical: !1,
                lastAdvanceWidth: 0,
                lastAdvanceHeight: 0,
                textAdvanceScale: 0,
                spaceWidth: 0,
                fakeSpaceMin: Infinity,
                fakeMultiSpaceMin: Infinity,
                fakeMultiSpaceMax: -0,
                textRunBreakAllowed: !1,
                transform: null,
                fontName: null,
              },
              z = this;
            b = this.xref;
            var L = null,
              t = Object.create(null),
              y = new D(w, b, m),
              Q,
              ua = new E();
            return new Promise(function oa(b, f) {
              var g = function(a) {
                q();
                Promise.all([a, B.ready]).then(function() {
                  try {
                    oa(b, f);
                  } catch ($a) {
                    f($a);
                  }
                }, f);
              };
              A.ensureNotTerminated();
              ua.reset();
              for (var p, n = {}, w = []; !(p = ua.check()); ) {
                w.length = 0;
                n.args = w;
                if (!y.read(n)) break;
                Q = m.state;
                var D = n.fn;
                w = n.args;
                var x, E, G, N, O, Z, C, da, W, ba, ea, X, aa, T, ca, S, wa, Y, P, U;
                p = (function() {
                  switch (D | 0) {
                    case k.OPS.setFont:
                      G = w[0].name;
                      N = w[1];
                      if (Q.font && G === Q.fontName && N === Q.fontSize) break;
                      h();
                      Q.fontName = G;
                      Q.fontSize = N;
                      g(l(G, null));
                      return { v: void 0 };
                    case k.OPS.setTextRise:
                      h();
                      Q.textRise = w[0];
                      break;
                    case k.OPS.setHScale:
                      h();
                      Q.textHScale = w[0] / 100;
                      break;
                    case k.OPS.setLeading:
                      h();
                      Q.leading = w[0];
                      break;
                    case k.OPS.moveText:
                      O = Q.font ? 0 === (Q.font.vertical ? w[0] : w[1]) : !1;
                      x = w[0] - w[1];
                      if (u && O && I.initialized && 0 < x && x <= I.fakeMultiSpaceMax) {
                        Q.translateTextLineMatrix(w[0], w[1]);
                        I.width += w[0] - I.lastAdvanceWidth;
                        I.height += w[1] - I.lastAdvanceHeight;
                        E = w[0] - I.lastAdvanceWidth - (w[1] - I.lastAdvanceHeight);
                        r(E, I.str);
                        break;
                      }
                      h();
                      Q.translateTextLineMatrix(w[0], w[1]);
                      Q.textMatrix = Q.textLineMatrix.slice();
                      break;
                    case k.OPS.setLeadingMoveText:
                      h();
                      Q.leading = -w[1];
                      Q.translateTextLineMatrix(w[0], w[1]);
                      Q.textMatrix = Q.textLineMatrix.slice();
                      break;
                    case k.OPS.nextLine:
                      h();
                      Q.carriageReturn();
                      break;
                    case k.OPS.setTextMatrix:
                      x = Q.calcTextLineMatrixAdvance(w[0], w[1], w[2], w[3], w[4], w[5]);
                      if (u && null !== x && I.initialized && 0 < x.value && x.value <= I.fakeMultiSpaceMax) {
                        Q.translateTextLineMatrix(x.width, x.height);
                        I.width += x.width - I.lastAdvanceWidth;
                        I.height += x.height - I.lastAdvanceHeight;
                        E = x.width - I.lastAdvanceWidth - (x.height - I.lastAdvanceHeight);
                        r(E, I.str);
                        break;
                      }
                      h();
                      Q.setTextMatrix(w[0], w[1], w[2], w[3], w[4], w[5]);
                      Q.setTextLineMatrix(w[0], w[1], w[2], w[3], w[4], w[5]);
                      break;
                    case k.OPS.setCharSpacing:
                      Q.charSpacing = w[0];
                      break;
                    case k.OPS.setWordSpacing:
                      Q.wordSpacing = w[0];
                      break;
                    case k.OPS.beginText:
                      h();
                      Q.textMatrix = k.IDENTITY_MATRIX.slice();
                      Q.textLineMatrix = k.IDENTITY_MATRIX.slice();
                      break;
                    case k.OPS.showSpacedText:
                      Z = w[0];
                      da = 0;
                      for (W = Z.length; da < W; da++)
                        'string' === typeof Z[da]
                          ? e(Z[da])
                          : (0, k.isNum)(Z[da]) &&
                            (c(),
                            (x = (Z[da] * Q.fontSize) / 1e3),
                            (ba = !1),
                            Q.font.vertical
                              ? ((C = x),
                                Q.translateTextMatrix(0, C),
                                (ba = I.textRunBreakAllowed && x > I.fakeMultiSpaceMax),
                                ba || (I.height += C))
                              : ((x = -x),
                                (C = x * Q.textHScale),
                                Q.translateTextMatrix(C, 0),
                                (ba = I.textRunBreakAllowed && x > I.fakeMultiSpaceMax),
                                ba || (I.width += C)),
                            ba ? h() : 0 < x && r(x, I.str));
                      break;
                    case k.OPS.showText:
                      e(w[0]);
                      break;
                    case k.OPS.nextLineShowText:
                      h();
                      Q.carriageReturn();
                      e(w[0]);
                      break;
                    case k.OPS.nextLineSetSpacingShowText:
                      h();
                      Q.wordSpacing = w[0];
                      Q.charSpacing = w[1];
                      Q.carriageReturn();
                      e(w[2]);
                      break;
                    case k.OPS.paintXObject:
                      h();
                      L || (L = F.get('XObject') || d.Dict.empty);
                      ea = w[0].name;
                      if (ea in t) break;
                      X = L.get(ea);
                      if (!X) break;
                      if (!(0, d.isStream)(X)) throw new k.FormatError('XObject should be a stream');
                      aa = X.dict.get('Subtype');
                      if (!(0, d.isName)(aa)) throw new k.FormatError('XObject should have a Name subtype');
                      if ('Form' !== aa.name) {
                        t[ea] = !0;
                        break;
                      }
                      T = m.state.clone();
                      ca = new J(T);
                      S = X.dict.getArray('Matrix');
                      Array.isArray(S) && 6 === S.length && ca.transform(S);
                      q();
                      var a = {
                        enqueueInvoked: !1,
                        enqueue: function(a, b) {
                          this.enqueueInvoked = !0;
                          B.enqueue(a, b);
                        },
                        get desiredSize() {
                          return B.desiredSize;
                        },
                        get ready() {
                          return B.ready;
                        },
                      };
                      g(
                        z
                          .getTextContent({
                            stream: X,
                            task: A,
                            resources: X.dict.get('Resources') || F,
                            stateManager: ca,
                            normalizeWhitespace: K,
                            combineTextItems: u,
                            sink: a,
                            seenStyles: v,
                          })
                          .then(function() {
                            a.enqueueInvoked || (t[ea] = !0);
                          }),
                      );
                      return { v: void 0 };
                    case k.OPS.setGState:
                      if (
                        (h(),
                        (wa = w[0]),
                        (Y = F.get('ExtGState')),
                        (0, d.isDict)(Y) &&
                          (0, d.isName)(wa) &&
                          ((P = Y.get(wa.name)), (0, d.isDict)(P) && (U = P.get('Font'))))
                      )
                        return (Q.fontName = null), (Q.fontSize = U[1]), g(l(null, U[0])), { v: void 0 };
                  }
                })();
                if ('object' === ('undefined' === typeof p ? 'undefined' : a(p))) return p.v;
                if (M.items.length >= B.desiredSize) {
                  p = !0;
                  break;
                }
              }
              p ? g(H) : (h(), q(), b());
            })['catch'](function(a) {
              if (!(a instanceof k.AbortException))
                if (n.options.ignoreErrors)
                  (0, k.warn)('getTextContent - ignoring errors during task: ' + A.name), h(), q();
                else throw a;
            });
          },
          extractDataStructures: function(a, b, c) {
            var f = this,
              g = this.xref;
            b = (b = a.get('ToUnicode') || b.get('ToUnicode')) ? this.readToUnicode(b) : Promise.resolve(void 0);
            if (c.composite) {
              var l = a.get('CIDSystemInfo');
              (0, d.isDict)(l) &&
                (c.cidSystemInfo = {
                  registry: l.get('Registry'),
                  ordering: l.get('Ordering'),
                  supplement: l.get('Supplement'),
                });
              l = a.get('CIDToGIDMap');
              (0, d.isStream)(l) && (c.cidToGidMap = this.readCidToGidMap(l));
            }
            l = [];
            var e = null;
            if (a.has('Encoding')) {
              var r = a.get('Encoding');
              if ((0, d.isDict)(r)) {
                if (((e = r.get('BaseEncoding')), (e = (0, d.isName)(e) ? e.name : null), r.has('Differences'))) {
                  r = r.get('Differences');
                  for (var p = 0, h = 0, q = r.length; h < q; h++) {
                    var n = g.fetchIfRef(r[h]);
                    if ((0, k.isNum)(n)) p = n;
                    else if ((0, d.isName)(n)) l[p++] = n.name;
                    else throw new k.FormatError("Invalid entry in 'Differences' array: " + n);
                  }
                }
              } else if ((0, d.isName)(r)) e = r.name;
              else throw new k.FormatError('Encoding is not a Name nor a Dict');
              'MacRomanEncoding' !== e && 'MacExpertEncoding' !== e && 'WinAnsiEncoding' !== e && (e = null);
            }
            e
              ? (c.defaultEncoding = (0, z.getEncoding)(e).slice())
              : ((g = !!(c.flags & u.FontFlags.Symbolic)),
                (p = !!(c.flags & u.FontFlags.Nonsymbolic)),
                (r = z.StandardEncoding),
                'TrueType' !== c.type || p || (r = z.WinAnsiEncoding),
                g &&
                  ((r = z.MacRomanEncoding),
                  c.file ||
                    (/Symbol/i.test(c.name)
                      ? (r = z.SymbolSetEncoding)
                      : /Dingbats/i.test(c.name) && (r = z.ZapfDingbatsEncoding))),
                (c.defaultEncoding = r));
            c.differences = l;
            c.baseEncodingName = e;
            c.hasEncoding = !!e || 0 < l.length;
            c.dict = a;
            return b
              .then(function(a) {
                c.toUnicode = a;
                return f.buildToUnicode(c);
              })
              .then(function(a) {
                c.toUnicode = a;
                return c;
              });
          },
          buildToUnicode: function(a) {
            a.hasIncludedToUnicodeMap = !!a.toUnicode && 0 < a.toUnicode.length;
            if (a.hasIncludedToUnicodeMap) return Promise.resolve(a.toUnicode);
            if (!a.composite) {
              var f = [];
              var g = a.defaultEncoding.slice(),
                l = a.baseEncodingName,
                e = a.differences;
              for (q in e) {
                var r = e[q];
                '.notdef' !== r && (g[q] = r);
              }
              e = (0, c.getGlyphsUnicode)();
              for (q in g)
                if (((r = g[q]), '' !== r))
                  if (void 0 === e[r]) {
                    var p = 0;
                    switch (r[0]) {
                      case 'G':
                        3 === r.length && (p = parseInt(r.substr(1), 16));
                        break;
                      case 'g':
                        5 === r.length && (p = parseInt(r.substr(1), 16));
                        break;
                      case 'C':
                      case 'c':
                        3 <= r.length && (p = +r.substr(1));
                        break;
                      default:
                        var h = (0, C.getUnicodeForGlyph)(r, e);
                        -1 !== h && (p = h);
                    }
                    if (p) {
                      if (l && p === +q && (h = (0, z.getEncoding)(l)) && (r = h[q])) {
                        f[q] = String.fromCharCode(e[r]);
                        continue;
                      }
                      f[q] = String.fromCharCode(p);
                    }
                  } else f[q] = String.fromCharCode(e[r]);
              return Promise.resolve(new u.ToUnicodeMap(f));
            }
            if (
              a.composite &&
              ((a.cMap.builtInCMap && !(a.cMap instanceof b.IdentityCMap)) ||
                ('Adobe' === a.cidSystemInfo.registry &&
                  ('GB1' === a.cidSystemInfo.ordering ||
                    'CNS1' === a.cidSystemInfo.ordering ||
                    'Japan1' === a.cidSystemInfo.ordering ||
                    'Korea1' === a.cidSystemInfo.ordering)))
            ) {
              var q = d.Name.get(a.cidSystemInfo.registry + '-' + a.cidSystemInfo.ordering + '-UCS2');
              return b.CMapFactory.create({ encoding: q, fetchBuiltInCMap: this.fetchBuiltInCMap, useCMap: null }).then(
                function(b) {
                  var d = a.cMap;
                  f = [];
                  d.forEach(function(a, d) {
                    if (65535 < d) throw new k.FormatError('Max size of CID is 65,535');
                    var c = b.lookup(d);
                    c && (f[a] = String.fromCharCode((c.charCodeAt(0) << 8) + c.charCodeAt(1)));
                  });
                  return new u.ToUnicodeMap(f);
                },
              );
            }
            return Promise.resolve(new u.IdentityToUnicodeMap(a.firstChar, a.lastChar));
          },
          readToUnicode: function(a) {
            return (0, d.isName)(a)
              ? b.CMapFactory.create({ encoding: a, fetchBuiltInCMap: this.fetchBuiltInCMap, useCMap: null }).then(
                  function(a) {
                    return a instanceof b.IdentityCMap
                      ? new u.IdentityToUnicodeMap(0, 65535)
                      : new u.ToUnicodeMap(a.getMap());
                  },
                )
              : (0, d.isStream)(a)
              ? b.CMapFactory.create({ encoding: a, fetchBuiltInCMap: this.fetchBuiltInCMap, useCMap: null }).then(
                  function(a) {
                    if (a instanceof b.IdentityCMap) return new u.IdentityToUnicodeMap(0, 65535);
                    var d = Array(a.length);
                    a.forEach(function(a, b) {
                      for (var c = [], f = 0; f < b.length; f += 2) {
                        var g = (b.charCodeAt(f) << 8) | b.charCodeAt(f + 1);
                        if (55296 !== (g & 63488)) c.push(g);
                        else {
                          f += 2;
                          var l = (b.charCodeAt(f) << 8) | b.charCodeAt(f + 1);
                          c.push(((g & 1023) << 10) + (l & 1023) + 65536);
                        }
                      }
                      d[a] = String.fromCharCode.apply(String, c);
                    });
                    return new u.ToUnicodeMap(d);
                  },
                )
              : Promise.resolve(null);
          },
          readCidToGidMap: function(a) {
            a = a.getBytes();
            for (var b = [], d = 0, c = a.length; d < c; d++) {
              var f = (a[d++] << 8) | a[d];
              0 !== f && (b[d >> 1] = f);
            }
            return b;
          },
          extractWidths: function(a, b, c) {
            var f = this.xref,
              g = [],
              l = 0,
              e = [],
              r,
              p,
              h;
            if (c.composite) {
              l = a.has('DW') ? a.get('DW') : 1e3;
              if ((h = a.get('W'))) {
                var q = 0;
                for (r = h.length; q < r; q++) {
                  b = f.fetchIfRef(h[q++]);
                  var n = f.fetchIfRef(h[q]);
                  if (Array.isArray(n)) {
                    var k = 0;
                    for (p = n.length; k < p; k++) g[b++] = f.fetchIfRef(n[k]);
                  } else for (p = f.fetchIfRef(h[++q]), k = b; k <= n; k++) g[k] = p;
                }
              }
              if (c.vertical) {
                h = a.getArray('DW2') || [880, -1e3];
                var w = [h[1], 0.5 * l, h[0]];
                if ((h = a.get('W2')))
                  for (q = 0, r = h.length; q < r; q++)
                    if (((b = f.fetchIfRef(h[q++])), (n = f.fetchIfRef(h[q])), Array.isArray(n)))
                      for (k = 0, p = n.length; k < p; k++)
                        e[b++] = [f.fetchIfRef(n[k++]), f.fetchIfRef(n[k++]), f.fetchIfRef(n[k])];
                    else
                      for (a = [f.fetchIfRef(h[++q]), f.fetchIfRef(h[++q]), f.fetchIfRef(h[++q])], k = b; k <= n; k++)
                        e[k] = a;
              }
            } else if (((q = c.firstChar), (h = a.get('Widths')))) {
              k = q;
              q = 0;
              for (r = h.length; q < r; q++) g[k++] = f.fetchIfRef(h[q]);
              l = parseFloat(b.get('MissingWidth')) || 0;
            } else
              (f = a.get('BaseFont')),
                (0, d.isName)(f) &&
                  ((l = this.getBaseFontMetrics(f.name)),
                  (g = this.buildCharCodeToWidth(l.widths, c)),
                  (l = l.defaultWidth));
            f = !0;
            a = l;
            for (var A in g)
              if ((q = g[A]))
                if (!a) a = q;
                else if (a !== q) {
                  f = !1;
                  break;
                }
            f && (c.flags |= u.FontFlags.FixedPitch);
            c.defaultWidth = l;
            c.widths = g;
            c.defaultVMetrics = w;
            c.vmetrics = e;
          },
          isSerifFont: function(a) {
            a = a.split('-')[0];
            return a in (0, B.getSerifFonts)() || -1 !== a.search(/serif/gi);
          },
          getBaseFontMetrics: function(a) {
            var b = 0,
              d = [],
              c = !1,
              f = (0, B.getStdFontMap)()[a] || a,
              g = (0, q.getMetrics)();
            f in g || (f = this.isSerifFont(a) ? 'Times-Roman' : 'Helvetica');
            a = g[f];
            (0, k.isNum)(a) ? ((b = a), (c = !0)) : (d = a());
            return { defaultWidth: b, monospace: c, widths: d };
          },
          buildCharCodeToWidth: function(a, b) {
            for (var d = Object.create(null), c = b.differences, f = b.defaultEncoding, g = 0; 256 > g; g++)
              g in c && a[c[g]] ? (d[g] = a[c[g]]) : g in f && a[f[g]] && (d[g] = a[f[g]]);
            return d;
          },
          preEvaluateFont: function(a) {
            var b = a,
              c = a.get('Subtype');
            if (!(0, d.isName)(c)) throw new k.FormatError('invalid font Subtype');
            var f = !1;
            if ('Type0' === c.name) {
              a = a.get('DescendantFonts');
              if (!a) throw new k.FormatError('Descendant fonts are not specified');
              a = Array.isArray(a) ? this.xref.fetchIfRef(a[0]) : a;
              c = a.get('Subtype');
              if (!(0, d.isName)(c)) throw new k.FormatError('invalid font Subtype');
              f = !0;
            }
            var g = a.get('FontDescriptor');
            if (g) {
              var l = new x.MurmurHash3_64();
              var e = b.getRaw('Encoding');
              if ((0, d.isName)(e)) l.update(e.name);
              else if ((0, d.isRef)(e)) l.update(e.toString());
              else if ((0, d.isDict)(e))
                for (var r = e.getKeys(), p = 0, h = r.length; p < h; p++) {
                  var q = e.getRaw(r[p]);
                  if ((0, d.isName)(q)) l.update(q.name);
                  else if ((0, d.isRef)(q)) l.update(q.toString());
                  else if (Array.isArray(q)) {
                    for (var n = q.length, w = Array(n), A = 0; A < n; A++) {
                      var D = q[A];
                      if ((0, d.isName)(D)) w[A] = D.name;
                      else if ((0, k.isNum)(D) || (0, d.isRef)(D)) w[A] = D.toString();
                    }
                    l.update(w.join());
                  }
                }
              e = a.get('ToUnicode') || b.get('ToUnicode');
              (0, d.isStream)(e)
                ? ((e = e.str || e),
                  (e = e.buffer
                    ? new Uint8Array(e.buffer.buffer, 0, e.bufferLength)
                    : new Uint8Array(e.bytes.buffer, e.start, e.end - e.start)),
                  l.update(e))
                : (0, d.isName)(e) && l.update(e.name);
              if ((e = a.get('Widths') || b.get('Widths')))
                (e = new Uint8Array(new Uint32Array(e).buffer)), l.update(e);
            }
            return { descriptor: g, dict: a, baseDict: b, composite: f, type: c.name, hash: l ? l.hexdigest() : '' };
          },
          translateFont: function(a) {
            var c = this,
              f = a.baseDict,
              g = a.dict,
              l = a.composite,
              e = a.descriptor,
              r = a.type;
            a = l ? 65535 : 255;
            if (!e)
              if ('Type3' === r)
                (e = new d.Dict(null)), e.set('FontName', d.Name.get(r)), e.set('FontBBox', g.getArray('FontBBox'));
              else {
                var p = g.get('BaseFont');
                if (!(0, d.isName)(p)) throw new k.FormatError('Base font is not specified');
                p = p.name.replace(/[,_]/g, '-');
                var h = this.getBaseFontMetrics(p);
                l = p.split('-')[0];
                l =
                  (this.isSerifFont(l) ? u.FontFlags.Serif : 0) |
                  (h.monospace ? u.FontFlags.FixedPitch : 0) |
                  ((0, B.getSymbolsFonts)()[l] ? u.FontFlags.Symbolic : u.FontFlags.Nonsymbolic);
                var q = {
                  type: r,
                  name: p,
                  widths: h.widths,
                  defaultWidth: h.defaultWidth,
                  flags: l,
                  firstChar: 0,
                  lastChar: a,
                };
                return this.extractDataStructures(g, g, q).then(function(a) {
                  a.widths = c.buildCharCodeToWidth(h.widths, a);
                  return new u.Font(p, null, a);
                });
              }
            var n = g.get('FirstChar') || 0,
              w = g.get('LastChar') || a,
              A = e.get('FontName'),
              D = g.get('BaseFont');
            (0, k.isString)(A) && (A = d.Name.get(A));
            (0, k.isString)(D) && (D = d.Name.get(D));
            if ('Type3' !== r) {
              var x = A && A.name,
                F = D && D.name;
              x !== F &&
                ((0, k.info)(
                  'The FontDescriptor\'s FontName is "' +
                    x +
                    '" but should be the same as the Font\'s BaseFont "' +
                    F +
                    '"',
                ),
                x && F && 0 === F.indexOf(x) && (A = D));
            }
            A = A || D;
            if (!(0, d.isName)(A)) throw new k.FormatError('invalid font name');
            var E = e.get('FontFile', 'FontFile2', 'FontFile3');
            if (E && E.dict) {
              var m = E.dict.get('Subtype');
              m && (m = m.name);
              var H = E.dict.get('Length1'),
                K = E.dict.get('Length2'),
                v = E.dict.get('Length3');
            }
            q = {
              type: r,
              name: A.name,
              subtype: m,
              file: E,
              length1: H,
              length2: K,
              length3: v,
              loadedName: f.loadedName,
              composite: l,
              wideChars: l,
              fixedPitch: !1,
              fontMatrix: g.getArray('FontMatrix') || k.FONT_IDENTITY_MATRIX,
              firstChar: n || 0,
              lastChar: w || a,
              bbox: e.getArray('FontBBox'),
              ascent: e.get('Ascent'),
              descent: e.get('Descent'),
              xHeight: e.get('XHeight'),
              capHeight: e.get('CapHeight'),
              flags: e.get('Flags'),
              italicAngle: e.get('ItalicAngle'),
              isType3Font: !1,
            };
            l
              ? ((a = f.get('Encoding')),
                (0, d.isName)(a) && (q.cidEncoding = a.name),
                (a = b.CMapFactory.create({ encoding: a, fetchBuiltInCMap: this.fetchBuiltInCMap, useCMap: null }).then(
                  function(a) {
                    q.cMap = a;
                    q.vertical = q.cMap.vertical;
                  },
                )))
              : (a = Promise.resolve(void 0));
            return a
              .then(function() {
                return c.extractDataStructures(g, f, q);
              })
              .then(function(a) {
                c.extractWidths(g, e, a);
                'Type3' === r && (a.isType3Font = !0);
                return new u.Font(A.name, E, a);
              });
          },
        };
        return w;
      })();
      var G = (function() {
          function a(a, b, d) {
            this.loadedName = a;
            this.font = b;
            this.dict = d;
            this.type3Loaded = null;
            this.sent = !1;
          }
          a.prototype = {
            send: function(a) {
              if (!this.sent) {
                var b = this.font.exportData();
                a.send('commonobj', [this.loadedName, 'Font', b]);
                this.sent = !0;
              }
            },
            loadType3Data: function(a, b, d, c) {
              if (!this.font.isType3Font) throw Error('Must be a Type3 font.');
              if (this.type3Loaded) return this.type3Loaded;
              var f = Object.create(a.options);
              f.ignoreErrors = !1;
              var g = a.clone(f),
                e = this.font,
                r = Promise.resolve(),
                p = this.dict.get('CharProcs'),
                h = this.dict.get('Resources') || b,
                q = p.getKeys(),
                n = Object.create(null);
              a = function() {
                var a = q[w];
                r = r.then(function() {
                  var b = p.get(a),
                    f = new l();
                  return g
                    .getOperatorList({ stream: b, task: c, resources: h, operatorList: f })
                    .then(function() {
                      n[a] = f.getIR();
                      d.addDependencies(f.dependencies);
                    })
                    ['catch'](function(b) {
                      (0, k.warn)('Type3 font resource "' + a + '" is not available.');
                      b = new l();
                      n[a] = b.getIR();
                    });
                });
              };
              var w = 0;
              for (b = q.length; w < b; ++w) a();
              return (this.type3Loaded = r.then(function() {
                e.charProcOperatorList = n;
              }));
            },
          };
          return a;
        })(),
        l = (function() {
          function a(a, b, d) {
            this.messageHandler = b;
            this.fnArray = [];
            this.argsArray = [];
            this.dependencies = Object.create(null);
            this._totalLength = 0;
            this.pageIndex = d;
            this.intent = a;
          }
          a.prototype = {
            get length() {
              return this.argsArray.length;
            },
            get totalLength() {
              return this._totalLength + this.length;
            },
            addOp: function(a, b) {
              this.fnArray.push(a);
              this.argsArray.push(b);
              this.messageHandler &&
                (1e3 <= this.fnArray.length
                  ? this.flush()
                  : 995 <= this.fnArray.length && (a === k.OPS.restore || a === k.OPS.endText) && this.flush());
            },
            addDependency: function(a) {
              a in this.dependencies || ((this.dependencies[a] = !0), this.addOp(k.OPS.dependency, [a]));
            },
            addDependencies: function(a) {
              for (var b in a) this.addDependency(b);
            },
            addOpList: function(a) {
              k.Util.extendObj(this.dependencies, a.dependencies);
              for (var b = 0, d = a.length; b < d; b++) this.addOp(a.fnArray[b], a.argsArray[b]);
            },
            getIR: function() {
              return { fnArray: this.fnArray, argsArray: this.argsArray, length: this.length };
            },
            flush: function(a) {
              'oplist' !== this.intent && new L().optimize(this);
              for (var b = [], d = this.fnArray, c = this.argsArray, f = 0, g = this.length; f < g; f++)
                switch (d[f]) {
                  case k.OPS.paintInlineImageXObject:
                  case k.OPS.paintInlineImageXObjectGroup:
                  case k.OPS.paintImageMaskXObject:
                    var l = c[f][0];
                    l.cached || b.push(l.data.buffer);
                }
              d = this.length;
              this._totalLength += d;
              this.messageHandler.send(
                'RenderPageChunk',
                {
                  operatorList: { fnArray: this.fnArray, argsArray: this.argsArray, lastChunk: a, length: d },
                  pageIndex: this.pageIndex,
                  intent: this.intent,
                },
                b,
              );
              this.dependencies = Object.create(null);
              this.fnArray.length = 0;
              this.argsArray.length = 0;
            },
          };
          return a;
        })(),
        J = (function() {
          function a(a) {
            this.state = a;
            this.stateStack = [];
          }
          a.prototype = {
            save: function() {
              var a = this.state;
              this.stateStack.push(this.state);
              this.state = a.clone();
            },
            restore: function() {
              var a = this.stateStack.pop();
              a && (this.state = a);
            },
            transform: function(a) {
              this.state.ctm = k.Util.transform(this.state.ctm, a);
            },
          };
          return a;
        })(),
        f = (function() {
          function a() {
            this.ctm = new Float32Array(k.IDENTITY_MATRIX);
            this.fontName = null;
            this.fontSize = 0;
            this.font = null;
            this.fontMatrix = k.FONT_IDENTITY_MATRIX;
            this.textMatrix = k.IDENTITY_MATRIX.slice();
            this.textLineMatrix = k.IDENTITY_MATRIX.slice();
            this.leading = this.wordSpacing = this.charSpacing = 0;
            this.textHScale = 1;
            this.textRise = 0;
          }
          a.prototype = {
            setTextMatrix: function(a, b, d, c, f, g) {
              var l = this.textMatrix;
              l[0] = a;
              l[1] = b;
              l[2] = d;
              l[3] = c;
              l[4] = f;
              l[5] = g;
            },
            setTextLineMatrix: function(a, b, d, c, f, g) {
              var l = this.textLineMatrix;
              l[0] = a;
              l[1] = b;
              l[2] = d;
              l[3] = c;
              l[4] = f;
              l[5] = g;
            },
            translateTextMatrix: function(a, b) {
              var d = this.textMatrix;
              d[4] = d[0] * a + d[2] * b + d[4];
              d[5] = d[1] * a + d[3] * b + d[5];
            },
            translateTextLineMatrix: function(a, b) {
              var d = this.textLineMatrix;
              d[4] = d[0] * a + d[2] * b + d[4];
              d[5] = d[1] * a + d[3] * b + d[5];
            },
            calcTextLineMatrixAdvance: function(a, b, d, c, f, g) {
              var l = this.font;
              if (!l) return null;
              var e = this.textLineMatrix;
              if (a !== e[0] || b !== e[1] || d !== e[2] || c !== e[3]) return null;
              f -= e[4];
              g -= e[5];
              if ((l.vertical && 0 !== f) || (!l.vertical && 0 !== g)) return null;
              e = a * c - b * d;
              l.vertical ? ((d = (-g * d) / e), (a = (g * a) / e)) : ((d = (f * c) / e), (a = (-f * b) / e));
              return { width: d, height: a, value: l.vertical ? a : d };
            },
            calcRenderMatrix: function(a) {
              return k.Util.transform(
                a,
                k.Util.transform(this.textMatrix, [
                  this.fontSize * this.textHScale,
                  0,
                  0,
                  this.fontSize,
                  0,
                  this.textRise,
                ]),
              );
            },
            carriageReturn: function() {
              this.translateTextLineMatrix(0, -this.leading);
              this.textMatrix = this.textLineMatrix.slice();
            },
            clone: function() {
              var a = Object.create(this);
              a.textMatrix = this.textMatrix.slice();
              a.textLineMatrix = this.textLineMatrix.slice();
              a.fontMatrix = this.fontMatrix.slice();
              return a;
            },
          };
          return a;
        })(),
        r = (function() {
          function a() {
            this.ctm = new Float32Array(k.IDENTITY_MATRIX);
            this.font = null;
            this.textRenderingMode = k.TextRenderingMode.FILL;
            this.strokeColorSpace = this.fillColorSpace = A.ColorSpace.singletons.gray;
          }
          a.prototype = {
            clone: function() {
              return Object.create(this);
            },
          };
          return a;
        })(),
        D = (function() {
          function a(a, d, c) {
            this.opMap = b();
            this.parser = new h.Parser(new h.Lexer(a, this.opMap), !1, d);
            this.stateManager = c;
            this.nonProcessedArgs = [];
          }
          var b = (0, k.getLookupTableFactory)(function(a) {
            a.w = { id: k.OPS.setLineWidth, numArgs: 1, variableArgs: !1 };
            a.J = { id: k.OPS.setLineCap, numArgs: 1, variableArgs: !1 };
            a.j = { id: k.OPS.setLineJoin, numArgs: 1, variableArgs: !1 };
            a.M = { id: k.OPS.setMiterLimit, numArgs: 1, variableArgs: !1 };
            a.d = { id: k.OPS.setDash, numArgs: 2, variableArgs: !1 };
            a.ri = { id: k.OPS.setRenderingIntent, numArgs: 1, variableArgs: !1 };
            a.i = { id: k.OPS.setFlatness, numArgs: 1, variableArgs: !1 };
            a.gs = { id: k.OPS.setGState, numArgs: 1, variableArgs: !1 };
            a.q = { id: k.OPS.save, numArgs: 0, variableArgs: !1 };
            a.Q = { id: k.OPS.restore, numArgs: 0, variableArgs: !1 };
            a.cm = { id: k.OPS.transform, numArgs: 6, variableArgs: !1 };
            a.m = { id: k.OPS.moveTo, numArgs: 2, variableArgs: !1 };
            a.l = { id: k.OPS.lineTo, numArgs: 2, variableArgs: !1 };
            a.c = { id: k.OPS.curveTo, numArgs: 6, variableArgs: !1 };
            a.v = { id: k.OPS.curveTo2, numArgs: 4, variableArgs: !1 };
            a.y = { id: k.OPS.curveTo3, numArgs: 4, variableArgs: !1 };
            a.h = { id: k.OPS.closePath, numArgs: 0, variableArgs: !1 };
            a.re = { id: k.OPS.rectangle, numArgs: 4, variableArgs: !1 };
            a.S = { id: k.OPS.stroke, numArgs: 0, variableArgs: !1 };
            a.s = { id: k.OPS.closeStroke, numArgs: 0, variableArgs: !1 };
            a.f = { id: k.OPS.fill, numArgs: 0, variableArgs: !1 };
            a.F = { id: k.OPS.fill, numArgs: 0, variableArgs: !1 };
            a['f*'] = { id: k.OPS.eoFill, numArgs: 0, variableArgs: !1 };
            a.B = { id: k.OPS.fillStroke, numArgs: 0, variableArgs: !1 };
            a['B*'] = { id: k.OPS.eoFillStroke, numArgs: 0, variableArgs: !1 };
            a.b = { id: k.OPS.closeFillStroke, numArgs: 0, variableArgs: !1 };
            a['b*'] = { id: k.OPS.closeEOFillStroke, numArgs: 0, variableArgs: !1 };
            a.n = { id: k.OPS.endPath, numArgs: 0, variableArgs: !1 };
            a.W = { id: k.OPS.clip, numArgs: 0, variableArgs: !1 };
            a['W*'] = { id: k.OPS.eoClip, numArgs: 0, variableArgs: !1 };
            a.BT = { id: k.OPS.beginText, numArgs: 0, variableArgs: !1 };
            a.ET = { id: k.OPS.endText, numArgs: 0, variableArgs: !1 };
            a.Tc = { id: k.OPS.setCharSpacing, numArgs: 1, variableArgs: !1 };
            a.Tw = { id: k.OPS.setWordSpacing, numArgs: 1, variableArgs: !1 };
            a.Tz = { id: k.OPS.setHScale, numArgs: 1, variableArgs: !1 };
            a.TL = { id: k.OPS.setLeading, numArgs: 1, variableArgs: !1 };
            a.Tf = { id: k.OPS.setFont, numArgs: 2, variableArgs: !1 };
            a.Tr = { id: k.OPS.setTextRenderingMode, numArgs: 1, variableArgs: !1 };
            a.Ts = { id: k.OPS.setTextRise, numArgs: 1, variableArgs: !1 };
            a.Td = { id: k.OPS.moveText, numArgs: 2, variableArgs: !1 };
            a.TD = { id: k.OPS.setLeadingMoveText, numArgs: 2, variableArgs: !1 };
            a.Tm = { id: k.OPS.setTextMatrix, numArgs: 6, variableArgs: !1 };
            a['T*'] = { id: k.OPS.nextLine, numArgs: 0, variableArgs: !1 };
            a.Tj = { id: k.OPS.showText, numArgs: 1, variableArgs: !1 };
            a.TJ = { id: k.OPS.showSpacedText, numArgs: 1, variableArgs: !1 };
            a["'"] = { id: k.OPS.nextLineShowText, numArgs: 1, variableArgs: !1 };
            a['"'] = { id: k.OPS.nextLineSetSpacingShowText, numArgs: 3, variableArgs: !1 };
            a.d0 = { id: k.OPS.setCharWidth, numArgs: 2, variableArgs: !1 };
            a.d1 = { id: k.OPS.setCharWidthAndBounds, numArgs: 6, variableArgs: !1 };
            a.CS = { id: k.OPS.setStrokeColorSpace, numArgs: 1, variableArgs: !1 };
            a.cs = { id: k.OPS.setFillColorSpace, numArgs: 1, variableArgs: !1 };
            a.SC = { id: k.OPS.setStrokeColor, numArgs: 4, variableArgs: !0 };
            a.SCN = { id: k.OPS.setStrokeColorN, numArgs: 33, variableArgs: !0 };
            a.sc = { id: k.OPS.setFillColor, numArgs: 4, variableArgs: !0 };
            a.scn = { id: k.OPS.setFillColorN, numArgs: 33, variableArgs: !0 };
            a.G = { id: k.OPS.setStrokeGray, numArgs: 1, variableArgs: !1 };
            a.g = { id: k.OPS.setFillGray, numArgs: 1, variableArgs: !1 };
            a.RG = { id: k.OPS.setStrokeRGBColor, numArgs: 3, variableArgs: !1 };
            a.rg = { id: k.OPS.setFillRGBColor, numArgs: 3, variableArgs: !1 };
            a.K = { id: k.OPS.setStrokeCMYKColor, numArgs: 4, variableArgs: !1 };
            a.k = { id: k.OPS.setFillCMYKColor, numArgs: 4, variableArgs: !1 };
            a.sh = { id: k.OPS.shadingFill, numArgs: 1, variableArgs: !1 };
            a.BI = { id: k.OPS.beginInlineImage, numArgs: 0, variableArgs: !1 };
            a.ID = { id: k.OPS.beginImageData, numArgs: 0, variableArgs: !1 };
            a.EI = { id: k.OPS.endInlineImage, numArgs: 1, variableArgs: !1 };
            a.Do = { id: k.OPS.paintXObject, numArgs: 1, variableArgs: !1 };
            a.MP = { id: k.OPS.markPoint, numArgs: 1, variableArgs: !1 };
            a.DP = { id: k.OPS.markPointProps, numArgs: 2, variableArgs: !1 };
            a.BMC = { id: k.OPS.beginMarkedContent, numArgs: 1, variableArgs: !1 };
            a.BDC = { id: k.OPS.beginMarkedContentProps, numArgs: 2, variableArgs: !1 };
            a.EMC = { id: k.OPS.endMarkedContent, numArgs: 0, variableArgs: !1 };
            a.BX = { id: k.OPS.beginCompat, numArgs: 0, variableArgs: !1 };
            a.EX = { id: k.OPS.endCompat, numArgs: 0, variableArgs: !1 };
            a.BM = null;
            a.BD = null;
            a['true'] = null;
            a.fa = null;
            a.fal = null;
            a.fals = null;
            a['false'] = null;
            a.nu = null;
            a.nul = null;
            a['null'] = null;
          });
          a.prototype = {
            get savedStatesDepth() {
              return this.stateManager.stateStack.length;
            },
            read: function(a) {
              for (var b = a.args; ; ) {
                var c = this.parser.getObj();
                if ((0, d.isCmd)(c)) {
                  var f = c.cmd;
                  c = this.opMap[f];
                  if (!c) {
                    (0, k.warn)('Unknown command "' + f + '"');
                    continue;
                  }
                  f = c.id;
                  var g = c.numArgs,
                    l = null !== b ? b.length : 0;
                  if (c.variableArgs)
                    l > g &&
                      (0, k.info)('Command ' + f + ': expected [0,' + g + '] args, but received ' + l + ' args.');
                  else {
                    if (l !== g) {
                      for (c = this.nonProcessedArgs; l > g; ) c.push(b.shift()), l--;
                      for (; l < g && 0 !== c.length; ) null === b && (b = []), b.unshift(c.pop()), l++;
                    }
                    if (l < g) {
                      (0, k.warn)('Skipping command ' + f + ': expected ' + g + ' args, but received ' + l + ' args.');
                      null !== b && (b.length = 0);
                      continue;
                    }
                  }
                  this.preprocessCommand(f, b);
                  a.fn = f;
                  a.args = b;
                  return !0;
                }
                if ((0, d.isEOF)(c)) return !1;
                if (null !== c && (null === b && (b = []), b.push(c), 33 < b.length))
                  throw new k.FormatError('Too many arguments');
              }
            },
            preprocessCommand: function(a, b) {
              switch (a | 0) {
                case k.OPS.save:
                  this.stateManager.save();
                  break;
                case k.OPS.restore:
                  this.stateManager.restore();
                  break;
                case k.OPS.transform:
                  this.stateManager.transform(b);
              }
            },
          };
          return a;
        })(),
        L = (function() {
          function a(a, b, d) {
            for (var c = 0, f = b.length - 1; c < f; c++) {
              var g = b[c];
              a = a[g] || (a[g] = []);
            }
            a[b[b.length - 1]] = d;
          }
          function b() {}
          var d = [];
          a(d, [k.OPS.save, k.OPS.transform, k.OPS.paintInlineImageXObject, k.OPS.restore], function(a) {
            var b = a.fnArray,
              d = a.argsArray,
              c = a.iCurr;
            a = c - 3;
            var f = c - 2;
            --c;
            for (
              var g = a + 4, l = b.length;
              g + 3 < l &&
              b[g] === k.OPS.save &&
              b[g + 1] === k.OPS.transform &&
              b[g + 2] === k.OPS.paintInlineImageXObject &&
              b[g + 3] === k.OPS.restore;

            )
              g += 4;
            l = Math.min((g - a) / 4, 200);
            if (10 > l) return g;
            var e = 0;
            g = [];
            var r = 0,
              p = 1,
              h = 1,
              q;
            for (q = 0; q < l; q++) {
              var n = d[f + (q << 2)],
                w = d[c + (q << 2)][0];
              1e3 < p + w.width && ((e = Math.max(e, p)), (h += r + 2), (r = p = 0));
              g.push({ transform: n, x: p, y: h, w: w.width, h: w.height });
              p += w.width + 2;
              r = Math.max(r, w.height);
            }
            f = Math.max(e, p) + 1;
            r = h + r + 1;
            h = new Uint8Array(f * r * 4);
            e = f << 2;
            for (q = 0; q < l; q++) {
              p = d[c + (q << 2)][0].data;
              n = g[q].w << 2;
              w = 0;
              var A = (g[q].x + g[q].y * f) << 2;
              h.set(p.subarray(0, n), A - e);
              for (var D = 0, x = g[q].h; D < x; D++) h.set(p.subarray(w, w + n), A), (w += n), (A += e);
              for (h.set(p.subarray(w - n, w), A); 0 <= A; )
                (p[A - 4] = p[A]),
                  (p[A - 3] = p[A + 1]),
                  (p[A - 2] = p[A + 2]),
                  (p[A - 1] = p[A + 3]),
                  (p[A + n] = p[A + n - 4]),
                  (p[A + n + 1] = p[A + n - 3]),
                  (p[A + n + 2] = p[A + n - 2]),
                  (p[A + n + 3] = p[A + n - 1]),
                  (A -= e);
            }
            b.splice(a, 4 * l, k.OPS.paintInlineImageXObjectGroup);
            d.splice(a, 4 * l, [{ width: f, height: r, kind: k.ImageKind.RGBA_32BPP, data: h }, g]);
            return a + 1;
          });
          a(d, [k.OPS.save, k.OPS.transform, k.OPS.paintImageMaskXObject, k.OPS.restore], function(a) {
            var b = a.fnArray,
              d = a.argsArray,
              c = a.iCurr;
            a = c - 3;
            var f = c - 2;
            --c;
            for (
              var g = a + 4, l = b.length;
              g + 3 < l &&
              b[g] === k.OPS.save &&
              b[g + 1] === k.OPS.transform &&
              b[g + 2] === k.OPS.paintImageMaskXObject &&
              b[g + 3] === k.OPS.restore;

            )
              g += 4;
            l = (g - a) / 4;
            for (var e = a + 2, r = 0; r < l; r++) {
              var p = d[e + 4 * r];
              if (
                (p = 1 === p.length && p[0]) &&
                1 === p.width &&
                1 === p.height &&
                (!p.data.length || (1 === p.data.length && 0 === p.data[0]))
              )
                b[e + 4 * r] = k.OPS.paintSolidColorImageMask;
              else break;
            }
            l -= r;
            if (10 > l) return g;
            var h = !1;
            p = d[c][0];
            if (0 === d[f][1] && 0 === d[f][2]) {
              h = !0;
              var q = d[f][0],
                n = d[f][3];
              r = f + 4;
              var w = c + 4;
              for (g = 1; g < l; g++, r += 4, w += 4)
                if (((e = d[r]), d[w][0] !== p || e[0] !== q || 0 !== e[1] || 0 !== e[2] || e[3] !== n)) {
                  10 > g ? (h = !1) : (l = g);
                  break;
                }
            }
            if (h) {
              l = Math.min(l, 1e3);
              c = new Float32Array(2 * l);
              r = f;
              for (g = 0; g < l; g++, r += 4) (e = d[r]), (c[g << 1] = e[4]), (c[(g << 1) + 1] = e[5]);
              b.splice(a, 4 * l, k.OPS.paintImageMaskXObjectRepeat);
              d.splice(a, 4 * l, [p, q, n, c]);
            } else {
              l = Math.min(l, 100);
              q = [];
              for (g = 0; g < l; g++)
                (e = d[f + (g << 2)]),
                  (n = d[c + (g << 2)][0]),
                  q.push({ data: n.data, width: n.width, height: n.height, transform: e });
              b.splice(a, 4 * l, k.OPS.paintImageMaskXObjectGroup);
              d.splice(a, 4 * l, [q]);
            }
            return a + 1;
          });
          a(d, [k.OPS.save, k.OPS.transform, k.OPS.paintImageXObject, k.OPS.restore], function(a) {
            var b = a.fnArray,
              d = a.argsArray,
              c = a.iCurr;
            a = c - 3;
            var f = c - 2;
            if (0 !== d[f][1] || 0 !== d[f][2]) return c + 1;
            c = d[c - 1][0];
            for (
              var g = d[f][0], l = d[f][3], e = a + 4, r = b.length;
              e + 3 < r &&
              b[e] === k.OPS.save &&
              b[e + 1] === k.OPS.transform &&
              b[e + 2] === k.OPS.paintImageXObject &&
              b[e + 3] === k.OPS.restore &&
              d[e + 1][0] === g &&
              0 === d[e + 1][1] &&
              0 === d[e + 1][2] &&
              d[e + 1][3] === l &&
              d[e + 2][0] === c;

            )
              e += 4;
            r = Math.min((e - a) / 4, 1e3);
            if (3 > r) return e;
            e = new Float32Array(2 * r);
            for (var p = 0; p < r; p++, f += 4) {
              var h = d[f];
              e[p << 1] = h[4];
              e[(p << 1) + 1] = h[5];
            }
            c = [c, g, l, e];
            b.splice(a, 4 * r, k.OPS.paintImageXObjectRepeat);
            d.splice(a, 4 * r, c);
            return a + 1;
          });
          a(d, [k.OPS.beginText, k.OPS.setFont, k.OPS.setTextMatrix, k.OPS.showText, k.OPS.endText], function(a) {
            var b = a.fnArray,
              d = a.argsArray,
              c = a.iCurr,
              f = c - 4,
              g = c - 3,
              l = d[g][0],
              e = d[g][1],
              r = f + 5;
            for (
              a = b.length;
              r + 4 < a &&
              b[r] === k.OPS.beginText &&
              b[r + 1] === k.OPS.setFont &&
              b[r + 2] === k.OPS.setTextMatrix &&
              b[r + 3] === k.OPS.showText &&
              b[r + 4] === k.OPS.endText &&
              d[r + 1][0] === l &&
              d[r + 1][1] === e;

            )
              r += 5;
            a = Math.min((r - f) / 5, 1e3);
            if (3 > a) return r;
            r = f;
            4 <= f &&
              b[f - 4] === b[g] &&
              b[f - 3] === b[c - 2] &&
              b[f - 2] === b[c - 1] &&
              b[f - 1] === b[c] &&
              d[f - 4][0] === l &&
              d[f - 4][1] === e &&
              (a++, (r -= 5));
            c = r + 4;
            for (f = 1; f < a; f++) b.splice(c, 3), d.splice(c, 3), (c += 2);
            return c + 1;
          });
          b.prototype = {
            optimize: function(a) {
              var b = a.fnArray;
              a = { iCurr: 0, fnArray: b, argsArray: a.argsArray };
              for (var c, f = 0, g = b.length; f < g; )
                (c = (c || d)[b[f]]),
                  'function' === typeof c ? ((a.iCurr = f), (f = c(a)), (c = void 0), (g = a.fnArray.length)) : f++;
            },
          };
          return b;
        })();
      m.OperatorList = l;
      m.PartialEvaluator = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.CFFCompiler = m.CFFPrivateDict = m.CFFTopDict = m.CFFCharset = m.CFFIndex = m.CFFStrings = m.CFFHeader = m.CFF = m.CFFParser = m.CFFStandardStrings = void 0;
      var a = t(0),
        k = t(111),
        b = t(18),
        v = '.notdef space exclam quotedbl numbersign dollar percent ampersand quoteright parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore quoteleft a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde exclamdown cent sterling fraction yen florin section currency quotesingle quotedblleft guillemotleft guilsinglleft guilsinglright fi fl endash dagger daggerdbl periodcentered paragraph bullet quotesinglbase quotedblbase quotedblright guillemotright ellipsis perthousand questiondown grave acute circumflex tilde macron breve dotaccent dieresis ring cedilla hungarumlaut ogonek caron emdash AE ordfeminine Lslash Oslash OE ordmasculine ae dotlessi lslash oslash oe germandbls onesuperior logicalnot mu trademark Eth onehalf plusminus Thorn onequarter divide brokenbar degree thorn threequarters twosuperior registered minus eth multiply threesuperior copyright Aacute Acircumflex Adieresis Agrave Aring Atilde Ccedilla Eacute Ecircumflex Edieresis Egrave Iacute Icircumflex Idieresis Igrave Ntilde Oacute Ocircumflex Odieresis Ograve Otilde Scaron Uacute Ucircumflex Udieresis Ugrave Yacute Ydieresis Zcaron aacute acircumflex adieresis agrave aring atilde ccedilla eacute ecircumflex edieresis egrave iacute icircumflex idieresis igrave ntilde oacute ocircumflex odieresis ograve otilde scaron uacute ucircumflex udieresis ugrave yacute ydieresis zcaron exclamsmall Hungarumlautsmall dollaroldstyle dollarsuperior ampersandsmall Acutesmall parenleftsuperior parenrightsuperior twodotenleader onedotenleader zerooldstyle oneoldstyle twooldstyle threeoldstyle fouroldstyle fiveoldstyle sixoldstyle sevenoldstyle eightoldstyle nineoldstyle commasuperior threequartersemdash periodsuperior questionsmall asuperior bsuperior centsuperior dsuperior esuperior isuperior lsuperior msuperior nsuperior osuperior rsuperior ssuperior tsuperior ff ffi ffl parenleftinferior parenrightinferior Circumflexsmall hyphensuperior Gravesmall Asmall Bsmall Csmall Dsmall Esmall Fsmall Gsmall Hsmall Ismall Jsmall Ksmall Lsmall Msmall Nsmall Osmall Psmall Qsmall Rsmall Ssmall Tsmall Usmall Vsmall Wsmall Xsmall Ysmall Zsmall colonmonetary onefitted rupiah Tildesmall exclamdownsmall centoldstyle Lslashsmall Scaronsmall Zcaronsmall Dieresissmall Brevesmall Caronsmall Dotaccentsmall Macronsmall figuredash hypheninferior Ogoneksmall Ringsmall Cedillasmall questiondownsmall oneeighth threeeighths fiveeighths seveneighths onethird twothirds zerosuperior foursuperior fivesuperior sixsuperior sevensuperior eightsuperior ninesuperior zeroinferior oneinferior twoinferior threeinferior fourinferior fiveinferior sixinferior seveninferior eightinferior nineinferior centinferior dollarinferior periodinferior commainferior Agravesmall Aacutesmall Acircumflexsmall Atildesmall Adieresissmall Aringsmall AEsmall Ccedillasmall Egravesmall Eacutesmall Ecircumflexsmall Edieresissmall Igravesmall Iacutesmall Icircumflexsmall Idieresissmall Ethsmall Ntildesmall Ogravesmall Oacutesmall Ocircumflexsmall Otildesmall Odieresissmall OEsmall Oslashsmall Ugravesmall Uacutesmall Ucircumflexsmall Udieresissmall Yacutesmall Thornsmall Ydieresissmall 001.000 001.001 001.002 001.003 Black Bold Book Light Medium Regular Roman Semibold'.split(
          ' ',
        );
      y = (function() {
        function q(a, b, d) {
          this.bytes = a.getBytes();
          this.properties = b;
          this.seacAnalysisEnabled = !!d;
        }
        var g = [
            null,
            { id: 'hstem', min: 2, stackClearing: !0, stem: !0 },
            null,
            { id: 'vstem', min: 2, stackClearing: !0, stem: !0 },
            { id: 'vmoveto', min: 1, stackClearing: !0 },
            { id: 'rlineto', min: 2, resetStack: !0 },
            { id: 'hlineto', min: 1, resetStack: !0 },
            { id: 'vlineto', min: 1, resetStack: !0 },
            { id: 'rrcurveto', min: 6, resetStack: !0 },
            null,
            { id: 'callsubr', min: 1, undefStack: !0 },
            { id: 'return', min: 0, undefStack: !0 },
            null,
            null,
            { id: 'endchar', min: 0, stackClearing: !0 },
            null,
            null,
            null,
            { id: 'hstemhm', min: 2, stackClearing: !0, stem: !0 },
            { id: 'hintmask', min: 0, stackClearing: !0 },
            { id: 'cntrmask', min: 0, stackClearing: !0 },
            { id: 'rmoveto', min: 2, stackClearing: !0 },
            { id: 'hmoveto', min: 1, stackClearing: !0 },
            { id: 'vstemhm', min: 2, stackClearing: !0, stem: !0 },
            { id: 'rcurveline', min: 8, resetStack: !0 },
            { id: 'rlinecurve', min: 8, resetStack: !0 },
            { id: 'vvcurveto', min: 4, resetStack: !0 },
            { id: 'hhcurveto', min: 4, resetStack: !0 },
            null,
            { id: 'callgsubr', min: 1, undefStack: !0 },
            { id: 'vhcurveto', min: 4, resetStack: !0 },
            { id: 'hvcurveto', min: 4, resetStack: !0 },
          ],
          m = [
            null,
            null,
            null,
            { id: 'and', min: 2, stackDelta: -1 },
            { id: 'or', min: 2, stackDelta: -1 },
            { id: 'not', min: 1, stackDelta: 0 },
            null,
            null,
            null,
            { id: 'abs', min: 1, stackDelta: 0 },
            {
              id: 'add',
              min: 2,
              stackDelta: -1,
              stackFn: function(a, b) {
                a[b - 2] += a[b - 1];
              },
            },
            {
              id: 'sub',
              min: 2,
              stackDelta: -1,
              stackFn: function(a, b) {
                a[b - 2] -= a[b - 1];
              },
            },
            {
              id: 'div',
              min: 2,
              stackDelta: -1,
              stackFn: function(a, b) {
                a[b - 2] /= a[b - 1];
              },
            },
            null,
            {
              id: 'neg',
              min: 1,
              stackDelta: 0,
              stackFn: function(a, b) {
                a[b - 1] = -a[b - 1];
              },
            },
            { id: 'eq', min: 2, stackDelta: -1 },
            null,
            null,
            { id: 'drop', min: 1, stackDelta: -1 },
            null,
            { id: 'put', min: 2, stackDelta: -2 },
            { id: 'get', min: 1, stackDelta: 0 },
            { id: 'ifelse', min: 4, stackDelta: -3 },
            { id: 'random', min: 0, stackDelta: 1 },
            {
              id: 'mul',
              min: 2,
              stackDelta: -1,
              stackFn: function(a, b) {
                a[b - 2] *= a[b - 1];
              },
            },
            null,
            { id: 'sqrt', min: 1, stackDelta: 0 },
            { id: 'dup', min: 1, stackDelta: 1 },
            { id: 'exch', min: 2, stackDelta: 0 },
            { id: 'index', min: 2, stackDelta: 0 },
            { id: 'roll', min: 3, stackDelta: -2 },
            null,
            null,
            null,
            { id: 'hflex', min: 7, resetStack: !0 },
            { id: 'flex', min: 13, resetStack: !0 },
            { id: 'hflex1', min: 9, resetStack: !0 },
            { id: 'flex1', min: 11, resetStack: !0 },
          ];
        q.prototype = {
          parse: function() {
            var a = this.properties,
              b = new d();
            this.cff = b;
            var c = this.parseHeader(),
              g = this.parseIndex(c.endPos),
              e = this.parseIndex(g.endPos),
              p = this.parseIndex(e.endPos),
              h = this.parseIndex(p.endPos);
            e = this.parseDict(e.obj.get(0));
            e = this.createDict(n, e, b.strings);
            b.header = c.obj;
            b.names = this.parseNameIndex(g.obj);
            b.strings = this.parseStringIndex(p.obj);
            b.topDict = e;
            b.globalSubrIndex = h.obj;
            this.parsePrivateDict(b.topDict);
            b.isCIDFont = e.hasName('ROS');
            c = e.getByName('CharStrings');
            c = this.parseIndex(c).obj;
            if ((g = e.getByName('FontMatrix'))) a.fontMatrix = g;
            if ((g = e.getByName('FontBBox')))
              (a.ascent = Math.max(g[3], g[1])), (a.descent = Math.min(g[1], g[3])), (a.ascentScaled = !0);
            if (b.isCIDFont) {
              a = this.parseIndex(e.getByName('FDArray')).obj;
              g = 0;
              for (p = a.count; g < p; ++g) {
                var q = a.get(g);
                q = this.createDict(n, this.parseDict(q), b.strings);
                this.parsePrivateDict(q);
                b.fdArray.push(q);
              }
              a = null;
              g = this.parseCharsets(e.getByName('charset'), c.count, b.strings, !0);
              b.fdSelect = this.parseFDSelect(e.getByName('FDSelect'), c.count);
            } else
              (g = this.parseCharsets(e.getByName('charset'), c.count, b.strings, !1)),
                (a = this.parseEncoding(e.getByName('Encoding'), a, b.strings, g.charset));
            b.charset = g;
            b.encoding = a;
            h = this.parseCharStrings({
              charStrings: c,
              localSubrIndex: e.privateDict.subrsIndex,
              globalSubrIndex: h.obj,
              fdSelect: b.fdSelect,
              fdArray: b.fdArray,
              privateDict: e.privateDict,
            });
            b.charStrings = h.charStrings;
            b.seacs = h.seacs;
            b.widths = h.widths;
            return b;
          },
          parseHeader: function() {
            for (var b = this.bytes, d = b.length, c = 0; c < d && 1 !== b[c]; ) ++c;
            if (c >= d) throw new a.FormatError('Invalid CFF header');
            0 !== c && ((0, a.info)('cff data is shifted'), (this.bytes = b = b.subarray(c)));
            d = b[2];
            return { obj: new u(b[0], b[1], d, b[3]), endPos: d };
          },
          parseDict: function(b) {
            function d() {
              var d = b[c++];
              if (30 === d) {
                d = '';
                for (
                  var f = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'], g = b.length;
                  c < g;

                ) {
                  var e = b[c++],
                    l = e >> 4;
                  e &= 15;
                  if (15 === l) break;
                  d += f[l];
                  if (15 === e) break;
                  d += f[e];
                }
                return parseFloat(d);
              }
              if (28 === d) return (d = b[c++]), (d = ((d << 24) | (b[c++] << 16)) >> 16);
              if (29 === d)
                return (d = b[c++]), (d = (d << 8) | b[c++]), (d = (d << 8) | b[c++]), (d = (d << 8) | b[c++]);
              if (32 <= d && 246 >= d) return d - 139;
              if (247 <= d && 250 >= d) return 256 * (d - 247) + b[c++] + 108;
              if (251 <= d && 254 >= d) return -(256 * (d - 251)) - b[c++] - 108;
              (0, a.warn)('CFFParser_parseDict: "' + d + '" is a reserved command.');
              return NaN;
            }
            var c = 0,
              g = [],
              e = [];
            c = 0;
            for (var l = b.length; c < l; ) {
              var p = b[c];
              21 >= p ? (12 === p && (p = (p << 8) | b[++c]), e.push([p, g]), (g = []), ++c) : g.push(d());
            }
            return e;
          },
          parseIndex: function(a) {
            var b = new C(),
              d = this.bytes,
              c = (d[a++] << 8) | d[a++],
              g = [],
              e = a,
              l;
            if (0 !== c) {
              e = d[a++];
              var p = a + (c + 1) * e - 1;
              var h = 0;
              for (l = c + 1; h < l; ++h) {
                for (var q = 0, n = 0; n < e; ++n) (q <<= 8), (q += d[a++]);
                g.push(p + q);
              }
              e = g[c];
            }
            h = 0;
            for (l = g.length - 1; h < l; ++h) b.add(d.subarray(g[h], g[h + 1]));
            return { obj: b, endPos: e };
          },
          parseNameIndex: function(b) {
            for (var d = [], c = 0, g = b.count; c < g; ++c) {
              for (var e = b.get(c), l = Math.min(e.length, 127), p = [], h = 0; h < l; ++h) {
                var q = e[h];
                p[h] =
                  0 === h && 0 === q
                    ? q
                    : 33 > q ||
                      126 < q ||
                      91 === q ||
                      93 === q ||
                      40 === q ||
                      41 === q ||
                      123 === q ||
                      125 === q ||
                      60 === q ||
                      62 === q ||
                      47 === q ||
                      37 === q ||
                      35 === q
                    ? 95
                    : q;
              }
              d.push((0, a.bytesToString)(p));
            }
            return d;
          },
          parseStringIndex: function(b) {
            for (var d = new z(), c = 0, g = b.count; c < g; ++c) {
              var e = b.get(c);
              d.add((0, a.bytesToString)(e));
            }
            return d;
          },
          createDict: function(a, b, d) {
            a = new a(d);
            d = 0;
            for (var c = b.length; d < c; ++d) {
              var g = b[d];
              a.setByKey(g[0], g[1]);
            }
            return a;
          },
          parseCharString: function(b, d, c, e) {
            if (!d || 10 < b.callDepth) return !1;
            for (var f = b.stackSize, l = b.stack, r = d.length, p = 0; p < r; ) {
              var h = d[p++],
                q = null;
              if (12 === h) (h = d[p++]), 0 === h ? ((d[p - 2] = 139), (d[p - 1] = 22), (f = 0)) : (q = m[h]);
              else if (28 === h) (l[f] = ((d[p] << 24) | (d[p + 1] << 16)) >> 16), (p += 2), f++;
              else if (14 === h) {
                if (4 <= f && ((f -= 4), this.seacAnalysisEnabled)) return (b.seac = l.slice(f, f + 4)), !1;
                q = g[h];
              } else if (32 <= h && 246 >= h) (l[f] = h - 139), f++;
              else if (247 <= h && 254 >= h)
                (l[f] = 251 > h ? ((h - 247) << 8) + d[p] + 108 : -((h - 251) << 8) - d[p] - 108), p++, f++;
              else if (255 === h)
                (l[f] = ((d[p] << 24) | (d[p + 1] << 16) | (d[p + 2] << 8) | d[p + 3]) / 65536), (p += 4), f++;
              else if (19 === h || 20 === h) (b.hints += f >> 1), (p += (b.hints + 7) >> 3), (f %= 2), (q = g[h]);
              else if (10 === h || 29 === h) {
                q = 10 === h ? c : e;
                if (!q) return (q = g[h]), (0, a.warn)('Missing subrsIndex for ' + q.id), !1;
                var n = 32768;
                1240 > q.count ? (n = 107) : 33900 > q.count && (n = 1131);
                n = l[--f] + n;
                if (0 > n || n >= q.count || isNaN(n))
                  return (q = g[h]), (0, a.warn)('Out of bounds subrIndex for ' + q.id), !1;
                b.stackSize = f;
                b.callDepth++;
                if (!this.parseCharString(b, q.get(n), c, e)) return !1;
                b.callDepth--;
                f = b.stackSize;
                continue;
              } else {
                if (11 === h) return (b.stackSize = f), !0;
                q = g[h];
              }
              if (q) {
                q.stem && (b.hints += f >> 1);
                if ('min' in q && !b.undefStack && f < q.min)
                  return (
                    (0, a.warn)('Not enough parameters for ' + q.id + '; actual: ' + f + ', expected: ' + q.min), !1
                  );
                b.firstStackClearing &&
                  q.stackClearing &&
                  ((b.firstStackClearing = !1),
                  (f -= q.min),
                  2 <= f && q.stem
                    ? (f %= 2)
                    : 1 < f && (0, a.warn)('Found too many parameters for stack-clearing command'),
                  0 < f && 0 <= l[f - 1] && (b.width = l[f - 1]));
                'stackDelta' in q
                  ? ('stackFn' in q && q.stackFn(l, f), (f += q.stackDelta))
                  : q.stackClearing
                  ? (f = 0)
                  : q.resetStack
                  ? ((f = 0), (b.undefStack = !1))
                  : q.undefStack && ((f = 0), (b.undefStack = !0), (b.firstStackClearing = !1));
              }
            }
            b.stackSize = f;
            return !0;
          },
          parseCharStrings: function(b) {
            var d = b.charStrings,
              c = b.localSubrIndex,
              g = b.globalSubrIndex,
              e = b.fdSelect,
              l = b.fdArray;
            b = b.privateDict;
            for (var p = [], h = [], q = d.count, n = 0; n < q; n++) {
              var k = d.get(n),
                A = {
                  callDepth: 0,
                  stackSize: 0,
                  stack: [],
                  undefStack: !0,
                  hints: 0,
                  firstStackClearing: !0,
                  seac: null,
                  width: null,
                },
                x = !0,
                m = null,
                u = b;
              if (e && l.length) {
                var B = e.getFDIndex(n);
                -1 === B && ((0, a.warn)('Glyph index is not in fd select.'), (x = !1));
                B >= l.length && ((0, a.warn)('Invalid fd index for glyph index.'), (x = !1));
                x && ((u = l[B].privateDict), (m = u.subrsIndex));
              } else c && (m = c);
              x && (x = this.parseCharString(A, k, m, g));
              null !== A.width
                ? ((k = u.getByName('nominalWidthX')), (h[n] = k + A.width))
                : ((k = u.getByName('defaultWidthX')), (h[n] = k));
              null !== A.seac && (p[n] = A.seac);
              x || d.set(n, new Uint8Array([14]));
            }
            return { charStrings: d, seacs: p, widths: h };
          },
          emptyPrivateDictionary: function(a) {
            var b = this.createDict(e, [], a.strings);
            a.setByKey(18, [0, 0]);
            a.privateDict = b;
          },
          parsePrivateDict: function(a) {
            if (a.hasName('Private')) {
              var b = a.getByName('Private');
              if (Array.isArray(b) && 2 === b.length) {
                var d = b[0];
                b = b[1];
                if (0 === d || b >= this.bytes.length) this.emptyPrivateDictionary(a);
                else if (
                  ((d = this.bytes.subarray(b, b + d)),
                  (d = this.parseDict(d)),
                  (d = this.createDict(e, d, a.strings)),
                  (a.privateDict = d),
                  d.getByName('Subrs'))
                ) {
                  var c = d.getByName('Subrs');
                  b += c;
                  0 === c || b >= this.bytes.length
                    ? this.emptyPrivateDictionary(a)
                    : ((a = this.parseIndex(b)), (d.subrsIndex = a.obj));
                }
              } else a.removeByName('Private');
            } else this.emptyPrivateDictionary(a);
          },
          parseCharsets: function(b, d, c, g) {
            if (0 === b) return new p(!0, h.ISO_ADOBE, k.ISOAdobeCharset);
            if (1 === b) return new p(!0, h.EXPERT, k.ExpertCharset);
            if (2 === b) return new p(!0, h.EXPERT_SUBSET, k.ExpertSubsetCharset);
            var f = this.bytes,
              e = b,
              l = f[b++],
              r = ['.notdef'],
              q;
            --d;
            switch (l) {
              case 0:
                for (q = 0; q < d; q++) {
                  var n = (f[b++] << 8) | f[b++];
                  r.push(g ? n : c.get(n));
                }
                break;
              case 1:
                for (; r.length <= d; ) {
                  n = (f[b++] << 8) | f[b++];
                  var A = f[b++];
                  for (q = 0; q <= A; q++) r.push(g ? n++ : c.get(n++));
                }
                break;
              case 2:
                for (; r.length <= d; )
                  for (n = (f[b++] << 8) | f[b++], A = (f[b++] << 8) | f[b++], q = 0; q <= A; q++)
                    r.push(g ? n++ : c.get(n++));
                break;
              default:
                throw new a.FormatError('Unknown charset format');
            }
            b = f.subarray(e, b);
            return new p(!1, l, r, b);
          },
          parseEncoding: function(d, c, f, g) {
            c = Object.create(null);
            var e = this.bytes,
              l = !1,
              p,
              r = null;
            if (0 === d || 1 === d) {
              l = !0;
              f = (p = d) ? b.ExpertEncoding : b.StandardEncoding;
              var h = 0;
              for (d = g.length; h < d; h++) (e = f.indexOf(g[h])), -1 !== e && (c[e] = h);
            } else {
              r = d;
              p = e[d++];
              switch (p & 127) {
                case 0:
                  var q = e[d++];
                  for (h = 1; h <= q; h++) c[e[d++]] = h;
                  break;
                case 1:
                  q = e[d++];
                  var n = 1;
                  for (h = 0; h < q; h++) for (var k = e[d++], x = e[d++], m = k; m <= k + x; m++) c[m] = n++;
                  break;
                default:
                  throw new a.FormatError('Unknown encoding format: ' + p + ' in CFF');
              }
              q = d;
              if (p & 128)
                for (e[r] &= 127, n = e[d++], h = 0; h < n; h++)
                  (k = e[d++]), (x = (e[d++] << 8) + (e[d++] & 255)), (c[k] = g.indexOf(f.get(x)));
              r = e.subarray(r, q);
            }
            return new A(l, p & 127, c, r);
          },
          parseFDSelect: function(b, d) {
            var f = b,
              g = this.bytes,
              e = g[b++],
              l = [],
              p = !1;
            switch (e) {
              case 0:
                for (e = 0; e < d; ++e) (p = g[b++]), l.push(p);
                f = g.subarray(f, b);
                break;
              case 3:
                var h = (g[b++] << 8) | g[b++];
                for (e = 0; e < h; ++e) {
                  var q = (g[b++] << 8) | g[b++];
                  0 === e &&
                    0 !== q &&
                    ((0, a.warn)('parseFDSelect: The first range must have a first GID of 0 -- trying to recover.'),
                    (p = !0),
                    (q = 0));
                  for (var n = g[b++], k = (g[b] << 8) | g[b + 1]; q < k; ++q) l.push(n);
                }
                f = g.subarray(f, b + 2);
                p && (f[3] = f[4] = 0);
                break;
              default:
                throw new a.FormatError('parseFDSelect: Unknown format "' + e + '".');
            }
            if (l.length !== d) throw new a.FormatError('parseFDSelect: Invalid font data.');
            return new c(l, f);
          },
        };
        return q;
      })();
      var d = (function() {
          return function() {
            this.header = null;
            this.names = [];
            this.topDict = null;
            this.strings = new z();
            this.charStrings = this.charset = this.encoding = this.globalSubrIndex = null;
            this.fdArray = [];
            this.fdSelect = null;
            this.isCIDFont = !1;
          };
        })(),
        u = (function() {
          return function(a, b, d, c) {
            this.major = a;
            this.minor = b;
            this.hdrSize = d;
            this.offSize = c;
          };
        })(),
        z = (function() {
          function a() {
            this.strings = [];
          }
          a.prototype = {
            get: function(a) {
              return 0 <= a && 390 >= a ? v[a] : a - 391 <= this.strings.length ? this.strings[a - 391] : v[0];
            },
            add: function(a) {
              this.strings.push(a);
            },
            get count() {
              return this.strings.length;
            },
          };
          return a;
        })(),
        C = (function() {
          function a() {
            this.objects = [];
            this.length = 0;
          }
          a.prototype = {
            add: function(a) {
              this.length += a.length;
              this.objects.push(a);
            },
            set: function(a, b) {
              this.length += b.length - this.objects[a].length;
              this.objects[a] = b;
            },
            get: function(a) {
              return this.objects[a];
            },
            get count() {
              return this.objects.length;
            },
          };
          return a;
        })(),
        B = (function() {
          function b(a, b) {
            this.keyToNameMap = a.keyToNameMap;
            this.nameToKeyMap = a.nameToKeyMap;
            this.defaults = a.defaults;
            this.types = a.types;
            this.opcodes = a.opcodes;
            this.order = a.order;
            this.strings = b;
            this.values = Object.create(null);
          }
          b.prototype = {
            setByKey: function(b, d) {
              if (!(b in this.keyToNameMap)) return !1;
              var c = d.length;
              if (0 === c) return !0;
              for (var g = 0; g < c; g++)
                if (isNaN(d[g])) return (0, a.warn)('Invalid CFFDict value: "' + d + '" for key "' + b + '".'), !0;
              c = this.types[b];
              if ('num' === c || 'sid' === c || 'offset' === c) d = d[0];
              this.values[b] = d;
              return !0;
            },
            setByName: function(b, d) {
              if (!(b in this.nameToKeyMap)) throw new a.FormatError('Invalid dictionary name "' + b + '"');
              this.values[this.nameToKeyMap[b]] = d;
            },
            hasName: function(a) {
              return this.nameToKeyMap[a] in this.values;
            },
            getByName: function(b) {
              if (!(b in this.nameToKeyMap)) throw new a.FormatError('Invalid dictionary name ' + b + '"');
              b = this.nameToKeyMap[b];
              return b in this.values ? this.values[b] : this.defaults[b];
            },
            removeByName: function(a) {
              delete this.values[this.nameToKeyMap[a]];
            },
          };
          b.createTables = function(a) {
            for (
              var b = { keyToNameMap: {}, nameToKeyMap: {}, defaults: {}, types: {}, opcodes: {}, order: [] },
                d = 0,
                c = a.length;
              d < c;
              ++d
            ) {
              var f = a[d],
                g = Array.isArray(f[0]) ? (f[0][0] << 8) + f[0][1] : f[0];
              b.keyToNameMap[g] = f[1];
              b.nameToKeyMap[f[1]] = g;
              b.types[g] = f[2];
              b.defaults[g] = f[3];
              b.opcodes[g] = Array.isArray(f[0]) ? f[0] : [f[0]];
              b.order.push(g);
            }
            return b;
          };
          return b;
        })(),
        n = (function() {
          function a(a) {
            null === d && (d = B.createTables(b));
            B.call(this, d, a);
            this.privateDict = null;
          }
          var b = [
              [[12, 30], 'ROS', ['sid', 'sid', 'num'], null],
              [[12, 20], 'SyntheticBase', 'num', null],
              [0, 'version', 'sid', null],
              [1, 'Notice', 'sid', null],
              [[12, 0], 'Copyright', 'sid', null],
              [2, 'FullName', 'sid', null],
              [3, 'FamilyName', 'sid', null],
              [4, 'Weight', 'sid', null],
              [[12, 1], 'isFixedPitch', 'num', 0],
              [[12, 2], 'ItalicAngle', 'num', 0],
              [[12, 3], 'UnderlinePosition', 'num', -100],
              [[12, 4], 'UnderlineThickness', 'num', 50],
              [[12, 5], 'PaintType', 'num', 0],
              [[12, 6], 'CharstringType', 'num', 2],
              [[12, 7], 'FontMatrix', 'num num num num num num'.split(' '), [0.001, 0, 0, 0.001, 0, 0]],
              [13, 'UniqueID', 'num', null],
              [5, 'FontBBox', ['num', 'num', 'num', 'num'], [0, 0, 0, 0]],
              [[12, 8], 'StrokeWidth', 'num', 0],
              [14, 'XUID', 'array', null],
              [15, 'charset', 'offset', 0],
              [16, 'Encoding', 'offset', 0],
              [17, 'CharStrings', 'offset', 0],
              [18, 'Private', ['offset', 'offset'], null],
              [[12, 21], 'PostScript', 'sid', null],
              [[12, 22], 'BaseFontName', 'sid', null],
              [[12, 23], 'BaseFontBlend', 'delta', null],
              [[12, 31], 'CIDFontVersion', 'num', 0],
              [[12, 32], 'CIDFontRevision', 'num', 0],
              [[12, 33], 'CIDFontType', 'num', 0],
              [[12, 34], 'CIDCount', 'num', 8720],
              [[12, 35], 'UIDBase', 'num', null],
              [[12, 37], 'FDSelect', 'offset', null],
              [[12, 36], 'FDArray', 'offset', null],
              [[12, 38], 'FontName', 'sid', null],
            ],
            d = null;
          a.prototype = Object.create(B.prototype);
          return a;
        })(),
        e = (function() {
          function a(a) {
            null === d && (d = B.createTables(b));
            B.call(this, d, a);
            this.subrsIndex = null;
          }
          var b = [
              [6, 'BlueValues', 'delta', null],
              [7, 'OtherBlues', 'delta', null],
              [8, 'FamilyBlues', 'delta', null],
              [9, 'FamilyOtherBlues', 'delta', null],
              [[12, 9], 'BlueScale', 'num', 0.039625],
              [[12, 10], 'BlueShift', 'num', 7],
              [[12, 11], 'BlueFuzz', 'num', 1],
              [10, 'StdHW', 'num', null],
              [11, 'StdVW', 'num', null],
              [[12, 12], 'StemSnapH', 'delta', null],
              [[12, 13], 'StemSnapV', 'delta', null],
              [[12, 14], 'ForceBold', 'num', 0],
              [[12, 17], 'LanguageGroup', 'num', 0],
              [[12, 18], 'ExpansionFactor', 'num', 0.06],
              [[12, 19], 'initialRandomSeed', 'num', 0],
              [20, 'defaultWidthX', 'num', 0],
              [21, 'nominalWidthX', 'num', 0],
              [19, 'Subrs', 'offset', null],
            ],
            d = null;
          a.prototype = Object.create(B.prototype);
          return a;
        })(),
        h = { ISO_ADOBE: 0, EXPERT: 1, EXPERT_SUBSET: 2 },
        p = (function() {
          return function(a, b, d, c) {
            this.predefined = a;
            this.format = b;
            this.charset = d;
            this.raw = c;
          };
        })(),
        A = (function() {
          return function(a, b, d, c) {
            this.predefined = a;
            this.format = b;
            this.encoding = d;
            this.raw = c;
          };
        })(),
        c = (function() {
          function a(a, b) {
            this.fdSelect = a;
            this.raw = b;
          }
          a.prototype = {
            getFDIndex: function(a) {
              return 0 > a || a >= this.fdSelect.length ? -1 : this.fdSelect[a];
            },
          };
          return a;
        })(),
        q = (function() {
          function b() {
            this.offsets = Object.create(null);
          }
          b.prototype = {
            isTracking: function(a) {
              return a in this.offsets;
            },
            track: function(b, d) {
              if (b in this.offsets) throw new a.FormatError('Already tracking location of ' + b);
              this.offsets[b] = d;
            },
            offset: function(a) {
              for (var b in this.offsets) this.offsets[b] += a;
            },
            setEntryLocation: function(b, d, c) {
              if (!(b in this.offsets)) throw new a.FormatError('Not tracking location of ' + b);
              c = c.data;
              b = this.offsets[b];
              for (var g = 0, f = d.length; g < f; ++g) {
                var e = 5 * g + b,
                  l = e + 1,
                  p = e + 2,
                  h = e + 3,
                  q = e + 4;
                if (29 !== c[e] || 0 !== c[l] || 0 !== c[p] || 0 !== c[h] || 0 !== c[q])
                  throw new a.FormatError('writing to an offset that is not empty');
                var n = d[g];
                c[e] = 29;
                c[l] = (n >> 24) & 255;
                c[p] = (n >> 16) & 255;
                c[h] = (n >> 8) & 255;
                c[q] = n & 255;
              }
            },
          };
          return b;
        })();
      t = (function() {
        function b(a) {
          this.cff = a;
        }
        b.prototype = {
          compile: function() {
            var b = this.cff,
              d = {
                data: [],
                length: 0,
                add: function(a) {
                  this.data = this.data.concat(a);
                  this.length = this.data.length;
                },
              },
              c = this.compileHeader(b.header);
            d.add(c);
            c = this.compileNameIndex(b.names);
            d.add(c);
            if (b.isCIDFont && b.topDict.hasName('FontMatrix')) {
              c = b.topDict.getByName('FontMatrix');
              b.topDict.removeByName('FontMatrix');
              for (var e = 0, f = b.fdArray.length; e < f; e++) {
                var p = b.fdArray[e],
                  h = c.slice(0);
                p.hasName('FontMatrix') && (h = a.Util.transform(h, p.getByName('FontMatrix')));
                p.setByName('FontMatrix', h);
              }
            }
            e = this.compileTopDicts([b.topDict], d.length, b.isCIDFont);
            d.add(e.output);
            c = e.trackers[0];
            e = this.compileStringIndex(b.strings.strings);
            d.add(e);
            e = this.compileIndex(b.globalSubrIndex);
            d.add(e);
            b.encoding &&
              b.topDict.hasName('Encoding') &&
              (b.encoding.predefined
                ? c.setEntryLocation('Encoding', [b.encoding.format], d)
                : ((e = this.compileEncoding(b.encoding)), c.setEntryLocation('Encoding', [d.length], d), d.add(e)));
            b.charset &&
              b.topDict.hasName('charset') &&
              (b.charset.predefined
                ? c.setEntryLocation('charset', [b.charset.format], d)
                : ((e = this.compileCharset(b.charset)), c.setEntryLocation('charset', [d.length], d), d.add(e)));
            e = this.compileCharStrings(b.charStrings);
            c.setEntryLocation('CharStrings', [d.length], d);
            d.add(e);
            b.isCIDFont &&
              (c.setEntryLocation('FDSelect', [d.length], d),
              (e = this.compileFDSelect(b.fdSelect.raw)),
              d.add(e),
              (e = this.compileTopDicts(b.fdArray, d.length, !0)),
              c.setEntryLocation('FDArray', [d.length], d),
              d.add(e.output),
              this.compilePrivateDicts(b.fdArray, e.trackers, d));
            this.compilePrivateDicts([b.topDict], [c], d);
            d.add([0]);
            return d.data;
          },
          encodeNumber: function(a) {
            return parseFloat(a) !== parseInt(a, 10) || isNaN(a) ? this.encodeFloat(a) : this.encodeInteger(a);
          },
          encodeFloat: function(a) {
            var b = a.toString(),
              d = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(b);
            d &&
              ((b = parseFloat('1e' + ((d[2] ? +d[2] : 0) + d[1].length))), (b = (Math.round(a * b) / b).toString()));
            a = '';
            var c;
            d = 0;
            for (c = b.length; d < c; ++d) {
              var f = b[d];
              a = 'e' === f ? a + ('-' === b[++d] ? 'c' : 'b') : '.' === f ? a + 'a' : '-' === f ? a + 'e' : a + f;
            }
            a += a.length & 1 ? 'f' : 'ff';
            b = [30];
            d = 0;
            for (c = a.length; d < c; d += 2) b.push(parseInt(a.substr(d, 2), 16));
            return b;
          },
          encodeInteger: function(a) {
            -107 <= a && 107 >= a
              ? (a = [a + 139])
              : 108 <= a && 1131 >= a
              ? ((a -= 108), (a = [(a >> 8) + 247, a & 255]))
              : -1131 <= a && -108 >= a
              ? ((a = -a - 108), (a = [(a >> 8) + 251, a & 255]))
              : (a =
                  -32768 <= a && 32767 >= a
                    ? [28, (a >> 8) & 255, a & 255]
                    : [29, (a >> 24) & 255, (a >> 16) & 255, (a >> 8) & 255, a & 255]);
            return a;
          },
          compileHeader: function(a) {
            return [a.major, a.minor, a.hdrSize, a.offSize];
          },
          compileNameIndex: function(b) {
            for (var d = new C(), c = 0, e = b.length; c < e; ++c) d.add((0, a.stringToBytes)(b[c]));
            return this.compileIndex(d);
          },
          compileTopDicts: function(a, b, d) {
            for (var c = [], f = new C(), e = 0, g = a.length; e < g; ++e) {
              var p = a[e];
              d &&
                (p.removeByName('CIDFontVersion'),
                p.removeByName('CIDFontRevision'),
                p.removeByName('CIDFontType'),
                p.removeByName('CIDCount'),
                p.removeByName('UIDBase'));
              var l = new q();
              p = this.compileDict(p, l);
              c.push(l);
              f.add(p);
              l.offset(b);
            }
            f = this.compileIndex(f, c);
            return { trackers: c, output: f };
          },
          compilePrivateDicts: function(b, d, c) {
            for (var e = 0, f = b.length; e < f; ++e) {
              var g = b[e],
                p = g.privateDict;
              if (!p || !g.hasName('Private')) throw new a.FormatError('There must be a private dictionary.');
              g = new q();
              var l = this.compileDict(p, g),
                h = c.length;
              g.offset(h);
              l.length || (h = 0);
              d[e].setEntryLocation('Private', [l.length, h], c);
              c.add(l);
              p.subrsIndex &&
                p.hasName('Subrs') &&
                ((p = this.compileIndex(p.subrsIndex)), g.setEntryLocation('Subrs', [l.length], c), c.add(p));
            }
          },
          compileDict: function(b, d) {
            for (var c = [], e = b.order, f = 0; f < e.length; ++f) {
              var g = e[f];
              if (g in b.values) {
                var p = b.values[g],
                  h = b.types[g];
                Array.isArray(h) || (h = [h]);
                Array.isArray(p) || (p = [p]);
                if (0 !== p.length) {
                  for (var q = 0, n = h.length; q < n; ++q) {
                    var k = h[q],
                      A = p[q];
                    switch (k) {
                      case 'num':
                      case 'sid':
                        c = c.concat(this.encodeNumber(A));
                        break;
                      case 'offset':
                        k = b.keyToNameMap[g];
                        d.isTracking(k) || d.track(k, c.length);
                        c = c.concat([29, 0, 0, 0, 0]);
                        break;
                      case 'array':
                      case 'delta':
                        c = c.concat(this.encodeNumber(A));
                        k = 1;
                        for (A = p.length; k < A; ++k) c = c.concat(this.encodeNumber(p[k]));
                        break;
                      default:
                        throw new a.FormatError('Unknown data type of ' + k);
                    }
                  }
                  c = c.concat(b.opcodes[g]);
                }
              }
            }
            return c;
          },
          compileStringIndex: function(b) {
            for (var d = new C(), c = 0, e = b.length; c < e; ++c) d.add((0, a.stringToBytes)(b[c]));
            return this.compileIndex(d);
          },
          compileGlobalSubrIndex: function() {
            this.out.writeByteArray(this.compileIndex(this.cff.globalSubrIndex));
          },
          compileCharStrings: function(a) {
            return this.compileIndex(a);
          },
          compileCharset: function(a) {
            return this.compileTypedArray(a.raw);
          },
          compileEncoding: function(a) {
            return this.compileTypedArray(a.raw);
          },
          compileFDSelect: function(a) {
            return this.compileTypedArray(a);
          },
          compileTypedArray: function(a) {
            for (var b = [], d = 0, c = a.length; d < c; ++d) b[d] = a[d];
            return b;
          },
          compileIndex: function(a, b) {
            b = b || [];
            var d = a.objects,
              c = d.length;
            if (0 === c) return [0, 0, 0];
            var f = [(c >> 8) & 255, c & 255],
              e = 1,
              g;
            for (g = 0; g < c; ++g) e += d[g].length;
            e = 256 > e ? 1 : 65536 > e ? 2 : 16777216 > e ? 3 : 4;
            f.push(e);
            var p = 1;
            for (g = 0; g < c + 1; g++)
              1 === e
                ? f.push(p & 255)
                : 2 === e
                ? f.push((p >> 8) & 255, p & 255)
                : 3 === e
                ? f.push((p >> 16) & 255, (p >> 8) & 255, p & 255)
                : f.push((p >>> 24) & 255, (p >> 16) & 255, (p >> 8) & 255, p & 255),
                d[g] && (p += d[g].length);
            for (g = 0; g < c; g++)
              for (b[g] && b[g].offset(f.length), e = 0, p = d[g].length; e < p; e++) f.push(d[g][e]);
            return f;
          },
        };
        return b;
      })();
      m.CFFStandardStrings = v;
      m.CFFParser = y;
      m.CFF = d;
      m.CFFHeader = u;
      m.CFFStrings = z;
      m.CFFIndex = C;
      m.CFFCharset = p;
      m.CFFTopDict = n;
      m.CFFPrivateDict = e;
      m.CFFCompiler = t;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.getSupplementalGlyphMapForArialBlack = m.getGlyphMapForStandardFonts = m.getSymbolsFonts = m.getSerifFonts = m.getNonStdFontMap = m.getStdFontMap = void 0;
      var a = t(0);
      y = (0, a.getLookupTableFactory)(function(a) {
        a.ArialNarrow = 'Helvetica';
        a['ArialNarrow-Bold'] = 'Helvetica-Bold';
        a['ArialNarrow-BoldItalic'] = 'Helvetica-BoldOblique';
        a['ArialNarrow-Italic'] = 'Helvetica-Oblique';
        a.ArialBlack = 'Helvetica';
        a['ArialBlack-Bold'] = 'Helvetica-Bold';
        a['ArialBlack-BoldItalic'] = 'Helvetica-BoldOblique';
        a['ArialBlack-Italic'] = 'Helvetica-Oblique';
        a['Arial-Black'] = 'Helvetica';
        a['Arial-Black-Bold'] = 'Helvetica-Bold';
        a['Arial-Black-BoldItalic'] = 'Helvetica-BoldOblique';
        a['Arial-Black-Italic'] = 'Helvetica-Oblique';
        a.Arial = 'Helvetica';
        a['Arial-Bold'] = 'Helvetica-Bold';
        a['Arial-BoldItalic'] = 'Helvetica-BoldOblique';
        a['Arial-Italic'] = 'Helvetica-Oblique';
        a['Arial-BoldItalicMT'] = 'Helvetica-BoldOblique';
        a['Arial-BoldMT'] = 'Helvetica-Bold';
        a['Arial-ItalicMT'] = 'Helvetica-Oblique';
        a.ArialMT = 'Helvetica';
        a['Courier-Bold'] = 'Courier-Bold';
        a['Courier-BoldItalic'] = 'Courier-BoldOblique';
        a['Courier-Italic'] = 'Courier-Oblique';
        a.CourierNew = 'Courier';
        a['CourierNew-Bold'] = 'Courier-Bold';
        a['CourierNew-BoldItalic'] = 'Courier-BoldOblique';
        a['CourierNew-Italic'] = 'Courier-Oblique';
        a['CourierNewPS-BoldItalicMT'] = 'Courier-BoldOblique';
        a['CourierNewPS-BoldMT'] = 'Courier-Bold';
        a['CourierNewPS-ItalicMT'] = 'Courier-Oblique';
        a.CourierNewPSMT = 'Courier';
        a.Helvetica = 'Helvetica';
        a['Helvetica-Bold'] = 'Helvetica-Bold';
        a['Helvetica-BoldItalic'] = 'Helvetica-BoldOblique';
        a['Helvetica-BoldOblique'] = 'Helvetica-BoldOblique';
        a['Helvetica-Italic'] = 'Helvetica-Oblique';
        a['Helvetica-Oblique'] = 'Helvetica-Oblique';
        a.SegoeUISymbol = 'Helvetica';
        a['Symbol-Bold'] = 'Symbol';
        a['Symbol-BoldItalic'] = 'Symbol';
        a['Symbol-Italic'] = 'Symbol';
        a.TimesNewRoman = 'Times-Roman';
        a['TimesNewRoman-Bold'] = 'Times-Bold';
        a['TimesNewRoman-BoldItalic'] = 'Times-BoldItalic';
        a['TimesNewRoman-Italic'] = 'Times-Italic';
        a.TimesNewRomanPS = 'Times-Roman';
        a['TimesNewRomanPS-Bold'] = 'Times-Bold';
        a['TimesNewRomanPS-BoldItalic'] = 'Times-BoldItalic';
        a['TimesNewRomanPS-BoldItalicMT'] = 'Times-BoldItalic';
        a['TimesNewRomanPS-BoldMT'] = 'Times-Bold';
        a['TimesNewRomanPS-Italic'] = 'Times-Italic';
        a['TimesNewRomanPS-ItalicMT'] = 'Times-Italic';
        a.TimesNewRomanPSMT = 'Times-Roman';
        a['TimesNewRomanPSMT-Bold'] = 'Times-Bold';
        a['TimesNewRomanPSMT-BoldItalic'] = 'Times-BoldItalic';
        a['TimesNewRomanPSMT-Italic'] = 'Times-Italic';
      });
      t = (0, a.getLookupTableFactory)(function(a) {
        a.CenturyGothic = 'Helvetica';
        a['CenturyGothic-Bold'] = 'Helvetica-Bold';
        a['CenturyGothic-BoldItalic'] = 'Helvetica-BoldOblique';
        a['CenturyGothic-Italic'] = 'Helvetica-Oblique';
        a.ComicSansMS = 'Comic Sans MS';
        a['ComicSansMS-Bold'] = 'Comic Sans MS-Bold';
        a['ComicSansMS-BoldItalic'] = 'Comic Sans MS-BoldItalic';
        a['ComicSansMS-Italic'] = 'Comic Sans MS-Italic';
        a.LucidaConsole = 'Courier';
        a['LucidaConsole-Bold'] = 'Courier-Bold';
        a['LucidaConsole-BoldItalic'] = 'Courier-BoldOblique';
        a['LucidaConsole-Italic'] = 'Courier-Oblique';
        a['MS-Gothic'] = 'MS Gothic';
        a['MS-Gothic-Bold'] = 'MS Gothic-Bold';
        a['MS-Gothic-BoldItalic'] = 'MS Gothic-BoldItalic';
        a['MS-Gothic-Italic'] = 'MS Gothic-Italic';
        a['MS-Mincho'] = 'MS Mincho';
        a['MS-Mincho-Bold'] = 'MS Mincho-Bold';
        a['MS-Mincho-BoldItalic'] = 'MS Mincho-BoldItalic';
        a['MS-Mincho-Italic'] = 'MS Mincho-Italic';
        a['MS-PGothic'] = 'MS PGothic';
        a['MS-PGothic-Bold'] = 'MS PGothic-Bold';
        a['MS-PGothic-BoldItalic'] = 'MS PGothic-BoldItalic';
        a['MS-PGothic-Italic'] = 'MS PGothic-Italic';
        a['MS-PMincho'] = 'MS PMincho';
        a['MS-PMincho-Bold'] = 'MS PMincho-Bold';
        a['MS-PMincho-BoldItalic'] = 'MS PMincho-BoldItalic';
        a['MS-PMincho-Italic'] = 'MS PMincho-Italic';
        a.NuptialScript = 'Times-Italic';
        a.Wingdings = 'ZapfDingbats';
      });
      var k = (0, a.getLookupTableFactory)(function(a) {
          a['Adobe Jenson'] = !0;
          a['Adobe Text'] = !0;
          a.Albertus = !0;
          a.Aldus = !0;
          a.Alexandria = !0;
          a.Algerian = !0;
          a['American Typewriter'] = !0;
          a.Antiqua = !0;
          a.Apex = !0;
          a.Arno = !0;
          a.Aster = !0;
          a.Aurora = !0;
          a.Baskerville = !0;
          a.Bell = !0;
          a.Bembo = !0;
          a['Bembo Schoolbook'] = !0;
          a.Benguiat = !0;
          a['Berkeley Old Style'] = !0;
          a['Bernhard Modern'] = !0;
          a['Berthold City'] = !0;
          a.Bodoni = !0;
          a['Bauer Bodoni'] = !0;
          a['Book Antiqua'] = !0;
          a.Bookman = !0;
          a['Bordeaux Roman'] = !0;
          a['Californian FB'] = !0;
          a.Calisto = !0;
          a.Calvert = !0;
          a.Capitals = !0;
          a.Cambria = !0;
          a.Cartier = !0;
          a.Caslon = !0;
          a.Catull = !0;
          a.Centaur = !0;
          a['Century Old Style'] = !0;
          a['Century Schoolbook'] = !0;
          a.Chaparral = !0;
          a['Charis SIL'] = !0;
          a.Cheltenham = !0;
          a['Cholla Slab'] = !0;
          a.Clarendon = !0;
          a.Clearface = !0;
          a.Cochin = !0;
          a.Colonna = !0;
          a['Computer Modern'] = !0;
          a['Concrete Roman'] = !0;
          a.Constantia = !0;
          a['Cooper Black'] = !0;
          a.Corona = !0;
          a.Ecotype = !0;
          a.Egyptienne = !0;
          a.Elephant = !0;
          a.Excelsior = !0;
          a.Fairfield = !0;
          a['FF Scala'] = !0;
          a.Folkard = !0;
          a.Footlight = !0;
          a.FreeSerif = !0;
          a['Friz Quadrata'] = !0;
          a.Garamond = !0;
          a.Gentium = !0;
          a.Georgia = !0;
          a.Gloucester = !0;
          a['Goudy Old Style'] = !0;
          a['Goudy Schoolbook'] = !0;
          a['Goudy Pro Font'] = !0;
          a.Granjon = !0;
          a['Guardian Egyptian'] = !0;
          a.Heather = !0;
          a.Hercules = !0;
          a['High Tower Text'] = !0;
          a.Hiroshige = !0;
          a['Hoefler Text'] = !0;
          a['Humana Serif'] = !0;
          a.Imprint = !0;
          a['Ionic No. 5'] = !0;
          a.Janson = !0;
          a.Joanna = !0;
          a.Korinna = !0;
          a.Lexicon = !0;
          a['Liberation Serif'] = !0;
          a['Linux Libertine'] = !0;
          a.Literaturnaya = !0;
          a.Lucida = !0;
          a['Lucida Bright'] = !0;
          a.Melior = !0;
          a.Memphis = !0;
          a.Miller = !0;
          a.Minion = !0;
          a.Modern = !0;
          a['Mona Lisa'] = !0;
          a['Mrs Eaves'] = !0;
          a['MS Serif'] = !0;
          a['Museo Slab'] = !0;
          a['New York'] = !0;
          a['Nimbus Roman'] = !0;
          a['NPS Rawlinson Roadway'] = !0;
          a.NuptialScript = !0;
          a.Palatino = !0;
          a.Perpetua = !0;
          a.Plantin = !0;
          a['Plantin Schoolbook'] = !0;
          a.Playbill = !0;
          a['Poor Richard'] = !0;
          a['Rawlinson Roadway'] = !0;
          a.Renault = !0;
          a.Requiem = !0;
          a.Rockwell = !0;
          a.Roman = !0;
          a['Rotis Serif'] = !0;
          a.Sabon = !0;
          a.Scala = !0;
          a.Seagull = !0;
          a.Sistina = !0;
          a.Souvenir = !0;
          a.STIX = !0;
          a['Stone Informal'] = !0;
          a['Stone Serif'] = !0;
          a.Sylfaen = !0;
          a.Times = !0;
          a.Trajan = !0;
          a['Trinit\u00e9'] = !0;
          a['Trump Mediaeval'] = !0;
          a.Utopia = !0;
          a['Vale Type'] = !0;
          a['Bitstream Vera'] = !0;
          a['Vera Serif'] = !0;
          a.Versailles = !0;
          a.Wanted = !0;
          a.Weiss = !0;
          a['Wide Latin'] = !0;
          a.Windsor = !0;
          a.XITS = !0;
        }),
        b = (0, a.getLookupTableFactory)(function(a) {
          a.Dingbats = !0;
          a.Symbol = !0;
          a.ZapfDingbats = !0;
        }),
        v = (0, a.getLookupTableFactory)(function(a) {
          a[2] = 10;
          a[3] = 32;
          a[4] = 33;
          a[5] = 34;
          a[6] = 35;
          a[7] = 36;
          a[8] = 37;
          a[9] = 38;
          a[10] = 39;
          a[11] = 40;
          a[12] = 41;
          a[13] = 42;
          a[14] = 43;
          a[15] = 44;
          a[16] = 45;
          a[17] = 46;
          a[18] = 47;
          a[19] = 48;
          a[20] = 49;
          a[21] = 50;
          a[22] = 51;
          a[23] = 52;
          a[24] = 53;
          a[25] = 54;
          a[26] = 55;
          a[27] = 56;
          a[28] = 57;
          a[29] = 58;
          a[30] = 894;
          a[31] = 60;
          a[32] = 61;
          a[33] = 62;
          a[34] = 63;
          a[35] = 64;
          a[36] = 65;
          a[37] = 66;
          a[38] = 67;
          a[39] = 68;
          a[40] = 69;
          a[41] = 70;
          a[42] = 71;
          a[43] = 72;
          a[44] = 73;
          a[45] = 74;
          a[46] = 75;
          a[47] = 76;
          a[48] = 77;
          a[49] = 78;
          a[50] = 79;
          a[51] = 80;
          a[52] = 81;
          a[53] = 82;
          a[54] = 83;
          a[55] = 84;
          a[56] = 85;
          a[57] = 86;
          a[58] = 87;
          a[59] = 88;
          a[60] = 89;
          a[61] = 90;
          a[62] = 91;
          a[63] = 92;
          a[64] = 93;
          a[65] = 94;
          a[66] = 95;
          a[67] = 96;
          a[68] = 97;
          a[69] = 98;
          a[70] = 99;
          a[71] = 100;
          a[72] = 101;
          a[73] = 102;
          a[74] = 103;
          a[75] = 104;
          a[76] = 105;
          a[77] = 106;
          a[78] = 107;
          a[79] = 108;
          a[80] = 109;
          a[81] = 110;
          a[82] = 111;
          a[83] = 112;
          a[84] = 113;
          a[85] = 114;
          a[86] = 115;
          a[87] = 116;
          a[88] = 117;
          a[89] = 118;
          a[90] = 119;
          a[91] = 120;
          a[92] = 121;
          a[93] = 122;
          a[94] = 123;
          a[95] = 124;
          a[96] = 125;
          a[97] = 126;
          a[98] = 196;
          a[99] = 197;
          a[100] = 199;
          a[101] = 201;
          a[102] = 209;
          a[103] = 214;
          a[104] = 220;
          a[105] = 225;
          a[106] = 224;
          a[107] = 226;
          a[108] = 228;
          a[109] = 227;
          a[110] = 229;
          a[111] = 231;
          a[112] = 233;
          a[113] = 232;
          a[114] = 234;
          a[115] = 235;
          a[116] = 237;
          a[117] = 236;
          a[118] = 238;
          a[119] = 239;
          a[120] = 241;
          a[121] = 243;
          a[122] = 242;
          a[123] = 244;
          a[124] = 246;
          a[125] = 245;
          a[126] = 250;
          a[127] = 249;
          a[128] = 251;
          a[129] = 252;
          a[130] = 8224;
          a[131] = 176;
          a[132] = 162;
          a[133] = 163;
          a[134] = 167;
          a[135] = 8226;
          a[136] = 182;
          a[137] = 223;
          a[138] = 174;
          a[139] = 169;
          a[140] = 8482;
          a[141] = 180;
          a[142] = 168;
          a[143] = 8800;
          a[144] = 198;
          a[145] = 216;
          a[146] = 8734;
          a[147] = 177;
          a[148] = 8804;
          a[149] = 8805;
          a[150] = 165;
          a[151] = 181;
          a[152] = 8706;
          a[153] = 8721;
          a[154] = 8719;
          a[156] = 8747;
          a[157] = 170;
          a[158] = 186;
          a[159] = 8486;
          a[160] = 230;
          a[161] = 248;
          a[162] = 191;
          a[163] = 161;
          a[164] = 172;
          a[165] = 8730;
          a[166] = 402;
          a[167] = 8776;
          a[168] = 8710;
          a[169] = 171;
          a[170] = 187;
          a[171] = 8230;
          a[210] = 218;
          a[223] = 711;
          a[224] = 321;
          a[225] = 322;
          a[227] = 353;
          a[229] = 382;
          a[234] = 253;
          a[252] = 263;
          a[253] = 268;
          a[254] = 269;
          a[258] = 258;
          a[260] = 260;
          a[261] = 261;
          a[265] = 280;
          a[266] = 281;
          a[268] = 283;
          a[269] = 313;
          a[275] = 323;
          a[276] = 324;
          a[278] = 328;
          a[284] = 345;
          a[285] = 346;
          a[286] = 347;
          a[292] = 367;
          a[295] = 377;
          a[296] = 378;
          a[298] = 380;
          a[305] = 963;
          a[306] = 964;
          a[307] = 966;
          a[308] = 8215;
          a[309] = 8252;
          a[310] = 8319;
          a[311] = 8359;
          a[312] = 8592;
          a[313] = 8593;
          a[337] = 9552;
          a[493] = 1039;
          a[494] = 1040;
          a[705] = 1524;
          a[706] = 8362;
          a[710] = 64288;
          a[711] = 64298;
          a[759] = 1617;
          a[761] = 1776;
          a[763] = 1778;
          a[775] = 1652;
          a[777] = 1764;
          a[778] = 1780;
          a[779] = 1781;
          a[780] = 1782;
          a[782] = 771;
          a[783] = 64726;
          a[786] = 8363;
          a[788] = 8532;
          a[790] = 768;
          a[791] = 769;
          a[792] = 768;
          a[795] = 803;
          a[797] = 64336;
          a[798] = 64337;
          a[799] = 64342;
          a[800] = 64343;
          a[801] = 64344;
          a[802] = 64345;
          a[803] = 64362;
          a[804] = 64363;
          a[805] = 64364;
          a[2424] = 7821;
          a[2425] = 7822;
          a[2426] = 7823;
          a[2427] = 7824;
          a[2428] = 7825;
          a[2429] = 7826;
          a[2430] = 7827;
          a[2433] = 7682;
          a[2678] = 8045;
          a[2679] = 8046;
          a[2830] = 1552;
          a[2838] = 686;
          a[2840] = 751;
          a[2842] = 753;
          a[2843] = 754;
          a[2844] = 755;
          a[2846] = 757;
          a[2856] = 767;
          a[2857] = 848;
          a[2858] = 849;
          a[2862] = 853;
          a[2863] = 854;
          a[2864] = 855;
          a[2865] = 861;
          a[2866] = 862;
          a[2906] = 7460;
          a[2908] = 7462;
          a[2909] = 7463;
          a[2910] = 7464;
          a[2912] = 7466;
          a[2913] = 7467;
          a[2914] = 7468;
          a[2916] = 7470;
          a[2917] = 7471;
          a[2918] = 7472;
          a[2920] = 7474;
          a[2921] = 7475;
          a[2922] = 7476;
          a[2924] = 7478;
          a[2925] = 7479;
          a[2926] = 7480;
          a[2928] = 7482;
          a[2929] = 7483;
          a[2930] = 7484;
          a[2932] = 7486;
          a[2933] = 7487;
          a[2934] = 7488;
          a[2936] = 7490;
          a[2937] = 7491;
          a[2938] = 7492;
          a[2940] = 7494;
          a[2941] = 7495;
          a[2942] = 7496;
          a[2944] = 7498;
          a[2946] = 7500;
          a[2948] = 7502;
          a[2950] = 7504;
          a[2951] = 7505;
          a[2952] = 7506;
          a[2954] = 7508;
          a[2955] = 7509;
          a[2956] = 7510;
          a[2958] = 7512;
          a[2959] = 7513;
          a[2960] = 7514;
          a[2962] = 7516;
          a[2963] = 7517;
          a[2964] = 7518;
          a[2966] = 7520;
          a[2967] = 7521;
          a[2968] = 7522;
          a[2970] = 7524;
          a[2971] = 7525;
          a[2972] = 7526;
          a[2974] = 7528;
          a[2975] = 7529;
          a[2976] = 7530;
          a[2978] = 1537;
          a[2979] = 1538;
          a[2980] = 1539;
          a[2982] = 1549;
          a[2983] = 1551;
          a[2984] = 1552;
          a[2986] = 1554;
          a[2987] = 1555;
          a[2988] = 1556;
          a[2990] = 1623;
          a[2991] = 1624;
          a[2995] = 1775;
          a[2999] = 1791;
          a[3002] = 64290;
          a[3003] = 64291;
          a[3004] = 64292;
          a[3006] = 64294;
          a[3007] = 64295;
          a[3008] = 64296;
          a[3011] = 1900;
          a[3014] = 8223;
          a[3015] = 8244;
          a[3017] = 7532;
          a[3018] = 7533;
          a[3019] = 7534;
          a[3075] = 7590;
          a[3076] = 7591;
          a[3079] = 7594;
          a[3080] = 7595;
          a[3083] = 7598;
          a[3084] = 7599;
          a[3087] = 7602;
          a[3088] = 7603;
          a[3091] = 7606;
          a[3092] = 7607;
          a[3095] = 7610;
          a[3096] = 7611;
          a[3099] = 7614;
          a[3100] = 7615;
          a[3103] = 7618;
          a[3104] = 7619;
          a[3107] = 8337;
          a[3108] = 8338;
          a[3116] = 1884;
          a[3119] = 1885;
          a[3120] = 1885;
          a[3123] = 1886;
          a[3124] = 1886;
          a[3127] = 1887;
          a[3128] = 1887;
          a[3131] = 1888;
          a[3132] = 1888;
          a[3135] = 1889;
          a[3136] = 1889;
          a[3139] = 1890;
          a[3140] = 1890;
          a[3143] = 1891;
          a[3144] = 1891;
          a[3147] = 1892;
          a[3148] = 1892;
          a[3153] = 580;
          a[3154] = 581;
          a[3157] = 584;
          a[3158] = 585;
          a[3161] = 588;
          a[3162] = 589;
          a[3165] = 891;
          a[3166] = 892;
          a[3169] = 1274;
          a[3170] = 1275;
          a[3173] = 1278;
          a[3174] = 1279;
          a[3181] = 7622;
          a[3182] = 7623;
          a[3282] = 11799;
          a[3316] = 578;
          a[3379] = 42785;
          a[3393] = 1159;
          a[3416] = 8377;
        });
      a = (0, a.getLookupTableFactory)(function(a) {
        a[227] = 322;
        a[264] = 261;
        a[291] = 346;
      });
      m.getStdFontMap = y;
      m.getNonStdFontMap = t;
      m.getSerifFonts = k;
      m.getSymbolsFonts = b;
      m.getGlyphMapForStandardFonts = v;
      m.getSupplementalGlyphMapForArialBlack = a;
    },
    function(y, m, t) {
      y = t(0).getLookupTableFactory;
      var a = y(function(a) {
          a[63721] = 169;
          a[63193] = 169;
          a[63720] = 174;
          a[63194] = 174;
          a[63722] = 8482;
          a[63195] = 8482;
          a[63729] = 9127;
          a[63730] = 9128;
          a[63731] = 9129;
          a[63740] = 9131;
          a[63741] = 9132;
          a[63742] = 9133;
          a[63726] = 9121;
          a[63727] = 9122;
          a[63728] = 9123;
          a[63737] = 9124;
          a[63738] = 9125;
          a[63739] = 9126;
          a[63723] = 9115;
          a[63724] = 9116;
          a[63725] = 9117;
          a[63734] = 9118;
          a[63735] = 9119;
          a[63736] = 9120;
        }),
        k = [
          { begin: 0, end: 127 },
          { begin: 128, end: 255 },
          { begin: 256, end: 383 },
          { begin: 384, end: 591 },
          { begin: 592, end: 687 },
          { begin: 688, end: 767 },
          { begin: 768, end: 879 },
          { begin: 880, end: 1023 },
          { begin: 11392, end: 11519 },
          { begin: 1024, end: 1279 },
          { begin: 1328, end: 1423 },
          { begin: 1424, end: 1535 },
          { begin: 42240, end: 42559 },
          { begin: 1536, end: 1791 },
          { begin: 1984, end: 2047 },
          { begin: 2304, end: 2431 },
          { begin: 2432, end: 2559 },
          { begin: 2560, end: 2687 },
          { begin: 2688, end: 2815 },
          { begin: 2816, end: 2943 },
          { begin: 2944, end: 3071 },
          { begin: 3072, end: 3199 },
          { begin: 3200, end: 3327 },
          { begin: 3328, end: 3455 },
          { begin: 3584, end: 3711 },
          { begin: 3712, end: 3839 },
          { begin: 4256, end: 4351 },
          { begin: 6912, end: 7039 },
          { begin: 4352, end: 4607 },
          { begin: 7680, end: 7935 },
          { begin: 7936, end: 8191 },
          { begin: 8192, end: 8303 },
          { begin: 8304, end: 8351 },
          { begin: 8352, end: 8399 },
          { begin: 8400, end: 8447 },
          { begin: 8448, end: 8527 },
          { begin: 8528, end: 8591 },
          { begin: 8592, end: 8703 },
          { begin: 8704, end: 8959 },
          { begin: 8960, end: 9215 },
          { begin: 9216, end: 9279 },
          { begin: 9280, end: 9311 },
          { begin: 9312, end: 9471 },
          { begin: 9472, end: 9599 },
          { begin: 9600, end: 9631 },
          { begin: 9632, end: 9727 },
          { begin: 9728, end: 9983 },
          { begin: 9984, end: 10175 },
          { begin: 12288, end: 12351 },
          { begin: 12352, end: 12447 },
          { begin: 12448, end: 12543 },
          { begin: 12544, end: 12591 },
          { begin: 12592, end: 12687 },
          { begin: 43072, end: 43135 },
          { begin: 12800, end: 13055 },
          { begin: 13056, end: 13311 },
          { begin: 44032, end: 55215 },
          { begin: 55296, end: 57343 },
          { begin: 67840, end: 67871 },
          { begin: 19968, end: 40959 },
          { begin: 57344, end: 63743 },
          { begin: 12736, end: 12783 },
          { begin: 64256, end: 64335 },
          { begin: 64336, end: 65023 },
          { begin: 65056, end: 65071 },
          { begin: 65040, end: 65055 },
          { begin: 65104, end: 65135 },
          { begin: 65136, end: 65279 },
          { begin: 65280, end: 65519 },
          { begin: 65520, end: 65535 },
          { begin: 3840, end: 4095 },
          { begin: 1792, end: 1871 },
          { begin: 1920, end: 1983 },
          { begin: 3456, end: 3583 },
          { begin: 4096, end: 4255 },
          { begin: 4608, end: 4991 },
          { begin: 5024, end: 5119 },
          { begin: 5120, end: 5759 },
          { begin: 5760, end: 5791 },
          { begin: 5792, end: 5887 },
          { begin: 6016, end: 6143 },
          { begin: 6144, end: 6319 },
          { begin: 10240, end: 10495 },
          { begin: 40960, end: 42127 },
          { begin: 5888, end: 5919 },
          { begin: 66304, end: 66351 },
          { begin: 66352, end: 66383 },
          { begin: 66560, end: 66639 },
          { begin: 118784, end: 119039 },
          { begin: 119808, end: 120831 },
          { begin: 1044480, end: 1048573 },
          { begin: 65024, end: 65039 },
          { begin: 917504, end: 917631 },
          { begin: 6400, end: 6479 },
          { begin: 6480, end: 6527 },
          { begin: 6528, end: 6623 },
          { begin: 6656, end: 6687 },
          { begin: 11264, end: 11359 },
          { begin: 11568, end: 11647 },
          { begin: 19904, end: 19967 },
          { begin: 43008, end: 43055 },
          { begin: 65536, end: 65663 },
          { begin: 65856, end: 65935 },
          { begin: 66432, end: 66463 },
          { begin: 66464, end: 66527 },
          { begin: 66640, end: 66687 },
          { begin: 66688, end: 66735 },
          { begin: 67584, end: 67647 },
          { begin: 68096, end: 68191 },
          { begin: 119552, end: 119647 },
          { begin: 73728, end: 74751 },
          { begin: 119648, end: 119679 },
          { begin: 7040, end: 7103 },
          { begin: 7168, end: 7247 },
          { begin: 7248, end: 7295 },
          { begin: 43136, end: 43231 },
          { begin: 43264, end: 43311 },
          { begin: 43312, end: 43359 },
          { begin: 43520, end: 43615 },
          { begin: 65936, end: 65999 },
          { begin: 66e3, end: 66047 },
          { begin: 66208, end: 66271 },
          { begin: 127024, end: 127135 },
        ];
      y = y(function(a) {
        a['\u00a8'] = ' \u0308';
        a['\u00af'] = ' \u0304';
        a['\u00b4'] = ' \u0301';
        a['\u00b5'] = '\u03bc';
        a['\u00b8'] = ' \u0327';
        a['\u0132'] = 'IJ';
        a['\u0133'] = 'ij';
        a['\u013f'] = 'L\u00b7';
        a['\u0140'] = 'l\u00b7';
        a['\u0149'] = '\u02bcn';
        a['\u017f'] = 's';
        a['\u01c4'] = 'D\u017d';
        a['\u01c5'] = 'D\u017e';
        a['\u01c6'] = 'd\u017e';
        a['\u01c7'] = 'LJ';
        a['\u01c8'] = 'Lj';
        a['\u01c9'] = 'lj';
        a['\u01ca'] = 'NJ';
        a['\u01cb'] = 'Nj';
        a['\u01cc'] = 'nj';
        a['\u01f1'] = 'DZ';
        a['\u01f2'] = 'Dz';
        a['\u01f3'] = 'dz';
        a['\u02d8'] = ' \u0306';
        a['\u02d9'] = ' \u0307';
        a['\u02da'] = ' \u030a';
        a['\u02db'] = ' \u0328';
        a['\u02dc'] = ' \u0303';
        a['\u02dd'] = ' \u030b';
        a['\u037a'] = ' \u0345';
        a['\u0384'] = ' \u0301';
        a['\u03d0'] = '\u03b2';
        a['\u03d1'] = '\u03b8';
        a['\u03d2'] = '\u03a5';
        a['\u03d5'] = '\u03c6';
        a['\u03d6'] = '\u03c0';
        a['\u03f0'] = '\u03ba';
        a['\u03f1'] = '\u03c1';
        a['\u03f2'] = '\u03c2';
        a['\u03f4'] = '\u0398';
        a['\u03f5'] = '\u03b5';
        a['\u03f9'] = '\u03a3';
        a['\u0587'] = '\u0565\u0582';
        a['\u0675'] = '\u0627\u0674';
        a['\u0676'] = '\u0648\u0674';
        a['\u0677'] = '\u06c7\u0674';
        a['\u0678'] = '\u064a\u0674';
        a['\u0e33'] = '\u0e4d\u0e32';
        a['\u0eb3'] = '\u0ecd\u0eb2';
        a['\u0edc'] = '\u0eab\u0e99';
        a['\u0edd'] = '\u0eab\u0ea1';
        a['\u0f77'] = '\u0fb2\u0f81';
        a['\u0f79'] = '\u0fb3\u0f81';
        a['\u1e9a'] = 'a\u02be';
        a['\u1fbd'] = ' \u0313';
        a['\u1fbf'] = ' \u0313';
        a['\u1fc0'] = ' \u0342';
        a['\u1ffe'] = ' \u0314';
        a['\u2002'] = ' ';
        a['\u2003'] = ' ';
        a['\u2004'] = ' ';
        a['\u2005'] = ' ';
        a['\u2006'] = ' ';
        a['\u2008'] = ' ';
        a['\u2009'] = ' ';
        a['\u200a'] = ' ';
        a['\u2017'] = ' \u0333';
        a['\u2024'] = '.';
        a['\u2025'] = '..';
        a['\u2026'] = '...';
        a['\u2033'] = '\u2032\u2032';
        a['\u2034'] = '\u2032\u2032\u2032';
        a['\u2036'] = '\u2035\u2035';
        a['\u2037'] = '\u2035\u2035\u2035';
        a['\u203c'] = '!!';
        a['\u203e'] = ' \u0305';
        a['\u2047'] = '??';
        a['\u2048'] = '?!';
        a['\u2049'] = '!?';
        a['\u2057'] = '\u2032\u2032\u2032\u2032';
        a['\u205f'] = ' ';
        a['\u20a8'] = 'Rs';
        a['\u2100'] = 'a/c';
        a['\u2101'] = 'a/s';
        a['\u2103'] = '\u00b0C';
        a['\u2105'] = 'c/o';
        a['\u2106'] = 'c/u';
        a['\u2107'] = '\u0190';
        a['\u2109'] = '\u00b0F';
        a['\u2116'] = 'No';
        a['\u2121'] = 'TEL';
        a['\u2135'] = '\u05d0';
        a['\u2136'] = '\u05d1';
        a['\u2137'] = '\u05d2';
        a['\u2138'] = '\u05d3';
        a['\u213b'] = 'FAX';
        a['\u2160'] = 'I';
        a['\u2161'] = 'II';
        a['\u2162'] = 'III';
        a['\u2163'] = 'IV';
        a['\u2164'] = 'V';
        a['\u2165'] = 'VI';
        a['\u2166'] = 'VII';
        a['\u2167'] = 'VIII';
        a['\u2168'] = 'IX';
        a['\u2169'] = 'X';
        a['\u216a'] = 'XI';
        a['\u216b'] = 'XII';
        a['\u216c'] = 'L';
        a['\u216d'] = 'C';
        a['\u216e'] = 'D';
        a['\u216f'] = 'M';
        a['\u2170'] = 'i';
        a['\u2171'] = 'ii';
        a['\u2172'] = 'iii';
        a['\u2173'] = 'iv';
        a['\u2174'] = 'v';
        a['\u2175'] = 'vi';
        a['\u2176'] = 'vii';
        a['\u2177'] = 'viii';
        a['\u2178'] = 'ix';
        a['\u2179'] = 'x';
        a['\u217a'] = 'xi';
        a['\u217b'] = 'xii';
        a['\u217c'] = 'l';
        a['\u217d'] = 'c';
        a['\u217e'] = 'd';
        a['\u217f'] = 'm';
        a['\u222c'] = '\u222b\u222b';
        a['\u222d'] = '\u222b\u222b\u222b';
        a['\u222f'] = '\u222e\u222e';
        a['\u2230'] = '\u222e\u222e\u222e';
        a['\u2474'] = '(1)';
        a['\u2475'] = '(2)';
        a['\u2476'] = '(3)';
        a['\u2477'] = '(4)';
        a['\u2478'] = '(5)';
        a['\u2479'] = '(6)';
        a['\u247a'] = '(7)';
        a['\u247b'] = '(8)';
        a['\u247c'] = '(9)';
        a['\u247d'] = '(10)';
        a['\u247e'] = '(11)';
        a['\u247f'] = '(12)';
        a['\u2480'] = '(13)';
        a['\u2481'] = '(14)';
        a['\u2482'] = '(15)';
        a['\u2483'] = '(16)';
        a['\u2484'] = '(17)';
        a['\u2485'] = '(18)';
        a['\u2486'] = '(19)';
        a['\u2487'] = '(20)';
        a['\u2488'] = '1.';
        a['\u2489'] = '2.';
        a['\u248a'] = '3.';
        a['\u248b'] = '4.';
        a['\u248c'] = '5.';
        a['\u248d'] = '6.';
        a['\u248e'] = '7.';
        a['\u248f'] = '8.';
        a['\u2490'] = '9.';
        a['\u2491'] = '10.';
        a['\u2492'] = '11.';
        a['\u2493'] = '12.';
        a['\u2494'] = '13.';
        a['\u2495'] = '14.';
        a['\u2496'] = '15.';
        a['\u2497'] = '16.';
        a['\u2498'] = '17.';
        a['\u2499'] = '18.';
        a['\u249a'] = '19.';
        a['\u249b'] = '20.';
        a['\u249c'] = '(a)';
        a['\u249d'] = '(b)';
        a['\u249e'] = '(c)';
        a['\u249f'] = '(d)';
        a['\u24a0'] = '(e)';
        a['\u24a1'] = '(f)';
        a['\u24a2'] = '(g)';
        a['\u24a3'] = '(h)';
        a['\u24a4'] = '(i)';
        a['\u24a5'] = '(j)';
        a['\u24a6'] = '(k)';
        a['\u24a7'] = '(l)';
        a['\u24a8'] = '(m)';
        a['\u24a9'] = '(n)';
        a['\u24aa'] = '(o)';
        a['\u24ab'] = '(p)';
        a['\u24ac'] = '(q)';
        a['\u24ad'] = '(r)';
        a['\u24ae'] = '(s)';
        a['\u24af'] = '(t)';
        a['\u24b0'] = '(u)';
        a['\u24b1'] = '(v)';
        a['\u24b2'] = '(w)';
        a['\u24b3'] = '(x)';
        a['\u24b4'] = '(y)';
        a['\u24b5'] = '(z)';
        a['\u2a0c'] = '\u222b\u222b\u222b\u222b';
        a['\u2a74'] = '::=';
        a['\u2a75'] = '==';
        a['\u2a76'] = '===';
        a['\u2e9f'] = '\u6bcd';
        a['\u2ef3'] = '\u9f9f';
        a['\u2f00'] = '\u4e00';
        a['\u2f01'] = '\u4e28';
        a['\u2f02'] = '\u4e36';
        a['\u2f03'] = '\u4e3f';
        a['\u2f04'] = '\u4e59';
        a['\u2f05'] = '\u4e85';
        a['\u2f06'] = '\u4e8c';
        a['\u2f07'] = '\u4ea0';
        a['\u2f08'] = '\u4eba';
        a['\u2f09'] = '\u513f';
        a['\u2f0a'] = '\u5165';
        a['\u2f0b'] = '\u516b';
        a['\u2f0c'] = '\u5182';
        a['\u2f0d'] = '\u5196';
        a['\u2f0e'] = '\u51ab';
        a['\u2f0f'] = '\u51e0';
        a['\u2f10'] = '\u51f5';
        a['\u2f11'] = '\u5200';
        a['\u2f12'] = '\u529b';
        a['\u2f13'] = '\u52f9';
        a['\u2f14'] = '\u5315';
        a['\u2f15'] = '\u531a';
        a['\u2f16'] = '\u5338';
        a['\u2f17'] = '\u5341';
        a['\u2f18'] = '\u535c';
        a['\u2f19'] = '\u5369';
        a['\u2f1a'] = '\u5382';
        a['\u2f1b'] = '\u53b6';
        a['\u2f1c'] = '\u53c8';
        a['\u2f1d'] = '\u53e3';
        a['\u2f1e'] = '\u56d7';
        a['\u2f1f'] = '\u571f';
        a['\u2f20'] = '\u58eb';
        a['\u2f21'] = '\u5902';
        a['\u2f22'] = '\u590a';
        a['\u2f23'] = '\u5915';
        a['\u2f24'] = '\u5927';
        a['\u2f25'] = '\u5973';
        a['\u2f26'] = '\u5b50';
        a['\u2f27'] = '\u5b80';
        a['\u2f28'] = '\u5bf8';
        a['\u2f29'] = '\u5c0f';
        a['\u2f2a'] = '\u5c22';
        a['\u2f2b'] = '\u5c38';
        a['\u2f2c'] = '\u5c6e';
        a['\u2f2d'] = '\u5c71';
        a['\u2f2e'] = '\u5ddb';
        a['\u2f2f'] = '\u5de5';
        a['\u2f30'] = '\u5df1';
        a['\u2f31'] = '\u5dfe';
        a['\u2f32'] = '\u5e72';
        a['\u2f33'] = '\u5e7a';
        a['\u2f34'] = '\u5e7f';
        a['\u2f35'] = '\u5ef4';
        a['\u2f36'] = '\u5efe';
        a['\u2f37'] = '\u5f0b';
        a['\u2f38'] = '\u5f13';
        a['\u2f39'] = '\u5f50';
        a['\u2f3a'] = '\u5f61';
        a['\u2f3b'] = '\u5f73';
        a['\u2f3c'] = '\u5fc3';
        a['\u2f3d'] = '\u6208';
        a['\u2f3e'] = '\u6236';
        a['\u2f3f'] = '\u624b';
        a['\u2f40'] = '\u652f';
        a['\u2f41'] = '\u6534';
        a['\u2f42'] = '\u6587';
        a['\u2f43'] = '\u6597';
        a['\u2f44'] = '\u65a4';
        a['\u2f45'] = '\u65b9';
        a['\u2f46'] = '\u65e0';
        a['\u2f47'] = '\u65e5';
        a['\u2f48'] = '\u66f0';
        a['\u2f49'] = '\u6708';
        a['\u2f4a'] = '\u6728';
        a['\u2f4b'] = '\u6b20';
        a['\u2f4c'] = '\u6b62';
        a['\u2f4d'] = '\u6b79';
        a['\u2f4e'] = '\u6bb3';
        a['\u2f4f'] = '\u6bcb';
        a['\u2f50'] = '\u6bd4';
        a['\u2f51'] = '\u6bdb';
        a['\u2f52'] = '\u6c0f';
        a['\u2f53'] = '\u6c14';
        a['\u2f54'] = '\u6c34';
        a['\u2f55'] = '\u706b';
        a['\u2f56'] = '\u722a';
        a['\u2f57'] = '\u7236';
        a['\u2f58'] = '\u723b';
        a['\u2f59'] = '\u723f';
        a['\u2f5a'] = '\u7247';
        a['\u2f5b'] = '\u7259';
        a['\u2f5c'] = '\u725b';
        a['\u2f5d'] = '\u72ac';
        a['\u2f5e'] = '\u7384';
        a['\u2f5f'] = '\u7389';
        a['\u2f60'] = '\u74dc';
        a['\u2f61'] = '\u74e6';
        a['\u2f62'] = '\u7518';
        a['\u2f63'] = '\u751f';
        a['\u2f64'] = '\u7528';
        a['\u2f65'] = '\u7530';
        a['\u2f66'] = '\u758b';
        a['\u2f67'] = '\u7592';
        a['\u2f68'] = '\u7676';
        a['\u2f69'] = '\u767d';
        a['\u2f6a'] = '\u76ae';
        a['\u2f6b'] = '\u76bf';
        a['\u2f6c'] = '\u76ee';
        a['\u2f6d'] = '\u77db';
        a['\u2f6e'] = '\u77e2';
        a['\u2f6f'] = '\u77f3';
        a['\u2f70'] = '\u793a';
        a['\u2f71'] = '\u79b8';
        a['\u2f72'] = '\u79be';
        a['\u2f73'] = '\u7a74';
        a['\u2f74'] = '\u7acb';
        a['\u2f75'] = '\u7af9';
        a['\u2f76'] = '\u7c73';
        a['\u2f77'] = '\u7cf8';
        a['\u2f78'] = '\u7f36';
        a['\u2f79'] = '\u7f51';
        a['\u2f7a'] = '\u7f8a';
        a['\u2f7b'] = '\u7fbd';
        a['\u2f7c'] = '\u8001';
        a['\u2f7d'] = '\u800c';
        a['\u2f7e'] = '\u8012';
        a['\u2f7f'] = '\u8033';
        a['\u2f80'] = '\u807f';
        a['\u2f81'] = '\u8089';
        a['\u2f82'] = '\u81e3';
        a['\u2f83'] = '\u81ea';
        a['\u2f84'] = '\u81f3';
        a['\u2f85'] = '\u81fc';
        a['\u2f86'] = '\u820c';
        a['\u2f87'] = '\u821b';
        a['\u2f88'] = '\u821f';
        a['\u2f89'] = '\u826e';
        a['\u2f8a'] = '\u8272';
        a['\u2f8b'] = '\u8278';
        a['\u2f8c'] = '\u864d';
        a['\u2f8d'] = '\u866b';
        a['\u2f8e'] = '\u8840';
        a['\u2f8f'] = '\u884c';
        a['\u2f90'] = '\u8863';
        a['\u2f91'] = '\u897e';
        a['\u2f92'] = '\u898b';
        a['\u2f93'] = '\u89d2';
        a['\u2f94'] = '\u8a00';
        a['\u2f95'] = '\u8c37';
        a['\u2f96'] = '\u8c46';
        a['\u2f97'] = '\u8c55';
        a['\u2f98'] = '\u8c78';
        a['\u2f99'] = '\u8c9d';
        a['\u2f9a'] = '\u8d64';
        a['\u2f9b'] = '\u8d70';
        a['\u2f9c'] = '\u8db3';
        a['\u2f9d'] = '\u8eab';
        a['\u2f9e'] = '\u8eca';
        a['\u2f9f'] = '\u8f9b';
        a['\u2fa0'] = '\u8fb0';
        a['\u2fa1'] = '\u8fb5';
        a['\u2fa2'] = '\u9091';
        a['\u2fa3'] = '\u9149';
        a['\u2fa4'] = '\u91c6';
        a['\u2fa5'] = '\u91cc';
        a['\u2fa6'] = '\u91d1';
        a['\u2fa7'] = '\u9577';
        a['\u2fa8'] = '\u9580';
        a['\u2fa9'] = '\u961c';
        a['\u2faa'] = '\u96b6';
        a['\u2fab'] = '\u96b9';
        a['\u2fac'] = '\u96e8';
        a['\u2fad'] = '\u9751';
        a['\u2fae'] = '\u975e';
        a['\u2faf'] = '\u9762';
        a['\u2fb0'] = '\u9769';
        a['\u2fb1'] = '\u97cb';
        a['\u2fb2'] = '\u97ed';
        a['\u2fb3'] = '\u97f3';
        a['\u2fb4'] = '\u9801';
        a['\u2fb5'] = '\u98a8';
        a['\u2fb6'] = '\u98db';
        a['\u2fb7'] = '\u98df';
        a['\u2fb8'] = '\u9996';
        a['\u2fb9'] = '\u9999';
        a['\u2fba'] = '\u99ac';
        a['\u2fbb'] = '\u9aa8';
        a['\u2fbc'] = '\u9ad8';
        a['\u2fbd'] = '\u9adf';
        a['\u2fbe'] = '\u9b25';
        a['\u2fbf'] = '\u9b2f';
        a['\u2fc0'] = '\u9b32';
        a['\u2fc1'] = '\u9b3c';
        a['\u2fc2'] = '\u9b5a';
        a['\u2fc3'] = '\u9ce5';
        a['\u2fc4'] = '\u9e75';
        a['\u2fc5'] = '\u9e7f';
        a['\u2fc6'] = '\u9ea5';
        a['\u2fc7'] = '\u9ebb';
        a['\u2fc8'] = '\u9ec3';
        a['\u2fc9'] = '\u9ecd';
        a['\u2fca'] = '\u9ed1';
        a['\u2fcb'] = '\u9ef9';
        a['\u2fcc'] = '\u9efd';
        a['\u2fcd'] = '\u9f0e';
        a['\u2fce'] = '\u9f13';
        a['\u2fcf'] = '\u9f20';
        a['\u2fd0'] = '\u9f3b';
        a['\u2fd1'] = '\u9f4a';
        a['\u2fd2'] = '\u9f52';
        a['\u2fd3'] = '\u9f8d';
        a['\u2fd4'] = '\u9f9c';
        a['\u2fd5'] = '\u9fa0';
        a['\u3036'] = '\u3012';
        a['\u3038'] = '\u5341';
        a['\u3039'] = '\u5344';
        a['\u303a'] = '\u5345';
        a['\u309b'] = ' \u3099';
        a['\u309c'] = ' \u309a';
        a['\u3131'] = '\u1100';
        a['\u3132'] = '\u1101';
        a['\u3133'] = '\u11aa';
        a['\u3134'] = '\u1102';
        a['\u3135'] = '\u11ac';
        a['\u3136'] = '\u11ad';
        a['\u3137'] = '\u1103';
        a['\u3138'] = '\u1104';
        a['\u3139'] = '\u1105';
        a['\u313a'] = '\u11b0';
        a['\u313b'] = '\u11b1';
        a['\u313c'] = '\u11b2';
        a['\u313d'] = '\u11b3';
        a['\u313e'] = '\u11b4';
        a['\u313f'] = '\u11b5';
        a['\u3140'] = '\u111a';
        a['\u3141'] = '\u1106';
        a['\u3142'] = '\u1107';
        a['\u3143'] = '\u1108';
        a['\u3144'] = '\u1121';
        a['\u3145'] = '\u1109';
        a['\u3146'] = '\u110a';
        a['\u3147'] = '\u110b';
        a['\u3148'] = '\u110c';
        a['\u3149'] = '\u110d';
        a['\u314a'] = '\u110e';
        a['\u314b'] = '\u110f';
        a['\u314c'] = '\u1110';
        a['\u314d'] = '\u1111';
        a['\u314e'] = '\u1112';
        a['\u314f'] = '\u1161';
        a['\u3150'] = '\u1162';
        a['\u3151'] = '\u1163';
        a['\u3152'] = '\u1164';
        a['\u3153'] = '\u1165';
        a['\u3154'] = '\u1166';
        a['\u3155'] = '\u1167';
        a['\u3156'] = '\u1168';
        a['\u3157'] = '\u1169';
        a['\u3158'] = '\u116a';
        a['\u3159'] = '\u116b';
        a['\u315a'] = '\u116c';
        a['\u315b'] = '\u116d';
        a['\u315c'] = '\u116e';
        a['\u315d'] = '\u116f';
        a['\u315e'] = '\u1170';
        a['\u315f'] = '\u1171';
        a['\u3160'] = '\u1172';
        a['\u3161'] = '\u1173';
        a['\u3162'] = '\u1174';
        a['\u3163'] = '\u1175';
        a['\u3164'] = '\u1160';
        a['\u3165'] = '\u1114';
        a['\u3166'] = '\u1115';
        a['\u3167'] = '\u11c7';
        a['\u3168'] = '\u11c8';
        a['\u3169'] = '\u11cc';
        a['\u316a'] = '\u11ce';
        a['\u316b'] = '\u11d3';
        a['\u316c'] = '\u11d7';
        a['\u316d'] = '\u11d9';
        a['\u316e'] = '\u111c';
        a['\u316f'] = '\u11dd';
        a['\u3170'] = '\u11df';
        a['\u3171'] = '\u111d';
        a['\u3172'] = '\u111e';
        a['\u3173'] = '\u1120';
        a['\u3174'] = '\u1122';
        a['\u3175'] = '\u1123';
        a['\u3176'] = '\u1127';
        a['\u3177'] = '\u1129';
        a['\u3178'] = '\u112b';
        a['\u3179'] = '\u112c';
        a['\u317a'] = '\u112d';
        a['\u317b'] = '\u112e';
        a['\u317c'] = '\u112f';
        a['\u317d'] = '\u1132';
        a['\u317e'] = '\u1136';
        a['\u317f'] = '\u1140';
        a['\u3180'] = '\u1147';
        a['\u3181'] = '\u114c';
        a['\u3182'] = '\u11f1';
        a['\u3183'] = '\u11f2';
        a['\u3184'] = '\u1157';
        a['\u3185'] = '\u1158';
        a['\u3186'] = '\u1159';
        a['\u3187'] = '\u1184';
        a['\u3188'] = '\u1185';
        a['\u3189'] = '\u1188';
        a['\u318a'] = '\u1191';
        a['\u318b'] = '\u1192';
        a['\u318c'] = '\u1194';
        a['\u318d'] = '\u119e';
        a['\u318e'] = '\u11a1';
        a['\u3200'] = '(\u1100)';
        a['\u3201'] = '(\u1102)';
        a['\u3202'] = '(\u1103)';
        a['\u3203'] = '(\u1105)';
        a['\u3204'] = '(\u1106)';
        a['\u3205'] = '(\u1107)';
        a['\u3206'] = '(\u1109)';
        a['\u3207'] = '(\u110b)';
        a['\u3208'] = '(\u110c)';
        a['\u3209'] = '(\u110e)';
        a['\u320a'] = '(\u110f)';
        a['\u320b'] = '(\u1110)';
        a['\u320c'] = '(\u1111)';
        a['\u320d'] = '(\u1112)';
        a['\u320e'] = '(\u1100\u1161)';
        a['\u320f'] = '(\u1102\u1161)';
        a['\u3210'] = '(\u1103\u1161)';
        a['\u3211'] = '(\u1105\u1161)';
        a['\u3212'] = '(\u1106\u1161)';
        a['\u3213'] = '(\u1107\u1161)';
        a['\u3214'] = '(\u1109\u1161)';
        a['\u3215'] = '(\u110b\u1161)';
        a['\u3216'] = '(\u110c\u1161)';
        a['\u3217'] = '(\u110e\u1161)';
        a['\u3218'] = '(\u110f\u1161)';
        a['\u3219'] = '(\u1110\u1161)';
        a['\u321a'] = '(\u1111\u1161)';
        a['\u321b'] = '(\u1112\u1161)';
        a['\u321c'] = '(\u110c\u116e)';
        a['\u321d'] = '(\u110b\u1169\u110c\u1165\u11ab)';
        a['\u321e'] = '(\u110b\u1169\u1112\u116e)';
        a['\u3220'] = '(\u4e00)';
        a['\u3221'] = '(\u4e8c)';
        a['\u3222'] = '(\u4e09)';
        a['\u3223'] = '(\u56db)';
        a['\u3224'] = '(\u4e94)';
        a['\u3225'] = '(\u516d)';
        a['\u3226'] = '(\u4e03)';
        a['\u3227'] = '(\u516b)';
        a['\u3228'] = '(\u4e5d)';
        a['\u3229'] = '(\u5341)';
        a['\u322a'] = '(\u6708)';
        a['\u322b'] = '(\u706b)';
        a['\u322c'] = '(\u6c34)';
        a['\u322d'] = '(\u6728)';
        a['\u322e'] = '(\u91d1)';
        a['\u322f'] = '(\u571f)';
        a['\u3230'] = '(\u65e5)';
        a['\u3231'] = '(\u682a)';
        a['\u3232'] = '(\u6709)';
        a['\u3233'] = '(\u793e)';
        a['\u3234'] = '(\u540d)';
        a['\u3235'] = '(\u7279)';
        a['\u3236'] = '(\u8ca1)';
        a['\u3237'] = '(\u795d)';
        a['\u3238'] = '(\u52b4)';
        a['\u3239'] = '(\u4ee3)';
        a['\u323a'] = '(\u547c)';
        a['\u323b'] = '(\u5b66)';
        a['\u323c'] = '(\u76e3)';
        a['\u323d'] = '(\u4f01)';
        a['\u323e'] = '(\u8cc7)';
        a['\u323f'] = '(\u5354)';
        a['\u3240'] = '(\u796d)';
        a['\u3241'] = '(\u4f11)';
        a['\u3242'] = '(\u81ea)';
        a['\u3243'] = '(\u81f3)';
        a['\u32c0'] = '1\u6708';
        a['\u32c1'] = '2\u6708';
        a['\u32c2'] = '3\u6708';
        a['\u32c3'] = '4\u6708';
        a['\u32c4'] = '5\u6708';
        a['\u32c5'] = '6\u6708';
        a['\u32c6'] = '7\u6708';
        a['\u32c7'] = '8\u6708';
        a['\u32c8'] = '9\u6708';
        a['\u32c9'] = '10\u6708';
        a['\u32ca'] = '11\u6708';
        a['\u32cb'] = '12\u6708';
        a['\u3358'] = '0\u70b9';
        a['\u3359'] = '1\u70b9';
        a['\u335a'] = '2\u70b9';
        a['\u335b'] = '3\u70b9';
        a['\u335c'] = '4\u70b9';
        a['\u335d'] = '5\u70b9';
        a['\u335e'] = '6\u70b9';
        a['\u335f'] = '7\u70b9';
        a['\u3360'] = '8\u70b9';
        a['\u3361'] = '9\u70b9';
        a['\u3362'] = '10\u70b9';
        a['\u3363'] = '11\u70b9';
        a['\u3364'] = '12\u70b9';
        a['\u3365'] = '13\u70b9';
        a['\u3366'] = '14\u70b9';
        a['\u3367'] = '15\u70b9';
        a['\u3368'] = '16\u70b9';
        a['\u3369'] = '17\u70b9';
        a['\u336a'] = '18\u70b9';
        a['\u336b'] = '19\u70b9';
        a['\u336c'] = '20\u70b9';
        a['\u336d'] = '21\u70b9';
        a['\u336e'] = '22\u70b9';
        a['\u336f'] = '23\u70b9';
        a['\u3370'] = '24\u70b9';
        a['\u33e0'] = '1\u65e5';
        a['\u33e1'] = '2\u65e5';
        a['\u33e2'] = '3\u65e5';
        a['\u33e3'] = '4\u65e5';
        a['\u33e4'] = '5\u65e5';
        a['\u33e5'] = '6\u65e5';
        a['\u33e6'] = '7\u65e5';
        a['\u33e7'] = '8\u65e5';
        a['\u33e8'] = '9\u65e5';
        a['\u33e9'] = '10\u65e5';
        a['\u33ea'] = '11\u65e5';
        a['\u33eb'] = '12\u65e5';
        a['\u33ec'] = '13\u65e5';
        a['\u33ed'] = '14\u65e5';
        a['\u33ee'] = '15\u65e5';
        a['\u33ef'] = '16\u65e5';
        a['\u33f0'] = '17\u65e5';
        a['\u33f1'] = '18\u65e5';
        a['\u33f2'] = '19\u65e5';
        a['\u33f3'] = '20\u65e5';
        a['\u33f4'] = '21\u65e5';
        a['\u33f5'] = '22\u65e5';
        a['\u33f6'] = '23\u65e5';
        a['\u33f7'] = '24\u65e5';
        a['\u33f8'] = '25\u65e5';
        a['\u33f9'] = '26\u65e5';
        a['\u33fa'] = '27\u65e5';
        a['\u33fb'] = '28\u65e5';
        a['\u33fc'] = '29\u65e5';
        a['\u33fd'] = '30\u65e5';
        a['\u33fe'] = '31\u65e5';
        a['\ufb00'] = 'ff';
        a['\ufb01'] = 'fi';
        a['\ufb02'] = 'fl';
        a['\ufb03'] = 'ffi';
        a['\ufb04'] = 'ffl';
        a['\ufb05'] = '\u017ft';
        a['\ufb06'] = 'st';
        a['\ufb13'] = '\u0574\u0576';
        a['\ufb14'] = '\u0574\u0565';
        a['\ufb15'] = '\u0574\u056b';
        a['\ufb16'] = '\u057e\u0576';
        a['\ufb17'] = '\u0574\u056d';
        a['\ufb4f'] = '\u05d0\u05dc';
        a['\ufb50'] = '\u0671';
        a['\ufb51'] = '\u0671';
        a['\ufb52'] = '\u067b';
        a['\ufb53'] = '\u067b';
        a['\ufb54'] = '\u067b';
        a['\ufb55'] = '\u067b';
        a['\ufb56'] = '\u067e';
        a['\ufb57'] = '\u067e';
        a['\ufb58'] = '\u067e';
        a['\ufb59'] = '\u067e';
        a['\ufb5a'] = '\u0680';
        a['\ufb5b'] = '\u0680';
        a['\ufb5c'] = '\u0680';
        a['\ufb5d'] = '\u0680';
        a['\ufb5e'] = '\u067a';
        a['\ufb5f'] = '\u067a';
        a['\ufb60'] = '\u067a';
        a['\ufb61'] = '\u067a';
        a['\ufb62'] = '\u067f';
        a['\ufb63'] = '\u067f';
        a['\ufb64'] = '\u067f';
        a['\ufb65'] = '\u067f';
        a['\ufb66'] = '\u0679';
        a['\ufb67'] = '\u0679';
        a['\ufb68'] = '\u0679';
        a['\ufb69'] = '\u0679';
        a['\ufb6a'] = '\u06a4';
        a['\ufb6b'] = '\u06a4';
        a['\ufb6c'] = '\u06a4';
        a['\ufb6d'] = '\u06a4';
        a['\ufb6e'] = '\u06a6';
        a['\ufb6f'] = '\u06a6';
        a['\ufb70'] = '\u06a6';
        a['\ufb71'] = '\u06a6';
        a['\ufb72'] = '\u0684';
        a['\ufb73'] = '\u0684';
        a['\ufb74'] = '\u0684';
        a['\ufb75'] = '\u0684';
        a['\ufb76'] = '\u0683';
        a['\ufb77'] = '\u0683';
        a['\ufb78'] = '\u0683';
        a['\ufb79'] = '\u0683';
        a['\ufb7a'] = '\u0686';
        a['\ufb7b'] = '\u0686';
        a['\ufb7c'] = '\u0686';
        a['\ufb7d'] = '\u0686';
        a['\ufb7e'] = '\u0687';
        a['\ufb7f'] = '\u0687';
        a['\ufb80'] = '\u0687';
        a['\ufb81'] = '\u0687';
        a['\ufb82'] = '\u068d';
        a['\ufb83'] = '\u068d';
        a['\ufb84'] = '\u068c';
        a['\ufb85'] = '\u068c';
        a['\ufb86'] = '\u068e';
        a['\ufb87'] = '\u068e';
        a['\ufb88'] = '\u0688';
        a['\ufb89'] = '\u0688';
        a['\ufb8a'] = '\u0698';
        a['\ufb8b'] = '\u0698';
        a['\ufb8c'] = '\u0691';
        a['\ufb8d'] = '\u0691';
        a['\ufb8e'] = '\u06a9';
        a['\ufb8f'] = '\u06a9';
        a['\ufb90'] = '\u06a9';
        a['\ufb91'] = '\u06a9';
        a['\ufb92'] = '\u06af';
        a['\ufb93'] = '\u06af';
        a['\ufb94'] = '\u06af';
        a['\ufb95'] = '\u06af';
        a['\ufb96'] = '\u06b3';
        a['\ufb97'] = '\u06b3';
        a['\ufb98'] = '\u06b3';
        a['\ufb99'] = '\u06b3';
        a['\ufb9a'] = '\u06b1';
        a['\ufb9b'] = '\u06b1';
        a['\ufb9c'] = '\u06b1';
        a['\ufb9d'] = '\u06b1';
        a['\ufb9e'] = '\u06ba';
        a['\ufb9f'] = '\u06ba';
        a['\ufba0'] = '\u06bb';
        a['\ufba1'] = '\u06bb';
        a['\ufba2'] = '\u06bb';
        a['\ufba3'] = '\u06bb';
        a['\ufba4'] = '\u06c0';
        a['\ufba5'] = '\u06c0';
        a['\ufba6'] = '\u06c1';
        a['\ufba7'] = '\u06c1';
        a['\ufba8'] = '\u06c1';
        a['\ufba9'] = '\u06c1';
        a['\ufbaa'] = '\u06be';
        a['\ufbab'] = '\u06be';
        a['\ufbac'] = '\u06be';
        a['\ufbad'] = '\u06be';
        a['\ufbae'] = '\u06d2';
        a['\ufbaf'] = '\u06d2';
        a['\ufbb0'] = '\u06d3';
        a['\ufbb1'] = '\u06d3';
        a['\ufbd3'] = '\u06ad';
        a['\ufbd4'] = '\u06ad';
        a['\ufbd5'] = '\u06ad';
        a['\ufbd6'] = '\u06ad';
        a['\ufbd7'] = '\u06c7';
        a['\ufbd8'] = '\u06c7';
        a['\ufbd9'] = '\u06c6';
        a['\ufbda'] = '\u06c6';
        a['\ufbdb'] = '\u06c8';
        a['\ufbdc'] = '\u06c8';
        a['\ufbdd'] = '\u0677';
        a['\ufbde'] = '\u06cb';
        a['\ufbdf'] = '\u06cb';
        a['\ufbe0'] = '\u06c5';
        a['\ufbe1'] = '\u06c5';
        a['\ufbe2'] = '\u06c9';
        a['\ufbe3'] = '\u06c9';
        a['\ufbe4'] = '\u06d0';
        a['\ufbe5'] = '\u06d0';
        a['\ufbe6'] = '\u06d0';
        a['\ufbe7'] = '\u06d0';
        a['\ufbe8'] = '\u0649';
        a['\ufbe9'] = '\u0649';
        a['\ufbea'] = '\u0626\u0627';
        a['\ufbeb'] = '\u0626\u0627';
        a['\ufbec'] = '\u0626\u06d5';
        a['\ufbed'] = '\u0626\u06d5';
        a['\ufbee'] = '\u0626\u0648';
        a['\ufbef'] = '\u0626\u0648';
        a['\ufbf0'] = '\u0626\u06c7';
        a['\ufbf1'] = '\u0626\u06c7';
        a['\ufbf2'] = '\u0626\u06c6';
        a['\ufbf3'] = '\u0626\u06c6';
        a['\ufbf4'] = '\u0626\u06c8';
        a['\ufbf5'] = '\u0626\u06c8';
        a['\ufbf6'] = '\u0626\u06d0';
        a['\ufbf7'] = '\u0626\u06d0';
        a['\ufbf8'] = '\u0626\u06d0';
        a['\ufbf9'] = '\u0626\u0649';
        a['\ufbfa'] = '\u0626\u0649';
        a['\ufbfb'] = '\u0626\u0649';
        a['\ufbfc'] = '\u06cc';
        a['\ufbfd'] = '\u06cc';
        a['\ufbfe'] = '\u06cc';
        a['\ufbff'] = '\u06cc';
        a['\ufc00'] = '\u0626\u062c';
        a['\ufc01'] = '\u0626\u062d';
        a['\ufc02'] = '\u0626\u0645';
        a['\ufc03'] = '\u0626\u0649';
        a['\ufc04'] = '\u0626\u064a';
        a['\ufc05'] = '\u0628\u062c';
        a['\ufc06'] = '\u0628\u062d';
        a['\ufc07'] = '\u0628\u062e';
        a['\ufc08'] = '\u0628\u0645';
        a['\ufc09'] = '\u0628\u0649';
        a['\ufc0a'] = '\u0628\u064a';
        a['\ufc0b'] = '\u062a\u062c';
        a['\ufc0c'] = '\u062a\u062d';
        a['\ufc0d'] = '\u062a\u062e';
        a['\ufc0e'] = '\u062a\u0645';
        a['\ufc0f'] = '\u062a\u0649';
        a['\ufc10'] = '\u062a\u064a';
        a['\ufc11'] = '\u062b\u062c';
        a['\ufc12'] = '\u062b\u0645';
        a['\ufc13'] = '\u062b\u0649';
        a['\ufc14'] = '\u062b\u064a';
        a['\ufc15'] = '\u062c\u062d';
        a['\ufc16'] = '\u062c\u0645';
        a['\ufc17'] = '\u062d\u062c';
        a['\ufc18'] = '\u062d\u0645';
        a['\ufc19'] = '\u062e\u062c';
        a['\ufc1a'] = '\u062e\u062d';
        a['\ufc1b'] = '\u062e\u0645';
        a['\ufc1c'] = '\u0633\u062c';
        a['\ufc1d'] = '\u0633\u062d';
        a['\ufc1e'] = '\u0633\u062e';
        a['\ufc1f'] = '\u0633\u0645';
        a['\ufc20'] = '\u0635\u062d';
        a['\ufc21'] = '\u0635\u0645';
        a['\ufc22'] = '\u0636\u062c';
        a['\ufc23'] = '\u0636\u062d';
        a['\ufc24'] = '\u0636\u062e';
        a['\ufc25'] = '\u0636\u0645';
        a['\ufc26'] = '\u0637\u062d';
        a['\ufc27'] = '\u0637\u0645';
        a['\ufc28'] = '\u0638\u0645';
        a['\ufc29'] = '\u0639\u062c';
        a['\ufc2a'] = '\u0639\u0645';
        a['\ufc2b'] = '\u063a\u062c';
        a['\ufc2c'] = '\u063a\u0645';
        a['\ufc2d'] = '\u0641\u062c';
        a['\ufc2e'] = '\u0641\u062d';
        a['\ufc2f'] = '\u0641\u062e';
        a['\ufc30'] = '\u0641\u0645';
        a['\ufc31'] = '\u0641\u0649';
        a['\ufc32'] = '\u0641\u064a';
        a['\ufc33'] = '\u0642\u062d';
        a['\ufc34'] = '\u0642\u0645';
        a['\ufc35'] = '\u0642\u0649';
        a['\ufc36'] = '\u0642\u064a';
        a['\ufc37'] = '\u0643\u0627';
        a['\ufc38'] = '\u0643\u062c';
        a['\ufc39'] = '\u0643\u062d';
        a['\ufc3a'] = '\u0643\u062e';
        a['\ufc3b'] = '\u0643\u0644';
        a['\ufc3c'] = '\u0643\u0645';
        a['\ufc3d'] = '\u0643\u0649';
        a['\ufc3e'] = '\u0643\u064a';
        a['\ufc3f'] = '\u0644\u062c';
        a['\ufc40'] = '\u0644\u062d';
        a['\ufc41'] = '\u0644\u062e';
        a['\ufc42'] = '\u0644\u0645';
        a['\ufc43'] = '\u0644\u0649';
        a['\ufc44'] = '\u0644\u064a';
        a['\ufc45'] = '\u0645\u062c';
        a['\ufc46'] = '\u0645\u062d';
        a['\ufc47'] = '\u0645\u062e';
        a['\ufc48'] = '\u0645\u0645';
        a['\ufc49'] = '\u0645\u0649';
        a['\ufc4a'] = '\u0645\u064a';
        a['\ufc4b'] = '\u0646\u062c';
        a['\ufc4c'] = '\u0646\u062d';
        a['\ufc4d'] = '\u0646\u062e';
        a['\ufc4e'] = '\u0646\u0645';
        a['\ufc4f'] = '\u0646\u0649';
        a['\ufc50'] = '\u0646\u064a';
        a['\ufc51'] = '\u0647\u062c';
        a['\ufc52'] = '\u0647\u0645';
        a['\ufc53'] = '\u0647\u0649';
        a['\ufc54'] = '\u0647\u064a';
        a['\ufc55'] = '\u064a\u062c';
        a['\ufc56'] = '\u064a\u062d';
        a['\ufc57'] = '\u064a\u062e';
        a['\ufc58'] = '\u064a\u0645';
        a['\ufc59'] = '\u064a\u0649';
        a['\ufc5a'] = '\u064a\u064a';
        a['\ufc5b'] = '\u0630\u0670';
        a['\ufc5c'] = '\u0631\u0670';
        a['\ufc5d'] = '\u0649\u0670';
        a['\ufc5e'] = ' \u064c\u0651';
        a['\ufc5f'] = ' \u064d\u0651';
        a['\ufc60'] = ' \u064e\u0651';
        a['\ufc61'] = ' \u064f\u0651';
        a['\ufc62'] = ' \u0650\u0651';
        a['\ufc63'] = ' \u0651\u0670';
        a['\ufc64'] = '\u0626\u0631';
        a['\ufc65'] = '\u0626\u0632';
        a['\ufc66'] = '\u0626\u0645';
        a['\ufc67'] = '\u0626\u0646';
        a['\ufc68'] = '\u0626\u0649';
        a['\ufc69'] = '\u0626\u064a';
        a['\ufc6a'] = '\u0628\u0631';
        a['\ufc6b'] = '\u0628\u0632';
        a['\ufc6c'] = '\u0628\u0645';
        a['\ufc6d'] = '\u0628\u0646';
        a['\ufc6e'] = '\u0628\u0649';
        a['\ufc6f'] = '\u0628\u064a';
        a['\ufc70'] = '\u062a\u0631';
        a['\ufc71'] = '\u062a\u0632';
        a['\ufc72'] = '\u062a\u0645';
        a['\ufc73'] = '\u062a\u0646';
        a['\ufc74'] = '\u062a\u0649';
        a['\ufc75'] = '\u062a\u064a';
        a['\ufc76'] = '\u062b\u0631';
        a['\ufc77'] = '\u062b\u0632';
        a['\ufc78'] = '\u062b\u0645';
        a['\ufc79'] = '\u062b\u0646';
        a['\ufc7a'] = '\u062b\u0649';
        a['\ufc7b'] = '\u062b\u064a';
        a['\ufc7c'] = '\u0641\u0649';
        a['\ufc7d'] = '\u0641\u064a';
        a['\ufc7e'] = '\u0642\u0649';
        a['\ufc7f'] = '\u0642\u064a';
        a['\ufc80'] = '\u0643\u0627';
        a['\ufc81'] = '\u0643\u0644';
        a['\ufc82'] = '\u0643\u0645';
        a['\ufc83'] = '\u0643\u0649';
        a['\ufc84'] = '\u0643\u064a';
        a['\ufc85'] = '\u0644\u0645';
        a['\ufc86'] = '\u0644\u0649';
        a['\ufc87'] = '\u0644\u064a';
        a['\ufc88'] = '\u0645\u0627';
        a['\ufc89'] = '\u0645\u0645';
        a['\ufc8a'] = '\u0646\u0631';
        a['\ufc8b'] = '\u0646\u0632';
        a['\ufc8c'] = '\u0646\u0645';
        a['\ufc8d'] = '\u0646\u0646';
        a['\ufc8e'] = '\u0646\u0649';
        a['\ufc8f'] = '\u0646\u064a';
        a['\ufc90'] = '\u0649\u0670';
        a['\ufc91'] = '\u064a\u0631';
        a['\ufc92'] = '\u064a\u0632';
        a['\ufc93'] = '\u064a\u0645';
        a['\ufc94'] = '\u064a\u0646';
        a['\ufc95'] = '\u064a\u0649';
        a['\ufc96'] = '\u064a\u064a';
        a['\ufc97'] = '\u0626\u062c';
        a['\ufc98'] = '\u0626\u062d';
        a['\ufc99'] = '\u0626\u062e';
        a['\ufc9a'] = '\u0626\u0645';
        a['\ufc9b'] = '\u0626\u0647';
        a['\ufc9c'] = '\u0628\u062c';
        a['\ufc9d'] = '\u0628\u062d';
        a['\ufc9e'] = '\u0628\u062e';
        a['\ufc9f'] = '\u0628\u0645';
        a['\ufca0'] = '\u0628\u0647';
        a['\ufca1'] = '\u062a\u062c';
        a['\ufca2'] = '\u062a\u062d';
        a['\ufca3'] = '\u062a\u062e';
        a['\ufca4'] = '\u062a\u0645';
        a['\ufca5'] = '\u062a\u0647';
        a['\ufca6'] = '\u062b\u0645';
        a['\ufca7'] = '\u062c\u062d';
        a['\ufca8'] = '\u062c\u0645';
        a['\ufca9'] = '\u062d\u062c';
        a['\ufcaa'] = '\u062d\u0645';
        a['\ufcab'] = '\u062e\u062c';
        a['\ufcac'] = '\u062e\u0645';
        a['\ufcad'] = '\u0633\u062c';
        a['\ufcae'] = '\u0633\u062d';
        a['\ufcaf'] = '\u0633\u062e';
        a['\ufcb0'] = '\u0633\u0645';
        a['\ufcb1'] = '\u0635\u062d';
        a['\ufcb2'] = '\u0635\u062e';
        a['\ufcb3'] = '\u0635\u0645';
        a['\ufcb4'] = '\u0636\u062c';
        a['\ufcb5'] = '\u0636\u062d';
        a['\ufcb6'] = '\u0636\u062e';
        a['\ufcb7'] = '\u0636\u0645';
        a['\ufcb8'] = '\u0637\u062d';
        a['\ufcb9'] = '\u0638\u0645';
        a['\ufcba'] = '\u0639\u062c';
        a['\ufcbb'] = '\u0639\u0645';
        a['\ufcbc'] = '\u063a\u062c';
        a['\ufcbd'] = '\u063a\u0645';
        a['\ufcbe'] = '\u0641\u062c';
        a['\ufcbf'] = '\u0641\u062d';
        a['\ufcc0'] = '\u0641\u062e';
        a['\ufcc1'] = '\u0641\u0645';
        a['\ufcc2'] = '\u0642\u062d';
        a['\ufcc3'] = '\u0642\u0645';
        a['\ufcc4'] = '\u0643\u062c';
        a['\ufcc5'] = '\u0643\u062d';
        a['\ufcc6'] = '\u0643\u062e';
        a['\ufcc7'] = '\u0643\u0644';
        a['\ufcc8'] = '\u0643\u0645';
        a['\ufcc9'] = '\u0644\u062c';
        a['\ufcca'] = '\u0644\u062d';
        a['\ufccb'] = '\u0644\u062e';
        a['\ufccc'] = '\u0644\u0645';
        a['\ufccd'] = '\u0644\u0647';
        a['\ufcce'] = '\u0645\u062c';
        a['\ufccf'] = '\u0645\u062d';
        a['\ufcd0'] = '\u0645\u062e';
        a['\ufcd1'] = '\u0645\u0645';
        a['\ufcd2'] = '\u0646\u062c';
        a['\ufcd3'] = '\u0646\u062d';
        a['\ufcd4'] = '\u0646\u062e';
        a['\ufcd5'] = '\u0646\u0645';
        a['\ufcd6'] = '\u0646\u0647';
        a['\ufcd7'] = '\u0647\u062c';
        a['\ufcd8'] = '\u0647\u0645';
        a['\ufcd9'] = '\u0647\u0670';
        a['\ufcda'] = '\u064a\u062c';
        a['\ufcdb'] = '\u064a\u062d';
        a['\ufcdc'] = '\u064a\u062e';
        a['\ufcdd'] = '\u064a\u0645';
        a['\ufcde'] = '\u064a\u0647';
        a['\ufcdf'] = '\u0626\u0645';
        a['\ufce0'] = '\u0626\u0647';
        a['\ufce1'] = '\u0628\u0645';
        a['\ufce2'] = '\u0628\u0647';
        a['\ufce3'] = '\u062a\u0645';
        a['\ufce4'] = '\u062a\u0647';
        a['\ufce5'] = '\u062b\u0645';
        a['\ufce6'] = '\u062b\u0647';
        a['\ufce7'] = '\u0633\u0645';
        a['\ufce8'] = '\u0633\u0647';
        a['\ufce9'] = '\u0634\u0645';
        a['\ufcea'] = '\u0634\u0647';
        a['\ufceb'] = '\u0643\u0644';
        a['\ufcec'] = '\u0643\u0645';
        a['\ufced'] = '\u0644\u0645';
        a['\ufcee'] = '\u0646\u0645';
        a['\ufcef'] = '\u0646\u0647';
        a['\ufcf0'] = '\u064a\u0645';
        a['\ufcf1'] = '\u064a\u0647';
        a['\ufcf2'] = '\u0640\u064e\u0651';
        a['\ufcf3'] = '\u0640\u064f\u0651';
        a['\ufcf4'] = '\u0640\u0650\u0651';
        a['\ufcf5'] = '\u0637\u0649';
        a['\ufcf6'] = '\u0637\u064a';
        a['\ufcf7'] = '\u0639\u0649';
        a['\ufcf8'] = '\u0639\u064a';
        a['\ufcf9'] = '\u063a\u0649';
        a['\ufcfa'] = '\u063a\u064a';
        a['\ufcfb'] = '\u0633\u0649';
        a['\ufcfc'] = '\u0633\u064a';
        a['\ufcfd'] = '\u0634\u0649';
        a['\ufcfe'] = '\u0634\u064a';
        a['\ufcff'] = '\u062d\u0649';
        a['\ufd00'] = '\u062d\u064a';
        a['\ufd01'] = '\u062c\u0649';
        a['\ufd02'] = '\u062c\u064a';
        a['\ufd03'] = '\u062e\u0649';
        a['\ufd04'] = '\u062e\u064a';
        a['\ufd05'] = '\u0635\u0649';
        a['\ufd06'] = '\u0635\u064a';
        a['\ufd07'] = '\u0636\u0649';
        a['\ufd08'] = '\u0636\u064a';
        a['\ufd09'] = '\u0634\u062c';
        a['\ufd0a'] = '\u0634\u062d';
        a['\ufd0b'] = '\u0634\u062e';
        a['\ufd0c'] = '\u0634\u0645';
        a['\ufd0d'] = '\u0634\u0631';
        a['\ufd0e'] = '\u0633\u0631';
        a['\ufd0f'] = '\u0635\u0631';
        a['\ufd10'] = '\u0636\u0631';
        a['\ufd11'] = '\u0637\u0649';
        a['\ufd12'] = '\u0637\u064a';
        a['\ufd13'] = '\u0639\u0649';
        a['\ufd14'] = '\u0639\u064a';
        a['\ufd15'] = '\u063a\u0649';
        a['\ufd16'] = '\u063a\u064a';
        a['\ufd17'] = '\u0633\u0649';
        a['\ufd18'] = '\u0633\u064a';
        a['\ufd19'] = '\u0634\u0649';
        a['\ufd1a'] = '\u0634\u064a';
        a['\ufd1b'] = '\u062d\u0649';
        a['\ufd1c'] = '\u062d\u064a';
        a['\ufd1d'] = '\u062c\u0649';
        a['\ufd1e'] = '\u062c\u064a';
        a['\ufd1f'] = '\u062e\u0649';
        a['\ufd20'] = '\u062e\u064a';
        a['\ufd21'] = '\u0635\u0649';
        a['\ufd22'] = '\u0635\u064a';
        a['\ufd23'] = '\u0636\u0649';
        a['\ufd24'] = '\u0636\u064a';
        a['\ufd25'] = '\u0634\u062c';
        a['\ufd26'] = '\u0634\u062d';
        a['\ufd27'] = '\u0634\u062e';
        a['\ufd28'] = '\u0634\u0645';
        a['\ufd29'] = '\u0634\u0631';
        a['\ufd2a'] = '\u0633\u0631';
        a['\ufd2b'] = '\u0635\u0631';
        a['\ufd2c'] = '\u0636\u0631';
        a['\ufd2d'] = '\u0634\u062c';
        a['\ufd2e'] = '\u0634\u062d';
        a['\ufd2f'] = '\u0634\u062e';
        a['\ufd30'] = '\u0634\u0645';
        a['\ufd31'] = '\u0633\u0647';
        a['\ufd32'] = '\u0634\u0647';
        a['\ufd33'] = '\u0637\u0645';
        a['\ufd34'] = '\u0633\u062c';
        a['\ufd35'] = '\u0633\u062d';
        a['\ufd36'] = '\u0633\u062e';
        a['\ufd37'] = '\u0634\u062c';
        a['\ufd38'] = '\u0634\u062d';
        a['\ufd39'] = '\u0634\u062e';
        a['\ufd3a'] = '\u0637\u0645';
        a['\ufd3b'] = '\u0638\u0645';
        a['\ufd3c'] = '\u0627\u064b';
        a['\ufd3d'] = '\u0627\u064b';
        a['\ufd50'] = '\u062a\u062c\u0645';
        a['\ufd51'] = '\u062a\u062d\u062c';
        a['\ufd52'] = '\u062a\u062d\u062c';
        a['\ufd53'] = '\u062a\u062d\u0645';
        a['\ufd54'] = '\u062a\u062e\u0645';
        a['\ufd55'] = '\u062a\u0645\u062c';
        a['\ufd56'] = '\u062a\u0645\u062d';
        a['\ufd57'] = '\u062a\u0645\u062e';
        a['\ufd58'] = '\u062c\u0645\u062d';
        a['\ufd59'] = '\u062c\u0645\u062d';
        a['\ufd5a'] = '\u062d\u0645\u064a';
        a['\ufd5b'] = '\u062d\u0645\u0649';
        a['\ufd5c'] = '\u0633\u062d\u062c';
        a['\ufd5d'] = '\u0633\u062c\u062d';
        a['\ufd5e'] = '\u0633\u062c\u0649';
        a['\ufd5f'] = '\u0633\u0645\u062d';
        a['\ufd60'] = '\u0633\u0645\u062d';
        a['\ufd61'] = '\u0633\u0645\u062c';
        a['\ufd62'] = '\u0633\u0645\u0645';
        a['\ufd63'] = '\u0633\u0645\u0645';
        a['\ufd64'] = '\u0635\u062d\u062d';
        a['\ufd65'] = '\u0635\u062d\u062d';
        a['\ufd66'] = '\u0635\u0645\u0645';
        a['\ufd67'] = '\u0634\u062d\u0645';
        a['\ufd68'] = '\u0634\u062d\u0645';
        a['\ufd69'] = '\u0634\u062c\u064a';
        a['\ufd6a'] = '\u0634\u0645\u062e';
        a['\ufd6b'] = '\u0634\u0645\u062e';
        a['\ufd6c'] = '\u0634\u0645\u0645';
        a['\ufd6d'] = '\u0634\u0645\u0645';
        a['\ufd6e'] = '\u0636\u062d\u0649';
        a['\ufd6f'] = '\u0636\u062e\u0645';
        a['\ufd70'] = '\u0636\u062e\u0645';
        a['\ufd71'] = '\u0637\u0645\u062d';
        a['\ufd72'] = '\u0637\u0645\u062d';
        a['\ufd73'] = '\u0637\u0645\u0645';
        a['\ufd74'] = '\u0637\u0645\u064a';
        a['\ufd75'] = '\u0639\u062c\u0645';
        a['\ufd76'] = '\u0639\u0645\u0645';
        a['\ufd77'] = '\u0639\u0645\u0645';
        a['\ufd78'] = '\u0639\u0645\u0649';
        a['\ufd79'] = '\u063a\u0645\u0645';
        a['\ufd7a'] = '\u063a\u0645\u064a';
        a['\ufd7b'] = '\u063a\u0645\u0649';
        a['\ufd7c'] = '\u0641\u062e\u0645';
        a['\ufd7d'] = '\u0641\u062e\u0645';
        a['\ufd7e'] = '\u0642\u0645\u062d';
        a['\ufd7f'] = '\u0642\u0645\u0645';
        a['\ufd80'] = '\u0644\u062d\u0645';
        a['\ufd81'] = '\u0644\u062d\u064a';
        a['\ufd82'] = '\u0644\u062d\u0649';
        a['\ufd83'] = '\u0644\u062c\u062c';
        a['\ufd84'] = '\u0644\u062c\u062c';
        a['\ufd85'] = '\u0644\u062e\u0645';
        a['\ufd86'] = '\u0644\u062e\u0645';
        a['\ufd87'] = '\u0644\u0645\u062d';
        a['\ufd88'] = '\u0644\u0645\u062d';
        a['\ufd89'] = '\u0645\u062d\u062c';
        a['\ufd8a'] = '\u0645\u062d\u0645';
        a['\ufd8b'] = '\u0645\u062d\u064a';
        a['\ufd8c'] = '\u0645\u062c\u062d';
        a['\ufd8d'] = '\u0645\u062c\u0645';
        a['\ufd8e'] = '\u0645\u062e\u062c';
        a['\ufd8f'] = '\u0645\u062e\u0645';
        a['\ufd92'] = '\u0645\u062c\u062e';
        a['\ufd93'] = '\u0647\u0645\u062c';
        a['\ufd94'] = '\u0647\u0645\u0645';
        a['\ufd95'] = '\u0646\u062d\u0645';
        a['\ufd96'] = '\u0646\u062d\u0649';
        a['\ufd97'] = '\u0646\u062c\u0645';
        a['\ufd98'] = '\u0646\u062c\u0645';
        a['\ufd99'] = '\u0646\u062c\u0649';
        a['\ufd9a'] = '\u0646\u0645\u064a';
        a['\ufd9b'] = '\u0646\u0645\u0649';
        a['\ufd9c'] = '\u064a\u0645\u0645';
        a['\ufd9d'] = '\u064a\u0645\u0645';
        a['\ufd9e'] = '\u0628\u062e\u064a';
        a['\ufd9f'] = '\u062a\u062c\u064a';
        a['\ufda0'] = '\u062a\u062c\u0649';
        a['\ufda1'] = '\u062a\u062e\u064a';
        a['\ufda2'] = '\u062a\u062e\u0649';
        a['\ufda3'] = '\u062a\u0645\u064a';
        a['\ufda4'] = '\u062a\u0645\u0649';
        a['\ufda5'] = '\u062c\u0645\u064a';
        a['\ufda6'] = '\u062c\u062d\u0649';
        a['\ufda7'] = '\u062c\u0645\u0649';
        a['\ufda8'] = '\u0633\u062e\u0649';
        a['\ufda9'] = '\u0635\u062d\u064a';
        a['\ufdaa'] = '\u0634\u062d\u064a';
        a['\ufdab'] = '\u0636\u062d\u064a';
        a['\ufdac'] = '\u0644\u062c\u064a';
        a['\ufdad'] = '\u0644\u0645\u064a';
        a['\ufdae'] = '\u064a\u062d\u064a';
        a['\ufdaf'] = '\u064a\u062c\u064a';
        a['\ufdb0'] = '\u064a\u0645\u064a';
        a['\ufdb1'] = '\u0645\u0645\u064a';
        a['\ufdb2'] = '\u0642\u0645\u064a';
        a['\ufdb3'] = '\u0646\u062d\u064a';
        a['\ufdb4'] = '\u0642\u0645\u062d';
        a['\ufdb5'] = '\u0644\u062d\u0645';
        a['\ufdb6'] = '\u0639\u0645\u064a';
        a['\ufdb7'] = '\u0643\u0645\u064a';
        a['\ufdb8'] = '\u0646\u062c\u062d';
        a['\ufdb9'] = '\u0645\u062e\u064a';
        a['\ufdba'] = '\u0644\u062c\u0645';
        a['\ufdbb'] = '\u0643\u0645\u0645';
        a['\ufdbc'] = '\u0644\u062c\u0645';
        a['\ufdbd'] = '\u0646\u062c\u062d';
        a['\ufdbe'] = '\u062c\u062d\u064a';
        a['\ufdbf'] = '\u062d\u062c\u064a';
        a['\ufdc0'] = '\u0645\u062c\u064a';
        a['\ufdc1'] = '\u0641\u0645\u064a';
        a['\ufdc2'] = '\u0628\u062d\u064a';
        a['\ufdc3'] = '\u0643\u0645\u0645';
        a['\ufdc4'] = '\u0639\u062c\u0645';
        a['\ufdc5'] = '\u0635\u0645\u0645';
        a['\ufdc6'] = '\u0633\u062e\u064a';
        a['\ufdc7'] = '\u0646\u062c\u064a';
        a['\ufe49'] = '\u203e';
        a['\ufe4a'] = '\u203e';
        a['\ufe4b'] = '\u203e';
        a['\ufe4c'] = '\u203e';
        a['\ufe4d'] = '_';
        a['\ufe4e'] = '_';
        a['\ufe4f'] = '_';
        a['\ufe80'] = '\u0621';
        a['\ufe81'] = '\u0622';
        a['\ufe82'] = '\u0622';
        a['\ufe83'] = '\u0623';
        a['\ufe84'] = '\u0623';
        a['\ufe85'] = '\u0624';
        a['\ufe86'] = '\u0624';
        a['\ufe87'] = '\u0625';
        a['\ufe88'] = '\u0625';
        a['\ufe89'] = '\u0626';
        a['\ufe8a'] = '\u0626';
        a['\ufe8b'] = '\u0626';
        a['\ufe8c'] = '\u0626';
        a['\ufe8d'] = '\u0627';
        a['\ufe8e'] = '\u0627';
        a['\ufe8f'] = '\u0628';
        a['\ufe90'] = '\u0628';
        a['\ufe91'] = '\u0628';
        a['\ufe92'] = '\u0628';
        a['\ufe93'] = '\u0629';
        a['\ufe94'] = '\u0629';
        a['\ufe95'] = '\u062a';
        a['\ufe96'] = '\u062a';
        a['\ufe97'] = '\u062a';
        a['\ufe98'] = '\u062a';
        a['\ufe99'] = '\u062b';
        a['\ufe9a'] = '\u062b';
        a['\ufe9b'] = '\u062b';
        a['\ufe9c'] = '\u062b';
        a['\ufe9d'] = '\u062c';
        a['\ufe9e'] = '\u062c';
        a['\ufe9f'] = '\u062c';
        a['\ufea0'] = '\u062c';
        a['\ufea1'] = '\u062d';
        a['\ufea2'] = '\u062d';
        a['\ufea3'] = '\u062d';
        a['\ufea4'] = '\u062d';
        a['\ufea5'] = '\u062e';
        a['\ufea6'] = '\u062e';
        a['\ufea7'] = '\u062e';
        a['\ufea8'] = '\u062e';
        a['\ufea9'] = '\u062f';
        a['\ufeaa'] = '\u062f';
        a['\ufeab'] = '\u0630';
        a['\ufeac'] = '\u0630';
        a['\ufead'] = '\u0631';
        a['\ufeae'] = '\u0631';
        a['\ufeaf'] = '\u0632';
        a['\ufeb0'] = '\u0632';
        a['\ufeb1'] = '\u0633';
        a['\ufeb2'] = '\u0633';
        a['\ufeb3'] = '\u0633';
        a['\ufeb4'] = '\u0633';
        a['\ufeb5'] = '\u0634';
        a['\ufeb6'] = '\u0634';
        a['\ufeb7'] = '\u0634';
        a['\ufeb8'] = '\u0634';
        a['\ufeb9'] = '\u0635';
        a['\ufeba'] = '\u0635';
        a['\ufebb'] = '\u0635';
        a['\ufebc'] = '\u0635';
        a['\ufebd'] = '\u0636';
        a['\ufebe'] = '\u0636';
        a['\ufebf'] = '\u0636';
        a['\ufec0'] = '\u0636';
        a['\ufec1'] = '\u0637';
        a['\ufec2'] = '\u0637';
        a['\ufec3'] = '\u0637';
        a['\ufec4'] = '\u0637';
        a['\ufec5'] = '\u0638';
        a['\ufec6'] = '\u0638';
        a['\ufec7'] = '\u0638';
        a['\ufec8'] = '\u0638';
        a['\ufec9'] = '\u0639';
        a['\ufeca'] = '\u0639';
        a['\ufecb'] = '\u0639';
        a['\ufecc'] = '\u0639';
        a['\ufecd'] = '\u063a';
        a['\ufece'] = '\u063a';
        a['\ufecf'] = '\u063a';
        a['\ufed0'] = '\u063a';
        a['\ufed1'] = '\u0641';
        a['\ufed2'] = '\u0641';
        a['\ufed3'] = '\u0641';
        a['\ufed4'] = '\u0641';
        a['\ufed5'] = '\u0642';
        a['\ufed6'] = '\u0642';
        a['\ufed7'] = '\u0642';
        a['\ufed8'] = '\u0642';
        a['\ufed9'] = '\u0643';
        a['\ufeda'] = '\u0643';
        a['\ufedb'] = '\u0643';
        a['\ufedc'] = '\u0643';
        a['\ufedd'] = '\u0644';
        a['\ufede'] = '\u0644';
        a['\ufedf'] = '\u0644';
        a['\ufee0'] = '\u0644';
        a['\ufee1'] = '\u0645';
        a['\ufee2'] = '\u0645';
        a['\ufee3'] = '\u0645';
        a['\ufee4'] = '\u0645';
        a['\ufee5'] = '\u0646';
        a['\ufee6'] = '\u0646';
        a['\ufee7'] = '\u0646';
        a['\ufee8'] = '\u0646';
        a['\ufee9'] = '\u0647';
        a['\ufeea'] = '\u0647';
        a['\ufeeb'] = '\u0647';
        a['\ufeec'] = '\u0647';
        a['\ufeed'] = '\u0648';
        a['\ufeee'] = '\u0648';
        a['\ufeef'] = '\u0649';
        a['\ufef0'] = '\u0649';
        a['\ufef1'] = '\u064a';
        a['\ufef2'] = '\u064a';
        a['\ufef3'] = '\u064a';
        a['\ufef4'] = '\u064a';
        a['\ufef5'] = '\u0644\u0622';
        a['\ufef6'] = '\u0644\u0622';
        a['\ufef7'] = '\u0644\u0623';
        a['\ufef8'] = '\u0644\u0623';
        a['\ufef9'] = '\u0644\u0625';
        a['\ufefa'] = '\u0644\u0625';
        a['\ufefb'] = '\u0644\u0627';
        a['\ufefc'] = '\u0644\u0627';
      });
      m.mapSpecialUnicodeValues = function(b) {
        return 65520 <= b && 65535 >= b ? 0 : 62976 <= b && 63743 >= b ? a()[b] || b : b;
      };
      m.reverseIfRtl = function(a) {
        var b = a.length,
          d;
        if (!(d = 1 >= b)) {
          d = a.charCodeAt(0);
          var m = k[13];
          d >= m.begin && d < m.end ? (d = !0) : ((m = k[11]), (d = d >= m.begin && d < m.end ? !0 : !1));
          d = !d;
        }
        if (d) return a;
        d = '';
        for (--b; 0 <= b; b--) d += a[b];
        return d;
      };
      m.getUnicodeRangeFor = function(a) {
        for (var b = 0, d = k.length; b < d; b++) {
          var m = k[b];
          if (a >= m.begin && a < m.end) return b;
        }
        return -1;
      };
      m.getNormalizedUnicodes = y;
      m.getUnicodeForGlyph = function(a, k) {
        var b = k[a];
        if (void 0 !== b) return b;
        if (!a) return -1;
        if ('u' === a[0]) {
          b = a.length;
          if (7 === b && 'n' === a[1] && 'i' === a[2]) b = a.substr(3);
          else if (5 <= b && 7 >= b) b = a.substr(1);
          else return -1;
          if (b === b.toUpperCase() && ((b = parseInt(b, 16)), 0 <= b)) return b;
        }
        return -1;
      };
    },
    function(y, m, t) {
      function a(a, b) {
        if (!a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !b || ('object' !== typeof b && 'function' !== typeof b) ? a : b;
      }
      function k(a, b) {
        if ('function' !== typeof b && null !== b)
          throw new TypeError('Super expression must either be null or a function, not ' + typeof b);
        a.prototype = Object.create(b && b.prototype, {
          constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 },
        });
        b && (Object.setPrototypeOf ? Object.setPrototypeOf(a, b) : (a.__proto__ = b));
      }
      function b(a, b) {
        if (!(a instanceof b)) throw new TypeError('Cannot call a class as a function');
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.AnnotationLayer = void 0;
      var v = (function() {
          function a(a, b) {
            for (var c = 0; c < b.length; c++) {
              var d = b[c];
              d.enumerable = d.enumerable || !1;
              d.configurable = !0;
              'value' in d && (d.writable = !0);
              Object.defineProperty(a, d.key, d);
            }
          }
          return function(b, c, d) {
            c && a(b.prototype, c);
            d && a(b, d);
            return b;
          };
        })(),
        d = t(7),
        u = t(0),
        z = (function() {
          function a() {
            b(this, a);
          }
          v(a, null, [
            {
              key: 'create',
              value: function(a) {
                switch (a.data.annotationType) {
                  case u.AnnotationType.LINK:
                    return new B(a);
                  case u.AnnotationType.TEXT:
                    return new n(a);
                  case u.AnnotationType.WIDGET:
                    switch (a.data.fieldType) {
                      case 'Tx':
                        return new h(a);
                      case 'Btn':
                        if (a.data.radioButton) return new A(a);
                        if (a.data.checkBox) return new p(a);
                        (0, u.warn)('Unimplemented button widget annotation: pushbutton');
                        break;
                      case 'Ch':
                        return new c(a);
                    }
                    return new e(a);
                  case u.AnnotationType.POPUP:
                    return new q(a);
                  case u.AnnotationType.LINE:
                    return new g(a);
                  case u.AnnotationType.SQUARE:
                    return new G(a);
                  case u.AnnotationType.CIRCLE:
                    return new l(a);
                  case u.AnnotationType.POLYLINE:
                    return new J(a);
                  case u.AnnotationType.POLYGON:
                    return new f(a);
                  case u.AnnotationType.HIGHLIGHT:
                    return new r(a);
                  case u.AnnotationType.UNDERLINE:
                    return new D(a);
                  case u.AnnotationType.SQUIGGLY:
                    return new L(a);
                  case u.AnnotationType.STRIKEOUT:
                    return new I(a);
                  case u.AnnotationType.STAMP:
                    return new w(a);
                  case u.AnnotationType.FILEATTACHMENT:
                    return new E(a);
                  default:
                    return new C(a);
                }
              },
            },
          ]);
          return a;
        })(),
        C = (function() {
          function a(c) {
            var d = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : !1,
              f = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : !1;
            b(this, a);
            this.isRenderable = d;
            this.data = c.data;
            this.layer = c.layer;
            this.page = c.page;
            this.viewport = c.viewport;
            this.linkService = c.linkService;
            this.downloadManager = c.downloadManager;
            this.imageResourcesPath = c.imageResourcesPath;
            this.renderInteractiveForms = c.renderInteractiveForms;
            this.svgFactory = c.svgFactory;
            d && (this.container = this._createContainer(f));
          }
          v(a, [
            {
              key: '_createContainer',
              value: function() {
                var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : !1,
                  b = this.data,
                  c = this.page,
                  f = this.viewport,
                  e = document.createElement('section'),
                  g = b.rect[2] - b.rect[0],
                  p = b.rect[3] - b.rect[1];
                e.setAttribute('data-annotation-id', b.id);
                c = u.Util.normalizeRect([
                  b.rect[0],
                  c.view[3] - b.rect[1] + c.view[1],
                  b.rect[2],
                  c.view[3] - b.rect[3] + c.view[1],
                ]);
                d.CustomStyle.setProp('transform', e, 'matrix(' + f.transform.join(',') + ')');
                d.CustomStyle.setProp('transformOrigin', e, -c[0] + 'px ' + -c[1] + 'px');
                if (!a && 0 < b.borderStyle.width) {
                  e.style.borderWidth = b.borderStyle.width + 'px';
                  b.borderStyle.style !== u.AnnotationBorderStyleType.UNDERLINE &&
                    ((g -= 2 * b.borderStyle.width), (p -= 2 * b.borderStyle.width));
                  a = b.borderStyle.horizontalCornerRadius;
                  f = b.borderStyle.verticalCornerRadius;
                  (0 < a || 0 < f) && d.CustomStyle.setProp('borderRadius', e, a + 'px / ' + f + 'px');
                  switch (b.borderStyle.style) {
                    case u.AnnotationBorderStyleType.SOLID:
                      e.style.borderStyle = 'solid';
                      break;
                    case u.AnnotationBorderStyleType.DASHED:
                      e.style.borderStyle = 'dashed';
                      break;
                    case u.AnnotationBorderStyleType.BEVELED:
                      (0, u.warn)('Unimplemented border style: beveled');
                      break;
                    case u.AnnotationBorderStyleType.INSET:
                      (0, u.warn)('Unimplemented border style: inset');
                      break;
                    case u.AnnotationBorderStyleType.UNDERLINE:
                      e.style.borderBottomStyle = 'solid';
                  }
                  b.color
                    ? (e.style.borderColor = u.Util.makeCssRgb(b.color[0] | 0, b.color[1] | 0, b.color[2] | 0))
                    : (e.style.borderWidth = 0);
                }
                e.style.left = c[0] + 'px';
                e.style.top = c[1] + 'px';
                e.style.width = g + 'px';
                e.style.height = p + 'px';
                return e;
              },
            },
            {
              key: '_createPopup',
              value: function(a, b, c) {
                b ||
                  ((b = document.createElement('div')),
                  (b.style.height = a.style.height),
                  (b.style.width = a.style.width),
                  a.appendChild(b));
                b = new x({
                  container: a,
                  trigger: b,
                  color: c.color,
                  title: c.title,
                  contents: c.contents,
                  hideWrapper: !0,
                }).render();
                b.style.left = a.style.width;
                a.appendChild(b);
              },
            },
            {
              key: 'render',
              value: function() {
                throw Error('Abstract method `AnnotationElement.render` called');
              },
            },
          ]);
          return a;
        })(),
        B = (function(c) {
          function f(c) {
            b(this, f);
            var d = !!(c.data.url || c.data.dest || c.data.action);
            return a(this, (f.__proto__ || Object.getPrototypeOf(f)).call(this, c, d));
          }
          k(f, c);
          v(f, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'linkAnnotation';
                var a = document.createElement('a');
                (0, d.addLinkAttributes)(a, {
                  url: this.data.url,
                  target: this.data.newWindow ? d.LinkTarget.BLANK : void 0,
                });
                this.data.url ||
                  (this.data.action ? this._bindNamedAction(a, this.data.action) : this._bindLink(a, this.data.dest));
                this.container.appendChild(a);
                return this.container;
              },
            },
            {
              key: '_bindLink',
              value: function(a, b) {
                var c = this;
                a.href = this.linkService.getDestinationHash(b);
                a.onclick = function() {
                  b && c.linkService.navigateTo(b);
                  return !1;
                };
                b && (a.className = 'internalLink');
              },
            },
            {
              key: '_bindNamedAction',
              value: function(a, b) {
                var c = this;
                a.href = this.linkService.getAnchorUrl('');
                a.onclick = function() {
                  c.linkService.executeNamedAction(b);
                  return !1;
                };
                a.className = 'internalLink';
              },
            },
          ]);
          return f;
        })(C),
        n = (function(c) {
          function d(c) {
            b(this, d);
            var f = !!(c.data.hasPopup || c.data.title || c.data.contents);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'textAnnotation';
                var a = document.createElement('img');
                a.style.height = this.container.style.height;
                a.style.width = this.container.style.width;
                a.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
                a.alt = '[{{type}} Annotation]';
                a.dataset.l10nId = 'text_annotation_type';
                a.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
                this.data.hasPopup || this._createPopup(this.container, a, this.data);
                this.container.appendChild(a);
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        e = (function(c) {
          function d() {
            b(this, d);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).apply(this, arguments));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        h = (function(c) {
          function d(c) {
            b(this, d);
            var f = c.renderInteractiveForms || (!c.data.hasAppearance && !!c.data.fieldValue);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                var a = ['left', 'center', 'right'];
                this.container.className = 'textWidgetAnnotation';
                if (this.renderInteractiveForms) {
                  if (this.data.multiLine) {
                    var b = document.createElement('textarea');
                    b.textContent = this.data.fieldValue;
                  } else
                    (b = document.createElement('input')),
                      (b.type = 'text'),
                      b.setAttribute('value', this.data.fieldValue);
                  b.disabled = this.data.readOnly;
                  null !== this.data.maxLen && (b.maxLength = this.data.maxLen);
                  if (this.data.comb) {
                    var c = (this.data.rect[2] - this.data.rect[0]) / this.data.maxLen;
                    b.classList.add('comb');
                    b.style.letterSpacing = 'calc(' + c + 'px - 1ch)';
                  }
                } else
                  (b = document.createElement('div')),
                    (b.textContent = this.data.fieldValue),
                    (b.style.verticalAlign = 'middle'),
                    (b.style.display = 'table-cell'),
                    (c = null),
                    this.data.fontRefName && (c = this.page.commonObjs.getData(this.data.fontRefName)),
                    this._setTextStyle(b, c);
                null !== this.data.textAlignment && (b.style.textAlign = a[this.data.textAlignment]);
                this.container.appendChild(b);
                return this.container;
              },
            },
            {
              key: '_setTextStyle',
              value: function(a, b) {
                var c = a.style;
                c.fontSize = this.data.fontSize + 'px';
                c.direction = 0 > this.data.fontDirection ? 'rtl' : 'ltr';
                b &&
                  ((c.fontWeight = b.black ? (b.bold ? '900' : 'bold') : b.bold ? 'bold' : 'normal'),
                  (c.fontStyle = b.italic ? 'italic' : 'normal'),
                  (c.fontFamily =
                    (b.loadedName ? '"' + b.loadedName + '", ' : '') + (b.fallbackName || 'Helvetica, sans-serif')));
              },
            },
          ]);
          return d;
        })(e),
        p = (function(c) {
          function d(c) {
            b(this, d);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, c.renderInteractiveForms));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'buttonWidgetAnnotation checkBox';
                var a = document.createElement('input');
                a.disabled = this.data.readOnly;
                a.type = 'checkbox';
                this.data.fieldValue && 'Off' !== this.data.fieldValue && a.setAttribute('checked', !0);
                this.container.appendChild(a);
                return this.container;
              },
            },
          ]);
          return d;
        })(e),
        A = (function(c) {
          function d(c) {
            b(this, d);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, c.renderInteractiveForms));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'buttonWidgetAnnotation radioButton';
                var a = document.createElement('input');
                a.disabled = this.data.readOnly;
                a.type = 'radio';
                a.name = this.data.fieldName;
                this.data.fieldValue === this.data.buttonValue && a.setAttribute('checked', !0);
                this.container.appendChild(a);
                return this.container;
              },
            },
          ]);
          return d;
        })(e),
        c = (function(c) {
          function d(c) {
            b(this, d);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, c.renderInteractiveForms));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'choiceWidgetAnnotation';
                var a = document.createElement('select');
                a.disabled = this.data.readOnly;
                this.data.combo || ((a.size = this.data.options.length), this.data.multiSelect && (a.multiple = !0));
                for (var b = 0, c = this.data.options.length; b < c; b++) {
                  var d = this.data.options[b],
                    f = document.createElement('option');
                  f.textContent = d.displayValue;
                  f.value = d.exportValue;
                  0 <= this.data.fieldValue.indexOf(d.displayValue) && f.setAttribute('selected', !0);
                  a.appendChild(f);
                }
                this.container.appendChild(a);
                return this.container;
              },
            },
          ]);
          return d;
        })(e),
        q = (function(c) {
          function f(c) {
            b(this, f);
            var d = !(!c.data.title && !c.data.contents);
            return a(this, (f.__proto__ || Object.getPrototypeOf(f)).call(this, c, d));
          }
          k(f, c);
          v(f, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'popupAnnotation';
                if (0 <= ['Line', 'Square', 'Circle', 'PolyLine', 'Polygon'].indexOf(this.data.parentType))
                  return this.container;
                var a = this.layer.querySelector('[data-annotation-id="' + this.data.parentId + '"]');
                if (!a) return this.container;
                var b = new x({
                    container: this.container,
                    trigger: a,
                    color: this.data.color,
                    title: this.data.title,
                    contents: this.data.contents,
                  }),
                  c = parseFloat(a.style.left),
                  f = parseFloat(a.style.width);
                d.CustomStyle.setProp('transformOrigin', this.container, -(c + f) + 'px -' + a.style.top);
                this.container.style.left = c + f + 'px';
                this.container.appendChild(b.render());
                return this.container;
              },
            },
          ]);
          return f;
        })(C),
        x = (function() {
          function a(c) {
            b(this, a);
            this.container = c.container;
            this.trigger = c.trigger;
            this.color = c.color;
            this.title = c.title;
            this.contents = c.contents;
            this.hideWrapper = c.hideWrapper || !1;
            this.pinned = !1;
          }
          v(a, [
            {
              key: 'render',
              value: function() {
                var a = document.createElement('div');
                a.className = 'popupWrapper';
                this.hideElement = this.hideWrapper ? a : this.container;
                this.hideElement.setAttribute('hidden', !0);
                var b = document.createElement('div');
                b.className = 'popup';
                var c = this.color;
                c &&
                  (b.style.backgroundColor = u.Util.makeCssRgb(
                    (0.7 * (255 - c[0]) + c[0]) | 0,
                    (0.7 * (255 - c[1]) + c[1]) | 0,
                    (0.7 * (255 - c[2]) + c[2]) | 0,
                  ));
                c = this._formatContents(this.contents);
                var d = document.createElement('h1');
                d.textContent = this.title;
                this.trigger.addEventListener('click', this._toggle.bind(this));
                this.trigger.addEventListener('mouseover', this._show.bind(this, !1));
                this.trigger.addEventListener('mouseout', this._hide.bind(this, !1));
                b.addEventListener('click', this._hide.bind(this, !0));
                b.appendChild(d);
                b.appendChild(c);
                a.appendChild(b);
                return a;
              },
            },
            {
              key: '_formatContents',
              value: function(a) {
                var b = document.createElement('p');
                a = a.split(/(?:\r\n?|\n)/);
                for (var c = 0, d = a.length; c < d; ++c)
                  b.appendChild(document.createTextNode(a[c])),
                    c < d - 1 && b.appendChild(document.createElement('br'));
                return b;
              },
            },
            {
              key: '_toggle',
              value: function() {
                this.pinned ? this._hide(!0) : this._show(!0);
              },
            },
            {
              key: '_show',
              value: function() {
                0 < arguments.length && void 0 !== arguments[0] && arguments[0] && (this.pinned = !0);
                this.hideElement.hasAttribute('hidden') &&
                  (this.hideElement.removeAttribute('hidden'), (this.container.style.zIndex += 1));
              },
            },
            {
              key: '_hide',
              value: function() {
                if (0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 1) this.pinned = !1;
                this.hideElement.hasAttribute('hidden') ||
                  this.pinned ||
                  (this.hideElement.setAttribute('hidden', !0), --this.container.style.zIndex);
              },
            },
          ]);
          return a;
        })(),
        g = (function(c) {
          function d(c) {
            b(this, d);
            var f = !!(c.data.hasPopup || c.data.title || c.data.contents);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f, !0));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'lineAnnotation';
                var a = this.data,
                  b = this.svgFactory.create(a.rect[2] - a.rect[0], a.rect[3] - a.rect[1]),
                  c = this.svgFactory.createElement('svg:line');
                c.setAttribute('x1', a.rect[2] - a.lineCoordinates[0]);
                c.setAttribute('y1', a.rect[3] - a.lineCoordinates[1]);
                c.setAttribute('x2', a.rect[2] - a.lineCoordinates[2]);
                c.setAttribute('y2', a.rect[3] - a.lineCoordinates[3]);
                c.setAttribute('stroke-width', a.borderStyle.width);
                c.setAttribute('stroke', 'transparent');
                b.appendChild(c);
                this.container.append(b);
                this._createPopup(this.container, c, a);
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        G = (function(c) {
          function d(c) {
            b(this, d);
            var f = !!(c.data.hasPopup || c.data.title || c.data.contents);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f, !0));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'squareAnnotation';
                var a = this.data,
                  b = a.rect[2] - a.rect[0],
                  c = a.rect[3] - a.rect[1],
                  d = this.svgFactory.create(b, c),
                  f = a.borderStyle.width,
                  e = this.svgFactory.createElement('svg:rect');
                e.setAttribute('x', f / 2);
                e.setAttribute('y', f / 2);
                e.setAttribute('width', b - f);
                e.setAttribute('height', c - f);
                e.setAttribute('stroke-width', f);
                e.setAttribute('stroke', 'transparent');
                e.setAttribute('fill', 'none');
                d.appendChild(e);
                this.container.append(d);
                this._createPopup(this.container, e, a);
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        l = (function(c) {
          function d(c) {
            b(this, d);
            var f = !!(c.data.hasPopup || c.data.title || c.data.contents);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f, !0));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'circleAnnotation';
                var a = this.data,
                  b = a.rect[2] - a.rect[0],
                  c = a.rect[3] - a.rect[1],
                  d = this.svgFactory.create(b, c),
                  f = a.borderStyle.width,
                  e = this.svgFactory.createElement('svg:ellipse');
                e.setAttribute('cx', b / 2);
                e.setAttribute('cy', c / 2);
                e.setAttribute('rx', b / 2 - f / 2);
                e.setAttribute('ry', c / 2 - f / 2);
                e.setAttribute('stroke-width', f);
                e.setAttribute('stroke', 'transparent');
                e.setAttribute('fill', 'none');
                d.appendChild(e);
                this.container.append(d);
                this._createPopup(this.container, e, a);
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        J = (function(c) {
          function d(c) {
            b(this, d);
            var f = !!(c.data.hasPopup || c.data.title || c.data.contents);
            c = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f, !0));
            c.containerClassName = 'polylineAnnotation';
            c.svgElementName = 'svg:polyline';
            return c;
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = this.containerClassName;
                for (
                  var a = this.data,
                    b = this.svgFactory.create(a.rect[2] - a.rect[0], a.rect[3] - a.rect[1]),
                    c = a.vertices,
                    d = [],
                    f = 0,
                    e = c.length;
                  f < e;
                  f++
                )
                  d.push(c[f].x - a.rect[0] + ',' + (a.rect[3] - c[f].y));
                d = d.join(' ');
                c = a.borderStyle.width;
                f = this.svgFactory.createElement(this.svgElementName);
                f.setAttribute('points', d);
                f.setAttribute('stroke-width', c);
                f.setAttribute('stroke', 'transparent');
                f.setAttribute('fill', 'none');
                b.appendChild(f);
                this.container.append(b);
                this._createPopup(this.container, f, a);
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        f = (function(c) {
          function d(c) {
            b(this, d);
            c = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            c.containerClassName = 'polygonAnnotation';
            c.svgElementName = 'svg:polygon';
            return c;
          }
          k(d, c);
          return d;
        })(J),
        r = (function(c) {
          function d(c) {
            b(this, d);
            var f = !!(c.data.hasPopup || c.data.title || c.data.contents);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f, !0));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'highlightAnnotation';
                this.data.hasPopup || this._createPopup(this.container, null, this.data);
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        D = (function(c) {
          function d(c) {
            b(this, d);
            var f = !!(c.data.hasPopup || c.data.title || c.data.contents);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f, !0));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'underlineAnnotation';
                this.data.hasPopup || this._createPopup(this.container, null, this.data);
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        L = (function(c) {
          function d(c) {
            b(this, d);
            var f = !!(c.data.hasPopup || c.data.title || c.data.contents);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f, !0));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'squigglyAnnotation';
                this.data.hasPopup || this._createPopup(this.container, null, this.data);
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        I = (function(c) {
          function d(c) {
            b(this, d);
            var f = !!(c.data.hasPopup || c.data.title || c.data.contents);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f, !0));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'strikeoutAnnotation';
                this.data.hasPopup || this._createPopup(this.container, null, this.data);
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        w = (function(c) {
          function d(c) {
            b(this, d);
            var f = !!(c.data.hasPopup || c.data.title || c.data.contents);
            return a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c, f, !0));
          }
          k(d, c);
          v(d, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'stampAnnotation';
                this.data.hasPopup || this._createPopup(this.container, null, this.data);
                return this.container;
              },
            },
          ]);
          return d;
        })(C),
        E = (function(c) {
          function f(c) {
            b(this, f);
            c = a(this, (f.__proto__ || Object.getPrototypeOf(f)).call(this, c, !0));
            var e = c.data.file;
            c.filename = (0, d.getFilenameFromUrl)(e.filename);
            c.content = e.content;
            c.linkService.onFileAttachmentAnnotation({
              id: (0, u.stringToPDFString)(e.filename),
              filename: e.filename,
              content: e.content,
            });
            return c;
          }
          k(f, c);
          v(f, [
            {
              key: 'render',
              value: function() {
                this.container.className = 'fileAttachmentAnnotation';
                var a = document.createElement('div');
                a.style.height = this.container.style.height;
                a.style.width = this.container.style.width;
                a.addEventListener('dblclick', this._download.bind(this));
                this.data.hasPopup ||
                  (!this.data.title && !this.data.contents) ||
                  this._createPopup(this.container, a, this.data);
                this.container.appendChild(a);
                return this.container;
              },
            },
            {
              key: '_download',
              value: function() {
                this.downloadManager
                  ? this.downloadManager.downloadData(this.content, this.filename, '')
                  : (0, u.warn)('Download cannot be started due to unavailable download manager');
              },
            },
          ]);
          return f;
        })(C);
      y = (function() {
        function a() {
          b(this, a);
        }
        v(a, null, [
          {
            key: 'render',
            value: function(a) {
              for (var b = 0, c = a.annotations.length; b < c; b++) {
                var f = a.annotations[b];
                f &&
                  ((f = z.create({
                    data: f,
                    layer: a.div,
                    page: a.page,
                    viewport: a.viewport,
                    linkService: a.linkService,
                    downloadManager: a.downloadManager,
                    imageResourcesPath: a.imageResourcesPath || (0, d.getDefaultSetting)('imageResourcesPath'),
                    renderInteractiveForms: a.renderInteractiveForms || !1,
                    svgFactory: new d.DOMSVGFactory(),
                  })),
                  f.isRenderable && a.div.appendChild(f.render()));
              }
            },
          },
          {
            key: 'update',
            value: function(a) {
              for (var b = 0, c = a.annotations.length; b < c; b++) {
                var f = a.div.querySelector('[data-annotation-id="' + a.annotations[b].id + '"]');
                f && d.CustomStyle.setProp('transform', f, 'matrix(' + a.viewport.transform.join(',') + ')');
              }
              a.div.removeAttribute('hidden');
            },
          },
        ]);
        return a;
      })();
      m.AnnotationLayer = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.renderTextLayer = void 0;
      var a = t(0),
        k = t(7);
      y = (function() {
        function b(a) {
          if (!a._canceled) {
            var b = a._textDivs,
              d = a._capability,
              p = b.length;
            if (!(1e5 < p || a._textContentStream)) for (var n = 0; n < p; n++) a._layoutText(b[n]);
            a._renderingDone = !0;
            d.resolve();
          }
        }
        function m(b) {
          var e = b._bounds,
            h = b._viewport;
          h = d(h.width, h.height, e);
          for (var p = 0; p < h.length; p++) {
            var n = e[p].div,
              c = b._textDivProperties.get(n);
            if (0 === c.angle)
              (c.paddingLeft = e[p].left - h[p].left),
                (c.paddingTop = e[p].top - h[p].top),
                (c.paddingRight = h[p].right - e[p].right),
                (c.paddingBottom = h[p].bottom - e[p].bottom);
            else {
              var q = h[p],
                k = e[p],
                g = k.m,
                m = g[0],
                l = g[1];
              k = [[0, 0], [0, k.size[1]], [k.size[0], 0], k.size];
              var u = new Float64Array(64);
              k.forEach(function(b, c) {
                var d = a.Util.applyTransform(b, g);
                u[c + 0] = m && (q.left - d[0]) / m;
                u[c + 4] = l && (q.top - d[1]) / l;
                u[c + 8] = m && (q.right - d[0]) / m;
                u[c + 12] = l && (q.bottom - d[1]) / l;
                u[c + 16] = l && (q.left - d[0]) / -l;
                u[c + 20] = m && (q.top - d[1]) / m;
                u[c + 24] = l && (q.right - d[0]) / -l;
                u[c + 28] = m && (q.bottom - d[1]) / m;
                u[c + 32] = m && (q.left - d[0]) / -m;
                u[c + 36] = l && (q.top - d[1]) / -l;
                u[c + 40] = m && (q.right - d[0]) / -m;
                u[c + 44] = l && (q.bottom - d[1]) / -l;
                u[c + 48] = l && (q.left - d[0]) / l;
                u[c + 52] = m && (q.top - d[1]) / -m;
                u[c + 56] = l && (q.right - d[0]) / l;
                u[c + 60] = m && (q.bottom - d[1]) / -m;
              });
              k = function(a, b, c) {
                for (var d = 0, f = 0; f < c; f++) {
                  var e = a[b++];
                  0 < e && (d = d ? Math.min(e, d) : e);
                }
                return d;
              };
              var f = 1 + Math.min(Math.abs(m), Math.abs(l));
              c.paddingLeft = k(u, 32, 16) / f;
              c.paddingTop = k(u, 48, 16) / f;
              c.paddingRight = k(u, 0, 16) / f;
              c.paddingBottom = k(u, 16, 16) / f;
            }
            b._textDivProperties.set(n, c);
          }
        }
        function d(a, b, d) {
          var e = d.map(function(a, b) {
            return { x1: a.left, y1: a.top, x2: a.right, y2: a.bottom, index: b, x1New: void 0, x2New: void 0 };
          });
          u(a, e);
          var h = Array(d.length);
          e.forEach(function(a) {
            h[a.index] = { left: a.x1New, top: 0, right: a.x2New, bottom: 0 };
          });
          d.map(function(b, d) {
            var c = h[d],
              g = e[d];
            g.x1 = b.top;
            g.y1 = a - c.right;
            g.x2 = b.bottom;
            g.y2 = a - c.left;
            g.index = d;
            g.x1New = void 0;
            g.x2New = void 0;
          });
          u(b, e);
          e.forEach(function(a) {
            var b = a.index;
            h[b].top = a.x1New;
            h[b].bottom = a.x2New;
          });
          return h;
        }
        function u(a, b) {
          b.sort(function(a, b) {
            return a.x1 - b.x1 || a.index - b.index;
          });
          var d = [
            {
              start: -Infinity,
              end: Infinity,
              boundary: { x1: -Infinity, y1: -Infinity, x2: 0, y2: Infinity, index: -1, x1New: 0, x2New: 0 },
            },
          ];
          b.forEach(function(a) {
            for (var b = 0; b < d.length && d[b].end <= a.y1; ) b++;
            for (var c = d.length - 1; 0 <= c && d[c].start >= a.y2; ) c--;
            var e,
              p = -Infinity;
            for (e = b; e <= c; e++) {
              var g = d[e];
              var h = g.boundary;
              var l =
                h.x2 > a.x1 ? (h.index > a.index ? h.x1New : a.x1) : void 0 === h.x2New ? (h.x2 + a.x1) / 2 : h.x2New;
              l > p && (p = l);
            }
            a.x1New = p;
            for (e = b; e <= c; e++)
              (g = d[e]),
                (h = g.boundary),
                void 0 === h.x2New
                  ? h.x2 > a.x1
                    ? h.index > a.index && (h.x2New = h.x2)
                    : (h.x2New = p)
                  : h.x2New > p && (h.x2New = Math.max(p, h.x2));
            l = [];
            var n = null;
            for (e = b; e <= c; e++)
              (g = d[e]),
                (h = g.boundary),
                (h = h.x2 > a.x2 ? h : a),
                n === h
                  ? (l[l.length - 1].end = g.end)
                  : (l.push({ start: g.start, end: g.end, boundary: h }), (n = h));
            d[b].start < a.y1 &&
              ((l[0].start = a.y1), l.unshift({ start: d[b].start, end: a.y1, boundary: d[b].boundary }));
            a.y2 < d[c].end &&
              ((l[l.length - 1].end = a.y2), l.push({ start: a.y2, end: d[c].end, boundary: d[c].boundary }));
            for (e = b; e <= c; e++)
              if (((g = d[e]), (h = g.boundary), void 0 === h.x2New)) {
                g = !1;
                for (a = b - 1; !g && 0 <= a && d[a].start >= h.y1; a--) g = d[a].boundary === h;
                for (a = c + 1; !g && a < d.length && d[a].end <= h.y2; a++) g = d[a].boundary === h;
                for (a = 0; !g && a < l.length; a++) g = l[a].boundary === h;
                g || (h.x2New = p);
              }
            Array.prototype.splice.apply(d, [b, c - b + 1].concat(l));
          });
          d.forEach(function(b) {
            b = b.boundary;
            void 0 === b.x2New && (b.x2New = Math.max(a, b.x2));
          });
        }
        function z(b) {
          var d = b.textContentStream,
            h = b.container,
            p = b.viewport,
            n = b.textDivs,
            c = b.textContentItemsStr,
            q = b.enhanceTextSelection;
          this._textContent = b.textContent;
          this._textContentStream = d;
          this._container = h;
          this._viewport = p;
          this._textDivs = n || [];
          this._textContentItemsStr = c || [];
          this._enhanceTextSelection = !!q;
          this._layoutTextCtx = this._layoutTextLastFontFamily = this._layoutTextLastFontSize = this._reader = null;
          this._textDivProperties = new WeakMap();
          this._canceled = this._renderingDone = !1;
          this._capability = (0, a.createPromiseCapability)();
          this._renderTimer = null;
          this._bounds = [];
        }
        var t = /\S/,
          B = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
        z.prototype = {
          get promise() {
            return this._capability.promise;
          },
          cancel: function() {
            this._reader &&
              (this._reader.cancel(new a.AbortException('text layer task cancelled')), (this._reader = null));
            this._canceled = !0;
            null !== this._renderTimer && (clearTimeout(this._renderTimer), (this._renderTimer = null));
            this._capability.reject('canceled');
          },
          _processItems: function(b, d) {
            for (var e = 0, p = b.length; e < p; e++) {
              this._textContentItemsStr.push(b[e].str);
              var n = void 0,
                c = b[e];
              var q = d;
              var m = document.createElement('div'),
                g = {
                  style: null,
                  angle: 0,
                  canvasWidth: 0,
                  isWhitespace: !1,
                  originalTransform: null,
                  paddingBottom: 0,
                  paddingLeft: 0,
                  paddingRight: 0,
                  paddingTop: 0,
                  scale: 1,
                };
              this._textDivs.push(m);
              if (t.test(c.str)) {
                var u = a.Util.transform(this._viewport.transform, c.transform);
                var l = Math.atan2(u[1], u[0]);
                var v = q[c.fontName];
                v.vertical && (l += Math.PI / 2);
                var f = Math.sqrt(u[2] * u[2] + u[3] * u[3]),
                  r = f;
                v.ascent ? (r *= v.ascent) : v.descent && (r *= 1 + v.descent);
                0 === l ? ((q = u[4]), (u = u[5] - r)) : ((q = u[4] + r * Math.sin(l)), (u = u[5] - r * Math.cos(l)));
                B[1] = q;
                B[3] = u;
                B[5] = f;
                B[7] = v.fontFamily;
                g.style = B.join('');
                m.setAttribute('style', g.style);
                m.textContent = c.str;
                (0, k.getDefaultSetting)('pdfBug') && (m.dataset.fontName = c.fontName);
                0 !== l && (g.angle = (180 / Math.PI) * l);
                1 < c.str.length &&
                  (g.canvasWidth = v.vertical ? c.height * this._viewport.scale : c.width * this._viewport.scale);
                this._textDivProperties.set(m, g);
                this._textContentStream && this._layoutText(m);
                this._enhanceTextSelection &&
                  ((g = 1),
                  (r = 0),
                  0 !== l && ((g = Math.cos(l)), (r = Math.sin(l))),
                  (c = (v.vertical ? c.height : c.width) * this._viewport.scale),
                  0 !== l
                    ? ((n = [g, r, -r, g, q, u]), (l = a.Util.getAxialAlignedBoundingBox([0, 0, c, f], n)))
                    : (l = [q, u, q + c, u + f]),
                  this._bounds.push({ left: l[0], top: l[1], right: l[2], bottom: l[3], div: m, size: [c, f], m: n }));
              } else (g.isWhitespace = !0), this._textDivProperties.set(m, g);
            }
          },
          _layoutText: function(a) {
            var b = this._container,
              d = this._textDivProperties.get(a);
            if (!d.isWhitespace) {
              var p = a.style.fontSize,
                n = a.style.fontFamily;
              if (p !== this._layoutTextLastFontSize || n !== this._layoutTextLastFontFamily)
                (this._layoutTextCtx.font = p + ' ' + n), (this._lastFontSize = p), (this._lastFontFamily = n);
              p = this._layoutTextCtx.measureText(a.textContent).width;
              n = '';
              0 !== d.canvasWidth && 0 < p && ((d.scale = d.canvasWidth / p), (n = 'scaleX(' + d.scale + ')'));
              0 !== d.angle && (n = 'rotate(' + d.angle + 'deg) ' + n);
              '' !== n && ((d.originalTransform = n), k.CustomStyle.setProp('transform', a, n));
              this._textDivProperties.set(a, d);
              b.appendChild(a);
            }
          },
          _render: function(d) {
            var e = this,
              h = (0, a.createPromiseCapability)(),
              p = Object.create(null);
            this._layoutTextCtx = document.createElement('canvas').getContext('2d', { alpha: !1 });
            if (this._textContent) this._processItems(this._textContent.items, this._textContent.styles), h.resolve();
            else if (this._textContentStream)
              (this._reader = this._textContentStream.getReader()),
                (function c() {
                  e._reader.read().then(function(b) {
                    var d = b.value;
                    b.done ? h.resolve() : (a.Util.extendObj(p, d.styles), e._processItems(d.items, p), c());
                  }, h.reject);
                })();
            else throw Error('Neither "textContent" nor "textContentStream" parameters specified.');
            h.promise.then(function() {
              p = null;
              d
                ? (e._renderTimer = setTimeout(function() {
                    b(e);
                    e._renderTimer = null;
                  }, d))
                : b(e);
            }, this._capability.reject);
          },
          expandTextDivs: function(a) {
            if (this._enhanceTextSelection && this._renderingDone) {
              null !== this._bounds && (m(this), (this._bounds = null));
              for (var b = 0, d = this._textDivs.length; b < d; b++) {
                var p = this._textDivs[b],
                  n = this._textDivProperties.get(p);
                if (!n.isWhitespace)
                  if (a) {
                    var c = '',
                      q = '';
                    1 !== n.scale && (c = 'scaleX(' + n.scale + ')');
                    0 !== n.angle && (c = 'rotate(' + n.angle + 'deg) ' + c);
                    0 !== n.paddingLeft &&
                      ((q += ' padding-left: ' + n.paddingLeft / n.scale + 'px;'),
                      (c += ' translateX(' + -n.paddingLeft / n.scale + 'px)'));
                    0 !== n.paddingTop &&
                      ((q += ' padding-top: ' + n.paddingTop + 'px;'), (c += ' translateY(' + -n.paddingTop + 'px)'));
                    0 !== n.paddingRight && (q += ' padding-right: ' + n.paddingRight / n.scale + 'px;');
                    0 !== n.paddingBottom && (q += ' padding-bottom: ' + n.paddingBottom + 'px;');
                    '' !== q && p.setAttribute('style', n.style + q);
                    '' !== c && k.CustomStyle.setProp('transform', p, c);
                  } else (p.style.padding = 0), k.CustomStyle.setProp('transform', p, n.originalTransform || '');
              }
            }
          },
        };
        return function(a) {
          var b = new z({
            textContent: a.textContent,
            textContentStream: a.textContentStream,
            container: a.container,
            viewport: a.viewport,
            textDivs: a.textDivs,
            textContentItemsStr: a.textContentItemsStr,
            enhanceTextSelection: a.enhanceTextSelection,
          });
          b._render(a.timeout);
          return b;
        };
      })();
      m.renderTextLayer = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.SVGGraphics = void 0;
      var a = t(0),
        k = t(7);
      y = function() {
        throw Error('Not implemented: SVGGraphics');
      };
      var b = (function() {
          function b(a, b, d, n) {
            var c = n,
              e = b.length;
            d[c] = (e >> 24) & 255;
            d[c + 1] = (e >> 16) & 255;
            d[c + 2] = (e >> 8) & 255;
            d[c + 3] = e & 255;
            c += 4;
            d[c] = a.charCodeAt(0) & 255;
            d[c + 1] = a.charCodeAt(1) & 255;
            d[c + 2] = a.charCodeAt(2) & 255;
            d[c + 3] = a.charCodeAt(3) & 255;
            c += 4;
            d.set(b, c);
            c += b.length;
            a = -1;
            for (n += 4; n < c; n++) a = (a >>> 8) ^ m[(a ^ d[n]) & 255];
            n = a ^ -1;
            d[c] = (n >> 24) & 255;
            d[c + 1] = (n >> 16) & 255;
            d[c + 2] = (n >> 8) & 255;
            d[c + 3] = n & 255;
          }
          for (
            var k = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), m = new Int32Array(256), v = 0;
            256 > v;
            v++
          ) {
            for (var B = v, n = 0; 8 > n; n++) B = B & 1 ? 3988292384 ^ ((B >> 1) & 2147483647) : (B >> 1) & 2147483647;
            m[v] = B;
          }
          return function(d, h) {
            var e = void 0 === d.kind ? a.ImageKind.GRAYSCALE_1BPP : d.kind,
              n = d.width,
              c = d.height,
              q = d.data;
            switch (e) {
              case a.ImageKind.GRAYSCALE_1BPP:
                var m = 0;
                var g = 1;
                var u = (n + 7) >> 3;
                break;
              case a.ImageKind.RGB_24BPP:
                m = 2;
                g = 8;
                u = 3 * n;
                break;
              case a.ImageKind.RGBA_32BPP:
                m = 6;
                g = 8;
                u = 4 * n;
                break;
              default:
                throw Error('invalid format');
            }
            var l = new Uint8Array((1 + u) * c),
              B = 0,
              f = 0,
              r;
            for (r = 0; r < c; ++r) (l[B++] = 0), l.set(q.subarray(f, f + u), B), (f += u), (B += u);
            if (e === a.ImageKind.GRAYSCALE_1BPP)
              for (r = B = 0; r < c; r++) for (B++, e = 0; e < u; e++) l[B++] ^= 255;
            n = new Uint8Array([
              (n >> 24) & 255,
              (n >> 16) & 255,
              (n >> 8) & 255,
              n & 255,
              (c >> 24) & 255,
              (c >> 16) & 255,
              (c >> 8) & 255,
              c & 255,
              g,
              m,
              0,
              0,
              0,
            ]);
            a: {
              if ((0, a.isNodeJS)())
                try {
                  var D = 8 <= parseInt(process.versions.node) ? l : new Buffer(l);
                  var v = require('zlib').deflateSync(D, { level: 9 });
                  var z = v instanceof Uint8Array ? v : new Uint8Array(v);
                  break a;
                } catch (w) {
                  (0, a.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + w);
                }
              v = l.length;
              z = new Uint8Array(2 + v + 5 * Math.ceil(v / 65535) + 4);
              D = 0;
              z[D++] = 120;
              z[D++] = 156;
              for (c = 0; 65535 < v; )
                (z[D++] = 0),
                  (z[D++] = 255),
                  (z[D++] = 255),
                  (z[D++] = 0),
                  (z[D++] = 0),
                  z.set(l.subarray(c, c + 65535), D),
                  (D += 65535),
                  (c += 65535),
                  (v -= 65535);
              z[D++] = 1;
              z[D++] = v & 255;
              z[D++] = (v >> 8) & 255;
              z[D++] = ~v & 255;
              z[D++] = ((~v & 65535) >> 8) & 255;
              z.set(l.subarray(c), D);
              D += l.length - c;
              v = 1;
              for (g = c = 0; g < l.length; ++g) (v = (v + (l[g] & 255)) % 65521), (c = (c + v) % 65521);
              l = (c << 16) | v;
              z[D++] = (l >> 24) & 255;
              z[D++] = (l >> 16) & 255;
              z[D++] = (l >> 8) & 255;
              z[D++] = l & 255;
            }
            l = new Uint8Array(k.length + 36 + n.length + z.length);
            D = 0;
            l.set(k, D);
            D += k.length;
            b('IHDR', n, l, D);
            D += 12 + n.length;
            b('IDATA', z, l, D);
            D += 12 + z.length;
            b('IEND', new Uint8Array(0), l, D);
            return (0, a.createObjectURL)(l, 'image/png', h);
          };
        })(),
        v = (function() {
          function b() {
            this.fontSizeScale = 1;
            this.fontWeight = 'normal';
            this.fontSize = 0;
            this.textMatrix = a.IDENTITY_MATRIX;
            this.fontMatrix = a.FONT_IDENTITY_MATRIX;
            this.wordSpacing = this.charSpacing = this.lineY = this.lineX = this.y = this.x = this.leading = 0;
            this.textHScale = 1;
            this.textRise = 0;
            this.strokeColor = this.fillColor = '#000000';
            this.lineWidth = this.strokeAlpha = this.fillAlpha = 1;
            this.lineCap = this.lineJoin = '';
            this.miterLimit = 0;
            this.dashArray = [];
            this.dashPhase = 0;
            this.dependencies = [];
            this.clipGroup = this.activeClipUrl = null;
            this.maskId = '';
          }
          b.prototype = {
            clone: function() {
              return Object.create(this);
            },
            setCurrentPoint: function(a, b) {
              this.x = a;
              this.y = b;
            },
          };
          return b;
        })();
      m.SVGGraphics = y = (function() {
        function d(a) {
          if (Number.isInteger(a)) return a.toString();
          a = a.toFixed(10);
          var b = a.length - 1;
          if ('0' !== a[b]) return a;
          do b--;
          while ('0' === a[b]);
          return a.substr(0, '.' === a[b] ? b : b + 1);
        }
        function m(a) {
          if (0 === a[4] && 0 === a[5]) {
            if (0 === a[1] && 0 === a[2])
              return 1 === a[0] && 1 === a[3] ? '' : 'scale(' + d(a[0]) + ' ' + d(a[3]) + ')';
            if (a[0] === a[3] && a[1] === -a[2]) return 'rotate(' + d((180 * Math.acos(a[0])) / Math.PI) + ')';
          } else if (1 === a[0] && 0 === a[1] && 0 === a[2] && 1 === a[3])
            return 'translate(' + d(a[4]) + ' ' + d(a[5]) + ')';
          return (
            'matrix(' + d(a[0]) + ' ' + d(a[1]) + ' ' + d(a[2]) + ' ' + d(a[3]) + ' ' + d(a[4]) + ' ' + d(a[5]) + ')'
          );
        }
        function z(b, d, e) {
          this.svgFactory = new k.DOMSVGFactory();
          this.current = new v();
          this.transformMatrix = a.IDENTITY_MATRIX;
          this.transformStack = [];
          this.extraStack = [];
          this.commonObjs = b;
          this.objs = d;
          this.pendingClip = null;
          this.embedFonts = this.pendingEOFill = !1;
          this.embeddedFonts = Object.create(null);
          this.cssStyle = null;
          this.forceDataSchema = !!e;
        }
        var t = ['butt', 'round', 'square'],
          B = ['miter', 'round', 'bevel'],
          n = 0,
          e = 0;
        z.prototype = {
          save: function() {
            this.transformStack.push(this.transformMatrix);
            var a = this.current;
            this.extraStack.push(a);
            this.current = a.clone();
          },
          restore: function() {
            this.transformMatrix = this.transformStack.pop();
            this.current = this.extraStack.pop();
            this.tgrp = this.pendingClip = null;
          },
          group: function(a) {
            this.save();
            this.executeOpTree(a);
            this.restore();
          },
          loadDependencies: function(b) {
            var d = this,
              e = b.fnArray,
              c = e.length;
            b = b.argsArray;
            for (var h = 0; h < c; h++)
              if (a.OPS.dependency === e[h])
                for (var n = b[h], g = 0, k = n.length; g < k; g++) {
                  var l = n[g];
                  var m =
                    'g_' === l.substring(0, 2)
                      ? new Promise(function(a) {
                          d.commonObjs.get(l, a);
                        })
                      : new Promise(function(a) {
                          d.objs.get(l, a);
                        });
                  this.current.dependencies.push(m);
                }
            return Promise.all(this.current.dependencies);
          },
          transform: function(b, d, e, c, q, n) {
            this.transformMatrix = a.Util.transform(this.transformMatrix, [b, d, e, c, q, n]);
            this.tgrp = null;
          },
          getSVG: function(b, d) {
            var e = this;
            this.viewport = d;
            var c = this._initialize(d);
            return this.loadDependencies(b).then(function() {
              e.transformMatrix = a.IDENTITY_MATRIX;
              var d = e.convertOpList(b);
              e.executeOpTree(d);
              return c;
            });
          },
          convertOpList: function(b) {
            var d = b.argsArray,
              e = b.fnArray,
              c = e.length,
              h = [];
            b = [];
            for (var n in a.OPS) h[a.OPS[n]] = n;
            for (n = 0; n < c; n++) {
              var g = e[n];
              b.push({ fnId: g, fn: h[g], args: d[n] });
            }
            d = [];
            e = [];
            c = b.length;
            for (h = 0; h < c; h++)
              'save' === b[h].fn
                ? (d.push({ fnId: 92, fn: 'group', items: [] }), e.push(d), (d = d[d.length - 1].items))
                : 'restore' === b[h].fn
                ? (d = e.pop())
                : d.push(b[h]);
            return d;
          },
          executeOpTree: function(b) {
            for (var d = b.length, e = 0; e < d; e++) {
              var c = b[e].fn,
                h = b[e].args;
              switch (b[e].fnId | 0) {
                case a.OPS.beginText:
                  this.beginText();
                  break;
                case a.OPS.setLeading:
                  this.setLeading(h);
                  break;
                case a.OPS.setLeadingMoveText:
                  this.setLeadingMoveText(h[0], h[1]);
                  break;
                case a.OPS.setFont:
                  this.setFont(h);
                  break;
                case a.OPS.showText:
                  this.showText(h[0]);
                  break;
                case a.OPS.showSpacedText:
                  this.showText(h[0]);
                  break;
                case a.OPS.endText:
                  this.endText();
                  break;
                case a.OPS.moveText:
                  this.moveText(h[0], h[1]);
                  break;
                case a.OPS.setCharSpacing:
                  this.setCharSpacing(h[0]);
                  break;
                case a.OPS.setWordSpacing:
                  this.setWordSpacing(h[0]);
                  break;
                case a.OPS.setHScale:
                  this.setHScale(h[0]);
                  break;
                case a.OPS.setTextMatrix:
                  this.setTextMatrix(h[0], h[1], h[2], h[3], h[4], h[5]);
                  break;
                case a.OPS.setTextRise:
                  this.setTextRise(h[0]);
                  break;
                case a.OPS.setLineWidth:
                  this.setLineWidth(h[0]);
                  break;
                case a.OPS.setLineJoin:
                  this.setLineJoin(h[0]);
                  break;
                case a.OPS.setLineCap:
                  this.setLineCap(h[0]);
                  break;
                case a.OPS.setMiterLimit:
                  this.setMiterLimit(h[0]);
                  break;
                case a.OPS.setFillRGBColor:
                  this.setFillRGBColor(h[0], h[1], h[2]);
                  break;
                case a.OPS.setStrokeRGBColor:
                  this.setStrokeRGBColor(h[0], h[1], h[2]);
                  break;
                case a.OPS.setDash:
                  this.setDash(h[0], h[1]);
                  break;
                case a.OPS.setGState:
                  this.setGState(h[0]);
                  break;
                case a.OPS.fill:
                  this.fill();
                  break;
                case a.OPS.eoFill:
                  this.eoFill();
                  break;
                case a.OPS.stroke:
                  this.stroke();
                  break;
                case a.OPS.fillStroke:
                  this.fillStroke();
                  break;
                case a.OPS.eoFillStroke:
                  this.eoFillStroke();
                  break;
                case a.OPS.clip:
                  this.clip('nonzero');
                  break;
                case a.OPS.eoClip:
                  this.clip('evenodd');
                  break;
                case a.OPS.paintSolidColorImageMask:
                  this.paintSolidColorImageMask();
                  break;
                case a.OPS.paintJpegXObject:
                  this.paintJpegXObject(h[0], h[1], h[2]);
                  break;
                case a.OPS.paintImageXObject:
                  this.paintImageXObject(h[0]);
                  break;
                case a.OPS.paintInlineImageXObject:
                  this.paintInlineImageXObject(h[0]);
                  break;
                case a.OPS.paintImageMaskXObject:
                  this.paintImageMaskXObject(h[0]);
                  break;
                case a.OPS.paintFormXObjectBegin:
                  this.paintFormXObjectBegin(h[0], h[1]);
                  break;
                case a.OPS.paintFormXObjectEnd:
                  this.paintFormXObjectEnd();
                  break;
                case a.OPS.closePath:
                  this.closePath();
                  break;
                case a.OPS.closeStroke:
                  this.closeStroke();
                  break;
                case a.OPS.closeFillStroke:
                  this.closeFillStroke();
                  break;
                case a.OPS.nextLine:
                  this.nextLine();
                  break;
                case a.OPS.transform:
                  this.transform(h[0], h[1], h[2], h[3], h[4], h[5]);
                  break;
                case a.OPS.constructPath:
                  this.constructPath(h[0], h[1]);
                  break;
                case a.OPS.endPath:
                  this.endPath();
                  break;
                case 92:
                  this.group(b[e].items);
                  break;
                default:
                  (0, a.warn)('Unimplemented operator ' + c);
              }
            }
          },
          setWordSpacing: function(a) {
            this.current.wordSpacing = a;
          },
          setCharSpacing: function(a) {
            this.current.charSpacing = a;
          },
          nextLine: function() {
            this.moveText(0, this.current.leading);
          },
          setTextMatrix: function(a, b, e, c, n, k) {
            var g = this.current;
            this.current.textMatrix = this.current.lineMatrix = [a, b, e, c, n, k];
            this.current.x = this.current.lineX = 0;
            this.current.y = this.current.lineY = 0;
            g.xcoords = [];
            g.tspan = this.svgFactory.createElement('svg:tspan');
            g.tspan.setAttributeNS(null, 'font-family', g.fontFamily);
            g.tspan.setAttributeNS(null, 'font-size', d(g.fontSize) + 'px');
            g.tspan.setAttributeNS(null, 'y', d(-g.y));
            g.txtElement = this.svgFactory.createElement('svg:text');
            g.txtElement.appendChild(g.tspan);
          },
          beginText: function() {
            this.current.x = this.current.lineX = 0;
            this.current.y = this.current.lineY = 0;
            this.current.textMatrix = a.IDENTITY_MATRIX;
            this.current.lineMatrix = a.IDENTITY_MATRIX;
            this.current.tspan = this.svgFactory.createElement('svg:tspan');
            this.current.txtElement = this.svgFactory.createElement('svg:text');
            this.current.txtgrp = this.svgFactory.createElement('svg:g');
            this.current.xcoords = [];
          },
          moveText: function(a, b) {
            var e = this.current;
            this.current.x = this.current.lineX += a;
            this.current.y = this.current.lineY += b;
            e.xcoords = [];
            e.tspan = this.svgFactory.createElement('svg:tspan');
            e.tspan.setAttributeNS(null, 'font-family', e.fontFamily);
            e.tspan.setAttributeNS(null, 'font-size', d(e.fontSize) + 'px');
            e.tspan.setAttributeNS(null, 'y', d(-e.y));
          },
          showText: function(b) {
            var e = this.current,
              h = e.font,
              c = e.fontSize;
            if (0 !== c) {
              var n = e.charSpacing,
                k = e.wordSpacing,
                g = e.fontDirection,
                u = e.textHScale * g,
                l = b.length,
                B = h.vertical,
                f = c * e.fontMatrix[0],
                r = 0,
                D;
              for (D = 0; D < l; ++D) {
                var v = b[D];
                if (null === v) r += g * k;
                else if ((0, a.isNum)(v)) r += -v * c * 0.001;
                else {
                  var z = v.fontChar,
                    w = v.width * f + ((v.isSpace ? k : 0) + n) * g;
                  if (v.isInFont || h.missingFile) e.xcoords.push(e.x + r * u), (e.tspan.textContent += z);
                  r += w;
                }
              }
              B ? (e.y -= r * u) : (e.x += r * u);
              e.tspan.setAttributeNS(null, 'x', e.xcoords.map(d).join(' '));
              e.tspan.setAttributeNS(null, 'y', d(-e.y));
              e.tspan.setAttributeNS(null, 'font-family', e.fontFamily);
              e.tspan.setAttributeNS(null, 'font-size', d(e.fontSize) + 'px');
              'normal' !== e.fontStyle && e.tspan.setAttributeNS(null, 'font-style', e.fontStyle);
              'normal' !== e.fontWeight && e.tspan.setAttributeNS(null, 'font-weight', e.fontWeight);
              '#000000' !== e.fillColor && e.tspan.setAttributeNS(null, 'fill', e.fillColor);
              b = e.textMatrix;
              0 !== e.textRise && ((b = b.slice()), (b[5] += e.textRise));
              e.txtElement.setAttributeNS(null, 'transform', m(b) + ' scale(1, -1)');
              e.txtElement.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
              e.txtElement.appendChild(e.tspan);
              e.txtgrp.appendChild(e.txtElement);
              this._ensureTransformGroup().appendChild(e.txtElement);
            }
          },
          setLeadingMoveText: function(a, b) {
            this.setLeading(-b);
            this.moveText(a, b);
          },
          addFontStyle: function(b) {
            this.cssStyle ||
              ((this.cssStyle = this.svgFactory.createElement('svg:style')),
              this.cssStyle.setAttributeNS(null, 'type', 'text/css'),
              this.defs.appendChild(this.cssStyle));
            var d = (0, a.createObjectURL)(b.data, b.mimetype, this.forceDataSchema);
            this.cssStyle.textContent += '@font-face { font-family: "' + b.loadedName + '"; src: url(' + d + '); }\n';
          },
          setFont: function(b) {
            var e = this.current,
              h = this.commonObjs.get(b[0]);
            b = b[1];
            this.current.font = h;
            this.embedFonts &&
              h.data &&
              !this.embeddedFonts[h.loadedName] &&
              (this.addFontStyle(h), (this.embeddedFonts[h.loadedName] = h));
            e.fontMatrix = h.fontMatrix ? h.fontMatrix : a.FONT_IDENTITY_MATRIX;
            var c = h.black ? (h.bold ? 'bolder' : 'bold') : h.bold ? 'bold' : 'normal',
              n = h.italic ? 'italic' : 'normal';
            0 > b ? ((b = -b), (e.fontDirection = -1)) : (e.fontDirection = 1);
            e.fontSize = b;
            e.fontFamily = h.loadedName;
            e.fontWeight = c;
            e.fontStyle = n;
            e.tspan = this.svgFactory.createElement('svg:tspan');
            e.tspan.setAttributeNS(null, 'y', d(-e.y));
            e.xcoords = [];
          },
          endText: function() {},
          setLineWidth: function(a) {
            this.current.lineWidth = a;
          },
          setLineCap: function(a) {
            this.current.lineCap = t[a];
          },
          setLineJoin: function(a) {
            this.current.lineJoin = B[a];
          },
          setMiterLimit: function(a) {
            this.current.miterLimit = a;
          },
          setStrokeAlpha: function(a) {
            this.current.strokeAlpha = a;
          },
          setStrokeRGBColor: function(b, d, e) {
            b = a.Util.makeCssRgb(b, d, e);
            this.current.strokeColor = b;
          },
          setFillAlpha: function(a) {
            this.current.fillAlpha = a;
          },
          setFillRGBColor: function(b, d, e) {
            b = a.Util.makeCssRgb(b, d, e);
            this.current.fillColor = b;
            this.current.tspan = this.svgFactory.createElement('svg:tspan');
            this.current.xcoords = [];
          },
          setDash: function(a, b) {
            this.current.dashArray = a;
            this.current.dashPhase = b;
          },
          constructPath: function(b, e) {
            var h = this.current,
              c = h.x,
              p = h.y;
            h.path = this.svgFactory.createElement('svg:path');
            for (var n = [], g = b.length, k = 0, l = 0; k < g; k++)
              switch (b[k] | 0) {
                case a.OPS.rectangle:
                  c = e[l++];
                  p = e[l++];
                  var m = e[l++],
                    f = e[l++];
                  m = c + m;
                  f = p + f;
                  n.push('M', d(c), d(p), 'L', d(m), d(p), 'L', d(m), d(f), 'L', d(c), d(f), 'Z');
                  break;
                case a.OPS.moveTo:
                  c = e[l++];
                  p = e[l++];
                  n.push('M', d(c), d(p));
                  break;
                case a.OPS.lineTo:
                  c = e[l++];
                  p = e[l++];
                  n.push('L', d(c), d(p));
                  break;
                case a.OPS.curveTo:
                  c = e[l + 4];
                  p = e[l + 5];
                  n.push('C', d(e[l]), d(e[l + 1]), d(e[l + 2]), d(e[l + 3]), d(c), d(p));
                  l += 6;
                  break;
                case a.OPS.curveTo2:
                  c = e[l + 2];
                  p = e[l + 3];
                  n.push('C', d(c), d(p), d(e[l]), d(e[l + 1]), d(e[l + 2]), d(e[l + 3]));
                  l += 4;
                  break;
                case a.OPS.curveTo3:
                  c = e[l + 2];
                  p = e[l + 3];
                  n.push('C', d(e[l]), d(e[l + 1]), d(c), d(p), d(c), d(p));
                  l += 4;
                  break;
                case a.OPS.closePath:
                  n.push('Z');
              }
            h.path.setAttributeNS(null, 'd', n.join(' '));
            h.path.setAttributeNS(null, 'fill', 'none');
            this._ensureTransformGroup().appendChild(h.path);
            h.element = h.path;
            h.setCurrentPoint(c, p);
          },
          endPath: function() {
            if (this.pendingClip) {
              var a = this.current,
                b = 'clippath' + n;
              n++;
              var d = this.svgFactory.createElement('svg:clipPath');
              d.setAttributeNS(null, 'id', b);
              d.setAttributeNS(null, 'transform', m(this.transformMatrix));
              var c = a.element.cloneNode();
              'evenodd' === this.pendingClip
                ? c.setAttributeNS(null, 'clip-rule', 'evenodd')
                : c.setAttributeNS(null, 'clip-rule', 'nonzero');
              this.pendingClip = null;
              d.appendChild(c);
              this.defs.appendChild(d);
              a.activeClipUrl &&
                ((a.clipGroup = null),
                this.extraStack.forEach(function(a) {
                  a.clipGroup = null;
                }));
              a.activeClipUrl = 'url(#' + b + ')';
              this.tgrp = null;
            }
          },
          clip: function(a) {
            this.pendingClip = a;
          },
          closePath: function() {
            var a = this.current,
              b = a.path.getAttributeNS(null, 'd');
            a.path.setAttributeNS(null, 'd', b + 'Z');
          },
          setLeading: function(a) {
            this.current.leading = -a;
          },
          setTextRise: function(a) {
            this.current.textRise = a;
          },
          setHScale: function(a) {
            this.current.textHScale = a / 100;
          },
          setGState: function(b) {
            for (var d = 0, e = b.length; d < e; d++) {
              var c = b[d],
                h = c[0];
              c = c[1];
              switch (h) {
                case 'LW':
                  this.setLineWidth(c);
                  break;
                case 'LC':
                  this.setLineCap(c);
                  break;
                case 'LJ':
                  this.setLineJoin(c);
                  break;
                case 'ML':
                  this.setMiterLimit(c);
                  break;
                case 'D':
                  this.setDash(c[0], c[1]);
                  break;
                case 'Font':
                  this.setFont(c);
                  break;
                case 'CA':
                  this.setStrokeAlpha(c);
                  break;
                case 'ca':
                  this.setFillAlpha(c);
                  break;
                default:
                  (0, a.warn)('Unimplemented graphic state ' + h);
              }
            }
          },
          fill: function() {
            var a = this.current;
            a.element.setAttributeNS(null, 'fill', a.fillColor);
            a.element.setAttributeNS(null, 'fill-opacity', a.fillAlpha);
          },
          stroke: function() {
            var a = this.current;
            a.element.setAttributeNS(null, 'stroke', a.strokeColor);
            a.element.setAttributeNS(null, 'stroke-opacity', a.strokeAlpha);
            a.element.setAttributeNS(null, 'stroke-miterlimit', d(a.miterLimit));
            a.element.setAttributeNS(null, 'stroke-linecap', a.lineCap);
            a.element.setAttributeNS(null, 'stroke-linejoin', a.lineJoin);
            a.element.setAttributeNS(null, 'stroke-width', d(a.lineWidth) + 'px');
            a.element.setAttributeNS(null, 'stroke-dasharray', a.dashArray.map(d).join(' '));
            a.element.setAttributeNS(null, 'stroke-dashoffset', d(a.dashPhase) + 'px');
            a.element.setAttributeNS(null, 'fill', 'none');
          },
          eoFill: function() {
            this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
            this.fill();
          },
          fillStroke: function() {
            this.stroke();
            this.fill();
          },
          eoFillStroke: function() {
            this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
            this.fillStroke();
          },
          closeStroke: function() {
            this.closePath();
            this.stroke();
          },
          closeFillStroke: function() {
            this.closePath();
            this.fillStroke();
          },
          paintSolidColorImageMask: function() {
            var a = this.current,
              b = this.svgFactory.createElement('svg:rect');
            b.setAttributeNS(null, 'x', '0');
            b.setAttributeNS(null, 'y', '0');
            b.setAttributeNS(null, 'width', '1px');
            b.setAttributeNS(null, 'height', '1px');
            b.setAttributeNS(null, 'fill', a.fillColor);
            this._ensureTransformGroup().appendChild(b);
          },
          paintJpegXObject: function(a, b, e) {
            a = this.objs.get(a);
            var c = this.svgFactory.createElement('svg:image');
            c.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', a.src);
            c.setAttributeNS(null, 'width', d(b));
            c.setAttributeNS(null, 'height', d(e));
            c.setAttributeNS(null, 'x', '0');
            c.setAttributeNS(null, 'y', d(-e));
            c.setAttributeNS(null, 'transform', 'scale(' + d(1 / b) + ' ' + d(-1 / e) + ')');
            this._ensureTransformGroup().appendChild(c);
          },
          paintImageXObject: function(b) {
            (b = this.objs.get(b)) ? this.paintInlineImageXObject(b) : (0, a.warn)("Dependent image isn't ready yet");
          },
          paintInlineImageXObject: function(a, e) {
            var h = a.width,
              c = a.height,
              p = b(a, this.forceDataSchema),
              n = this.svgFactory.createElement('svg:rect');
            n.setAttributeNS(null, 'x', '0');
            n.setAttributeNS(null, 'y', '0');
            n.setAttributeNS(null, 'width', d(h));
            n.setAttributeNS(null, 'height', d(c));
            this.current.element = n;
            this.clip('nonzero');
            n = this.svgFactory.createElement('svg:image');
            n.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', p);
            n.setAttributeNS(null, 'x', '0');
            n.setAttributeNS(null, 'y', d(-c));
            n.setAttributeNS(null, 'width', d(h) + 'px');
            n.setAttributeNS(null, 'height', d(c) + 'px');
            n.setAttributeNS(null, 'transform', 'scale(' + d(1 / h) + ' ' + d(-1 / c) + ')');
            e ? e.appendChild(n) : this._ensureTransformGroup().appendChild(n);
          },
          paintImageMaskXObject: function(a) {
            var b = this.current,
              h = a.width,
              c = a.height,
              n = b.fillColor;
            b.maskId = 'mask' + e++;
            var k = this.svgFactory.createElement('svg:mask');
            k.setAttributeNS(null, 'id', b.maskId);
            var g = this.svgFactory.createElement('svg:rect');
            g.setAttributeNS(null, 'x', '0');
            g.setAttributeNS(null, 'y', '0');
            g.setAttributeNS(null, 'width', d(h));
            g.setAttributeNS(null, 'height', d(c));
            g.setAttributeNS(null, 'fill', n);
            g.setAttributeNS(null, 'mask', 'url(#' + b.maskId + ')');
            this.defs.appendChild(k);
            this._ensureTransformGroup().appendChild(g);
            this.paintInlineImageXObject(a, k);
          },
          paintFormXObjectBegin: function(a, b) {
            Array.isArray(a) && 6 === a.length && this.transform(a[0], a[1], a[2], a[3], a[4], a[5]);
            if (Array.isArray(b) && 4 === b.length) {
              var e = b[2] - b[0],
                c = b[3] - b[1],
                n = this.svgFactory.createElement('svg:rect');
              n.setAttributeNS(null, 'x', b[0]);
              n.setAttributeNS(null, 'y', b[1]);
              n.setAttributeNS(null, 'width', d(e));
              n.setAttributeNS(null, 'height', d(c));
              this.current.element = n;
              this.clip('nonzero');
              this.endPath();
            }
          },
          paintFormXObjectEnd: function() {},
          _initialize: function(a) {
            var b = this.svgFactory.create(a.width, a.height),
              d = this.svgFactory.createElement('svg:defs');
            b.appendChild(d);
            this.defs = d;
            d = this.svgFactory.createElement('svg:g');
            d.setAttributeNS(null, 'transform', m(a.transform));
            b.appendChild(d);
            this.svg = d;
            return b;
          },
          _ensureClipGroup: function() {
            if (!this.current.clipGroup) {
              var a = this.svgFactory.createElement('svg:g');
              a.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
              this.svg.appendChild(a);
              this.current.clipGroup = a;
            }
            return this.current.clipGroup;
          },
          _ensureTransformGroup: function() {
            this.tgrp ||
              ((this.tgrp = this.svgFactory.createElement('svg:g')),
              this.tgrp.setAttributeNS(null, 'transform', m(this.transformMatrix)),
              this.current.activeClipUrl
                ? this._ensureClipGroup().appendChild(this.tgrp)
                : this.svg.appendChild(this.tgrp));
            return this.tgrp;
          },
        };
        return z;
      })();
      m.SVGGraphics = y;
    },
    function(y, m, t) {
      y = t(0);
      var a = t(98),
        k = t(55),
        b = t(68),
        v = t(67),
        d = t(7),
        u = t(69);
      y.isNodeJS()
        ? ((t = t(120).PDFNodeStream), k.setPDFNetworkStreamClass(t))
        : 'undefined' !== typeof Response && 'body' in Response.prototype && 'undefined' !== typeof ReadableStream
        ? ((t = t(121).PDFFetchStream), k.setPDFNetworkStreamClass(t))
        : ((t = t(122).PDFNetworkStream), k.setPDFNetworkStreamClass(t));
      m.PDFJS = a.PDFJS;
      m.build = k.build;
      m.version = k.version;
      m.getDocument = k.getDocument;
      m.LoopbackPort = k.LoopbackPort;
      m.PDFDataRangeTransport = k.PDFDataRangeTransport;
      m.PDFWorker = k.PDFWorker;
      m.renderTextLayer = b.renderTextLayer;
      m.AnnotationLayer = v.AnnotationLayer;
      m.CustomStyle = d.CustomStyle;
      m.createPromiseCapability = y.createPromiseCapability;
      m.PasswordResponses = y.PasswordResponses;
      m.InvalidPDFException = y.InvalidPDFException;
      m.MissingPDFException = y.MissingPDFException;
      m.SVGGraphics = u.SVGGraphics;
      m.NativeImageDecoding = y.NativeImageDecoding;
      m.UnexpectedResponseException = y.UnexpectedResponseException;
      m.OPS = y.OPS;
      m.UNSUPPORTED_FEATURES = y.UNSUPPORTED_FEATURES;
      m.isValidUrl = d.isValidUrl;
      m.createValidAbsoluteUrl = y.createValidAbsoluteUrl;
      m.createObjectURL = y.createObjectURL;
      m.removeNullCharacters = y.removeNullCharacters;
      m.shadow = y.shadow;
      m.createBlob = y.createBlob;
      m.RenderingCancelledException = d.RenderingCancelledException;
      m.getFilenameFromUrl = d.getFilenameFromUrl;
      m.addLinkAttributes = d.addLinkAttributes;
      m.StatTimer = y.StatTimer;
    },
    function(y, m, t) {
      var a =
        'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
          ? function(a) {
              return typeof a;
            }
          : function(a) {
              return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                ? 'symbol'
                : typeof a;
            };
      if ('undefined' === typeof PDFJS || !PDFJS.compatibilityChecked) {
        var k = t(11),
          b = ('undefined' !== typeof navigator && navigator.userAgent) || '',
          v = /Android/.test(b);
        y = /Android\s[0-2][^\d]/.test(b);
        var d = /Android\s[0-4][^\d]/.test(b),
          u = 0 <= b.indexOf('Chrom');
        m = /Chrome\/(39|40)\./.test(b);
        var z = 0 <= b.indexOf('CriOS'),
          C = 0 <= b.indexOf('Trident'),
          B = /\b(iPad|iPhone|iPod)(?=;)/.test(b),
          n = 0 <= b.indexOf('Opera'),
          e = /Safari\//.test(b) && !/(Chrome\/|Android\s)/.test(b),
          h =
            'object' === ('undefined' === typeof window ? 'undefined' : a(window)) &&
            'object' === ('undefined' === typeof document ? 'undefined' : a(document));
        'undefined' === typeof PDFJS && (k.PDFJS = {});
        PDFJS.compatibilityChecked = !0;
        (function() {
          function b(a, b) {
            return new n(this.slice(a, b));
          }
          function d(a, b) {
            2 > arguments.length && (b = 0);
            for (var c = 0, d = a.length; c < d; ++c, ++b) this[b] = a[c] & 255;
          }
          function c(a, b) {
            this.buffer = a;
            this.byteLength = a.length;
            for (var d = (this.length = b); g < d; ) Object.defineProperty(c.prototype, g, e(g)), g++;
          }
          function e(a) {
            return {
              get: function() {
                var b = this.buffer,
                  c = a << 2;
                return (b[c] | (b[c + 1] << 8) | (b[c + 2] << 16) | (b[c + 3] << 24)) >>> 0;
              },
              set: function(b) {
                var c = this.buffer,
                  d = a << 2;
                c[d] = b & 255;
                c[d + 1] = (b >> 8) & 255;
                c[d + 2] = (b >> 16) & 255;
                c[d + 3] = (b >>> 24) & 255;
              },
            };
          }
          function n(c) {
            var e, g;
            if ('number' === typeof c) {
              var f = [];
              for (e = 0; e < c; ++e) f[e] = 0;
            } else if ('slice' in c) f = c.slice(0);
            else for (f = [], e = 0, g = c.length; e < g; ++e) f[e] = c[e];
            f.subarray = b;
            f.buffer = f;
            f.byteLength = f.length;
            f.set = d;
            'object' === ('undefined' === typeof c ? 'undefined' : a(c)) && c.buffer && (f.buffer = c.buffer);
            return f;
          }
          'undefined' === typeof Uint8ClampedArray && (k.Uint8ClampedArray = t(72));
          if ('undefined' !== typeof Uint8Array)
            'undefined' === typeof Uint8Array.prototype.subarray &&
              ((Uint8Array.prototype.subarray = function(a, b) {
                return new Uint8Array(this.slice(a, b));
              }),
              (Float32Array.prototype.subarray = function(a, b) {
                return new Float32Array(this.slice(a, b));
              })),
              'undefined' === typeof Float64Array && (k.Float64Array = Float32Array);
          else {
            c.prototype = Object.create(null);
            var g = 0;
            k.Uint8Array = n;
            k.Int8Array = n;
            k.Int32Array = n;
            k.Uint16Array = n;
            k.Float32Array = n;
            k.Float64Array = n;
            k.Uint32Array = function() {
              if (3 === arguments.length) {
                if (0 !== arguments[1]) throw Error('offset !== 0 is not supported');
                return new c(arguments[0], arguments[2]);
              }
              return n.apply(this, arguments);
            };
          }
        })();
        (function() {
          if (h && window.CanvasPixelArray) {
            var a = window.CanvasPixelArray.prototype;
            'buffer' in a ||
              (Object.defineProperty(a, 'buffer', {
                get: function() {
                  return this;
                },
                enumerable: !1,
                configurable: !0,
              }),
              Object.defineProperty(a, 'byteLength', {
                get: function() {
                  return this.length;
                },
                enumerable: !1,
                configurable: !0,
              }));
          }
        })();
        k.URL || (k.URL = k.webkitURL);
        (function() {
          if ('undefined' !== typeof Object.defineProperty) {
            var a = !0;
            try {
              h && Object.defineProperty(new Image(), 'id', { value: 'test' });
              var b = function() {};
              b.prototype = { get id() {} };
              Object.defineProperty(new b(), 'id', { value: '', configurable: !0, enumerable: !0, writable: !1 });
            } catch (c) {
              a = !1;
            }
            if (a) return;
          }
          Object.defineProperty = function(a, b, d) {
            delete a[b];
            'get' in d && a.__defineGetter__(b, d.get);
            'set' in d && a.__defineSetter__(b, d.set);
            'value' in d &&
              (a.__defineSetter__(b, function(a) {
                this.__defineGetter__(b, function() {
                  return a;
                });
                return a;
              }),
              (a[b] = d.value));
          };
        })();
        (function() {
          if ('undefined' !== typeof XMLHttpRequest) {
            var a = XMLHttpRequest.prototype,
              b = new XMLHttpRequest();
            'overrideMimeType' in b || Object.defineProperty(a, 'overrideMimeType', { value: function(a) {} });
            'responseType' in b ||
              (Object.defineProperty(a, 'responseType', {
                get: function() {
                  return this._responseType || 'text';
                },
                set: function(a) {
                  if ('text' === a || 'arraybuffer' === a)
                    (this._responseType = a),
                      'arraybuffer' === a &&
                        'function' === typeof this.overrideMimeType &&
                        this.overrideMimeType('text/plain; charset=x-user-defined');
                },
              }),
              'undefined' !== typeof VBArray
                ? Object.defineProperty(a, 'response', {
                    get: function() {
                      return 'arraybuffer' === this.responseType
                        ? new Uint8Array(new VBArray(this.responseBody).toArray())
                        : this.responseText;
                    },
                  })
                : Object.defineProperty(a, 'response', {
                    get: function() {
                      if ('arraybuffer' !== this.responseType) return this.responseText;
                      var a = this.responseText,
                        b,
                        d = a.length,
                        e = new Uint8Array(d);
                      for (b = 0; b < d; ++b) e[b] = a.charCodeAt(b) & 255;
                      return e.buffer;
                    },
                  }));
          }
        })();
        (function() {
          'btoa' in k ||
            (k.btoa = function(a) {
              var b = '',
                c;
              var d = 0;
              for (c = a.length; d < c; d += 3) {
                var e = a.charCodeAt(d) & 255,
                  g = a.charCodeAt(d + 1) & 255,
                  n = a.charCodeAt(d + 2) & 255,
                  l = ((e & 3) << 4) | (g >> 4);
                g = d + 1 < c ? ((g & 15) << 2) | (n >> 6) : 64;
                n = d + 2 < c ? n & 63 : 64;
                b +=
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.charAt(e >> 2) +
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.charAt(l) +
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.charAt(g) +
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.charAt(n);
              }
              return b;
            });
        })();
        (function() {
          'atob' in k ||
            (k.atob = function(a) {
              a = a.replace(/=+$/, '');
              if (1 === a.length % 4) throw Error('bad atob input');
              for (
                var b = 0, c, d, e = 0, g = '';
                (d = a.charAt(e++));
                ~d && ((c = b % 4 ? 64 * c + d : d), b++ % 4)
                  ? (g += String.fromCharCode(255 & (c >> ((-2 * b) & 6))))
                  : 0
              )
                d = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.indexOf(d);
              return g;
            });
        })();
        (function() {
          'undefined' === typeof Function.prototype.bind &&
            (Function.prototype.bind = function(a) {
              var b = this,
                c = Array.prototype.slice.call(arguments, 1);
              return function() {
                var d = c.concat(Array.prototype.slice.call(arguments));
                return b.apply(a, d);
              };
            });
        })();
        (function() {
          h &&
            ('dataset' in document.createElement('div') ||
              Object.defineProperty(HTMLElement.prototype, 'dataset', {
                get: function() {
                  if (this._dataset) return this._dataset;
                  for (var a = {}, b = 0, c = this.attributes.length; b < c; b++) {
                    var d = this.attributes[b];
                    if ('data-' === d.name.substring(0, 5)) {
                      var e = d.name.substring(5).replace(/\-([a-z])/g, function(a, b) {
                        return b.toUpperCase();
                      });
                      a[e] = d.value;
                    }
                  }
                  Object.defineProperty(this, '_dataset', { value: a, writable: !1, enumerable: !1 });
                  return a;
                },
                enumerable: !0,
              }));
        })();
        (function() {
          function a(a, b, d, e) {
            var c = (a.className || '').split(/\s+/g);
            '' === c[0] && c.shift();
            var g = c.indexOf(b);
            0 > g && d && c.push(b);
            0 <= g && e && c.splice(g, 1);
            a.className = c.join(' ');
            return 0 <= g;
          }
          if (h && !('classList' in document.createElement('div'))) {
            var b = {
              add: function(b) {
                a(this.element, b, !0, !1);
              },
              contains: function(b) {
                return a(this.element, b, !1, !1);
              },
              remove: function(b) {
                a(this.element, b, !1, !0);
              },
              toggle: function(b) {
                a(this.element, b, !0, !0);
              },
            };
            Object.defineProperty(HTMLElement.prototype, 'classList', {
              get: function() {
                if (this._classList) return this._classList;
                var a = Object.create(b, { element: { value: this, writable: !1, enumerable: !0 } });
                Object.defineProperty(this, '_classList', { value: a, writable: !1, enumerable: !1 });
                return a;
              },
              enumerable: !0,
            });
          }
        })();
        (function() {
          if (!('undefined' === typeof importScripts || 'console' in k)) {
            var a = {};
            k.console = {
              log: function() {
                var a = Array.prototype.slice.call(arguments);
                k.postMessage({ targetName: 'main', action: 'console_log', data: a });
              },
              error: function() {
                var a = Array.prototype.slice.call(arguments);
                k.postMessage({ targetName: 'main', action: 'console_error', data: a });
              },
              time: function(b) {
                a[b] = Date.now();
              },
              timeEnd: function(b) {
                var c = a[b];
                if (!c) throw Error('Unknown timer name ' + b);
                this.log('Timer:', b, Date.now() - c);
              },
            };
          }
        })();
        (function() {
          h &&
            ('console' in window
              ? 'bind' in console.log ||
                ((console.log = (function(a) {
                  return function(b) {
                    return a(b);
                  };
                })(console.log)),
                (console.error = (function(a) {
                  return function(b) {
                    return a(b);
                  };
                })(console.error)),
                (console.warn = (function(a) {
                  return function(b) {
                    return a(b);
                  };
                })(console.warn)))
              : (window.console = { log: function() {}, error: function() {}, warn: function() {} }));
        })();
        (function() {
          function a(a) {
            b(a.target) && a.stopPropagation();
          }
          function b(a) {
            return a.disabled || (a.parentNode && b(a.parentNode));
          }
          n && document.addEventListener('click', a, !0);
        })();
        if (C || z) PDFJS.disableCreateObjectURL = !0;
        'undefined' === typeof navigator ||
          'language' in navigator ||
          (PDFJS.locale = navigator.userLanguage || 'en-US');
        if (e || y || m || B) (PDFJS.disableRange = !0), (PDFJS.disableStream = !0);
        !h || (history.pushState && !y) || (PDFJS.disableHistory = !0);
        (function() {
          if (h)
            if (window.CanvasPixelArray)
              'function' !== typeof window.CanvasPixelArray.prototype.set &&
                (window.CanvasPixelArray.prototype.set = function(a) {
                  for (var b = 0, c = this.length; b < c; b++) this[b] = a[b];
                });
            else {
              var a = !1;
              u
                ? (a = (a = b.match(/Chrom(e|ium)\/([0-9]+)\./)) && 21 > parseInt(a[2]))
                : v
                ? (a = d)
                : e && (a = (a = b.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//)) && 6 > parseInt(a[1]));
              if (a) {
                a = window.CanvasRenderingContext2D.prototype;
                var n = a.createImageData;
                a.createImageData = function(a, b) {
                  var c = n.call(this, a, b);
                  c.data.set = function(a) {
                    for (var b = 0, c = this.length; b < c; b++) this[b] = a[b];
                  };
                  return c;
                };
                a = null;
              }
            }
        })();
        (function() {
          function a() {
            window.requestAnimationFrame = function(a) {
              return window.setTimeout(a, 20);
            };
            window.cancelAnimationFrame = function(a) {
              window.clearTimeout(a);
            };
          }
          h &&
            (B
              ? a()
              : 'requestAnimationFrame' in window ||
                ((window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame),
                window.requestAnimationFrame || a()));
        })();
        if (B || v) PDFJS.maxCanvasPixels = 5242880;
        h && C && window.parent !== window && (PDFJS.disableFullscreen = !0);
        (function() {
          h &&
            ('currentScript' in document ||
              Object.defineProperty(document, 'currentScript', {
                get: function() {
                  var a = document.getElementsByTagName('script');
                  return a[a.length - 1];
                },
                enumerable: !0,
                configurable: !0,
              }));
        })();
        (function() {
          if (h) {
            var a = document.createElement('input');
            try {
              a.type = 'number';
            } catch (c) {
              a = a.constructor.prototype;
              var b = Object.getOwnPropertyDescriptor(a, 'type');
              Object.defineProperty(a, 'type', {
                get: function() {
                  return b.get.call(this);
                },
                set: function(a) {
                  b.set.call(this, 'number' === a ? 'text' : a);
                },
                enumerable: !0,
                configurable: !0,
              });
            }
          }
        })();
        (function() {
          if (h && document.attachEvent) {
            var a = document.constructor.prototype,
              b = Object.getOwnPropertyDescriptor(a, 'readyState');
            Object.defineProperty(a, 'readyState', {
              get: function() {
                var a = b.get.call(this);
                return 'interactive' === a ? 'loading' : a;
              },
              set: function(a) {
                b.set.call(this, a);
              },
              enumerable: !0,
              configurable: !0,
            });
          }
        })();
        (function() {
          h &&
            'undefined' === typeof Element.prototype.remove &&
            (Element.prototype.remove = function() {
              this.parentNode && this.parentNode.removeChild(this);
            });
        })();
        (function() {
          Number.isNaN ||
            (Number.isNaN = function(a) {
              return 'number' === typeof a && isNaN(a);
            });
        })();
        (function() {
          Number.isInteger ||
            (Number.isInteger = function(a) {
              return 'number' === typeof a && isFinite(a) && Math.floor(a) === a;
            });
        })();
        (function() {
          if (k.Promise)
            'function' !== typeof k.Promise.all &&
              (k.Promise.all = function(a) {
                var b = 0,
                  c = [],
                  d,
                  e,
                  l = new k.Promise(function(a, b) {
                    d = a;
                    e = b;
                  });
                a.forEach(function(a, f) {
                  b++;
                  a.then(function(a) {
                    c[f] = a;
                    b--;
                    0 === b && d(c);
                  }, e);
                });
                0 === b && d(c);
                return l;
              }),
              'function' !== typeof k.Promise.resolve &&
                (k.Promise.resolve = function(a) {
                  return new k.Promise(function(b) {
                    b(a);
                  });
                }),
              'function' !== typeof k.Promise.reject &&
                (k.Promise.reject = function(a) {
                  return new k.Promise(function(b, c) {
                    c(a);
                  });
                }),
              'function' !== typeof k.Promise.prototype['catch'] &&
                (k.Promise.prototype['catch'] = function(a) {
                  return k.Promise.prototype.then(void 0, a);
                });
          else {
            var a = {
                handlers: [],
                running: !1,
                unhandledRejections: [],
                pendingRejectionCheck: !1,
                scheduleHandlers: function(a) {
                  0 !== a._status &&
                    ((this.handlers = this.handlers.concat(a._handlers)),
                    (a._handlers = []),
                    this.running || ((this.running = !0), setTimeout(this.runHandlers.bind(this), 0)));
                },
                runHandlers: function() {
                  for (var a = Date.now() + 1; 0 < this.handlers.length; ) {
                    var b = this.handlers.shift(),
                      d = b.thisPromise._status,
                      e = b.thisPromise._value;
                    try {
                      1 === d
                        ? 'function' === typeof b.onResolve && (e = b.onResolve(e))
                        : 'function' === typeof b.onReject &&
                          ((e = b.onReject(e)),
                          (d = 1),
                          b.thisPromise._unhandledRejection && this.removeUnhandeledRejection(b.thisPromise));
                    } catch (G) {
                      (d = 2), (e = G);
                    }
                    b.nextPromise._updateStatus(d, e);
                    if (Date.now() >= a) break;
                  }
                  0 < this.handlers.length ? setTimeout(this.runHandlers.bind(this), 0) : (this.running = !1);
                },
                addUnhandledRejection: function(a) {
                  this.unhandledRejections.push({ promise: a, time: Date.now() });
                  this.scheduleRejectionCheck();
                },
                removeUnhandeledRejection: function(a) {
                  a._unhandledRejection = !1;
                  for (var b = 0; b < this.unhandledRejections.length; b++)
                    this.unhandledRejections[b].promise === a && (this.unhandledRejections.splice(b), b--);
                },
                scheduleRejectionCheck: function() {
                  var a = this;
                  this.pendingRejectionCheck ||
                    ((this.pendingRejectionCheck = !0),
                    setTimeout(function() {
                      a.pendingRejectionCheck = !1;
                      for (var b = Date.now(), c = 0; c < a.unhandledRejections.length; c++)
                        if (500 < b - a.unhandledRejections[c].time) {
                          var d = a.unhandledRejections[c].promise._value,
                            e = 'Unhandled rejection: ' + d;
                          d.stack && (e += '\n' + d.stack);
                          try {
                            throw Error(e);
                          } catch (l) {
                            console.warn(e);
                          }
                          a.unhandledRejections.splice(c);
                          c--;
                        }
                      a.unhandledRejections.length && a.scheduleRejectionCheck();
                    }, 500));
                },
              },
              b = function(a) {
                this._status = 0;
                this._handlers = [];
                try {
                  a.call(this, this._resolve.bind(this), this._reject.bind(this));
                } catch (q) {
                  this._reject(q);
                }
              };
            b.all = function(a) {
              function c(a) {
                2 !== n._status && ((h = []), e(a));
              }
              var d,
                e,
                n = new b(function(a, b) {
                  d = a;
                  e = b;
                }),
                l = a.length,
                h = [];
              if (0 === l) return d(h), n;
              for (var f = 0, r = a.length; f < r; ++f) {
                var p = a[f],
                  k = (function(a) {
                    return function(b) {
                      2 !== n._status && ((h[a] = b), l--, 0 === l && d(h));
                    };
                  })(f);
                b.isPromise(p) ? p.then(k, c) : k(p);
              }
              return n;
            };
            b.isPromise = function(a) {
              return a && 'function' === typeof a.then;
            };
            b.resolve = function(a) {
              return new b(function(b) {
                b(a);
              });
            };
            b.reject = function(a) {
              return new b(function(b, c) {
                c(a);
              });
            };
            b.prototype = {
              _status: null,
              _value: null,
              _handlers: null,
              _unhandledRejection: null,
              _updateStatus: function(c, d) {
                1 !== this._status &&
                  2 !== this._status &&
                  (1 === c && b.isPromise(d)
                    ? d.then(this._updateStatus.bind(this, 1), this._updateStatus.bind(this, 2))
                    : ((this._status = c),
                      (this._value = d),
                      2 === c &&
                        0 === this._handlers.length &&
                        ((this._unhandledRejection = !0), a.addUnhandledRejection(this)),
                      a.scheduleHandlers(this)));
              },
              _resolve: function(a) {
                this._updateStatus(1, a);
              },
              _reject: function(a) {
                this._updateStatus(2, a);
              },
              then: function(c, d) {
                var e = new b(function(a, b) {
                  this.resolve = a;
                  this.reject = b;
                });
                this._handlers.push({ thisPromise: this, onResolve: c, onReject: d, nextPromise: e });
                a.scheduleHandlers(this);
                return e;
              },
              catch: function(a) {
                return this.then(void 0, a);
              },
            };
            k.Promise = b;
          }
        })();
        (function() {
          function b() {
            this.id = '$weakmap' + d++;
          }
          if (!k.WeakMap) {
            var d = 0;
            b.prototype = {
              has: function(b) {
                return ('object' !== ('undefined' === typeof b ? 'undefined' : a(b)) && 'function' !== typeof b) ||
                  null === b
                  ? !1
                  : !!Object.getOwnPropertyDescriptor(b, this.id);
              },
              get: function(a) {
                return this.has(a) ? a[this.id] : void 0;
              },
              set: function(a, b) {
                Object.defineProperty(a, this.id, { value: b, enumerable: !1, configurable: !0 });
              },
              delete: function(a) {
                delete a[this.id];
              },
            };
            k.WeakMap = b;
          }
        })();
        (function() {
          function b(a) {
            '' === a && (n.call(this), (this._isInvalid = !0));
            return a.toLowerCase();
          }
          function d(a) {
            var b = a.charCodeAt(0);
            return 32 < b && 127 > b && -1 === [34, 35, 60, 62, 63, 96].indexOf(b) ? a : encodeURIComponent(a);
          }
          function c(a) {
            var b = a.charCodeAt(0);
            return 32 < b && 127 > b && -1 === [34, 35, 60, 62, 96].indexOf(b) ? a : encodeURIComponent(a);
          }
          function e(a, e, g) {
            function l(a) {
              A.push(a);
            }
            var h = e || 'scheme start',
              p = 0,
              q = '',
              k = !1,
              w = !1,
              A = [];
            a: for (; (a[p - 1] !== r || 0 === p) && !this._isInvalid; ) {
              var x = a[p];
              switch (h) {
                case 'scheme start':
                  if (x && u.test(x)) (q += x.toLowerCase()), (h = 'scheme');
                  else if (e) {
                    l('Invalid scheme.');
                    break a;
                  } else {
                    q = '';
                    h = 'no scheme';
                    continue;
                  }
                  break;
                case 'scheme':
                  if (x && B.test(x)) q += x.toLowerCase();
                  else if (':' === x) {
                    this._scheme = q;
                    q = '';
                    if (e) break a;
                    void 0 !== m[this._scheme] && (this._isRelative = !0);
                    h =
                      'file' === this._scheme
                        ? 'relative'
                        : this._isRelative && g && g._scheme === this._scheme
                        ? 'relative or authority'
                        : this._isRelative
                        ? 'authority first slash'
                        : 'scheme data';
                  } else if (e) {
                    x !== r && l('Code point not allowed in scheme: ' + x);
                    break a;
                  } else {
                    q = '';
                    p = 0;
                    h = 'no scheme';
                    continue;
                  }
                  break;
                case 'scheme data':
                  '?' === x
                    ? ((this._query = '?'), (h = 'query'))
                    : '#' === x
                    ? ((this._fragment = '#'), (h = 'fragment'))
                    : x !== r && '\t' !== x && '\n' !== x && '\r' !== x && (this._schemeData += d(x));
                  break;
                case 'no scheme':
                  if (g && void 0 !== m[g._scheme]) {
                    h = 'relative';
                    continue;
                  } else l('Missing scheme.'), n.call(this), (this._isInvalid = !0);
                  break;
                case 'relative or authority':
                  if ('/' === x && '/' === a[p + 1]) h = 'authority ignore slashes';
                  else {
                    l('Expected /, got: ' + x);
                    h = 'relative';
                    continue;
                  }
                  break;
                case 'relative':
                  this._isRelative = !0;
                  'file' !== this._scheme && (this._scheme = g._scheme);
                  if (x === r) {
                    this._host = g._host;
                    this._port = g._port;
                    this._path = g._path.slice();
                    this._query = g._query;
                    this._username = g._username;
                    this._password = g._password;
                    break a;
                  } else if ('/' === x || '\\' === x)
                    '\\' === x && l('\\ is an invalid code point.'), (h = 'relative slash');
                  else if ('?' === x)
                    (this._host = g._host),
                      (this._port = g._port),
                      (this._path = g._path.slice()),
                      (this._query = '?'),
                      (this._username = g._username),
                      (this._password = g._password),
                      (h = 'query');
                  else if ('#' === x)
                    (this._host = g._host),
                      (this._port = g._port),
                      (this._path = g._path.slice()),
                      (this._query = g._query),
                      (this._fragment = '#'),
                      (this._username = g._username),
                      (this._password = g._password),
                      (h = 'fragment');
                  else {
                    h = a[p + 1];
                    var v = a[p + 2];
                    if (
                      'file' !== this._scheme ||
                      !u.test(x) ||
                      (':' !== h && '|' !== h) ||
                      (v !== r && '/' !== v && '\\' !== v && '?' !== v && '#' !== v)
                    )
                      (this._host = g._host),
                        (this._port = g._port),
                        (this._username = g._username),
                        (this._password = g._password),
                        (this._path = g._path.slice()),
                        this._path.pop();
                    h = 'relative path';
                    continue;
                  }
                  break;
                case 'relative slash':
                  if ('/' === x || '\\' === x)
                    '\\' === x && l('\\ is an invalid code point.'),
                      (h = 'file' === this._scheme ? 'file host' : 'authority ignore slashes');
                  else {
                    'file' !== this._scheme &&
                      ((this._host = g._host),
                      (this._port = g._port),
                      (this._username = g._username),
                      (this._password = g._password));
                    h = 'relative path';
                    continue;
                  }
                  break;
                case 'authority first slash':
                  if ('/' === x) h = 'authority second slash';
                  else {
                    l("Expected '/', got: " + x);
                    h = 'authority ignore slashes';
                    continue;
                  }
                  break;
                case 'authority second slash':
                  h = 'authority ignore slashes';
                  if ('/' !== x) {
                    l("Expected '/', got: " + x);
                    continue;
                  }
                  break;
                case 'authority ignore slashes':
                  if ('/' !== x && '\\' !== x) {
                    h = 'authority';
                    continue;
                  } else l('Expected authority, got: ' + x);
                  break;
                case 'authority':
                  if ('@' === x) {
                    k && (l('@ already seen.'), (q += '%40'));
                    k = !0;
                    for (x = 0; x < q.length; x++)
                      (v = q[x]),
                        '\t' === v || '\n' === v || '\r' === v
                          ? l('Invalid whitespace in authority.')
                          : ':' === v && null === this._password
                          ? (this._password = '')
                          : ((v = d(v)), null !== this._password ? (this._password += v) : (this._username += v));
                    q = '';
                  } else if (x === r || '/' === x || '\\' === x || '?' === x || '#' === x) {
                    p -= q.length;
                    q = '';
                    h = 'host';
                    continue;
                  } else q += x;
                  break;
                case 'file host':
                  if (x === r || '/' === x || '\\' === x || '?' === x || '#' === x) {
                    2 !== q.length || !u.test(q[0]) || (':' !== q[1] && '|' !== q[1])
                      ? (0 !== q.length && ((this._host = b.call(this, q)), (q = '')), (h = 'relative path start'))
                      : (h = 'relative path');
                    continue;
                  } else '\t' === x || '\n' === x || '\r' === x ? l('Invalid whitespace in file host.') : (q += x);
                  break;
                case 'host':
                case 'hostname':
                  if (':' !== x || w)
                    if (x === r || '/' === x || '\\' === x || '?' === x || '#' === x) {
                      this._host = b.call(this, q);
                      q = '';
                      h = 'relative path start';
                      if (e) break a;
                      continue;
                    } else
                      '\t' !== x && '\n' !== x && '\r' !== x
                        ? ('[' === x ? (w = !0) : ']' === x && (w = !1), (q += x))
                        : l('Invalid code point in host/hostname: ' + x);
                  else if (((this._host = b.call(this, q)), (q = ''), (h = 'port'), 'hostname' === e)) break a;
                  break;
                case 'port':
                  if (/[0-9]/.test(x)) q += x;
                  else if (x === r || '/' === x || '\\' === x || '?' === x || '#' === x || e) {
                    '' !== q && ((q = parseInt(q, 10)), q !== m[this._scheme] && (this._port = q + ''), (q = ''));
                    if (e) break a;
                    h = 'relative path start';
                    continue;
                  } else
                    '\t' === x || '\n' === x || '\r' === x
                      ? l('Invalid code point in port: ' + x)
                      : (n.call(this), (this._isInvalid = !0));
                  break;
                case 'relative path start':
                  '\\' === x && l("'\\' not allowed in path.");
                  h = 'relative path';
                  if ('/' !== x && '\\' !== x) continue;
                  break;
                case 'relative path':
                  if (x !== r && '/' !== x && '\\' !== x && (e || ('?' !== x && '#' !== x)))
                    '\t' !== x && '\n' !== x && '\r' !== x && (q += d(x));
                  else {
                    '\\' === x && l('\\ not allowed in relative path.');
                    if ((v = f[q.toLowerCase()])) q = v;
                    '..' === q
                      ? (this._path.pop(), '/' !== x && '\\' !== x && this._path.push(''))
                      : '.' === q && '/' !== x && '\\' !== x
                      ? this._path.push('')
                      : '.' !== q &&
                        ('file' === this._scheme &&
                          0 === this._path.length &&
                          2 === q.length &&
                          u.test(q[0]) &&
                          '|' === q[1] &&
                          (q = q[0] + ':'),
                        this._path.push(q));
                    q = '';
                    '?' === x
                      ? ((this._query = '?'), (h = 'query'))
                      : '#' === x && ((this._fragment = '#'), (h = 'fragment'));
                  }
                  break;
                case 'query':
                  e || '#' !== x
                    ? x !== r && '\t' !== x && '\n' !== x && '\r' !== x && (this._query += c(x))
                    : ((this._fragment = '#'), (h = 'fragment'));
                  break;
                case 'fragment':
                  x !== r && '\t' !== x && '\n' !== x && '\r' !== x && (this._fragment += x);
              }
              p++;
            }
          }
          function n() {
            this._username = this._schemeData = this._scheme = '';
            this._password = null;
            this._port = this._host = '';
            this._path = [];
            this._fragment = this._query = '';
            this._isRelative = this._isInvalid = !1;
          }
          function g(a, b) {
            void 0 === b || b instanceof g || (b = new g(String(b)));
            this._url = a;
            n.call(this);
            var c = a.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
            e.call(this, c, null, b);
          }
          var h = !1;
          try {
            if ('function' === typeof URL && 'object' === a(URL.prototype) && 'origin' in URL.prototype) {
              var l = new URL('b', 'http://a');
              l.pathname = 'c%20d';
              h = 'http://a/c%20d' === l.href;
            }
          } catch (w) {}
          if (!h) {
            var m = Object.create(null);
            m.ftp = 21;
            m.file = 0;
            m.gopher = 70;
            m.http = 80;
            m.https = 443;
            m.ws = 80;
            m.wss = 443;
            var f = Object.create(null);
            f['%2e'] = '.';
            f['.%2e'] = '..';
            f['%2e.'] = '..';
            f['%2e%2e'] = '..';
            var r,
              u = /[a-zA-Z]/,
              B = /[a-zA-Z0-9\+\-\.]/;
            g.prototype = {
              toString: function() {
                return this.href;
              },
              get href() {
                if (this._isInvalid) return this._url;
                var a = '';
                if ('' !== this._username || null !== this._password)
                  a = this._username + (null !== this._password ? ':' + this._password : '') + '@';
                return (
                  this.protocol +
                  (this._isRelative ? '//' + a + this.host : '') +
                  this.pathname +
                  this._query +
                  this._fragment
                );
              },
              set href(a) {
                n.call(this);
                e.call(this, a);
              },
              get protocol() {
                return this._scheme + ':';
              },
              set protocol(a) {
                this._isInvalid || e.call(this, a + ':', 'scheme start');
              },
              get host() {
                return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
              },
              set host(a) {
                !this._isInvalid && this._isRelative && e.call(this, a, 'host');
              },
              get hostname() {
                return this._host;
              },
              set hostname(a) {
                !this._isInvalid && this._isRelative && e.call(this, a, 'hostname');
              },
              get port() {
                return this._port;
              },
              set port(a) {
                !this._isInvalid && this._isRelative && e.call(this, a, 'port');
              },
              get pathname() {
                return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
              },
              set pathname(a) {
                !this._isInvalid && this._isRelative && ((this._path = []), e.call(this, a, 'relative path start'));
              },
              get search() {
                return this._isInvalid || !this._query || '?' === this._query ? '' : this._query;
              },
              set search(a) {
                !this._isInvalid &&
                  this._isRelative &&
                  ((this._query = '?'), '?' === a[0] && (a = a.slice(1)), e.call(this, a, 'query'));
              },
              get hash() {
                return this._isInvalid || !this._fragment || '#' === this._fragment ? '' : this._fragment;
              },
              set hash(a) {
                this._isInvalid ||
                  ((this._fragment = '#'), '#' === a[0] && (a = a.slice(1)), e.call(this, a, 'fragment'));
              },
              get origin() {
                var a;
                if (this._isInvalid || !this._scheme) return '';
                switch (this._scheme) {
                  case 'data':
                  case 'file':
                  case 'javascript':
                  case 'mailto':
                    return 'null';
                  case 'blob':
                    try {
                      return new g(this._schemeData).origin || 'null';
                    } catch (E) {}
                    return 'null';
                }
                return (a = this.host) ? this._scheme + '://' + a : '';
              },
            };
            var v = k.URL;
            v &&
              ((g.createObjectURL = function(a) {
                return v.createObjectURL.apply(v, arguments);
              }),
              (g.revokeObjectURL = function(a) {
                v.revokeObjectURL(a);
              }));
            k.URL = g;
          }
        })();
      }
    },
    function(y, m, t) {
      t(73);
      y.exports = t(20).Uint8ClampedArray;
    },
    function(y, m, t) {
      t(74)(
        'Uint8',
        1,
        function(a) {
          return function(k, b, m) {
            return a(this, k, b, m);
          };
        },
        !0,
      );
    },
    function(y, m, t) {
      var a =
        'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
          ? function(a) {
              return typeof a;
            }
          : function(a) {
              return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                ? 'symbol'
                : typeof a;
            };
      if (t(5)) {
        var k = t(27),
          b = t(4),
          v = t(19),
          d = t(37),
          u = t(41),
          z = t(75),
          C = t(30),
          B = t(43),
          n = t(22),
          e = t(6);
        m = t(42);
        var h = t(14),
          p = t(9),
          A = t(44),
          c = t(24),
          q = t(28),
          x = t(8),
          g = t(52),
          G = t(12),
          l = t(15),
          J = t(76),
          f = t(53),
          r = t(54),
          D = t(45).f,
          L = t(80),
          I = t(13),
          w = t(2),
          E = t(81),
          F = t(49),
          K = t(85),
          H = t(86),
          M = t(16),
          O = t(91),
          N = t(92),
          da = t(51),
          W = t(93),
          Z = t(10);
        t = t(94);
        var ea = Z.f,
          aa = t.f,
          X = b.RangeError,
          ba = b.TypeError,
          ca = b.Uint8Array,
          T = Array.prototype,
          S = z.ArrayBuffer,
          Y = z.DataView,
          U = E(0),
          V = E(2),
          P = E(3),
          Ha = E(4),
          Aa = E(5),
          Ca = E(6),
          Wa = F(!0),
          na = F(!1),
          Oa = H.values,
          Ia = H.keys,
          wa = H.entries,
          Q = T.lastIndexOf,
          ua = T.reduce,
          Ja = T.reduceRight,
          Sa = T.join,
          ja = T.sort,
          oa = T.slice,
          Da = T.toString,
          Ka = T.toLocaleString,
          ya = w('iterator'),
          ma = w('toStringTag'),
          la = I('typed_constructor'),
          pa = I('def_constructor');
        z = u.CONSTR;
        var va = u.TYPED,
          Ba = u.VIEW,
          ta = E(1, function(a, b) {
            return R(K(a, a[pa]), b);
          }),
          Ta = v(function() {
            return 1 === new ca(new Uint16Array([1]).buffer)[0];
          }),
          qa =
            !!ca &&
            !!ca.prototype.set &&
            v(function() {
              new ca(1).set({});
            }),
          ra = function(a, b) {
            var c = h(a);
            if (0 > c || c % b) throw X('Wrong offset!');
            return c;
          },
          ia = function(a) {
            if (G(a) && va in a) return a;
            throw ba(a + ' is not a typed array!');
          },
          R = function(a, b) {
            if (!(G(a) && la in a)) throw ba('It is not a typed array constructor!');
            return new a(b);
          },
          fa = function(a, b) {
            return Ya(K(a, a[pa]), b);
          },
          Ya = function(a, b) {
            for (var c = 0, d = b.length, e = R(a, d); d > c; ) e[c] = b[c++];
            return e;
          };
        E = function(a, b, c) {
          ea(a, b, {
            get: function() {
              return this._d[c];
            },
          });
        };
        var bb = function(a) {
            var b = l(a),
              c = arguments.length,
              d = 1 < c ? arguments[1] : void 0,
              e = void 0 !== d,
              f = L(b),
              g;
            if (void 0 != f && !J(f)) {
              var r = f.call(b);
              b = [];
              for (f = 0; !(g = r.next()).done; f++) b.push(g.value);
            }
            e && 2 < c && (d = C(d, arguments[2], 2));
            f = 0;
            c = p(b.length);
            for (g = R(this, c); c > f; f++) g[f] = e ? d(b[f], f) : b[f];
            return g;
          },
          Ea = function() {
            for (var a = 0, b = arguments.length, c = R(this, b); b > a; ) c[a] = arguments[a++];
            return c;
          },
          Ua =
            !!ca &&
            v(function() {
              Ka.call(new ca(1));
            }),
          Za = function() {
            return Ka.apply(Ua ? oa.call(ia(this)) : ia(this), arguments);
          },
          Pa = {
            copyWithin: function(a, b) {
              return W.call(ia(this), a, b, 2 < arguments.length ? arguments[2] : void 0);
            },
            every: function(a) {
              return Ha(ia(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            fill: function(a) {
              return da.apply(ia(this), arguments);
            },
            filter: function(a) {
              return fa(this, V(ia(this), a, 1 < arguments.length ? arguments[1] : void 0));
            },
            find: function(a) {
              return Aa(ia(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            findIndex: function(a) {
              return Ca(ia(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            forEach: function(a) {
              U(ia(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            indexOf: function(a) {
              return na(ia(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            includes: function(a) {
              return Wa(ia(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            join: function(a) {
              return Sa.apply(ia(this), arguments);
            },
            lastIndexOf: function(a) {
              return Q.apply(ia(this), arguments);
            },
            map: function(a) {
              return ta(ia(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            reduce: function(a) {
              return ua.apply(ia(this), arguments);
            },
            reduceRight: function(a) {
              return Ja.apply(ia(this), arguments);
            },
            reverse: function() {
              for (var a = ia(this).length, b = Math.floor(a / 2), c = 0, d; c < b; )
                (d = this[c]), (this[c++] = this[--a]), (this[a] = d);
              return this;
            },
            some: function(a) {
              return P(ia(this), a, 1 < arguments.length ? arguments[1] : void 0);
            },
            sort: function(a) {
              return ja.call(ia(this), a);
            },
            subarray: function(a, b) {
              var d = ia(this),
                e = d.length,
                f = c(a, e);
              return new (K(d, d[pa]))(
                d.buffer,
                d.byteOffset + f * d.BYTES_PER_ELEMENT,
                p((void 0 === b ? e : c(b, e)) - f),
              );
            },
          },
          za = function(a, b) {
            return fa(this, oa.call(ia(this), a, b));
          },
          La = function(a, b) {
            ia(this);
            var c = ra(b, 1),
              d = this.length,
              e = l(a),
              f = p(e.length),
              g = 0;
            if (f + c > d) throw X('Wrong length!');
            for (; g < f; ) this[c + g] = e[g++];
          },
          ka = {
            entries: function() {
              return wa.call(ia(this));
            },
            keys: function() {
              return Ia.call(ia(this));
            },
            values: function() {
              return Oa.call(ia(this));
            },
          },
          Ma = function(b, c) {
            return (
              G(b) &&
              b[va] &&
              'symbol' != ('undefined' === typeof c ? 'undefined' : a(c)) &&
              c in b &&
              String(+c) == String(c)
            );
          };
        I = function(a, b) {
          return Ma(a, (b = q(b, !0))) ? n(2, a[b]) : aa(a, b);
        };
        w = function(a, b, c) {
          return !(Ma(a, (b = q(b, !0))) && G(c) && x(c, 'value')) ||
            x(c, 'get') ||
            x(c, 'set') ||
            c.configurable ||
            (x(c, 'writable') && !c.writable) ||
            (x(c, 'enumerable') && !c.enumerable)
            ? ea(a, b, c)
            : ((a[b] = c.value), a);
        };
        z || ((t.f = I), (Z.f = w));
        d(d.S + d.F * !z, 'Object', { getOwnPropertyDescriptor: I, defineProperty: w });
        v(function() {
          Da.call({});
        }) &&
          (Da = Ka = function() {
            return Sa.call(this);
          });
        var xa = m({}, Pa);
        m(xa, ka);
        e(xa, ya, ka.values);
        m(xa, { slice: za, set: La, constructor: function() {}, toString: Da, toLocaleString: Za });
        E(xa, 'buffer', 'b');
        E(xa, 'byteOffset', 'o');
        E(xa, 'byteLength', 'l');
        E(xa, 'length', 'e');
        ea(xa, ma, {
          get: function() {
            return this[va];
          },
        });
        y.exports = function(a, c, l, n) {
          n = !!n;
          var h = a + (n ? 'Clamped' : '') + 'Array',
            q = 'get' + a,
            m = 'set' + a,
            w = b[h],
            x = w || {},
            E = w && r(w);
          a = {};
          var F = w && w.prototype,
            z = function(a, b) {
              ea(a, b, {
                get: function() {
                  var a = this._d;
                  return a.v[q](b * c + a.o, Ta);
                },
                set: function(a) {
                  var d = this._d;
                  n && (a = 0 > (a = Math.round(a)) ? 0 : 255 < a ? 255 : a & 255);
                  d.v[m](b * c + d.o, a, Ta);
                },
                enumerable: !0,
              });
            };
          w && u.ABV
            ? (v(function() {
                w(1);
              }) &&
                v(function() {
                  new w(-1);
                }) &&
                O(function(a) {
                  new w();
                  new w(null);
                  new w(1.5);
                  new w(a);
                }, !0)) ||
              ((w = l(function(a, b, d, e) {
                B(a, w, h);
                var f;
                return G(b)
                  ? b instanceof S || 'ArrayBuffer' == (f = g(b)) || 'SharedArrayBuffer' == f
                    ? void 0 !== e
                      ? new x(b, ra(d, c), e)
                      : void 0 !== d
                      ? new x(b, ra(d, c))
                      : new x(b)
                    : va in b
                    ? Ya(w, b)
                    : bb.call(w, b)
                  : new x(A(b));
              })),
              U(E !== Function.prototype ? D(x).concat(D(E)) : D(x), function(a) {
                a in w || e(w, a, x[a]);
              }),
              (w.prototype = F),
              k || (F.constructor = w))
            : ((w = l(function(a, b, d, f) {
                B(a, w, h, '_d');
                var l = 0,
                  r = 0,
                  n;
                if (G(b))
                  if (b instanceof S || 'ArrayBuffer' == (n = g(b)) || 'SharedArrayBuffer' == n) {
                    n = b;
                    r = ra(d, c);
                    b = b.byteLength;
                    if (void 0 === f) {
                      if (b % c) throw X('Wrong length!');
                      f = b - r;
                      if (0 > f) throw X('Wrong length!');
                    } else if (((f = p(f) * c), f + r > b)) throw X('Wrong length!');
                    b = f / c;
                  } else return va in b ? Ya(w, b) : bb.call(w, b);
                else (b = A(b)), (f = b * c), (n = new S(f));
                for (e(a, '_d', { b: n, o: r, l: f, e: b, v: new Y(n) }); l < b; ) z(a, l++);
              })),
              (F = w.prototype = f(xa)),
              e(F, 'constructor', w));
          l = F[ya];
          E = !!l && ('values' == l.name || void 0 == l.name);
          var t = ka.values;
          e(w, la, !0);
          e(F, va, h);
          e(F, Ba, !0);
          e(F, pa, w);
          (n ? new w(1)[ma] == h : ma in F) ||
            ea(F, ma, {
              get: function() {
                return h;
              },
            });
          a[h] = w;
          d(d.G + d.W + d.F * (w != x), a);
          d(d.S, h, { BYTES_PER_ELEMENT: c });
          d(
            d.S +
              d.F *
                v(function() {
                  x.of.call(w, 1);
                }),
            h,
            { from: bb, of: Ea },
          );
          'BYTES_PER_ELEMENT' in F || e(F, 'BYTES_PER_ELEMENT', c);
          d(d.P, h, Pa);
          N(h);
          d(d.P + d.F * qa, h, { set: La });
          d(d.P + d.F * !E, h, ka);
          k || F.toString == Da || (F.toString = Da);
          d(
            d.P +
              d.F *
                v(function() {
                  new w(1).slice();
                }),
            h,
            { slice: za },
          );
          d(
            d.P +
              d.F *
                (v(function() {
                  return [1, 2].toLocaleString() != new w([1, 2]).toLocaleString();
                }) ||
                  !v(function() {
                    F.toLocaleString.call([1, 2]);
                  })),
            h,
            { toLocaleString: Za },
          );
          M[h] = E ? l : t;
          k || E || e(F, ya, t);
        };
      } else y.exports = function() {};
    },
    function(y, m, t) {
      function a(a, b, c) {
        var d = Array(c);
        c = 8 * c - b - 1;
        var e = (1 << c) - 1,
          f = e >> 1,
          g = 23 === b ? M(2, -24) - M(2, -77) : 0,
          l = 0,
          r = 0 > a || (0 === a && 0 > 1 / a) ? 1 : 0,
          h;
        a = H(a);
        if (a != a || a === F) {
          a = a != a ? 1 : 0;
          var n = e;
        } else
          (n = O(N(a) / da)),
            1 > a * (h = M(2, -n)) && (n--, (h *= 2)),
            (a = 1 <= n + f ? a + g / h : a + g * M(2, 1 - f)),
            2 <= a * h && (n++, (h /= 2)),
            n + f >= e
              ? ((a = 0), (n = e))
              : 1 <= n + f
              ? ((a = (a * h - 1) * M(2, b)), (n += f))
              : ((a = a * M(2, f - 1) * M(2, b)), (n = 0));
        for (; 8 <= b; d[l++] = a & 255, a /= 256, b -= 8);
        n = (n << b) | a;
        for (c += b; 0 < c; d[l++] = n & 255, n /= 256, c -= 8);
        d[--l] |= 128 * r;
        return d;
      }
      function k(a, b, c) {
        var d = 8 * c - b - 1,
          e = (1 << d) - 1,
          f = e >> 1;
        d -= 7;
        --c;
        var g = a[c--],
          l = g & 127;
        for (g >>= 7; 0 < d; l = 256 * l + a[c], c--, d -= 8);
        var n = l & ((1 << -d) - 1);
        l >>= -d;
        for (d += b; 0 < d; n = 256 * n + a[c], c--, d -= 8);
        if (0 === l) l = 1 - f;
        else {
          if (l === e) return n ? NaN : g ? -F : F;
          n += M(2, b);
          l -= f;
        }
        return (g ? -1 : 1) * n * M(2, l - b);
      }
      function b(a) {
        return (a[3] << 24) | (a[2] << 16) | (a[1] << 8) | a[0];
      }
      function v(a) {
        return [a & 255];
      }
      function d(a) {
        return [a & 255, (a >> 8) & 255];
      }
      function u(a) {
        return [a & 255, (a >> 8) & 255, (a >> 16) & 255, (a >> 24) & 255];
      }
      function z(b) {
        return a(b, 52, 8);
      }
      function C(b) {
        return a(b, 23, 4);
      }
      function B(a, b, c) {
        r(a.prototype, b, {
          get: function() {
            return this[c];
          },
        });
      }
      function n(a, b, c, d) {
        c = J(+c);
        if (c + b > a[Z]) throw E('Wrong index!');
        c += a[ea];
        a = a[W]._b.slice(c, c + b);
        return d ? a : a.reverse();
      }
      function e(a, b, c, d, e, f) {
        var g = J(+c);
        if (g + b > a[Z]) throw E('Wrong index!');
        c = a[W]._b;
        a = g + a[ea];
        d = d(+e);
        for (e = 0; e < b; e++) c[a + e] = d[f ? e : b - e - 1];
      }
      var h = t(4),
        p = t(5),
        A = t(27);
      y = t(41);
      var c = t(6),
        q = t(42),
        x = t(19),
        g = t(43),
        G = t(14),
        l = t(9),
        J = t(44),
        f = t(45).f,
        r = t(10).f,
        D = t(51);
      t = t(34);
      var L = h.ArrayBuffer,
        I = h.DataView,
        w = h.Math,
        E = h.RangeError,
        F = h.Infinity,
        K = L,
        H = w.abs,
        M = w.pow,
        O = w.floor,
        N = w.log,
        da = w.LN2,
        W = p ? '_b' : 'buffer',
        Z = p ? '_l' : 'byteLength',
        ea = p ? '_o' : 'byteOffset';
      if (y.ABV) {
        if (
          !x(function() {
            L(1);
          }) ||
          !x(function() {
            new L(-1);
          }) ||
          x(function() {
            new L();
            new L(1.5);
            new L(NaN);
            return 'ArrayBuffer' != L.name;
          })
        ) {
          L = function(a) {
            g(this, L);
            return new K(J(a));
          };
          h = L.prototype = K.prototype;
          f = f(K);
          p = 0;
          for (var aa; f.length > p; ) (aa = f[p++]) in L || c(L, aa, K[aa]);
          A || (h.constructor = L);
        }
        aa = new I(new L(2));
        var X = I.prototype.setInt8;
        aa.setInt8(0, 2147483648);
        aa.setInt8(1, 2147483649);
        (!aa.getInt8(0) && aa.getInt8(1)) ||
          q(
            I.prototype,
            {
              setInt8: function(a, b) {
                X.call(this, a, (b << 24) >> 24);
              },
              setUint8: function(a, b) {
                X.call(this, a, (b << 24) >> 24);
              },
            },
            !0,
          );
      } else
        (L = function(a) {
          g(this, L, 'ArrayBuffer');
          a = J(a);
          this._b = D.call(Array(a), 0);
          this[Z] = a;
        }),
          (I = function(a, b, c) {
            g(this, I, 'DataView');
            g(a, L, 'DataView');
            var d = a[Z];
            b = G(b);
            if (0 > b || b > d) throw E('Wrong offset!');
            c = void 0 === c ? d - b : l(c);
            if (b + c > d) throw E('Wrong length!');
            this[W] = a;
            this[ea] = b;
            this[Z] = c;
          }),
          p && (B(L, 'byteLength', '_l'), B(I, 'buffer', '_b'), B(I, 'byteLength', '_l'), B(I, 'byteOffset', '_o')),
          q(I.prototype, {
            getInt8: function(a) {
              return (n(this, 1, a)[0] << 24) >> 24;
            },
            getUint8: function(a) {
              return n(this, 1, a)[0];
            },
            getInt16: function(a, b) {
              var c = n(this, 2, a, b);
              return (((c[1] << 8) | c[0]) << 16) >> 16;
            },
            getUint16: function(a, b) {
              var c = n(this, 2, a, b);
              return (c[1] << 8) | c[0];
            },
            getInt32: function(a, c) {
              return b(n(this, 4, a, c));
            },
            getUint32: function(a, c) {
              return b(n(this, 4, a, c)) >>> 0;
            },
            getFloat32: function(a, b) {
              return k(n(this, 4, a, b), 23, 4);
            },
            getFloat64: function(a, b) {
              return k(n(this, 8, a, b), 52, 8);
            },
            setInt8: function(a, b) {
              e(this, 1, a, v, b);
            },
            setUint8: function(a, b) {
              e(this, 1, a, v, b);
            },
            setInt16: function(a, b, c) {
              e(this, 2, a, d, b, c);
            },
            setUint16: function(a, b, c) {
              e(this, 2, a, d, b, c);
            },
            setInt32: function(a, b, c) {
              e(this, 4, a, u, b, c);
            },
            setUint32: function(a, b, c) {
              e(this, 4, a, u, b, c);
            },
            setFloat32: function(a, b, c) {
              e(this, 4, a, C, b, c);
            },
            setFloat64: function(a, b, c) {
              e(this, 8, a, z, b, c);
            },
          });
      t(L, 'ArrayBuffer');
      t(I, 'DataView');
      c(I.prototype, y.VIEW, !0);
      m.ArrayBuffer = L;
      m.DataView = I;
    },
    function(y, m, t) {
      var a = t(16),
        k = t(2)('iterator'),
        b = Array.prototype;
      y.exports = function(m) {
        return void 0 !== m && (a.Array === m || b[k] === m);
      };
    },
    function(y, m, t) {
      var a = t(10),
        k = t(21),
        b = t(78);
      y.exports = t(5)
        ? Object.defineProperties
        : function(m, d) {
            k(m);
            for (var u = b(d), v = u.length, t = 0, B; v > t; ) a.f(m, (B = u[t++]), d[B]);
            return m;
          };
    },
    function(y, m, t) {
      var a = t(46),
        k = t(33);
      y.exports =
        Object.keys ||
        function(b) {
          return a(b, k);
        };
    },
    function(y, m, t) {
      m = t(4).document;
      y.exports = m && m.documentElement;
    },
    function(y, m, t) {
      var a = t(52),
        k = t(2)('iterator'),
        b = t(16);
      y.exports = t(20).getIteratorMethod = function(m) {
        if (void 0 != m) return m[k] || m['@@iterator'] || b[a(m)];
      };
    },
    function(y, m, t) {
      var a = t(30),
        k = t(47),
        b = t(15),
        v = t(9),
        d = t(82);
      y.exports = function(m, z) {
        var u = 1 == m,
          B = 2 == m,
          n = 3 == m,
          e = 4 == m,
          h = 6 == m,
          p = 5 == m || h,
          A = z || d;
        return function(c, d, x) {
          var g = b(c),
            q = k(g);
          d = a(d, x, 3);
          x = v(q.length);
          var l = 0;
          c = u ? A(c, x) : B ? A(c, 0) : void 0;
          for (var z, f; x > l; l++)
            if (p || l in q)
              if (((z = q[l]), (f = d(z, l, g)), m))
                if (u) c[l] = f;
                else if (f)
                  switch (m) {
                    case 3:
                      return !0;
                    case 5:
                      return z;
                    case 6:
                      return l;
                    case 2:
                      c.push(z);
                  }
                else if (e) return !1;
          return h ? -1 : n || e ? e : c;
        };
      };
    },
    function(y, m, t) {
      var a = t(83);
      y.exports = function(k, b) {
        return new (a(k))(b);
      };
    },
    function(y, m, t) {
      var a = t(12),
        k = t(84),
        b = t(2)('species');
      y.exports = function(m) {
        if (k(m)) {
          var d = m.constructor;
          'function' != typeof d || (d !== Array && !k(d.prototype)) || (d = void 0);
          a(d) && ((d = d[b]), null === d && (d = void 0));
        }
        return void 0 === d ? Array : d;
      };
    },
    function(y, m, t) {
      var a = t(31);
      y.exports =
        Array.isArray ||
        function(k) {
          return 'Array' == a(k);
        };
    },
    function(y, m, t) {
      var a = t(21),
        k = t(40),
        b = t(2)('species');
      y.exports = function(m, d) {
        var u = a(m).constructor,
          v;
        return void 0 === u || void 0 == (v = a(u)[b]) ? d : k(v);
      };
    },
    function(y, m, t) {
      m = t(87);
      var a = t(88),
        k = t(16),
        b = t(23);
      y.exports = t(89)(
        Array,
        'Array',
        function(a, d) {
          this._t = b(a);
          this._i = 0;
          this._k = d;
        },
        function() {
          var b = this._t,
            d = this._k,
            k = this._i++;
          return !b || k >= b.length
            ? ((this._t = void 0), a(1))
            : 'keys' == d
            ? a(0, k)
            : 'values' == d
            ? a(0, b[k])
            : a(0, [k, b[k]]);
        },
        'values',
      );
      k.Arguments = k.Array;
      m('keys');
      m('values');
      m('entries');
    },
    function(y, m, t) {
      var a = t(2)('unscopables'),
        k = Array.prototype;
      void 0 == k[a] && t(6)(k, a, {});
      y.exports = function(b) {
        k[a][b] = !0;
      };
    },
    function(y, m, t) {
      y.exports = function(a, k) {
        return { value: k, done: !!a };
      };
    },
    function(y, m, t) {
      var a = t(27),
        k = t(37),
        b = t(29),
        v = t(6),
        d = t(8),
        u = t(16),
        z = t(90),
        C = t(34),
        B = t(54),
        n = t(2)('iterator'),
        e = !([].keys && 'next' in [].keys()),
        h = function() {
          return this;
        };
      y.exports = function(p, m, c, q, x, g, t) {
        z(c, m, q);
        q = function(a) {
          return !e && a in r
            ? r[a]
            : function() {
                return new c(this, a);
              };
        };
        var l = m + ' Iterator',
          A = 'values' == x,
          f = !1,
          r = p.prototype,
          D = r[n] || r['@@iterator'] || (x && r[x]),
          G = D || q(x),
          I = x ? (A ? q('entries') : G) : void 0,
          w = 'Array' == m ? r.entries || D : D,
          E;
        w && ((p = B(w.call(new p()))), p !== Object.prototype && p.next && (C(p, l, !0), a || d(p, n) || v(p, n, h)));
        A &&
          D &&
          'values' !== D.name &&
          ((f = !0),
          (G = function() {
            return D.call(this);
          }));
        (a && !t) || (!e && !f && r[n]) || v(r, n, G);
        u[m] = G;
        u[l] = h;
        if (x) {
          var F = { values: A ? G : q('values'), keys: g ? G : q('keys'), entries: I };
          if (t) for (E in F) E in r || b(r, E, F[E]);
          else k(k.P + k.F * (e || f), m, F);
        }
        return F;
      };
    },
    function(y, m, t) {
      var a = t(53),
        k = t(22),
        b = t(34),
        v = {};
      t(6)(v, t(2)('iterator'), function() {
        return this;
      });
      y.exports = function(d, m, z) {
        d.prototype = a(v, { next: k(1, z) });
        b(d, m + ' Iterator');
      };
    },
    function(y, m, t) {
      var a = t(2)('iterator'),
        k = !1;
      try {
        var b = [7][a]();
        b['return'] = function() {
          k = !0;
        };
        Array.from(b, function() {
          throw 2;
        });
      } catch (v) {}
      y.exports = function(b, d) {
        if (!d && !k) return !1;
        var m = !1;
        try {
          var v = [7],
            t = v[a]();
          t.next = function() {
            return { done: (m = !0) };
          };
          v[a] = function() {
            return t;
          };
          b(v);
        } catch (B) {}
        return m;
      };
    },
    function(y, m, t) {
      var a = t(4),
        k = t(10),
        b = t(5),
        v = t(2)('species');
      y.exports = function(d) {
        d = a[d];
        b &&
          d &&
          !d[v] &&
          k.f(d, v, {
            configurable: !0,
            get: function() {
              return this;
            },
          });
      };
    },
    function(y, m, t) {
      var a = t(15),
        k = t(24),
        b = t(9);
      y.exports =
        [].copyWithin ||
        function(m, d) {
          var u = a(this),
            v = b(u.length),
            t = k(m, v),
            B = k(d, v),
            n = 2 < arguments.length ? arguments[2] : void 0;
          v = Math.min((void 0 === n ? v : k(n, v)) - B, v - t);
          n = 1;
          B < t && t < B + v && ((n = -1), (B += v - 1), (t += v - 1));
          for (; 0 < v--; ) B in u ? (u[t] = u[B]) : delete u[t], (t += n), (B += n);
          return u;
        };
    },
    function(y, m, t) {
      var a = t(95),
        k = t(22),
        b = t(23),
        v = t(28),
        d = t(8),
        u = t(38),
        z = Object.getOwnPropertyDescriptor;
      m.f = t(5)
        ? z
        : function(m, B) {
            m = b(m);
            B = v(B, !0);
            if (u)
              try {
                return z(m, B);
              } catch (n) {}
            if (d(m, B)) return k(!a.f.call(m, B), m[B]);
          };
    },
    function(y, m, t) {
      m.f = {}.propertyIsEnumerable;
    },
    function(y, m, t) {
      y = !1;
      if ('undefined' !== typeof ReadableStream)
        try {
          new ReadableStream({
            start: function(a) {
              a.close();
            },
          }),
            (y = !0);
        } catch (a) {}
      m.ReadableStream = y ? ReadableStream : t(97).ReadableStream;
    },
    function(y, m, t) {
      var a =
        'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
          ? function(a) {
              return typeof a;
            }
          : function(a) {
              return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                ? 'symbol'
                : typeof a;
            };
      (function(a, b) {
        for (var k in b) a[k] = b[k];
      })(
        m,
        (function(a) {
          function b(d) {
            if (k[d]) return k[d].exports;
            var m = (k[d] = { i: d, l: !1, exports: {} });
            a[d].call(m.exports, m, m.exports, b);
            m.l = !0;
            return m.exports;
          }
          var k = {};
          b.m = a;
          b.c = k;
          b.i = function(a) {
            return a;
          };
          b.d = function(a, k, m) {
            b.o(a, k) || Object.defineProperty(a, k, { configurable: !1, enumerable: !0, get: m });
          };
          b.n = function(a) {
            var d =
              a && a.__esModule
                ? function() {
                    return a['default'];
                  }
                : function() {
                    return a;
                  };
            b.d(d, 'a', d);
            return d;
          };
          b.o = function(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
          };
          b.p = '';
          return b((b.s = 7));
        })([
          function(k, b, m) {
            function d(a) {
              return 'string' === typeof a || 'symbol' === ('undefined' === typeof a ? 'undefined' : v(a));
            }
            function u(a, b, d) {
              if ('function' !== typeof a) throw new TypeError('Argument is not a function');
              return Function.prototype.apply.call(a, b, d);
            }
            var v =
                'function' === typeof Symbol && 'symbol' === a(Symbol.iterator)
                  ? function(b) {
                      return 'undefined' === typeof b ? 'undefined' : a(b);
                    }
                  : function(b) {
                      return b && 'function' === typeof Symbol && b.constructor === Symbol && b !== Symbol.prototype
                        ? 'symbol'
                        : 'undefined' === typeof b
                        ? 'undefined'
                        : a(b);
                    },
              t = m(1).assert;
            b.typeIsObject = function(a) {
              return (
                ('object' === ('undefined' === typeof a ? 'undefined' : v(a)) && null !== a) || 'function' === typeof a
              );
            };
            b.createDataProperty = function(a, d, e) {
              t(b.typeIsObject(a));
              Object.defineProperty(a, d, { value: e, writable: !0, enumerable: !0, configurable: !0 });
            };
            b.createArrayFromList = function(a) {
              return a.slice();
            };
            b.ArrayBufferCopy = function(a, b, d, h, p) {
              new Uint8Array(a).set(new Uint8Array(d, h, p), b);
            };
            b.CreateIterResultObject = function(a, b) {
              t('boolean' === typeof b);
              var d = {};
              Object.defineProperty(d, 'value', { value: a, enumerable: !0, writable: !0, configurable: !0 });
              Object.defineProperty(d, 'done', { value: b, enumerable: !0, writable: !0, configurable: !0 });
              return d;
            };
            b.IsFiniteNonNegativeNumber = function(a) {
              return Number.isNaN(a) || Infinity === a || 0 > a ? !1 : !0;
            };
            b.InvokeOrNoop = function(a, b, e) {
              t(void 0 !== a);
              t(d(b));
              t(Array.isArray(e));
              b = a[b];
              if (void 0 !== b) return u(b, a, e);
            };
            b.PromiseInvokeOrNoop = function(a, n, e) {
              t(void 0 !== a);
              t(d(n));
              t(Array.isArray(e));
              try {
                return Promise.resolve(b.InvokeOrNoop(a, n, e));
              } catch (h) {
                return Promise.reject(h);
              }
            };
            b.PromiseInvokeOrPerformFallback = function(a, b, e, h, p) {
              t(void 0 !== a);
              t(d(b));
              t(Array.isArray(e));
              t(Array.isArray(p));
              var n = void 0;
              try {
                n = a[b];
              } catch (c) {
                return Promise.reject(c);
              }
              if (void 0 === n) return h.apply(null, p);
              try {
                return Promise.resolve(u(n, a, e));
              } catch (c) {
                return Promise.reject(c);
              }
            };
            b.TransferArrayBuffer = function(a) {
              return a.slice();
            };
            b.ValidateAndNormalizeHighWaterMark = function(a) {
              a = Number(a);
              if (Number.isNaN(a) || 0 > a)
                throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
              return a;
            };
            b.ValidateAndNormalizeQueuingStrategy = function(a, d) {
              if (void 0 !== a && 'function' !== typeof a)
                throw new TypeError('size property of a queuing strategy must be a function');
              d = b.ValidateAndNormalizeHighWaterMark(d);
              return { size: a, highWaterMark: d };
            };
          },
          function(a, b, m) {
            function d(a) {
              this.name = 'AssertionError';
              this.message = a || '';
              this.stack = Error().stack;
            }
            d.prototype = Object.create(Error.prototype);
            d.prototype.constructor = d;
            a.exports = {
              rethrowAssertionErrorRejection: function(a) {
                a &&
                  a.constructor === d &&
                  setTimeout(function() {
                    throw a;
                  }, 0);
              },
              AssertionError: d,
              assert: function(a, b) {
                if (!a) throw new d(b);
              },
            };
          },
          function(a, b, m) {
            function d(a, b) {
              if (!(a instanceof b)) throw new TypeError('Cannot call a class as a function');
            }
            function k(a) {
              return new Oa(a);
            }
            function v(a) {
              return V(a) && Object.prototype.hasOwnProperty.call(a, '_writableStreamController') ? !0 : !1;
            }
            function t(a) {
              P(!0 === v(a), 'IsWritableStreamLocked should only be used on known writable streams');
              return void 0 === a._writer ? !1 : !0;
            }
            function B(a, b) {
              var c = a._state;
              if ('closed' === c) return Promise.resolve(void 0);
              if ('errored' === c) return Promise.reject(a._storedError);
              var d = new TypeError('Requested to abort');
              if (void 0 !== a._pendingAbortRequest) return Promise.reject(d);
              P('writable' === c || 'erroring' === c, 'state must be writable or erroring');
              var e = !1;
              'erroring' === c && ((e = !0), (b = void 0));
              c = new Promise(function(c, d) {
                a._pendingAbortRequest = { _resolve: c, _reject: d, _reason: b, _wasAlreadyErroring: e };
              });
              !1 === e && h(a, d);
              return c;
            }
            function n(a) {
              P(!0 === t(a));
              P('writable' === a._state);
              return new Promise(function(b, c) {
                a._writeRequests.push({ _resolve: b, _reject: c });
              });
            }
            function e(a, b) {
              var c = a._state;
              'writable' === c ? h(a, b) : (P('erroring' === c), p(a));
            }
            function h(a, b) {
              P(void 0 === a._storedError, 'stream._storedError === undefined');
              P('writable' === a._state, 'state must be writable');
              var c = a._writableStreamController;
              P(void 0 !== c, 'controller must not be undefined');
              a._state = 'erroring';
              a._storedError = b;
              var d = a._writer;
              void 0 !== d && f(d, b);
              !1 === (void 0 === a._inFlightWriteRequest && void 0 === a._inFlightCloseRequest ? !1 : !0) &&
                !0 === c._started &&
                p(a);
            }
            function p(a) {
              P('erroring' === a._state, 'stream._state === erroring');
              P(
                !1 === (void 0 === a._inFlightWriteRequest && void 0 === a._inFlightCloseRequest ? !1 : !0),
                'WritableStreamHasOperationMarkedInFlight(stream) === false',
              );
              a._state = 'errored';
              a._writableStreamController.__errorSteps();
              for (var b = a._storedError, c = 0; c < a._writeRequests.length; c++) a._writeRequests[c]._reject(b);
              a._writeRequests = [];
              if (void 0 === a._pendingAbortRequest) x(a);
              else {
                var d = a._pendingAbortRequest;
                a._pendingAbortRequest = void 0;
                !0 === d._wasAlreadyErroring
                  ? (d._reject(b), x(a))
                  : a._writableStreamController.__abortSteps(d._reason).then(
                      function() {
                        d._resolve();
                        x(a);
                      },
                      function(b) {
                        d._reject(b);
                        x(a);
                      },
                    );
              }
            }
            function A(a) {
              return void 0 === a._closeRequest && void 0 === a._inFlightCloseRequest ? !1 : !0;
            }
            function c(a) {
              P(void 0 === a._inFlightCloseRequest);
              P(void 0 !== a._closeRequest);
              a._inFlightCloseRequest = a._closeRequest;
              a._closeRequest = void 0;
            }
            function q(a) {
              P(void 0 === a._inFlightWriteRequest, 'there must be no pending write request');
              P(0 !== a._writeRequests.length, 'writeRequests must not be empty');
              a._inFlightWriteRequest = a._writeRequests.shift();
            }
            function x(a) {
              P('errored' === a._state, '_stream_.[[state]] is `"errored"`');
              void 0 !== a._closeRequest &&
                (P(void 0 === a._inFlightCloseRequest),
                a._closeRequest._reject(a._storedError),
                (a._closeRequest = void 0));
              var b = a._writer;
              void 0 !== b && (N(b, a._storedError), b._closedPromise['catch'](function() {}));
            }
            function g(a, b) {
              P('writable' === a._state);
              P(!1 === A(a));
              var c = a._writer;
              void 0 !== c && b !== a._backpressure && (!0 === b ? X(c) : (P(!1 === b), ca(c)));
              a._backpressure = b;
            }
            function G(a) {
              return V(a) && Object.prototype.hasOwnProperty.call(a, '_ownerWritableStream') ? !0 : !1;
            }
            function l(a) {
              var b = a._ownerWritableStream;
              P(void 0 !== b);
              var c = b._state;
              if ('closed' === c || 'errored' === c)
                return Promise.reject(
                  new TypeError('The stream (in ' + c + ' state) is not in the writable state and cannot be closed'),
                );
              P('writable' === c || 'erroring' === c);
              P(!1 === A(b));
              var d = new Promise(function(a, c) {
                b._closeRequest = { _resolve: a, _reject: c };
              });
              !0 === b._backpressure && 'writable' === c && ca(a);
              L(b._writableStreamController);
              return d;
            }
            function J(a, b) {
              'pending' === a._closedPromiseState ? N(a, b) : da(a, b);
              a._closedPromise['catch'](function() {});
            }
            function f(a, b) {
              'pending' === a._readyPromiseState ? aa(a, b) : ba(a, b);
              a._readyPromise['catch'](function() {});
            }
            function r(a) {
              var b = a._ownerWritableStream;
              P(void 0 !== b);
              P(b._writer === a);
              var c = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
              f(a, c);
              J(a, c);
              b._writer = void 0;
              a._ownerWritableStream = void 0;
            }
            function D(a, b) {
              var c = a._ownerWritableStream;
              P(void 0 !== c);
              var d = c._writableStreamController;
              var e = d._strategySize;
              if (void 0 === e) var f = 1;
              else
                try {
                  f = e(b);
                } catch (oa) {
                  'writable' === d._controlledWritableStream._state && F(d, oa), (f = 1);
                }
              if (c !== a._ownerWritableStream) return Promise.reject(M('write to'));
              e = c._state;
              if ('errored' === e) return Promise.reject(c._storedError);
              if (!0 === A(c) || 'closed' === e)
                return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
              if ('erroring' === e) return Promise.reject(c._storedError);
              P('writable' === e);
              c = n(c);
              a: {
                e = { chunk: b };
                try {
                  Ca(d, e, f);
                } catch (oa) {
                  'writable' === d._controlledWritableStream._state && F(d, oa);
                  break a;
                }
                f = d._controlledWritableStream;
                !1 === A(f) && 'writable' === f._state && g(f, 0 >= d._strategyHWM - d._queueTotalSize);
                I(d);
              }
              return c;
            }
            function L(a) {
              Ca(a, 'close', 0);
              I(a);
            }
            function I(a) {
              var b = a._controlledWritableStream;
              if (!1 !== a._started && void 0 === b._inFlightWriteRequest) {
                var c = b._state;
                'closed' !== c &&
                  'errored' !== c &&
                  ('erroring' === c
                    ? p(b)
                    : 0 !== a._queue.length && ((b = Wa(a)), 'close' === b ? w(a) : E(a, b.chunk)));
              }
            }
            function w(a) {
              var b = a._controlledWritableStream;
              c(b);
              Aa(a);
              P(0 === a._queue.length, 'queue must be empty once the final write record is dequeued');
              Y(a._underlyingSink, 'close', [])
                .then(
                  function() {
                    P(void 0 !== b._inFlightCloseRequest);
                    b._inFlightCloseRequest._resolve(void 0);
                    b._inFlightCloseRequest = void 0;
                    var a = b._state;
                    P('writable' === a || 'erroring' === a);
                    'erroring' === a &&
                      ((b._storedError = void 0),
                      void 0 !== b._pendingAbortRequest &&
                        (b._pendingAbortRequest._resolve(), (b._pendingAbortRequest = void 0)));
                    b._state = 'closed';
                    a = b._writer;
                    void 0 !== a &&
                      (P(void 0 !== a._closedPromise_resolve, 'writer._closedPromise_resolve !== undefined'),
                      P(void 0 !== a._closedPromise_reject, 'writer._closedPromise_reject !== undefined'),
                      P('pending' === a._closedPromiseState, 'writer._closedPromiseState is pending'),
                      a._closedPromise_resolve(void 0),
                      (a._closedPromise_resolve = void 0),
                      (a._closedPromise_reject = void 0),
                      (a._closedPromiseState = 'resolved'));
                    P(void 0 === b._pendingAbortRequest, 'stream._pendingAbortRequest === undefined');
                    P(void 0 === b._storedError, 'stream._storedError === undefined');
                  },
                  function(a) {
                    P(void 0 !== b._inFlightCloseRequest);
                    b._inFlightCloseRequest._reject(a);
                    b._inFlightCloseRequest = void 0;
                    P('writable' === b._state || 'erroring' === b._state);
                    void 0 !== b._pendingAbortRequest &&
                      (b._pendingAbortRequest._reject(a), (b._pendingAbortRequest = void 0));
                    e(b, a);
                  },
                )
                ['catch'](Ha);
            }
            function E(a, b) {
              var c = a._controlledWritableStream;
              q(c);
              Y(a._underlyingSink, 'write', [b, a])
                .then(
                  function() {
                    P(void 0 !== c._inFlightWriteRequest);
                    c._inFlightWriteRequest._resolve(void 0);
                    c._inFlightWriteRequest = void 0;
                    var b = c._state;
                    P('writable' === b || 'erroring' === b);
                    Aa(a);
                    !1 === A(c) && 'writable' === b && g(c, 0 >= a._strategyHWM - a._queueTotalSize);
                    I(a);
                  },
                  function(a) {
                    P(void 0 !== c._inFlightWriteRequest);
                    c._inFlightWriteRequest._reject(a);
                    c._inFlightWriteRequest = void 0;
                    P('writable' === c._state || 'erroring' === c._state);
                    e(c, a);
                  },
                )
                ['catch'](Ha);
            }
            function F(a, b) {
              var c = a._controlledWritableStream;
              P('writable' === c._state);
              h(c, b);
            }
            function K(a) {
              return new TypeError('WritableStream.prototype.' + a + ' can only be used on a WritableStream');
            }
            function H(a) {
              return new TypeError(
                'WritableStreamDefaultWriter.prototype.' + a + ' can only be used on a WritableStreamDefaultWriter',
              );
            }
            function M(a) {
              return new TypeError('Cannot ' + a + ' a stream using a released writer');
            }
            function O(a) {
              a._closedPromise = new Promise(function(b, c) {
                a._closedPromise_resolve = b;
                a._closedPromise_reject = c;
                a._closedPromiseState = 'pending';
              });
            }
            function N(a, b) {
              P(void 0 !== a._closedPromise_resolve, 'writer._closedPromise_resolve !== undefined');
              P(void 0 !== a._closedPromise_reject, 'writer._closedPromise_reject !== undefined');
              P('pending' === a._closedPromiseState, 'writer._closedPromiseState is pending');
              a._closedPromise_reject(b);
              a._closedPromise_resolve = void 0;
              a._closedPromise_reject = void 0;
              a._closedPromiseState = 'rejected';
            }
            function da(a, b) {
              P(void 0 === a._closedPromise_resolve, 'writer._closedPromise_resolve === undefined');
              P(void 0 === a._closedPromise_reject, 'writer._closedPromise_reject === undefined');
              P('pending' !== a._closedPromiseState, 'writer._closedPromiseState is not pending');
              a._closedPromise = Promise.reject(b);
              a._closedPromiseState = 'rejected';
            }
            function W(a) {
              a._readyPromise = new Promise(function(b, c) {
                a._readyPromise_resolve = b;
                a._readyPromise_reject = c;
              });
              a._readyPromiseState = 'pending';
            }
            function Z(a, b) {
              a._readyPromise = Promise.reject(b);
              a._readyPromise_resolve = void 0;
              a._readyPromise_reject = void 0;
              a._readyPromiseState = 'rejected';
            }
            function y(a) {
              a._readyPromise = Promise.resolve(void 0);
              a._readyPromise_resolve = void 0;
              a._readyPromise_reject = void 0;
              a._readyPromiseState = 'fulfilled';
            }
            function aa(a, b) {
              P(void 0 !== a._readyPromise_resolve, 'writer._readyPromise_resolve !== undefined');
              P(void 0 !== a._readyPromise_reject, 'writer._readyPromise_reject !== undefined');
              a._readyPromise_reject(b);
              a._readyPromise_resolve = void 0;
              a._readyPromise_reject = void 0;
              a._readyPromiseState = 'rejected';
            }
            function X(a) {
              P(void 0 === a._readyPromise_resolve, 'writer._readyPromise_resolve === undefined');
              P(void 0 === a._readyPromise_reject, 'writer._readyPromise_reject === undefined');
              a._readyPromise = new Promise(function(b, c) {
                a._readyPromise_resolve = b;
                a._readyPromise_reject = c;
              });
              a._readyPromiseState = 'pending';
            }
            function ba(a, b) {
              P(void 0 === a._readyPromise_resolve, 'writer._readyPromise_resolve === undefined');
              P(void 0 === a._readyPromise_reject, 'writer._readyPromise_reject === undefined');
              a._readyPromise = Promise.reject(b);
              a._readyPromiseState = 'rejected';
            }
            function ca(a) {
              P(void 0 !== a._readyPromise_resolve, 'writer._readyPromise_resolve !== undefined');
              P(void 0 !== a._readyPromise_reject, 'writer._readyPromise_reject !== undefined');
              a._readyPromise_resolve(void 0);
              a._readyPromise_resolve = void 0;
              a._readyPromise_reject = void 0;
              a._readyPromiseState = 'fulfilled';
            }
            var T = (function() {
              function a(a, b) {
                for (var c = 0; c < b.length; c++) {
                  var d = b[c];
                  d.enumerable = d.enumerable || !1;
                  d.configurable = !0;
                  'value' in d && (d.writable = !0);
                  Object.defineProperty(a, d.key, d);
                }
              }
              return function(b, c, d) {
                c && a(b.prototype, c);
                d && a(b, d);
                return b;
              };
            })();
            b = m(0);
            var S = b.InvokeOrNoop,
              Y = b.PromiseInvokeOrNoop,
              U = b.ValidateAndNormalizeQueuingStrategy,
              V = b.typeIsObject;
            b = m(1);
            var P = b.assert,
              Ha = b.rethrowAssertionErrorRejection;
            m = m(3);
            var Aa = m.DequeueValue,
              Ca = m.EnqueueValueWithSize,
              Wa = m.PeekQueueValue,
              na = m.ResetQueue;
            m = (function() {
              function a() {
                var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
                  c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
                  e = c.size;
                c = c.highWaterMark;
                c = void 0 === c ? 1 : c;
                d(this, a);
                this._state = 'writable';
                this._writableStreamController = this._writer = this._storedError = void 0;
                this._writeRequests = [];
                this._pendingAbortRequest = this._inFlightCloseRequest = this._closeRequest = this._inFlightWriteRequest = void 0;
                this._backpressure = !1;
                if (void 0 !== b.type) throw new RangeError('Invalid type is specified');
                this._writableStreamController = new Ia(this, b, e, c);
                this._writableStreamController.__startSteps();
              }
              T(a, [
                {
                  key: 'abort',
                  value: function(a) {
                    return !1 === v(this)
                      ? Promise.reject(K('abort'))
                      : !0 === t(this)
                      ? Promise.reject(new TypeError('Cannot abort a stream that already has a writer'))
                      : B(this, a);
                  },
                },
                {
                  key: 'getWriter',
                  value: function() {
                    if (!1 === v(this)) throw K('getWriter');
                    return k(this);
                  },
                },
                {
                  key: 'locked',
                  get: function() {
                    if (!1 === v(this)) throw K('locked');
                    return t(this);
                  },
                },
              ]);
              return a;
            })();
            a.exports = {
              AcquireWritableStreamDefaultWriter: k,
              IsWritableStream: v,
              IsWritableStreamLocked: t,
              WritableStream: m,
              WritableStreamAbort: B,
              WritableStreamDefaultControllerError: F,
              WritableStreamDefaultWriterCloseWithErrorPropagation: function(a) {
                var b = a._ownerWritableStream;
                P(void 0 !== b);
                var c = b._state;
                if (!0 === A(b) || 'closed' === c) return Promise.resolve();
                if ('errored' === c) return Promise.reject(b._storedError);
                P('writable' === c || 'erroring' === c);
                return l(a);
              },
              WritableStreamDefaultWriterRelease: r,
              WritableStreamDefaultWriterWrite: D,
              WritableStreamCloseQueuedOrInFlight: A,
            };
            var Oa = (function() {
                function a(b) {
                  d(this, a);
                  if (!1 === v(b))
                    throw new TypeError(
                      'WritableStreamDefaultWriter can only be constructed with a WritableStream instance',
                    );
                  if (!0 === t(b))
                    throw new TypeError('This stream has already been locked for exclusive writing by another writer');
                  this._ownerWritableStream = b;
                  b._writer = this;
                  var c = b._state;
                  'writable' === c
                    ? (!1 === A(b) && !0 === b._backpressure ? W(this) : y(this), O(this))
                    : 'erroring' === c
                    ? (Z(this, b._storedError), this._readyPromise['catch'](function() {}), O(this))
                    : 'closed' === c
                    ? (y(this),
                      (this._closedPromise = Promise.resolve(void 0)),
                      (this._closedPromise_reject = this._closedPromise_resolve = void 0),
                      (this._closedPromiseState = 'resolved'))
                    : (P('errored' === c, 'state must be errored'),
                      (b = b._storedError),
                      Z(this, b),
                      this._readyPromise['catch'](function() {}),
                      (this._closedPromise = Promise.reject(b)),
                      (this._closedPromise_reject = this._closedPromise_resolve = void 0),
                      (this._closedPromiseState = 'rejected'),
                      this._closedPromise['catch'](function() {}));
                }
                T(a, [
                  {
                    key: 'abort',
                    value: function(a) {
                      if (!1 === G(this)) return Promise.reject(H('abort'));
                      if (void 0 === this._ownerWritableStream) return Promise.reject(M('abort'));
                      var b = this._ownerWritableStream;
                      P(void 0 !== b);
                      return B(b, a);
                    },
                  },
                  {
                    key: 'close',
                    value: function() {
                      if (!1 === G(this)) return Promise.reject(H('close'));
                      var a = this._ownerWritableStream;
                      return void 0 === a
                        ? Promise.reject(M('close'))
                        : !0 === A(a)
                        ? Promise.reject(new TypeError('cannot close an already-closing stream'))
                        : l(this);
                    },
                  },
                  {
                    key: 'releaseLock',
                    value: function() {
                      if (!1 === G(this)) throw H('releaseLock');
                      var a = this._ownerWritableStream;
                      void 0 !== a && (P(void 0 !== a._writer), r(this));
                    },
                  },
                  {
                    key: 'write',
                    value: function(a) {
                      return !1 === G(this)
                        ? Promise.reject(H('write'))
                        : void 0 === this._ownerWritableStream
                        ? Promise.reject(M('write to'))
                        : D(this, a);
                    },
                  },
                  {
                    key: 'closed',
                    get: function() {
                      return !1 === G(this) ? Promise.reject(H('closed')) : this._closedPromise;
                    },
                  },
                  {
                    key: 'desiredSize',
                    get: function() {
                      if (!1 === G(this)) throw H('desiredSize');
                      if (void 0 === this._ownerWritableStream) throw M('desiredSize');
                      var a = this._ownerWritableStream,
                        b = a._state;
                      'errored' === b || 'erroring' === b
                        ? (a = null)
                        : 'closed' === b
                        ? (a = 0)
                        : ((a = a._writableStreamController), (a = a._strategyHWM - a._queueTotalSize));
                      return a;
                    },
                  },
                  {
                    key: 'ready',
                    get: function() {
                      return !1 === G(this) ? Promise.reject(H('ready')) : this._readyPromise;
                    },
                  },
                ]);
                return a;
              })(),
              Ia = (function() {
                function a(b, c, e, f) {
                  d(this, a);
                  if (!1 === v(b))
                    throw new TypeError(
                      'WritableStreamDefaultController can only be constructed with a WritableStream instance',
                    );
                  if (void 0 !== b._writableStreamController)
                    throw new TypeError(
                      'WritableStreamDefaultController instances can only be created by the WritableStream constructor',
                    );
                  this._controlledWritableStream = b;
                  this._underlyingSink = c;
                  this._queueTotalSize = this._queue = void 0;
                  na(this);
                  this._started = !1;
                  c = U(e, f);
                  this._strategySize = c.size;
                  this._strategyHWM = c.highWaterMark;
                  g(b, 0 >= this._strategyHWM - this._queueTotalSize);
                }
                T(a, [
                  {
                    key: 'error',
                    value: function(a) {
                      var b = V(this) ? (Object.prototype.hasOwnProperty.call(this, '_underlyingSink') ? !0 : !1) : !1;
                      if (!1 === b)
                        throw new TypeError(
                          'WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController',
                        );
                      'writable' === this._controlledWritableStream._state && F(this, a);
                    },
                  },
                  {
                    key: '__abortSteps',
                    value: function(a) {
                      return Y(this._underlyingSink, 'abort', [a]);
                    },
                  },
                  {
                    key: '__errorSteps',
                    value: function() {
                      na(this);
                    },
                  },
                  {
                    key: '__startSteps',
                    value: function() {
                      var a = this,
                        b = S(this._underlyingSink, 'start', [this]),
                        c = this._controlledWritableStream;
                      Promise.resolve(b)
                        .then(
                          function() {
                            P('writable' === c._state || 'erroring' === c._state);
                            a._started = !0;
                            I(a);
                          },
                          function(b) {
                            P('writable' === c._state || 'erroring' === c._state);
                            a._started = !0;
                            e(c, b);
                          },
                        )
                        ['catch'](Ha);
                    },
                  },
                ]);
                return a;
              })();
          },
          function(a, b, m) {
            var d = m(0).IsFiniteNonNegativeNumber,
              k = m(1).assert;
            b.DequeueValue = function(a) {
              k(
                '_queue' in a && '_queueTotalSize' in a,
                'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].',
              );
              k(0 < a._queue.length, 'Spec-level failure: should never dequeue from an empty queue.');
              var b = a._queue.shift();
              a._queueTotalSize -= b.size;
              0 > a._queueTotalSize && (a._queueTotalSize = 0);
              return b.value;
            };
            b.EnqueueValueWithSize = function(a, b, m) {
              k(
                '_queue' in a && '_queueTotalSize' in a,
                'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and [[queueTotalSize]].',
              );
              m = Number(m);
              if (!d(m)) throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
              a._queue.push({ value: b, size: m });
              a._queueTotalSize += m;
            };
            b.PeekQueueValue = function(a) {
              k(
                '_queue' in a && '_queueTotalSize' in a,
                'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].',
              );
              k(0 < a._queue.length, 'Spec-level failure: should never peek at an empty queue.');
              return a._queue[0].value;
            };
            b.ResetQueue = function(a) {
              k(
                '_queue' in a && '_queueTotalSize' in a,
                'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].',
              );
              a._queue = [];
              a._queueTotalSize = 0;
            };
          },
          function(a, b, m) {
            function d(a, b) {
              if (!(a instanceof b)) throw new TypeError('Cannot call a class as a function');
            }
            function k(a) {
              return ia(a) && Object.prototype.hasOwnProperty.call(a, '_readableStreamController') ? !0 : !1;
            }
            function v(a) {
              R(!0 === k(a), 'IsReadableStreamLocked should only be used on known readable streams');
              return void 0 === a._reader ? !1 : !0;
            }
            function t(a, b) {
              R(!0 === k(a));
              R('boolean' === typeof b);
              var c = new jb(a),
                d = { closedOrErrored: !1, canceled1: !1, canceled2: !1, reason1: void 0, reason2: void 0 };
              d.promise = new Promise(function(a) {
                d._resolve = a;
              });
              var f = B();
              f._reader = c;
              f._teeState = d;
              f._cloneForBranch2 = b;
              var g = n();
              g._stream = a;
              g._teeState = d;
              var l = e();
              l._stream = a;
              l._teeState = d;
              var r = Object.create(Object.prototype);
              ra(r, 'pull', f);
              ra(r, 'cancel', g);
              g = new $a(r);
              r = Object.create(Object.prototype);
              ra(r, 'pull', f);
              ra(r, 'cancel', l);
              l = new $a(r);
              f._branch1 = g._readableStreamController;
              f._branch2 = l._readableStreamController;
              c._closedPromise['catch'](function(a) {
                !0 !== d.closedOrErrored && (H(f._branch1, a), H(f._branch2, a), (d.closedOrErrored = !0));
              });
              return [g, l];
            }
            function B() {
              function a() {
                var b = a._branch1,
                  c = a._branch2,
                  d = a._teeState;
                return L(a._reader).then(function(a) {
                  R(ia(a));
                  var e = a.value;
                  a = a.done;
                  R('boolean' === typeof a);
                  !0 === a &&
                    !1 === d.closedOrErrored &&
                    (!1 === d.canceled1 && F(b), !1 === d.canceled2 && F(c), (d.closedOrErrored = !0));
                  !0 !== d.closedOrErrored && (!1 === d.canceled1 && K(b, e), !1 === d.canceled2 && K(c, e));
                });
              }
              return a;
            }
            function n() {
              function a(b) {
                var c = a._stream,
                  d = a._teeState;
                d.canceled1 = !0;
                d.reason1 = b;
                !0 === d.canceled2 && ((b = qa([d.reason1, d.reason2])), (c = A(c, b)), d._resolve(c));
                return d.promise;
              }
              return a;
            }
            function e() {
              function a(b) {
                var c = a._stream,
                  d = a._teeState;
                d.canceled2 = !0;
                d.reason2 = b;
                !0 === d.canceled1 && ((b = qa([d.reason1, d.reason2])), (c = A(c, b)), d._resolve(c));
                return d.promise;
              }
              return a;
            }
            function h(a) {
              R(!0 === l(a._reader));
              R('readable' === a._state || 'closed' === a._state);
              return new Promise(function(b, c) {
                a._reader._readIntoRequests.push({ _resolve: b, _reject: c });
              });
            }
            function p(a) {
              R(!0 === J(a._reader));
              R('readable' === a._state);
              return new Promise(function(b, c) {
                a._reader._readRequests.push({ _resolve: b, _reject: c });
              });
            }
            function A(a, b) {
              a._disturbed = !0;
              if ('closed' === a._state) return Promise.resolve(void 0);
              if ('errored' === a._state) return Promise.reject(a._storedError);
              c(a);
              return a._readableStreamController.__cancelSteps(b).then(function() {});
            }
            function c(a) {
              R('readable' === a._state);
              a._state = 'closed';
              a = a._reader;
              if (void 0 !== a) {
                if (!0 === J(a)) {
                  for (var b = 0; b < a._readRequests.length; b++) {
                    var c = a._readRequests[b]._resolve;
                    c(ma(void 0, !0));
                  }
                  a._readRequests = [];
                }
                R(void 0 !== a._closedPromise_resolve);
                R(void 0 !== a._closedPromise_reject);
                a._closedPromise_resolve(void 0);
                a._closedPromise_resolve = void 0;
                a._closedPromise_reject = void 0;
              }
            }
            function q(a, b) {
              R(!0 === k(a), 'stream must be ReadableStream');
              R('readable' === a._state, 'state must be readable');
              a._state = 'errored';
              a._storedError = b;
              var c = a._reader;
              if (void 0 !== c) {
                if (!0 === J(c)) {
                  for (var d = 0; d < c._readRequests.length; d++) c._readRequests[d]._reject(b);
                  c._readRequests = [];
                } else {
                  R(l(c), 'reader must be ReadableStreamBYOBReader');
                  for (d = 0; d < c._readIntoRequests.length; d++) c._readIntoRequests[d]._reject(b);
                  c._readIntoRequests = [];
                }
                Q(c, b);
                c._closedPromise['catch'](function() {});
              }
            }
            function x(a, b, c) {
              a = a._reader;
              R(0 < a._readRequests.length);
              a._readRequests.shift()._resolve(ma(b, c));
            }
            function g(a) {
              a = a._reader;
              return void 0 === a || !1 === l(a) ? !1 : !0;
            }
            function G(a) {
              a = a._reader;
              return void 0 === a || !1 === J(a) ? !1 : !0;
            }
            function l(a) {
              return ia(a) && Object.prototype.hasOwnProperty.call(a, '_readIntoRequests') ? !0 : !1;
            }
            function J(a) {
              return ia(a) && Object.prototype.hasOwnProperty.call(a, '_readRequests') ? !0 : !1;
            }
            function f(a, b) {
              a._ownerReadableStream = b;
              b._reader = a;
              'readable' === b._state
                ? Oa(a)
                : 'closed' === b._state
                ? wa(a)
                : (R('errored' === b._state, 'state must be errored'),
                  Ia(a, b._storedError),
                  a._closedPromise['catch'](function() {}));
            }
            function r(a, b) {
              var c = a._ownerReadableStream;
              R(void 0 !== c);
              return A(c, b);
            }
            function D(a) {
              R(void 0 !== a._ownerReadableStream);
              R(a._ownerReadableStream._reader === a);
              'readable' === a._ownerReadableStream._state
                ? Q(
                    a,
                    new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"),
                  )
                : ua(
                    a,
                    new TypeError("Reader was released and can no longer be used to monitor the stream's closedness"),
                  );
              a._closedPromise['catch'](function() {});
              a._ownerReadableStream._reader = void 0;
              a._ownerReadableStream = void 0;
            }
            function L(a) {
              a = a._ownerReadableStream;
              R(void 0 !== a);
              a._disturbed = !0;
              if ('closed' === a._state) return Promise.resolve(ma(void 0, !0));
              if ('errored' === a._state) return Promise.reject(a._storedError);
              R('readable' === a._state);
              return a._readableStreamController.__pullSteps();
            }
            function I(a) {
              return ia(a) && Object.prototype.hasOwnProperty.call(a, '_underlyingSource') ? !0 : !1;
            }
            function w(a) {
              !1 !== E(a) &&
                (!0 === a._pulling
                  ? (a._pullAgain = !0)
                  : (R(!1 === a._pullAgain),
                    (a._pulling = !0),
                    va(a._underlyingSource, 'pull', [a])
                      .then(
                        function() {
                          a._pulling = !1;
                          if (!0 === a._pullAgain) return (a._pullAgain = !1), w(a);
                        },
                        function(b) {
                          M(a, b);
                        },
                      )
                      ['catch'](fa)));
            }
            function E(a) {
              var b = a._controlledReadableStream;
              return 'closed' === b._state || 'errored' === b._state || !0 === a._closeRequested || !1 === a._started
                ? !1
                : (!0 === v(b) && 0 < b._reader._readRequests.length) || 0 < O(a)
                ? !0
                : !1;
            }
            function F(a) {
              var b = a._controlledReadableStream;
              R(!1 === a._closeRequested);
              R('readable' === b._state);
              a._closeRequested = !0;
              0 === a._queue.length && c(b);
            }
            function K(a, b) {
              var c = a._controlledReadableStream;
              R(!1 === a._closeRequested);
              R('readable' === c._state);
              if (!0 === v(c) && 0 < c._reader._readRequests.length) x(c, b, !1);
              else {
                c = 1;
                if (void 0 !== a._strategySize) {
                  var d = a._strategySize;
                  try {
                    c = d(b);
                  } catch (Qa) {
                    throw (M(a, Qa), Qa);
                  }
                }
                try {
                  bb(a, b, c);
                } catch (Qa) {
                  throw (M(a, Qa), Qa);
                }
              }
              w(a);
            }
            function H(a, b) {
              var c = a._controlledReadableStream;
              R('readable' === c._state);
              Ea(a);
              q(c, b);
            }
            function M(a, b) {
              'readable' === a._controlledReadableStream._state && H(a, b);
            }
            function O(a) {
              var b = a._controlledReadableStream._state;
              return 'errored' === b ? null : 'closed' === b ? 0 : a._strategyHWM - a._queueTotalSize;
            }
            function N(a) {
              return ia(a) && Object.prototype.hasOwnProperty.call(a, '_underlyingByteSource') ? !0 : !1;
            }
            function da(a) {
              return ia(a) && Object.prototype.hasOwnProperty.call(a, '_associatedReadableByteStreamController')
                ? !0
                : !1;
            }
            function W(a) {
              !1 !== P(a) &&
                (!0 === a._pulling
                  ? (a._pullAgain = !0)
                  : (R(!1 === a._pullAgain),
                    (a._pulling = !0),
                    va(a._underlyingByteSource, 'pull', [a])
                      .then(
                        function() {
                          a._pulling = !1;
                          !0 === a._pullAgain && ((a._pullAgain = !1), W(a));
                        },
                        function(b) {
                          'readable' === a._controlledReadableStream._state && Ha(a, b);
                        },
                      )
                      ['catch'](fa)));
            }
            function Z(a, b) {
              R('errored' !== a._state, 'state must not be errored');
              var c = !1;
              'closed' === a._state && (R(0 === b.bytesFilled), (c = !0));
              var d = y(b);
              if ('default' === b.readerType) x(a, d, c);
              else {
                R('byob' === b.readerType);
                var e = a._reader;
                R(0 < e._readIntoRequests.length);
                e._readIntoRequests.shift()._resolve(ma(d, c));
              }
            }
            function y(a) {
              var b = a.bytesFilled,
                c = a.elementSize;
              R(b <= a.byteLength);
              R(0 === b % c);
              return new a.ctor(a.buffer, a.byteOffset, b / c);
            }
            function aa(a, b, c, d) {
              a._queue.push({ buffer: b, byteOffset: c, byteLength: d });
              a._queueTotalSize += d;
            }
            function X(a, b) {
              var c = b.elementSize,
                d = Math.min(a._queueTotalSize, b.byteLength - b.bytesFilled),
                e = b.bytesFilled + d,
                f = e - (e % c);
              e = !1;
              f > b.bytesFilled - (b.bytesFilled % c) && ((d = f - b.bytesFilled), (e = !0));
              for (c = a._queue; 0 < d; ) {
                f = c[0];
                var g = Math.min(d, f.byteLength);
                ya(b.buffer, b.byteOffset + b.bytesFilled, f.buffer, f.byteOffset, g);
                f.byteLength === g ? c.shift() : ((f.byteOffset += g), (f.byteLength -= g));
                a._queueTotalSize -= g;
                ba(a, g, b);
                d -= g;
              }
              !1 === e &&
                (R(0 === a._queueTotalSize, 'queue must be empty'),
                R(0 < b.bytesFilled),
                R(b.bytesFilled < b.elementSize));
              return e;
            }
            function ba(a, b, c) {
              R(0 === a._pendingPullIntos.length || a._pendingPullIntos[0] === c);
              T(a);
              c.bytesFilled += b;
            }
            function ca(a) {
              R('readable' === a._controlledReadableStream._state);
              0 === a._queueTotalSize && !0 === a._closeRequested ? c(a._controlledReadableStream) : W(a);
            }
            function T(a) {
              void 0 !== a._byobRequest &&
                ((a._byobRequest._associatedReadableByteStreamController = void 0),
                (a._byobRequest._view = void 0),
                (a._byobRequest = void 0));
            }
            function S(a) {
              for (R(!1 === a._closeRequested); 0 < a._pendingPullIntos.length && 0 !== a._queueTotalSize; ) {
                var b = a._pendingPullIntos[0];
                !0 === X(a, b) && (V(a), Z(a._controlledReadableStream, b));
              }
            }
            function Y(a, b) {
              var c = a._controlledReadableStream,
                d = 1;
              b.constructor !== DataView && (d = b.constructor.BYTES_PER_ELEMENT);
              d = {
                buffer: b.buffer,
                byteOffset: b.byteOffset,
                byteLength: b.byteLength,
                bytesFilled: 0,
                elementSize: d,
                ctor: b.constructor,
                readerType: 'byob',
              };
              if (0 < a._pendingPullIntos.length) return (d.buffer = Ba(d.buffer)), a._pendingPullIntos.push(d), h(c);
              if ('closed' === c._state)
                return (c = new b.constructor(d.buffer, d.byteOffset, 0)), Promise.resolve(ma(c, !0));
              if (0 < a._queueTotalSize) {
                if (!0 === X(a, d)) return (c = y(d)), ca(a), Promise.resolve(ma(c, !1));
                if (!0 === a._closeRequested)
                  return (
                    (c = new TypeError('Insufficient bytes to fill elements in the given buffer')),
                    Ha(a, c),
                    Promise.reject(c)
                  );
              }
              d.buffer = Ba(d.buffer);
              a._pendingPullIntos.push(d);
              c = h(c);
              W(a);
              return c;
            }
            function U(a, b) {
              var c = a._pendingPullIntos[0],
                d = a._controlledReadableStream;
              if ('closed' === d._state) {
                if (0 !== b) throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
                c.buffer = Ba(c.buffer);
                R(0 === c.bytesFilled, 'bytesFilled must be 0');
                c = a._controlledReadableStream;
                if (!0 === g(c)) for (; 0 < c._reader._readIntoRequests.length; ) (d = V(a)), Z(c, d);
              } else {
                R('readable' === d._state);
                if (c.bytesFilled + b > c.byteLength) throw new RangeError('bytesWritten out of range');
                ba(a, b, c);
                if (!(c.bytesFilled < c.elementSize)) {
                  V(a);
                  d = c.bytesFilled % c.elementSize;
                  if (0 < d) {
                    var e = c.byteOffset + c.bytesFilled;
                    e = c.buffer.slice(e - d, e);
                    aa(a, e, 0, e.byteLength);
                  }
                  c.buffer = Ba(c.buffer);
                  c.bytesFilled -= d;
                  Z(a._controlledReadableStream, c);
                  S(a);
                }
              }
            }
            function V(a) {
              var b = a._pendingPullIntos.shift();
              T(a);
              return b;
            }
            function P(a) {
              var b = a._controlledReadableStream;
              return 'readable' !== b._state || !0 === a._closeRequested || !1 === a._started
                ? !1
                : (!0 === G(b) && 0 < b._reader._readRequests.length) ||
                  (!0 === g(b) && 0 < b._reader._readIntoRequests.length) ||
                  0 < Aa(a)
                ? !0
                : !1;
            }
            function Ha(a, b) {
              var c = a._controlledReadableStream;
              R('readable' === c._state);
              T(a);
              a._pendingPullIntos = [];
              Ea(a);
              q(c, b);
            }
            function Aa(a) {
              var b = a._controlledReadableStream._state;
              return 'errored' === b ? null : 'closed' === b ? 0 : a._strategyHWM - a._queueTotalSize;
            }
            function Ca(a) {
              return new TypeError('ReadableStream.prototype.' + a + ' can only be used on a ReadableStream');
            }
            function Wa(a) {
              return new TypeError('Cannot ' + a + ' a stream using a released reader');
            }
            function na(a) {
              return new TypeError(
                'ReadableStreamDefaultReader.prototype.' + a + ' can only be used on a ReadableStreamDefaultReader',
              );
            }
            function Oa(a) {
              a._closedPromise = new Promise(function(b, c) {
                a._closedPromise_resolve = b;
                a._closedPromise_reject = c;
              });
            }
            function Ia(a, b) {
              a._closedPromise = Promise.reject(b);
              a._closedPromise_resolve = void 0;
              a._closedPromise_reject = void 0;
            }
            function wa(a) {
              a._closedPromise = Promise.resolve(void 0);
              a._closedPromise_resolve = void 0;
              a._closedPromise_reject = void 0;
            }
            function Q(a, b) {
              R(void 0 !== a._closedPromise_resolve);
              R(void 0 !== a._closedPromise_reject);
              a._closedPromise_reject(b);
              a._closedPromise_resolve = void 0;
              a._closedPromise_reject = void 0;
            }
            function ua(a, b) {
              R(void 0 === a._closedPromise_resolve);
              R(void 0 === a._closedPromise_reject);
              a._closedPromise = Promise.reject(b);
            }
            function Ja(a) {
              return new TypeError(
                'ReadableStreamBYOBReader.prototype.' + a + ' can only be used on a ReadableStreamBYOBReader',
              );
            }
            function Sa(a) {
              return new TypeError(
                'ReadableStreamDefaultController.prototype.' +
                  a +
                  ' can only be used on a ReadableStreamDefaultController',
              );
            }
            function ja(a) {
              return new TypeError(
                'ReadableStreamBYOBRequest.prototype.' + a + ' can only be used on a ReadableStreamBYOBRequest',
              );
            }
            function oa(a) {
              return new TypeError(
                'ReadableByteStreamController.prototype.' + a + ' can only be used on a ReadableByteStreamController',
              );
            }
            function Da(a) {
              try {
                Promise.prototype.then.call(a, void 0, function() {});
              } catch (Cb) {}
            }
            var Ka = (function() {
              function a(a, b) {
                for (var c = 0; c < b.length; c++) {
                  var d = b[c];
                  d.enumerable = d.enumerable || !1;
                  d.configurable = !0;
                  'value' in d && (d.writable = !0);
                  Object.defineProperty(a, d.key, d);
                }
              }
              return function(b, c, d) {
                c && a(b.prototype, c);
                d && a(b, d);
                return b;
              };
            })();
            b = m(0);
            var ya = b.ArrayBufferCopy,
              ma = b.CreateIterResultObject,
              la = b.IsFiniteNonNegativeNumber,
              pa = b.InvokeOrNoop,
              va = b.PromiseInvokeOrNoop,
              Ba = b.TransferArrayBuffer,
              ta = b.ValidateAndNormalizeQueuingStrategy,
              Ta = b.ValidateAndNormalizeHighWaterMark;
            b = m(0);
            var qa = b.createArrayFromList,
              ra = b.createDataProperty,
              ia = b.typeIsObject;
            b = m(1);
            var R = b.assert,
              fa = b.rethrowAssertionErrorRejection;
            b = m(3);
            var Ya = b.DequeueValue,
              bb = b.EnqueueValueWithSize,
              Ea = b.ResetQueue;
            m = m(2);
            var Ua = m.AcquireWritableStreamDefaultWriter,
              Za = m.IsWritableStream,
              Pa = m.IsWritableStreamLocked,
              za = m.WritableStreamAbort,
              La = m.WritableStreamDefaultWriterCloseWithErrorPropagation,
              ka = m.WritableStreamDefaultWriterRelease,
              Ma = m.WritableStreamDefaultWriterWrite,
              xa = m.WritableStreamCloseQueuedOrInFlight,
              $a = (function() {
                function a() {
                  var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
                    c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
                    e = c.size;
                  c = c.highWaterMark;
                  d(this, a);
                  this._state = 'readable';
                  this._storedError = this._reader = void 0;
                  this._disturbed = !1;
                  this._readableStreamController = void 0;
                  var f = b.type;
                  if ('bytes' === String(f))
                    void 0 === c && (c = 0), (this._readableStreamController = new Fa(this, b, c));
                  else if (void 0 === f)
                    void 0 === c && (c = 1), (this._readableStreamController = new vb(this, b, e, c));
                  else throw new RangeError('Invalid type is specified');
                }
                Ka(a, [
                  {
                    key: 'cancel',
                    value: function(a) {
                      return !1 === k(this)
                        ? Promise.reject(Ca('cancel'))
                        : !0 === v(this)
                        ? Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'))
                        : A(this, a);
                    },
                  },
                  {
                    key: 'getReader',
                    value: function() {
                      var a = (0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}).mode;
                      if (!1 === k(this)) throw Ca('getReader');
                      if (void 0 === a) return new jb(this);
                      a = String(a);
                      if ('byob' === a) return new ub(this);
                      throw new RangeError('Invalid mode is specified');
                    },
                  },
                  {
                    key: 'pipeThrough',
                    value: function(a, b) {
                      var c = a.readable,
                        d = this.pipeTo(a.writable, b);
                      Da(d);
                      return c;
                    },
                  },
                  {
                    key: 'pipeTo',
                    value: function(a) {
                      var b = this,
                        c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
                        d = c.preventClose,
                        e = c.preventAbort,
                        f = c.preventCancel;
                      if (!1 === k(this)) return Promise.reject(Ca('pipeTo'));
                      if (!1 === Za(a))
                        return Promise.reject(
                          new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"),
                        );
                      d = !!d;
                      e = !!e;
                      f = !!f;
                      if (!0 === v(this))
                        return Promise.reject(
                          new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'),
                        );
                      if (!0 === Pa(a))
                        return Promise.reject(
                          new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'),
                        );
                      var g = new jb(this),
                        l = Ua(a),
                        r = !1,
                        h = Promise.resolve();
                      return new Promise(function(c, n) {
                        function p() {
                          h = Promise.resolve();
                          return !0 === r
                            ? Promise.resolve()
                            : l._readyPromise
                                .then(function() {
                                  return L(g).then(function(a) {
                                    !0 !== a.done && (h = Ma(l, a.value)['catch'](function() {}));
                                  });
                                })
                                .then(p);
                        }
                        function q() {
                          var a = h;
                          return h.then(function() {
                            return a !== h ? q() : void 0;
                          });
                        }
                        function k(a, b, c) {
                          'errored' === a._state ? c(a._storedError) : b['catch'](c)['catch'](fa);
                        }
                        function m(b, c, d) {
                          function e() {
                            b()
                              .then(
                                function() {
                                  return x(c, d);
                                },
                                function(a) {
                                  return x(!0, a);
                                },
                              )
                              ['catch'](fa);
                          }
                          !0 !== r && ((r = !0), 'writable' === a._state && !1 === xa(a) ? q().then(e) : e());
                        }
                        function w(b, c) {
                          !0 !== r &&
                            ((r = !0),
                            'writable' === a._state && !1 === xa(a)
                              ? q()
                                  .then(function() {
                                    return x(b, c);
                                  })
                                  ['catch'](fa)
                              : x(b, c));
                        }
                        function x(a, b) {
                          ka(l);
                          D(g);
                          a ? n(b) : c(void 0);
                        }
                        k(b, g._closedPromise, function(b) {
                          !1 === e
                            ? m(
                                function() {
                                  return za(a, b);
                                },
                                !0,
                                b,
                              )
                            : w(!0, b);
                        });
                        k(a, l._closedPromise, function(a) {
                          !1 === f
                            ? m(
                                function() {
                                  return A(b, a);
                                },
                                !0,
                                a,
                              )
                            : w(!0, a);
                        });
                        (function(a, b, c) {
                          'closed' === a._state ? c() : b.then(c)['catch'](fa);
                        })(b, g._closedPromise, function() {
                          !1 === d
                            ? m(function() {
                                return La(l);
                              })
                            : w();
                        });
                        if (!0 === xa(a) || 'closed' === a._state) {
                          var u = new TypeError(
                            'the destination writable stream closed before all data could be piped to it',
                          );
                          !1 === f
                            ? m(
                                function() {
                                  return A(b, u);
                                },
                                !0,
                                u,
                              )
                            : w(!0, u);
                        }
                        p()['catch'](function(a) {
                          h = Promise.resolve();
                          fa(a);
                        });
                      });
                    },
                  },
                  {
                    key: 'tee',
                    value: function() {
                      if (!1 === k(this)) throw Ca('tee');
                      var a = t(this, !1);
                      return qa(a);
                    },
                  },
                  {
                    key: 'locked',
                    get: function() {
                      if (!1 === k(this)) throw Ca('locked');
                      return v(this);
                    },
                  },
                ]);
                return a;
              })();
            a.exports = {
              ReadableStream: $a,
              IsReadableStreamDisturbed: function(a) {
                R(!0 === k(a), 'IsReadableStreamDisturbed should only be used on known readable streams');
                return a._disturbed;
              },
              ReadableStreamDefaultControllerClose: F,
              ReadableStreamDefaultControllerEnqueue: K,
              ReadableStreamDefaultControllerError: H,
              ReadableStreamDefaultControllerGetDesiredSize: O,
            };
            var jb = (function() {
                function a(b) {
                  d(this, a);
                  if (!1 === k(b))
                    throw new TypeError(
                      'ReadableStreamDefaultReader can only be constructed with a ReadableStream instance',
                    );
                  if (!0 === v(b))
                    throw new TypeError('This stream has already been locked for exclusive reading by another reader');
                  f(this, b);
                  this._readRequests = [];
                }
                Ka(a, [
                  {
                    key: 'cancel',
                    value: function(a) {
                      return !1 === J(this)
                        ? Promise.reject(na('cancel'))
                        : void 0 === this._ownerReadableStream
                        ? Promise.reject(Wa('cancel'))
                        : r(this, a);
                    },
                  },
                  {
                    key: 'read',
                    value: function() {
                      return !1 === J(this)
                        ? Promise.reject(na('read'))
                        : void 0 === this._ownerReadableStream
                        ? Promise.reject(Wa('read from'))
                        : L(this);
                    },
                  },
                  {
                    key: 'releaseLock',
                    value: function() {
                      if (!1 === J(this)) throw na('releaseLock');
                      if (void 0 !== this._ownerReadableStream) {
                        if (0 < this._readRequests.length)
                          throw new TypeError(
                            'Tried to release a reader lock when that reader has pending read() calls un-settled',
                          );
                        D(this);
                      }
                    },
                  },
                  {
                    key: 'closed',
                    get: function() {
                      return !1 === J(this) ? Promise.reject(na('closed')) : this._closedPromise;
                    },
                  },
                ]);
                return a;
              })(),
              ub = (function() {
                function a(b) {
                  d(this, a);
                  if (!k(b))
                    throw new TypeError(
                      'ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a byte source',
                    );
                  if (!1 === N(b._readableStreamController))
                    throw new TypeError(
                      'Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source',
                    );
                  if (v(b))
                    throw new TypeError('This stream has already been locked for exclusive reading by another reader');
                  f(this, b);
                  this._readIntoRequests = [];
                }
                Ka(a, [
                  {
                    key: 'cancel',
                    value: function(a) {
                      return l(this)
                        ? void 0 === this._ownerReadableStream
                          ? Promise.reject(Wa('cancel'))
                          : r(this, a)
                        : Promise.reject(Ja('cancel'));
                    },
                  },
                  {
                    key: 'read',
                    value: function(a) {
                      if (!l(this)) return Promise.reject(Ja('read'));
                      if (void 0 === this._ownerReadableStream) return Promise.reject(Wa('read from'));
                      if (!ArrayBuffer.isView(a))
                        return Promise.reject(new TypeError('view must be an array buffer view'));
                      if (0 === a.byteLength)
                        return Promise.reject(new TypeError('view must have non-zero byteLength'));
                      var b = this._ownerReadableStream;
                      R(void 0 !== b);
                      b._disturbed = !0;
                      a = 'errored' === b._state ? Promise.reject(b._storedError) : Y(b._readableStreamController, a);
                      return a;
                    },
                  },
                  {
                    key: 'releaseLock',
                    value: function() {
                      if (!l(this)) throw Ja('releaseLock');
                      if (void 0 !== this._ownerReadableStream) {
                        if (0 < this._readIntoRequests.length)
                          throw new TypeError(
                            'Tried to release a reader lock when that reader has pending read() calls un-settled',
                          );
                        D(this);
                      }
                    },
                  },
                  {
                    key: 'closed',
                    get: function() {
                      return l(this) ? this._closedPromise : Promise.reject(Ja('closed'));
                    },
                  },
                ]);
                return a;
              })(),
              vb = (function() {
                function a(b, c, e, f) {
                  d(this, a);
                  if (!1 === k(b))
                    throw new TypeError(
                      'ReadableStreamDefaultController can only be constructed with a ReadableStream instance',
                    );
                  if (void 0 !== b._readableStreamController)
                    throw new TypeError(
                      'ReadableStreamDefaultController instances can only be created by the ReadableStream constructor',
                    );
                  this._controlledReadableStream = b;
                  this._underlyingSource = c;
                  this._queueTotalSize = this._queue = void 0;
                  Ea(this);
                  this._pulling = this._pullAgain = this._closeRequested = this._started = !1;
                  b = ta(e, f);
                  this._strategySize = b.size;
                  this._strategyHWM = b.highWaterMark;
                  var g = this;
                  c = pa(c, 'start', [this]);
                  Promise.resolve(c)
                    .then(
                      function() {
                        g._started = !0;
                        R(!1 === g._pulling);
                        R(!1 === g._pullAgain);
                        w(g);
                      },
                      function(a) {
                        M(g, a);
                      },
                    )
                    ['catch'](fa);
                }
                Ka(a, [
                  {
                    key: 'close',
                    value: function() {
                      if (!1 === I(this)) throw Sa('close');
                      if (!0 === this._closeRequested)
                        throw new TypeError('The stream has already been closed; do not close it again!');
                      var a = this._controlledReadableStream._state;
                      if ('readable' !== a)
                        throw new TypeError(
                          'The stream (in ' + a + ' state) is not in the readable state and cannot be closed',
                        );
                      F(this);
                    },
                  },
                  {
                    key: 'enqueue',
                    value: function(a) {
                      if (!1 === I(this)) throw Sa('enqueue');
                      if (!0 === this._closeRequested) throw new TypeError('stream is closed or draining');
                      var b = this._controlledReadableStream._state;
                      if ('readable' !== b)
                        throw new TypeError(
                          'The stream (in ' + b + ' state) is not in the readable state and cannot be enqueued to',
                        );
                      return K(this, a);
                    },
                  },
                  {
                    key: 'error',
                    value: function(a) {
                      if (!1 === I(this)) throw Sa('error');
                      var b = this._controlledReadableStream;
                      if ('readable' !== b._state)
                        throw new TypeError('The stream is ' + b._state + ' and so cannot be errored');
                      H(this, a);
                    },
                  },
                  {
                    key: '__cancelSteps',
                    value: function(a) {
                      Ea(this);
                      return va(this._underlyingSource, 'cancel', [a]);
                    },
                  },
                  {
                    key: '__pullSteps',
                    value: function() {
                      var a = this._controlledReadableStream;
                      if (0 < this._queue.length) {
                        var b = Ya(this);
                        !0 === this._closeRequested && 0 === this._queue.length ? c(a) : w(this);
                        return Promise.resolve(ma(b, !1));
                      }
                      a = p(a);
                      w(this);
                      return a;
                    },
                  },
                  {
                    key: 'desiredSize',
                    get: function() {
                      if (!1 === I(this)) throw Sa('desiredSize');
                      return O(this);
                    },
                  },
                ]);
                return a;
              })(),
              ha = (function() {
                function a(b, c) {
                  d(this, a);
                  this._associatedReadableByteStreamController = b;
                  this._view = c;
                }
                Ka(a, [
                  {
                    key: 'respond',
                    value: function(a) {
                      if (!1 === da(this)) throw ja('respond');
                      if (void 0 === this._associatedReadableByteStreamController)
                        throw new TypeError('This BYOB request has been invalidated');
                      var b = this._associatedReadableByteStreamController;
                      a = Number(a);
                      if (!1 === la(a)) throw new RangeError('bytesWritten must be a finite');
                      R(0 < b._pendingPullIntos.length);
                      U(b, a);
                    },
                  },
                  {
                    key: 'respondWithNewView',
                    value: function(a) {
                      if (!1 === da(this)) throw ja('respond');
                      if (void 0 === this._associatedReadableByteStreamController)
                        throw new TypeError('This BYOB request has been invalidated');
                      if (!ArrayBuffer.isView(a)) throw new TypeError('You can only respond with array buffer views');
                      var b = this._associatedReadableByteStreamController;
                      R(0 < b._pendingPullIntos.length);
                      var c = b._pendingPullIntos[0];
                      if (c.byteOffset + c.bytesFilled !== a.byteOffset)
                        throw new RangeError('The region specified by view does not match byobRequest');
                      if (c.byteLength !== a.byteLength)
                        throw new RangeError('The buffer of view has different capacity than byobRequest');
                      c.buffer = a.buffer;
                      U(b, a.byteLength);
                    },
                  },
                  {
                    key: 'view',
                    get: function() {
                      return this._view;
                    },
                  },
                ]);
                return a;
              })(),
              Fa = (function() {
                function a(b, c, e) {
                  d(this, a);
                  if (!1 === k(b))
                    throw new TypeError(
                      'ReadableByteStreamController can only be constructed with a ReadableStream instance given a byte source',
                    );
                  if (void 0 !== b._readableStreamController)
                    throw new TypeError(
                      'ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte source',
                    );
                  this._controlledReadableStream = b;
                  this._underlyingByteSource = c;
                  this._pulling = this._pullAgain = !1;
                  T(this);
                  this._pendingPullIntos = [];
                  this._queue = this._queueTotalSize = void 0;
                  Ea(this);
                  this._started = this._closeRequested = !1;
                  this._strategyHWM = Ta(e);
                  e = c.autoAllocateChunkSize;
                  if (void 0 !== e && (!1 === Number.isInteger(e) || 0 >= e))
                    throw new RangeError('autoAllocateChunkSize must be a positive integer');
                  this._autoAllocateChunkSize = e;
                  this._pendingPullIntos = [];
                  var f = this;
                  c = pa(c, 'start', [this]);
                  Promise.resolve(c)
                    .then(
                      function() {
                        f._started = !0;
                        R(!1 === f._pulling);
                        R(!1 === f._pullAgain);
                        W(f);
                      },
                      function(a) {
                        'readable' === b._state && Ha(f, a);
                      },
                    )
                    ['catch'](fa);
                }
                Ka(a, [
                  {
                    key: 'close',
                    value: function() {
                      if (!1 === N(this)) throw oa('close');
                      if (!0 === this._closeRequested)
                        throw new TypeError('The stream has already been closed; do not close it again!');
                      var a = this._controlledReadableStream._state;
                      if ('readable' !== a)
                        throw new TypeError(
                          'The stream (in ' + a + ' state) is not in the readable state and cannot be closed',
                        );
                      a = this._controlledReadableStream;
                      R(!1 === this._closeRequested);
                      R('readable' === a._state);
                      if (0 < this._queueTotalSize) this._closeRequested = !0;
                      else {
                        if (0 < this._pendingPullIntos.length && 0 < this._pendingPullIntos[0].bytesFilled)
                          throw ((a = new TypeError('Insufficient bytes to fill elements in the given buffer')),
                          Ha(this, a),
                          a);
                        c(a);
                      }
                    },
                  },
                  {
                    key: 'enqueue',
                    value: function(a) {
                      if (!1 === N(this)) throw oa('enqueue');
                      if (!0 === this._closeRequested) throw new TypeError('stream is closed or draining');
                      var b = this._controlledReadableStream._state;
                      if ('readable' !== b)
                        throw new TypeError(
                          'The stream (in ' + b + ' state) is not in the readable state and cannot be enqueued to',
                        );
                      if (!ArrayBuffer.isView(a))
                        throw new TypeError(
                          'You can only enqueue array buffer views when using a ReadableByteStreamController',
                        );
                      b = this._controlledReadableStream;
                      R(!1 === this._closeRequested);
                      R('readable' === b._state);
                      var c = a.byteOffset,
                        d = a.byteLength;
                      a = Ba(a.buffer);
                      !0 === G(b)
                        ? 0 === b._reader._readRequests.length
                          ? aa(this, a, c, d)
                          : (R(0 === this._queue.length), (a = new Uint8Array(a, c, d)), x(b, a, !1))
                        : !0 === g(b)
                        ? (aa(this, a, c, d), S(this))
                        : (R(!1 === v(b), 'stream must not be locked'), aa(this, a, c, d));
                    },
                  },
                  {
                    key: 'error',
                    value: function(a) {
                      if (!1 === N(this)) throw oa('error');
                      var b = this._controlledReadableStream;
                      if ('readable' !== b._state)
                        throw new TypeError('The stream is ' + b._state + ' and so cannot be errored');
                      Ha(this, a);
                    },
                  },
                  {
                    key: '__cancelSteps',
                    value: function(a) {
                      0 < this._pendingPullIntos.length && (this._pendingPullIntos[0].bytesFilled = 0);
                      Ea(this);
                      return va(this._underlyingByteSource, 'cancel', [a]);
                    },
                  },
                  {
                    key: '__pullSteps',
                    value: function() {
                      var a = this._controlledReadableStream;
                      R(!0 === G(a));
                      if (0 < this._queueTotalSize) {
                        R(0 === a._reader._readRequests.length);
                        a = this._queue.shift();
                        this._queueTotalSize -= a.byteLength;
                        ca(this);
                        var b = void 0;
                        try {
                          b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
                        } catch (Qa) {
                          return Promise.reject(Qa);
                        }
                        return Promise.resolve(ma(b, !1));
                      }
                      b = this._autoAllocateChunkSize;
                      if (void 0 !== b) {
                        var c = void 0;
                        try {
                          c = new ArrayBuffer(b);
                        } catch (Qa) {
                          return Promise.reject(Qa);
                        }
                        this._pendingPullIntos.push({
                          buffer: c,
                          byteOffset: 0,
                          byteLength: b,
                          bytesFilled: 0,
                          elementSize: 1,
                          ctor: Uint8Array,
                          readerType: 'default',
                        });
                      }
                      a = p(a);
                      W(this);
                      return a;
                    },
                  },
                  {
                    key: 'byobRequest',
                    get: function() {
                      if (!1 === N(this)) throw oa('byobRequest');
                      if (void 0 === this._byobRequest && 0 < this._pendingPullIntos.length) {
                        var a = this._pendingPullIntos[0];
                        a = new Uint8Array(a.buffer, a.byteOffset + a.bytesFilled, a.byteLength - a.bytesFilled);
                        this._byobRequest = new ha(this, a);
                      }
                      return this._byobRequest;
                    },
                  },
                  {
                    key: 'desiredSize',
                    get: function() {
                      if (!1 === N(this)) throw oa('desiredSize');
                      return Aa(this);
                    },
                  },
                ]);
                return a;
              })();
          },
          function(a, b, m) {
            a = m(6);
            var d = m(4);
            m = m(2);
            b.TransformStream = a.TransformStream;
            b.ReadableStream = d.ReadableStream;
            b.IsReadableStreamDisturbed = d.IsReadableStreamDisturbed;
            b.ReadableStreamDefaultControllerClose = d.ReadableStreamDefaultControllerClose;
            b.ReadableStreamDefaultControllerEnqueue = d.ReadableStreamDefaultControllerEnqueue;
            b.ReadableStreamDefaultControllerError = d.ReadableStreamDefaultControllerError;
            b.ReadableStreamDefaultControllerGetDesiredSize = d.ReadableStreamDefaultControllerGetDesiredSize;
            b.AcquireWritableStreamDefaultWriter = m.AcquireWritableStreamDefaultWriter;
            b.IsWritableStream = m.IsWritableStream;
            b.IsWritableStreamLocked = m.IsWritableStreamLocked;
            b.WritableStream = m.WritableStream;
            b.WritableStreamAbort = m.WritableStreamAbort;
            b.WritableStreamDefaultControllerError = m.WritableStreamDefaultControllerError;
            b.WritableStreamDefaultWriterCloseWithErrorPropagation =
              m.WritableStreamDefaultWriterCloseWithErrorPropagation;
            b.WritableStreamDefaultWriterRelease = m.WritableStreamDefaultWriterRelease;
            b.WritableStreamDefaultWriterWrite = m.WritableStreamDefaultWriterWrite;
          },
          function(a, b, m) {
            function d(a, b) {
              if (!(a instanceof b)) throw new TypeError('Cannot call a class as a function');
            }
            function k(a, b) {
              if (!0 === a._errored) throw new TypeError('TransformStream is already errored');
              if (!0 === a._readableClosed) throw new TypeError('Readable side is already closed');
              var c = a._readableController;
              try {
                L(c, b);
              } catch (W) {
                throw ((a._readableClosed = !0), !1 === a._errored && t(a, W), a._storedError);
              }
              !0 === 0 >= w(c) && !1 === a._backpressure && n(a, !0);
            }
            function v(a) {
              g(!1 === a._errored);
              g(!1 === a._readableClosed);
              try {
                D(a._readableController);
              } catch (N) {
                g(!1);
              }
              a._readableClosed = !0;
            }
            function t(a, b) {
              g(!1 === a._errored);
              a._errored = !0;
              a._storedError = b;
              !1 === a._writableDone && F(a._writableController, b);
              !1 === a._readableClosed && I(a._readableController, b);
            }
            function B(a) {
              g(void 0 !== a._backpressureChangePromise, '_backpressureChangePromise should have been initialized');
              if (!1 === a._backpressure) return Promise.resolve();
              g(!0 === a._backpressure, '_backpressure should have been initialized');
              return a._backpressureChangePromise;
            }
            function n(a, b) {
              g(
                a._backpressure !== b,
                'TransformStreamSetBackpressure() should be called only when backpressure is changed',
              );
              void 0 !== a._backpressureChangePromise && a._backpressureChangePromise_resolve(b);
              a._backpressureChangePromise = new Promise(function(b) {
                a._backpressureChangePromise_resolve = b;
              });
              a._backpressureChangePromise.then(function(a) {
                g(a !== b, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
              });
              a._backpressure = b;
            }
            function e(a, b) {
              k(b._controlledTransformStream, a);
              return Promise.resolve();
            }
            function h(a, b) {
              g(!1 === a._errored);
              g(!1 === a._transforming);
              g(!1 === a._backpressure);
              a._transforming = !0;
              var c = a._transformStreamController;
              return l(a._transformer, 'transform', [b, c], e, [b, c]).then(
                function() {
                  a._transforming = !1;
                  return B(a);
                },
                function(b) {
                  !1 === a._errored && t(a, b);
                  return Promise.reject(b);
                },
              );
            }
            function p(a) {
              return f(a) && Object.prototype.hasOwnProperty.call(a, '_controlledTransformStream') ? !0 : !1;
            }
            function A(a) {
              return f(a) && Object.prototype.hasOwnProperty.call(a, '_transformStreamController') ? !0 : !1;
            }
            function c(a) {
              return new TypeError(
                'TransformStreamDefaultController.prototype.' +
                  a +
                  ' can only be used on a TransformStreamDefaultController',
              );
            }
            function q(a) {
              return new TypeError('TransformStream.prototype.' + a + ' can only be used on a TransformStream');
            }
            var x = (function() {
                function a(a, b) {
                  for (var c = 0; c < b.length; c++) {
                    var d = b[c];
                    d.enumerable = d.enumerable || !1;
                    d.configurable = !0;
                    'value' in d && (d.writable = !0);
                    Object.defineProperty(a, d.key, d);
                  }
                }
                return function(b, c, d) {
                  c && a(b.prototype, c);
                  d && a(b, d);
                  return b;
                };
              })(),
              g = m(1).assert;
            b = m(0);
            var G = b.InvokeOrNoop,
              l = b.PromiseInvokeOrPerformFallback,
              J = b.PromiseInvokeOrNoop,
              f = b.typeIsObject;
            b = m(4);
            var r = b.ReadableStream,
              D = b.ReadableStreamDefaultControllerClose,
              L = b.ReadableStreamDefaultControllerEnqueue,
              I = b.ReadableStreamDefaultControllerError,
              w = b.ReadableStreamDefaultControllerGetDesiredSize;
            m = m(2);
            var E = m.WritableStream,
              F = m.WritableStreamDefaultControllerError,
              K = (function() {
                function a(b, c) {
                  d(this, a);
                  this._transformStream = b;
                  this._startPromise = c;
                }
                x(a, [
                  {
                    key: 'start',
                    value: function(a) {
                      var b = this._transformStream;
                      b._writableController = a;
                      return this._startPromise.then(function() {
                        return B(b);
                      });
                    },
                  },
                  {
                    key: 'write',
                    value: function(a) {
                      return h(this._transformStream, a);
                    },
                  },
                  {
                    key: 'abort',
                    value: function() {
                      var a = this._transformStream;
                      a._writableDone = !0;
                      t(a, new TypeError('Writable side aborted'));
                    },
                  },
                  {
                    key: 'close',
                    value: function() {
                      var a = this._transformStream;
                      g(!1 === a._transforming);
                      a._writableDone = !0;
                      return J(a._transformer, 'flush', [a._transformStreamController])
                        .then(function() {
                          if (!0 === a._errored) return Promise.reject(a._storedError);
                          !1 === a._readableClosed && v(a);
                          return Promise.resolve();
                        })
                        ['catch'](function(b) {
                          !1 === a._errored && t(a, b);
                          return Promise.reject(a._storedError);
                        });
                    },
                  },
                ]);
                return a;
              })(),
              H = (function() {
                function a(b, c) {
                  d(this, a);
                  this._transformStream = b;
                  this._startPromise = c;
                }
                x(a, [
                  {
                    key: 'start',
                    value: function(a) {
                      var b = this._transformStream;
                      b._readableController = a;
                      return this._startPromise.then(function() {
                        g(
                          void 0 !== b._backpressureChangePromise,
                          '_backpressureChangePromise should have been initialized',
                        );
                        if (!0 === b._backpressure) return Promise.resolve();
                        g(!1 === b._backpressure, '_backpressure should have been initialized');
                        return b._backpressureChangePromise;
                      });
                    },
                  },
                  {
                    key: 'pull',
                    value: function() {
                      var a = this._transformStream;
                      g(!0 === a._backpressure, 'pull() should be never called while _backpressure is false');
                      g(
                        void 0 !== a._backpressureChangePromise,
                        '_backpressureChangePromise should have been initialized',
                      );
                      n(a, !1);
                      return a._backpressureChangePromise;
                    },
                  },
                  {
                    key: 'cancel',
                    value: function() {
                      var a = this._transformStream;
                      a._readableClosed = !0;
                      t(a, new TypeError('Readable side canceled'));
                    },
                  },
                ]);
                return a;
              })(),
              M = (function() {
                function a(b) {
                  d(this, a);
                  if (!1 === A(b))
                    throw new TypeError(
                      'TransformStreamDefaultController can only be constructed with a TransformStream instance',
                    );
                  if (void 0 !== b._transformStreamController)
                    throw new TypeError(
                      'TransformStreamDefaultController instances can only be created by the TransformStream constructor',
                    );
                  this._controlledTransformStream = b;
                }
                x(a, [
                  {
                    key: 'enqueue',
                    value: function(a) {
                      if (!1 === p(this)) throw c('enqueue');
                      k(this._controlledTransformStream, a);
                    },
                  },
                  {
                    key: 'close',
                    value: function() {
                      if (!1 === p(this)) throw c('close');
                      var a = this._controlledTransformStream;
                      if (!0 === a._errored) throw new TypeError('TransformStream is already errored');
                      if (!0 === a._readableClosed) throw new TypeError('Readable side is already closed');
                      v(a);
                    },
                  },
                  {
                    key: 'error',
                    value: function(a) {
                      if (!1 === p(this)) throw c('error');
                      var b = this._controlledTransformStream;
                      if (!0 === b._errored) throw new TypeError('TransformStream is already errored');
                      t(b, a);
                    },
                  },
                  {
                    key: 'desiredSize',
                    get: function() {
                      if (!1 === p(this)) throw c('desiredSize');
                      return w(this._controlledTransformStream._readableController);
                    },
                  },
                ]);
                return a;
              })();
            m = (function() {
              function a() {
                var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
                d(this, a);
                this._transformer = b;
                var c = b.readableStrategy,
                  e = b.writableStrategy;
                this._errored = this._transforming = !1;
                this._transformStreamController = this._readableController = this._writableController = this._storedError = void 0;
                this._readableClosed = this._writableDone = !1;
                this._backpressureChangePromise_resolve = this._backpressureChangePromise = this._backpressure = void 0;
                this._transformStreamController = new M(this);
                var f = void 0,
                  l = new Promise(function(a) {
                    f = a;
                  }),
                  h = new H(this, l);
                this._readable = new r(h, c);
                c = new K(this, l);
                this._writable = new E(c, e);
                g(void 0 !== this._writableController);
                g(void 0 !== this._readableController);
                e = w(this._readableController);
                n(this, 0 >= e);
                var p = this;
                b = G(b, 'start', [p._transformStreamController]);
                f(b);
                l['catch'](function(a) {
                  !1 === p._errored && ((p._errored = !0), (p._storedError = a));
                });
              }
              x(a, [
                {
                  key: 'readable',
                  get: function() {
                    if (!1 === A(this)) throw q('readable');
                    return this._readable;
                  },
                },
                {
                  key: 'writable',
                  get: function() {
                    if (!1 === A(this)) throw q('writable');
                    return this._writable;
                  },
                },
              ]);
              return a;
            })();
            a.exports = { TransformStream: m };
          },
          function(a, b, m) {
            a.exports = m(5);
          },
        ]),
      );
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.PDFJS = m.isWorker = m.globalScope = void 0;
      y = t(55);
      var a = t(7),
        k = t(0),
        b = t(67),
        v = t(11);
      v = v && v.__esModule ? v : { default: v };
      var d = t(57),
        u = t(68);
      t = t(69);
      var z = 'undefined' === typeof window;
      v['default'].PDFJS || (v['default'].PDFJS = {});
      var C = v['default'].PDFJS;
      C.version = '1.9.597';
      C.build = 'f3987bba';
      C.pdfBug = !1;
      void 0 !== C.verbosity && (0, k.setVerbosityLevel)(C.verbosity);
      delete C.verbosity;
      Object.defineProperty(C, 'verbosity', {
        get: function() {
          return (0, k.getVerbosityLevel)();
        },
        set: function(a) {
          (0, k.setVerbosityLevel)(a);
        },
        enumerable: !0,
        configurable: !0,
      });
      C.VERBOSITY_LEVELS = k.VERBOSITY_LEVELS;
      C.OPS = k.OPS;
      C.UNSUPPORTED_FEATURES = k.UNSUPPORTED_FEATURES;
      C.isValidUrl = a.isValidUrl;
      C.shadow = k.shadow;
      C.createBlob = k.createBlob;
      C.createObjectURL = function(a, b) {
        return (0, k.createObjectURL)(a, b, C.disableCreateObjectURL);
      };
      Object.defineProperty(C, 'isLittleEndian', {
        configurable: !0,
        get: function() {
          return (0, k.shadow)(C, 'isLittleEndian', (0, k.isLittleEndian)());
        },
      });
      C.removeNullCharacters = k.removeNullCharacters;
      C.PasswordResponses = k.PasswordResponses;
      C.PasswordException = k.PasswordException;
      C.UnknownErrorException = k.UnknownErrorException;
      C.InvalidPDFException = k.InvalidPDFException;
      C.MissingPDFException = k.MissingPDFException;
      C.UnexpectedResponseException = k.UnexpectedResponseException;
      C.Util = k.Util;
      C.PageViewport = k.PageViewport;
      C.createPromiseCapability = k.createPromiseCapability;
      C.maxImageSize = void 0 === C.maxImageSize ? -1 : C.maxImageSize;
      C.cMapUrl = void 0 === C.cMapUrl ? null : C.cMapUrl;
      C.cMapPacked = void 0 === C.cMapPacked ? !1 : C.cMapPacked;
      C.disableFontFace = void 0 === C.disableFontFace ? !1 : C.disableFontFace;
      C.imageResourcesPath = void 0 === C.imageResourcesPath ? '' : C.imageResourcesPath;
      C.disableWorker = void 0 === C.disableWorker ? !1 : C.disableWorker;
      C.workerSrc = void 0 === C.workerSrc ? null : C.workerSrc;
      C.workerPort = void 0 === C.workerPort ? null : C.workerPort;
      C.disableRange = void 0 === C.disableRange ? !1 : C.disableRange;
      C.disableStream = void 0 === C.disableStream ? !1 : C.disableStream;
      C.disableAutoFetch = void 0 === C.disableAutoFetch ? !1 : C.disableAutoFetch;
      C.pdfBug = void 0 === C.pdfBug ? !1 : C.pdfBug;
      C.postMessageTransfers = void 0 === C.postMessageTransfers ? !0 : C.postMessageTransfers;
      C.disableCreateObjectURL = void 0 === C.disableCreateObjectURL ? !1 : C.disableCreateObjectURL;
      C.disableWebGL = void 0 === C.disableWebGL ? !0 : C.disableWebGL;
      C.externalLinkTarget = void 0 === C.externalLinkTarget ? a.LinkTarget.NONE : C.externalLinkTarget;
      C.externalLinkRel = void 0 === C.externalLinkRel ? a.DEFAULT_LINK_REL : C.externalLinkRel;
      C.isEvalSupported = void 0 === C.isEvalSupported ? !0 : C.isEvalSupported;
      C.pdfjsNext = void 0 === C.pdfjsNext ? !1 : C.pdfjsNext;
      var B = C.openExternalLinksInNewWindow;
      delete C.openExternalLinksInNewWindow;
      Object.defineProperty(C, 'openExternalLinksInNewWindow', {
        get: function() {
          return C.externalLinkTarget === a.LinkTarget.BLANK;
        },
        set: function(b) {
          b &&
            (0, k.deprecated)(
              'PDFJS.openExternalLinksInNewWindow, please use "PDFJS.externalLinkTarget = PDFJS.LinkTarget.BLANK" instead.',
            );
          C.externalLinkTarget !== a.LinkTarget.NONE
            ? (0, k.warn)('PDFJS.externalLinkTarget is already initialized')
            : (C.externalLinkTarget = b ? a.LinkTarget.BLANK : a.LinkTarget.NONE);
        },
        enumerable: !0,
        configurable: !0,
      });
      B && (C.openExternalLinksInNewWindow = B);
      C.getDocument = y.getDocument;
      C.LoopbackPort = y.LoopbackPort;
      C.PDFDataRangeTransport = y.PDFDataRangeTransport;
      C.PDFWorker = y.PDFWorker;
      C.hasCanvasTypedArrays = !0;
      C.CustomStyle = a.CustomStyle;
      C.LinkTarget = a.LinkTarget;
      C.addLinkAttributes = a.addLinkAttributes;
      C.getFilenameFromUrl = a.getFilenameFromUrl;
      C.isExternalLinkTargetSet = a.isExternalLinkTargetSet;
      C.AnnotationLayer = b.AnnotationLayer;
      C.renderTextLayer = u.renderTextLayer;
      C.Metadata = d.Metadata;
      C.SVGGraphics = t.SVGGraphics;
      C.UnsupportedManager = y._UnsupportedManager;
      m.globalScope = v['default'];
      m.isWorker = z;
      m.PDFJS = C;
    },
    function(y, m, t) {
      function a(a) {
        this.docId = a;
        this.styleElement = null;
        this.nativeFontFaces = [];
        this.loadTestFontId = 0;
        this.loadingContext = { requests: [], nextRequestId: 0 };
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.FontLoader = m.FontFaceObject = void 0;
      var k = t(0);
      a.prototype = {
        insertRule: function(a) {
          var b = this.styleElement;
          b ||
            ((b = this.styleElement = document.createElement('style')),
            (b.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId),
            document.documentElement.getElementsByTagName('head')[0].appendChild(b));
          b = b.sheet;
          b.insertRule(a, b.cssRules.length);
        },
        clear: function() {
          this.styleElement && (this.styleElement.remove(), (this.styleElement = null));
          this.nativeFontFaces.forEach(function(a) {
            document.fonts['delete'](a);
          });
          this.nativeFontFaces.length = 0;
        },
      };
      Object.defineProperty(a.prototype, 'loadTestFont', {
        get: function() {
          return (0, k.shadow)(
            this,
            'loadTestFont',
            atob(
              'T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==',
            ),
          );
        },
        configurable: !0,
      });
      a.prototype.addNativeFontFace = function(a) {
        this.nativeFontFaces.push(a);
        document.fonts.add(a);
      };
      a.prototype.bind = function(b, d) {
        for (
          var m = [],
            v = [],
            t = [],
            B = function(a) {
              return a.loaded['catch'](function(b) {
                (0, k.warn)('Failed to load font "' + a.family + '": ' + b);
              });
            },
            n = a.isFontLoadingAPISupported && !a.isSyncFontLoadingSupported,
            e = 0,
            h = b.length;
          e < h;
          e++
        ) {
          var p = b[e];
          if (!p.attached && !1 !== p.loading)
            if (((p.attached = !0), n)) {
              if ((p = p.createNativeFontFace())) this.addNativeFontFace(p), t.push(B(p));
            } else {
              var A = p.createFontFaceRule();
              A && (this.insertRule(A), m.push(A), v.push(p));
            }
        }
        var c = this.queueLoadingCallback(d);
        n
          ? Promise.all(t).then(function() {
              c.complete();
            })
          : 0 < m.length && !a.isSyncFontLoadingSupported
          ? this.prepareFontLoadEvent(m, v, c)
          : c.complete();
      };
      a.prototype.queueLoadingCallback = function(a) {
        var b = this.loadingContext,
          m = {
            id: 'pdfjs-font-loading-' + b.nextRequestId++,
            complete: function() {
              (0, k.assert)(!m.end, 'completeRequest() cannot be called twice');
              for (m.end = Date.now(); 0 < b.requests.length && b.requests[0].end; ) {
                var a = b.requests.shift();
                setTimeout(a.callback, 0);
              }
            },
            callback: a,
            started: Date.now(),
          };
        b.requests.push(m);
        return m;
      };
      a.prototype.prepareFontLoadEvent = function(a, b, m) {
        function d(a, b) {
          return (
            (a.charCodeAt(b) << 24) |
            (a.charCodeAt(b + 1) << 16) |
            (a.charCodeAt(b + 2) << 8) |
            (a.charCodeAt(b + 3) & 255)
          );
        }
        function u(a, b, c, d) {
          var e = a.substr(0, b);
          a = a.substr(b + c);
          return e + d + a;
        }
        function B(a, b) {
          h++;
          30 < h
            ? ((0, k.warn)('Load test font never loaded.'), b())
            : ((e.font = '30px ' + a),
              e.fillText('.', 0, 20),
              0 < e.getImageData(0, 0, 1, 1).data[3] ? b() : setTimeout(B.bind(null, a, b)));
        }
        var n;
        a = document.createElement('canvas');
        a.width = 1;
        a.height = 1;
        var e = a.getContext('2d'),
          h = 0;
        a = 'lt' + Date.now() + this.loadTestFontId++;
        var p = this.loadTestFont;
        p = u(p, 976, a.length, a);
        var A = d(p, 16);
        var c = 0;
        for (n = a.length - 3; c < n; c += 4) A = (A - 1482184792 + d(a, c)) | 0;
        c < a.length && (A = (A - 1482184792 + d(a + 'XXX', c)) | 0);
        p = u(p, 16, 4, (0, k.string32)(A));
        c = 'url(data:font/opentype;base64,' + btoa(p) + ');';
        this.insertRule('@font-face { font-family:"' + a + '";src:' + c + '}');
        p = [];
        c = 0;
        for (n = b.length; c < n; c++) p.push(b[c].loadedName);
        p.push(a);
        var q = document.createElement('div');
        q.setAttribute(
          'style',
          'visibility: hidden;width: 10px; height: 10px;position: absolute; top: 0px; left: 0px;',
        );
        c = 0;
        for (n = p.length; c < n; ++c)
          (b = document.createElement('span')), (b.textContent = 'Hi'), (b.style.fontFamily = p[c]), q.appendChild(b);
        document.body.appendChild(q);
        B(a, function() {
          document.body.removeChild(q);
          m.complete();
        });
      };
      a.isFontLoadingAPISupported = 'undefined' !== typeof document && !!document.fonts;
      Object.defineProperty(a, 'isSyncFontLoadingSupported', {
        get: function() {
          var b = (0, k.shadow);
          if ('undefined' === typeof navigator) var d = !0;
          else {
            d = !1;
            var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
            m && 14 <= m[1] && (d = !0);
          }
          return b(a, 'isSyncFontLoadingSupported', d);
        },
        enumerable: !0,
        configurable: !0,
      });
      var b = {
        get value() {
          return (0, k.shadow)(this, 'value', (0, k.isEvalSupported)());
        },
      };
      y = (function() {
        function a(a, b) {
          this.compiledGlyphs = Object.create(null);
          for (var d in a) this[d] = a[d];
          this.options = b;
        }
        a.prototype = {
          createNativeFontFace: function() {
            if (!this.data) return null;
            if (this.options.disableFontFace) return (this.disableFontFace = !0), null;
            var a = new FontFace(this.loadedName, this.data, {});
            this.options.fontRegistry && this.options.fontRegistry.registerFont(this);
            return a;
          },
          createFontFaceRule: function() {
            if (!this.data) return null;
            if (this.options.disableFontFace) return (this.disableFontFace = !0), null;
            var a = (0, k.bytesToString)(new Uint8Array(this.data)),
              b = this.loadedName;
            a = 'url(data:' + this.mimetype + ';base64,' + btoa(a) + ');';
            b = '@font-face { font-family:"' + b + '";src:' + a + '}';
            this.options.fontRegistry && this.options.fontRegistry.registerFont(this, a);
            return b;
          },
          getPathGenerator: function(a, k) {
            if (!(k in this.compiledGlyphs)) {
              var d = a.get(this.loadedName + '_path_' + k),
                m;
              if (this.options.isEvalSupported && b.value) {
                var u = '';
                var n = 0;
                for (m = d.length; n < m; n++) {
                  var e = d[n];
                  var h = void 0 !== e.args ? e.args.join(',') : '';
                  u += 'c.' + e.cmd + '(' + h + ');\n';
                }
                this.compiledGlyphs[k] = new Function('c', 'size', u);
              } else
                this.compiledGlyphs[k] = function(a, b) {
                  n = 0;
                  for (m = d.length; n < m; n++)
                    (e = d[n]), 'scale' === e.cmd && (e.args = [b, -b]), a[e.cmd].apply(a, e.args);
                };
            }
            return this.compiledGlyphs[k];
          },
        };
        return a;
      })();
      m.FontFaceObject = y;
      m.FontLoader = a;
    },
    function(y, m, t) {
      function a(a) {
        a.mozCurrentTransform ||
          ((a._originalSave = a.save),
          (a._originalRestore = a.restore),
          (a._originalRotate = a.rotate),
          (a._originalScale = a.scale),
          (a._originalTranslate = a.translate),
          (a._originalTransform = a.transform),
          (a._originalSetTransform = a.setTransform),
          (a._transformMatrix = a._transformMatrix || [1, 0, 0, 1, 0, 0]),
          (a._transformStack = []),
          Object.defineProperty(a, 'mozCurrentTransform', {
            get: function() {
              return this._transformMatrix;
            },
          }),
          Object.defineProperty(a, 'mozCurrentTransformInverse', {
            get: function() {
              var a = this._transformMatrix,
                b = a[0],
                d = a[1],
                p = a[2],
                k = a[3],
                c = a[4];
              a = a[5];
              var q = b * k - d * p,
                m = d * p - b * k;
              return [k / q, d / m, p / m, b / q, (k * c - p * a) / m, (d * c - b * a) / q];
            },
          }),
          (a.save = function() {
            var a = this._transformMatrix;
            this._transformStack.push(a);
            this._transformMatrix = a.slice(0, 6);
            this._originalSave();
          }),
          (a.restore = function() {
            var a = this._transformStack.pop();
            a && ((this._transformMatrix = a), this._originalRestore());
          }),
          (a.translate = function(a, b) {
            var d = this._transformMatrix;
            d[4] = d[0] * a + d[2] * b + d[4];
            d[5] = d[1] * a + d[3] * b + d[5];
            this._originalTranslate(a, b);
          }),
          (a.scale = function(a, b) {
            var d = this._transformMatrix;
            d[0] *= a;
            d[1] *= a;
            d[2] *= b;
            d[3] *= b;
            this._originalScale(a, b);
          }),
          (a.transform = function(b, d, h, p, k, c) {
            var e = this._transformMatrix;
            this._transformMatrix = [
              e[0] * b + e[2] * d,
              e[1] * b + e[3] * d,
              e[0] * h + e[2] * p,
              e[1] * h + e[3] * p,
              e[0] * k + e[2] * c + e[4],
              e[1] * k + e[3] * c + e[5],
            ];
            a._originalTransform(b, d, h, p, k, c);
          }),
          (a.setTransform = function(b, d, h, p, k, c) {
            this._transformMatrix = [b, d, h, p, k, c];
            a._originalSetTransform(b, d, h, p, k, c);
          }),
          (a.rotate = function(a) {
            var b = Math.cos(a),
              d = Math.sin(a),
              n = this._transformMatrix;
            this._transformMatrix = [
              n[0] * b + n[2] * d,
              n[1] * b + n[3] * d,
              n[0] * -d + n[2] * b,
              n[1] * -d + n[3] * b,
              n[4],
              n[5],
            ];
            this._originalRotate(a);
          }));
      }
      function k(a) {
        var b = a.width,
          d = a.height,
          h,
          p = b + 1,
          k = new Uint8Array(p * (d + 1)),
          c = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]),
          q = (b + 7) & -8,
          m = a.data,
          g = new Uint8Array(q * d),
          u = 0;
        a = 0;
        for (h = m.length; a < h; a++) {
          var l = 128;
          for (var v = m[a]; 0 < l; ) (g[u++] = v & l ? 0 : 255), (l >>= 1);
        }
        u = m = 0;
        0 !== g[u] && ((k[0] = 1), ++m);
        for (h = 1; h < b; h++) g[u] !== g[u + 1] && ((k[h] = g[u] ? 2 : 1), ++m), u++;
        0 !== g[u] && ((k[h] = 2), ++m);
        for (a = 1; a < d; a++) {
          u = a * q;
          l = a * p;
          g[u - q] !== g[u] && ((k[l] = g[u] ? 1 : 8), ++m);
          v = (g[u] ? 4 : 0) + (g[u - q] ? 8 : 0);
          for (h = 1; h < b; h++)
            (v = (v >> 2) + (g[u + 1] ? 4 : 0) + (g[u - q + 1] ? 8 : 0)), c[v] && ((k[l + h] = c[v]), ++m), u++;
          g[u - q] !== g[u] && ((k[l + h] = g[u] ? 2 : 4), ++m);
          if (1e3 < m) return null;
        }
        u = q * (d - 1);
        l = a * p;
        0 !== g[u] && ((k[l] = 8), ++m);
        for (h = 1; h < b; h++) g[u] !== g[u + 1] && ((k[l + h] = g[u] ? 4 : 8), ++m), u++;
        0 !== g[u] && ((k[l + h] = 4), ++m);
        if (1e3 < m) return null;
        c = new Int32Array([0, p, -1, 0, -p, 0, 0, 0, 1]);
        var f = [];
        for (a = 0; m && a <= d; a++) {
          q = a * p;
          for (g = q + b; q < g && !k[q]; ) q++;
          if (q !== g) {
            g = [q % p, a];
            u = k[q];
            h = q;
            do {
              l = c[u];
              do q += l;
              while (!k[q]);
              l = k[q];
              5 !== l && 10 !== l ? ((u = l), (k[q] = 0)) : ((u = l & ((51 * u) >> 4)), (k[q] &= (u >> 2) | (u << 2)));
              g.push(q % p);
              g.push((q / p) | 0);
              --m;
            } while (h !== q);
            f.push(g);
            --a;
          }
        }
        return function(a) {
          a.save();
          a.scale(1 / b, -1 / d);
          a.translate(0, -d);
          a.beginPath();
          for (var c = 0, e = f.length; c < e; c++) {
            var g = f[c];
            a.moveTo(g[0], g[1]);
            for (var l = 2, r = g.length; l < r; l += 2) a.lineTo(g[l], g[l + 1]);
          }
          a.fill();
          a.beginPath();
          a.restore();
        };
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.CanvasGraphics = void 0;
      var b = t(0),
        v = t(101),
        d = t(56),
        u = {
          get value() {
            return (0, b.shadow)(u, 'value', (0, b.isLittleEndian)());
          },
        },
        z = (function() {
          function b(a) {
            this.canvasFactory = a;
            this.cache = Object.create(null);
          }
          b.prototype = {
            getCanvas: function(b, d, h, p) {
              if (void 0 !== this.cache[b]) {
                var e = this.cache[b];
                this.canvasFactory.reset(e, d, h);
                e.context.setTransform(1, 0, 0, 1, 0, 0);
              } else (e = this.canvasFactory.create(d, h)), (this.cache[b] = e);
              p && a(e.context);
              return e;
            },
            clear: function() {
              for (var a in this.cache) this.canvasFactory.destroy(this.cache[a]), delete this.cache[a];
            },
          };
          return b;
        })(),
        C = (function() {
          function a() {
            this.alphaIsShape = !1;
            this.fontSize = 0;
            this.fontSizeScale = 1;
            this.textMatrix = b.IDENTITY_MATRIX;
            this.textMatrixScale = 1;
            this.fontMatrix = b.FONT_IDENTITY_MATRIX;
            this.wordSpacing = this.charSpacing = this.lineY = this.lineX = this.y = this.x = this.leading = 0;
            this.textHScale = 1;
            this.textRenderingMode = b.TextRenderingMode.FILL;
            this.textRise = 0;
            this.strokeColor = this.fillColor = '#000000';
            this.patternFill = !1;
            this.lineWidth = this.strokeAlpha = this.fillAlpha = 1;
            this.resumeSMaskCtx = this.activeSMask = null;
          }
          a.prototype = {
            clone: function() {
              return Object.create(this);
            },
            setCurrentPoint: function(a, b) {
              this.x = a;
              this.y = b;
            },
          };
          return a;
        })();
      y = (function() {
        function m(b, c, d, e, g) {
          this.ctx = b;
          this.current = new C();
          this.stateStack = [];
          this.pendingClip = null;
          this.pendingEOFill = !1;
          this.xobjs = this.res = null;
          this.commonObjs = c;
          this.objs = d;
          this.canvasFactory = e;
          this.imageLayer = g;
          this.groupStack = [];
          this.baseTransform = this.processingType3 = null;
          this.baseTransformStack = [];
          this.groupLevel = 0;
          this.smaskStack = [];
          this.smaskCounter = 0;
          this.tempSMask = null;
          this.cachedCanvases = new z(this.canvasFactory);
          b && a(b);
          this.cachedGetSinglePixelWidth = null;
        }
        function n(a, c) {
          if ('undefined' !== typeof ImageData && c instanceof ImageData) a.putImageData(c, 0, 0);
          else {
            var d = c.height,
              e = c.width,
              f = d % 16;
            d = (d - f) / 16;
            var g = 0 === f ? d : d + 1,
              l = a.createImageData(e, 16),
              r = 0,
              h,
              n = c.data,
              p = l.data,
              q,
              k;
            if (c.kind === b.ImageKind.GRAYSCALE_1BPP) {
              var m = n.byteLength;
              p = new Uint32Array(p.buffer, 0, p.byteLength >> 2);
              var x = p.length,
                A = (e + 7) >> 3,
                v = u.value ? 4278190080 : 255;
              for (q = 0; q < g; q++) {
                var B = q < d ? 16 : f;
                for (k = h = 0; k < B; k++) {
                  var t = m - r,
                    z = 0;
                  t = t > A ? e : 8 * t - 7;
                  for (var C = t & -8, G = 0, J = 0; z < C; z += 8)
                    (J = n[r++]),
                      (p[h++] = J & 128 ? 4294967295 : v),
                      (p[h++] = J & 64 ? 4294967295 : v),
                      (p[h++] = J & 32 ? 4294967295 : v),
                      (p[h++] = J & 16 ? 4294967295 : v),
                      (p[h++] = J & 8 ? 4294967295 : v),
                      (p[h++] = J & 4 ? 4294967295 : v),
                      (p[h++] = J & 2 ? 4294967295 : v),
                      (p[h++] = J & 1 ? 4294967295 : v);
                  for (; z < t; z++) 0 === G && ((J = n[r++]), (G = 128)), (p[h++] = J & G ? 4294967295 : v), (G >>= 1);
                }
                for (; h < x; ) p[h++] = 0;
                a.putImageData(l, 0, 16 * q);
              }
            } else if (c.kind === b.ImageKind.RGBA_32BPP) {
              k = 0;
              B = 64 * e;
              for (q = 0; q < d; q++) p.set(n.subarray(r, r + B)), (r += B), a.putImageData(l, 0, k), (k += 16);
              q < g && (p.set(n.subarray(r, r + e * f * 4)), a.putImageData(l, 0, k));
            } else if (c.kind === b.ImageKind.RGB_24BPP)
              for (B = 16 * e, q = 0; q < g; q++) {
                q >= d && ((B = f), (B *= e));
                h = 0;
                for (k = B; k--; ) (p[h++] = n[r++]), (p[h++] = n[r++]), (p[h++] = n[r++]), (p[h++] = 255);
                a.putImageData(l, 0, 16 * q);
              }
            else throw Error('bad image kind: ' + c.kind);
          }
        }
        function e(a, b) {
          var c = b.height,
            d = b.width,
            e = c % 16;
          c = (c - e) / 16;
          for (
            var f = 0 === e ? c : c + 1, g = a.createImageData(d, 16), l = 0, r = b.data, h = g.data, n = 0;
            n < f;
            n++
          ) {
            for (var p = n < c ? 16 : e, q = 3, k = 0; k < p; k++)
              for (var m = 0, x = 0; x < d; x++) {
                if (!m) {
                  var u = r[l++];
                  m = 128;
                }
                h[q] = u & m ? 0 : 255;
                q += 4;
                m >>= 1;
              }
            a.putImageData(g, 0, 16 * n);
          }
        }
        function h(a, b) {
          for (
            var c = 'strokeStyle fillStyle fillRule globalAlpha lineWidth lineCap lineJoin miterLimit globalCompositeOperation font'.split(
                ' ',
              ),
              d = 0,
              e = c.length;
            d < e;
            d++
          ) {
            var f = c[d];
            void 0 !== a[f] && (b[f] = a[f]);
          }
          void 0 !== a.setLineDash && (b.setLineDash(a.getLineDash()), (b.lineDashOffset = a.lineDashOffset));
        }
        function p(a) {
          a.strokeStyle = '#000000';
          a.fillStyle = '#000000';
          a.fillRule = 'nonzero';
          a.globalAlpha = 1;
          a.lineWidth = 1;
          a.lineCap = 'butt';
          a.lineJoin = 'miter';
          a.miterLimit = 10;
          a.globalCompositeOperation = 'source-over';
          a.font = '10px sans-serif';
          void 0 !== a.setLineDash && (a.setLineDash([]), (a.lineDashOffset = 0));
        }
        function A(a, b, c) {
          for (var d = a.length, e = 1 / 255, f = 3; f < d; f += 4) b[f] = (b[f] * (c ? c[a[f]] : a[f]) * e) | 0;
        }
        function c(a, b, c) {
          for (var d = a.length, e = 3; e < d; e += 4) {
            var f = 77 * a[e - 3] + 152 * a[e - 2] + 28 * a[e - 1];
            b[e] = c ? (b[e] * c[f >> 8]) >> 8 : (b[e] * f) >> 16;
          }
        }
        function q(a, b, e) {
          var f = b.canvas,
            g = b.context;
          a.setTransform(b.scaleX, 0, 0, b.scaleY, b.offsetX, b.offsetY);
          var l = b.backdrop || null;
          if (!b.transferMap && d.WebGLUtils.isEnabled)
            (e = d.WebGLUtils.composeSMask(e.canvas, f, { subtype: b.subtype, backdrop: l })),
              a.setTransform(1, 0, 0, 1, 0, 0),
              a.drawImage(e, b.offsetX, b.offsetY);
          else {
            var h = f.width,
              r = f.height,
              n = b.transferMap,
              p = !!l,
              q = p ? l[0] : 0,
              k = p ? l[1] : 0;
            l = p ? l[2] : 0;
            b = 'Luminosity' === b.subtype ? c : A;
            for (var m = Math.min(r, Math.ceil(1048576 / h)), x = 0; x < r; x += m) {
              var u = Math.min(m, r - x),
                D = g.getImageData(0, x, h, u);
              u = e.getImageData(0, x, h, u);
              if (p)
                for (var v = D.data, B = q, t = k, z = l, C = v.length, G = 3; G < C; G += 4) {
                  var J = v[G];
                  if (0 === J) (v[G - 3] = B), (v[G - 2] = t), (v[G - 1] = z);
                  else if (255 > J) {
                    var y = 255 - J;
                    v[G - 3] = (v[G - 3] * J + B * y) >> 8;
                    v[G - 2] = (v[G - 2] * J + t * y) >> 8;
                    v[G - 1] = (v[G - 1] * J + z * y) >> 8;
                  }
                }
              b(D.data, u.data, n);
              g.putImageData(u, 0, x);
            }
            a.drawImage(f, 0, 0);
          }
        }
        var x = ['butt', 'round', 'square'],
          g = ['miter', 'round', 'bevel'],
          t = {},
          l = {};
        m.prototype = {
          beginDrawing: function(a) {
            var b = a.transform,
              c = a.viewport,
              d = a.transparency;
            a = a.background;
            a = void 0 === a ? null : a;
            var e = this.ctx.canvas.width,
              f = this.ctx.canvas.height;
            this.ctx.save();
            this.ctx.fillStyle = a || 'rgb(255, 255, 255)';
            this.ctx.fillRect(0, 0, e, f);
            this.ctx.restore();
            d &&
              ((d = this.cachedCanvases.getCanvas('transparent', e, f, !0)),
              (this.compositeCtx = this.ctx),
              (this.transparentCanvas = d.canvas),
              (this.ctx = d.context),
              this.ctx.save(),
              this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform));
            this.ctx.save();
            p(this.ctx);
            b && this.ctx.transform.apply(this.ctx, b);
            this.ctx.transform.apply(this.ctx, c.transform);
            this.baseTransform = this.ctx.mozCurrentTransform.slice();
            this.imageLayer && this.imageLayer.beginLayout();
          },
          executeOperatorList: function(a, c, d, e) {
            var f = a.argsArray;
            a = a.fnArray;
            c = c || 0;
            var g = f.length;
            if (g === c) return c;
            for (
              var l = 10 < g - c && 'function' === typeof d,
                h = l ? Date.now() + 15 : 0,
                r = 0,
                n = this.commonObjs,
                p = this.objs,
                q;
              ;

            ) {
              if (void 0 !== e && c === e.nextBreakPoint) return e.breakIt(c, d), c;
              q = a[c];
              if (q !== b.OPS.dependency) this[q].apply(this, f[c]);
              else {
                q = f[c];
                for (var k = 0, m = q.length; k < m; k++) {
                  var x = q[k],
                    u = 'g' === x[0] && '_' === x[1] ? n : p;
                  if (!u.isResolved(x)) return u.get(x, d), c;
                }
              }
              c++;
              if (c === g) return c;
              if (l && 10 < ++r) {
                if (Date.now() > h) return d(), c;
                r = 0;
              }
            }
          },
          endDrawing: function() {
            null !== this.current.activeSMask && this.endSMaskGroup();
            this.ctx.restore();
            this.transparentCanvas &&
              ((this.ctx = this.compositeCtx),
              this.ctx.save(),
              this.ctx.setTransform(1, 0, 0, 1, 0, 0),
              this.ctx.drawImage(this.transparentCanvas, 0, 0),
              this.ctx.restore(),
              (this.transparentCanvas = null));
            this.cachedCanvases.clear();
            d.WebGLUtils.clear();
            this.imageLayer && this.imageLayer.endLayout();
          },
          setLineWidth: function(a) {
            this.current.lineWidth = a;
            this.ctx.lineWidth = a;
          },
          setLineCap: function(a) {
            this.ctx.lineCap = x[a];
          },
          setLineJoin: function(a) {
            this.ctx.lineJoin = g[a];
          },
          setMiterLimit: function(a) {
            this.ctx.miterLimit = a;
          },
          setDash: function(a, b) {
            var c = this.ctx;
            void 0 !== c.setLineDash && (c.setLineDash(a), (c.lineDashOffset = b));
          },
          setRenderingIntent: function(a) {},
          setFlatness: function(a) {},
          setGState: function(a) {
            for (var b = 0, c = a.length; b < c; b++) {
              var d = a[b],
                e = d[1];
              switch (d[0]) {
                case 'LW':
                  this.setLineWidth(e);
                  break;
                case 'LC':
                  this.setLineCap(e);
                  break;
                case 'LJ':
                  this.setLineJoin(e);
                  break;
                case 'ML':
                  this.setMiterLimit(e);
                  break;
                case 'D':
                  this.setDash(e[0], e[1]);
                  break;
                case 'RI':
                  this.setRenderingIntent(e);
                  break;
                case 'FL':
                  this.setFlatness(e);
                  break;
                case 'Font':
                  this.setFont(e[0], e[1]);
                  break;
                case 'CA':
                  this.current.strokeAlpha = d[1];
                  break;
                case 'ca':
                  this.current.fillAlpha = d[1];
                  this.ctx.globalAlpha = d[1];
                  break;
                case 'BM':
                  this.ctx.globalCompositeOperation = e;
                  break;
                case 'SMask':
                  this.current.activeSMask &&
                    (0 < this.stateStack.length &&
                    this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask
                      ? this.suspendSMaskGroup()
                      : this.endSMaskGroup()),
                    (this.current.activeSMask = e ? this.tempSMask : null),
                    this.current.activeSMask && this.beginSMaskGroup(),
                    (this.tempSMask = null);
              }
            }
          },
          beginSMaskGroup: function() {
            var a = this.current.activeSMask,
              b = this.cachedCanvases.getCanvas('smaskGroupAt' + this.groupLevel, a.canvas.width, a.canvas.height, !0),
              c = this.ctx,
              d = c.mozCurrentTransform;
            this.ctx.save();
            b = b.context;
            b.scale(1 / a.scaleX, 1 / a.scaleY);
            b.translate(-a.offsetX, -a.offsetY);
            b.transform.apply(b, d);
            a.startTransformInverse = b.mozCurrentTransformInverse;
            h(c, b);
            this.ctx = b;
            this.setGState([
              ['BM', 'source-over'],
              ['ca', 1],
              ['CA', 1],
            ]);
            this.groupStack.push(c);
            this.groupLevel++;
          },
          suspendSMaskGroup: function() {
            var a = this.ctx;
            this.groupLevel--;
            this.ctx = this.groupStack.pop();
            q(this.ctx, this.current.activeSMask, a);
            this.ctx.restore();
            this.ctx.save();
            h(a, this.ctx);
            this.current.resumeSMaskCtx = a;
            var c = b.Util.transform(this.current.activeSMask.startTransformInverse, a.mozCurrentTransform);
            this.ctx.transform.apply(this.ctx, c);
            a.save();
            a.setTransform(1, 0, 0, 1, 0, 0);
            a.clearRect(0, 0, a.canvas.width, a.canvas.height);
            a.restore();
          },
          resumeSMaskGroup: function() {
            var a = this.ctx;
            this.ctx = this.current.resumeSMaskCtx;
            this.groupStack.push(a);
            this.groupLevel++;
          },
          endSMaskGroup: function() {
            var a = this.ctx;
            this.groupLevel--;
            this.ctx = this.groupStack.pop();
            q(this.ctx, this.current.activeSMask, a);
            this.ctx.restore();
            h(a, this.ctx);
            a = b.Util.transform(this.current.activeSMask.startTransformInverse, a.mozCurrentTransform);
            this.ctx.transform.apply(this.ctx, a);
          },
          save: function() {
            this.ctx.save();
            var a = this.current;
            this.stateStack.push(a);
            this.current = a.clone();
            this.current.resumeSMaskCtx = null;
          },
          restore: function() {
            this.current.resumeSMaskCtx && this.resumeSMaskGroup();
            null === this.current.activeSMask ||
              (0 !== this.stateStack.length &&
                this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) ||
              this.endSMaskGroup();
            0 !== this.stateStack.length &&
              ((this.current = this.stateStack.pop()),
              this.ctx.restore(),
              (this.cachedGetSinglePixelWidth = this.pendingClip = null));
          },
          transform: function(a, b, c, d, e, g) {
            this.ctx.transform(a, b, c, d, e, g);
            this.cachedGetSinglePixelWidth = null;
          },
          constructPath: function(a, c) {
            for (var d = this.ctx, e = this.current, f = e.x, g = e.y, l = 0, h = 0, n = a.length; l < n; l++)
              switch (a[l] | 0) {
                case b.OPS.rectangle:
                  f = c[h++];
                  g = c[h++];
                  var r = c[h++],
                    p = c[h++];
                  0 === r && (r = this.getSinglePixelWidth());
                  0 === p && (p = this.getSinglePixelWidth());
                  r = f + r;
                  p = g + p;
                  this.ctx.moveTo(f, g);
                  this.ctx.lineTo(r, g);
                  this.ctx.lineTo(r, p);
                  this.ctx.lineTo(f, p);
                  this.ctx.lineTo(f, g);
                  this.ctx.closePath();
                  break;
                case b.OPS.moveTo:
                  f = c[h++];
                  g = c[h++];
                  d.moveTo(f, g);
                  break;
                case b.OPS.lineTo:
                  f = c[h++];
                  g = c[h++];
                  d.lineTo(f, g);
                  break;
                case b.OPS.curveTo:
                  f = c[h + 4];
                  g = c[h + 5];
                  d.bezierCurveTo(c[h], c[h + 1], c[h + 2], c[h + 3], f, g);
                  h += 6;
                  break;
                case b.OPS.curveTo2:
                  d.bezierCurveTo(f, g, c[h], c[h + 1], c[h + 2], c[h + 3]);
                  f = c[h + 2];
                  g = c[h + 3];
                  h += 4;
                  break;
                case b.OPS.curveTo3:
                  f = c[h + 2];
                  g = c[h + 3];
                  d.bezierCurveTo(c[h], c[h + 1], f, g, f, g);
                  h += 4;
                  break;
                case b.OPS.closePath:
                  d.closePath();
              }
            e.setCurrentPoint(f, g);
          },
          closePath: function() {
            this.ctx.closePath();
          },
          stroke: function(a) {
            a = 'undefined' !== typeof a ? a : !0;
            var b = this.ctx,
              c = this.current.strokeColor;
            b.lineWidth = Math.max(0.65 * this.getSinglePixelWidth(), this.current.lineWidth);
            b.globalAlpha = this.current.strokeAlpha;
            c && c.hasOwnProperty('type') && 'Pattern' === c.type
              ? (b.save(), (b.strokeStyle = c.getPattern(b, this)), b.stroke(), b.restore())
              : b.stroke();
            a && this.consumePath();
            b.globalAlpha = this.current.fillAlpha;
          },
          closeStroke: function() {
            this.closePath();
            this.stroke();
          },
          fill: function(a) {
            a = 'undefined' !== typeof a ? a : !0;
            var b = this.ctx,
              c = this.current.fillColor,
              d = !1;
            this.current.patternFill &&
              (b.save(),
              this.baseTransform && b.setTransform.apply(b, this.baseTransform),
              (b.fillStyle = c.getPattern(b, this)),
              (d = !0));
            this.pendingEOFill ? (b.fill('evenodd'), (this.pendingEOFill = !1)) : b.fill();
            d && b.restore();
            a && this.consumePath();
          },
          eoFill: function() {
            this.pendingEOFill = !0;
            this.fill();
          },
          fillStroke: function() {
            this.fill(!1);
            this.stroke(!1);
            this.consumePath();
          },
          eoFillStroke: function() {
            this.pendingEOFill = !0;
            this.fillStroke();
          },
          closeFillStroke: function() {
            this.closePath();
            this.fillStroke();
          },
          closeEOFillStroke: function() {
            this.pendingEOFill = !0;
            this.closePath();
            this.fillStroke();
          },
          endPath: function() {
            this.consumePath();
          },
          clip: function() {
            this.pendingClip = t;
          },
          eoClip: function() {
            this.pendingClip = l;
          },
          beginText: function() {
            this.current.textMatrix = b.IDENTITY_MATRIX;
            this.current.textMatrixScale = 1;
            this.current.x = this.current.lineX = 0;
            this.current.y = this.current.lineY = 0;
          },
          endText: function() {
            var a = this.pendingTextPaths,
              b = this.ctx;
            if (void 0 === a) b.beginPath();
            else {
              b.save();
              b.beginPath();
              for (var c = 0; c < a.length; c++) {
                var d = a[c];
                b.setTransform.apply(b, d.transform);
                b.translate(d.x, d.y);
                d.addToPath(b, d.fontSize);
              }
              b.restore();
              b.clip();
              b.beginPath();
              delete this.pendingTextPaths;
            }
          },
          setCharSpacing: function(a) {
            this.current.charSpacing = a;
          },
          setWordSpacing: function(a) {
            this.current.wordSpacing = a;
          },
          setHScale: function(a) {
            this.current.textHScale = a / 100;
          },
          setLeading: function(a) {
            this.current.leading = -a;
          },
          setFont: function(a, c) {
            var d = this.commonObjs.get(a),
              e = this.current;
            if (!d) throw Error("Can't find font for " + a);
            e.fontMatrix = d.fontMatrix ? d.fontMatrix : b.FONT_IDENTITY_MATRIX;
            (0 !== e.fontMatrix[0] && 0 !== e.fontMatrix[3]) || (0, b.warn)('Invalid font matrix for font ' + a);
            0 > c ? ((c = -c), (e.fontDirection = -1)) : (e.fontDirection = 1);
            this.current.font = d;
            this.current.fontSize = c;
            if (!d.isType3Font) {
              e = d.black ? '900' : d.bold ? 'bold' : 'normal';
              var f = d.italic ? 'italic' : 'normal';
              d = '"' + (d.loadedName || 'sans-serif') + '", ' + d.fallbackName;
              var g = 16 > c ? 16 : 100 < c ? 100 : c;
              this.current.fontSizeScale = c / g;
              this.ctx.font = f + ' ' + e + ' ' + g + 'px ' + d;
            }
          },
          setTextRenderingMode: function(a) {
            this.current.textRenderingMode = a;
          },
          setTextRise: function(a) {
            this.current.textRise = a;
          },
          moveText: function(a, b) {
            this.current.x = this.current.lineX += a;
            this.current.y = this.current.lineY += b;
          },
          setLeadingMoveText: function(a, b) {
            this.setLeading(-b);
            this.moveText(a, b);
          },
          setTextMatrix: function(a, b, c, d, e, g) {
            this.current.textMatrix = [a, b, c, d, e, g];
            this.current.textMatrixScale = Math.sqrt(a * a + b * b);
            this.current.x = this.current.lineX = 0;
            this.current.y = this.current.lineY = 0;
          },
          nextLine: function() {
            this.moveText(0, this.current.leading);
          },
          paintChar: function(a, c, d) {
            var e = this.ctx,
              f = this.current,
              g = f.font,
              l = f.textRenderingMode;
            f = f.fontSize / f.fontSizeScale;
            var h = l & b.TextRenderingMode.FILL_STROKE_MASK;
            l = !!(l & b.TextRenderingMode.ADD_TO_PATH_FLAG);
            if (g.disableFontFace || l) var n = g.getPathGenerator(this.commonObjs, a);
            g.disableFontFace
              ? (e.save(),
                e.translate(c, d),
                e.beginPath(),
                n(e, f),
                (h !== b.TextRenderingMode.FILL && h !== b.TextRenderingMode.FILL_STROKE) || e.fill(),
                (h !== b.TextRenderingMode.STROKE && h !== b.TextRenderingMode.FILL_STROKE) || e.stroke(),
                e.restore())
              : ((h !== b.TextRenderingMode.FILL && h !== b.TextRenderingMode.FILL_STROKE) || e.fillText(a, c, d),
                (h !== b.TextRenderingMode.STROKE && h !== b.TextRenderingMode.FILL_STROKE) || e.strokeText(a, c, d));
            l &&
              (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
                transform: e.mozCurrentTransform,
                x: c,
                y: d,
                fontSize: f,
                addToPath: n,
              });
          },
          get isFontSubpixelAAEnabled() {
            var a = this.canvasFactory.create(10, 10).context;
            a.scale(1.5, 1);
            a.fillText('I', 0, 10);
            a = a.getImageData(0, 0, 10, 10).data;
            for (var c = !1, d = 3; d < a.length; d += 4)
              if (0 < a[d] && 255 > a[d]) {
                c = !0;
                break;
              }
            return (0, b.shadow)(this, 'isFontSubpixelAAEnabled', c);
          },
          showText: function(a) {
            var c = this.current,
              d = c.font;
            if (d.isType3Font) return this.showType3Text(a);
            var e = c.fontSize;
            if (0 !== e) {
              var f = this.ctx,
                g = c.fontSizeScale,
                l = c.charSpacing,
                h = c.wordSpacing,
                n = c.fontDirection,
                p = c.textHScale * n,
                q = a.length,
                k = d.vertical,
                m = k ? 1 : -1,
                x = d.defaultVMetrics,
                u = e * c.fontMatrix[0],
                A = c.textRenderingMode === b.TextRenderingMode.FILL && !d.disableFontFace;
              f.save();
              f.transform.apply(f, c.textMatrix);
              f.translate(c.x, c.y + c.textRise);
              c.patternFill && (f.fillStyle = c.fillColor.getPattern(f, this));
              0 < n ? f.scale(p, -1) : f.scale(p, 1);
              var v = c.lineWidth,
                B = c.textMatrixScale;
              if (0 === B || 0 === v) {
                if (
                  ((B = c.textRenderingMode & b.TextRenderingMode.FILL_STROKE_MASK),
                  B === b.TextRenderingMode.STROKE || B === b.TextRenderingMode.FILL_STROKE)
                )
                  (this.cachedGetSinglePixelWidth = null), (v = 0.65 * this.getSinglePixelWidth());
              } else v /= B;
              1 !== g && (f.scale(g, g), (v /= g));
              f.lineWidth = v;
              for (B = v = 0; B < q; ++B) {
                var t = a[B];
                if ((0, b.isNum)(t)) v += (m * t * e) / 1e3;
                else {
                  var z = !1,
                    C = (t.isSpace ? h : 0) + l,
                    G = t.fontChar,
                    J = t.accent,
                    y = t.width;
                  if (k) {
                    var U = t.vmetric || x;
                    var V = t.vmetric ? U[1] : 0.5 * y;
                    V = -V * u;
                    var P = U[2] * u;
                    y = U ? -U[0] : y;
                    U = V / g;
                    P = (v + P) / g;
                  } else (U = v / g), (P = 0);
                  d.remeasure &&
                    0 < y &&
                    ((V = ((1e3 * f.measureText(G).width) / e) * g),
                    y < V && this.isFontSubpixelAAEnabled
                      ? ((V = y / V), (z = !0), f.save(), f.scale(V, 1), (U /= V))
                      : y !== V && (U += (((y - V) / 2e3) * e) / g));
                  if (t.isInFont || d.missingFile)
                    A && !J
                      ? f.fillText(G, U, P)
                      : (this.paintChar(G, U, P),
                        J && ((t = U + J.offset.x / g), (G = P - J.offset.y / g), this.paintChar(J.fontChar, t, G)));
                  v += y * u + C * n;
                  z && f.restore();
                }
              }
              k ? (c.y -= v * p) : (c.x += v * p);
              f.restore();
            }
          },
          showType3Text: function(a) {
            var c = this.ctx,
              d = this.current,
              e = d.font,
              f = d.fontSize,
              g = d.fontDirection,
              l = e.vertical ? 1 : -1,
              h = d.charSpacing,
              n = d.wordSpacing,
              p = d.textHScale * g,
              q = d.fontMatrix || b.FONT_IDENTITY_MATRIX,
              k = a.length;
            if (d.textRenderingMode !== b.TextRenderingMode.INVISIBLE && 0 !== f) {
              this.cachedGetSinglePixelWidth = null;
              c.save();
              c.transform.apply(c, d.textMatrix);
              c.translate(d.x, d.y);
              c.scale(p, g);
              for (g = 0; g < k; ++g) {
                var m = a[g];
                if ((0, b.isNum)(m)) (m = (l * m * f) / 1e3), this.ctx.translate(m, 0), (d.x += m * p);
                else {
                  var x = (m.isSpace ? n : 0) + h,
                    u = e.charProcOperatorList[m.operatorListId];
                  u
                    ? ((this.processingType3 = m),
                      this.save(),
                      c.scale(f, f),
                      c.transform.apply(c, q),
                      this.executeOperatorList(u),
                      this.restore(),
                      (m = b.Util.applyTransform([m.width, 0], q)[0] * f + x),
                      c.translate(m, 0),
                      (d.x += m * p))
                    : (0, b.warn)('Type3 character "' + m.operatorListId + '" is not available.');
                }
              }
              c.restore();
              this.processingType3 = null;
            }
          },
          setCharWidth: function(a, b) {},
          setCharWidthAndBounds: function(a, b, c, d, e, g) {
            this.ctx.rect(c, d, e - c, g - d);
            this.clip();
            this.endPath();
          },
          getColorN_Pattern: function(a) {
            var b = this;
            if ('TilingPattern' === a[0]) {
              var c = a[1],
                d = this.baseTransform || this.ctx.mozCurrentTransform.slice();
              a = new v.TilingPattern(
                a,
                c,
                this.ctx,
                {
                  createCanvasGraphics: function(a) {
                    return new m(a, b.commonObjs, b.objs, b.canvasFactory);
                  },
                },
                d,
              );
            } else a = (0, v.getShadingPatternFromIR)(a);
            return a;
          },
          setStrokeColorN: function() {
            this.current.strokeColor = this.getColorN_Pattern(arguments);
          },
          setFillColorN: function() {
            this.current.fillColor = this.getColorN_Pattern(arguments);
            this.current.patternFill = !0;
          },
          setStrokeRGBColor: function(a, c, d) {
            a = b.Util.makeCssRgb(a, c, d);
            this.ctx.strokeStyle = a;
            this.current.strokeColor = a;
          },
          setFillRGBColor: function(a, c, d) {
            a = b.Util.makeCssRgb(a, c, d);
            this.ctx.fillStyle = a;
            this.current.fillColor = a;
            this.current.patternFill = !1;
          },
          shadingFill: function(a) {
            var c = this.ctx;
            this.save();
            a = (0, v.getShadingPatternFromIR)(a);
            c.fillStyle = a.getPattern(c, this, !0);
            var d = c.mozCurrentTransformInverse;
            if (d) {
              c = c.canvas;
              var e = c.width,
                f = c.height;
              c = b.Util.applyTransform([0, 0], d);
              a = b.Util.applyTransform([0, f], d);
              var g = b.Util.applyTransform([e, 0], d);
              d = b.Util.applyTransform([e, f], d);
              e = Math.min(c[0], a[0], g[0], d[0]);
              f = Math.min(c[1], a[1], g[1], d[1]);
              this.ctx.fillRect(e, f, Math.max(c[0], a[0], g[0], d[0]) - e, Math.max(c[1], a[1], g[1], d[1]) - f);
            } else this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
            this.restore();
          },
          beginInlineImage: function() {
            throw Error('Should not call beginInlineImage');
          },
          beginImageData: function() {
            throw Error('Should not call beginImageData');
          },
          paintFormXObjectBegin: function(a, b) {
            this.save();
            this.baseTransformStack.push(this.baseTransform);
            Array.isArray(a) && 6 === a.length && this.transform.apply(this, a);
            this.baseTransform = this.ctx.mozCurrentTransform;
            Array.isArray(b) &&
              4 === b.length &&
              (this.ctx.rect(b[0], b[1], b[2] - b[0], b[3] - b[1]), this.clip(), this.endPath());
          },
          paintFormXObjectEnd: function() {
            this.restore();
            this.baseTransform = this.baseTransformStack.pop();
          },
          beginGroup: function(a) {
            this.save();
            var c = this.ctx;
            a.isolated || (0, b.info)('TODO: Support non-isolated groups.');
            a.knockout && (0, b.warn)('Knockout groups not supported.');
            var d = c.mozCurrentTransform;
            a.matrix && c.transform.apply(c, a.matrix);
            if (!a.bbox) throw Error('Bounding box is required.');
            var e = b.Util.getAxialAlignedBoundingBox(a.bbox, c.mozCurrentTransform);
            e = b.Util.intersect(e, [0, 0, c.canvas.width, c.canvas.height]) || [0, 0, 0, 0];
            var f = Math.floor(e[0]),
              g = Math.floor(e[1]),
              l = Math.max(Math.ceil(e[2]) - f, 1),
              n = Math.max(Math.ceil(e[3]) - g, 1),
              p = (e = 1);
            4096 < l && ((e = l / 4096), (l = 4096));
            4096 < n && ((p = n / 4096), (n = 4096));
            var q = 'groupAt' + this.groupLevel;
            a.smask && (q += '_smask_' + (this.smaskCounter++ % 2));
            l = this.cachedCanvases.getCanvas(q, l, n, !0);
            n = l.context;
            n.scale(1 / e, 1 / p);
            n.translate(-f, -g);
            n.transform.apply(n, d);
            a.smask
              ? this.smaskStack.push({
                  canvas: l.canvas,
                  context: n,
                  offsetX: f,
                  offsetY: g,
                  scaleX: e,
                  scaleY: p,
                  subtype: a.smask.subtype,
                  backdrop: a.smask.backdrop,
                  transferMap: a.smask.transferMap || null,
                  startTransformInverse: null,
                })
              : (c.setTransform(1, 0, 0, 1, 0, 0), c.translate(f, g), c.scale(e, p));
            h(c, n);
            this.ctx = n;
            this.setGState([
              ['BM', 'source-over'],
              ['ca', 1],
              ['CA', 1],
            ]);
            this.groupStack.push(c);
            this.groupLevel++;
            this.current.activeSMask = null;
          },
          endGroup: function(a) {
            this.groupLevel--;
            var b = this.ctx;
            this.ctx = this.groupStack.pop();
            void 0 !== this.ctx.imageSmoothingEnabled
              ? (this.ctx.imageSmoothingEnabled = !1)
              : (this.ctx.mozImageSmoothingEnabled = !1);
            a.smask ? (this.tempSMask = this.smaskStack.pop()) : this.ctx.drawImage(b.canvas, 0, 0);
            this.restore();
          },
          beginAnnotations: function() {
            this.save();
            this.baseTransform && this.ctx.setTransform.apply(this.ctx, this.baseTransform);
          },
          endAnnotations: function() {
            this.restore();
          },
          beginAnnotation: function(a, b, c) {
            this.save();
            p(this.ctx);
            this.current = new C();
            Array.isArray(a) &&
              4 === a.length &&
              (this.ctx.rect(a[0], a[1], a[2] - a[0], a[3] - a[1]), this.clip(), this.endPath());
            this.transform.apply(this, b);
            this.transform.apply(this, c);
          },
          endAnnotation: function() {
            this.restore();
          },
          paintJpegXObject: function(a, c, d) {
            var e = this.objs.get(a);
            if (e) {
              this.save();
              var f = this.ctx;
              f.scale(1 / c, -1 / d);
              f.drawImage(e, 0, 0, e.width, e.height, 0, -d, c, d);
              this.imageLayer &&
                ((e = f.mozCurrentTransformInverse),
                (f = this.getCanvasPosition(0, 0)),
                this.imageLayer.appendImage({ objId: a, left: f[0], top: f[1], width: c / e[0], height: d / e[3] }));
              this.restore();
            } else (0, b.warn)("Dependent image isn't ready yet");
          },
          paintImageMaskXObject: function(a) {
            var b = this.ctx,
              c = a.width,
              d = a.height,
              f = this.current.fillColor,
              g = this.current.patternFill,
              l = this.processingType3;
            l &&
              void 0 === l.compiled &&
              (l.compiled = 1e3 >= c && 1e3 >= d ? k({ data: a.data, width: c, height: d }) : null);
            l && l.compiled
              ? l.compiled(b)
              : ((b = this.cachedCanvases.getCanvas('maskCanvas', c, d)),
                (l = b.context),
                l.save(),
                e(l, a),
                (l.globalCompositeOperation = 'source-in'),
                (l.fillStyle = g ? f.getPattern(l, this) : f),
                l.fillRect(0, 0, c, d),
                l.restore(),
                this.paintInlineImageXObject(b.canvas));
          },
          paintImageMaskXObjectRepeat: function(a, b, c, d) {
            var f = a.width,
              g = a.height,
              l = this.current.fillColor,
              h = this.current.patternFill,
              n = this.cachedCanvases.getCanvas('maskCanvas', f, g),
              p = n.context;
            p.save();
            e(p, a);
            p.globalCompositeOperation = 'source-in';
            p.fillStyle = h ? l.getPattern(p, this) : l;
            p.fillRect(0, 0, f, g);
            p.restore();
            a = this.ctx;
            l = 0;
            for (h = d.length; l < h; l += 2)
              a.save(),
                a.transform(b, 0, 0, c, d[l], d[l + 1]),
                a.scale(1, -1),
                a.drawImage(n.canvas, 0, 0, f, g, 0, -1, 1, 1),
                a.restore();
          },
          paintImageMaskXObjectGroup: function(a) {
            for (
              var b = this.ctx, c = this.current.fillColor, d = this.current.patternFill, f = 0, g = a.length;
              f < g;
              f++
            ) {
              var l = a[f],
                h = l.width,
                n = l.height,
                p = this.cachedCanvases.getCanvas('maskCanvas', h, n),
                q = p.context;
              q.save();
              e(q, l);
              q.globalCompositeOperation = 'source-in';
              q.fillStyle = d ? c.getPattern(q, this) : c;
              q.fillRect(0, 0, h, n);
              q.restore();
              b.save();
              b.transform.apply(b, l.transform);
              b.scale(1, -1);
              b.drawImage(p.canvas, 0, 0, h, n, 0, -1, 1, 1);
              b.restore();
            }
          },
          paintImageXObject: function(a) {
            (a = this.objs.get(a)) ? this.paintInlineImageXObject(a) : (0, b.warn)("Dependent image isn't ready yet");
          },
          paintImageXObjectRepeat: function(a, c, d, e) {
            if ((a = this.objs.get(a))) {
              for (var f = a.width, g = a.height, l = [], h = 0, n = e.length; h < n; h += 2)
                l.push({ transform: [c, 0, 0, d, e[h], e[h + 1]], x: 0, y: 0, w: f, h: g });
              this.paintInlineImageXObjectGroup(a, l);
            } else (0, b.warn)("Dependent image isn't ready yet");
          },
          paintInlineImageXObject: function(a) {
            var b = a.width,
              c = a.height,
              d = this.ctx;
            this.save();
            d.scale(1 / b, -1 / c);
            var e = d.mozCurrentTransformInverse,
              f = e[0],
              g = e[1];
            f = Math.max(Math.sqrt(f * f + g * g), 1);
            g = e[2];
            var l = e[3];
            g = Math.max(Math.sqrt(g * g + l * l), 1);
            if (a instanceof HTMLElement || !a.data) l = a;
            else {
              var h = this.cachedCanvases.getCanvas('inlineImage', b, c);
              var p = h.context;
              n(p, a);
              l = h.canvas;
            }
            for (var q = b, k = c, m = 'prescale1'; (2 < f && 1 < q) || (2 < g && 1 < k); ) {
              var x = q,
                u = k;
              2 < f && 1 < q && ((x = Math.ceil(q / 2)), (f /= q / x));
              2 < g && 1 < k && ((u = Math.ceil(k / 2)), (g /= k / u));
              h = this.cachedCanvases.getCanvas(m, x, u);
              p = h.context;
              p.clearRect(0, 0, x, u);
              p.drawImage(l, 0, 0, q, k, 0, 0, x, u);
              l = h.canvas;
              q = x;
              k = u;
              m = 'prescale1' === m ? 'prescale2' : 'prescale1';
            }
            d.drawImage(l, 0, 0, q, k, 0, -c, b, c);
            this.imageLayer &&
              ((d = this.getCanvasPosition(0, -c)),
              this.imageLayer.appendImage({ imgData: a, left: d[0], top: d[1], width: b / e[0], height: c / e[3] }));
            this.restore();
          },
          paintInlineImageXObjectGroup: function(a, b) {
            var c = this.ctx,
              d = a.width,
              e = a.height,
              f = this.cachedCanvases.getCanvas('inlineImage', d, e);
            n(f.context, a);
            for (var g = 0, l = b.length; g < l; g++) {
              var h = b[g];
              c.save();
              c.transform.apply(c, h.transform);
              c.scale(1, -1);
              c.drawImage(f.canvas, h.x, h.y, h.w, h.h, 0, -1, 1, 1);
              this.imageLayer &&
                ((h = this.getCanvasPosition(h.x, h.y)),
                this.imageLayer.appendImage({ imgData: a, left: h[0], top: h[1], width: d, height: e }));
              c.restore();
            }
          },
          paintSolidColorImageMask: function() {
            this.ctx.fillRect(0, 0, 1, 1);
          },
          paintXObject: function() {
            (0, b.warn)("Unsupported 'paintXObject' command.");
          },
          markPoint: function(a) {},
          markPointProps: function(a, b) {},
          beginMarkedContent: function(a) {},
          beginMarkedContentProps: function(a, b) {},
          endMarkedContent: function() {},
          beginCompat: function() {},
          endCompat: function() {},
          consumePath: function() {
            var a = this.ctx;
            this.pendingClip && (this.pendingClip === l ? a.clip('evenodd') : a.clip(), (this.pendingClip = null));
            a.beginPath();
          },
          getSinglePixelWidth: function(a) {
            null === this.cachedGetSinglePixelWidth &&
              (this.ctx.save(),
              (a = this.ctx.mozCurrentTransformInverse),
              this.ctx.restore(),
              (this.cachedGetSinglePixelWidth = Math.sqrt(
                Math.max(a[0] * a[0] + a[1] * a[1], a[2] * a[2] + a[3] * a[3]),
              )));
            return this.cachedGetSinglePixelWidth;
          },
          getCanvasPosition: function(a, b) {
            var c = this.ctx.mozCurrentTransform;
            return [c[0] * a + c[2] * b + c[4], c[1] * a + c[3] * b + c[5]];
          },
        };
        for (var J in b.OPS) m.prototype[b.OPS[J]] = m.prototype[J];
        return m;
      })();
      m.CanvasGraphics = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.TilingPattern = m.getShadingPatternFromIR = void 0;
      var a = t(0),
        k = t(56),
        b = {
          RadialAxial: {
            fromIR: function(a) {
              var b = a[1],
                d = a[2],
                k = a[3],
                m = a[4],
                n = a[5],
                e = a[6];
              return {
                type: 'Pattern',
                getPattern: function(a) {
                  var h;
                  'axial' === b
                    ? (h = a.createLinearGradient(k[0], k[1], m[0], m[1]))
                    : 'radial' === b && (h = a.createRadialGradient(k[0], k[1], n, m[0], m[1], e));
                  a = 0;
                  for (var u = d.length; a < u; ++a) {
                    var c = d[a];
                    h.addColorStop(c[0], c[1]);
                  }
                  return h;
                },
              };
            },
          },
        },
        v = (function() {
          function a(a, b, d, k, n, e, h, p) {
            var m = b.coords,
              c = b.colors,
              q = a.data;
            a = 4 * a.width;
            if (m[d + 1] > m[k + 1]) {
              var x = d;
              d = k;
              k = x;
              x = e;
              e = h;
              h = x;
            }
            m[k + 1] > m[n + 1] && ((x = k), (k = n), (n = x), (x = h), (h = p), (p = x));
            m[d + 1] > m[k + 1] && ((x = d), (d = k), (k = x), (x = e), (e = h), (h = x));
            x = (m[d] + b.offsetX) * b.scaleX;
            d = (m[d + 1] + b.offsetY) * b.scaleY;
            var g = (m[k] + b.offsetX) * b.scaleX;
            k = (m[k + 1] + b.offsetY) * b.scaleY;
            var u = (m[n] + b.offsetX) * b.scaleX;
            b = (m[n + 1] + b.offsetY) * b.scaleY;
            if (!(d >= b)) {
              n = c[e];
              m = c[e + 1];
              e = c[e + 2];
              var l = c[h],
                v = c[h + 1];
              h = c[h + 2];
              var f = c[p],
                r = c[p + 1];
              p = c[p + 2];
              c = Math.round(b);
              for (var B, t, z, w, E, F, C, H, y, O = Math.round(d); O <= c; O++) {
                O < k
                  ? ((y = O < d ? 0 : d === k ? 1 : (d - O) / (d - k)),
                    (B = x - (x - g) * y),
                    (t = n - (n - l) * y),
                    (z = m - (m - v) * y),
                    (w = e - (e - h) * y))
                  : ((y = O > b ? 1 : k === b ? 0 : (k - O) / (k - b)),
                    (B = g - (g - u) * y),
                    (t = l - (l - f) * y),
                    (z = v - (v - r) * y),
                    (w = h - (h - p) * y));
                y = O < d ? 0 : O > b ? 1 : (d - O) / (d - b);
                E = x - (x - u) * y;
                F = n - (n - f) * y;
                C = m - (m - r) * y;
                H = e - (e - p) * y;
                y = Math.round(Math.min(B, E));
                for (var N = Math.round(Math.max(B, E)), da = a * O + 4 * y, W = y; W <= N; W++)
                  (y = (B - W) / (B - E)),
                    (y = 0 > y ? 0 : 1 < y ? 1 : y),
                    (q[da++] = (t - (t - F) * y) | 0),
                    (q[da++] = (z - (z - C) * y) | 0),
                    (q[da++] = (w - (w - H) * y) | 0),
                    (q[da++] = 255);
              }
            }
          }
          return function(b, d, m, v, n, e, h) {
            var p = Math.floor(b[0]),
              u = Math.floor(b[1]),
              c = Math.ceil(b[2]) - p;
            b = Math.ceil(b[3]) - u;
            var q = Math.min(Math.ceil(Math.abs(c * d[0] * 1.1)), 3e3);
            d = Math.min(Math.ceil(Math.abs(b * d[1] * 1.1)), 3e3);
            c /= q;
            b /= d;
            m = { coords: m, colors: v, offsetX: -p, offsetY: -u, scaleX: 1 / c, scaleY: 1 / b };
            v = q + 4;
            var x = d + 4;
            if (k.WebGLUtils.isEnabled)
              (n = k.WebGLUtils.drawFigures(q, d, e, n, m)),
                (h = h.getCanvas('mesh', v, x, !1)),
                h.context.drawImage(n, 2, 2);
            else {
              h = h.getCanvas('mesh', v, x, !1);
              v = h.context;
              d = v.createImageData(q, d);
              if (e) {
                var g = d.data;
                q = 0;
                for (x = g.length; q < x; q += 4) (g[q] = e[0]), (g[q + 1] = e[1]), (g[q + 2] = e[2]), (g[q + 3] = 255);
              }
              for (q = 0; q < n.length; q++) {
                e = d;
                var B = n[q];
                x = m;
                g = B.coords;
                var l = B.colors;
                switch (B.type) {
                  case 'lattice':
                    var t = B.verticesPerRow;
                    var f = Math.floor(g.length / t) - 1,
                      r = t - 1;
                    for (B = 0; B < f; B++)
                      for (var D = B * t, z = 0; z < r; z++, D++)
                        a(e, x, g[D], g[D + 1], g[D + t], l[D], l[D + 1], l[D + t]),
                          a(e, x, g[D + t + 1], g[D + 1], g[D + t], l[D + t + 1], l[D + 1], l[D + t]);
                    break;
                  case 'triangles':
                    B = 0;
                    for (t = g.length; B < t; B += 3) a(e, x, g[B], g[B + 1], g[B + 2], l[B], l[B + 1], l[B + 2]);
                    break;
                  default:
                    throw Error('illegal figure');
                }
              }
              v.putImageData(d, 2, 2);
            }
            n = h.canvas;
            return { canvas: n, offsetX: p - 2 * c, offsetY: u - 2 * b, scaleX: c, scaleY: b };
          };
        })();
      b.Mesh = {
        fromIR: function(b) {
          var d = b[2],
            k = b[3],
            m = b[4],
            B = b[5],
            n = b[6],
            e = b[8];
          return {
            type: 'Pattern',
            getPattern: function(b, p, u) {
              if (u) var c = a.Util.singularValueDecompose2dScale(b.mozCurrentTransform);
              else if (((c = a.Util.singularValueDecompose2dScale(p.baseTransform)), n)) {
                var h = a.Util.singularValueDecompose2dScale(n);
                c = [c[0] * h[0], c[1] * h[1]];
              }
              c = v(B, c, d, k, m, u ? null : e, p.cachedCanvases);
              u || (b.setTransform.apply(b, p.baseTransform), n && b.transform.apply(b, n));
              b.translate(c.offsetX, c.offsetY);
              b.scale(c.scaleX, c.scaleY);
              return b.createPattern(c.canvas, 'no-repeat');
            },
          };
        },
      };
      b.Dummy = {
        fromIR: function() {
          return {
            type: 'Pattern',
            getPattern: function() {
              return 'hotpink';
            },
          };
        },
      };
      y = (function() {
        function b(a, b, d, k, n) {
          this.operatorList = a[2];
          this.matrix = a[3] || [1, 0, 0, 1, 0, 0];
          this.bbox = a[4];
          this.xstep = a[5];
          this.ystep = a[6];
          this.paintType = a[7];
          this.tilingType = a[8];
          this.color = b;
          this.canvasGraphicsFactory = k;
          this.baseTransform = n;
          this.type = 'Pattern';
          this.ctx = d;
        }
        b.prototype = {
          createPatternCanvas: function(b) {
            var d = this.operatorList,
              k = this.bbox,
              m = this.xstep,
              n = this.ystep,
              e = this.paintType,
              h = this.tilingType,
              p = this.color,
              u = this.canvasGraphicsFactory;
            (0, a.info)('TilingType: ' + h);
            h = k[0];
            var c = k[1],
              q = k[2],
              x = k[3],
              g = [h, c],
              v = [h + m, c + n],
              l = v[0] - g[0];
            v = v[1] - g[1];
            var t = a.Util.singularValueDecompose2dScale(this.matrix),
              f = a.Util.singularValueDecompose2dScale(this.baseTransform);
            t = [t[0] * f[0], t[1] * f[1]];
            l = Math.min(Math.ceil(Math.abs(l * t[0])), 3e3);
            v = Math.min(Math.ceil(Math.abs(v * t[1])), 3e3);
            t = b.cachedCanvases.getCanvas('pattern', l, v, !0);
            u = u.createCanvasGraphics(t.context);
            u.groupLevel = b.groupLevel;
            this.setFillAndStrokeStyleToContext(u, e, p);
            this.setScale(l, v, m, n);
            this.transformToScale(u);
            u.transform.apply(u, [1, 0, 0, 1, -g[0], -g[1]]);
            this.clipBbox(u, k, h, c, q, x);
            u.executeOperatorList(d);
            return t.canvas;
          },
          setScale: function(a, b, d, k) {
            this.scale = [a / d, b / k];
          },
          transformToScale: function(a) {
            var b = this.scale;
            a.transform.apply(a, [b[0], 0, 0, b[1], 0, 0]);
          },
          scaleToContext: function() {
            var a = this.scale;
            this.ctx.scale(1 / a[0], 1 / a[1]);
          },
          clipBbox: function(a, b, d, k, n, e) {
            Array.isArray(b) && 4 === b.length && (a.ctx.rect(d, k, n - d, e - k), a.clip(), a.endPath());
          },
          setFillAndStrokeStyleToContext: function(b, d, k) {
            var m = b.ctx;
            b = b.current;
            switch (d) {
              case 1:
                d = this.ctx;
                m.fillStyle = d.fillStyle;
                m.strokeStyle = d.strokeStyle;
                b.fillColor = d.fillStyle;
                b.strokeColor = d.strokeStyle;
                break;
              case 2:
                d = a.Util.makeCssRgb(k[0], k[1], k[2]);
                m.fillStyle = d;
                m.strokeStyle = d;
                b.fillColor = d;
                b.strokeColor = d;
                break;
              default:
                throw new a.FormatError('Unsupported paint type: ' + d);
            }
          },
          getPattern: function(a, b) {
            var d = this.createPatternCanvas(b);
            a = this.ctx;
            a.setTransform.apply(a, this.baseTransform);
            a.transform.apply(a, this.matrix);
            this.scaleToContext();
            return a.createPattern(d, 'repeat');
          },
        };
        return b;
      })();
      m.getShadingPatternFromIR = function(a) {
        var d = b[a[0]];
        if (!d) throw Error('Unknown IR type: ' + a[0]);
        return d.fromIR(a);
      };
      m.TilingPattern = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.PDFDataTransportStream = void 0;
      var a = t(0);
      y = (function() {
        function k(b, k) {
          var d = this;
          (0, a.assert)(k);
          this._queuedChunks = [];
          var m = b.initialData;
          m && 0 < m.length && ((m = new Uint8Array(m).buffer), this._queuedChunks.push(m));
          this._pdfDataRangeTransport = k;
          this._isRangeSupported = !b.disableRange;
          this._isStreamingSupported = !b.disableStream;
          this._contentLength = b.length;
          this._fullRequestReader = null;
          this._rangeReaders = [];
          this._pdfDataRangeTransport.addRangeListener(function(a, b) {
            d._onReceiveData({ begin: a, chunk: b });
          });
          this._pdfDataRangeTransport.addProgressListener(function(a) {
            d._onProgress({ loaded: a });
          });
          this._pdfDataRangeTransport.addProgressiveReadListener(function(a) {
            d._onReceiveData({ chunk: a });
          });
          this._pdfDataRangeTransport.transportReady();
        }
        function b(a, b) {
          this._stream = a;
          this._done = !1;
          this._queuedChunks = b || [];
          this._requests = [];
          this._headersReady = Promise.resolve();
          a._fullRequestReader = this;
          this.onProgress = null;
        }
        function m(a, b, k) {
          this._stream = a;
          this._begin = b;
          this._end = k;
          this._queuedChunk = null;
          this._requests = [];
          this._done = !1;
          this.onProgress = null;
        }
        k.prototype = {
          _onReceiveData: function(b) {
            var d = new Uint8Array(b.chunk).buffer;
            if (void 0 === b.begin)
              this._fullRequestReader ? this._fullRequestReader._enqueue(d) : this._queuedChunks.push(d);
            else {
              var k = this._rangeReaders.some(function(a) {
                if (a._begin !== b.begin) return !1;
                a._enqueue(d);
                return !0;
              });
              (0, a.assert)(k);
            }
          },
          _onProgress: function(a) {
            if (0 < this._rangeReaders.length) {
              var b = this._rangeReaders[0];
              if (b.onProgress) b.onProgress({ loaded: a.loaded });
            }
          },
          _removeRangeReader: function(a) {
            a = this._rangeReaders.indexOf(a);
            0 <= a && this._rangeReaders.splice(a, 1);
          },
          getFullReader: function() {
            (0, a.assert)(!this._fullRequestReader);
            var d = this._queuedChunks;
            this._queuedChunks = null;
            return new b(this, d);
          },
          getRangeReader: function(a, b) {
            var d = new m(this, a, b);
            this._pdfDataRangeTransport.requestDataRange(a, b);
            this._rangeReaders.push(d);
            return d;
          },
          cancelAllRequests: function(a) {
            this._fullRequestReader && this._fullRequestReader.cancel(a);
            this._rangeReaders.slice(0).forEach(function(b) {
              b.cancel(a);
            });
            this._pdfDataRangeTransport.abort();
          },
        };
        b.prototype = {
          _enqueue: function(a) {
            this._done ||
              (0 < this._requests.length
                ? this._requests.shift().resolve({ value: a, done: !1 })
                : this._queuedChunks.push(a));
          },
          get headersReady() {
            return this._headersReady;
          },
          get isRangeSupported() {
            return this._stream._isRangeSupported;
          },
          get isStreamingSupported() {
            return this._stream._isStreamingSupported;
          },
          get contentLength() {
            return this._stream._contentLength;
          },
          read: function() {
            if (0 < this._queuedChunks.length) {
              var b = this._queuedChunks.shift();
              return Promise.resolve({ value: b, done: !1 });
            }
            if (this._done) return Promise.resolve({ value: void 0, done: !0 });
            b = (0, a.createPromiseCapability)();
            this._requests.push(b);
            return b.promise;
          },
          cancel: function(a) {
            this._done = !0;
            this._requests.forEach(function(a) {
              a.resolve({ value: void 0, done: !0 });
            });
            this._requests = [];
          },
        };
        m.prototype = {
          _enqueue: function(a) {
            this._done ||
              (0 === this._requests.length
                ? (this._queuedChunk = a)
                : (this._requests.shift().resolve({ value: a, done: !1 }),
                  this._requests.forEach(function(a) {
                    a.resolve({ value: void 0, done: !0 });
                  }),
                  (this._requests = [])),
              (this._done = !0),
              this._stream._removeRangeReader(this));
          },
          get isStreamingSupported() {
            return !1;
          },
          read: function() {
            if (this._queuedChunk) {
              var b = this._queuedChunk;
              this._queuedChunk = null;
              return Promise.resolve({ value: b, done: !1 });
            }
            if (this._done) return Promise.resolve({ value: void 0, done: !0 });
            b = (0, a.createPromiseCapability)();
            this._requests.push(b);
            return b.promise;
          },
          cancel: function(a) {
            this._done = !0;
            this._requests.forEach(function(a) {
              a.resolve({ value: void 0, done: !0 });
            });
            this._requests = [];
            this._stream._removeRangeReader(this);
          },
        };
        return k;
      })();
      m.PDFDataTransportStream = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.WorkerMessageHandler = m.WorkerTask = void 0;
      var a =
          'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
            ? function(a) {
                return typeof a;
              }
            : function(a) {
                return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                  ? 'symbol'
                  : typeof a;
              },
        k = t(0),
        b = t(104),
        v = t(1),
        d = (function() {
          function a(a) {
            this.name = a;
            this.terminated = !1;
            this._capability = (0, k.createPromiseCapability)();
          }
          a.prototype = {
            get finished() {
              return this._capability.promise;
            },
            finish: function() {
              this._capability.resolve();
            },
            terminate: function() {
              this.terminated = !0;
            },
            ensureNotTerminated: function() {
              if (this.terminated) throw Error('Worker task was terminated');
            },
          };
          return a;
        })(),
        u = (function() {
          function a(a) {
            this._msgHandler = a;
            this._fullRequestReader = this._contentLength = null;
            this._rangeRequestReaders = [];
          }
          function b(a) {
            var b = this;
            this._msgHandler = a;
            this._contentLength = null;
            this._isStreamingSupported = this._isRangeSupported = !1;
            this._reader = this._msgHandler.sendWithStream('GetReader').getReader();
            this._headersReady = this._msgHandler.sendWithPromise('ReaderHeadersReady').then(function(a) {
              b._isStreamingSupported = a.isStreamingSupported;
              b._isRangeSupported = a.isRangeSupported;
              b._contentLength = a.contentLength;
            });
          }
          function d(a, b, d) {
            this._msgHandler = d;
            this.onProgress = null;
            this._reader = this._msgHandler.sendWithStream('GetRangeReader', { begin: a, end: b }).getReader();
          }
          a.prototype = {
            getFullReader: function() {
              (0, k.assert)(!this._fullRequestReader);
              return (this._fullRequestReader = new b(this._msgHandler));
            },
            getRangeReader: function(a, b) {
              var e = new d(a, b, this._msgHandler);
              this._rangeRequestReaders.push(e);
              return e;
            },
            cancelAllRequests: function(a) {
              this._fullRequestReader && this._fullRequestReader.cancel(a);
              this._rangeRequestReaders.slice(0).forEach(function(b) {
                b.cancel(a);
              });
            },
          };
          b.prototype = {
            get headersReady() {
              return this._headersReady;
            },
            get contentLength() {
              return this._contentLength;
            },
            get isStreamingSupported() {
              return this._isStreamingSupported;
            },
            get isRangeSupported() {
              return this._isRangeSupported;
            },
            read: function() {
              return this._reader.read().then(function(a) {
                return a.done ? { value: void 0, done: !0 } : { value: a.value.buffer, done: !1 };
              });
            },
            cancel: function(a) {
              this._reader.cancel(a);
            },
          };
          d.prototype = {
            get isStreamingSupported() {
              return !1;
            },
            read: function() {
              return this._reader.read().then(function(a) {
                return a.done ? { value: void 0, done: !0 } : { value: a.value.buffer, done: !1 };
              });
            },
            cancel: function(a) {
              this._reader.cancel(a);
            },
          };
          return a;
        })(),
        z = {
          setup: function(a, b) {
            var d = !1;
            a.on('test', function(b) {
              if (!d)
                if (((d = !0), b instanceof Uint8Array)) {
                  b = 255 === b[0];
                  a.postMessageTransfers = b;
                  var e = new XMLHttpRequest(),
                    n = 'response' in e;
                  try {
                    e.responseType;
                  } catch (A) {
                    n = !1;
                  }
                  n ? a.send('test', { supportTypedArray: !0, supportTransfers: b }) : a.send('test', !1);
                } else a.send('test', 'main', !1);
            });
            a.on('configure', function(a) {
              (0, k.setVerbosityLevel)(a.verbosity);
            });
            a.on('GetDocRequest', function(a) {
              return z.createDocumentHandler(a, b);
            });
          },
          createDocumentHandler: function(m, B) {
            function n() {
              if (q) throw Error('Worker was terminated');
            }
            function e(a) {
              a.finish();
              a = g.indexOf(a);
              g.splice(a, 1);
            }
            function h(a) {
              var b = (0, k.createPromiseCapability)(),
                d = function() {
                  var a = c.ensureDoc('numPages'),
                    d = c.ensureDoc('fingerprint'),
                    g = c.ensureXRef('encrypt');
                  Promise.all([a, d, g]).then(function(a) {
                    b.resolve({ numPages: a[0], fingerprint: a[1], encrypted: !!a[2] });
                  }, e);
                },
                e = function(a) {
                  b.reject(a);
                };
              c.ensureDoc('checkHeader', []).then(function() {
                c.ensureDoc('parseStartXRef', []).then(function() {
                  c.ensureDoc('parse', [a]).then(d, e);
                }, e);
              }, e);
              return b.promise;
            }
            function p(a, c) {
              var d = (0, k.createPromiseCapability)(),
                e = a.source;
              if (e.data) {
                try {
                  var g = new b.LocalPdfManager(t, e.data, e.password, c, l);
                  d.resolve(g);
                } catch (M) {
                  d.reject(M);
                }
                return d.promise;
              }
              var h = [];
              try {
                var p = new u(f);
              } catch (M) {
                return d.reject(M), d.promise;
              }
              var q = p.getFullReader();
              q.headersReady
                .then(function() {
                  if (q.isRangeSupported) {
                    g = new b.NetworkPdfManager(
                      t,
                      p,
                      {
                        msgHandler: f,
                        url: e.url,
                        password: e.password,
                        length: q.contentLength,
                        disableAutoFetch: e.disableAutoFetch || q.isStreamingSupported,
                        rangeChunkSize: e.rangeChunkSize,
                      },
                      c,
                      l,
                    );
                    for (var a = 0; a < h.length; a++) g.sendProgressiveData(h[a]);
                    h = [];
                    d.resolve(g);
                    x = null;
                  }
                })
                ['catch'](function(a) {
                  d.reject(a);
                  x = null;
                });
              var r = 0;
              new Promise(function(a, p) {
                q.read().then(function W(a) {
                  try {
                    if ((n(), a.done)) {
                      if (!g) {
                        var m = (0, k.arraysToBytes)(h);
                        e.length &&
                          m.length !== e.length &&
                          (0, k.warn)('reported HTTP length is different from actual');
                        try {
                          (g = new b.LocalPdfManager(t, m, e.password, c, l)), d.resolve(g);
                        } catch (aa) {
                          d.reject(aa);
                        }
                        h = [];
                      }
                      x = null;
                    } else {
                      var w = a.value;
                      r += (0, k.arrayByteLength)(w);
                      q.isStreamingSupported ||
                        f.send('DocProgress', { loaded: r, total: Math.max(r, q.contentLength || 0) });
                      g ? g.sendProgressiveData(w) : h.push(w);
                      q.read().then(W, p);
                    }
                  } catch (aa) {
                    p(aa);
                  }
                }, p);
              })['catch'](function(a) {
                d.reject(a);
                x = null;
              });
              x = function() {
                p.cancelAllRequests('abort');
              };
              return d.promise;
            }
            function A(a) {
              function b(a) {
                n();
                f.send('GetDoc', { pdfInfo: a });
              }
              function l(a) {
                n();
                if (a instanceof k.PasswordException) {
                  var b = new d('PasswordException: response ' + a.code);
                  g.push(b);
                  f.sendWithPromise('PasswordRequest', a)
                    .then(function(a) {
                      e(b);
                      c.updatePassword(a.password);
                      r();
                    })
                    ['catch'](
                      function(a) {
                        e(b);
                        f.send('PasswordException', a);
                      }.bind(null, a),
                    );
                } else
                  a instanceof k.InvalidPDFException
                    ? f.send('InvalidPDF', a)
                    : a instanceof k.MissingPDFException
                    ? f.send('MissingPDF', a)
                    : a instanceof k.UnexpectedResponseException
                    ? f.send('UnexpectedResponse', a)
                    : f.send('UnknownError', new k.UnknownErrorException(a.message, a.toString()));
              }
              function r() {
                n();
                h(!1).then(
                  b,
                  function(a) {
                    n();
                    a instanceof k.XRefParseException
                      ? (c.requestLoadedStream(),
                        c.onLoadedStream().then(function() {
                          n();
                          h(!0).then(b, l);
                        }))
                      : l(a);
                  },
                  l,
                );
              }
              n();
              p(a, {
                forceDataSchema: a.disableCreateObjectURL,
                maxImageSize: void 0 === a.maxImageSize ? -1 : a.maxImageSize,
                disableFontFace: a.disableFontFace,
                nativeImageDecoderSupport: a.nativeImageDecoderSupport,
                ignoreErrors: a.ignoreErrors,
                isEvalSupported: a.isEvalSupported,
              })
                .then(function(a) {
                  if (q) throw (a.terminate(), Error('Worker was terminated'));
                  c = a;
                  f.send('PDFManagerReady', null);
                  c.onLoadedStream().then(function(a) {
                    f.send('DataLoaded', { length: a.bytes.byteLength });
                  });
                })
                .then(r, l);
            }
            var c,
              q = !1,
              x = null,
              g = [],
              t = m.docId,
              l = m.docBaseUrl,
              z = m.docId + '_worker',
              f = new k.MessageHandler(z, t, B);
            f.postMessageTransfers = m.postMessageTransfers;
            f.on('GetPage', function(a) {
              return c.getPage(a.pageIndex).then(function(a) {
                var b = c.ensure(a, 'rotate'),
                  d = c.ensure(a, 'ref'),
                  e = c.ensure(a, 'userUnit');
                a = c.ensure(a, 'view');
                return Promise.all([b, d, e, a]).then(function(a) {
                  return { rotate: a[0], ref: a[1], userUnit: a[2], view: a[3] };
                });
              });
            });
            f.on('GetPageIndex', function(a) {
              a = new v.Ref(a.ref.num, a.ref.gen);
              return c.pdfDocument.catalog.getPageIndex(a);
            });
            f.on('GetDestinations', function(a) {
              return c.ensureCatalog('destinations');
            });
            f.on('GetDestination', function(a) {
              return c.ensureCatalog('getDestination', [a.id]);
            });
            f.on('GetPageLabels', function(a) {
              return c.ensureCatalog('pageLabels');
            });
            f.on('GetPageMode', function(a) {
              return c.ensureCatalog('pageMode');
            });
            f.on('GetAttachments', function(a) {
              return c.ensureCatalog('attachments');
            });
            f.on('GetJavaScript', function(a) {
              return c.ensureCatalog('javaScript');
            });
            f.on('GetOutline', function(a) {
              return c.ensureCatalog('documentOutline');
            });
            f.on('GetMetadata', function(a) {
              return Promise.all([c.ensureDoc('documentInfo'), c.ensureCatalog('metadata')]);
            });
            f.on('GetData', function(a) {
              c.requestLoadedStream();
              return c.onLoadedStream().then(function(a) {
                return a.bytes;
              });
            });
            f.on('GetStats', function(a) {
              return c.pdfDocument.xref.stats;
            });
            f.on('GetAnnotations', function(a) {
              return c.getPage(a.pageIndex).then(function(b) {
                return c.ensure(b, 'getAnnotationsData', [a.intent]);
              });
            });
            f.on(
              'RenderPageRequest',
              function(b) {
                var l = b.pageIndex;
                c.getPage(l).then(function(c) {
                  var h = new d('RenderPageRequest: page ' + l);
                  g.push(h);
                  var n = l + 1,
                    p = Date.now();
                  c.getOperatorList({
                    handler: f,
                    task: h,
                    intent: b.intent,
                    renderInteractiveForms: b.renderInteractiveForms,
                  }).then(
                    function(a) {
                      e(h);
                      (0, k.info)(
                        'page=' + n + ' - getOperatorList: time=' + (Date.now() - p) + 'ms, len=' + a.totalLength,
                      );
                    },
                    function(c) {
                      e(h);
                      h.terminated ||
                        (f.send('UnsupportedFeature', { featureId: k.UNSUPPORTED_FEATURES.unknown }),
                        (c =
                          'string' === typeof c
                            ? { message: c, stack: 'worker.js: while trying to getPage() and getOperatorList()' }
                            : 'object' === ('undefined' === typeof c ? 'undefined' : a(c))
                            ? {
                                message: c.message || c.toString(),
                                stack: c.stack || 'worker.js: while trying to getPage() and getOperatorList()',
                              }
                            : {
                                message: 'Unknown exception type: ' + ('undefined' === typeof c ? 'undefined' : a(c)),
                                stack: 'worker.js: while trying to getPage() and getOperatorList()',
                              }),
                        f.send('PageError', { pageNum: n, error: c, intent: b.intent }));
                    },
                  );
                });
              },
              this,
            );
            f.on('GetTextContent', function(a, b) {
              var l = a.pageIndex;
              b.onPull = function(a) {};
              b.onCancel = function(a) {};
              c.getPage(l).then(function(c) {
                var h = new d('GetTextContent: page ' + l);
                g.push(h);
                var n = l + 1,
                  p = Date.now();
                c.extractTextContent({
                  handler: f,
                  task: h,
                  sink: b,
                  normalizeWhitespace: a.normalizeWhitespace,
                  combineTextItems: a.combineTextItems,
                }).then(
                  function() {
                    e(h);
                    (0, k.info)('text indexing: page=' + n + ' - time=' + (Date.now() - p) + 'ms');
                    b.close();
                  },
                  function(a) {
                    e(h);
                    if (!h.terminated) throw (b.error(a), a);
                  },
                );
              });
            });
            f.on('Cleanup', function(a) {
              return c.cleanup();
            });
            f.on('Terminate', function(a) {
              q = !0;
              c && (c.terminate(), (c = null));
              x && x();
              var b = [];
              g.forEach(function(a) {
                b.push(a.finished);
                a.terminate();
              });
              return Promise.all(b).then(function() {
                f.destroy();
                f = null;
              });
            });
            f.on('Ready', function(a) {
              A(m);
              m = null;
            });
            return z;
          },
          initializeFromPort: function(a) {
            var b = new k.MessageHandler('worker', 'main', a);
            z.setup(b, a);
            b.send('ready', null);
          },
        };
      'undefined' === typeof window &&
        !(0, k.isNodeJS)() &&
        'undefined' !== typeof self &&
        'function' === typeof self.postMessage &&
        'onmessage' in self &&
        z.initializeFromPort(self);
      m.WorkerTask = d;
      m.WorkerMessageHandler = z;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.NetworkPdfManager = m.LocalPdfManager = void 0;
      var a = t(0),
        k = t(58),
        b = t(105),
        v = t(3),
        d = (function() {
          function b() {
            throw Error('Cannot initialize BaseManagerManager');
          }
          b.prototype = {
            get docId() {
              return this._docId;
            },
            get password() {
              return this._password;
            },
            get docBaseUrl() {
              var b = null;
              if (this._docBaseUrl) {
                var d = (0, a.createValidAbsoluteUrl)(this._docBaseUrl);
                d ? (b = d.href) : (0, a.warn)('Invalid absolute docBaseUrl: "' + this._docBaseUrl + '".');
              }
              return (0, a.shadow)(this, 'docBaseUrl', b);
            },
            onLoadedStream: function() {
              throw new a.NotImplementedException();
            },
            ensureDoc: function(a, b) {
              return this.ensure(this.pdfDocument, a, b);
            },
            ensureXRef: function(a, b) {
              return this.ensure(this.pdfDocument.xref, a, b);
            },
            ensureCatalog: function(a, b) {
              return this.ensure(this.pdfDocument.catalog, a, b);
            },
            getPage: function(a) {
              return this.pdfDocument.getPage(a);
            },
            cleanup: function() {
              return this.pdfDocument.cleanup();
            },
            ensure: function(b, d, k) {
              return new a.NotImplementedException();
            },
            requestRange: function(b, d) {
              return new a.NotImplementedException();
            },
            requestLoadedStream: function() {
              return new a.NotImplementedException();
            },
            sendProgressiveData: function(b) {
              return new a.NotImplementedException();
            },
            updatePassword: function(a) {
              this._password = a;
            },
            terminate: function() {
              return new a.NotImplementedException();
            },
          };
          return b;
        })();
      y = (function() {
        function k(d, k, m, n, e) {
          this._docId = d;
          this._password = m;
          this._docBaseUrl = e;
          this.evaluatorOptions = n;
          d = new v.Stream(k);
          this.pdfDocument = new b.PDFDocument(this, d);
          this._loadedStreamCapability = (0, a.createPromiseCapability)();
          this._loadedStreamCapability.resolve(d);
        }
        a.Util.inherit(k, d, {
          ensure: function(a, b, d) {
            return new Promise(function(n, e) {
              try {
                var h = a[b];
                var p = 'function' === typeof h ? h.apply(a, d) : h;
                n(p);
              } catch (A) {
                e(A);
              }
            });
          },
          requestRange: function(a, b) {
            return Promise.resolve();
          },
          requestLoadedStream: function() {},
          onLoadedStream: function() {
            return this._loadedStreamCapability.promise;
          },
          terminate: function() {},
        });
        return k;
      })();
      t = (function() {
        function m(a, d, m, n, e) {
          this._docId = a;
          this._password = m.password;
          this._docBaseUrl = e;
          this.msgHandler = m.msgHandler;
          this.evaluatorOptions = n;
          this.streamManager = new k.ChunkedStreamManager(d, {
            msgHandler: m.msgHandler,
            url: m.url,
            length: m.length,
            disableAutoFetch: m.disableAutoFetch,
            rangeChunkSize: m.rangeChunkSize,
          });
          this.pdfDocument = new b.PDFDocument(this, this.streamManager.getStream());
        }
        a.Util.inherit(m, d, {
          ensure: function(b, d, k) {
            var n = this;
            return new Promise(function(e, h) {
              function p() {
                try {
                  var m = b[d];
                  var c = 'function' === typeof m ? m.apply(b, k) : m;
                  e(c);
                } catch (q) {
                  q instanceof a.MissingDataException ? n.streamManager.requestRange(q.begin, q.end).then(p, h) : h(q);
                }
              }
              p();
            });
          },
          requestRange: function(a, b) {
            return this.streamManager.requestRange(a, b);
          },
          requestLoadedStream: function() {
            this.streamManager.requestAllChunks();
          },
          sendProgressiveData: function(a) {
            this.streamManager.onReceiveData({ chunk: a });
          },
          onLoadedStream: function() {
            return this.streamManager.onLoadedStream();
          },
          terminate: function() {
            this.streamManager.abort();
          },
        });
        return m;
      })();
      m.LocalPdfManager = y;
      m.NetworkPdfManager = t;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.PDFDocument = m.Page = void 0;
      var a = (function() {
          return function(a, b) {
            if (Array.isArray(a)) return a;
            if (Symbol.iterator in Object(a)) {
              var d = [],
                c = !0,
                e = !1,
                h = void 0;
              try {
                for (
                  var g = a[Symbol.iterator](), n;
                  !(c = (n = g.next()).done) && (d.push(n.value), !b || d.length !== b);
                  c = !0
                );
              } catch (l) {
                (e = !0), (h = l);
              } finally {
                try {
                  if (!c && g['return']) g['return']();
                } finally {
                  if (e) throw h;
                }
              }
              return d;
            }
            throw new TypeError('Invalid attempt to destructure non-iterable instance');
          };
        })(),
        k = t(59),
        b = t(1),
        v = t(0),
        d = t(3),
        u = t(63),
        z = t(119),
        C = t(62),
        B = t(25),
        n = t(26),
        e = (function() {
          function e(a, b) {
            return ('display' === b && a.viewable) || ('print' === b && a.printable);
          }
          function n(a, b, d, e, h, l, n) {
            this.pdfManager = a;
            this.pageIndex = d;
            this.pageDict = e;
            this.xref = b;
            this.ref = h;
            this.fontCache = l;
            this.builtInCMapCache = n;
            this.evaluatorOptions = a.evaluatorOptions;
            this.resourcesPromise = null;
            var c = 'p' + this.pageIndex + '_',
              g = 0;
            this.idFactory = {
              createObjId: function() {
                return c + ++g;
              },
            };
          }
          var m = [0, 0, 612, 792];
          n.prototype = {
            getPageProp: function(a) {
              return this.pageDict.get(a);
            },
            getInheritedPageProp: function(a, d) {
              var c = this.pageDict,
                e = null,
                h = 0;
              for (d = d || !1; c; ) {
                var l = d ? c.getArray(a) : c.get(a);
                void 0 !== l && (e || (e = []), e.push(l));
                if (100 < ++h)
                  return (0, v.warn)('getInheritedPageProp: maximum loop count exceeded for ' + a), e ? e[0] : void 0;
                c = c.get('Parent');
              }
              if (e) return 1 !== e.length && (0, b.isDict)(e[0]) ? b.Dict.merge(this.xref, e) : e[0];
            },
            get content() {
              return this.getPageProp('Contents');
            },
            get resources() {
              return (0, v.shadow)(this, 'resources', this.getInheritedPageProp('Resources') || b.Dict.empty);
            },
            get mediaBox() {
              var a = this.getInheritedPageProp('MediaBox', !0);
              return Array.isArray(a) && 4 === a.length
                ? (0, v.shadow)(this, 'mediaBox', a)
                : (0, v.shadow)(this, 'mediaBox', m);
            },
            get cropBox() {
              var a = this.getInheritedPageProp('CropBox', !0);
              return Array.isArray(a) && 4 === a.length
                ? (0, v.shadow)(this, 'cropBox', a)
                : (0, v.shadow)(this, 'cropBox', this.mediaBox);
            },
            get userUnit() {
              var a = this.getPageProp('UserUnit');
              if (!(0, v.isNum)(a) || 0 >= a) a = 1;
              return (0, v.shadow)(this, 'userUnit', a);
            },
            get view() {
              var a = this.mediaBox,
                b = this.cropBox;
              if (a === b) return (0, v.shadow)(this, 'view', a);
              b = v.Util.intersect(b, a);
              return (0, v.shadow)(this, 'view', b || a);
            },
            get rotate() {
              var a = this.getInheritedPageProp('Rotate') || 0;
              0 !== a % 90 ? (a = 0) : 360 <= a ? (a %= 360) : 0 > a && (a = ((a % 360) + 360) % 360);
              return (0, v.shadow)(this, 'rotate', a);
            },
            getContentStream: function() {
              var a = this.content;
              if (Array.isArray(a)) {
                var e = this.xref,
                  h,
                  g = a.length,
                  n = [];
                for (h = 0; h < g; ++h) n.push(e.fetchIfRef(a[h]));
                a = new d.StreamsSequenceStream(n);
              } else a = (0, b.isStream)(a) ? a : new d.NullStream();
              return a;
            },
            loadResources: function(a) {
              var b = this;
              this.resourcesPromise || (this.resourcesPromise = this.pdfManager.ensure(this, 'resources'));
              return this.resourcesPromise.then(function() {
                return new k.ObjectLoader(b.resources, a, b.xref).load();
              });
            },
            getOperatorList: function(b) {
              var c = this,
                d = b.handler,
                g = b.task,
                h = b.intent,
                l = b.renderInteractiveForms;
              b = this.pdfManager.ensure(this, 'getContentStream');
              var n = this.loadResources('ExtGState ColorSpace Pattern Shading XObject Font'.split(' ')),
                f = new u.PartialEvaluator({
                  pdfManager: this.pdfManager,
                  xref: this.xref,
                  handler: d,
                  pageIndex: this.pageIndex,
                  idFactory: this.idFactory,
                  fontCache: this.fontCache,
                  builtInCMapCache: this.builtInCMapCache,
                  options: this.evaluatorOptions,
                });
              b = Promise.all([b, n]).then(function(b) {
                b = a(b, 1)[0];
                var e = new u.OperatorList(h, d, c.pageIndex);
                d.send('StartRenderPage', {
                  transparency: f.hasBlendModes(c.resources),
                  pageIndex: c.pageIndex,
                  intent: h,
                });
                return f
                  .getOperatorList({ stream: b, task: g, resources: c.resources, operatorList: e })
                  .then(function() {
                    return e;
                  });
              });
              n = this.pdfManager.ensure(this, 'annotations');
              return Promise.all([b, n]).then(function(b) {
                b = a(b, 2);
                var c = b[0];
                b = b[1];
                if (0 === b.length) return c.flush(!0), c;
                var d,
                  n = [];
                var p = 0;
                for (d = b.length; p < d; p++) e(b[p], h) && n.push(b[p].getOperatorList(f, g, l));
                return Promise.all(n).then(function(a) {
                  c.addOp(v.OPS.beginAnnotations, []);
                  p = 0;
                  for (d = a.length; p < d; p++) c.addOpList(a[p]);
                  c.addOp(v.OPS.endAnnotations, []);
                  c.flush(!0);
                  return c;
                });
              });
            },
            extractTextContent: function(b) {
              var c = this,
                d = b.handler,
                e = b.task,
                h = b.normalizeWhitespace,
                l = b.sink,
                n = b.combineTextItems;
              b = this.pdfManager.ensure(this, 'getContentStream');
              var f = this.loadResources(['ExtGState', 'XObject', 'Font']);
              return Promise.all([b, f]).then(function(b) {
                b = a(b, 1)[0];
                return new u.PartialEvaluator({
                  pdfManager: c.pdfManager,
                  xref: c.xref,
                  handler: d,
                  pageIndex: c.pageIndex,
                  idFactory: c.idFactory,
                  fontCache: c.fontCache,
                  builtInCMapCache: c.builtInCMapCache,
                  options: c.evaluatorOptions,
                }).getTextContent({
                  stream: b,
                  task: e,
                  resources: c.resources,
                  normalizeWhitespace: h,
                  combineTextItems: n,
                  sink: l,
                });
              });
            },
            getAnnotationsData: function(a) {
              for (var b = this.annotations, c = [], d = 0, h = b.length; d < h; ++d)
                (a && !e(b[d], a)) || c.push(b[d].data);
              return c;
            },
            get annotations() {
              for (var a = [], b = this.getInheritedPageProp('Annots') || [], d = 0, e = b.length; d < e; ++d) {
                var h = z.AnnotationFactory.create(this.xref, b[d], this.pdfManager, this.idFactory);
                h && a.push(h);
              }
              return (0, v.shadow)(this, 'annotations', a);
            },
          };
          return n;
        })();
      y = (function() {
        function a(a, e) {
          if ((0, b.isStream)(e)) var c = e;
          else if ((0, v.isArrayBuffer)(e)) c = new d.Stream(e);
          else throw Error('PDFDocument: Unknown argument type');
          if (0 >= c.length) throw Error('PDFDocument: stream must have data');
          this.pdfManager = a;
          this.stream = c;
          this.xref = new k.XRef(c, a);
        }
        function p(a, b, d, e) {
          var c = a.pos,
            g = a.end,
            h = [];
          c + d > g && (d = g - c);
          for (g = 0; g < d; ++g) h.push(String.fromCharCode(a.getByte()));
          d = h.join('');
          a.pos = c;
          b = e ? d.lastIndexOf(b) : d.indexOf(b);
          if (-1 === b) return !1;
          a.pos += b;
          return !0;
        }
        var m = {
          get entries() {
            return (0, v.shadow)(this, 'entries', {
              Title: v.isString,
              Author: v.isString,
              Subject: v.isString,
              Keywords: v.isString,
              Creator: v.isString,
              Producer: v.isString,
              CreationDate: v.isString,
              ModDate: v.isString,
              Trapped: b.isName,
            });
          },
        };
        a.prototype = {
          parse: function(a) {
            this.setup(a);
            a = this.catalog.catDict.get('Version');
            (0, b.isName)(a) && (this.pdfFormatVersion = a.name);
            try {
              if ((this.acroForm = this.catalog.catDict.get('AcroForm'))) {
                this.xfa = this.acroForm.get('XFA');
                var c = this.acroForm.get('Fields');
                (c && Array.isArray(c) && 0 !== c.length) || this.xfa || (this.acroForm = null);
              }
            } catch (x) {
              if (x instanceof v.MissingDataException) throw x;
              (0, v.info)('Something wrong with AcroForm entry');
              this.acroForm = null;
            }
          },
          get linearization() {
            var a = null;
            if (this.stream.length)
              try {
                a = B.Linearization.create(this.stream);
              } catch (q) {
                if (q instanceof v.MissingDataException) throw q;
                (0, v.info)(q);
              }
            return (0, v.shadow)(this, 'linearization', a);
          },
          get startXRef() {
            var a = this.stream,
              b = 0;
            if (this.linearization) a.reset(), p(a, 'endobj', 1024) && (b = a.pos + 6);
            else {
              for (var d = !1, e = a.end; !d && 0 < e; )
                (e -= 1015), 0 > e && (e = 0), (a.pos = e), (d = p(a, 'startxref', 1024, !0));
              if (d) {
                a.skip(9);
                do b = a.getByte();
                while ((0, v.isSpace)(b));
                for (d = ''; 32 <= b && 57 >= b; ) (d += String.fromCharCode(b)), (b = a.getByte());
                b = parseInt(d, 10);
                isNaN(b) && (b = 0);
              }
            }
            return (0, v.shadow)(this, 'startXRef', b);
          },
          get mainXRefEntriesOffset() {
            var a = 0,
              b = this.linearization;
            b && (a = b.mainXRefEntriesOffset);
            return (0, v.shadow)(this, 'mainXRefEntriesOffset', a);
          },
          checkHeader: function() {
            var a = this.stream;
            a.reset();
            if (p(a, '%PDF-', 1024)) {
              a.moveStart();
              for (var b = '', d; 32 < (d = a.getByte()) && !(12 <= b.length); ) b += String.fromCharCode(d);
              this.pdfFormatVersion || (this.pdfFormatVersion = b.substring(5));
            }
          },
          parseStartXRef: function() {
            this.xref.setStartXRef(this.startXRef);
          },
          setup: function(a) {
            var b = this;
            this.xref.parse(a);
            this.catalog = new k.Catalog(this.pdfManager, this.xref, {
              createPage: function(a, c, d, l, h) {
                return new e(b.pdfManager, b.xref, a, c, d, l, h);
              },
            });
            n.PDFFunction.setIsEvalSupported(this.pdfManager.evaluatorOptions.isEvalSupported);
          },
          get numPages() {
            var a = this.linearization;
            a = a ? a.numPages : this.catalog.numPages;
            return (0, v.shadow)(this, 'numPages', a);
          },
          get documentInfo() {
            var a = {
              PDFFormatVersion: this.pdfFormatVersion,
              IsAcroFormPresent: !!this.acroForm,
              IsXFAPresent: !!this.xfa,
            };
            try {
              var b = this.xref.trailer.get('Info');
            } catch (l) {
              if (l instanceof v.MissingDataException) throw l;
              (0, v.info)('The document information dictionary is invalid.');
            }
            if (b) {
              var d = m.entries,
                e;
              for (e in d)
                if (b.has(e)) {
                  var h = b.get(e);
                  d[e](h)
                    ? (a[e] = 'string' !== typeof h ? h : (0, v.stringToPDFString)(h))
                    : (0, v.info)('Bad value in document info for "' + e + '"');
                }
            }
            return (0, v.shadow)(this, 'documentInfo', a);
          },
          get fingerprint() {
            var a = '';
            var b = this.xref.trailer.get('ID');
            Array.isArray(b) &&
            b[0] &&
            (0, v.isString)(b[0]) &&
            '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00' !== b[0]
              ? (b = (0, v.stringToBytes)(b[0]))
              : (this.stream.ensureRange && this.stream.ensureRange(0, Math.min(1024, this.stream.end)),
                (b = (0, C.calculateMD5)(this.stream.bytes.subarray(0, 1024), 0, 1024)));
            for (var d = 0, e = b.length; d < e; d++) {
              var h = b[d].toString(16);
              a += 1 === h.length ? '0' + h : h;
            }
            return (0, v.shadow)(this, 'fingerprint', a);
          },
          getPage: function(a) {
            return this.catalog.getPage(a);
          },
          cleanup: function() {
            return this.catalog.cleanup();
          },
        };
        return a;
      })();
      m.Page = e;
      m.PDFDocument = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.Jbig2Image = void 0;
      var a = t(0),
        k = t(60),
        b = (function() {
          function a(a) {
            this.message = 'JBIG2 error: ' + a;
          }
          a.prototype = Error();
          a.prototype.name = 'Jbig2Error';
          return (a.constructor = a);
        })();
      y = (function() {
        function m() {}
        function d(a, b, c) {
          this.data = a;
          this.start = b;
          this.end = c;
        }
        function u(a, b, c) {
          function d(a) {
            for (var b = 0, d = 0; d < a; d++) {
              var g = c.readBit(e, f);
              f = 256 > f ? (f << 1) | g : (((f << 1) | g) & 511) | 256;
              b = (b << 1) | g;
            }
            return b >>> 0;
          }
          var e = a.getContexts(b),
            f = 1;
          a = d(1);
          b = d(1)
            ? d(1)
              ? d(1)
                ? d(1)
                  ? d(1)
                    ? d(32) + 4436
                    : d(12) + 340
                  : d(8) + 84
                : d(6) + 20
              : d(4) + 4
            : d(2);
          return 0 === a ? b : 0 < b ? -b : null;
        }
        function t(a, b, c) {
          a = a.getContexts('IAID');
          for (var d = 1, e = 0; e < c; e++) {
            var f = b.readBit(a, d);
            d = (d << 1) | f;
          }
          return 31 > c ? d & ((1 << c) - 1) : d & 2147483647;
        }
        function y(a, b, c) {
          var d = c.decoder;
          c = c.contextCache.getContexts('GB');
          var e,
            f,
            g,
            l = [];
          for (e = 0; e < b; e++) {
            var h = (l[e] = new Uint8Array(a));
            var n = 1 > e ? h : l[e - 1];
            var p = 2 > e ? h : l[e - 2];
            var q = (p[0] << 13) | (p[1] << 12) | (p[2] << 11) | (n[0] << 7) | (n[1] << 6) | (n[2] << 5) | (n[3] << 4);
            for (f = 0; f < a; f++)
              (h[f] = g = d.readBit(c, q)),
                (q = ((q & 31735) << 1) | (f + 3 < a ? p[f + 3] << 11 : 0) | (f + 4 < a ? n[f + 4] << 4 : 0) | g);
          }
          return l;
        }
        function B(a, c, d, e, h, n, p, k) {
          if (a) throw new b('MMR encoding is not supported');
          if (
            0 === e &&
            !n &&
            !h &&
            4 === p.length &&
            3 === p[0].x &&
            -1 === p[0].y &&
            -3 === p[1].x &&
            -1 === p[1].y &&
            2 === p[2].x &&
            -2 === p[2].y &&
            -2 === p[3].x &&
            -2 === p[3].y
          )
            return y(c, d, k);
          a = !!n;
          var f = q[e].concat(p);
          f.sort(function(a, b) {
            return a.y - b.y || a.x - b.x;
          });
          p = f.length;
          var l = new Int8Array(p),
            r = new Int8Array(p),
            m = [],
            x = 0,
            w = 0,
            v = 0,
            u = 0,
            A,
            t;
          for (t = 0; t < p; t++)
            (l[t] = f[t].x),
              (r[t] = f[t].y),
              (w = Math.min(w, f[t].x)),
              (v = Math.max(v, f[t].x)),
              (u = Math.min(u, f[t].y)),
              t < p - 1 && f[t].y === f[t + 1].y && f[t].x === f[t + 1].x - 1 ? (x |= 1 << (p - 1 - t)) : m.push(t);
          var B = m.length,
            D = new Int8Array(B),
            z = new Int8Array(B),
            G = new Uint16Array(B);
          for (A = 0; A < B; A++) (t = m[A]), (D[A] = f[t].x), (z[A] = f[t].y), (G[A] = 1 << (p - 1 - t));
          f = -w;
          u = -u;
          v = c - v;
          e = g[e];
          m = new Uint8Array(c);
          w = [];
          A = k.decoder;
          k = k.contextCache.getContexts('GB');
          for (var C = 0, J, I, L, U = 0, V, P = 0; P < d; P++) {
            if (h && ((t = A.readBit(k, e)), (C ^= t))) {
              w.push(m);
              continue;
            }
            m = new Uint8Array(m);
            w.push(m);
            for (J = 0; J < c; J++)
              if (a && n[P][J]) m[J] = 0;
              else {
                if (J >= f && J < v && P >= u)
                  for (U = (U << 1) & x, t = 0; t < B; t++) {
                    if (((I = P + z[t]), (L = J + D[t]), (I = w[I][L]))) (I = G[t]), (U |= I);
                  }
                else
                  for (U = 0, V = p - 1, t = 0; t < p; t++, V--)
                    (L = J + l[t]), 0 <= L && L < c && ((I = P + r[t]), 0 <= I && (I = w[I][L]) && (U |= I << V));
                t = A.readBit(k, U);
                m[J] = t;
              }
          }
          return w;
        }
        function n(a, c, d, e, g, h, n, p, q) {
          var f = x[d].coding;
          0 === d && (f = f.concat([p[0]]));
          var l = f.length,
            k = new Int32Array(l),
            r = new Int32Array(l),
            m;
          for (m = 0; m < l; m++) (k[m] = f[m].x), (r[m] = f[m].y);
          var w = x[d].reference;
          0 === d && (w = w.concat([p[1]]));
          p = w.length;
          f = new Int32Array(p);
          var v = new Int32Array(p);
          for (m = 0; m < p; m++) (f[m] = w[m].x), (v[m] = w[m].y);
          w = e[0].length;
          var u = e.length;
          d = G[d];
          var A = [],
            t = q.decoder;
          q = q.contextCache.getContexts('GR');
          for (var B = 0, D = 0; D < c; D++) {
            if (n && ((m = t.readBit(q, d)), (B ^= m))) throw new b('prediction is not supported');
            var E = new Uint8Array(a);
            A.push(E);
            for (var z = 0; z < a; z++) {
              var y = 0;
              for (m = 0; m < l; m++) {
                var J = D + r[m];
                var C = z + k[m];
                y = 0 > J || 0 > C || C >= a ? y << 1 : (y << 1) | A[J][C];
              }
              for (m = 0; m < p; m++)
                (J = D + v[m] - h),
                  (C = z + f[m] - g),
                  (y = 0 > J || J >= u || 0 > C || C >= w ? y << 1 : (y << 1) | e[J][C]);
              m = t.readBit(q, y);
              E[z] = m;
            }
          }
          return A;
        }
        function e(a, c, d, e, g, h, p, q, k, m, x, v, A, B, z, y, G) {
          if (a) throw new b('huffman is not supported');
          a = [];
          for (B = 0; B < e; B++) {
            var f = new Uint8Array(d);
            if (g) for (var l = 0; l < d; l++) f[l] = g;
            a.push(f);
          }
          e = G.decoder;
          g = G.contextCache;
          l = -u(g, 'IADT', e);
          var r = 0;
          for (B = 0; B < h; ) {
            var w = u(g, 'IADT', e);
            l += w;
            w = u(g, 'IAFS', e);
            w = r += w;
            do {
              var E = 1 === p ? 0 : u(g, 'IAIT', e);
              f = p * l + E;
              E = t(g, e, k);
              var D = c && u(g, 'IARI', e);
              E = q[E];
              var F = E[0].length,
                H = E.length;
              if (D) {
                D = u(g, 'IARDW', e);
                var K = u(g, 'IARDH', e),
                  C = u(g, 'IARDX', e),
                  J = u(g, 'IARDY', e);
                F += D;
                H += K;
                E = n(F, H, z, E, (D >> 1) + C, (K >> 1) + J, !1, y, G);
              }
              D = f - (v & 1 ? 0 : H - 1);
              K = w - (v & 2 ? F - 1 : 0);
              if (m) {
                for (C = 0; C < H; C++)
                  if ((f = a[K + C])) {
                    var I = E[C];
                    var N = Math.min(d - D, F);
                    switch (A) {
                      case 0:
                        for (J = 0; J < N; J++) f[D + J] |= I[J];
                        break;
                      case 2:
                        for (J = 0; J < N; J++) f[D + J] ^= I[J];
                        break;
                      default:
                        throw new b('operator ' + A + ' is not supported');
                    }
                  }
                w += H - 1;
              } else {
                for (J = 0; J < H; J++)
                  if ((f = a[D + J]))
                    switch (((I = E[J]), A)) {
                      case 0:
                        for (C = 0; C < F; C++) f[K + C] |= I[C];
                        break;
                      case 2:
                        for (C = 0; C < F; C++) f[K + C] ^= I[C];
                        break;
                      default:
                        throw new b('operator ' + A + ' is not supported');
                    }
                w += F - 1;
              }
              B++;
              E = u(g, 'IADS', e);
              if (null === E) break;
              w += E + x;
            } while (1);
          }
          return a;
        }
        function h(b, c) {
          return {
            width: (0, a.readUint32)(b, c),
            height: (0, a.readUint32)(b, c + 4),
            x: (0, a.readUint32)(b, c + 8),
            y: (0, a.readUint32)(b, c + 12),
            combinationOperator: b[c + 16] & 7,
          };
        }
        function p() {}
        function A() {}
        m.prototype = {
          getContexts: function(a) {
            return a in this ? this[a] : (this[a] = new Int8Array(65536));
          },
        };
        d.prototype = {
          get decoder() {
            var b = new k.ArithmeticDecoder(this.data, this.start, this.end);
            return (0, a.shadow)(this, 'decoder', b);
          },
          get contextCache() {
            var b = new m();
            return (0, a.shadow)(this, 'contextCache', b);
          },
        };
        var c = [
            'SymbolDictionary',
            null,
            null,
            null,
            'IntermediateTextRegion',
            null,
            'ImmediateTextRegion',
            'ImmediateLosslessTextRegion',
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            'PatternDictionary',
            null,
            null,
            null,
            'IntermediateHalftoneRegion',
            null,
            'ImmediateHalftoneRegion',
            'ImmediateLosslessHalftoneRegion',
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            'IntermediateGenericRegion',
            null,
            'ImmediateGenericRegion',
            'ImmediateLosslessGenericRegion',
            'IntermediateGenericRefinementRegion',
            null,
            'ImmediateGenericRefinementRegion',
            'ImmediateLosslessGenericRefinementRegion',
            null,
            null,
            null,
            null,
            'PageInformation',
            'EndOfPage',
            'EndOfStripe',
            'EndOfFile',
            'Profiles',
            'Tables',
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            'Extension',
          ],
          q = [
            [
              { x: -1, y: -2 },
              { x: 0, y: -2 },
              { x: 1, y: -2 },
              { x: -2, y: -1 },
              { x: -1, y: -1 },
              { x: 0, y: -1 },
              { x: 1, y: -1 },
              { x: 2, y: -1 },
              { x: -4, y: 0 },
              { x: -3, y: 0 },
              { x: -2, y: 0 },
              { x: -1, y: 0 },
            ],
            [
              { x: -1, y: -2 },
              { x: 0, y: -2 },
              { x: 1, y: -2 },
              { x: 2, y: -2 },
              { x: -2, y: -1 },
              { x: -1, y: -1 },
              { x: 0, y: -1 },
              { x: 1, y: -1 },
              { x: 2, y: -1 },
              { x: -3, y: 0 },
              { x: -2, y: 0 },
              { x: -1, y: 0 },
            ],
            [
              { x: -1, y: -2 },
              { x: 0, y: -2 },
              { x: 1, y: -2 },
              { x: -2, y: -1 },
              { x: -1, y: -1 },
              { x: 0, y: -1 },
              { x: 1, y: -1 },
              { x: -2, y: 0 },
              { x: -1, y: 0 },
            ],
            [
              { x: -3, y: -1 },
              { x: -2, y: -1 },
              { x: -1, y: -1 },
              { x: 0, y: -1 },
              { x: 1, y: -1 },
              { x: -4, y: 0 },
              { x: -3, y: 0 },
              { x: -2, y: 0 },
              { x: -1, y: 0 },
            ],
          ],
          x = [
            {
              coding: [
                { x: 0, y: -1 },
                { x: 1, y: -1 },
                { x: -1, y: 0 },
              ],
              reference: [
                { x: 0, y: -1 },
                { x: 1, y: -1 },
                { x: -1, y: 0 },
                { x: 0, y: 0 },
                { x: 1, y: 0 },
                { x: -1, y: 1 },
                { x: 0, y: 1 },
                { x: 1, y: 1 },
              ],
            },
            {
              coding: [
                { x: -1, y: -1 },
                { x: 0, y: -1 },
                { x: 1, y: -1 },
                { x: -1, y: 0 },
              ],
              reference: [
                { x: 0, y: -1 },
                { x: -1, y: 0 },
                { x: 0, y: 0 },
                { x: 1, y: 0 },
                { x: 0, y: 1 },
                { x: 1, y: 1 },
              ],
            },
          ],
          g = [39717, 1941, 229, 405],
          G = [32, 8];
        p.prototype = {
          onPageInformation: function(a) {
            this.currentPageInfo = a;
            var b = new Uint8ClampedArray(((a.width + 7) >> 3) * a.height);
            if (a.defaultPixelValue) {
              a = 0;
              for (var c = b.length; a < c; a++) b[a] = 255;
            }
            this.buffer = b;
          },
          drawBitmap: function(a, c) {
            var d = this.currentPageInfo,
              e = a.width,
              g = a.height,
              l = (d.width + 7) >> 3,
              h = d.combinationOperatorOverride ? a.combinationOperator : d.combinationOperator;
            d = this.buffer;
            var n = 128 >> (a.x & 7),
              p = a.y * l + (a.x >> 3),
              q;
            switch (h) {
              case 0:
                for (h = 0; h < g; h++) {
                  var k = n;
                  var m = p;
                  for (q = 0; q < e; q++) c[h][q] && (d[m] |= k), (k >>= 1), k || ((k = 128), m++);
                  p += l;
                }
                break;
              case 2:
                for (h = 0; h < g; h++) {
                  k = n;
                  m = p;
                  for (q = 0; q < e; q++) c[h][q] && (d[m] ^= k), (k >>= 1), k || ((k = 128), m++);
                  p += l;
                }
                break;
              default:
                throw new b('operator ' + h + ' is not supported');
            }
          },
          onImmediateGenericRegion: function(a, b, c, e) {
            var f = a.info;
            b = new d(b, c, e);
            a = B(a.mmr, f.width, f.height, a.template, a.prediction, null, a.at, b);
            this.drawBitmap(f, a);
          },
          onImmediateLosslessGenericRegion: function() {
            this.onImmediateGenericRegion.apply(this, arguments);
          },
          onSymbolDictionary: function(c, g, f, h, p, q) {
            if (c.huffman) throw new b('huffman is not supported');
            var l = this.symbols;
            l || (this.symbols = l = {});
            for (var k = [], m = 0, r = f.length; m < r; m++) k = k.concat(l[f[m]]);
            q = new d(h, p, q);
            m = c.huffman;
            r = c.refinement;
            f = k;
            k = c.numberOfNewSymbols;
            var x = c.template,
              v = c.at,
              A = c.refinementTemplate,
              D = c.refinementAt;
            if (m) throw new b('huffman is not supported');
            c = [];
            var z = 0,
              C = (0, a.log2)(f.length + k);
            h = q.decoder;
            for (p = q.contextCache; c.length < k; ) {
              var y = u(p, 'IADH', h);
              z += y;
              for (y = 0; ; ) {
                var G = u(p, 'IADW', h);
                if (null === G) break;
                y += G;
                if (r)
                  if (((G = u(p, 'IAAI', h)), 1 < G))
                    G = e(m, r, y, z, 0, G, 1, f.concat(c), C, 0, 0, 1, 0, void 0, A, D, q);
                  else {
                    G = t(p, h, C);
                    var J = u(p, 'IARDX', h),
                      L = u(p, 'IARDY', h);
                    G = n(y, z, A, G < f.length ? f[G] : c[G - f.length], J, L, !1, D, q);
                  }
                else G = B(!1, y, z, x, !1, null, v, q);
                c.push(G);
              }
            }
            q = [];
            m = [];
            r = !1;
            for (x = f.length + k; m.length < x; ) {
              for (v = u(p, 'IAEX', h); v--; ) m.push(r);
              r = !r;
            }
            h = 0;
            for (p = f.length; h < p; h++) m[h] && q.push(f[h]);
            for (f = 0; f < k; h++, f++) m[h] && q.push(c[f]);
            l[g] = q;
          },
          onImmediateTextRegion: function(b, c, f, g, h) {
            for (var l = b.info, n = this.symbols, p = [], q = 0, k = c.length; q < k; q++) p = p.concat(n[c[q]]);
            c = (0, a.log2)(p.length);
            f = new d(f, g, h);
            b = e(
              b.huffman,
              b.refinement,
              l.width,
              l.height,
              b.defaultPixelValue,
              b.numberOfSymbolInstances,
              b.stripSize,
              p,
              c,
              b.transposed,
              b.dsOffset,
              b.referenceCorner,
              b.combinationOperator,
              void 0,
              b.refinementTemplate,
              b.refinementAt,
              f,
            );
            this.drawBitmap(l, b);
          },
          onImmediateLosslessTextRegion: function() {
            this.onImmediateTextRegion.apply(this, arguments);
          },
          onPatternDictionary: function(a, b, c, e, g) {
            var f = this.patterns;
            f || (this.patterns = f = {});
            var h = new d(c, e, g),
              l = a.mmr;
            c = a.patternWidth;
            e = a.patternHeight;
            g = a.maxPatternIndex;
            a = a.template;
            var n = [];
            n.push({ x: -c, y: 0 });
            0 === a && (n.push({ x: -3, y: -1 }), n.push({ x: 2, y: -2 }), n.push({ x: -2, y: -2 }));
            a = B(l, (g + 1) * c, e, a, !1, null, n, h);
            h = [];
            l = 0;
            for (var p, q, k; l <= g; ) {
              n = [];
              p = c * l;
              q = p + c;
              for (k = 0; k < e; k++) n.push(a[k].subarray(p, q));
              h.push(n);
              l++;
            }
            f[b] = h;
          },
          onImmediateHalftoneRegion: function(c, e, g, h, n) {
            e = this.patterns[e[0]];
            var f = c.info,
              l = new d(g, h, n),
              p = c.mmr,
              q = c.template;
            g = f.width;
            h = f.height;
            var k = c.defaultPixelValue,
              m = c.combinationOperator;
            n = c.gridWidth;
            var r = c.gridHeight,
              x = c.gridOffsetX,
              v = c.gridOffsetY,
              u = c.gridVectorX,
              A = c.gridVectorY;
            if (c.enableSkip) throw new b('skip is not supported');
            if (0 !== m) throw new b('operator ' + m + ' is not supported in halftone region');
            c = [];
            var t, D;
            for (t = 0; t < h; t++) {
              m = new Uint8Array(g);
              if (k) for (D = 0; D < g; D++) m[D] = k;
              c.push(m);
            }
            t = e.length;
            m = e[0];
            k = m[0].length;
            m = m.length;
            var z = (0, a.log2)(t);
            D = [];
            D.push({ x: 1 >= q ? 3 : 2, y: -1 });
            0 === q && (D.push({ x: -3, y: -1 }), D.push({ x: 2, y: -2 }), D.push({ x: -2, y: -2 }));
            var G = [];
            for (t = z - 1; 0 <= t; t--) G[t] = B(p, n, r, q, !1, null, D, l);
            for (l = 0; l < r; l++)
              for (p = 0; p < n; p++) {
                q = t = 0;
                for (D = z - 1; 0 <= D; D--) (t ^= G[D][l][p]), (q |= t << D);
                q = e[q];
                var y = (x + l * A + p * u) >> 8;
                var C = (v + l * u - p * A) >> 8;
                if (0 <= y && y + k <= g && 0 <= C && C + m <= h)
                  for (t = 0; t < m; t++) {
                    var J = c[C + t];
                    var T = q[t];
                    for (D = 0; D < k; D++) J[y + D] |= T[D];
                  }
                else
                  for (t = 0; t < m; t++)
                    if (((D = C + t), !(0 > D || D >= h)))
                      for (J = c[D], T = q[t], D = 0; D < k; D++) {
                        var S = y + D;
                        0 <= S && S < g && (J[S] |= T[D]);
                      }
              }
            this.drawBitmap(f, c);
          },
          onImmediateLosslessHalftoneRegion: function() {
            this.onImmediateHalftoneRegion.apply(this, arguments);
          },
        };
        A.prototype = {
          parseChunks: function(d) {
            for (var e = new p(), g = 0, l = d.length; g < l; g++) {
              for (var n = d[g], q = {}, k = n.data, m = n.end, x = [], v = n.start; v < m; ) {
                n = k;
                var u = v;
                v = {};
                v.number = (0, a.readUint32)(n, u);
                var A = n[u + 4];
                var t = A & 63;
                if (!c[t]) throw new b('invalid segment type: ' + t);
                v.type = t;
                v.typeName = c[t];
                v.deferredNonRetain = !!(A & 128);
                A = !!(A & 64);
                var B = n[u + 5],
                  z = (B >> 5) & 7;
                var y = [B & 31];
                u += 6;
                if (7 === B)
                  for (z = (0, a.readUint32)(n, u - 1) & 536870911, u += 3, B = (z + 7) >> 3, y[0] = n[u++]; 0 < --B; )
                    y.push(n[u++]);
                else if (5 === B || 6 === B) throw new b('invalid referred-to flags');
                v.retainBits = y;
                B = 256 >= v.number ? 1 : 65536 >= v.number ? 2 : 4;
                var G = [];
                for (y = 0; y < z; y++) {
                  var C = 1 === B ? n[u] : 2 === B ? (0, a.readUint16)(n, u) : (0, a.readUint32)(n, u);
                  G.push(C);
                  u += B;
                }
                v.referredTo = G;
                A ? ((v.pageAssociation = (0, a.readUint32)(n, u)), (u += 4)) : (v.pageAssociation = n[u++]);
                v.length = (0, a.readUint32)(n, u);
                u += 4;
                if (4294967295 === v.length)
                  if (38 === t) {
                    A = h(n, u);
                    z = !!(n[u + 17] & 1);
                    t = new Uint8Array(6);
                    z || ((t[0] = 255), (t[1] = 172));
                    t[2] = (A.height >>> 24) & 255;
                    t[3] = (A.height >> 16) & 255;
                    t[4] = (A.height >> 8) & 255;
                    t[5] = A.height & 255;
                    y = u;
                    for (A = n.length; y < A; y++) {
                      for (z = 0; 6 > z && t[z] === n[y + z]; ) z++;
                      if (6 === z) {
                        v.length = y + 6;
                        break;
                      }
                    }
                    if (4294967295 === v.length) throw new b('segment end was not found');
                  } else throw new b('invalid unknown segment length');
                v.headerEnd = u;
                n = v;
                v = n.headerEnd;
                u = { header: n, data: k };
                q.randomAccess || ((u.start = v), (v += n.length), (u.end = v));
                x.push(u);
                if (51 === n.type) break;
              }
              if (q.randomAccess)
                for (q = 0, k = x.length; q < k; q++) (x[q].start = v), (v += x[q].header.length), (x[q].end = v);
              q = e;
              k = 0;
              for (m = x.length; k < m; k++) {
                z = void 0;
                A = x[k];
                n = q;
                v = A.header;
                u = A.data;
                t = A.start;
                A = A.end;
                switch (v.type) {
                  case 0:
                    G = {};
                    z = (0, a.readUint16)(u, t);
                    G.huffman = !!(z & 1);
                    G.refinement = !!(z & 2);
                    G.huffmanDHSelector = (z >> 2) & 3;
                    G.huffmanDWSelector = (z >> 4) & 3;
                    G.bitmapSizeSelector = (z >> 6) & 1;
                    G.aggregationInstancesSelector = (z >> 7) & 1;
                    G.bitmapCodingContextUsed = !!(z & 256);
                    G.bitmapCodingContextRetained = !!(z & 512);
                    G.template = (z >> 10) & 3;
                    G.refinementTemplate = (z >> 12) & 1;
                    t += 2;
                    if (!G.huffman) {
                      B = 0 === G.template ? 4 : 1;
                      y = [];
                      for (z = 0; z < B; z++)
                        y.push({ x: (0, a.readInt8)(u, t), y: (0, a.readInt8)(u, t + 1) }), (t += 2);
                      G.at = y;
                    }
                    if (G.refinement && !G.refinementTemplate) {
                      y = [];
                      for (z = 0; 2 > z; z++)
                        y.push({ x: (0, a.readInt8)(u, t), y: (0, a.readInt8)(u, t + 1) }), (t += 2);
                      G.refinementAt = y;
                    }
                    G.numberOfExportedSymbols = (0, a.readUint32)(u, t);
                    t += 4;
                    G.numberOfNewSymbols = (0, a.readUint32)(u, t);
                    z = [G, v.number, v.referredTo, u, t + 4, A];
                    break;
                  case 6:
                  case 7:
                    B = {};
                    B.info = h(u, t);
                    t += 17;
                    z = (0, a.readUint16)(u, t);
                    t += 2;
                    B.huffman = !!(z & 1);
                    B.refinement = !!(z & 2);
                    B.stripSize = 1 << ((z >> 2) & 3);
                    B.referenceCorner = (z >> 4) & 3;
                    B.transposed = !!(z & 64);
                    B.combinationOperator = (z >> 7) & 3;
                    B.defaultPixelValue = (z >> 9) & 1;
                    B.dsOffset = (z << 17) >> 27;
                    B.refinementTemplate = (z >> 15) & 1;
                    B.huffman &&
                      ((z = (0, a.readUint16)(u, t)),
                      (t += 2),
                      (B.huffmanFS = z & 3),
                      (B.huffmanDS = (z >> 2) & 3),
                      (B.huffmanDT = (z >> 4) & 3),
                      (B.huffmanRefinementDW = (z >> 6) & 3),
                      (B.huffmanRefinementDH = (z >> 8) & 3),
                      (B.huffmanRefinementDX = (z >> 10) & 3),
                      (B.huffmanRefinementDY = (z >> 12) & 3),
                      (B.huffmanRefinementSizeSelector = !!(z & 14)));
                    if (B.refinement && !B.refinementTemplate) {
                      y = [];
                      for (z = 0; 2 > z; z++)
                        y.push({ x: (0, a.readInt8)(u, t), y: (0, a.readInt8)(u, t + 1) }), (t += 2);
                      B.refinementAt = y;
                    }
                    B.numberOfSymbolInstances = (0, a.readUint32)(u, t);
                    t += 4;
                    if (B.huffman) throw new b('huffman is not supported');
                    z = [B, v.referredTo, u, t, A];
                    break;
                  case 16:
                    z = {};
                    y = u[t++];
                    z.mmr = !!(y & 1);
                    z.template = (y >> 1) & 3;
                    z.patternWidth = u[t++];
                    z.patternHeight = u[t++];
                    z.maxPatternIndex = (0, a.readUint32)(u, t);
                    z = [z, v.number, u, t + 4, A];
                    break;
                  case 22:
                  case 23:
                    z = {};
                    z.info = h(u, t);
                    t += 17;
                    y = u[t++];
                    z.mmr = !!(y & 1);
                    z.template = (y >> 1) & 3;
                    z.enableSkip = !!(y & 8);
                    z.combinationOperator = (y >> 4) & 7;
                    z.defaultPixelValue = (y >> 7) & 1;
                    z.gridWidth = (0, a.readUint32)(u, t);
                    t += 4;
                    z.gridHeight = (0, a.readUint32)(u, t);
                    t += 4;
                    z.gridOffsetX = (0, a.readUint32)(u, t) & 4294967295;
                    t += 4;
                    z.gridOffsetY = (0, a.readUint32)(u, t) & 4294967295;
                    t += 4;
                    z.gridVectorX = (0, a.readUint16)(u, t);
                    t += 2;
                    z.gridVectorY = (0, a.readUint16)(u, t);
                    z = [z, v.referredTo, u, t + 2, A];
                    break;
                  case 38:
                  case 39:
                    G = {};
                    G.info = h(u, t);
                    t += 17;
                    z = u[t++];
                    G.mmr = !!(z & 1);
                    G.template = (z >> 1) & 3;
                    G.prediction = !!(z & 8);
                    if (!G.mmr) {
                      B = 0 === G.template ? 4 : 1;
                      y = [];
                      for (z = 0; z < B; z++)
                        y.push({ x: (0, a.readInt8)(u, t), y: (0, a.readInt8)(u, t + 1) }), (t += 2);
                      G.at = y;
                    }
                    z = [G, u, t, A];
                    break;
                  case 48:
                    A = {
                      width: (0, a.readUint32)(u, t),
                      height: (0, a.readUint32)(u, t + 4),
                      resolutionX: (0, a.readUint32)(u, t + 8),
                      resolutionY: (0, a.readUint32)(u, t + 12),
                    };
                    4294967295 === A.height && delete A.height;
                    z = u[t + 16];
                    (0, a.readUint16)(u, t + 17);
                    A.lossless = !!(z & 1);
                    A.refinement = !!(z & 2);
                    A.defaultPixelValue = (z >> 2) & 1;
                    A.combinationOperator = (z >> 3) & 3;
                    A.requiresBuffer = !!(z & 32);
                    A.combinationOperatorOverride = !!(z & 64);
                    z = [A];
                    break;
                  case 49:
                    break;
                  case 50:
                    break;
                  case 51:
                    break;
                  case 62:
                    break;
                  default:
                    throw new b('segment type ' + v.typeName + '(' + v.type + ') is not implemented');
                }
                v = 'on' + v.typeName;
                v in n && n[v].apply(n, z);
              }
            }
            return e.buffer;
          },
        };
        return A;
      })();
      m.Jbig2Image = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.JpegImage = void 0;
      var a =
          'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
            ? function(a) {
                return typeof a;
              }
            : function(a) {
                return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                  ? 'symbol'
                  : typeof a;
              },
        k = t(0),
        b = (function() {
          function a(a) {
            this.message = 'JPEG error: ' + a;
          }
          a.prototype = Error();
          a.prototype.name = 'JpegError';
          return (a.constructor = a);
        })();
      y = (function() {
        function m() {
          this.decodeTransform = null;
          this.colorTransform = -1;
        }
        function d(a, b) {
          for (var d = 0, e = [], n, c, q = 16; 0 < q && !a[q - 1]; ) q--;
          e.push({ children: [], index: 0 });
          var k = e[0],
            g;
          for (n = 0; n < q; n++) {
            for (c = 0; c < a[n]; c++) {
              k = e.pop();
              for (k.children[k.index] = b[d]; 0 < k.index; ) k = e.pop();
              k.index++;
              for (e.push(k); e.length <= n; )
                e.push((g = { children: [], index: 0 })), (k.children[k.index] = g.children), (k = g);
              d++;
            }
            n + 1 < q && (e.push((g = { children: [], index: 0 })), (k.children[k.index] = g.children), (k = g));
          }
          return e[0].children;
        }
        function u(d, e, h, p, m, c, q, x, g) {
          function n() {
            if (0 < H) return H--, (C >> H) & 1;
            C = d[e++];
            if (255 === C) {
              var a = d[e++];
              if (a) throw new b('unexpected marker ' + ((C << 8) | a).toString(16));
            }
            H = 7;
            return C >>> 7;
          }
          function l(c) {
            for (;;) {
              c = c[n()];
              if ('number' === typeof c) return c;
              if ('object' !== ('undefined' === typeof c ? 'undefined' : a(c))) throw new b('invalid huffman sequence');
            }
          }
          function u(a) {
            for (var b = 0; 0 < a; ) (b = (b << 1) | n()), a--;
            return b;
          }
          function f(a) {
            if (1 === a) return 1 === n() ? 1 : -1;
            var b = u(a);
            return b >= 1 << (a - 1) ? b : b + (-1 << a) + 1;
          }
          function r(a, b) {
            var c = l(a.huffmanTableDC);
            c = 0 === c ? 0 : f(c);
            a.blockData[b] = a.pred += c;
            for (c = 1; 64 > c; ) {
              var d = l(a.huffmanTableAC),
                e = d & 15;
              d >>= 4;
              if (0 === e) {
                if (15 > d) break;
                c += 16;
              } else (c += d), (a.blockData[b + B[c]] = f(e)), c++;
            }
          }
          function v(a, b) {
            var c = l(a.huffmanTableDC);
            c = 0 === c ? 0 : f(c) << g;
            a.blockData[b] = a.pred += c;
          }
          function t(a, b) {
            a.blockData[b] |= n() << g;
          }
          function A(a, b) {
            if (0 < M) M--;
            else
              for (var d = c; d <= q; ) {
                var e = l(a.huffmanTableAC),
                  h = e & 15;
                e >>= 4;
                if (0 === h) {
                  if (15 > e) {
                    M = u(e) + (1 << e) - 1;
                    break;
                  }
                  d += 16;
                } else (d += e), (a.blockData[b + B[d]] = f(h) * (1 << g)), d++;
              }
          }
          function w(a, d) {
            for (var e = c, h = 0, p; e <= q; ) {
              p = B[e];
              switch (O) {
                case 0:
                  h = l(a.huffmanTableAC);
                  p = h & 15;
                  h >>= 4;
                  if (0 === p) 15 > h ? ((M = u(h) + (1 << h)), (O = 4)) : ((h = 16), (O = 1));
                  else {
                    if (1 !== p) throw new b('invalid ACn encoding');
                    N = f(p);
                    O = h ? 2 : 3;
                  }
                  continue;
                case 1:
                case 2:
                  a.blockData[d + p] ? (a.blockData[d + p] += n() << g) : (h--, 0 === h && (O = 2 === O ? 3 : 0));
                  break;
                case 3:
                  a.blockData[d + p] ? (a.blockData[d + p] += n() << g) : ((a.blockData[d + p] = N << g), (O = 0));
                  break;
                case 4:
                  a.blockData[d + p] && (a.blockData[d + p] += n() << g);
              }
              e++;
            }
            4 === O && (M--, 0 === M && (O = 0));
          }
          var z = h.mcusPerLine,
            F = e,
            C = 0,
            H = 0,
            M = 0,
            O = 0,
            N,
            da = p.length,
            W,
            Z,
            ea,
            aa;
          x = h.progressive ? (0 === c ? (0 === x ? v : t) : 0 === x ? A : w) : r;
          var X = 0;
          h = 1 === da ? p[0].blocksPerLine * p[0].blocksPerColumn : z * h.mcusPerColumn;
          for (var ba, ca; X < h; ) {
            var T = m ? Math.min(h - X, m) : h;
            for (W = 0; W < da; W++) p[W].pred = 0;
            M = 0;
            if (1 === da) {
              var S = p[0];
              for (aa = 0; aa < T; aa++)
                x(S, 64 * ((S.blocksPerLine + 1) * ((X / S.blocksPerLine) | 0) + (X % S.blocksPerLine))), X++;
            } else
              for (aa = 0; aa < T; aa++) {
                for (W = 0; W < da; W++)
                  for (S = p[W], ba = S.h, ca = S.v, Z = 0; Z < ca; Z++)
                    for (ea = 0; ea < ba; ea++)
                      x(S, 64 * ((S.blocksPerLine + 1) * (((X / z) | 0) * S.v + Z) + ((X % z) * S.h + ea)));
                X++;
              }
            H = 0;
            (S = y(d, e)) &&
              S.invalid &&
              ((0, k.warn)('decodeScan - unexpected MCU data, next marker is: ' + S.invalid), (e = S.offset));
            S = S && S.marker;
            if (!S || 65280 >= S) throw new b('marker was not found');
            if (65488 <= S && 65495 >= S) e += 2;
            else break;
          }
          (S = y(d, e)) &&
            S.invalid &&
            ((0, k.warn)('decodeScan - unexpected Scan data, next marker is: ' + S.invalid), (e = S.offset));
          return e - F;
        }
        function t(a, d) {
          for (var e = d.blocksPerLine, n = d.blocksPerColumn, k = new Int16Array(64), c = 0; c < n; c++)
            for (var q = 0; q < e; q++) {
              var m = 64 * ((d.blocksPerLine + 1) * c + q),
                g = k,
                u = d.quantizationTable,
                l = d.blockData;
              if (!u) throw new b('missing required Quantization Table.');
              for (var v = 0; 64 > v; v += 8) {
                var f = l[m + v];
                var r = l[m + v + 1];
                var t = l[m + v + 2];
                var B = l[m + v + 3];
                var z = l[m + v + 4];
                var w = l[m + v + 5];
                var E = l[m + v + 6];
                var F = l[m + v + 7];
                f *= u[v];
                if (0 === (r | t | B | z | w | E | F))
                  (f = (5793 * f + 512) >> 10),
                    (g[v] = f),
                    (g[v + 1] = f),
                    (g[v + 2] = f),
                    (g[v + 3] = f),
                    (g[v + 4] = f),
                    (g[v + 5] = f),
                    (g[v + 6] = f),
                    (g[v + 7] = f);
                else {
                  r *= u[v + 1];
                  t *= u[v + 2];
                  B *= u[v + 3];
                  z *= u[v + 4];
                  w *= u[v + 5];
                  E *= u[v + 6];
                  F *= u[v + 7];
                  var y = (5793 * f + 128) >> 8;
                  var C = (5793 * z + 128) >> 8;
                  var M = t;
                  var O = E;
                  z = (2896 * (r - F) + 128) >> 8;
                  F = (2896 * (r + F) + 128) >> 8;
                  B <<= 4;
                  w <<= 4;
                  y = (y + C + 1) >> 1;
                  C = y - C;
                  f = (3784 * M + 1567 * O + 128) >> 8;
                  M = (1567 * M - 3784 * O + 128) >> 8;
                  O = f;
                  z = (z + w + 1) >> 1;
                  w = z - w;
                  F = (F + B + 1) >> 1;
                  B = F - B;
                  y = (y + O + 1) >> 1;
                  O = y - O;
                  C = (C + M + 1) >> 1;
                  M = C - M;
                  f = (2276 * z + 3406 * F + 2048) >> 12;
                  z = (3406 * z - 2276 * F + 2048) >> 12;
                  F = f;
                  f = (799 * B + 4017 * w + 2048) >> 12;
                  B = (4017 * B - 799 * w + 2048) >> 12;
                  w = f;
                  g[v] = y + F;
                  g[v + 7] = y - F;
                  g[v + 1] = C + w;
                  g[v + 6] = C - w;
                  g[v + 2] = M + B;
                  g[v + 5] = M - B;
                  g[v + 3] = O + z;
                  g[v + 4] = O - z;
                }
              }
              for (u = 0; 8 > u; ++u)
                (f = g[u]),
                  (r = g[u + 8]),
                  (t = g[u + 16]),
                  (B = g[u + 24]),
                  (z = g[u + 32]),
                  (w = g[u + 40]),
                  (E = g[u + 48]),
                  (F = g[u + 56]),
                  0 === (r | t | B | z | w | E | F)
                    ? ((f = (5793 * f + 8192) >> 14),
                      (f = -2040 > f ? 0 : 2024 <= f ? 255 : (f + 2056) >> 4),
                      (l[m + u] = f),
                      (l[m + u + 8] = f),
                      (l[m + u + 16] = f),
                      (l[m + u + 24] = f),
                      (l[m + u + 32] = f),
                      (l[m + u + 40] = f),
                      (l[m + u + 48] = f),
                      (l[m + u + 56] = f))
                    : ((y = (5793 * f + 2048) >> 12),
                      (C = (5793 * z + 2048) >> 12),
                      (M = t),
                      (O = E),
                      (z = (2896 * (r - F) + 2048) >> 12),
                      (F = (2896 * (r + F) + 2048) >> 12),
                      (y = ((y + C + 1) >> 1) + 4112),
                      (C = y - C),
                      (f = (3784 * M + 1567 * O + 2048) >> 12),
                      (M = (1567 * M - 3784 * O + 2048) >> 12),
                      (O = f),
                      (z = (z + w + 1) >> 1),
                      (w = z - w),
                      (F = (F + B + 1) >> 1),
                      (B = F - B),
                      (y = (y + O + 1) >> 1),
                      (O = y - O),
                      (C = (C + M + 1) >> 1),
                      (M = C - M),
                      (f = (2276 * z + 3406 * F + 2048) >> 12),
                      (z = (3406 * z - 2276 * F + 2048) >> 12),
                      (F = f),
                      (f = (799 * B + 4017 * w + 2048) >> 12),
                      (B = (4017 * B - 799 * w + 2048) >> 12),
                      (w = f),
                      (f = y + F),
                      (F = y - F),
                      (r = C + w),
                      (E = C - w),
                      (t = M + B),
                      (w = M - B),
                      (B = O + z),
                      (z = O - z),
                      (f = 16 > f ? 0 : 4080 <= f ? 255 : f >> 4),
                      (r = 16 > r ? 0 : 4080 <= r ? 255 : r >> 4),
                      (t = 16 > t ? 0 : 4080 <= t ? 255 : t >> 4),
                      (B = 16 > B ? 0 : 4080 <= B ? 255 : B >> 4),
                      (z = 16 > z ? 0 : 4080 <= z ? 255 : z >> 4),
                      (w = 16 > w ? 0 : 4080 <= w ? 255 : w >> 4),
                      (E = 16 > E ? 0 : 4080 <= E ? 255 : E >> 4),
                      (F = 16 > F ? 0 : 4080 <= F ? 255 : F >> 4),
                      (l[m + u] = f),
                      (l[m + u + 8] = r),
                      (l[m + u + 16] = t),
                      (l[m + u + 24] = B),
                      (l[m + u + 32] = z),
                      (l[m + u + 40] = w),
                      (l[m + u + 48] = E),
                      (l[m + u + 56] = F));
            }
          return d.blockData;
        }
        function y(a, b, d) {
          var e = a.length - 1;
          d = d < b ? d : b;
          if (b >= e) return null;
          var h = (a[b] << 8) | a[b + 1];
          if (65472 <= h && 65534 >= h) return { invalid: null, marker: h, offset: b };
          for (b = (a[d] << 8) | a[d + 1]; !(65472 <= b && 65534 >= b); ) {
            if (++d >= e) return null;
            b = (a[d] << 8) | a[d + 1];
          }
          return { invalid: h.toString(16), marker: b, offset: d };
        }
        var B = new Uint8Array([
          0,
          1,
          8,
          16,
          9,
          2,
          3,
          10,
          17,
          24,
          32,
          25,
          18,
          11,
          4,
          5,
          12,
          19,
          26,
          33,
          40,
          48,
          41,
          34,
          27,
          20,
          13,
          6,
          7,
          14,
          21,
          28,
          35,
          42,
          49,
          56,
          57,
          50,
          43,
          36,
          29,
          22,
          15,
          23,
          30,
          37,
          44,
          51,
          58,
          59,
          52,
          45,
          38,
          31,
          39,
          46,
          53,
          60,
          61,
          54,
          47,
          55,
          62,
          63,
        ]);
        m.prototype = {
          parse: function(a) {
            function e() {
              var b = (a[m] << 8) | a[m + 1];
              m += 2;
              return b;
            }
            function h() {
              var b = e();
              b = m + b - 2;
              var c = y(a, b, m);
              c &&
                c.invalid &&
                ((0, k.warn)('readDataBlock - incorrect length, next marker is: ' + c.invalid), (b = c.offset));
              b = a.subarray(m, b);
              m += b.length;
              return b;
            }
            function n(a) {
              for (
                var b = Math.ceil(a.samplesPerLine / 8 / a.maxH), c = Math.ceil(a.scanLines / 8 / a.maxV), d = 0;
                d < a.components.length;
                d++
              ) {
                F = a.components[d];
                var e = Math.ceil((Math.ceil(a.samplesPerLine / 8) * F.h) / a.maxH),
                  g = Math.ceil((Math.ceil(a.scanLines / 8) * F.v) / a.maxV);
                F.blockData = new Int16Array(64 * c * F.v * (b * F.h + 1));
                F.blocksPerLine = e;
                F.blocksPerColumn = g;
              }
              a.mcusPerLine = b;
              a.mcusPerColumn = c;
            }
            var m = 0,
              c = null,
              q = null,
              v = [],
              g = [],
              z = [],
              l = e();
            if (65496 !== l) throw new b('SOI not found');
            for (l = e(); 65497 !== l; ) {
              switch (l) {
                case 65504:
                case 65505:
                case 65506:
                case 65507:
                case 65508:
                case 65509:
                case 65510:
                case 65511:
                case 65512:
                case 65513:
                case 65514:
                case 65515:
                case 65516:
                case 65517:
                case 65518:
                case 65519:
                case 65534:
                  var C = h();
                  65504 === l &&
                    74 === C[0] &&
                    70 === C[1] &&
                    73 === C[2] &&
                    70 === C[3] &&
                    0 === C[4] &&
                    (c = {
                      version: { major: C[5], minor: C[6] },
                      densityUnits: C[7],
                      xDensity: (C[8] << 8) | C[9],
                      yDensity: (C[10] << 8) | C[11],
                      thumbWidth: C[12],
                      thumbHeight: C[13],
                      thumbData: C.subarray(14, 14 + 3 * C[12] * C[13]),
                    });
                  65518 === l &&
                    65 === C[0] &&
                    100 === C[1] &&
                    111 === C[2] &&
                    98 === C[3] &&
                    101 === C[4] &&
                    (q = {
                      version: (C[5] << 8) | C[6],
                      flags0: (C[7] << 8) | C[8],
                      flags1: (C[9] << 8) | C[10],
                      transformCode: C[11],
                    });
                  break;
                case 65499:
                  l = e() + m - 2;
                  for (var f; m < l; ) {
                    var r = a[m++],
                      D = new Uint16Array(64);
                    if (0 === r >> 4) for (C = 0; 64 > C; C++) (f = B[C]), (D[f] = a[m++]);
                    else if (1 === r >> 4) for (C = 0; 64 > C; C++) (f = B[C]), (D[f] = e());
                    else throw new b('DQT - invalid table spec');
                    v[r & 15] = D;
                  }
                  break;
                case 65472:
                case 65473:
                case 65474:
                  if (L) throw new b('Only single frame JPEGs supported');
                  e();
                  var L = {};
                  L.extended = 65473 === l;
                  L.progressive = 65474 === l;
                  L.precision = a[m++];
                  L.scanLines = e();
                  L.samplesPerLine = e();
                  L.components = [];
                  L.componentIds = {};
                  C = a[m++];
                  for (l = D = r = 0; l < C; l++) {
                    f = a[m];
                    var I = a[m + 1] >> 4;
                    var w = a[m + 1] & 15;
                    r < I && (r = I);
                    D < w && (D = w);
                    I = L.components.push({ h: I, v: w, quantizationId: a[m + 2], quantizationTable: null });
                    L.componentIds[f] = I - 1;
                    m += 3;
                  }
                  L.maxH = r;
                  L.maxV = D;
                  n(L);
                  break;
                case 65476:
                  f = e();
                  for (l = 2; l < f; ) {
                    r = a[m++];
                    D = new Uint8Array(16);
                    for (C = I = 0; 16 > C; C++, m++) I += D[C] = a[m];
                    w = new Uint8Array(I);
                    for (C = 0; C < I; C++, m++) w[C] = a[m];
                    l += 17 + I;
                    (0 === r >> 4 ? z : g)[r & 15] = d(D, w);
                  }
                  break;
                case 65501:
                  e();
                  var E = e();
                  break;
                case 65498:
                  e();
                  f = a[m++];
                  C = [];
                  for (l = 0; l < f; l++) {
                    r = L.componentIds[a[m++]];
                    var F = L.components[r];
                    r = a[m++];
                    F.huffmanTableDC = z[r >> 4];
                    F.huffmanTableAC = g[r & 15];
                    C.push(F);
                  }
                  l = a[m++];
                  f = a[m++];
                  r = a[m++];
                  l = u(a, m, L, C, E, l, f, r >> 4, r & 15);
                  m += l;
                  break;
                case 65535:
                  255 !== a[m] && m--;
                  break;
                default:
                  if (255 === a[m - 3] && 192 <= a[m - 2] && 254 >= a[m - 2]) m -= 3;
                  else throw new b('unknown marker ' + l.toString(16));
              }
              l = e();
            }
            this.width = L.samplesPerLine;
            this.height = L.scanLines;
            this.jfif = c;
            this.adobe = q;
            this.components = [];
            for (l = 0; l < L.components.length; l++) {
              F = L.components[l];
              if ((c = v[F.quantizationId])) F.quantizationTable = c;
              this.components.push({
                output: t(L, F),
                scaleX: F.h / L.maxH,
                scaleY: F.v / L.maxV,
                blocksPerLine: F.blocksPerLine,
                blocksPerColumn: F.blocksPerColumn,
              });
            }
            this.numComponents = this.components.length;
          },
          _getLinearizedBlockData: function(a, b) {
            var d = this.width / a,
              e = this.height / b,
              n,
              c,
              q = this.components.length,
              k = a * b * q,
              g = new Uint8ClampedArray(k),
              m = new Uint32Array(a);
            for (c = 0; c < q; c++) {
              var l = this.components[c];
              var u = l.scaleX * d;
              var f = l.scaleY * e;
              var r = c;
              var v = l.output;
              var t = (l.blocksPerLine + 1) << 3;
              for (n = 0; n < a; n++) (l = 0 | (n * u)), (m[n] = ((l & 4294967288) << 3) | (l & 7));
              for (u = 0; u < b; u++)
                for (l = 0 | (u * f), l = (t * (l & 4294967288)) | ((l & 7) << 3), n = 0; n < a; n++)
                  (g[r] = v[l + m[n]]), (r += q);
            }
            if ((e = this.decodeTransform))
              for (c = 0; c < k; ) for (d = l = 0; l < q; l++, c++, d += 2) g[c] = ((g[c] * e[d]) >> 8) + e[d + 1];
            return g;
          },
          _isColorConversionNeeded: function() {
            return this.adobe
              ? !!this.adobe.transformCode
              : 3 === this.numComponents
              ? 0 === this.colorTransform
                ? !1
                : !0
              : 1 === this.colorTransform
              ? !0
              : !1;
          },
          _convertYccToRgb: function(a) {
            for (var b, d, n, k = 0, c = a.length; k < c; k += 3)
              (b = a[k]),
                (d = a[k + 1]),
                (n = a[k + 2]),
                (a[k] = b - 179.456 + 1.402 * n),
                (a[k + 1] = b + 135.459 - 0.344 * d - 0.714 * n),
                (a[k + 2] = b - 226.816 + 1.772 * d);
            return a;
          },
          _convertYcckToRgb: function(a) {
            for (var b, d, n, k, c = 0, q = 0, m = a.length; q < m; q += 4)
              (b = a[q]),
                (d = a[q + 1]),
                (n = a[q + 2]),
                (k = a[q + 3]),
                (a[c++] =
                  -122.67195406894 +
                  d *
                    (-6.60635669420364e-5 * d +
                      4.37130475926232e-4 * n -
                      5.4080610064599e-5 * b +
                      4.8449797120281e-4 * k -
                      0.154362151871126) +
                  n *
                    (-9.57964378445773e-4 * n + 8.17076911346625e-4 * b - 0.00477271405408747 * k + 1.53380253221734) +
                  b * (9.61250184130688e-4 * b - 0.00266257332283933 * k + 0.48357088451265) +
                  k * (-3.36197177618394e-4 * k + 0.484791561490776)),
                (a[c++] =
                  107.268039397724 +
                  d *
                    (2.19927104525741e-5 * d -
                      6.40992018297945e-4 * n +
                      6.59397001245577e-4 * b +
                      4.26105652938837e-4 * k -
                      0.176491792462875) +
                  n *
                    (-7.78269941513683e-4 * n + 0.00130872261408275 * b + 7.70482631801132e-4 * k - 0.151051492775562) +
                  b * (0.00126935368114843 * b - 0.00265090189010898 * k + 0.25802910206845) +
                  k * (-3.18913117588328e-4 * k - 0.213742400323665)),
                (a[c++] =
                  -20.810012546947 +
                  d *
                    (-5.70115196973677e-4 * d -
                      2.63409051004589e-5 * n +
                      0.0020741088115012 * b -
                      0.00288260236853442 * k +
                      0.814272968359295) +
                  n *
                    (-1.53496057440975e-5 * n - 1.32689043961446e-4 * b + 5.60833691242812e-4 * k - 0.195152027534049) +
                  b * (0.00174418132927582 * b - 0.00255243321439347 * k + 0.116935020465145) +
                  k * (-3.43531996510555e-4 * k + 0.24165260232407));
            return a;
          },
          _convertYcckToCmyk: function(a) {
            for (var b, d, n, k = 0, c = a.length; k < c; k += 4)
              (b = a[k]),
                (d = a[k + 1]),
                (n = a[k + 2]),
                (a[k] = 434.456 - b - 1.402 * n),
                (a[k + 1] = 119.541 - b + 0.344 * d + 0.714 * n),
                (a[k + 2] = 481.816 - b - 1.772 * d);
            return a;
          },
          _convertCmykToRgb: function(a) {
            for (var b, d, n, k, c = 0, q = 1 / 255, m = 0, g = a.length; m < g; m += 4)
              (b = a[m] * q),
                (d = a[m + 1] * q),
                (n = a[m + 2] * q),
                (k = a[m + 3] * q),
                (a[c++] =
                  255 +
                  b *
                    (-4.387332384609988 * b +
                      54.48615194189176 * d +
                      18.82290502165302 * n +
                      212.25662451639585 * k -
                      285.2331026137004) +
                  d * (1.7149763477362134 * d - 5.6096736904047315 * n - 17.873870861415444 * k - 5.497006427196366) +
                  n * (-2.5217340131683033 * n - 21.248923337353073 * k + 17.5119270841813) -
                  k * (21.86122147463605 * k + 189.48180835922747)),
                (a[c++] =
                  255 +
                  b *
                    (8.841041422036149 * b +
                      60.118027045597366 * d +
                      6.871425592049007 * n +
                      31.159100130055922 * k -
                      79.2970844816548) +
                  d * (-15.310361306967817 * d + 17.575251261109482 * n + 131.35250912493976 * k - 190.9453302588951) +
                  n * (4.444339102852739 * n + 9.8632861493405 * k - 24.86741582555878) -
                  k * (20.737325471181034 * k + 187.80453709719578)),
                (a[c++] =
                  255 +
                  b *
                    (0.8842522430003296 * b +
                      8.078677503112928 * d +
                      30.89978309703729 * n -
                      0.23883238689178934 * k -
                      14.183576799673286) +
                  d * (10.49593273432072 * d + 63.02378494754052 * n + 50.606957656360734 * k - 112.23884253719248) +
                  n * (0.03296041114873217 * n + 115.60384449646641 * k - 193.58209356861505) -
                  k * (22.33816807309886 * k + 180.12613974708367));
            return a;
          },
          getData: function(a, d, h) {
            if (4 < this.numComponents) throw new b('Unsupported color mode');
            a = this._getLinearizedBlockData(a, d);
            if (1 === this.numComponents && h) {
              h = a.length;
              d = new Uint8ClampedArray(3 * h);
              for (var e = 0, n = 0; n < h; n++) {
                var c = a[n];
                d[e++] = c;
                d[e++] = c;
                d[e++] = c;
              }
              return d;
            }
            if (3 === this.numComponents && this._isColorConversionNeeded()) return this._convertYccToRgb(a);
            if (4 === this.numComponents) {
              if (this._isColorConversionNeeded()) return h ? this._convertYcckToRgb(a) : this._convertYcckToCmyk(a);
              if (h) return this._convertCmykToRgb(a);
            }
            return a;
          },
        };
        return m;
      })();
      m.JpegImage = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.PostScriptParser = m.PostScriptLexer = void 0;
      var a = t(0),
        k = t(1);
      y = (function() {
        function d(a) {
          this.lexer = a;
          this.operators = [];
          this.prev = this.token = null;
        }
        d.prototype = {
          nextToken: function() {
            this.prev = this.token;
            this.token = this.lexer.getToken();
          },
          accept: function(a) {
            return this.token.type === a ? (this.nextToken(), !0) : !1;
          },
          expect: function(b) {
            if (this.accept(b)) return !0;
            throw new a.FormatError('Unexpected symbol: found ' + this.token.type + ' expected ' + b + '.');
          },
          parse: function() {
            this.nextToken();
            this.expect(b.LBRACE);
            this.parseBlock();
            this.expect(b.RBRACE);
            return this.operators;
          },
          parseBlock: function() {
            for (;;)
              if (this.accept(b.NUMBER)) this.operators.push(this.prev.value);
              else if (this.accept(b.OPERATOR)) this.operators.push(this.prev.value);
              else if (this.accept(b.LBRACE)) this.parseCondition();
              else break;
          },
          parseCondition: function() {
            var d = this.operators.length;
            this.operators.push(null, null);
            this.parseBlock();
            this.expect(b.RBRACE);
            if (this.accept(b.IF)) (this.operators[d] = this.operators.length), (this.operators[d + 1] = 'jz');
            else if (this.accept(b.LBRACE)) {
              var k = this.operators.length;
              this.operators.push(null, null);
              var m = this.operators.length;
              this.parseBlock();
              this.expect(b.RBRACE);
              this.expect(b.IFELSE);
              this.operators[k] = this.operators.length;
              this.operators[k + 1] = 'j';
              this.operators[d] = m;
              this.operators[d + 1] = 'jz';
            } else throw new a.FormatError('PS Function: error parsing conditional.');
          },
        };
        return d;
      })();
      var b = { LBRACE: 0, RBRACE: 1, NUMBER: 2, OPERATOR: 3, IF: 4, IFELSE: 5 },
        v = (function() {
          function a(a, b) {
            this.type = a;
            this.value = b;
          }
          var k = Object.create(null);
          a.getOperator = function(d) {
            var m = k[d];
            return m ? m : (k[d] = new a(b.OPERATOR, d));
          };
          a.LBRACE = new a(b.LBRACE, '{');
          a.RBRACE = new a(b.RBRACE, '}');
          a.IF = new a(b.IF, 'IF');
          a.IFELSE = new a(b.IFELSE, 'IFELSE');
          return a;
        })();
      t = (function() {
        function d(a) {
          this.stream = a;
          this.nextChar();
          this.strBuf = [];
        }
        d.prototype = {
          nextChar: function() {
            return (this.currentChar = this.stream.getByte());
          },
          getToken: function() {
            for (var d = !1, m = this.currentChar; ; ) {
              if (0 > m) return k.EOF;
              if (d) {
                if (10 === m || 13 === m) d = !1;
              } else if (37 === m) d = !0;
              else if (!(0, a.isSpace)(m)) break;
              m = this.nextChar();
            }
            switch (m | 0) {
              case 48:
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
              case 43:
              case 45:
              case 46:
                return new v(b.NUMBER, this.getNumber());
              case 123:
                return this.nextChar(), v.LBRACE;
              case 125:
                return this.nextChar(), v.RBRACE;
            }
            d = this.strBuf;
            d.length = 0;
            for (
              d[0] = String.fromCharCode(m);
              0 <= (m = this.nextChar()) && ((65 <= m && 90 >= m) || (97 <= m && 122 >= m));

            )
              d.push(String.fromCharCode(m));
            m = d.join('');
            switch (m.toLowerCase()) {
              case 'if':
                return v.IF;
              case 'ifelse':
                return v.IFELSE;
              default:
                return v.getOperator(m);
            }
          },
          getNumber: function() {
            var b = this.currentChar,
              d = this.strBuf;
            d.length = 0;
            for (d[0] = String.fromCharCode(b); 0 <= (b = this.nextChar()); )
              if ((48 <= b && 57 >= b) || 45 === b || 46 === b) d.push(String.fromCharCode(b));
              else break;
            b = parseFloat(d.join(''));
            if (isNaN(b)) throw new a.FormatError('Invalid floating point number: ' + b);
            return b;
          },
        };
        return d;
      })();
      m.PostScriptLexer = t;
      m.PostScriptParser = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.CMapFactory = m.IdentityCMap = m.CMap = void 0;
      var a = t(0),
        k = t(1),
        b = t(25),
        v = t(3),
        d = 'Adobe-GB1-UCS2 Adobe-CNS1-UCS2 Adobe-Japan1-UCS2 Adobe-Korea1-UCS2 78-EUC-H 78-EUC-V 78-H 78-RKSJ-H 78-RKSJ-V 78-V 78ms-RKSJ-H 78ms-RKSJ-V 83pv-RKSJ-H 90ms-RKSJ-H 90ms-RKSJ-V 90msp-RKSJ-H 90msp-RKSJ-V 90pv-RKSJ-H 90pv-RKSJ-V Add-H Add-RKSJ-H Add-RKSJ-V Add-V Adobe-CNS1-0 Adobe-CNS1-1 Adobe-CNS1-2 Adobe-CNS1-3 Adobe-CNS1-4 Adobe-CNS1-5 Adobe-CNS1-6 Adobe-GB1-0 Adobe-GB1-1 Adobe-GB1-2 Adobe-GB1-3 Adobe-GB1-4 Adobe-GB1-5 Adobe-Japan1-0 Adobe-Japan1-1 Adobe-Japan1-2 Adobe-Japan1-3 Adobe-Japan1-4 Adobe-Japan1-5 Adobe-Japan1-6 Adobe-Korea1-0 Adobe-Korea1-1 Adobe-Korea1-2 B5-H B5-V B5pc-H B5pc-V CNS-EUC-H CNS-EUC-V CNS1-H CNS1-V CNS2-H CNS2-V ETHK-B5-H ETHK-B5-V ETen-B5-H ETen-B5-V ETenms-B5-H ETenms-B5-V EUC-H EUC-V Ext-H Ext-RKSJ-H Ext-RKSJ-V Ext-V GB-EUC-H GB-EUC-V GB-H GB-V GBK-EUC-H GBK-EUC-V GBK2K-H GBK2K-V GBKp-EUC-H GBKp-EUC-V GBT-EUC-H GBT-EUC-V GBT-H GBT-V GBTpc-EUC-H GBTpc-EUC-V GBpc-EUC-H GBpc-EUC-V H HKdla-B5-H HKdla-B5-V HKdlb-B5-H HKdlb-B5-V HKgccs-B5-H HKgccs-B5-V HKm314-B5-H HKm314-B5-V HKm471-B5-H HKm471-B5-V HKscs-B5-H HKscs-B5-V Hankaku Hiragana KSC-EUC-H KSC-EUC-V KSC-H KSC-Johab-H KSC-Johab-V KSC-V KSCms-UHC-H KSCms-UHC-HW-H KSCms-UHC-HW-V KSCms-UHC-V KSCpc-EUC-H KSCpc-EUC-V Katakana NWP-H NWP-V RKSJ-H RKSJ-V Roman UniCNS-UCS2-H UniCNS-UCS2-V UniCNS-UTF16-H UniCNS-UTF16-V UniCNS-UTF32-H UniCNS-UTF32-V UniCNS-UTF8-H UniCNS-UTF8-V UniGB-UCS2-H UniGB-UCS2-V UniGB-UTF16-H UniGB-UTF16-V UniGB-UTF32-H UniGB-UTF32-V UniGB-UTF8-H UniGB-UTF8-V UniJIS-UCS2-H UniJIS-UCS2-HW-H UniJIS-UCS2-HW-V UniJIS-UCS2-V UniJIS-UTF16-H UniJIS-UTF16-V UniJIS-UTF32-H UniJIS-UTF32-V UniJIS-UTF8-H UniJIS-UTF8-V UniJIS2004-UTF16-H UniJIS2004-UTF16-V UniJIS2004-UTF32-H UniJIS2004-UTF32-V UniJIS2004-UTF8-H UniJIS2004-UTF8-V UniJISPro-UCS2-HW-V UniJISPro-UCS2-V UniJISPro-UTF8-V UniJISX0213-UTF32-H UniJISX0213-UTF32-V UniJISX02132004-UTF32-H UniJISX02132004-UTF32-V UniKS-UCS2-H UniKS-UCS2-V UniKS-UTF16-H UniKS-UTF16-V UniKS-UTF32-H UniKS-UTF32-V UniKS-UTF8-H UniKS-UTF8-V V WP-Symbol'.split(
          ' ',
        ),
        u = (function() {
          function a(a) {
            this.codespaceRanges = [[], [], [], []];
            this.numCodespaceRanges = 0;
            this._map = [];
            this.name = '';
            this.vertical = !1;
            this.useCMap = null;
            this.builtInCMap = a;
          }
          a.prototype = {
            addCodespaceRange: function(a, b, d) {
              this.codespaceRanges[a - 1].push(b, d);
              this.numCodespaceRanges++;
            },
            mapCidRange: function(a, b, d) {
              for (; a <= b; ) this._map[a++] = d++;
            },
            mapBfRange: function(a, b, d) {
              for (var e = d.length - 1; a <= b; )
                (this._map[a++] = d), (d = d.substr(0, e) + String.fromCharCode(d.charCodeAt(e) + 1));
            },
            mapBfRangeToArray: function(a, b, d) {
              for (var e = 0, h = d.length; a <= b && e < h; ) (this._map[a] = d[e++]), ++a;
            },
            mapOne: function(a, b) {
              this._map[a] = b;
            },
            lookup: function(a) {
              return this._map[a];
            },
            contains: function(a) {
              return void 0 !== this._map[a];
            },
            forEach: function(a) {
              var b = this._map,
                d = b.length;
              if (65536 >= d) for (var n = 0; n < d; n++) void 0 !== b[n] && a(n, b[n]);
              else for (n in b) a(n, b[n]);
            },
            charCodeOf: function(a) {
              var b = this._map;
              if (65536 >= b.length) return b.indexOf(a);
              for (var d in b) if (b[d] === a) return d | 0;
              return -1;
            },
            getMap: function() {
              return this._map;
            },
            readCharCode: function(a, b, d) {
              for (var e = 0, h = this.codespaceRanges, c = this.codespaceRanges.length, n = 0; n < c; n++) {
                e = ((e << 8) | a.charCodeAt(b + n)) >>> 0;
                for (var k = h[n], g = 0, m = k.length; g < m; ) {
                  var l = k[g++],
                    v = k[g++];
                  if (e >= l && e <= v) {
                    d.charcode = e;
                    d.length = n + 1;
                    return;
                  }
                }
              }
              d.charcode = 0;
              d.length = 1;
            },
            get length() {
              return this._map.length;
            },
            get isIdentityCMap() {
              if (('Identity-H' !== this.name && 'Identity-V' !== this.name) || 65536 !== this._map.length) return !1;
              for (var a = 0; 65536 > a; a++) if (this._map[a] !== a) return !1;
              return !0;
            },
          };
          return a;
        })(),
        z = (function() {
          function b(a, b) {
            u.call(this);
            this.vertical = a;
            this.addCodespaceRange(b, 0, 65535);
          }
          a.Util.inherit(b, u, {});
          b.prototype = {
            addCodespaceRange: u.prototype.addCodespaceRange,
            mapCidRange: function(a, b, d) {
              throw Error('should not call mapCidRange');
            },
            mapBfRange: function(a, b, d) {
              throw Error('should not call mapBfRange');
            },
            mapBfRangeToArray: function(a, b, d) {
              throw Error('should not call mapBfRangeToArray');
            },
            mapOne: function(a, b) {
              throw Error('should not call mapCidOne');
            },
            lookup: function(a) {
              return Number.isInteger(a) && 65535 >= a ? a : void 0;
            },
            contains: function(a) {
              return Number.isInteger(a) && 65535 >= a;
            },
            forEach: function(a) {
              for (var b = 0; 65535 >= b; b++) a(b, b);
            },
            charCodeOf: function(a) {
              return Number.isInteger(a) && 65535 >= a ? a : -1;
            },
            getMap: function() {
              for (var a = Array(65536), b = 0; 65535 >= b; b++) a[b] = b;
              return a;
            },
            readCharCode: u.prototype.readCharCode,
            get length() {
              return 65536;
            },
            get isIdentityCMap() {
              throw Error('should not access .isIdentityCMap');
            },
          };
          return b;
        })(),
        C = (function() {
          function b(a, b) {
            for (var c = 0, d = 0; d <= b; d++) c = (c << 8) | a[d];
            return c >>> 0;
          }
          function d(a, b) {
            return 1 === b
              ? String.fromCharCode(a[0], a[1])
              : 3 === b
              ? String.fromCharCode(a[0], a[1], a[2], a[3])
              : String.fromCharCode.apply(null, a.subarray(0, b + 1));
          }
          function e(a, b, d) {
            for (var c = 0; 0 <= d; d--) (c += a[d] + b[d]), (a[d] = c & 255), (c >>= 8);
          }
          function h(a, b) {
            for (var c = 1, d = b; 0 <= d && 0 < c; d--) (c += a[d]), (a[d] = c & 255), (c >>= 8);
          }
          function p(a) {
            this.buffer = a;
            this.pos = 0;
            this.end = a.length;
            this.tmpBuf = new Uint8Array(19);
          }
          function k() {}
          p.prototype = {
            readByte: function() {
              return this.pos >= this.end ? -1 : this.buffer[this.pos++];
            },
            readNumber: function() {
              var b = 0;
              do {
                var d = this.readByte();
                if (0 > d) throw new a.FormatError('unexpected EOF in bcmap');
                var e = !(d & 128);
                b = (b << 7) | (d & 127);
              } while (!e);
              return b;
            },
            readSigned: function() {
              var a = this.readNumber();
              return a & 1 ? ~(a >>> 1) : a >>> 1;
            },
            readHex: function(a, b) {
              a.set(this.buffer.subarray(this.pos, this.pos + b + 1));
              this.pos += b + 1;
            },
            readHexNumber: function(b, d) {
              var c = this.tmpBuf,
                e = 0;
              do {
                var h = this.readByte();
                if (0 > h) throw new a.FormatError('unexpected EOF in bcmap');
                var l = !(h & 128);
                c[e++] = h & 127;
              } while (!l);
              l = d;
              for (var n = (h = 0); 0 <= l; ) {
                for (; 8 > n && 0 < c.length; ) (h |= c[--e] << n), (n += 7);
                b[l] = h & 255;
                l--;
                h >>= 8;
                n -= 8;
              }
            },
            readHexSigned: function(a, b) {
              this.readHexNumber(a, b);
              for (var c = a[b] & 1 ? 255 : 0, d = 0, e = 0; e <= b; e++)
                (d = ((d & 1) << 8) | a[e]), (a[e] = (d >> 1) ^ c);
            },
            readString: function() {
              for (var a = this.readNumber(), b = '', d = 0; d < a; d++) b += String.fromCharCode(this.readNumber());
              return b;
            },
          };
          k.prototype = {
            process: function(a, n, k) {
              return new Promise(function(c, m) {
                var g = new p(a),
                  q = g.readByte();
                n.vertical = !!(q & 1);
                q = null;
                for (
                  var f = new Uint8Array(16),
                    r = new Uint8Array(16),
                    v = new Uint8Array(16),
                    u = new Uint8Array(16),
                    t = new Uint8Array(16),
                    w,
                    x;
                  0 <= (x = g.readByte());

                )
                  if (((w = x >> 5), 7 === w))
                    switch (x & 31) {
                      case 0:
                        g.readString();
                        break;
                      case 1:
                        q = g.readString();
                    }
                  else {
                    var B = !!(x & 16);
                    x &= 15;
                    if (16 < x + 1) throw Error('processBinaryCMap: Invalid dataSize.');
                    var A = g.readNumber(),
                      z;
                    switch (w) {
                      case 0:
                        g.readHex(f, x);
                        g.readHexNumber(r, x);
                        e(r, f, x);
                        n.addCodespaceRange(x + 1, b(f, x), b(r, x));
                        for (z = 1; z < A; z++)
                          h(r, x),
                            g.readHexNumber(f, x),
                            e(f, r, x),
                            g.readHexNumber(r, x),
                            e(r, f, x),
                            n.addCodespaceRange(x + 1, b(f, x), b(r, x));
                        break;
                      case 1:
                        g.readHex(f, x);
                        g.readHexNumber(r, x);
                        e(r, f, x);
                        g.readNumber();
                        for (z = 1; z < A; z++)
                          h(r, x), g.readHexNumber(f, x), e(f, r, x), g.readHexNumber(r, x), e(r, f, x), g.readNumber();
                        break;
                      case 2:
                        g.readHex(v, x);
                        w = g.readNumber();
                        n.mapOne(b(v, x), w);
                        for (z = 1; z < A; z++)
                          h(v, x),
                            B || (g.readHexNumber(t, x), e(v, t, x)),
                            (w = g.readSigned() + (w + 1)),
                            n.mapOne(b(v, x), w);
                        break;
                      case 3:
                        g.readHex(f, x);
                        g.readHexNumber(r, x);
                        e(r, f, x);
                        w = g.readNumber();
                        n.mapCidRange(b(f, x), b(r, x), w);
                        for (z = 1; z < A; z++)
                          h(r, x),
                            B ? f.set(r) : (g.readHexNumber(f, x), e(f, r, x)),
                            g.readHexNumber(r, x),
                            e(r, f, x),
                            (w = g.readNumber()),
                            n.mapCidRange(b(f, x), b(r, x), w);
                        break;
                      case 4:
                        g.readHex(v, 1);
                        g.readHex(u, x);
                        n.mapOne(b(v, 1), d(u, x));
                        for (z = 1; z < A; z++)
                          h(v, 1),
                            B || (g.readHexNumber(t, 1), e(v, t, 1)),
                            h(u, x),
                            g.readHexSigned(t, x),
                            e(u, t, x),
                            n.mapOne(b(v, 1), d(u, x));
                        break;
                      case 5:
                        g.readHex(f, 1);
                        g.readHexNumber(r, 1);
                        e(r, f, 1);
                        g.readHex(u, x);
                        n.mapBfRange(b(f, 1), b(r, 1), d(u, x));
                        for (z = 1; z < A; z++)
                          h(r, 1),
                            B ? f.set(r) : (g.readHexNumber(f, 1), e(f, r, 1)),
                            g.readHexNumber(r, 1),
                            e(r, f, 1),
                            g.readHex(u, x),
                            n.mapBfRange(b(f, 1), b(r, 1), d(u, x));
                        break;
                      default:
                        m(Error('processBinaryCMap: Unknown type: ' + w));
                        return;
                    }
                  }
                q ? c(k(q)) : c(n);
              });
            },
          };
          return k;
        })();
      y = (function() {
        function m(a) {
          for (var b = 0, c = 0; c < a.length; c++) b = (b << 8) | a.charCodeAt(c);
          return b >>> 0;
        }
        function n(b) {
          if (!(0, a.isString)(b)) throw new a.FormatError('Malformed CMap: expected string.');
        }
        function e(b) {
          if (!Number.isInteger(b)) throw new a.FormatError('Malformed CMap: expected int.');
        }
        function h(b, d, h, g) {
          a: for (;;)
            try {
              var c = d.getObj();
              if ((0, k.isEOF)(c)) break;
              else if ((0, k.isName)(c)) {
                if ('WMode' === c.name) {
                  var l = b,
                    q = d.getObj();
                  Number.isInteger(q) && (l.vertical = !!q);
                } else if ('CMapName' === c.name) {
                  l = b;
                  var f = d.getObj();
                  (0, k.isName)(f) && (0, a.isString)(f.name) && (l.name = f.name);
                }
                var r = c;
              } else if ((0, k.isCmd)(c))
                switch (c.cmd) {
                  case 'endcmap':
                    break a;
                  case 'usecmap':
                    if ((0, k.isName)(r)) var v = r.name;
                    break;
                  case 'begincodespacerange':
                    b: {
                      l = b;
                      for (var u = d; ; ) {
                        var t = u.getObj();
                        if ((0, k.isEOF)(t)) break;
                        if ((0, k.isCmd)(t, 'endcodespacerange')) break b;
                        if (!(0, a.isString)(t)) break;
                        var x = m(t);
                        t = u.getObj();
                        if (!(0, a.isString)(t)) break;
                        var B = m(t);
                        l.addCodespaceRange(t.length, x, B);
                      }
                      throw new a.FormatError('Invalid codespace range.');
                    }
                    break;
                  case 'beginbfchar':
                    b: for (l = b, u = d; ; ) {
                      var A = u.getObj();
                      if ((0, k.isEOF)(A)) break;
                      if ((0, k.isCmd)(A, 'endbfchar')) break b;
                      n(A);
                      var z = m(A);
                      A = u.getObj();
                      n(A);
                      l.mapOne(z, A);
                    }
                    break;
                  case 'begincidchar':
                    b: for (l = b, u = d; ; ) {
                      var C = u.getObj();
                      if ((0, k.isEOF)(C)) break;
                      if ((0, k.isCmd)(C, 'endcidchar')) break b;
                      n(C);
                      var y = m(C);
                      C = u.getObj();
                      e(C);
                      l.mapOne(y, C);
                    }
                    break;
                  case 'beginbfrange':
                    b: {
                      l = b;
                      for (u = d; ; ) {
                        var O = u.getObj();
                        if ((0, k.isEOF)(O)) break;
                        if ((0, k.isCmd)(O, 'endbfrange')) break b;
                        n(O);
                        var N = m(O);
                        O = u.getObj();
                        n(O);
                        var da = m(O);
                        O = u.getObj();
                        if (Number.isInteger(O) || (0, a.isString)(O)) {
                          var W = Number.isInteger(O) ? String.fromCharCode(O) : O;
                          l.mapBfRange(N, da, W);
                        } else if ((0, k.isCmd)(O, '[')) {
                          O = u.getObj();
                          for (var Z = []; !(0, k.isCmd)(O, ']') && !(0, k.isEOF)(O); ) Z.push(O), (O = u.getObj());
                          l.mapBfRangeToArray(N, da, Z);
                        } else break;
                      }
                      throw new a.FormatError('Invalid bf range.');
                    }
                    break;
                  case 'begincidrange':
                    b: for (l = b, u = d; ; ) {
                      var ea = u.getObj();
                      if ((0, k.isEOF)(ea)) break;
                      if ((0, k.isCmd)(ea, 'endcidrange')) break b;
                      n(ea);
                      var aa = m(ea);
                      ea = u.getObj();
                      n(ea);
                      var X = m(ea);
                      ea = u.getObj();
                      e(ea);
                      l.mapCidRange(aa, X, ea);
                    }
                }
            } catch (ba) {
              if (ba instanceof a.MissingDataException) throw ba;
              (0, a.warn)('Invalid cMap data: ' + ba);
            }
          !g && v && (g = v);
          return g ? p(b, h, g) : Promise.resolve(b);
        }
        function p(a, b, d) {
          return t(d, b).then(function(b) {
            a.useCMap = b;
            if (0 === a.numCodespaceRanges) {
              b = a.useCMap.codespaceRanges;
              for (var c = 0; c < b.length; c++) a.codespaceRanges[c] = b[c].slice();
              a.numCodespaceRanges = a.useCMap.numCodespaceRanges;
            }
            a.useCMap.forEach(function(b, c) {
              a.contains(b) || a.mapOne(b, a.useCMap.lookup(b));
            });
            return a;
          });
        }
        function t(c, e) {
          return 'Identity-H' === c
            ? Promise.resolve(new z(!1, 2))
            : 'Identity-V' === c
            ? Promise.resolve(new z(!0, 2))
            : -1 === d.indexOf(c)
            ? Promise.reject(Error('Unknown CMap name: ' + c))
            : e
            ? e(c).then(function(c) {
                var d = c.cMapData;
                c = c.compressionType;
                var n = new u(!0);
                return c === a.CMapCompressionType.BINARY
                  ? new C().process(d, n, function(a) {
                      return p(n, e, a);
                    })
                  : c === a.CMapCompressionType.NONE
                  ? ((d = new b.Lexer(new v.Stream(d))), h(n, d, e, null))
                  : Promise.reject(Error('TODO: Only BINARY/NONE CMap compression is currently supported.'));
              })
            : Promise.reject(Error('Built-in CMap parameters are not provided.'));
        }
        return {
          create: function(a) {
            var c = a.encoding,
              d = a.fetchBuiltInCMap;
            a = a.useCMap;
            if ((0, k.isName)(c)) return t(c.name, d);
            if ((0, k.isStream)(c)) {
              var e = new u();
              c = new b.Lexer(c);
              return h(e, c, d, a).then(function(a) {
                return a.isIdentityCMap ? t(a.name, d) : a;
              });
            }
            return Promise.reject(Error('Encoding required.'));
          },
        };
      })();
      m.CMap = u;
      m.IdentityCMap = z;
      m.CMapFactory = y;
    },
    function(y, m, t) {
      function a(a) {
        if (a.fontMatrix && a.fontMatrix[0] !== u.FONT_IDENTITY_MATRIX[0]) {
          var b = 0.001 / a.fontMatrix[0],
            c = a.widths,
            d;
          for (d in c) c[d] *= b;
          a.defaultWidth *= b;
        }
      }
      function k(a, b) {
        if (!(a.hasIncludedToUnicodeMap || a.hasEncoding || b === a.defaultEncoding || a.toUnicode instanceof J)) {
          var c = [],
            d = (0, C.getGlyphsUnicode)(),
            g;
          for (g in b) {
            var f = b[g];
            f = (0, e.getUnicodeForGlyph)(f, d);
            -1 !== f && (c[g] = String.fromCharCode(f));
          }
          a.toUnicode.amend(c);
        }
      }
      function b(a, b) {
        switch (a) {
          case 'Type1':
            return 'Type1C' === b ? u.FontType.TYPE1C : u.FontType.TYPE1;
          case 'CIDFontType0':
            return 'CIDFontType0C' === b ? u.FontType.CIDFONTTYPE0C : u.FontType.CIDFONTTYPE0;
          case 'OpenType':
            return u.FontType.OPENTYPE;
          case 'TrueType':
            return u.FontType.TRUETYPE;
          case 'CIDFontType2':
            return u.FontType.CIDFONTTYPE2;
          case 'MMType1':
            return u.FontType.MMTYPE1;
          case 'Type0':
            return u.FontType.TYPE0;
          default:
            return u.FontType.UNKNOWN;
        }
      }
      function v(a, b) {
        if (void 0 !== b[a]) return a;
        var c = (0, e.getUnicodeForGlyph)(a, b);
        if (-1 !== c) for (var d in b) if (b[d] === c) return d;
        (0, u.info)('Unable to recover a standard glyph name for: ' + a);
        return a;
      }
      function d(a, b, c) {
        var d = Object.create(null),
          e;
        var g = !!(a.flags & x.Symbolic);
        if (a.baseEncodingName)
          for (g = (0, B.getEncoding)(a.baseEncodingName), e = 0; e < g.length; e++)
            (b = c.indexOf(g[e])), (d[e] = 0 <= b ? b : 0);
        else if (g) for (e in b) d[e] = b[e];
        else for (g = B.StandardEncoding, e = 0; e < g.length; e++) (b = c.indexOf(g[e])), (d[e] = 0 <= b ? b : 0);
        a = a.differences;
        var f;
        if (a)
          for (e in a) {
            g = a[e];
            b = c.indexOf(g);
            if (-1 === b) {
              f || (f = (0, C.getGlyphsUnicode)());
              var h = v(g, f);
              h !== g && (b = c.indexOf(h));
            }
            d[e] = 0 <= b ? b : 0;
          }
        return d;
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.getFontType = m.ProblematicCharRanges = m.IdentityToUnicodeMap = m.ToUnicodeMap = m.FontFlags = m.Font = m.ErrorFont = m.PRIVATE_USE_OFFSET_END = m.PRIVATE_USE_OFFSET_START = m.SEAC_ANALYSIS_ENABLED = void 0;
      var u = t(0),
        z = t(64),
        C = t(35),
        B = t(18),
        n = t(65),
        e = t(66),
        h = t(112),
        p = t(3),
        A = t(113),
        c = !1,
        q = !1,
        x = {
          FixedPitch: 1,
          Serif: 2,
          Symbolic: 4,
          Script: 8,
          Nonsymbolic: 32,
          Italic: 64,
          AllCap: 65536,
          SmallCap: 131072,
          ForceBold: 262144,
        },
        g = '.notdef .null nonmarkingreturn space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis nonbreakingspace Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron Lslash lslash Scaron scaron Zcaron zcaron brokenbar Eth eth Yacute yacute Thorn thorn minus multiply onesuperior twosuperior threesuperior onehalf onequarter threequarters franc Gbreve gbreve Idotaccent Scedilla scedilla Cacute cacute Ccaron ccaron dcroat'.split(
          ' ',
        ),
        G = (function() {
          function a(a, b, c, d, e, g, f, h) {
            this.fontChar = a;
            this.unicode = b;
            this.accent = c;
            this.width = d;
            this.vmetric = e;
            this.operatorListId = g;
            this.isSpace = f;
            this.isInFont = h;
          }
          a.prototype.matchesForCache = function(a, b, c, d, e, g, f, h) {
            return (
              this.fontChar === a &&
              this.unicode === b &&
              this.accent === c &&
              this.width === d &&
              this.vmetric === e &&
              this.operatorListId === g &&
              this.isSpace === f &&
              this.isInFont === h
            );
          };
          return a;
        })(),
        l = (function() {
          function a(a) {
            this._map = a;
          }
          a.prototype = {
            get length() {
              return this._map.length;
            },
            forEach: function(a) {
              for (var b in this._map) a(b, this._map[b].charCodeAt(0));
            },
            has: function(a) {
              return void 0 !== this._map[a];
            },
            get: function(a) {
              return this._map[a];
            },
            charCodeOf: function(a) {
              var b = this._map;
              if (65536 >= b.length) return b.indexOf(a);
              for (var c in b) if (b[c] === a) return c | 0;
              return -1;
            },
            amend: function(a) {
              for (var b in a) this._map[b] = a[b];
            },
          };
          return a;
        })(),
        J = (function() {
          function a(a, b) {
            this.firstChar = a;
            this.lastChar = b;
          }
          a.prototype = {
            get length() {
              return this.lastChar + 1 - this.firstChar;
            },
            forEach: function(a) {
              for (var b = this.firstChar, c = this.lastChar; b <= c; b++) a(b, b);
            },
            has: function(a) {
              return this.firstChar <= a && a <= this.lastChar;
            },
            get: function(a) {
              if (this.firstChar <= a && a <= this.lastChar) return String.fromCharCode(a);
            },
            charCodeOf: function(a) {
              return Number.isInteger(a) && a >= this.firstChar && a <= this.lastChar ? a : -1;
            },
            amend: function(a) {
              throw Error('Should not call amend()');
            },
          };
          return a;
        })(),
        f = (function() {
          function a(a, b, c) {
            a[b] = (c >> 8) & 255;
            a[b + 1] = c & 255;
          }
          function b(a, b, c) {
            a[b] = (c >> 24) & 255;
            a[b + 1] = (c >> 16) & 255;
            a[b + 2] = (c >> 8) & 255;
            a[b + 3] = c & 255;
          }
          function c(a) {
            this.sfnt = a;
            this.tables = Object.create(null);
          }
          c.getSearchParams = function(a, b) {
            for (var c = 1, d = 0; (c ^ a) > c; ) (c <<= 1), d++;
            c *= b;
            return { range: c, entry: d, rangeShift: b * a - c };
          };
          c.prototype = {
            toArray: function() {
              var d = this.sfnt,
                e = this.tables,
                g = Object.keys(e);
              g.sort();
              var f = g.length,
                h,
                l = 12 + 16 * f,
                n = [l];
              for (h = 0; h < f; h++) {
                var p = e[g[h]];
                l += ((p.length + 3) & -4) >>> 0;
                n.push(l);
              }
              var k = new Uint8Array(l);
              for (h = 0; h < f; h++) {
                p = e[g[h]];
                l = k;
                var m = n[h];
                var q = p;
                if (q instanceof Uint8Array) l.set(q, m);
                else if ('string' === typeof q) {
                  var r = 0;
                  for (p = q.length; r < p; r++) l[m++] = q.charCodeAt(r) & 255;
                } else for (r = 0, p = q.length; r < p; r++) l[m++] = q[r] & 255;
              }
              'true' === d && (d = (0, u.string32)(65536));
              k[0] = d.charCodeAt(0) & 255;
              k[1] = d.charCodeAt(1) & 255;
              k[2] = d.charCodeAt(2) & 255;
              k[3] = d.charCodeAt(3) & 255;
              a(k, 4, f);
              h = c.getSearchParams(f, 16);
              a(k, 6, h.range);
              a(k, 8, h.entry);
              a(k, 10, h.rangeShift);
              l = 12;
              for (h = 0; h < f; h++) {
                p = g[h];
                k[l] = p.charCodeAt(0) & 255;
                k[l + 1] = p.charCodeAt(1) & 255;
                k[l + 2] = p.charCodeAt(2) & 255;
                k[l + 3] = p.charCodeAt(3) & 255;
                r = 0;
                d = n[h];
                for (m = n[h + 1]; d < m; d += 4) (q = (0, u.readUint32)(k, d)), (r = (r + q) >>> 0);
                b(k, l + 4, r);
                b(k, l + 8, n[h]);
                b(k, l + 12, e[p].length);
                l += 16;
              }
              return k;
            },
            addTable: function(a, b) {
              if (a in this.tables) throw Error('Table ' + a + ' already exists');
              this.tables[a] = b;
            },
          };
          return c;
        })(),
        r = new Int32Array([
          0,
          32,
          127,
          161,
          173,
          174,
          1536,
          1920,
          2208,
          4256,
          6016,
          6144,
          7168,
          7248,
          8192,
          8208,
          8209,
          8210,
          8232,
          8240,
          8287,
          8304,
          9676,
          9677,
          12288,
          12289,
          12644,
          12645,
          43616,
          43648,
          65520,
          65536,
        ]);
      y = (function() {
        function d(c, d, e) {
          this.name = c;
          this.loadedName = e.loadedName;
          this.isType3Font = e.isType3Font;
          this.sizes = [];
          this.missingFile = !1;
          this.glyphCache = Object.create(null);
          this.isSerifFont = !!(e.flags & x.Serif);
          this.isSymbolicFont = !!(e.flags & x.Symbolic);
          this.isMonospace = !!(e.flags & x.FixedPitch);
          var g = e.type,
            f = e.subtype;
          this.type = g;
          this.subtype = f;
          this.fallbackName = this.isMonospace ? 'monospace' : this.isSerifFont ? 'serif' : 'sans-serif';
          this.differences = e.differences;
          this.widths = e.widths;
          this.defaultWidth = e.defaultWidth;
          this.composite = e.composite;
          this.wideChars = e.wideChars;
          this.cMap = e.cMap;
          this.ascent = e.ascent / 1e3;
          this.descent = e.descent / 1e3;
          this.fontMatrix = e.fontMatrix;
          this.bbox = e.bbox;
          this.defaultEncoding = e.defaultEncoding;
          this.toUnicode = e.toUnicode;
          this.toFontChar = [];
          if ('Type3' === e.type) {
            for (c = 0; 256 > c; c++) this.toFontChar[c] = this.differences[c] || e.defaultEncoding[c];
            this.fontType = u.FontType.TYPE3;
          } else {
            this.cidEncoding = e.cidEncoding;
            if ((this.vertical = e.vertical)) (this.vmetrics = e.vmetrics), (this.defaultVMetrics = e.defaultVMetrics);
            if (!d || d.isEmpty)
              d && (0, u.warn)('Font file is empty in "' + c + '" (' + this.loadedName + ')'),
                this.fallbackToSystemFont();
            else {
              if ('Type1C' === f)
                if ('Type1' !== g && 'MMType1' !== g) {
                  var h = d.peekBytes(4);
                  65536 === (0, u.readUint32)(h, 0) ? (f = 'TrueType') : (g = 'Type1');
                } else y(d) && (f = 'OpenType');
              'CIDFontType0C' === f && 'CIDFontType0' !== g && (g = 'CIDFontType0');
              'CIDFontType0' === g &&
                ((f = d.peekBytes(2)),
                (f = 37 === f[0] && 33 === f[1] ? !0 : 128 === f[0] && 1 === f[1] ? !0 : !1),
                (f = f ? 'CIDFontType0' : y(d) ? 'OpenType' : 'CIDFontType0C'));
              'OpenType' === f && 'OpenType' !== g && (g = 'OpenType');
              try {
                switch (g) {
                  case 'MMType1':
                    (0, u.info)('MMType1 font (' + c + '), falling back to Type1.');
                  case 'Type1':
                  case 'CIDFontType0':
                    this.mimetype = 'font/opentype';
                    var l = 'Type1C' === f || 'CIDFontType0C' === f ? new L(d, e) : new D(c, d, e);
                    a(e);
                    var n = this.convert(c, l, e);
                    break;
                  case 'OpenType':
                  case 'TrueType':
                  case 'CIDFontType2':
                    this.mimetype = 'font/opentype';
                    n = this.checkAndRepair(c, d, e);
                    this.isOpenType && (a(e), (g = 'OpenType'));
                    break;
                  default:
                    throw new u.FormatError('Font ' + g + ' is not supported');
                }
              } catch (V) {
                if (!(V instanceof u.FormatError)) throw V;
                (0, u.warn)(V);
                this.fallbackToSystemFont();
                return;
              }
              this.data = n;
              this.fontType = b(g, f);
              this.fontMatrix = e.fontMatrix;
              this.widths = e.widths;
              this.defaultWidth = e.defaultWidth;
              this.toUnicode = e.toUnicode;
              this.encoding = e.baseEncoding;
              this.seacMap = e.seacMap;
              this.loading = !0;
            }
          }
        }
        function m(a, b) {
          var c = (a << 8) + b;
          return c & 32768 ? c - 65536 : c;
        }
        function t(a) {
          return String.fromCharCode((a >> 8) & 255, a & 255);
        }
        function A(a) {
          a = 32767 < a ? 32767 : -32768 > a ? -32768 : a;
          return String.fromCharCode((a >> 8) & 255, a & 255);
        }
        function y(a) {
          a = a.peekBytes(4);
          return 'OTTO' === (0, u.bytesToString)(a);
        }
        function H(a, b, c) {
          for (var d = [], g, f = 0, h = a.length; f < h; f++)
            (g = (0, e.getUnicodeForGlyph)(a[f], b)), -1 !== g && (d[f] = g);
          for (var l in c) (g = (0, e.getUnicodeForGlyph)(c[l], b)), -1 !== g && (d[+l] = g);
          return d;
        }
        function M(a, b, d) {
          var e = b.toUnicode,
            g = !!(b.flags & x.Symbolic);
          b = b.toUnicode instanceof J;
          var f = Object.create(null),
            h = [],
            l = [],
            n = 57344,
            p;
          for (p in a) {
            p |= 0;
            var k = a[p];
            if (!d[k]) {
              var m = p,
                q = !1;
              if (!b && e.has(p)) {
                q = !0;
                var t = e.get(m);
                1 === t.length && (m = t.charCodeAt(0));
              }
              if (!(t = void 0 !== l[m])) {
                t = 0;
                for (var v = r.length - 1; t < v; ) {
                  var B = (t + v + 1) >> 1;
                  m < r[B] ? (v = B - 1) : (t = B);
                }
                t = !(t & 1);
              }
              if (t || (g && !q)) {
                do {
                  if (63743 < n) {
                    (0, u.warn)('Ran out of space in font private use area.');
                    break;
                  }
                  m = n++;
                  c && 61440 === m && ((m = 61472), (n = m + 1));
                } while (void 0 !== l[m]);
              }
              f[m] = k;
              h[p] = m;
              l[m] = !0;
            }
          }
          return { toFontChar: h, charCodeToGlyphId: f, nextAvailableFontCharCode: n };
        }
        function O(a, b) {
          var c = [];
          for (d in a) a[d] >= b || c.push({ fontCharCode: d | 0, glyphId: a[d] });
          0 === c.length && c.push({ fontCharCode: 0, glyphId: 0 });
          c.sort(function(a, b) {
            return a.fontCharCode - b.fontCharCode;
          });
          var d = [];
          for (var e = c.length, g = 0; g < e; ) {
            var f = c[g].fontCharCode,
              h = [c[g].glyphId];
            ++g;
            for (var l = f; g < e && l + 1 === c[g].fontCharCode && (h.push(c[g].glyphId), ++l, ++g, 65535 !== l); );
            d.push([f, l, h]);
          }
          return d;
        }
        function N(a, b) {
          var c = O(a, b),
            d = 65535 < c[c.length - 1][1] ? 2 : 1,
            e = '\x00\x00' + t(d) + '\x00\u0003\x00\u0001' + (0, u.string32)(4 + 8 * d),
            g,
            h;
          for (g = c.length - 1; 0 <= g && !(65535 >= c[g][0]); --g);
          var l = g + 1;
          65535 > c[g][0] && 65535 === c[g][1] && (c[g][1] = 65534);
          var n = 65535 > c[g][1] ? 1 : 0,
            p = l + n,
            k = f.getSearchParams(p, 2),
            m = '',
            q = '',
            r = '',
            v = '',
            x = '',
            B = 0;
          for (g = 0; g < l; g++) {
            var w = c[g];
            var A = w[0];
            var z = w[1];
            m += t(A);
            q += t(z);
            var D = w[2];
            w = !0;
            var C = 1;
            for (h = D.length; C < h; ++C)
              if (D[C] !== D[C - 1] + 1) {
                w = !1;
                break;
              }
            if (w) (r += t((D[0] - A) & 65535)), (v += t(0));
            else
              for (C = 2 * (p - g) + 2 * B, B += z - A + 1, r += t(0), v += t(C), C = 0, h = D.length; C < h; ++C)
                x += t(D[C]);
          }
          0 < n && ((q += '\u00ff\u00ff'), (m += '\u00ff\u00ff'), (r += '\x00\u0001'), (v += '\x00\x00'));
          n = '\x00\x00' + t(2 * p) + t(k.range) + t(k.entry) + t(k.rangeShift) + q + '\x00\x00' + m + r + v + x;
          g = p = '';
          if (1 < d) {
            e += '\x00\u0003\x00\n' + (0, u.string32)(8 * d + 8 + n.length);
            p = '';
            g = 0;
            for (l = c.length; g < l; g++) {
              w = c[g];
              A = w[0];
              D = w[2];
              d = D[0];
              C = 1;
              for (h = D.length; C < h; ++C)
                D[C] !== D[C - 1] + 1 &&
                  ((z = w[0] + C - 1),
                  (p += (0, u.string32)(A) + (0, u.string32)(z) + (0, u.string32)(d)),
                  (A = z + 1),
                  (d = D[C]));
              p += (0, u.string32)(A) + (0, u.string32)(w[1]) + (0, u.string32)(d);
            }
            g = '\x00\f\x00\x00' + (0, u.string32)(p.length + 16) + '\x00\x00\x00\x00' + (0, u.string32)(p.length / 12);
          }
          return e + '\x00\u0004' + t(n.length + 4) + n + g + p;
        }
        function da(a) {
          var b = new p.Stream(a.data),
            c = b.getUint16();
          b.getBytes(60);
          var d = b.getUint16();
          if (4 > c && d & 768) return !1;
          c = b.getUint16();
          d = b.getUint16();
          if (c > d) return !1;
          b.getBytes(6);
          if (0 === b.getUint16()) return !1;
          a.data[8] = a.data[9] = 0;
          return !0;
        }
        function W(a, b, c) {
          c = c || { unitsPerEm: 0, yMax: 0, yMin: 0, ascent: 0, descent: 0 };
          var d = 0,
            g = 0,
            f = 0,
            h = 0,
            l = null,
            n = 0;
          if (b)
            for (var p in b) {
              p |= 0;
              if (l > p || !l) l = p;
              n < p && (n = p);
              b = (0, e.getUnicodeRangeFor)(p);
              if (32 > b) d |= 1 << b;
              else if (64 > b) g |= 1 << (b - 32);
              else if (96 > b) f |= 1 << (b - 64);
              else if (123 > b) h |= 1 << (b - 96);
              else throw new u.FormatError('Unicode ranges Bits > 123 are reserved for internal usage');
            }
          else (l = 0), (n = 255);
          b = a.bbox || [0, 0, 0, 0];
          p = c.unitsPerEm || 1 / (a.fontMatrix || u.FONT_IDENTITY_MATRIX)[0];
          var k = a.ascentScaled ? 1 : p / 1e3;
          p = c.ascent || Math.round(k * (a.ascent || b[3]));
          k = c.descent || Math.round(k * (a.descent || b[1]));
          0 < k && 0 < a.descent && 0 > b[1] && (k = -k);
          b = c.yMax || p;
          c = -c.yMin || -k;
          return (
            '\x00\u0003\u0002$\u0001\u00f4\x00\u0005\x00\x00\u0002\u008a\u0002\u00bb\x00\x00\x00\u008c\u0002\u008a\u0002\u00bb\x00\x00\u0001\u00df\x001\u0001\u0002\x00\x00\x00\x00\u0006' +
            String.fromCharCode(a.fixedPitch ? 9 : 0) +
            '\x00\x00\x00\x00\x00\x00' +
            (0, u.string32)(d) +
            (0, u.string32)(g) +
            (0, u.string32)(f) +
            (0, u.string32)(h) +
            '*21*' +
            t(a.italicAngle ? 1 : 0) +
            t(l || a.firstChar) +
            t(n || a.lastChar) +
            t(p) +
            t(k) +
            '\x00d' +
            t(b) +
            t(c) +
            '\x00\x00\x00\x00\x00\x00\x00\x00' +
            t(a.xHeight) +
            t(a.capHeight) +
            t(0) +
            t(l || a.firstChar) +
            '\x00\u0003'
          );
        }
        function Z(a) {
          var b = Math.floor(a.italicAngle * Math.pow(2, 16));
          return (
            '\x00\u0003\x00\x00' +
            (0, u.string32)(b) +
            '\x00\x00\x00\x00' +
            (0, u.string32)(a.fixedPitch) +
            '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00'
          );
        }
        function ea(a, b) {
          b || (b = [[], []]);
          var c = [
              b[0][0] || 'Original licence',
              b[0][1] || a,
              b[0][2] || 'Unknown',
              b[0][3] || 'uniqueID',
              b[0][4] || a,
              b[0][5] || 'Version 0.11',
              b[0][6] || '',
              b[0][7] || 'Unknown',
              b[0][8] || 'Unknown',
              b[0][9] || 'Unknown',
            ],
            d = [],
            e,
            g;
          var f = 0;
          for (e = c.length; f < e; f++) {
            var h = b[1][f] || c[f];
            var l = [];
            var n = 0;
            for (g = h.length; n < g; n++) l.push(t(h.charCodeAt(n)));
            d.push(l.join(''));
          }
          l = [c, d];
          var p = ['\x00\u0001', '\x00\u0003'],
            k = ['\x00\x00', '\x00\u0001'],
            m = ['\x00\x00', '\u0004\t'];
          f = c.length * p.length;
          var q = '\x00\x00' + t(f) + t(12 * f + 6),
            r = 0;
          f = 0;
          for (e = p.length; f < e; f++) {
            var v = l[f];
            n = 0;
            for (g = v.length; n < g; n++) {
              h = v[n];
              var u = p[f] + k[f] + m[f] + t(n) + t(h.length) + t(r);
              q += u;
              r += h.length;
            }
          }
          return (q += c.join('') + d.join(''));
        }
        d.getFontID = (function() {
          var a = 1;
          return function() {
            return String(a++);
          };
        })();
        d.prototype = {
          name: null,
          font: null,
          mimetype: null,
          encoding: null,
          get renderer() {
            var a = h.FontRendererFactory.create(this, q);
            return (0, u.shadow)(this, 'renderer', a);
          },
          exportData: function() {
            var a = {},
              b;
            for (b in this) this.hasOwnProperty(b) && (a[b] = this[b]);
            return a;
          },
          fallbackToSystemFont: function() {
            var a = this;
            this.missingFile = !0;
            var c,
              d,
              g = this.name,
              f = this.type,
              h = this.subtype,
              p = g.replace(/[,_]/g, '-'),
              k = (0, n.getStdFontMap)(),
              m = (0, n.getNonStdFontMap)(),
              q = !!k[p] || !(!m[p] || !k[m[p]]);
            p = k[p] || m[p] || p;
            this.bold = -1 !== p.search(/bold/gi);
            this.italic = -1 !== p.search(/oblique/gi) || -1 !== p.search(/italic/gi);
            this.black = -1 !== g.search(/Black/g);
            this.remeasure = 0 < Object.keys(this.widths).length;
            if (q && 'CIDFontType2' === f && 0 === this.cidEncoding.indexOf('Identity-')) {
              k = (0, n.getGlyphMapForStandardFonts)();
              var r = [];
              for (c in k) r[+c] = k[c];
              if (/Arial-?Black/i.test(g))
                for (c in ((g = (0, n.getSupplementalGlyphMapForArialBlack)()), g)) r[+c] = g[c];
              this.toUnicode instanceof J ||
                this.toUnicode.forEach(function(a, b) {
                  r[+a] = b;
                });
              this.toFontChar = r;
              this.toUnicode = new l(r);
            } else if (/Symbol/i.test(p))
              this.toFontChar = H(B.SymbolSetEncoding, (0, C.getGlyphsUnicode)(), this.differences);
            else if (/Dingbats/i.test(p))
              /Wingdings/i.test(g) && (0, u.warn)('Non-embedded Wingdings font, falling back to ZapfDingbats.'),
                (this.toFontChar = H(B.ZapfDingbatsEncoding, (0, C.getDingbatsGlyphsUnicode)(), this.differences));
            else if (q) this.toFontChar = H(this.defaultEncoding, (0, C.getGlyphsUnicode)(), this.differences);
            else {
              var t = (0, C.getGlyphsUnicode)();
              this.toUnicode.forEach(function(b, c) {
                if (!a.composite) {
                  var g = a.differences[b] || a.defaultEncoding[b];
                  d = (0, e.getUnicodeForGlyph)(g, t);
                  -1 !== d && (c = d);
                }
                a.toFontChar[b] = c;
              });
            }
            this.loadedName = p.split('-')[0];
            this.loading = !1;
            this.fontType = b(f, h);
          },
          checkAndRepair: function(b, c, d) {
            function e(a) {
              var b = (0, u.bytesToString)(a.getBytes(4)),
                c = a.getInt32() >>> 0,
                d = a.getInt32() >>> 0,
                e = a.getInt32() >>> 0,
                g = a.pos;
              a.pos = a.start ? a.start : 0;
              a.skip(d);
              var f = a.getBytes(e);
              a.pos = g;
              'head' === b && ((f[8] = f[9] = f[10] = f[11] = 0), (f[17] |= 32));
              return { tag: b, checksum: c, length: e, offset: d, data: f };
            }
            function h(a, b, c, d) {
              if (!a)
                return (
                  (0, u.warn)('No cmap table available.'),
                  { platformId: -1, encodingId: -1, mappings: [], hasShortCmap: !1 }
                );
              var e;
              a = (b.start ? b.start : 0) + a.offset;
              b.pos = a;
              b.getUint16();
              var g = b.getUint16(),
                f,
                h = !1;
              for (e = 0; e < g; e++) {
                var l = b.getUint16(),
                  n = b.getUint16(),
                  p = b.getInt32() >>> 0,
                  k = !1;
                if (!f || f.platformId !== l || f.encodingId !== n)
                  if (
                    (0 === l && 0 === n
                      ? (k = !0)
                      : 1 === l && 0 === n
                      ? (k = !0)
                      : 3 !== l || 1 !== n || (!d && f)
                      ? c && 3 === l && 0 === n && (h = k = !0)
                      : ((k = !0), c || (h = !0)),
                    k && (f = { platformId: l, encodingId: n, offset: p }),
                    h)
                  )
                    break;
              }
              f && (b.pos = a + f.offset);
              if (!f || -1 === b.peekByte())
                return (
                  (0, u.warn)('Could not find a preferred cmap table.'),
                  { platformId: -1, encodingId: -1, mappings: [], hasShortCmap: !1 }
                );
              a = b.getUint16();
              b.getUint16();
              b.getUint16();
              d = !1;
              c = [];
              if (0 === a) {
                for (e = 0; 256 > e; e++) (a = b.getByte()) && c.push({ charCode: e, glyphId: a });
                d = !0;
              } else if (4 === a) {
                g = b.getUint16() >> 1;
                b.getBytes(6);
                l = [];
                for (h = 0; h < g; h++) l.push({ end: b.getUint16() });
                b.getUint16();
                for (h = 0; h < g; h++) l[h].start = b.getUint16();
                for (h = 0; h < g; h++) l[h].delta = b.getUint16();
                for (h = a = 0; h < g; h++)
                  (e = l[h]),
                    (n = b.getUint16())
                      ? ((p = (n >> 1) - (g - h)), (e.offsetIndex = p), (a = Math.max(a, p + e.end - e.start + 1)))
                      : (e.offsetIndex = -1);
                k = [];
                for (e = 0; e < a; e++) k.push(b.getUint16());
                for (h = 0; h < g; h++) {
                  e = l[h];
                  a = e.start;
                  b = e.end;
                  var m = e.delta;
                  p = e.offsetIndex;
                  for (e = a; e <= b; e++)
                    65535 !== e &&
                      ((n = 0 > p ? e : k[p + e - a]), (n = (n + m) & 65535), c.push({ charCode: e, glyphId: n }));
                }
              } else if (6 === a)
                for (a = b.getUint16(), g = b.getUint16(), e = 0; e < g; e++)
                  (n = b.getUint16()), c.push({ charCode: a + e, glyphId: n });
              else
                return (
                  (0, u.warn)('cmap table has unsupported format: ' + a),
                  { platformId: -1, encodingId: -1, mappings: [], hasShortCmap: !1 }
                );
              c.sort(function(a, b) {
                return a.charCode - b.charCode;
              });
              for (e = 1; e < c.length; e++) c[e - 1].charCode === c[e].charCode && (c.splice(e, 1), e--);
              return { platformId: f.platformId, encodingId: f.encodingId, mappings: c, hasShortCmap: d };
            }
            function l(a, b, c, d, e, g) {
              if (12 >= c - b) return 0;
              a = a.subarray(b, c);
              var f = (a[0] << 8) | a[1];
              if (f & 32768) return d.set(a, e), a.length;
              c = 10;
              var h = 0;
              for (b = 0; b < f; b++) (h = ((a[c] << 8) | a[c + 1]) + 1), (c += 2);
              f = c;
              var l = (a[c] << 8) | a[c + 1],
                n = (c += 2 + l),
                p = 0;
              for (b = 0; b < h; b++) {
                var k = a[c++];
                k & 192 && (a[c - 1] = k & 63);
                var m = (k & 2 ? 1 : k & 16 ? 0 : 2) + (k & 4 ? 1 : k & 32 ? 0 : 2);
                p += m;
                k & 8 && ((k = a[c++]), (b += k), (p += k * m));
              }
              if (0 === p) return 0;
              b = c + p;
              if (b > a.length) return 0;
              if (!g && 0 < l)
                return (
                  d.set(a.subarray(0, f), e),
                  d.set([0, 0], e + f),
                  d.set(a.subarray(n, b), e + f + 2),
                  (b -= l),
                  3 < a.length - b && (b = (b + 3) & -4),
                  b
                );
              if (3 < a.length - b) return (b = (b + 3) & -4), d.set(a.subarray(0, b), e), b;
              d.set(a, e);
              return a.length;
            }
            function n(a, b, c, d, e, g) {
              if (d) {
                d = 4;
                var f = function(a, b) {
                  return (a[b] << 24) | (a[b + 1] << 16) | (a[b + 2] << 8) | a[b + 3];
                };
                var h = function(a, b, c) {
                  a[b] = (c >>> 24) & 255;
                  a[b + 1] = (c >> 16) & 255;
                  a[b + 2] = (c >> 8) & 255;
                  a[b + 3] = c & 255;
                };
              } else
                (d = 2),
                  (f = function(a, b) {
                    return (a[b] << 9) | (a[b + 1] << 1);
                  }),
                  (h = function(a, b, c) {
                    a[b] = (c >> 9) & 255;
                    a[b + 1] = (c >> 1) & 255;
                  });
              var n = a.data,
                p = d * (1 + c);
              n.length !== p && ((n = new Uint8Array(p)), n.set(a.data.subarray(0, p)), (a.data = n));
              var k = b.data,
                m = k.length,
                q = new Uint8Array(m),
                r = f(n, 0),
                t = 0;
              p = Object.create(null);
              h(n, 0, t);
              var v,
                u = g ? c - 1 : c;
              var x = 0;
              for (v = d; x < u; x++, v += d) {
                var w = f(n, v);
                w > m && ((m + 3) & -4) === w && (w = m);
                w > m && (r = w);
                r = l(k, r, w, q, t, e);
                0 === r && (p[x] = !0);
                t += r;
                h(n, v, t);
                r = w;
              }
              if (0 === t) {
                a = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
                x = 0;
                for (v = d; x < c; x++, v += d) h(n, v, a.length);
                b.data = a;
                return p;
              }
              g
                ? ((c = f(n, d)),
                  q.length > c + t
                    ? (b.data = q.subarray(0, c + t))
                    : ((b.data = new Uint8Array(c + t)), b.data.set(q.subarray(0, t))),
                  b.data.set(q.subarray(0, c), t),
                  h(a.data, n.length - d, t + c))
                : (b.data = q.subarray(0, t));
              return p;
            }
            function k(a, b, d) {
              var e = (c.start ? c.start : 0) + a.offset;
              c.pos = e;
              e += a.length;
              var f = c.getInt32();
              c.getBytes(28);
              a = !0;
              switch (f) {
                case 65536:
                  var h = g;
                  break;
                case 131072:
                  f = c.getUint16();
                  if (f !== d) {
                    a = !1;
                    break;
                  }
                  var l = [];
                  for (d = 0; d < f; ++d) {
                    var n = c.getUint16();
                    if (32768 <= n) {
                      a = !1;
                      break;
                    }
                    l.push(n);
                  }
                  if (!a) break;
                  n = [];
                  for (h = []; c.pos < e; ) {
                    var p = c.getByte();
                    h.length = p;
                    for (d = 0; d < p; ++d) h[d] = String.fromCharCode(c.getByte());
                    n.push(h.join(''));
                  }
                  h = [];
                  for (d = 0; d < f; ++d) (e = l[d]), 258 > e ? h.push(g[e]) : h.push(n[e - 258]);
                  break;
                case 196608:
                  break;
                default:
                  (0, u.warn)('Unknown/unsupported post table version ' + f),
                    (a = !1),
                    b.defaultEncoding && (h = b.defaultEncoding);
              }
              b.glyphNames = h;
              return a;
            }
            function r(a) {
              var b = (c.start ? c.start : 0) + a.offset;
              c.pos = b;
              var d = [[], []],
                e = a.length;
              a = b + e;
              if (0 !== c.getUint16() || 6 > e) return d;
              var g = c.getUint16();
              e = c.getUint16();
              var f = [],
                h;
              for (h = 0; h < g && c.pos + 12 <= a; h++) {
                var l = {
                  platform: c.getUint16(),
                  encoding: c.getUint16(),
                  language: c.getUint16(),
                  name: c.getUint16(),
                  length: c.getUint16(),
                  offset: c.getUint16(),
                };
                ((1 === l.platform && 0 === l.encoding && 0 === l.language) ||
                  (3 === l.platform && 1 === l.encoding && 1033 === l.language)) &&
                  f.push(l);
              }
              h = 0;
              for (g = f.length; h < g; h++)
                if (((l = f[h]), !(0 >= l.length))) {
                  var n = b + e + l.offset;
                  if (!(n + l.length > a))
                    if (((c.pos = n), (n = l.name), l.encoding)) {
                      var p = '',
                        k = 0;
                      for (l = l.length; k < l; k += 2) p += String.fromCharCode(c.getUint16());
                      d[1][n] = p;
                    } else d[0][n] = (0, u.bytesToString)(c.getBytes(l.length));
                }
              return d;
            }
            function t(a, b) {
              for (
                var c = a.data,
                  d = 0,
                  e,
                  g,
                  f,
                  h = 0,
                  l = 0,
                  n = [],
                  p = [],
                  k = [],
                  m = b.tooComplexToFollowFunctions,
                  q = !1,
                  r = 0,
                  t = 0,
                  v = c.length;
                d < v;

              ) {
                var w = c[d++];
                if (64 === w)
                  if (((g = c[d++]), q || t)) d += g;
                  else for (e = 0; e < g; e++) n.push(c[d++]);
                else if (65 === w)
                  if (((g = c[d++]), q || t)) d += 2 * g;
                  else for (e = 0; e < g; e++) (f = c[d++]), n.push((f << 8) | c[d++]);
                else if (176 === (w & 248))
                  if (((g = w - 176 + 1), q || t)) d += g;
                  else for (e = 0; e < g; e++) n.push(c[d++]);
                else if (184 === (w & 248))
                  if (((g = w - 184 + 1), q || t)) d += 2 * g;
                  else for (e = 0; e < g; e++) (f = c[d++]), n.push((f << 8) | c[d++]);
                else if (43 !== w || m)
                  if (44 !== w || m)
                    if (45 === w)
                      if (q) (q = !1), (h = d);
                      else {
                        e = p.pop();
                        if (!e) {
                          (0, u.warn)('TT: ENDF bad stack');
                          b.hintsValid = !1;
                          return;
                        }
                        g = k.pop();
                        c = e.data;
                        d = e.i;
                        b.functionsStackDeltas[g] = n.length - e.stackTop;
                      }
                    else if (137 === w) {
                      if (q || t) (0, u.warn)('TT: nested IDEFs not allowed'), (m = !0);
                      q = !0;
                      l = d;
                    } else
                      88 === w
                        ? ++r
                        : 27 === w
                        ? (t = r)
                        : 89 === w
                        ? (t === r && (t = 0), --r)
                        : 28 !== w || q || t || ((g = n[n.length - 1]), 0 < g && (d += g - 1));
                  else {
                    if (q || t) (0, u.warn)('TT: nested FDEFs not allowed'), (m = !0);
                    q = !0;
                    l = d;
                    g = n.pop();
                    b.functionsDefined[g] = { data: c, i: d };
                  }
                else if (!q && !t)
                  if (((g = n[n.length - 1]), (b.functionsUsed[g] = !0), g in b.functionsStackDeltas))
                    n.length += b.functionsStackDeltas[g];
                  else if (g in b.functionsDefined && 0 > k.indexOf(g)) {
                    p.push({ data: c, i: d, stackTop: n.length - 1 });
                    k.push(g);
                    e = b.functionsDefined[g];
                    if (!e) {
                      (0, u.warn)('TT: CALL non-existent function');
                      b.hintsValid = !1;
                      return;
                    }
                    c = e.data;
                    d = e.i;
                  }
                if (!q && !t) {
                  e = 142 >= w ? x[w] : 192 <= w && 223 >= w ? -1 : 224 <= w ? -2 : 0;
                  113 <= w && 117 >= w && ((g = n.pop()), isNaN(g) || (e = 2 * -g));
                  for (; 0 > e && 0 < n.length; ) n.pop(), e++;
                  for (; 0 < e; ) n.push(NaN), e--;
                }
              }
              b.tooComplexToFollowFunctions = m;
              n = [c];
              d > c.length && n.push(new Uint8Array(d - c.length));
              l > h && ((0, u.warn)('TT: complementing a missing function tail'), n.push(new Uint8Array([34, 45])));
              if (1 < n.length) {
                d = c = 0;
                for (h = n.length; d < h; d++) c += n[d].length;
                c = (c + 3) & -4;
                l = new Uint8Array(c);
                d = p = 0;
                for (h = n.length; d < h; d++) l.set(n[d], p), (p += n[d].length);
                a.data = l;
                a.length = c;
              }
            }
            var x = [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              -2,
              -2,
              -2,
              -2,
              0,
              0,
              -2,
              -5,
              -1,
              -1,
              -1,
              -1,
              -1,
              -1,
              -1,
              -1,
              0,
              0,
              -1,
              0,
              -1,
              -1,
              -1,
              -1,
              1,
              -1,
              -999,
              0,
              1,
              0,
              -1,
              -2,
              0,
              -1,
              -2,
              -1,
              -1,
              0,
              -1,
              -1,
              0,
              0,
              -999,
              -999,
              -1,
              -1,
              -1,
              -1,
              -2,
              -999,
              -2,
              -2,
              -999,
              0,
              -2,
              -2,
              0,
              0,
              -2,
              0,
              -2,
              0,
              0,
              0,
              -2,
              -1,
              -1,
              1,
              1,
              0,
              0,
              -1,
              -1,
              -1,
              -1,
              -1,
              -1,
              -1,
              0,
              0,
              -1,
              0,
              -1,
              -1,
              0,
              -999,
              -1,
              -1,
              -1,
              -1,
              -1,
              -1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              -2,
              -999,
              -999,
              -999,
              -999,
              -999,
              -1,
              -1,
              -2,
              -2,
              0,
              0,
              0,
              0,
              -1,
              -1,
              -999,
              -2,
              -2,
              0,
              0,
              -1,
              -2,
              -2,
              0,
              0,
              0,
              -1,
              -1,
              -1,
              -2,
            ];
            c = new p.Stream(new Uint8Array(c.getBytes()));
            var w = 'OS/2;cmap;head;hhea;hmtx;maxp;name;post;loca;glyf;fpgm;prep;cvt ;CFF '.split(';'),
              A = (function(a) {
                return {
                  version: (0, u.bytesToString)(a.getBytes(4)),
                  numTables: a.getUint16(),
                  searchRange: a.getUint16(),
                  entrySelector: a.getUint16(),
                  rangeShift: a.getUint16(),
                };
              })(c),
              D = A.numTables,
              y = Object.create(null);
            y['OS/2'] = null;
            y.cmap = null;
            y.head = null;
            y.hhea = null;
            y.hmtx = null;
            y.maxp = null;
            y.name = null;
            y.post = null;
            for (var F, E = 0; E < D; E++) (F = e(c)), 0 > w.indexOf(F.tag) || (0 !== F.length && (y[F.tag] = F));
            if ((w = !y['CFF '])) {
              if (!y.loca) throw new u.FormatError('Required "loca" table is not found');
              y.glyf ||
                ((0, u.warn)('Required "glyf" table is not found -- trying to recover.'),
                (y.glyf = { tag: 'glyf', data: new Uint8Array(0) }));
              this.isOpenType = !1;
            } else {
              if (!(('OTTO' !== A.version || (d.composite && d.cidToGidMap)) && y.head && y.hhea && y.maxp && y.post)) {
                var G = new p.Stream(y['CFF '].data);
                var H = new L(G, d);
                a(d);
                return this.convert(b, H, d);
              }
              delete y.glyf;
              delete y.loca;
              delete y.fpgm;
              delete y.prep;
              delete y['cvt '];
              this.isOpenType = !0;
            }
            if (!y.maxp) throw new u.FormatError('Required "maxp" table is not found');
            c.pos = (c.start || 0) + y.maxp.offset;
            E = c.getInt32();
            var J = c.getUint16();
            D = 0;
            65536 <= E &&
              22 <= y.maxp.length &&
              ((c.pos += 8),
              2 < c.getUint16() && ((y.maxp.data[14] = 0), (y.maxp.data[15] = 2)),
              (c.pos += 4),
              (D = c.getUint16()));
            E = !1;
            'CIDFontType2' === d.type &&
              d.toUnicode &&
              '\x00' < d.toUnicode.get(0) &&
              ((E = !0), J++, (y.maxp.data[4] = J >> 8), (y.maxp.data[5] = J & 255));
            D = (function(a, b, c, d) {
              var e = {
                functionsDefined: [],
                functionsUsed: [],
                functionsStackDeltas: [],
                tooComplexToFollowFunctions: !1,
                hintsValid: !0,
              };
              a && t(a, e);
              b && t(b, e);
              if (a && !e.tooComplexToFollowFunctions)
                if (e.functionsDefined.length > d)
                  (0, u.warn)('TT: more functions defined than expected'), (e.hintsValid = !1);
                else
                  for (a = 0, b = e.functionsUsed.length; a < b; a++) {
                    if (a > d) {
                      (0, u.warn)('TT: invalid function id: ' + a);
                      e.hintsValid = !1;
                      break;
                    }
                    if (e.functionsUsed[a] && !e.functionsDefined[a]) {
                      (0, u.warn)('TT: undefined function: ' + a);
                      e.hintsValid = !1;
                      break;
                    }
                  }
              c && c.length & 1 && ((d = new Uint8Array(c.length + 1)), d.set(c.data), (c.data = d));
              return e.hintsValid;
            })(y.fpgm, y.prep, y['cvt '], D);
            D || (delete y.fpgm, delete y.prep, delete y['cvt ']);
            (function(a, b, c, d) {
              b
                ? ((a.pos = (a.start ? a.start : 0) + b.offset),
                  (a.pos += b.length - 2),
                  (a = a.getUint16()),
                  a > d &&
                    ((0, u.info)('The numOfMetrics (' + a + ') should not be greater than the numGlyphs (' + d + ')'),
                    (a = d),
                    (b.data[34] = (a & 65280) >> 8),
                    (b.data[35] = a & 255)),
                  (b = d - a - ((c.length - 4 * a) >> 1)),
                  0 < b && ((b = new Uint8Array(c.length + 2 * b)), b.set(c.data), (c.data = b)))
                : c && (c.data = null);
            })(c, y.hhea, y.hmtx, J);
            if (!y.head) throw new u.FormatError('Required "head" table is not found');
            (function(a, b, c) {
              a = a.data;
              var d = (a[0] << 24) + (a[1] << 16) + (a[2] << 8) + a[3];
              1 !== d >> 16 &&
                ((0, u.info)('Attempting to fix invalid version in head table: ' + d),
                (a[0] = 0),
                (a[1] = 1),
                (a[2] = 0),
                (a[3] = 0));
              d = (a[50] << 8) + a[51];
              if (0 > d || 1 < d)
                if (
                  ((0, u.info)('Attempting to fix invalid indexToLocFormat in head table: ' + d),
                  (b += 1),
                  c === b << 1)
                )
                  (a[50] = 0), (a[51] = 0);
                else if (c === b << 2) (a[50] = 0), (a[51] = 1);
                else throw new u.FormatError('Could not fix indexToLocFormat: ' + d);
            })(y.head, J, w ? y.loca.length : 0);
            var I = Object.create(null);
            w && (I = n(y.loca, y.glyf, J, (y.head.data[50] << 8) + y.head.data[51], D, E));
            if (!y.hhea) throw new u.FormatError('Required "hhea" table is not found');
            0 === y.hhea.data[10] && 0 === y.hhea.data[11] && ((y.hhea.data[10] = 255), (y.hhea.data[11] = 255));
            D = {
              unitsPerEm: (y.head.data[18] << 8) + y.head.data[19],
              yMax: (y.head.data[42] << 8) + y.head.data[43],
              yMin: m(y.head.data[38], y.head.data[39]),
              ascent: (y.hhea.data[4] << 8) + y.hhea.data[5],
              descent: m(y.hhea.data[6], y.hhea.data[7]),
            };
            this.ascent = D.ascent / D.unitsPerEm;
            this.descent = D.descent / D.unitsPerEm;
            y.post && (k(y.post, d, J) || (y.post = null));
            var K = [],
              O;
            if (d.composite) {
              var aa = d.cidToGidMap || [],
                ba = 0 === aa.length;
              d.cMap.forEach(function(a, b) {
                if (65535 < b) throw new u.FormatError('Max size of CID is 65,535');
                var c = -1;
                ba ? (c = b) : void 0 !== aa[b] && (c = aa[b]);
                0 <= c && c < J && !I[c] && (K[a] = c);
              });
              !E || (!ba && K[0]) || (K[0] = J - 1);
            } else {
              E = h(y.cmap, c, this.isSymbolicFont, d.hasEncoding);
              F = E.platformId;
              var X = E.encodingId,
                ya = E.mappings,
                ma = ya.length;
              if (
                (d.hasEncoding && ((3 === F && 1 === X) || (1 === F && 0 === X))) ||
                (-1 === F && -1 === X && (0, B.getEncoding)(d.baseEncodingName))
              ) {
                var la = [];
                if ('MacRomanEncoding' === d.baseEncodingName || 'WinAnsiEncoding' === d.baseEncodingName)
                  la = (0, B.getEncoding)(d.baseEncodingName);
                var pa = (0, C.getGlyphsUnicode)();
                for (O = 0; 256 > O; O++) {
                  var va;
                  if (
                    (va =
                      this.differences && O in this.differences
                        ? this.differences[O]
                        : O in la && '' !== la[O]
                        ? la[O]
                        : B.StandardEncoding[O])
                  ) {
                    var Ba = v(va, pa);
                    var ta;
                    3 === F && 1 === X ? (ta = pa[Ba]) : 1 === F && 0 === X && (ta = B.MacRomanEncoding.indexOf(Ba));
                    var Ta = !1;
                    for (E = 0; E < ma; ++E)
                      if (ya[E].charCode === ta) {
                        K[O] = ya[E].glyphId;
                        Ta = !0;
                        break;
                      }
                    !Ta &&
                      d.glyphNames &&
                      ((E = d.glyphNames.indexOf(va)),
                      -1 === E && Ba !== va && (E = d.glyphNames.indexOf(Ba)),
                      0 < E && !I[E] && ((K[O] = E), (Ta = !0)));
                  }
                }
              } else if (0 === F && 0 === X) for (E = 0; E < ma; ++E) K[ya[E].charCode] = ya[E].glyphId;
              else
                for (E = 0; E < ma; ++E)
                  (O = ya[E].charCode), 3 === F && 61440 <= O && 61695 >= O && (O &= 255), (K[O] = ya[E].glyphId);
            }
            0 === K.length && (K[0] = 0);
            ta = M(K, d, I);
            this.toFontChar = ta.toFontChar;
            y.cmap = { tag: 'cmap', data: N(ta.charCodeToGlyphId, J) };
            (y['OS/2'] && da(y['OS/2'])) || (y['OS/2'] = { tag: 'OS/2', data: W(d, ta.charCodeToGlyphId, D) });
            y.post || (y.post = { tag: 'post', data: Z(d) });
            if (!w)
              try {
                G = new p.Stream(y['CFF '].data);
                H = new z.CFFParser(G, d, q).parse();
                var qa = new z.CFFCompiler(H);
                y['CFF '].data = qa.compile();
              } catch (ia) {
                (0, u.warn)('Failed to compile font ' + d.loadedName);
              }
            y.name ? ((d = r(y.name)), (y.name.data = ea(b, d))) : (y.name = { tag: 'name', data: ea(this.name) });
            b = new f(A.version);
            for (var ra in y) b.addTable(ra, y[ra].data);
            return b.toArray();
          },
          convert: function(a, b, c) {
            function d(a, b) {
              var c = null,
                d;
              for (d in a) b === a[d] && (c || (c = []), c.push(d | 0));
              return c;
            }
            function e(a, b) {
              for (var c in a) if (b === a[c]) return c | 0;
              h.charCodeToGlyphId[h.nextAvailableFontCharCode] = b;
              return h.nextAvailableFontCharCode++;
            }
            c.fixedPitch = !1;
            c.builtInEncoding && k(c, c.builtInEncoding);
            var g = b.getGlyphMapping(c),
              h = M(g, c, Object.create(null));
            this.toFontChar = h.toFontChar;
            var l = b.numGlyphs,
              n = b.seacs;
            if (q && n && n.length) {
              var p = c.fontMatrix || u.FONT_IDENTITY_MATRIX,
                m = b.getCharset(),
                r = Object.create(null),
                v;
              for (v in n) {
                v |= 0;
                var x = n[v],
                  w = B.StandardEncoding[x[3]],
                  z = m.indexOf(B.StandardEncoding[x[2]]);
                w = m.indexOf(w);
                if (!(0 > z || 0 > w)) {
                  x = { x: x[0] * p[0] + x[1] * p[2] + p[4], y: x[0] * p[1] + x[1] * p[3] + p[5] };
                  var y = d(g, v);
                  if (y)
                    for (var D = 0, C = y.length; D < C; D++) {
                      var F = y[D],
                        E = h.charCodeToGlyphId,
                        G = e(E, z);
                      E = e(E, w);
                      r[F] = { baseFontCharCode: G, accentFontCharCode: E, accentOffset: x };
                    }
                }
              }
              c.seacMap = r;
            }
            g = 1 / (c.fontMatrix || u.FONT_IDENTITY_MATRIX)[0];
            n = new f('OTTO');
            n.addTable('CFF ', b.data);
            n.addTable('OS/2', W(c, h.charCodeToGlyphId));
            n.addTable('cmap', N(h.charCodeToGlyphId, l));
            n.addTable(
              'head',
              '\x00\u0001\x00\x00\x00\x00\u0010\x00\x00\x00\x00\x00_\u000f<\u00f5\x00\x00' +
                A(g) +
                "\x00\x00\x00\x00\u009e\x0B~'\x00\x00\x00\x00\u009e\x0B~'\x00\x00" +
                A(c.descent) +
                '\u000f\u00ff' +
                A(c.ascent) +
                t(c.italicAngle ? 2 : 0) +
                '\x00\u0011\x00\x00\x00\x00\x00\x00',
            );
            n.addTable(
              'hhea',
              '\x00\u0001\x00\x00' +
                A(c.ascent) +
                A(c.descent) +
                '\x00\x00\u00ff\u00ff\x00\x00\x00\x00\x00\x00' +
                A(c.capHeight) +
                A(Math.tan(c.italicAngle) * c.xHeight) +
                '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00' +
                t(l),
            );
            n.addTable(
              'hmtx',
              (function() {
                for (
                  var a = b.charstrings, c = b.cff ? b.cff.widths : null, d = '\x00\x00\x00\x00', e = 1;
                  e < l;
                  e++
                ) {
                  var g = 0;
                  a ? ((g = a[e - 1]), (g = 'width' in g ? g.width : 0)) : c && (g = Math.ceil(c[e] || 0));
                  d += t(g) + t(0);
                }
                return d;
              })(),
            );
            n.addTable('maxp', '\x00\x00P\x00' + t(l));
            n.addTable('name', ea(a));
            n.addTable('post', Z(c));
            return n.toArray();
          },
          get spaceWidth() {
            if ('_shadowWidth' in this) return this._shadowWidth;
            for (var a = ['space', 'minus', 'one', 'i', 'I'], b, c = 0, d = a.length; c < d; c++) {
              b = a[c];
              if (b in this.widths) {
                b = this.widths[b];
                break;
              }
              b = (0, C.getGlyphsUnicode)()[b];
              var e = 0;
              this.composite && this.cMap.contains(b) && (e = this.cMap.lookup(b));
              !e && this.toUnicode && (e = this.toUnicode.charCodeOf(b));
              0 >= e && (e = b);
              if ((b = this.widths[e])) break;
            }
            return (this._shadowWidth = b = b || this.defaultWidth);
          },
          charToGlyph: function(a, b) {
            var c,
              d = a;
            this.cMap && this.cMap.contains(a) && (d = this.cMap.lookup(a));
            var g = this.widths[d];
            g = (0, u.isNum)(g) ? g : this.defaultWidth;
            d = this.vmetrics && this.vmetrics[d];
            var f = this.toUnicode.get(a) || a;
            'number' === typeof f && (f = String.fromCharCode(f));
            var h = a in this.toFontChar;
            var l = this.toFontChar[a] || a;
            this.missingFile && (l = (0, e.mapSpecialUnicodeValues)(l));
            this.isType3Font && (c = l);
            var n = null;
            this.seacMap &&
              this.seacMap[a] &&
              ((h = !0),
              (n = this.seacMap[a]),
              (l = n.baseFontCharCode),
              (n = { fontChar: String.fromCharCode(n.accentFontCharCode), offset: n.accentOffset }));
            l = String.fromCharCode(l);
            var p = this.glyphCache[a];
            (p && p.matchesForCache(l, f, n, g, d, c, b, h)) ||
              ((p = new G(l, f, n, g, d, c, b, h)), (this.glyphCache[a] = p));
            return p;
          },
          charsToGlyphs: function(a) {
            var b = this.charsCache,
              c;
            if (b && (c = b[a])) return c;
            b || (b = this.charsCache = Object.create(null));
            c = [];
            var d = 0,
              e;
            if (this.cMap)
              for (e = Object.create(null); d < a.length; ) {
                this.cMap.readCharCode(a, d, e);
                var g = e.charcode;
                var f = e.length;
                d += f;
                f = 1 === f && 32 === a.charCodeAt(d - 1);
                g = this.charToGlyph(g, f);
                c.push(g);
              }
            else
              for (d = 0, e = a.length; d < e; ++d)
                (g = a.charCodeAt(d)), (g = this.charToGlyph(g, 32 === g)), c.push(g);
            return (b[a] = c);
          },
        };
        return d;
      })();
      t = (function() {
        function a(a) {
          this.error = a;
          this.loadedName = 'g_font_error';
          this.loading = !1;
        }
        a.prototype = {
          charsToGlyphs: function() {
            return [];
          },
          exportData: function() {
            return { error: this.error };
          },
        };
        return a;
      })();
      var D = (function() {
          function a(a, b, c) {
            for (var d = a.length, e = b.length, g = d - e, f, h = !1; c < g; ) {
              for (f = 0; f < e && a[c + f] === b[f]; ) f++;
              if (f >= e) {
                for (c += f; c < d && (0, u.isSpace)(a[c]); ) c++;
                h = !0;
                break;
              }
              c++;
            }
            return { found: h, length: c };
          }
          function b(b, c, d) {
            var e = d.length1,
              g = c.peekBytes(6),
              f = 128 === g[0] && 1 === g[1];
            f && (c.skip(6), (e = (g[5] << 24) | (g[4] << 16) | (g[3] << 8) | g[2]));
            a: {
              g = [101, 101, 120, 101, 99];
              var h = c.pos;
              try {
                var l = c.getBytes(e);
                var n = l.length;
              } catch (aa) {
                if (aa instanceof u.MissingDataException) throw aa;
              }
              if (n === e && ((n = a(l, g, e - 2 * g.length)), n.found && n.length === e)) {
                var k = new p.Stream(l);
                break a;
              }
              (0, u.warn)('Invalid "Length1" property in Type1 font -- trying to recover.');
              for (c.pos = h; ; ) {
                l = c.peekBytes(2048);
                n = a(l, g, 0);
                if (0 === n.length) break;
                c.pos += n.length;
                if (n.found) {
                  k = c.pos - h;
                  break;
                }
              }
              c.pos = h;
              k
                ? (k = new p.Stream(c.getBytes(k)))
                : ((0, u.warn)('Unable to recover "Length1" property in Type1 font -- using as is.'),
                  (k = new p.Stream(c.getBytes(e))));
            }
            new A.Type1Parser(k, !1, q).extractFontHeader(d);
            f && c.getBytes(6);
            c = c.getBytes();
            c = new p.Stream(c);
            c = new A.Type1Parser(c, !0, q).extractFontProgram();
            for (var m in c.properties) d[m] = c.properties[m];
            m = c.charstrings;
            f = this.getType2Charstrings(m);
            k = this.getType2Subrs(c.subrs);
            this.charstrings = m;
            this.data = this.wrap(b, f, this.charstrings, k, d);
            this.seacs = this.getSeacs(c.charstrings);
          }
          b.prototype = {
            get numGlyphs() {
              return this.charstrings.length + 1;
            },
            getCharset: function() {
              for (var a = ['.notdef'], b = this.charstrings, c = 0; c < b.length; c++) a.push(b[c].glyphName);
              return a;
            },
            getGlyphMapping: function(a) {
              var b = this.charstrings,
                c = ['.notdef'],
                e;
              for (e = 0; e < b.length; e++) c.push(b[e].glyphName);
              if ((b = a.builtInEncoding)) {
                var g = Object.create(null),
                  f;
                for (f in b) (e = c.indexOf(b[f])), 0 <= e && (g[f] = e);
              }
              return d(a, g, c);
            },
            getSeacs: function(a) {
              var b,
                c = [];
              var d = 0;
              for (b = a.length; d < b; d++) {
                var e = a[d];
                e.seac && (c[d + 1] = e.seac);
              }
              return c;
            },
            getType2Charstrings: function(a) {
              for (var b = [], c = 0, d = a.length; c < d; c++) b.push(a[c].charstring);
              return b;
            },
            getType2Subrs: function(a) {
              var b = a.length;
              var c = 1133 > b ? 107 : 33769 > b ? 1131 : 32768;
              var d = [],
                e;
              for (e = 0; e < c; e++) d.push([11]);
              for (e = 0; e < b; e++) d.push(a[e]);
              return d;
            },
            wrap: function(a, b, c, d, e) {
              var g = new z.CFF();
              g.header = new z.CFFHeader(1, 0, 4, 4);
              g.names = [a];
              var f = new z.CFFTopDict();
              f.setByName('version', 391);
              f.setByName('Notice', 392);
              f.setByName('FullName', 393);
              f.setByName('FamilyName', 394);
              f.setByName('Weight', 395);
              f.setByName('Encoding', null);
              f.setByName('FontMatrix', e.fontMatrix);
              f.setByName('FontBBox', e.bbox);
              f.setByName('charset', null);
              f.setByName('CharStrings', null);
              f.setByName('Private', null);
              g.topDict = f;
              f = new z.CFFStrings();
              f.add('Version 0.11');
              f.add('See original notice');
              f.add(a);
              f.add(a);
              f.add('Medium');
              g.strings = f;
              g.globalSubrIndex = new z.CFFIndex();
              f = b.length;
              var h = [0];
              for (a = 0; a < f; a++) {
                var l = z.CFFStandardStrings.indexOf(c[a].glyphName);
                -1 === l && (l = 0);
                h.push((l >> 8) & 255, l & 255);
              }
              g.charset = new z.CFFCharset(!1, 0, [], h);
              c = new z.CFFIndex();
              c.add([139, 14]);
              for (a = 0; a < f; a++) (h = b[a]), 0 === h.length ? c.add([139, 14]) : c.add(h);
              g.charStrings = c;
              c = new z.CFFPrivateDict();
              c.setByName('Subrs', null);
              f = 'BlueValues OtherBlues FamilyBlues FamilyOtherBlues StemSnapH StemSnapV BlueShift BlueFuzz BlueScale LanguageGroup ExpansionFactor ForceBold StdHW StdVW'.split(
                ' ',
              );
              a = 0;
              for (b = f.length; a < b; a++)
                if (((h = f[a]), h in e.privateData)) {
                  l = e.privateData[h];
                  if (Array.isArray(l)) for (var n = l.length - 1; 0 < n; n--) l[n] -= l[n - 1];
                  c.setByName(h, l);
                }
              g.topDict.privateDict = c;
              e = new z.CFFIndex();
              a = 0;
              for (b = d.length; a < b; a++) e.add(d[a]);
              c.subrsIndex = e;
              return new z.CFFCompiler(g).compile();
            },
          };
          return b;
        })(),
        L = (function() {
          function a(a, b) {
            this.properties = b;
            this.cff = new z.CFFParser(a, b, q).parse();
            var c = new z.CFFCompiler(this.cff);
            this.seacs = this.cff.seacs;
            try {
              this.data = c.compile();
            } catch (K) {
              (0, u.warn)('Failed to compile font ' + b.loadedName), (this.data = a);
            }
          }
          a.prototype = {
            get numGlyphs() {
              return this.cff.charStrings.count;
            },
            getCharset: function() {
              return this.cff.charset.charset;
            },
            getGlyphMapping: function() {
              var a = this.cff,
                b = this.properties,
                c = a.charset.charset,
                e;
              if (b.composite) {
                var g = Object.create(null);
                if (a.isCIDFont) for (e = 0; e < c.length; e++) (a = b.cMap.charCodeOf(c[e])), (g[a] = e);
                else for (e = 0; e < a.charStrings.count; e++) g[e] = e;
                return g;
              }
              return (g = d(b, a.encoding ? a.encoding.encoding : null, c));
            },
          };
          return a;
        })();
      'undefined' !== typeof navigator && /Windows/.test(navigator.userAgent) && (m.SEAC_ANALYSIS_ENABLED = q = !0);
      'undefined' !== typeof navigator && /Windows.*Chrome/.test(navigator.userAgent) && (c = !0);
      m.SEAC_ANALYSIS_ENABLED = q;
      m.PRIVATE_USE_OFFSET_START = 57344;
      m.PRIVATE_USE_OFFSET_END = 63743;
      m.ErrorFont = t;
      m.Font = y;
      m.FontFlags = x;
      m.ToUnicodeMap = l;
      m.IdentityToUnicodeMap = J;
      m.ProblematicCharRanges = r;
      m.getFontType = b;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.ISOAdobeCharset = '.notdef space exclam quotedbl numbersign dollar percent ampersand quoteright parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore quoteleft a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde exclamdown cent sterling fraction yen florin section currency quotesingle quotedblleft guillemotleft guilsinglleft guilsinglright fi fl endash dagger daggerdbl periodcentered paragraph bullet quotesinglbase quotedblbase quotedblright guillemotright ellipsis perthousand questiondown grave acute circumflex tilde macron breve dotaccent dieresis ring cedilla hungarumlaut ogonek caron emdash AE ordfeminine Lslash Oslash OE ordmasculine ae dotlessi lslash oslash oe germandbls onesuperior logicalnot mu trademark Eth onehalf plusminus Thorn onequarter divide brokenbar degree thorn threequarters twosuperior registered minus eth multiply threesuperior copyright Aacute Acircumflex Adieresis Agrave Aring Atilde Ccedilla Eacute Ecircumflex Edieresis Egrave Iacute Icircumflex Idieresis Igrave Ntilde Oacute Ocircumflex Odieresis Ograve Otilde Scaron Uacute Ucircumflex Udieresis Ugrave Yacute Ydieresis Zcaron aacute acircumflex adieresis agrave aring atilde ccedilla eacute ecircumflex edieresis egrave iacute icircumflex idieresis igrave ntilde oacute ocircumflex odieresis ograve otilde scaron uacute ucircumflex udieresis ugrave yacute ydieresis zcaron'.split(
        ' ',
      );
      m.ExpertCharset = '.notdef space exclamsmall Hungarumlautsmall dollaroldstyle dollarsuperior ampersandsmall Acutesmall parenleftsuperior parenrightsuperior twodotenleader onedotenleader comma hyphen period fraction zerooldstyle oneoldstyle twooldstyle threeoldstyle fouroldstyle fiveoldstyle sixoldstyle sevenoldstyle eightoldstyle nineoldstyle colon semicolon commasuperior threequartersemdash periodsuperior questionsmall asuperior bsuperior centsuperior dsuperior esuperior isuperior lsuperior msuperior nsuperior osuperior rsuperior ssuperior tsuperior ff fi fl ffi ffl parenleftinferior parenrightinferior Circumflexsmall hyphensuperior Gravesmall Asmall Bsmall Csmall Dsmall Esmall Fsmall Gsmall Hsmall Ismall Jsmall Ksmall Lsmall Msmall Nsmall Osmall Psmall Qsmall Rsmall Ssmall Tsmall Usmall Vsmall Wsmall Xsmall Ysmall Zsmall colonmonetary onefitted rupiah Tildesmall exclamdownsmall centoldstyle Lslashsmall Scaronsmall Zcaronsmall Dieresissmall Brevesmall Caronsmall Dotaccentsmall Macronsmall figuredash hypheninferior Ogoneksmall Ringsmall Cedillasmall onequarter onehalf threequarters questiondownsmall oneeighth threeeighths fiveeighths seveneighths onethird twothirds zerosuperior onesuperior twosuperior threesuperior foursuperior fivesuperior sixsuperior sevensuperior eightsuperior ninesuperior zeroinferior oneinferior twoinferior threeinferior fourinferior fiveinferior sixinferior seveninferior eightinferior nineinferior centinferior dollarinferior periodinferior commainferior Agravesmall Aacutesmall Acircumflexsmall Atildesmall Adieresissmall Aringsmall AEsmall Ccedillasmall Egravesmall Eacutesmall Ecircumflexsmall Edieresissmall Igravesmall Iacutesmall Icircumflexsmall Idieresissmall Ethsmall Ntildesmall Ogravesmall Oacutesmall Ocircumflexsmall Otildesmall Odieresissmall OEsmall Oslashsmall Ugravesmall Uacutesmall Ucircumflexsmall Udieresissmall Yacutesmall Thornsmall Ydieresissmall'.split(
        ' ',
      );
      m.ExpertSubsetCharset = '.notdef space dollaroldstyle dollarsuperior parenleftsuperior parenrightsuperior twodotenleader onedotenleader comma hyphen period fraction zerooldstyle oneoldstyle twooldstyle threeoldstyle fouroldstyle fiveoldstyle sixoldstyle sevenoldstyle eightoldstyle nineoldstyle colon semicolon commasuperior threequartersemdash periodsuperior asuperior bsuperior centsuperior dsuperior esuperior isuperior lsuperior msuperior nsuperior osuperior rsuperior ssuperior tsuperior ff fi fl ffi ffl parenleftinferior parenrightinferior hyphensuperior colonmonetary onefitted rupiah centoldstyle figuredash hypheninferior onequarter onehalf threequarters oneeighth threeeighths fiveeighths seveneighths onethird twothirds zerosuperior onesuperior twosuperior threesuperior foursuperior fivesuperior sixsuperior sevensuperior eightsuperior ninesuperior zeroinferior oneinferior twoinferior threeinferior fourinferior fiveinferior sixinferior seveninferior eightinferior nineinferior centinferior dollarinferior periodinferior commainferior'.split(
        ' ',
      );
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.FontRendererFactory = void 0;
      var a = t(0),
        k = t(64),
        b = t(35),
        v = t(18),
        d = t(3);
      y = (function() {
        function m(a, b) {
          return (a[b] << 24) | (a[b + 1] << 16) | (a[b + 2] << 8) | a[b + 3];
        }
        function t(a, b) {
          return (a[b] << 8) | a[b + 1];
        }
        function y(a, b, d) {
          if (d) {
            d = 4;
            var c = function(a, b) {
              return (a[b] << 24) | (a[b + 1] << 16) | (a[b + 2] << 8) | a[b + 3];
            };
          } else
            (d = 2),
              (c = function(a, b) {
                return (a[b] << 9) | (a[b + 1] << 1);
              });
          for (var e = [], h = c(b, 0), n = d; n < b.length; n += d) {
            var f = c(b, n);
            e.push(a.subarray(h, f));
            h = f;
          }
          return e;
        }
        function B(a, b) {
          for (var c = b.charCodeAt(0), d = 0, e = 0, h = a.length - 1; e < h; ) {
            var n = (e + h + 1) >> 1;
            c < a[n].start ? (h = n - 1) : (e = n);
          }
          a[e].start <= c && c <= a[e].end && (d = (a[e].idDelta + (a[e].ids ? a[e].ids[c - a[e].start] : c)) & 65535);
          return { charCode: c, glyphId: d };
        }
        function n(a, b, d) {
          var c = 0,
            e = ((a[c] << 24) | (a[c + 1] << 16)) >> 16,
            h = 0,
            p = 0;
          c += 10;
          if (0 > e) {
            do {
              var f = (a[c] << 8) | a[c + 1];
              e = (a[c + 2] << 8) | a[c + 3];
              c += 4;
              f & 1
                ? ((h = ((a[c] << 24) | (a[c + 1] << 16)) >> 16),
                  (p = ((a[c + 2] << 24) | (a[c + 3] << 16)) >> 16),
                  (c += 4))
                : ((h = a[c++]), (p = a[c++]));
              f & 2 || (p = h = 0);
              var k = 1,
                m = 1,
                q = 0,
                t = 0;
              f & 8
                ? ((k = m = ((a[c] << 24) | (a[c + 1] << 16)) / 1073741824), (c += 2))
                : f & 64
                ? ((k = ((a[c] << 24) | (a[c + 1] << 16)) / 1073741824),
                  (m = ((a[c + 2] << 24) | (a[c + 3] << 16)) / 1073741824),
                  (c += 4))
                : f & 128 &&
                  ((k = ((a[c] << 24) | (a[c + 1] << 16)) / 1073741824),
                  (q = ((a[c + 2] << 24) | (a[c + 3] << 16)) / 1073741824),
                  (t = ((a[c + 4] << 24) | (a[c + 5] << 16)) / 1073741824),
                  (m = ((a[c + 6] << 24) | (a[c + 7] << 16)) / 1073741824),
                  (c += 8));
              if ((e = d.glyphs[e]))
                b.push({ cmd: 'save' }),
                  b.push({ cmd: 'transform', args: [k, q, t, m, h, p] }),
                  n(e, b, d),
                  b.push({ cmd: 'restore' });
            } while (f & 32);
          } else {
            d = [];
            for (f = 0; f < e; f++) d.push((a[c] << 8) | a[c + 1]), (c += 2);
            c += 2 + ((a[c] << 8) | a[c + 1]);
            m = d[d.length - 1] + 1;
            for (k = []; k.length < m; )
              for (f = a[c++], q = 1, f & 8 && (q += a[c++]); 0 < q--; ) k.push({ flags: f });
            for (f = 0; f < m; f++) {
              switch (k[f].flags & 18) {
                case 0:
                  h += ((a[c] << 24) | (a[c + 1] << 16)) >> 16;
                  c += 2;
                  break;
                case 2:
                  h -= a[c++];
                  break;
                case 18:
                  h += a[c++];
              }
              k[f].x = h;
            }
            for (f = 0; f < m; f++) {
              switch (k[f].flags & 36) {
                case 0:
                  p += ((a[c] << 24) | (a[c + 1] << 16)) >> 16;
                  c += 2;
                  break;
                case 4:
                  p -= a[c++];
                  break;
                case 36:
                  p += a[c++];
              }
              k[f].y = p;
            }
            for (c = f = 0; c < e; c++) {
              a = d[c];
              h = k.slice(f, a + 1);
              h[0].flags & 1
                ? h.push(h[0])
                : h[h.length - 1].flags & 1
                ? h.unshift(h[h.length - 1])
                : ((f = { flags: 1, x: (h[0].x + h[h.length - 1].x) / 2, y: (h[0].y + h[h.length - 1].y) / 2 }),
                  h.unshift(f),
                  h.push(f));
              b.push({ cmd: 'moveTo', args: [h[0].x, h[0].y] });
              f = 1;
              for (p = h.length; f < p; f++)
                h[f].flags & 1
                  ? b.push({ cmd: 'lineTo', args: [h[f].x, h[f].y] })
                  : h[f + 1].flags & 1
                  ? (b.push({ cmd: 'quadraticCurveTo', args: [h[f].x, h[f].y, h[f + 1].x, h[f + 1].y] }), f++)
                  : b.push({
                      cmd: 'quadraticCurveTo',
                      args: [h[f].x, h[f].y, (h[f].x + h[f + 1].x) / 2, (h[f].y + h[f + 1].y) / 2],
                    });
              f = a + 1;
            }
          }
        }
        function e(b, d, h) {
          function c(a, b) {
            d.push({ cmd: 'moveTo', args: [a, b] });
          }
          function n(a, b) {
            d.push({ cmd: 'lineTo', args: [a, b] });
          }
          function l(a, b, c, e, f, g) {
            d.push({ cmd: 'bezierCurveTo', args: [a, b, c, e, f, g] });
          }
          function p(b) {
            for (var g = 0; g < b.length; ) {
              var r = !1,
                t = b[g++];
              switch (t) {
                case 1:
                  q += f.length >> 1;
                  r = !0;
                  break;
                case 3:
                  q += f.length >> 1;
                  r = !0;
                  break;
                case 4:
                  m += f.pop();
                  c(k, m);
                  r = !0;
                  break;
                case 5:
                  for (; 0 < f.length; ) (k += f.shift()), (m += f.shift()), n(k, m);
                  break;
                case 6:
                  for (; 0 < f.length; ) {
                    k += f.shift();
                    n(k, m);
                    if (0 === f.length) break;
                    m += f.shift();
                    n(k, m);
                  }
                  break;
                case 7:
                  for (; 0 < f.length; ) {
                    m += f.shift();
                    n(k, m);
                    if (0 === f.length) break;
                    k += f.shift();
                    n(k, m);
                  }
                  break;
                case 8:
                  for (; 0 < f.length; ) {
                    t = k + f.shift();
                    var u = m + f.shift();
                    var x = t + f.shift();
                    var A = u + f.shift();
                    k = x + f.shift();
                    m = A + f.shift();
                    l(t, u, x, A, k, m);
                  }
                  break;
                case 10:
                  t = f.pop() + h.subrsBias;
                  (t = h.subrs[t]) && p(t);
                  break;
                case 11:
                  return;
                case 12:
                  t = b[g++];
                  switch (t) {
                    case 34:
                      t = k + f.shift();
                      x = t + f.shift();
                      A = m + f.shift();
                      k = x + f.shift();
                      l(t, m, x, A, k, A);
                      t = k + f.shift();
                      x = t + f.shift();
                      k = x + f.shift();
                      l(t, A, x, m, k, m);
                      break;
                    case 35:
                      t = k + f.shift();
                      u = m + f.shift();
                      x = t + f.shift();
                      A = u + f.shift();
                      k = x + f.shift();
                      m = A + f.shift();
                      l(t, u, x, A, k, m);
                      t = k + f.shift();
                      u = m + f.shift();
                      x = t + f.shift();
                      A = u + f.shift();
                      k = x + f.shift();
                      m = A + f.shift();
                      l(t, u, x, A, k, m);
                      f.pop();
                      break;
                    case 36:
                      t = k + f.shift();
                      A = m + f.shift();
                      x = t + f.shift();
                      u = A + f.shift();
                      k = x + f.shift();
                      l(t, A, x, u, k, u);
                      t = k + f.shift();
                      x = t + f.shift();
                      A = u + f.shift();
                      k = x + f.shift();
                      l(t, u, x, A, k, m);
                      break;
                    case 37:
                      var z = k,
                        y = m;
                      t = k + f.shift();
                      u = m + f.shift();
                      x = t + f.shift();
                      A = u + f.shift();
                      k = x + f.shift();
                      m = A + f.shift();
                      l(t, u, x, A, k, m);
                      t = k + f.shift();
                      u = m + f.shift();
                      x = t + f.shift();
                      A = u + f.shift();
                      k = x;
                      m = A;
                      Math.abs(k - z) > Math.abs(m - y) ? (k += f.shift()) : (m += f.shift());
                      l(t, u, x, A, k, m);
                      break;
                    default:
                      throw new a.FormatError('unknown operator: 12 ' + t);
                  }
                  break;
                case 14:
                  4 <= f.length &&
                    ((g = f.pop()),
                    (b = f.pop()),
                    (m = f.pop()),
                    (k = f.pop()),
                    d.push({ cmd: 'save' }),
                    d.push({ cmd: 'translate', args: [k, m] }),
                    (g = B(h.cmap, String.fromCharCode(h.glyphNameMap[v.StandardEncoding[g]]))),
                    e(h.glyphs[g.glyphId], d, h),
                    d.push({ cmd: 'restore' }),
                    (g = B(h.cmap, String.fromCharCode(h.glyphNameMap[v.StandardEncoding[b]]))),
                    e(h.glyphs[g.glyphId], d, h));
                  return;
                case 18:
                  q += f.length >> 1;
                  r = !0;
                  break;
                case 19:
                  q += f.length >> 1;
                  g += (q + 7) >> 3;
                  r = !0;
                  break;
                case 20:
                  q += f.length >> 1;
                  g += (q + 7) >> 3;
                  r = !0;
                  break;
                case 21:
                  m += f.pop();
                  k += f.pop();
                  c(k, m);
                  r = !0;
                  break;
                case 22:
                  k += f.pop();
                  c(k, m);
                  r = !0;
                  break;
                case 23:
                  q += f.length >> 1;
                  r = !0;
                  break;
                case 24:
                  for (; 2 < f.length; )
                    (t = k + f.shift()),
                      (u = m + f.shift()),
                      (x = t + f.shift()),
                      (A = u + f.shift()),
                      (k = x + f.shift()),
                      (m = A + f.shift()),
                      l(t, u, x, A, k, m);
                  k += f.shift();
                  m += f.shift();
                  n(k, m);
                  break;
                case 25:
                  for (; 6 < f.length; ) (k += f.shift()), (m += f.shift()), n(k, m);
                  t = k + f.shift();
                  u = m + f.shift();
                  x = t + f.shift();
                  A = u + f.shift();
                  k = x + f.shift();
                  m = A + f.shift();
                  l(t, u, x, A, k, m);
                  break;
                case 26:
                  for (f.length % 2 && (k += f.shift()); 0 < f.length; )
                    (t = k),
                      (u = m + f.shift()),
                      (x = t + f.shift()),
                      (A = u + f.shift()),
                      (k = x),
                      (m = A + f.shift()),
                      l(t, u, x, A, k, m);
                  break;
                case 27:
                  for (f.length % 2 && (m += f.shift()); 0 < f.length; )
                    (t = k + f.shift()),
                      (u = m),
                      (x = t + f.shift()),
                      (A = u + f.shift()),
                      (k = x + f.shift()),
                      (m = A),
                      l(t, u, x, A, k, m);
                  break;
                case 28:
                  f.push(((b[g] << 24) | (b[g + 1] << 16)) >> 16);
                  g += 2;
                  break;
                case 29:
                  t = f.pop() + h.gsubrsBias;
                  (t = h.gsubrs[t]) && p(t);
                  break;
                case 30:
                  for (; 0 < f.length; ) {
                    t = k;
                    u = m + f.shift();
                    x = t + f.shift();
                    A = u + f.shift();
                    k = x + f.shift();
                    m = A + (1 === f.length ? f.shift() : 0);
                    l(t, u, x, A, k, m);
                    if (0 === f.length) break;
                    t = k + f.shift();
                    u = m;
                    x = t + f.shift();
                    A = u + f.shift();
                    m = A + f.shift();
                    k = x + (1 === f.length ? f.shift() : 0);
                    l(t, u, x, A, k, m);
                  }
                  break;
                case 31:
                  for (; 0 < f.length; ) {
                    t = k + f.shift();
                    u = m;
                    x = t + f.shift();
                    A = u + f.shift();
                    m = A + f.shift();
                    k = x + (1 === f.length ? f.shift() : 0);
                    l(t, u, x, A, k, m);
                    if (0 === f.length) break;
                    t = k;
                    u = m + f.shift();
                    x = t + f.shift();
                    A = u + f.shift();
                    k = x + f.shift();
                    m = A + (1 === f.length ? f.shift() : 0);
                    l(t, u, x, A, k, m);
                  }
                  break;
                default:
                  if (32 > t) throw new a.FormatError('unknown operator: ' + t);
                  247 > t
                    ? f.push(t - 139)
                    : 251 > t
                    ? f.push(256 * (t - 247) + b[g++] + 108)
                    : 255 > t
                    ? f.push(256 * -(t - 251) - b[g++] - 108)
                    : (f.push(((b[g] << 24) | (b[g + 1] << 16) | (b[g + 2] << 8) | b[g + 3]) / 65536), (g += 4));
              }
              r && (f.length = 0);
            }
          }
          var f = [],
            k = 0,
            m = 0,
            q = 0;
          p(b);
        }
        function h(a) {
          this.compiledGlyphs = Object.create(null);
          this.compiledCharCodeToGlyphId = Object.create(null);
          this.fontMatrix = a;
        }
        function p(a, b, d) {
          d = d || [4.88e-4, 0, 0, 4.88e-4, 0, 0];
          h.call(this, d);
          this.glyphs = a;
          this.cmap = b;
        }
        function A(a, d, e, g) {
          e = e || [0.001, 0, 0, 0.001, 0, 0];
          h.call(this, e);
          this.glyphs = a.glyphs;
          this.gsubrs = a.gsubrs || [];
          this.subrs = a.subrs || [];
          this.cmap = d;
          this.glyphNameMap = g || (0, b.getGlyphsUnicode)();
          this.gsubrsBias = 1240 > this.gsubrs.length ? 107 : 33900 > this.gsubrs.length ? 1131 : 32768;
          this.subrsBias = 1240 > this.subrs.length ? 107 : 33900 > this.subrs.length ? 1131 : 32768;
        }
        h.prototype = {
          getPathJs: function(a) {
            a = B(this.cmap, a);
            var b = this.compiledGlyphs[a.glyphId];
            b || ((b = this.compileGlyph(this.glyphs[a.glyphId])), (this.compiledGlyphs[a.glyphId] = b));
            void 0 === this.compiledCharCodeToGlyphId[a.charCode] &&
              (this.compiledCharCodeToGlyphId[a.charCode] = a.glyphId);
            return b;
          },
          compileGlyph: function(a) {
            if (!a || 0 === a.length || 14 === a[0]) return '';
            var b = [];
            b.push({ cmd: 'save' });
            b.push({ cmd: 'transform', args: this.fontMatrix.slice() });
            b.push({ cmd: 'scale', args: ['size', '-size'] });
            this.compileGlyphImpl(a, b);
            b.push({ cmd: 'restore' });
            return b;
          },
          compileGlyphImpl: function() {
            throw Error('Children classes should implement this.');
          },
          hasBuiltPath: function(a) {
            a = B(this.cmap, a);
            return void 0 !== this.compiledGlyphs[a.glyphId] && void 0 !== this.compiledCharCodeToGlyphId[a.charCode];
          },
        };
        a.Util.inherit(p, h, {
          compileGlyphImpl: function(a, b) {
            n(a, b, this);
          },
        });
        a.Util.inherit(A, h, {
          compileGlyphImpl: function(a, b) {
            e(a, b, this);
          },
        });
        return {
          create: function(b, e) {
            for (var c = new Uint8Array(b.data), g, h, n, q, f, r, u = t(c, 4), v = 0, B = 12; v < u; v++, B += 16) {
              var w = (0, a.bytesToString)(c.subarray(B, B + 4)),
                z = m(c, B + 8),
                C = m(c, B + 12);
              switch (w) {
                case 'cmap':
                  g = c;
                  C = z;
                  w = 1 === t(g, C + 2) ? m(g, C + 8) : m(g, C + 16);
                  z = t(g, C + w);
                  if (4 === z) {
                    t(g, C + w + 2);
                    z = t(g, C + w + 6) >> 1;
                    w = C + w + 14;
                    var K = [];
                    for (C = 0; C < z; C++, w += 2) K[C] = { end: t(g, w) };
                    w += 2;
                    for (C = 0; C < z; C++, w += 2) K[C].start = t(g, w);
                    for (C = 0; C < z; C++, w += 2) K[C].idDelta = t(g, w);
                    for (C = 0; C < z; C++, w += 2) {
                      var H = t(g, w);
                      if (0 !== H) {
                        K[C].ids = [];
                        for (var M = 0, O = K[C].end - K[C].start + 1; M < O; M++)
                          (K[C].ids[M] = t(g, w + H)), (H += 2);
                      }
                    }
                    g = K;
                  } else if (12 === z) {
                    m(g, C + w + 4);
                    z = m(g, C + w + 12);
                    w = C + w + 16;
                    K = [];
                    for (C = 0; C < z; C++)
                      K.push({ start: m(g, w), end: m(g, w + 4), idDelta: m(g, w + 8) - m(g, w) }), (w += 12);
                    g = K;
                  } else throw new a.FormatError('unsupported cmap: ' + z);
                  break;
                case 'glyf':
                  h = c.subarray(z, z + C);
                  break;
                case 'loca':
                  n = c.subarray(z, z + C);
                  break;
                case 'head':
                  r = t(c, z + 18);
                  f = t(c, z + 50);
                  break;
                case 'CFF ':
                  (q = e),
                    (q = new k.CFFParser(new d.Stream(c, z, z + C - z), {}, q).parse()),
                    (q = {
                      glyphs: q.charStrings.objects,
                      subrs:
                        q.topDict.privateDict &&
                        q.topDict.privateDict.subrsIndex &&
                        q.topDict.privateDict.subrsIndex.objects,
                      gsubrs: q.globalSubrIndex && q.globalSubrIndex.objects,
                    });
              }
            }
            return h
              ? ((c = r ? [1 / r, 0, 0, 1 / r, 0, 0] : b.fontMatrix), new p(y(h, n, f), g, c))
              : new A(q, g, b.fontMatrix, b.glyphNameMap);
          },
        };
      })();
      m.FontRendererFactory = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.Type1Parser = void 0;
      var a = t(0),
        k = t(18),
        b = t(3),
        v = (function() {
          function b() {
            this.lsb = this.width = 0;
            this.flexing = !1;
            this.output = [];
            this.stack = [];
          }
          var k = [4],
            m = [5],
            t = [6],
            v = [7],
            n = [8],
            e = [12, 35],
            h = [14],
            p = [21],
            A = [22],
            c = [30],
            q = [31];
          b.prototype = {
            convert: function(b, d, u) {
              for (var g = b.length, x = !1, f, r = 0; r < g; r++)
                if (((f = b[r]), 32 > f)) {
                  12 === f && (f = (f << 8) + b[++r]);
                  switch (f) {
                    case 1:
                      this.stack = [];
                      break;
                    case 3:
                      this.stack = [];
                      break;
                    case 4:
                      if (this.flexing) {
                        if (1 > this.stack.length) {
                          x = !0;
                          break;
                        }
                        f = this.stack.pop();
                        this.stack.push(0, f);
                        break;
                      }
                      x = this.executeCommand(1, k);
                      break;
                    case 5:
                      x = this.executeCommand(2, m);
                      break;
                    case 6:
                      x = this.executeCommand(1, t);
                      break;
                    case 7:
                      x = this.executeCommand(1, v);
                      break;
                    case 8:
                      x = this.executeCommand(6, n);
                      break;
                    case 9:
                      this.stack = [];
                      break;
                    case 10:
                      if (1 > this.stack.length) {
                        x = !0;
                        break;
                      }
                      f = this.stack.pop();
                      x = this.convert(d[f], d, u);
                      break;
                    case 11:
                      return x;
                    case 13:
                      if (2 > this.stack.length) {
                        x = !0;
                        break;
                      }
                      x = this.stack.pop();
                      this.lsb = f = this.stack.pop();
                      this.width = x;
                      this.stack.push(x, f);
                      x = this.executeCommand(2, A);
                      break;
                    case 14:
                      this.output.push(h[0]);
                      break;
                    case 21:
                      if (this.flexing) break;
                      x = this.executeCommand(2, p);
                      break;
                    case 22:
                      if (this.flexing) {
                        this.stack.push(0);
                        break;
                      }
                      x = this.executeCommand(1, A);
                      break;
                    case 30:
                      x = this.executeCommand(4, c);
                      break;
                    case 31:
                      x = this.executeCommand(4, q);
                      break;
                    case 3072:
                      this.stack = [];
                      break;
                    case 3073:
                      this.stack = [];
                      break;
                    case 3074:
                      this.stack = [];
                      break;
                    case 3078:
                      u
                        ? ((this.seac = this.stack.splice(-4, 4)), (x = this.executeCommand(0, h)))
                        : (x = this.executeCommand(4, h));
                      break;
                    case 3079:
                      if (4 > this.stack.length) {
                        x = !0;
                        break;
                      }
                      this.stack.pop();
                      x = this.stack.pop();
                      var B = this.stack.pop();
                      this.lsb = f = this.stack.pop();
                      this.width = x;
                      this.stack.push(x, f, B);
                      x = this.executeCommand(3, p);
                      break;
                    case 3084:
                      if (2 > this.stack.length) {
                        x = !0;
                        break;
                      }
                      f = this.stack.pop();
                      B = this.stack.pop();
                      this.stack.push(B / f);
                      break;
                    case 3088:
                      if (2 > this.stack.length) {
                        x = !0;
                        break;
                      }
                      f = this.stack.pop();
                      B = this.stack.pop();
                      0 === f && 3 === B
                        ? ((f = this.stack.splice(this.stack.length - 17, 17)),
                          this.stack.push(
                            f[2] + f[0],
                            f[3] + f[1],
                            f[4],
                            f[5],
                            f[6],
                            f[7],
                            f[8],
                            f[9],
                            f[10],
                            f[11],
                            f[12],
                            f[13],
                            f[14],
                          ),
                          (x = this.executeCommand(13, e, !0)),
                          (this.flexing = !1),
                          this.stack.push(f[15], f[16]))
                        : 1 === f && 0 === B && (this.flexing = !0);
                      break;
                    case 3089:
                      break;
                    case 3105:
                      this.stack = [];
                      break;
                    default:
                      (0, a.warn)('Unknown type 1 charstring command of "' + f + '"');
                  }
                  if (x) break;
                } else
                  (f =
                    246 >= f
                      ? f - 139
                      : 250 >= f
                      ? 256 * (f - 247) + b[++r] + 108
                      : 254 >= f
                      ? -(256 * (f - 251)) - b[++r] - 108
                      : ((b[++r] & 255) << 24) |
                        ((b[++r] & 255) << 16) |
                        ((b[++r] & 255) << 8) |
                        ((b[++r] & 255) << 0)),
                    this.stack.push(f);
              return x;
            },
            executeCommand: function(a, b, c) {
              var d = this.stack.length;
              if (a > d) return !0;
              for (var e = d - a, g = e; g < d; g++) {
                var h = this.stack[g];
                Number.isInteger(h)
                  ? this.output.push(28, (h >> 8) & 255, h & 255)
                  : ((h = (65536 * h) | 0),
                    this.output.push(255, (h >> 24) & 255, (h >> 16) & 255, (h >> 8) & 255, h & 255));
              }
              this.output.push.apply(this.output, b);
              c ? this.stack.splice(e, a) : (this.stack.length = 0);
              return !1;
            },
          };
          return b;
        })();
      y = (function() {
        function d(a) {
          return (48 <= a && 57 >= a) || (65 <= a && 70 >= a) || (97 <= a && 102 >= a);
        }
        function m(a, b, d) {
          if (d >= a.length) return new Uint8Array(0);
          b |= 0;
          var e;
          for (e = 0; e < d; e++) b = (52845 * (a[e] + b) + 22719) & 65535;
          var n = a.length - d,
            k = new Uint8Array(n);
          e = d;
          for (d = 0; d < n; e++, d++) {
            var c = a[e];
            k[d] = c ^ (b >> 8);
            b = (52845 * (c + b) + 22719) & 65535;
          }
          return k;
        }
        function t(a) {
          return 47 === a || 91 === a || 93 === a || 123 === a || 125 === a || 40 === a || 41 === a;
        }
        function y(a, n, e) {
          if (n) {
            n = a.getBytes();
            var h = !(d(n[0]) && d(n[1]) && d(n[2]) && d(n[3]));
            a = b.Stream;
            if (h) var k = m(n, 55665, 4);
            else {
              h = 55665;
              var t = n.length,
                c = new Uint8Array(t >>> 1),
                q,
                u;
              for (u = q = 0; q < t; q++) {
                var g = n[q];
                if (d(g)) {
                  for (q++; q < t && !d((k = n[q])); ) q++;
                  q < t &&
                    ((g = parseInt(String.fromCharCode(g, k), 16)),
                    (c[u++] = g ^ (h >> 8)),
                    (h = (52845 * (g + h) + 22719) & 65535));
                }
              }
              k = Array.prototype.slice.call(c, 4, u);
            }
            a = new a(k);
          }
          this.seacAnalysisEnabled = !!e;
          this.stream = a;
          this.nextChar();
        }
        y.prototype = {
          readNumberArray: function() {
            this.getToken();
            for (var a = []; ; ) {
              var b = this.getToken();
              if (null === b || ']' === b || '}' === b) break;
              a.push(parseFloat(b || 0));
            }
            return a;
          },
          readNumber: function() {
            var a = this.getToken();
            return parseFloat(a || 0);
          },
          readInt: function() {
            var a = this.getToken();
            return parseInt(a || 0, 10) | 0;
          },
          readBoolean: function() {
            return 'true' === this.getToken() ? 1 : 0;
          },
          nextChar: function() {
            return (this.currentChar = this.stream.getByte());
          },
          getToken: function() {
            for (var b = !1, d = this.currentChar; ; ) {
              if (-1 === d) return null;
              if (b) {
                if (10 === d || 13 === d) b = !1;
              } else if (37 === d) b = !0;
              else if (!(0, a.isSpace)(d)) break;
              d = this.nextChar();
            }
            if (t(d)) return this.nextChar(), String.fromCharCode(d);
            b = '';
            do (b += String.fromCharCode(d)), (d = this.nextChar());
            while (0 <= d && !(0, a.isSpace)(d) && !t(d));
            return b;
          },
          extractFontProgram: function() {
            var a = this.stream,
              b = [],
              d = [],
              h = Object.create(null);
            h.lenIV = 4;
            h = { subrs: [], charstrings: [], properties: { privateData: h } };
            for (var k, t, c; null !== (k = this.getToken()); )
              if ('/' === k)
                switch (((k = this.getToken()), k)) {
                  case 'CharStrings':
                    this.getToken();
                    this.getToken();
                    this.getToken();
                    for (this.getToken(); ; ) {
                      k = this.getToken();
                      if (null === k || 'end' === k) break;
                      if ('/' === k) {
                        var q = this.getToken();
                        k = this.readInt();
                        this.getToken();
                        t = a.makeSubStream(a.pos, k);
                        c = h.properties.privateData.lenIV;
                        t = m(t.getBytes(), 4330, c);
                        a.skip(k);
                        this.nextChar();
                        k = this.getToken();
                        'noaccess' === k && this.getToken();
                        d.push({ glyph: q, encoded: t });
                      }
                    }
                    break;
                  case 'Subrs':
                    this.readInt();
                    for (this.getToken(); 'dup' === this.getToken(); )
                      (q = this.readInt()),
                        (k = this.readInt()),
                        this.getToken(),
                        (t = a.makeSubStream(a.pos, k)),
                        (c = h.properties.privateData.lenIV),
                        (t = m(t.getBytes(), 4330, c)),
                        a.skip(k),
                        this.nextChar(),
                        (k = this.getToken()),
                        'noaccess' === k && this.getToken(),
                        (b[q] = t);
                    break;
                  case 'BlueValues':
                  case 'OtherBlues':
                  case 'FamilyBlues':
                  case 'FamilyOtherBlues':
                    this.readNumberArray();
                    break;
                  case 'StemSnapH':
                  case 'StemSnapV':
                    h.properties.privateData[k] = this.readNumberArray();
                    break;
                  case 'StdHW':
                  case 'StdVW':
                    h.properties.privateData[k] = this.readNumberArray()[0];
                    break;
                  case 'BlueShift':
                  case 'lenIV':
                  case 'BlueFuzz':
                  case 'BlueScale':
                  case 'LanguageGroup':
                  case 'ExpansionFactor':
                    h.properties.privateData[k] = this.readNumber();
                    break;
                  case 'ForceBold':
                    h.properties.privateData[k] = this.readBoolean();
                }
            for (a = 0; a < d.length; a++)
              (q = d[a].glyph),
                (t = d[a].encoded),
                (k = new v()),
                (t = k.convert(t, b, this.seacAnalysisEnabled)),
                (c = k.output),
                t && (c = [14]),
                h.charstrings.push({ glyphName: q, charstring: c, width: k.width, lsb: k.lsb, seac: k.seac });
            return h;
          },
          extractFontHeader: function(a) {
            for (var b; null !== (b = this.getToken()); )
              if ('/' === b)
                switch (((b = this.getToken()), b)) {
                  case 'FontMatrix':
                    var d = this.readNumberArray();
                    a.fontMatrix = d;
                    break;
                  case 'Encoding':
                    var h = this.getToken();
                    if (/^\d+$/.test(h)) {
                      d = [];
                      h = parseInt(h, 10) | 0;
                      this.getToken();
                      for (var p = 0; p < h; p++) {
                        for (b = this.getToken(); 'dup' !== b && 'def' !== b; )
                          if (((b = this.getToken()), null === b)) return;
                        if ('def' === b) break;
                        b = this.readInt();
                        this.getToken();
                        var m = this.getToken();
                        d[b] = m;
                        this.getToken();
                      }
                    } else d = (0, k.getEncoding)(h);
                    a.builtInEncoding = d;
                    break;
                  case 'FontBBox':
                    (d = this.readNumberArray()),
                      (a.ascent = Math.max(d[3], d[1])),
                      (a.descent = Math.min(d[1], d[3])),
                      (a.ascentScaled = !0);
                }
          },
        };
        return y;
      })();
      m.Type1Parser = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.getTilingPatternIR = m.Pattern = void 0;
      var a = t(0),
        k = t(17),
        b = t(1),
        v = t(26);
      y = (function() {
        function k() {
          throw Error('should not call Pattern constructor');
        }
        k.prototype = {
          getPattern: function(a) {
            throw Error('Should not call Pattern.getStyle: ' + a);
          },
        };
        k.parseShading = function(k, m, t, n, e) {
          var h = (0, b.isStream)(k) ? k.dict : k,
            p = h.get('ShadingType');
          try {
            switch (p) {
              case 2:
              case 3:
                return new d.RadialAxial(h, m, t, n);
              case 4:
              case 5:
              case 6:
              case 7:
                return new d.Mesh(k, m, t, n);
              default:
                throw new a.FormatError('Unsupported ShadingType: ' + p);
            }
          } catch (A) {
            if (A instanceof a.MissingDataException) throw A;
            e.send('UnsupportedFeature', { featureId: a.UNSUPPORTED_FEATURES.shadingPattern });
            (0, a.warn)(A);
            return new d.Dummy();
          }
        };
        return k;
      })();
      var d = { SMALL_NUMBER: 1e-6 };
      d.RadialAxial = (function() {
        function b(b, m, t, n) {
          this.matrix = m;
          this.coordsArr = b.getArray('Coords');
          this.shadingType = b.get('ShadingType');
          this.type = 'Pattern';
          m = b.get('ColorSpace', 'CS');
          this.cs = m = k.ColorSpace.parse(m, t, n);
          n = 0;
          var e = 1;
          if (b.has('Domain')) {
            var h = b.getArray('Domain');
            n = h[0];
            e = h[1];
          }
          var p = (h = !1);
          b.has('Extend') && ((p = b.getArray('Extend')), (h = p[0]), (p = p[1]));
          if (!(3 !== this.shadingType || (h && p))) {
            var u = this.coordsArr[0],
              c = this.coordsArr[1],
              q = this.coordsArr[2],
              x = this.coordsArr[3],
              g = this.coordsArr[4],
              B = this.coordsArr[5];
            u = Math.sqrt((u - x) * (u - x) + (c - g) * (c - g));
            q <= B + u && B <= q + u && (0, a.warn)('Unsupported radial gradient.');
          }
          this.extendStart = h;
          this.extendEnd = p;
          q = b.get('Function');
          q = v.PDFFunction.parseArray(t, q);
          B = e - n;
          u = B / 10;
          t = this.colorStops = [];
          if (n >= e || 0 >= u) (0, a.info)('Bad shading domain.');
          else {
            c = new Float32Array(m.numComps);
            x = new Float32Array(1);
            for (g = n; g <= e; g += u) {
              x[0] = g;
              q(x, 0, c, 0);
              var l = m.getRgb(c, 0);
              l = a.Util.makeCssRgb(l[0], l[1], l[2]);
              t.push([(g - n) / B, l]);
            }
            n = 'transparent';
            b.has('Background') && ((l = m.getRgb(b.get('Background'), 0)), (n = a.Util.makeCssRgb(l[0], l[1], l[2])));
            h || (t.unshift([0, n]), (t[1][0] += d.SMALL_NUMBER));
            p || ((t[t.length - 1][0] -= d.SMALL_NUMBER), t.push([1, n]));
            this.colorStops = t;
          }
        }
        b.prototype = {
          getIR: function() {
            var b = this.coordsArr,
              d = this.shadingType,
              k;
            if (2 === d) {
              var n = [b[0], b[1]];
              var e = [b[2], b[3]];
              var h = (k = null);
              var p = 'axial';
            } else
              3 === d
                ? ((n = [b[0], b[1]]), (e = [b[3], b[4]]), (k = b[2]), (h = b[5]), (p = 'radial'))
                : (0, a.unreachable)('getPattern type unknown: ' + d);
            if ((b = this.matrix))
              (n = a.Util.applyTransform(n, b)),
                (e = a.Util.applyTransform(e, b)),
                3 === d && ((d = a.Util.singularValueDecompose2dScale(b)), (k *= d[0]), (h *= d[1]));
            return ['RadialAxial', p, this.colorStops, n, e, k, h];
          },
        };
        return b;
      })();
      d.Mesh = (function() {
        function d(a, b) {
          this.stream = a;
          this.context = b;
          this.bufferLength = this.buffer = 0;
          this.tmpCompsBuf = new Float32Array(b.numComps);
          var d = b.colorSpace.numComps;
          this.tmpCsCompsBuf = b.colorFn ? new Float32Array(d) : this.tmpCompsBuf;
        }
        function m(a) {
          for (var b = a.coords[0][0], d = a.coords[0][1], n = b, k = d, c = 1, m = a.coords.length; c < m; c++) {
            var t = a.coords[c][0],
              g = a.coords[c][1];
            b = b > t ? t : b;
            d = d > g ? g : d;
            n = n < t ? t : n;
            k = k < g ? g : k;
          }
          a.bounds = [b, d, n, k];
        }
        function t(n, e, h, p) {
          if (!(0, b.isStream)(n)) throw new a.FormatError('Mesh data is not a stream');
          var t = n.dict;
          this.matrix = e;
          this.shadingType = t.get('ShadingType');
          this.type = 'Pattern';
          this.bbox = t.getArray('BBox');
          e = t.get('ColorSpace', 'CS');
          this.cs = e = k.ColorSpace.parse(e, h, p);
          this.background = t.has('Background') ? e.getRgb(t.get('Background'), 0) : null;
          h = (p = t.get('Function')) ? v.PDFFunction.parseArray(h, p) : null;
          this.coords = [];
          this.colors = [];
          this.figures = [];
          h = {
            bitsPerCoordinate: t.get('BitsPerCoordinate'),
            bitsPerComponent: t.get('BitsPerComponent'),
            bitsPerFlag: t.get('BitsPerFlag'),
            decode: t.getArray('Decode'),
            colorFn: h,
            colorSpace: e,
            numComps: h ? 1 : e.numComps,
          };
          n = new d(n, h);
          h = !1;
          switch (this.shadingType) {
            case 4:
              t = this.coords;
              e = this.colors;
              p = [];
              for (var c = [], q = 0; n.hasData; ) {
                var u = n.readFlag(),
                  g = n.readCoordinate(),
                  z = n.readComponents();
                if (0 === q) {
                  if (!(0 <= u && 2 >= u)) throw new a.FormatError('Unknown type4 flag');
                  switch (u) {
                    case 0:
                      q = 3;
                      break;
                    case 1:
                      c.push(c[c.length - 2], c[c.length - 1]);
                      q = 1;
                      break;
                    case 2:
                      c.push(c[c.length - 3], c[c.length - 1]), (q = 1);
                  }
                  p.push(u);
                }
                c.push(t.length);
                t.push(g);
                e.push(z);
                q--;
                n.align();
              }
              this.figures.push({ type: 'triangles', coords: new Int32Array(c), colors: new Int32Array(c) });
              break;
            case 5:
              t = t.get('VerticesPerRow') | 0;
              if (2 > t) throw new a.FormatError('Invalid VerticesPerRow');
              e = this.coords;
              p = this.colors;
              for (c = []; n.hasData; )
                (q = n.readCoordinate()), (u = n.readComponents()), c.push(e.length), e.push(q), p.push(u);
              this.figures.push({
                type: 'lattice',
                coords: new Int32Array(c),
                colors: new Int32Array(c),
                verticesPerRow: t,
              });
              break;
            case 6:
              h = this.coords;
              t = this.colors;
              e = new Int32Array(16);
              for (p = new Int32Array(4); n.hasData; ) {
                u = n.readFlag();
                if (!(0 <= u && 3 >= u)) throw new a.FormatError('Unknown type6 flag');
                c = h.length;
                g = 0;
                for (z = 0 !== u ? 8 : 12; g < z; g++) h.push(n.readCoordinate());
                q = t.length;
                g = 0;
                for (z = 0 !== u ? 2 : 4; g < z; g++) t.push(n.readComponents());
                switch (u) {
                  case 0:
                    e[12] = c + 3;
                    e[13] = c + 4;
                    e[14] = c + 5;
                    e[15] = c + 6;
                    e[8] = c + 2;
                    e[11] = c + 7;
                    e[4] = c + 1;
                    e[7] = c + 8;
                    e[0] = c;
                    e[1] = c + 11;
                    e[2] = c + 10;
                    e[3] = c + 9;
                    p[2] = q + 1;
                    p[3] = q + 2;
                    p[0] = q;
                    p[1] = q + 3;
                    break;
                  case 1:
                    u = e[12];
                    g = e[13];
                    z = e[14];
                    var l = e[15];
                    e[12] = l;
                    e[13] = c + 0;
                    e[14] = c + 1;
                    e[15] = c + 2;
                    e[8] = z;
                    e[11] = c + 3;
                    e[4] = g;
                    e[7] = c + 4;
                    e[0] = u;
                    e[1] = c + 7;
                    e[2] = c + 6;
                    e[3] = c + 5;
                    u = p[2];
                    g = p[3];
                    p[2] = g;
                    p[3] = q;
                    p[0] = u;
                    p[1] = q + 1;
                    break;
                  case 2:
                    u = e[15];
                    g = e[11];
                    e[12] = e[3];
                    e[13] = c + 0;
                    e[14] = c + 1;
                    e[15] = c + 2;
                    e[8] = e[7];
                    e[11] = c + 3;
                    e[4] = g;
                    e[7] = c + 4;
                    e[0] = u;
                    e[1] = c + 7;
                    e[2] = c + 6;
                    e[3] = c + 5;
                    u = p[3];
                    p[2] = p[1];
                    p[3] = q;
                    p[0] = u;
                    p[1] = q + 1;
                    break;
                  case 3:
                    (e[12] = e[0]),
                      (e[13] = c + 0),
                      (e[14] = c + 1),
                      (e[15] = c + 2),
                      (e[8] = e[1]),
                      (e[11] = c + 3),
                      (e[4] = e[2]),
                      (e[7] = c + 4),
                      (e[0] = e[3]),
                      (e[1] = c + 7),
                      (e[2] = c + 6),
                      (e[3] = c + 5),
                      (p[2] = p[0]),
                      (p[3] = q),
                      (p[0] = p[1]),
                      (p[1] = q + 1);
                }
                e[5] = h.length;
                h.push([
                  (-4 * h[e[0]][0] -
                    h[e[15]][0] +
                    6 * (h[e[4]][0] + h[e[1]][0]) -
                    2 * (h[e[12]][0] + h[e[3]][0]) +
                    3 * (h[e[13]][0] + h[e[7]][0])) /
                    9,
                  (-4 * h[e[0]][1] -
                    h[e[15]][1] +
                    6 * (h[e[4]][1] + h[e[1]][1]) -
                    2 * (h[e[12]][1] + h[e[3]][1]) +
                    3 * (h[e[13]][1] + h[e[7]][1])) /
                    9,
                ]);
                e[6] = h.length;
                h.push([
                  (-4 * h[e[3]][0] -
                    h[e[12]][0] +
                    6 * (h[e[2]][0] + h[e[7]][0]) -
                    2 * (h[e[0]][0] + h[e[15]][0]) +
                    3 * (h[e[4]][0] + h[e[14]][0])) /
                    9,
                  (-4 * h[e[3]][1] -
                    h[e[12]][1] +
                    6 * (h[e[2]][1] + h[e[7]][1]) -
                    2 * (h[e[0]][1] + h[e[15]][1]) +
                    3 * (h[e[4]][1] + h[e[14]][1])) /
                    9,
                ]);
                e[9] = h.length;
                h.push([
                  (-4 * h[e[12]][0] -
                    h[e[3]][0] +
                    6 * (h[e[8]][0] + h[e[13]][0]) -
                    2 * (h[e[0]][0] + h[e[15]][0]) +
                    3 * (h[e[11]][0] + h[e[1]][0])) /
                    9,
                  (-4 * h[e[12]][1] -
                    h[e[3]][1] +
                    6 * (h[e[8]][1] + h[e[13]][1]) -
                    2 * (h[e[0]][1] + h[e[15]][1]) +
                    3 * (h[e[11]][1] + h[e[1]][1])) /
                    9,
                ]);
                e[10] = h.length;
                h.push([
                  (-4 * h[e[15]][0] -
                    h[e[0]][0] +
                    6 * (h[e[11]][0] + h[e[14]][0]) -
                    2 * (h[e[12]][0] + h[e[3]][0]) +
                    3 * (h[e[2]][0] + h[e[8]][0])) /
                    9,
                  (-4 * h[e[15]][1] -
                    h[e[0]][1] +
                    6 * (h[e[11]][1] + h[e[14]][1]) -
                    2 * (h[e[12]][1] + h[e[3]][1]) +
                    3 * (h[e[2]][1] + h[e[8]][1])) /
                    9,
                ]);
                this.figures.push({ type: 'patch', coords: new Int32Array(e), colors: new Int32Array(p) });
              }
              h = !0;
              break;
            case 7:
              h = this.coords;
              t = this.colors;
              e = new Int32Array(16);
              for (p = new Int32Array(4); n.hasData; ) {
                u = n.readFlag();
                if (!(0 <= u && 3 >= u)) throw new a.FormatError('Unknown type7 flag');
                c = h.length;
                g = 0;
                for (z = 0 !== u ? 12 : 16; g < z; g++) h.push(n.readCoordinate());
                q = t.length;
                g = 0;
                for (z = 0 !== u ? 2 : 4; g < z; g++) t.push(n.readComponents());
                switch (u) {
                  case 0:
                    e[12] = c + 3;
                    e[13] = c + 4;
                    e[14] = c + 5;
                    e[15] = c + 6;
                    e[8] = c + 2;
                    e[9] = c + 13;
                    e[10] = c + 14;
                    e[11] = c + 7;
                    e[4] = c + 1;
                    e[5] = c + 12;
                    e[6] = c + 15;
                    e[7] = c + 8;
                    e[0] = c;
                    e[1] = c + 11;
                    e[2] = c + 10;
                    e[3] = c + 9;
                    p[2] = q + 1;
                    p[3] = q + 2;
                    p[0] = q;
                    p[1] = q + 3;
                    break;
                  case 1:
                    u = e[12];
                    g = e[13];
                    z = e[14];
                    l = e[15];
                    e[12] = l;
                    e[13] = c + 0;
                    e[14] = c + 1;
                    e[15] = c + 2;
                    e[8] = z;
                    e[9] = c + 9;
                    e[10] = c + 10;
                    e[11] = c + 3;
                    e[4] = g;
                    e[5] = c + 8;
                    e[6] = c + 11;
                    e[7] = c + 4;
                    e[0] = u;
                    e[1] = c + 7;
                    e[2] = c + 6;
                    e[3] = c + 5;
                    u = p[2];
                    g = p[3];
                    p[2] = g;
                    p[3] = q;
                    p[0] = u;
                    p[1] = q + 1;
                    break;
                  case 2:
                    u = e[15];
                    g = e[11];
                    e[12] = e[3];
                    e[13] = c + 0;
                    e[14] = c + 1;
                    e[15] = c + 2;
                    e[8] = e[7];
                    e[9] = c + 9;
                    e[10] = c + 10;
                    e[11] = c + 3;
                    e[4] = g;
                    e[5] = c + 8;
                    e[6] = c + 11;
                    e[7] = c + 4;
                    e[0] = u;
                    e[1] = c + 7;
                    e[2] = c + 6;
                    e[3] = c + 5;
                    u = p[3];
                    p[2] = p[1];
                    p[3] = q;
                    p[0] = u;
                    p[1] = q + 1;
                    break;
                  case 3:
                    (e[12] = e[0]),
                      (e[13] = c + 0),
                      (e[14] = c + 1),
                      (e[15] = c + 2),
                      (e[8] = e[1]),
                      (e[9] = c + 9),
                      (e[10] = c + 10),
                      (e[11] = c + 3),
                      (e[4] = e[2]),
                      (e[5] = c + 8),
                      (e[6] = c + 11),
                      (e[7] = c + 4),
                      (e[0] = e[3]),
                      (e[1] = c + 7),
                      (e[2] = c + 6),
                      (e[3] = c + 5),
                      (p[2] = p[0]),
                      (p[3] = q),
                      (p[0] = p[1]),
                      (p[1] = q + 1);
                }
                this.figures.push({ type: 'patch', coords: new Int32Array(e), colors: new Int32Array(p) });
              }
              h = !0;
              break;
            default:
              (0, a.unreachable)('Unsupported mesh type.');
          }
          if (h)
            for (m(this), n = 0, h = this.figures.length; n < h; n++) {
              t = n;
              q = this.figures[t];
              (0, a.assert)('patch' === q.type, 'Unexpected patch mesh figure');
              e = this.coords;
              p = this.colors;
              c = q.coords;
              q = q.colors;
              g = Math.min(e[c[0]][1], e[c[3]][1], e[c[12]][1], e[c[15]][1]);
              z = Math.max(e[c[0]][1], e[c[3]][1], e[c[12]][1], e[c[15]][1]);
              u = Math.ceil(
                (20 *
                  (Math.max(e[c[0]][0], e[c[3]][0], e[c[12]][0], e[c[15]][0]) -
                    Math.min(e[c[0]][0], e[c[3]][0], e[c[12]][0], e[c[15]][0]))) /
                  (this.bounds[2] - this.bounds[0]),
              );
              u = Math.max(3, Math.min(20, u));
              g = Math.ceil((20 * (z - g)) / (this.bounds[3] - this.bounds[1]));
              g = Math.max(3, Math.min(20, g));
              z = u + 1;
              l = new Int32Array((g + 1) * z);
              for (
                var y = new Int32Array((g + 1) * z),
                  f = 0,
                  r = new Uint8Array(3),
                  C = new Uint8Array(3),
                  L = p[q[0]],
                  I = p[q[1]],
                  w = p[q[2]],
                  E = p[q[3]],
                  F = B(g),
                  K = B(u),
                  H = 0;
                H <= g;
                H++
              ) {
                r[0] = ((L[0] * (g - H) + w[0] * H) / g) | 0;
                r[1] = ((L[1] * (g - H) + w[1] * H) / g) | 0;
                r[2] = ((L[2] * (g - H) + w[2] * H) / g) | 0;
                C[0] = ((I[0] * (g - H) + E[0] * H) / g) | 0;
                C[1] = ((I[1] * (g - H) + E[1] * H) / g) | 0;
                C[2] = ((I[2] * (g - H) + E[2] * H) / g) | 0;
                for (var M = 0; M <= u; M++, f++)
                  if ((0 !== H && H !== g) || (0 !== M && M !== u)) {
                    for (var O = 0, N = 0, da = 0, W = 0; 3 >= W; W++)
                      for (var Z = 0; 3 >= Z; Z++, da++) {
                        var ea = F[H][W] * K[M][Z];
                        O += e[c[da]][0] * ea;
                        N += e[c[da]][1] * ea;
                      }
                    l[f] = e.length;
                    e.push([O, N]);
                    y[f] = p.length;
                    O = new Uint8Array(3);
                    O[0] = ((r[0] * (u - M) + C[0] * M) / u) | 0;
                    O[1] = ((r[1] * (u - M) + C[1] * M) / u) | 0;
                    O[2] = ((r[2] * (u - M) + C[2] * M) / u) | 0;
                    p.push(O);
                  }
              }
              l[0] = c[0];
              y[0] = q[0];
              l[u] = c[3];
              y[u] = q[1];
              l[z * g] = c[12];
              y[z * g] = q[2];
              l[z * g + u] = c[15];
              y[z * g + u] = q[3];
              this.figures[t] = { type: 'lattice', coords: l, colors: y, verticesPerRow: z };
            }
          m(this);
          e = this.coords;
          p = new Float32Array(2 * e.length);
          t = n = 0;
          for (h = e.length; n < h; n++) (c = e[n]), (p[t++] = c[0]), (p[t++] = c[1]);
          this.coords = p;
          e = this.colors;
          p = new Uint8Array(3 * e.length);
          t = n = 0;
          for (h = e.length; n < h; n++) (c = e[n]), (p[t++] = c[0]), (p[t++] = c[1]), (p[t++] = c[2]);
          this.colors = p;
          e = this.figures;
          n = 0;
          for (h = e.length; n < h; n++)
            for (t = e[n], p = t.coords, q = t.colors, t = 0, c = p.length; t < c; t++) (p[t] *= 2), (q[t] *= 3);
        }
        d.prototype = {
          get hasData() {
            if (this.stream.end) return this.stream.pos < this.stream.end;
            if (0 < this.bufferLength) return !0;
            var a = this.stream.getByte();
            if (0 > a) return !1;
            this.buffer = a;
            this.bufferLength = 8;
            return !0;
          },
          readBits: function(a) {
            var b = this.buffer,
              d = this.bufferLength;
            if (32 === a) {
              if (0 === d)
                return (
                  ((this.stream.getByte() << 24) |
                    (this.stream.getByte() << 16) |
                    (this.stream.getByte() << 8) |
                    this.stream.getByte()) >>>
                  0
                );
              b = (b << 24) | (this.stream.getByte() << 16) | (this.stream.getByte() << 8) | this.stream.getByte();
              a = this.stream.getByte();
              this.buffer = a & ((1 << d) - 1);
              return ((b << (8 - d)) | ((a & 255) >> d)) >>> 0;
            }
            if (8 === a && 0 === d) return this.stream.getByte();
            for (; d < a; ) (b = (b << 8) | this.stream.getByte()), (d += 8);
            this.bufferLength = d -= a;
            this.buffer = b & ((1 << d) - 1);
            return b >> d;
          },
          align: function() {
            this.bufferLength = this.buffer = 0;
          },
          readFlag: function() {
            return this.readBits(this.context.bitsPerFlag);
          },
          readCoordinate: function() {
            var a = this.context.bitsPerCoordinate,
              b = this.readBits(a),
              d = this.readBits(a),
              k = this.context.decode;
            a = 32 > a ? 1 / ((1 << a) - 1) : 2.3283064365386963e-10;
            return [b * a * (k[1] - k[0]) + k[0], d * a * (k[3] - k[2]) + k[2]];
          },
          readComponents: function() {
            for (
              var a = this.context.numComps,
                b = this.context.bitsPerComponent,
                d = 32 > b ? 1 / ((1 << b) - 1) : 2.3283064365386963e-10,
                k = this.context.decode,
                m = this.tmpCompsBuf,
                c = 0,
                q = 4;
              c < a;
              c++, q += 2
            ) {
              var t = this.readBits(b);
              m[c] = t * d * (k[q + 1] - k[q]) + k[q];
            }
            a = this.tmpCsCompsBuf;
            this.context.colorFn && this.context.colorFn(m, 0, a, 0);
            return this.context.colorSpace.getRgb(a, 0);
          },
        };
        var B = (function() {
          var a = [];
          return function(b) {
            if (!a[b]) {
              for (var d = [], e = 0; e <= b; e++) {
                var n = e / b,
                  c = 1 - n;
                d.push(new Float32Array([c * c * c, 3 * n * c * c, 3 * n * n * c, n * n * n]));
              }
              a[b] = d;
            }
            return a[b];
          };
        })();
        t.prototype = {
          getIR: function() {
            return [
              'Mesh',
              this.shadingType,
              this.coords,
              this.colors,
              this.figures,
              this.bounds,
              this.matrix,
              this.bbox,
              this.background,
            ];
          },
        };
        return t;
      })();
      d.Dummy = (function() {
        function a() {
          this.type = 'Pattern';
        }
        a.prototype = {
          getIR: function() {
            return ['Dummy'];
          },
        };
        return a;
      })();
      m.Pattern = y;
      m.getTilingPatternIR = function(b, d, k) {
        var m = d.getArray('Matrix'),
          n = a.Util.normalizeRect(d.getArray('BBox')),
          e = d.get('XStep'),
          h = d.get('YStep'),
          p = d.get('PaintType');
        d = d.get('TilingType');
        if (0 === n[2] - n[0] || 0 === n[3] - n[1])
          throw new a.FormatError('Invalid getTilingPatternIR /BBox array: [' + n + '].');
        return ['TilingPattern', k, b, m, n, e, h, p, d];
      };
    },
    function(y, m, t) {
      function a(a, b, d) {
        for (--d; b < d; ++b, --d) {
          var e = a[b];
          a[b] = a[d];
          a[d] = e;
        }
      }
      function k(a, b, d) {
        return { str: a, dir: d ? 'ttb' : b ? 'ltr' : 'rtl' };
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.bidi = void 0;
      var b = t(0),
        v = 'BN BN BN BN BN BN BN BN BN S B S WS B BN BN BN BN BN BN BN BN BN BN BN BN BN BN B B B S WS ON ON ET ET ET ON ON ON ON ON ES CS ES CS CS EN EN EN EN EN EN EN EN EN EN CS ON ON ON ON ON ON L L L L L L L L L L L L L L L L L L L L L L L L L L ON ON ON ON ON ON L L L L L L L L L L L L L L L L L L L L L L L L L L ON ON ON ON BN BN BN BN BN BN B BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN CS ON ET ET ET ET ON ON ON ON L ON ON BN ON ON ET ET EN EN ON L ON ON ON EN L ON ON ON ON ON L L L L L L L L L L L L L L L L L L L L L L L ON L L L L L L L L L L L L L L L L L L L L L L L L L L L L L L L ON L L L L L L L L'.split(
          ' ',
        ),
        d = 'AN AN AN AN AN AN ON ON AL ET ET AL CS AL ON ON NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM AL AL  AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM AN AN AN AN AN AN AN AN AN AN ET AN AN AL AL AL NSM AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL NSM NSM NSM NSM NSM NSM NSM AN ON NSM NSM NSM NSM NSM NSM AL AL NSM NSM ON NSM NSM NSM NSM AL AL EN EN EN EN EN EN EN EN EN EN AL AL AL AL AL AL'.split(
          ' ',
        ),
        u = [],
        z = [];
      m.bidi = function(m, t, n) {
        var e = !0,
          h = m.length;
        if (0 === h || n) return k(m, e, n);
        u.length = h;
        z.length = h;
        var p = 0;
        for (n = 0; n < h; ++n) {
          u[n] = m.charAt(n);
          var A = m.charCodeAt(n),
            c = 'L';
          255 >= A
            ? (c = v[A])
            : 1424 <= A && 1524 >= A
            ? (c = 'R')
            : 1536 <= A && 1791 >= A
            ? (c = d[A & 255]) || (0, b.warn)('Bidi: invalid Unicode character ' + A.toString(16))
            : 1792 <= A && 2220 >= A && (c = 'AL');
          ('R' !== c && 'AL' !== c && 'AN' !== c) || p++;
          z[n] = c;
        }
        if (0 === p) return k(m, !0);
        -1 === t && (0.3 > p / h ? ((e = !0), (t = 0)) : ((e = !1), (t = 1)));
        m = [];
        for (n = 0; n < h; ++n) m[n] = t;
        p = t = 0 !== (t & 1) ? 'R' : 'L';
        for (n = 0; n < h; ++n) 'NSM' === z[n] ? (z[n] = p) : (p = z[n]);
        p = t;
        for (n = 0; n < h; ++n)
          if (((A = z[n]), 'EN' === A)) z[n] = 'AL' === p ? 'AN' : 'EN';
          else if ('R' === A || 'L' === A || 'AL' === A) p = A;
        for (n = 0; n < h; ++n) (A = z[n]), 'AL' === A && (z[n] = 'R');
        for (n = 1; n < h - 1; ++n)
          'ES' === z[n] && 'EN' === z[n - 1] && 'EN' === z[n + 1] && (z[n] = 'EN'),
            'CS' !== z[n] || ('EN' !== z[n - 1] && 'AN' !== z[n - 1]) || z[n + 1] !== z[n - 1] || (z[n] = z[n - 1]);
        for (n = 0; n < h; ++n)
          if ('EN' === z[n]) {
            for (p = n - 1; 0 <= p && 'ET' === z[p]; --p) z[p] = 'EN';
            for (p = n + 1; p < h && 'ET' === z[p]; ++p) z[p] = 'EN';
          }
        for (n = 0; n < h; ++n) if (((A = z[n]), 'WS' === A || 'ES' === A || 'ET' === A || 'CS' === A)) z[n] = 'ON';
        p = t;
        for (n = 0; n < h; ++n)
          if (((A = z[n]), 'EN' === A)) z[n] = 'L' === p ? 'L' : 'EN';
          else if ('R' === A || 'L' === A) p = A;
        for (n = 0; n < h; ++n)
          if ('ON' === z[n]) {
            a: for (p = n + 1, A = z.length; p < A; ++p) if ('ON' !== z[p]) break a;
            var q = t;
            0 < n && (q = z[n - 1]);
            A = t;
            p + 1 < h && (A = z[p + 1]);
            'L' !== q && (q = 'R');
            'L' !== A && (A = 'R');
            if (q === A) for (A = z, c = p; n < c; ++n) A[n] = q;
            n = p - 1;
          }
        for (n = 0; n < h; ++n) 'ON' === z[n] && (z[n] = t);
        for (n = 0; n < h; ++n)
          if (((A = z[n]), 0 === (m[n] & 1)))
            if ('R' === A) m[n] += 1;
            else {
              if ('AN' === A || 'EN' === A) m[n] += 2;
            }
          else if ('L' === A || 'AN' === A || 'EN' === A) m[n] += 1;
        A = -1;
        t = 99;
        n = 0;
        for (h = m.length; n < h; ++n) (p = m[n]), A < p && (A = p), t > p && 0 !== (p & 1) && (t = p);
        for (p = A; p >= t; --p) {
          A = -1;
          n = 0;
          for (h = m.length; n < h; ++n) m[n] < p ? 0 <= A && (a(u, A, n), (A = -1)) : 0 > A && (A = n);
          0 <= A && a(u, A, m.length);
        }
        n = 0;
        for (h = u.length; n < h; ++n) if (((m = u[n]), '<' === m || '>' === m)) u[n] = '';
        return k(u.join(''), e);
      };
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.getMetrics = void 0;
      var a = t(0);
      y = (0, a.getLookupTableFactory)(function(k) {
        k.Courier = 600;
        k['Courier-Bold'] = 600;
        k['Courier-BoldOblique'] = 600;
        k['Courier-Oblique'] = 600;
        k.Helvetica = (0, a.getLookupTableFactory)(function(a) {
          a.space = 278;
          a.exclam = 278;
          a.quotedbl = 355;
          a.numbersign = 556;
          a.dollar = 556;
          a.percent = 889;
          a.ampersand = 667;
          a.quoteright = 222;
          a.parenleft = 333;
          a.parenright = 333;
          a.asterisk = 389;
          a.plus = 584;
          a.comma = 278;
          a.hyphen = 333;
          a.period = 278;
          a.slash = 278;
          a.zero = 556;
          a.one = 556;
          a.two = 556;
          a.three = 556;
          a.four = 556;
          a.five = 556;
          a.six = 556;
          a.seven = 556;
          a.eight = 556;
          a.nine = 556;
          a.colon = 278;
          a.semicolon = 278;
          a.less = 584;
          a.equal = 584;
          a.greater = 584;
          a.question = 556;
          a.at = 1015;
          a.A = 667;
          a.B = 667;
          a.C = 722;
          a.D = 722;
          a.E = 667;
          a.F = 611;
          a.G = 778;
          a.H = 722;
          a.I = 278;
          a.J = 500;
          a.K = 667;
          a.L = 556;
          a.M = 833;
          a.N = 722;
          a.O = 778;
          a.P = 667;
          a.Q = 778;
          a.R = 722;
          a.S = 667;
          a.T = 611;
          a.U = 722;
          a.V = 667;
          a.W = 944;
          a.X = 667;
          a.Y = 667;
          a.Z = 611;
          a.bracketleft = 278;
          a.backslash = 278;
          a.bracketright = 278;
          a.asciicircum = 469;
          a.underscore = 556;
          a.quoteleft = 222;
          a.a = 556;
          a.b = 556;
          a.c = 500;
          a.d = 556;
          a.e = 556;
          a.f = 278;
          a.g = 556;
          a.h = 556;
          a.i = 222;
          a.j = 222;
          a.k = 500;
          a.l = 222;
          a.m = 833;
          a.n = 556;
          a.o = 556;
          a.p = 556;
          a.q = 556;
          a.r = 333;
          a.s = 500;
          a.t = 278;
          a.u = 556;
          a.v = 500;
          a.w = 722;
          a.x = 500;
          a.y = 500;
          a.z = 500;
          a.braceleft = 334;
          a.bar = 260;
          a.braceright = 334;
          a.asciitilde = 584;
          a.exclamdown = 333;
          a.cent = 556;
          a.sterling = 556;
          a.fraction = 167;
          a.yen = 556;
          a.florin = 556;
          a.section = 556;
          a.currency = 556;
          a.quotesingle = 191;
          a.quotedblleft = 333;
          a.guillemotleft = 556;
          a.guilsinglleft = 333;
          a.guilsinglright = 333;
          a.fi = 500;
          a.fl = 500;
          a.endash = 556;
          a.dagger = 556;
          a.daggerdbl = 556;
          a.periodcentered = 278;
          a.paragraph = 537;
          a.bullet = 350;
          a.quotesinglbase = 222;
          a.quotedblbase = 333;
          a.quotedblright = 333;
          a.guillemotright = 556;
          a.ellipsis = 1e3;
          a.perthousand = 1e3;
          a.questiondown = 611;
          a.grave = 333;
          a.acute = 333;
          a.circumflex = 333;
          a.tilde = 333;
          a.macron = 333;
          a.breve = 333;
          a.dotaccent = 333;
          a.dieresis = 333;
          a.ring = 333;
          a.cedilla = 333;
          a.hungarumlaut = 333;
          a.ogonek = 333;
          a.caron = 333;
          a.emdash = 1e3;
          a.AE = 1e3;
          a.ordfeminine = 370;
          a.Lslash = 556;
          a.Oslash = 778;
          a.OE = 1e3;
          a.ordmasculine = 365;
          a.ae = 889;
          a.dotlessi = 278;
          a.lslash = 222;
          a.oslash = 611;
          a.oe = 944;
          a.germandbls = 611;
          a.Idieresis = 278;
          a.eacute = 556;
          a.abreve = 556;
          a.uhungarumlaut = 556;
          a.ecaron = 556;
          a.Ydieresis = 667;
          a.divide = 584;
          a.Yacute = 667;
          a.Acircumflex = 667;
          a.aacute = 556;
          a.Ucircumflex = 722;
          a.yacute = 500;
          a.scommaaccent = 500;
          a.ecircumflex = 556;
          a.Uring = 722;
          a.Udieresis = 722;
          a.aogonek = 556;
          a.Uacute = 722;
          a.uogonek = 556;
          a.Edieresis = 667;
          a.Dcroat = 722;
          a.commaaccent = 250;
          a.copyright = 737;
          a.Emacron = 667;
          a.ccaron = 500;
          a.aring = 556;
          a.Ncommaaccent = 722;
          a.lacute = 222;
          a.agrave = 556;
          a.Tcommaaccent = 611;
          a.Cacute = 722;
          a.atilde = 556;
          a.Edotaccent = 667;
          a.scaron = 500;
          a.scedilla = 500;
          a.iacute = 278;
          a.lozenge = 471;
          a.Rcaron = 722;
          a.Gcommaaccent = 778;
          a.ucircumflex = 556;
          a.acircumflex = 556;
          a.Amacron = 667;
          a.rcaron = 333;
          a.ccedilla = 500;
          a.Zdotaccent = 611;
          a.Thorn = 667;
          a.Omacron = 778;
          a.Racute = 722;
          a.Sacute = 667;
          a.dcaron = 643;
          a.Umacron = 722;
          a.uring = 556;
          a.threesuperior = 333;
          a.Ograve = 778;
          a.Agrave = 667;
          a.Abreve = 667;
          a.multiply = 584;
          a.uacute = 556;
          a.Tcaron = 611;
          a.partialdiff = 476;
          a.ydieresis = 500;
          a.Nacute = 722;
          a.icircumflex = 278;
          a.Ecircumflex = 667;
          a.adieresis = 556;
          a.edieresis = 556;
          a.cacute = 500;
          a.nacute = 556;
          a.umacron = 556;
          a.Ncaron = 722;
          a.Iacute = 278;
          a.plusminus = 584;
          a.brokenbar = 260;
          a.registered = 737;
          a.Gbreve = 778;
          a.Idotaccent = 278;
          a.summation = 600;
          a.Egrave = 667;
          a.racute = 333;
          a.omacron = 556;
          a.Zacute = 611;
          a.Zcaron = 611;
          a.greaterequal = 549;
          a.Eth = 722;
          a.Ccedilla = 722;
          a.lcommaaccent = 222;
          a.tcaron = 317;
          a.eogonek = 556;
          a.Uogonek = 722;
          a.Aacute = 667;
          a.Adieresis = 667;
          a.egrave = 556;
          a.zacute = 500;
          a.iogonek = 222;
          a.Oacute = 778;
          a.oacute = 556;
          a.amacron = 556;
          a.sacute = 500;
          a.idieresis = 278;
          a.Ocircumflex = 778;
          a.Ugrave = 722;
          a.Delta = 612;
          a.thorn = 556;
          a.twosuperior = 333;
          a.Odieresis = 778;
          a.mu = 556;
          a.igrave = 278;
          a.ohungarumlaut = 556;
          a.Eogonek = 667;
          a.dcroat = 556;
          a.threequarters = 834;
          a.Scedilla = 667;
          a.lcaron = 299;
          a.Kcommaaccent = 667;
          a.Lacute = 556;
          a.trademark = 1e3;
          a.edotaccent = 556;
          a.Igrave = 278;
          a.Imacron = 278;
          a.Lcaron = 556;
          a.onehalf = 834;
          a.lessequal = 549;
          a.ocircumflex = 556;
          a.ntilde = 556;
          a.Uhungarumlaut = 722;
          a.Eacute = 667;
          a.emacron = 556;
          a.gbreve = 556;
          a.onequarter = 834;
          a.Scaron = 667;
          a.Scommaaccent = 667;
          a.Ohungarumlaut = 778;
          a.degree = 400;
          a.ograve = 556;
          a.Ccaron = 722;
          a.ugrave = 556;
          a.radical = 453;
          a.Dcaron = 722;
          a.rcommaaccent = 333;
          a.Ntilde = 722;
          a.otilde = 556;
          a.Rcommaaccent = 722;
          a.Lcommaaccent = 556;
          a.Atilde = 667;
          a.Aogonek = 667;
          a.Aring = 667;
          a.Otilde = 778;
          a.zdotaccent = 500;
          a.Ecaron = 667;
          a.Iogonek = 278;
          a.kcommaaccent = 500;
          a.minus = 584;
          a.Icircumflex = 278;
          a.ncaron = 556;
          a.tcommaaccent = 278;
          a.logicalnot = 584;
          a.odieresis = 556;
          a.udieresis = 556;
          a.notequal = 549;
          a.gcommaaccent = 556;
          a.eth = 556;
          a.zcaron = 500;
          a.ncommaaccent = 556;
          a.onesuperior = 333;
          a.imacron = 278;
          a.Euro = 556;
        });
        k['Helvetica-Bold'] = (0, a.getLookupTableFactory)(function(a) {
          a.space = 278;
          a.exclam = 333;
          a.quotedbl = 474;
          a.numbersign = 556;
          a.dollar = 556;
          a.percent = 889;
          a.ampersand = 722;
          a.quoteright = 278;
          a.parenleft = 333;
          a.parenright = 333;
          a.asterisk = 389;
          a.plus = 584;
          a.comma = 278;
          a.hyphen = 333;
          a.period = 278;
          a.slash = 278;
          a.zero = 556;
          a.one = 556;
          a.two = 556;
          a.three = 556;
          a.four = 556;
          a.five = 556;
          a.six = 556;
          a.seven = 556;
          a.eight = 556;
          a.nine = 556;
          a.colon = 333;
          a.semicolon = 333;
          a.less = 584;
          a.equal = 584;
          a.greater = 584;
          a.question = 611;
          a.at = 975;
          a.A = 722;
          a.B = 722;
          a.C = 722;
          a.D = 722;
          a.E = 667;
          a.F = 611;
          a.G = 778;
          a.H = 722;
          a.I = 278;
          a.J = 556;
          a.K = 722;
          a.L = 611;
          a.M = 833;
          a.N = 722;
          a.O = 778;
          a.P = 667;
          a.Q = 778;
          a.R = 722;
          a.S = 667;
          a.T = 611;
          a.U = 722;
          a.V = 667;
          a.W = 944;
          a.X = 667;
          a.Y = 667;
          a.Z = 611;
          a.bracketleft = 333;
          a.backslash = 278;
          a.bracketright = 333;
          a.asciicircum = 584;
          a.underscore = 556;
          a.quoteleft = 278;
          a.a = 556;
          a.b = 611;
          a.c = 556;
          a.d = 611;
          a.e = 556;
          a.f = 333;
          a.g = 611;
          a.h = 611;
          a.i = 278;
          a.j = 278;
          a.k = 556;
          a.l = 278;
          a.m = 889;
          a.n = 611;
          a.o = 611;
          a.p = 611;
          a.q = 611;
          a.r = 389;
          a.s = 556;
          a.t = 333;
          a.u = 611;
          a.v = 556;
          a.w = 778;
          a.x = 556;
          a.y = 556;
          a.z = 500;
          a.braceleft = 389;
          a.bar = 280;
          a.braceright = 389;
          a.asciitilde = 584;
          a.exclamdown = 333;
          a.cent = 556;
          a.sterling = 556;
          a.fraction = 167;
          a.yen = 556;
          a.florin = 556;
          a.section = 556;
          a.currency = 556;
          a.quotesingle = 238;
          a.quotedblleft = 500;
          a.guillemotleft = 556;
          a.guilsinglleft = 333;
          a.guilsinglright = 333;
          a.fi = 611;
          a.fl = 611;
          a.endash = 556;
          a.dagger = 556;
          a.daggerdbl = 556;
          a.periodcentered = 278;
          a.paragraph = 556;
          a.bullet = 350;
          a.quotesinglbase = 278;
          a.quotedblbase = 500;
          a.quotedblright = 500;
          a.guillemotright = 556;
          a.ellipsis = 1e3;
          a.perthousand = 1e3;
          a.questiondown = 611;
          a.grave = 333;
          a.acute = 333;
          a.circumflex = 333;
          a.tilde = 333;
          a.macron = 333;
          a.breve = 333;
          a.dotaccent = 333;
          a.dieresis = 333;
          a.ring = 333;
          a.cedilla = 333;
          a.hungarumlaut = 333;
          a.ogonek = 333;
          a.caron = 333;
          a.emdash = 1e3;
          a.AE = 1e3;
          a.ordfeminine = 370;
          a.Lslash = 611;
          a.Oslash = 778;
          a.OE = 1e3;
          a.ordmasculine = 365;
          a.ae = 889;
          a.dotlessi = 278;
          a.lslash = 278;
          a.oslash = 611;
          a.oe = 944;
          a.germandbls = 611;
          a.Idieresis = 278;
          a.eacute = 556;
          a.abreve = 556;
          a.uhungarumlaut = 611;
          a.ecaron = 556;
          a.Ydieresis = 667;
          a.divide = 584;
          a.Yacute = 667;
          a.Acircumflex = 722;
          a.aacute = 556;
          a.Ucircumflex = 722;
          a.yacute = 556;
          a.scommaaccent = 556;
          a.ecircumflex = 556;
          a.Uring = 722;
          a.Udieresis = 722;
          a.aogonek = 556;
          a.Uacute = 722;
          a.uogonek = 611;
          a.Edieresis = 667;
          a.Dcroat = 722;
          a.commaaccent = 250;
          a.copyright = 737;
          a.Emacron = 667;
          a.ccaron = 556;
          a.aring = 556;
          a.Ncommaaccent = 722;
          a.lacute = 278;
          a.agrave = 556;
          a.Tcommaaccent = 611;
          a.Cacute = 722;
          a.atilde = 556;
          a.Edotaccent = 667;
          a.scaron = 556;
          a.scedilla = 556;
          a.iacute = 278;
          a.lozenge = 494;
          a.Rcaron = 722;
          a.Gcommaaccent = 778;
          a.ucircumflex = 611;
          a.acircumflex = 556;
          a.Amacron = 722;
          a.rcaron = 389;
          a.ccedilla = 556;
          a.Zdotaccent = 611;
          a.Thorn = 667;
          a.Omacron = 778;
          a.Racute = 722;
          a.Sacute = 667;
          a.dcaron = 743;
          a.Umacron = 722;
          a.uring = 611;
          a.threesuperior = 333;
          a.Ograve = 778;
          a.Agrave = 722;
          a.Abreve = 722;
          a.multiply = 584;
          a.uacute = 611;
          a.Tcaron = 611;
          a.partialdiff = 494;
          a.ydieresis = 556;
          a.Nacute = 722;
          a.icircumflex = 278;
          a.Ecircumflex = 667;
          a.adieresis = 556;
          a.edieresis = 556;
          a.cacute = 556;
          a.nacute = 611;
          a.umacron = 611;
          a.Ncaron = 722;
          a.Iacute = 278;
          a.plusminus = 584;
          a.brokenbar = 280;
          a.registered = 737;
          a.Gbreve = 778;
          a.Idotaccent = 278;
          a.summation = 600;
          a.Egrave = 667;
          a.racute = 389;
          a.omacron = 611;
          a.Zacute = 611;
          a.Zcaron = 611;
          a.greaterequal = 549;
          a.Eth = 722;
          a.Ccedilla = 722;
          a.lcommaaccent = 278;
          a.tcaron = 389;
          a.eogonek = 556;
          a.Uogonek = 722;
          a.Aacute = 722;
          a.Adieresis = 722;
          a.egrave = 556;
          a.zacute = 500;
          a.iogonek = 278;
          a.Oacute = 778;
          a.oacute = 611;
          a.amacron = 556;
          a.sacute = 556;
          a.idieresis = 278;
          a.Ocircumflex = 778;
          a.Ugrave = 722;
          a.Delta = 612;
          a.thorn = 611;
          a.twosuperior = 333;
          a.Odieresis = 778;
          a.mu = 611;
          a.igrave = 278;
          a.ohungarumlaut = 611;
          a.Eogonek = 667;
          a.dcroat = 611;
          a.threequarters = 834;
          a.Scedilla = 667;
          a.lcaron = 400;
          a.Kcommaaccent = 722;
          a.Lacute = 611;
          a.trademark = 1e3;
          a.edotaccent = 556;
          a.Igrave = 278;
          a.Imacron = 278;
          a.Lcaron = 611;
          a.onehalf = 834;
          a.lessequal = 549;
          a.ocircumflex = 611;
          a.ntilde = 611;
          a.Uhungarumlaut = 722;
          a.Eacute = 667;
          a.emacron = 556;
          a.gbreve = 611;
          a.onequarter = 834;
          a.Scaron = 667;
          a.Scommaaccent = 667;
          a.Ohungarumlaut = 778;
          a.degree = 400;
          a.ograve = 611;
          a.Ccaron = 722;
          a.ugrave = 611;
          a.radical = 549;
          a.Dcaron = 722;
          a.rcommaaccent = 389;
          a.Ntilde = 722;
          a.otilde = 611;
          a.Rcommaaccent = 722;
          a.Lcommaaccent = 611;
          a.Atilde = 722;
          a.Aogonek = 722;
          a.Aring = 722;
          a.Otilde = 778;
          a.zdotaccent = 500;
          a.Ecaron = 667;
          a.Iogonek = 278;
          a.kcommaaccent = 556;
          a.minus = 584;
          a.Icircumflex = 278;
          a.ncaron = 611;
          a.tcommaaccent = 333;
          a.logicalnot = 584;
          a.odieresis = 611;
          a.udieresis = 611;
          a.notequal = 549;
          a.gcommaaccent = 611;
          a.eth = 611;
          a.zcaron = 500;
          a.ncommaaccent = 611;
          a.onesuperior = 333;
          a.imacron = 278;
          a.Euro = 556;
        });
        k['Helvetica-BoldOblique'] = (0, a.getLookupTableFactory)(function(a) {
          a.space = 278;
          a.exclam = 333;
          a.quotedbl = 474;
          a.numbersign = 556;
          a.dollar = 556;
          a.percent = 889;
          a.ampersand = 722;
          a.quoteright = 278;
          a.parenleft = 333;
          a.parenright = 333;
          a.asterisk = 389;
          a.plus = 584;
          a.comma = 278;
          a.hyphen = 333;
          a.period = 278;
          a.slash = 278;
          a.zero = 556;
          a.one = 556;
          a.two = 556;
          a.three = 556;
          a.four = 556;
          a.five = 556;
          a.six = 556;
          a.seven = 556;
          a.eight = 556;
          a.nine = 556;
          a.colon = 333;
          a.semicolon = 333;
          a.less = 584;
          a.equal = 584;
          a.greater = 584;
          a.question = 611;
          a.at = 975;
          a.A = 722;
          a.B = 722;
          a.C = 722;
          a.D = 722;
          a.E = 667;
          a.F = 611;
          a.G = 778;
          a.H = 722;
          a.I = 278;
          a.J = 556;
          a.K = 722;
          a.L = 611;
          a.M = 833;
          a.N = 722;
          a.O = 778;
          a.P = 667;
          a.Q = 778;
          a.R = 722;
          a.S = 667;
          a.T = 611;
          a.U = 722;
          a.V = 667;
          a.W = 944;
          a.X = 667;
          a.Y = 667;
          a.Z = 611;
          a.bracketleft = 333;
          a.backslash = 278;
          a.bracketright = 333;
          a.asciicircum = 584;
          a.underscore = 556;
          a.quoteleft = 278;
          a.a = 556;
          a.b = 611;
          a.c = 556;
          a.d = 611;
          a.e = 556;
          a.f = 333;
          a.g = 611;
          a.h = 611;
          a.i = 278;
          a.j = 278;
          a.k = 556;
          a.l = 278;
          a.m = 889;
          a.n = 611;
          a.o = 611;
          a.p = 611;
          a.q = 611;
          a.r = 389;
          a.s = 556;
          a.t = 333;
          a.u = 611;
          a.v = 556;
          a.w = 778;
          a.x = 556;
          a.y = 556;
          a.z = 500;
          a.braceleft = 389;
          a.bar = 280;
          a.braceright = 389;
          a.asciitilde = 584;
          a.exclamdown = 333;
          a.cent = 556;
          a.sterling = 556;
          a.fraction = 167;
          a.yen = 556;
          a.florin = 556;
          a.section = 556;
          a.currency = 556;
          a.quotesingle = 238;
          a.quotedblleft = 500;
          a.guillemotleft = 556;
          a.guilsinglleft = 333;
          a.guilsinglright = 333;
          a.fi = 611;
          a.fl = 611;
          a.endash = 556;
          a.dagger = 556;
          a.daggerdbl = 556;
          a.periodcentered = 278;
          a.paragraph = 556;
          a.bullet = 350;
          a.quotesinglbase = 278;
          a.quotedblbase = 500;
          a.quotedblright = 500;
          a.guillemotright = 556;
          a.ellipsis = 1e3;
          a.perthousand = 1e3;
          a.questiondown = 611;
          a.grave = 333;
          a.acute = 333;
          a.circumflex = 333;
          a.tilde = 333;
          a.macron = 333;
          a.breve = 333;
          a.dotaccent = 333;
          a.dieresis = 333;
          a.ring = 333;
          a.cedilla = 333;
          a.hungarumlaut = 333;
          a.ogonek = 333;
          a.caron = 333;
          a.emdash = 1e3;
          a.AE = 1e3;
          a.ordfeminine = 370;
          a.Lslash = 611;
          a.Oslash = 778;
          a.OE = 1e3;
          a.ordmasculine = 365;
          a.ae = 889;
          a.dotlessi = 278;
          a.lslash = 278;
          a.oslash = 611;
          a.oe = 944;
          a.germandbls = 611;
          a.Idieresis = 278;
          a.eacute = 556;
          a.abreve = 556;
          a.uhungarumlaut = 611;
          a.ecaron = 556;
          a.Ydieresis = 667;
          a.divide = 584;
          a.Yacute = 667;
          a.Acircumflex = 722;
          a.aacute = 556;
          a.Ucircumflex = 722;
          a.yacute = 556;
          a.scommaaccent = 556;
          a.ecircumflex = 556;
          a.Uring = 722;
          a.Udieresis = 722;
          a.aogonek = 556;
          a.Uacute = 722;
          a.uogonek = 611;
          a.Edieresis = 667;
          a.Dcroat = 722;
          a.commaaccent = 250;
          a.copyright = 737;
          a.Emacron = 667;
          a.ccaron = 556;
          a.aring = 556;
          a.Ncommaaccent = 722;
          a.lacute = 278;
          a.agrave = 556;
          a.Tcommaaccent = 611;
          a.Cacute = 722;
          a.atilde = 556;
          a.Edotaccent = 667;
          a.scaron = 556;
          a.scedilla = 556;
          a.iacute = 278;
          a.lozenge = 494;
          a.Rcaron = 722;
          a.Gcommaaccent = 778;
          a.ucircumflex = 611;
          a.acircumflex = 556;
          a.Amacron = 722;
          a.rcaron = 389;
          a.ccedilla = 556;
          a.Zdotaccent = 611;
          a.Thorn = 667;
          a.Omacron = 778;
          a.Racute = 722;
          a.Sacute = 667;
          a.dcaron = 743;
          a.Umacron = 722;
          a.uring = 611;
          a.threesuperior = 333;
          a.Ograve = 778;
          a.Agrave = 722;
          a.Abreve = 722;
          a.multiply = 584;
          a.uacute = 611;
          a.Tcaron = 611;
          a.partialdiff = 494;
          a.ydieresis = 556;
          a.Nacute = 722;
          a.icircumflex = 278;
          a.Ecircumflex = 667;
          a.adieresis = 556;
          a.edieresis = 556;
          a.cacute = 556;
          a.nacute = 611;
          a.umacron = 611;
          a.Ncaron = 722;
          a.Iacute = 278;
          a.plusminus = 584;
          a.brokenbar = 280;
          a.registered = 737;
          a.Gbreve = 778;
          a.Idotaccent = 278;
          a.summation = 600;
          a.Egrave = 667;
          a.racute = 389;
          a.omacron = 611;
          a.Zacute = 611;
          a.Zcaron = 611;
          a.greaterequal = 549;
          a.Eth = 722;
          a.Ccedilla = 722;
          a.lcommaaccent = 278;
          a.tcaron = 389;
          a.eogonek = 556;
          a.Uogonek = 722;
          a.Aacute = 722;
          a.Adieresis = 722;
          a.egrave = 556;
          a.zacute = 500;
          a.iogonek = 278;
          a.Oacute = 778;
          a.oacute = 611;
          a.amacron = 556;
          a.sacute = 556;
          a.idieresis = 278;
          a.Ocircumflex = 778;
          a.Ugrave = 722;
          a.Delta = 612;
          a.thorn = 611;
          a.twosuperior = 333;
          a.Odieresis = 778;
          a.mu = 611;
          a.igrave = 278;
          a.ohungarumlaut = 611;
          a.Eogonek = 667;
          a.dcroat = 611;
          a.threequarters = 834;
          a.Scedilla = 667;
          a.lcaron = 400;
          a.Kcommaaccent = 722;
          a.Lacute = 611;
          a.trademark = 1e3;
          a.edotaccent = 556;
          a.Igrave = 278;
          a.Imacron = 278;
          a.Lcaron = 611;
          a.onehalf = 834;
          a.lessequal = 549;
          a.ocircumflex = 611;
          a.ntilde = 611;
          a.Uhungarumlaut = 722;
          a.Eacute = 667;
          a.emacron = 556;
          a.gbreve = 611;
          a.onequarter = 834;
          a.Scaron = 667;
          a.Scommaaccent = 667;
          a.Ohungarumlaut = 778;
          a.degree = 400;
          a.ograve = 611;
          a.Ccaron = 722;
          a.ugrave = 611;
          a.radical = 549;
          a.Dcaron = 722;
          a.rcommaaccent = 389;
          a.Ntilde = 722;
          a.otilde = 611;
          a.Rcommaaccent = 722;
          a.Lcommaaccent = 611;
          a.Atilde = 722;
          a.Aogonek = 722;
          a.Aring = 722;
          a.Otilde = 778;
          a.zdotaccent = 500;
          a.Ecaron = 667;
          a.Iogonek = 278;
          a.kcommaaccent = 556;
          a.minus = 584;
          a.Icircumflex = 278;
          a.ncaron = 611;
          a.tcommaaccent = 333;
          a.logicalnot = 584;
          a.odieresis = 611;
          a.udieresis = 611;
          a.notequal = 549;
          a.gcommaaccent = 611;
          a.eth = 611;
          a.zcaron = 500;
          a.ncommaaccent = 611;
          a.onesuperior = 333;
          a.imacron = 278;
          a.Euro = 556;
        });
        k['Helvetica-Oblique'] = (0, a.getLookupTableFactory)(function(a) {
          a.space = 278;
          a.exclam = 278;
          a.quotedbl = 355;
          a.numbersign = 556;
          a.dollar = 556;
          a.percent = 889;
          a.ampersand = 667;
          a.quoteright = 222;
          a.parenleft = 333;
          a.parenright = 333;
          a.asterisk = 389;
          a.plus = 584;
          a.comma = 278;
          a.hyphen = 333;
          a.period = 278;
          a.slash = 278;
          a.zero = 556;
          a.one = 556;
          a.two = 556;
          a.three = 556;
          a.four = 556;
          a.five = 556;
          a.six = 556;
          a.seven = 556;
          a.eight = 556;
          a.nine = 556;
          a.colon = 278;
          a.semicolon = 278;
          a.less = 584;
          a.equal = 584;
          a.greater = 584;
          a.question = 556;
          a.at = 1015;
          a.A = 667;
          a.B = 667;
          a.C = 722;
          a.D = 722;
          a.E = 667;
          a.F = 611;
          a.G = 778;
          a.H = 722;
          a.I = 278;
          a.J = 500;
          a.K = 667;
          a.L = 556;
          a.M = 833;
          a.N = 722;
          a.O = 778;
          a.P = 667;
          a.Q = 778;
          a.R = 722;
          a.S = 667;
          a.T = 611;
          a.U = 722;
          a.V = 667;
          a.W = 944;
          a.X = 667;
          a.Y = 667;
          a.Z = 611;
          a.bracketleft = 278;
          a.backslash = 278;
          a.bracketright = 278;
          a.asciicircum = 469;
          a.underscore = 556;
          a.quoteleft = 222;
          a.a = 556;
          a.b = 556;
          a.c = 500;
          a.d = 556;
          a.e = 556;
          a.f = 278;
          a.g = 556;
          a.h = 556;
          a.i = 222;
          a.j = 222;
          a.k = 500;
          a.l = 222;
          a.m = 833;
          a.n = 556;
          a.o = 556;
          a.p = 556;
          a.q = 556;
          a.r = 333;
          a.s = 500;
          a.t = 278;
          a.u = 556;
          a.v = 500;
          a.w = 722;
          a.x = 500;
          a.y = 500;
          a.z = 500;
          a.braceleft = 334;
          a.bar = 260;
          a.braceright = 334;
          a.asciitilde = 584;
          a.exclamdown = 333;
          a.cent = 556;
          a.sterling = 556;
          a.fraction = 167;
          a.yen = 556;
          a.florin = 556;
          a.section = 556;
          a.currency = 556;
          a.quotesingle = 191;
          a.quotedblleft = 333;
          a.guillemotleft = 556;
          a.guilsinglleft = 333;
          a.guilsinglright = 333;
          a.fi = 500;
          a.fl = 500;
          a.endash = 556;
          a.dagger = 556;
          a.daggerdbl = 556;
          a.periodcentered = 278;
          a.paragraph = 537;
          a.bullet = 350;
          a.quotesinglbase = 222;
          a.quotedblbase = 333;
          a.quotedblright = 333;
          a.guillemotright = 556;
          a.ellipsis = 1e3;
          a.perthousand = 1e3;
          a.questiondown = 611;
          a.grave = 333;
          a.acute = 333;
          a.circumflex = 333;
          a.tilde = 333;
          a.macron = 333;
          a.breve = 333;
          a.dotaccent = 333;
          a.dieresis = 333;
          a.ring = 333;
          a.cedilla = 333;
          a.hungarumlaut = 333;
          a.ogonek = 333;
          a.caron = 333;
          a.emdash = 1e3;
          a.AE = 1e3;
          a.ordfeminine = 370;
          a.Lslash = 556;
          a.Oslash = 778;
          a.OE = 1e3;
          a.ordmasculine = 365;
          a.ae = 889;
          a.dotlessi = 278;
          a.lslash = 222;
          a.oslash = 611;
          a.oe = 944;
          a.germandbls = 611;
          a.Idieresis = 278;
          a.eacute = 556;
          a.abreve = 556;
          a.uhungarumlaut = 556;
          a.ecaron = 556;
          a.Ydieresis = 667;
          a.divide = 584;
          a.Yacute = 667;
          a.Acircumflex = 667;
          a.aacute = 556;
          a.Ucircumflex = 722;
          a.yacute = 500;
          a.scommaaccent = 500;
          a.ecircumflex = 556;
          a.Uring = 722;
          a.Udieresis = 722;
          a.aogonek = 556;
          a.Uacute = 722;
          a.uogonek = 556;
          a.Edieresis = 667;
          a.Dcroat = 722;
          a.commaaccent = 250;
          a.copyright = 737;
          a.Emacron = 667;
          a.ccaron = 500;
          a.aring = 556;
          a.Ncommaaccent = 722;
          a.lacute = 222;
          a.agrave = 556;
          a.Tcommaaccent = 611;
          a.Cacute = 722;
          a.atilde = 556;
          a.Edotaccent = 667;
          a.scaron = 500;
          a.scedilla = 500;
          a.iacute = 278;
          a.lozenge = 471;
          a.Rcaron = 722;
          a.Gcommaaccent = 778;
          a.ucircumflex = 556;
          a.acircumflex = 556;
          a.Amacron = 667;
          a.rcaron = 333;
          a.ccedilla = 500;
          a.Zdotaccent = 611;
          a.Thorn = 667;
          a.Omacron = 778;
          a.Racute = 722;
          a.Sacute = 667;
          a.dcaron = 643;
          a.Umacron = 722;
          a.uring = 556;
          a.threesuperior = 333;
          a.Ograve = 778;
          a.Agrave = 667;
          a.Abreve = 667;
          a.multiply = 584;
          a.uacute = 556;
          a.Tcaron = 611;
          a.partialdiff = 476;
          a.ydieresis = 500;
          a.Nacute = 722;
          a.icircumflex = 278;
          a.Ecircumflex = 667;
          a.adieresis = 556;
          a.edieresis = 556;
          a.cacute = 500;
          a.nacute = 556;
          a.umacron = 556;
          a.Ncaron = 722;
          a.Iacute = 278;
          a.plusminus = 584;
          a.brokenbar = 260;
          a.registered = 737;
          a.Gbreve = 778;
          a.Idotaccent = 278;
          a.summation = 600;
          a.Egrave = 667;
          a.racute = 333;
          a.omacron = 556;
          a.Zacute = 611;
          a.Zcaron = 611;
          a.greaterequal = 549;
          a.Eth = 722;
          a.Ccedilla = 722;
          a.lcommaaccent = 222;
          a.tcaron = 317;
          a.eogonek = 556;
          a.Uogonek = 722;
          a.Aacute = 667;
          a.Adieresis = 667;
          a.egrave = 556;
          a.zacute = 500;
          a.iogonek = 222;
          a.Oacute = 778;
          a.oacute = 556;
          a.amacron = 556;
          a.sacute = 500;
          a.idieresis = 278;
          a.Ocircumflex = 778;
          a.Ugrave = 722;
          a.Delta = 612;
          a.thorn = 556;
          a.twosuperior = 333;
          a.Odieresis = 778;
          a.mu = 556;
          a.igrave = 278;
          a.ohungarumlaut = 556;
          a.Eogonek = 667;
          a.dcroat = 556;
          a.threequarters = 834;
          a.Scedilla = 667;
          a.lcaron = 299;
          a.Kcommaaccent = 667;
          a.Lacute = 556;
          a.trademark = 1e3;
          a.edotaccent = 556;
          a.Igrave = 278;
          a.Imacron = 278;
          a.Lcaron = 556;
          a.onehalf = 834;
          a.lessequal = 549;
          a.ocircumflex = 556;
          a.ntilde = 556;
          a.Uhungarumlaut = 722;
          a.Eacute = 667;
          a.emacron = 556;
          a.gbreve = 556;
          a.onequarter = 834;
          a.Scaron = 667;
          a.Scommaaccent = 667;
          a.Ohungarumlaut = 778;
          a.degree = 400;
          a.ograve = 556;
          a.Ccaron = 722;
          a.ugrave = 556;
          a.radical = 453;
          a.Dcaron = 722;
          a.rcommaaccent = 333;
          a.Ntilde = 722;
          a.otilde = 556;
          a.Rcommaaccent = 722;
          a.Lcommaaccent = 556;
          a.Atilde = 667;
          a.Aogonek = 667;
          a.Aring = 667;
          a.Otilde = 778;
          a.zdotaccent = 500;
          a.Ecaron = 667;
          a.Iogonek = 278;
          a.kcommaaccent = 500;
          a.minus = 584;
          a.Icircumflex = 278;
          a.ncaron = 556;
          a.tcommaaccent = 278;
          a.logicalnot = 584;
          a.odieresis = 556;
          a.udieresis = 556;
          a.notequal = 549;
          a.gcommaaccent = 556;
          a.eth = 556;
          a.zcaron = 500;
          a.ncommaaccent = 556;
          a.onesuperior = 333;
          a.imacron = 278;
          a.Euro = 556;
        });
        k.Symbol = (0, a.getLookupTableFactory)(function(a) {
          a.space = 250;
          a.exclam = 333;
          a.universal = 713;
          a.numbersign = 500;
          a.existential = 549;
          a.percent = 833;
          a.ampersand = 778;
          a.suchthat = 439;
          a.parenleft = 333;
          a.parenright = 333;
          a.asteriskmath = 500;
          a.plus = 549;
          a.comma = 250;
          a.minus = 549;
          a.period = 250;
          a.slash = 278;
          a.zero = 500;
          a.one = 500;
          a.two = 500;
          a.three = 500;
          a.four = 500;
          a.five = 500;
          a.six = 500;
          a.seven = 500;
          a.eight = 500;
          a.nine = 500;
          a.colon = 278;
          a.semicolon = 278;
          a.less = 549;
          a.equal = 549;
          a.greater = 549;
          a.question = 444;
          a.congruent = 549;
          a.Alpha = 722;
          a.Beta = 667;
          a.Chi = 722;
          a.Delta = 612;
          a.Epsilon = 611;
          a.Phi = 763;
          a.Gamma = 603;
          a.Eta = 722;
          a.Iota = 333;
          a.theta1 = 631;
          a.Kappa = 722;
          a.Lambda = 686;
          a.Mu = 889;
          a.Nu = 722;
          a.Omicron = 722;
          a.Pi = 768;
          a.Theta = 741;
          a.Rho = 556;
          a.Sigma = 592;
          a.Tau = 611;
          a.Upsilon = 690;
          a.sigma1 = 439;
          a.Omega = 768;
          a.Xi = 645;
          a.Psi = 795;
          a.Zeta = 611;
          a.bracketleft = 333;
          a.therefore = 863;
          a.bracketright = 333;
          a.perpendicular = 658;
          a.underscore = 500;
          a.radicalex = 500;
          a.alpha = 631;
          a.beta = 549;
          a.chi = 549;
          a.delta = 494;
          a.epsilon = 439;
          a.phi = 521;
          a.gamma = 411;
          a.eta = 603;
          a.iota = 329;
          a.phi1 = 603;
          a.kappa = 549;
          a.lambda = 549;
          a.mu = 576;
          a.nu = 521;
          a.omicron = 549;
          a.pi = 549;
          a.theta = 521;
          a.rho = 549;
          a.sigma = 603;
          a.tau = 439;
          a.upsilon = 576;
          a.omega1 = 713;
          a.omega = 686;
          a.xi = 493;
          a.psi = 686;
          a.zeta = 494;
          a.braceleft = 480;
          a.bar = 200;
          a.braceright = 480;
          a.similar = 549;
          a.Euro = 750;
          a.Upsilon1 = 620;
          a.minute = 247;
          a.lessequal = 549;
          a.fraction = 167;
          a.infinity = 713;
          a.florin = 500;
          a.club = 753;
          a.diamond = 753;
          a.heart = 753;
          a.spade = 753;
          a.arrowboth = 1042;
          a.arrowleft = 987;
          a.arrowup = 603;
          a.arrowright = 987;
          a.arrowdown = 603;
          a.degree = 400;
          a.plusminus = 549;
          a.second = 411;
          a.greaterequal = 549;
          a.multiply = 549;
          a.proportional = 713;
          a.partialdiff = 494;
          a.bullet = 460;
          a.divide = 549;
          a.notequal = 549;
          a.equivalence = 549;
          a.approxequal = 549;
          a.ellipsis = 1e3;
          a.arrowvertex = 603;
          a.arrowhorizex = 1e3;
          a.carriagereturn = 658;
          a.aleph = 823;
          a.Ifraktur = 686;
          a.Rfraktur = 795;
          a.weierstrass = 987;
          a.circlemultiply = 768;
          a.circleplus = 768;
          a.emptyset = 823;
          a.intersection = 768;
          a.union = 768;
          a.propersuperset = 713;
          a.reflexsuperset = 713;
          a.notsubset = 713;
          a.propersubset = 713;
          a.reflexsubset = 713;
          a.element = 713;
          a.notelement = 713;
          a.angle = 768;
          a.gradient = 713;
          a.registerserif = 790;
          a.copyrightserif = 790;
          a.trademarkserif = 890;
          a.product = 823;
          a.radical = 549;
          a.dotmath = 250;
          a.logicalnot = 713;
          a.logicaland = 603;
          a.logicalor = 603;
          a.arrowdblboth = 1042;
          a.arrowdblleft = 987;
          a.arrowdblup = 603;
          a.arrowdblright = 987;
          a.arrowdbldown = 603;
          a.lozenge = 494;
          a.angleleft = 329;
          a.registersans = 790;
          a.copyrightsans = 790;
          a.trademarksans = 786;
          a.summation = 713;
          a.parenlefttp = 384;
          a.parenleftex = 384;
          a.parenleftbt = 384;
          a.bracketlefttp = 384;
          a.bracketleftex = 384;
          a.bracketleftbt = 384;
          a.bracelefttp = 494;
          a.braceleftmid = 494;
          a.braceleftbt = 494;
          a.braceex = 494;
          a.angleright = 329;
          a.integral = 274;
          a.integraltp = 686;
          a.integralex = 686;
          a.integralbt = 686;
          a.parenrighttp = 384;
          a.parenrightex = 384;
          a.parenrightbt = 384;
          a.bracketrighttp = 384;
          a.bracketrightex = 384;
          a.bracketrightbt = 384;
          a.bracerighttp = 494;
          a.bracerightmid = 494;
          a.bracerightbt = 494;
          a.apple = 790;
        });
        k['Times-Roman'] = (0, a.getLookupTableFactory)(function(a) {
          a.space = 250;
          a.exclam = 333;
          a.quotedbl = 408;
          a.numbersign = 500;
          a.dollar = 500;
          a.percent = 833;
          a.ampersand = 778;
          a.quoteright = 333;
          a.parenleft = 333;
          a.parenright = 333;
          a.asterisk = 500;
          a.plus = 564;
          a.comma = 250;
          a.hyphen = 333;
          a.period = 250;
          a.slash = 278;
          a.zero = 500;
          a.one = 500;
          a.two = 500;
          a.three = 500;
          a.four = 500;
          a.five = 500;
          a.six = 500;
          a.seven = 500;
          a.eight = 500;
          a.nine = 500;
          a.colon = 278;
          a.semicolon = 278;
          a.less = 564;
          a.equal = 564;
          a.greater = 564;
          a.question = 444;
          a.at = 921;
          a.A = 722;
          a.B = 667;
          a.C = 667;
          a.D = 722;
          a.E = 611;
          a.F = 556;
          a.G = 722;
          a.H = 722;
          a.I = 333;
          a.J = 389;
          a.K = 722;
          a.L = 611;
          a.M = 889;
          a.N = 722;
          a.O = 722;
          a.P = 556;
          a.Q = 722;
          a.R = 667;
          a.S = 556;
          a.T = 611;
          a.U = 722;
          a.V = 722;
          a.W = 944;
          a.X = 722;
          a.Y = 722;
          a.Z = 611;
          a.bracketleft = 333;
          a.backslash = 278;
          a.bracketright = 333;
          a.asciicircum = 469;
          a.underscore = 500;
          a.quoteleft = 333;
          a.a = 444;
          a.b = 500;
          a.c = 444;
          a.d = 500;
          a.e = 444;
          a.f = 333;
          a.g = 500;
          a.h = 500;
          a.i = 278;
          a.j = 278;
          a.k = 500;
          a.l = 278;
          a.m = 778;
          a.n = 500;
          a.o = 500;
          a.p = 500;
          a.q = 500;
          a.r = 333;
          a.s = 389;
          a.t = 278;
          a.u = 500;
          a.v = 500;
          a.w = 722;
          a.x = 500;
          a.y = 500;
          a.z = 444;
          a.braceleft = 480;
          a.bar = 200;
          a.braceright = 480;
          a.asciitilde = 541;
          a.exclamdown = 333;
          a.cent = 500;
          a.sterling = 500;
          a.fraction = 167;
          a.yen = 500;
          a.florin = 500;
          a.section = 500;
          a.currency = 500;
          a.quotesingle = 180;
          a.quotedblleft = 444;
          a.guillemotleft = 500;
          a.guilsinglleft = 333;
          a.guilsinglright = 333;
          a.fi = 556;
          a.fl = 556;
          a.endash = 500;
          a.dagger = 500;
          a.daggerdbl = 500;
          a.periodcentered = 250;
          a.paragraph = 453;
          a.bullet = 350;
          a.quotesinglbase = 333;
          a.quotedblbase = 444;
          a.quotedblright = 444;
          a.guillemotright = 500;
          a.ellipsis = 1e3;
          a.perthousand = 1e3;
          a.questiondown = 444;
          a.grave = 333;
          a.acute = 333;
          a.circumflex = 333;
          a.tilde = 333;
          a.macron = 333;
          a.breve = 333;
          a.dotaccent = 333;
          a.dieresis = 333;
          a.ring = 333;
          a.cedilla = 333;
          a.hungarumlaut = 333;
          a.ogonek = 333;
          a.caron = 333;
          a.emdash = 1e3;
          a.AE = 889;
          a.ordfeminine = 276;
          a.Lslash = 611;
          a.Oslash = 722;
          a.OE = 889;
          a.ordmasculine = 310;
          a.ae = 667;
          a.dotlessi = 278;
          a.lslash = 278;
          a.oslash = 500;
          a.oe = 722;
          a.germandbls = 500;
          a.Idieresis = 333;
          a.eacute = 444;
          a.abreve = 444;
          a.uhungarumlaut = 500;
          a.ecaron = 444;
          a.Ydieresis = 722;
          a.divide = 564;
          a.Yacute = 722;
          a.Acircumflex = 722;
          a.aacute = 444;
          a.Ucircumflex = 722;
          a.yacute = 500;
          a.scommaaccent = 389;
          a.ecircumflex = 444;
          a.Uring = 722;
          a.Udieresis = 722;
          a.aogonek = 444;
          a.Uacute = 722;
          a.uogonek = 500;
          a.Edieresis = 611;
          a.Dcroat = 722;
          a.commaaccent = 250;
          a.copyright = 760;
          a.Emacron = 611;
          a.ccaron = 444;
          a.aring = 444;
          a.Ncommaaccent = 722;
          a.lacute = 278;
          a.agrave = 444;
          a.Tcommaaccent = 611;
          a.Cacute = 667;
          a.atilde = 444;
          a.Edotaccent = 611;
          a.scaron = 389;
          a.scedilla = 389;
          a.iacute = 278;
          a.lozenge = 471;
          a.Rcaron = 667;
          a.Gcommaaccent = 722;
          a.ucircumflex = 500;
          a.acircumflex = 444;
          a.Amacron = 722;
          a.rcaron = 333;
          a.ccedilla = 444;
          a.Zdotaccent = 611;
          a.Thorn = 556;
          a.Omacron = 722;
          a.Racute = 667;
          a.Sacute = 556;
          a.dcaron = 588;
          a.Umacron = 722;
          a.uring = 500;
          a.threesuperior = 300;
          a.Ograve = 722;
          a.Agrave = 722;
          a.Abreve = 722;
          a.multiply = 564;
          a.uacute = 500;
          a.Tcaron = 611;
          a.partialdiff = 476;
          a.ydieresis = 500;
          a.Nacute = 722;
          a.icircumflex = 278;
          a.Ecircumflex = 611;
          a.adieresis = 444;
          a.edieresis = 444;
          a.cacute = 444;
          a.nacute = 500;
          a.umacron = 500;
          a.Ncaron = 722;
          a.Iacute = 333;
          a.plusminus = 564;
          a.brokenbar = 200;
          a.registered = 760;
          a.Gbreve = 722;
          a.Idotaccent = 333;
          a.summation = 600;
          a.Egrave = 611;
          a.racute = 333;
          a.omacron = 500;
          a.Zacute = 611;
          a.Zcaron = 611;
          a.greaterequal = 549;
          a.Eth = 722;
          a.Ccedilla = 667;
          a.lcommaaccent = 278;
          a.tcaron = 326;
          a.eogonek = 444;
          a.Uogonek = 722;
          a.Aacute = 722;
          a.Adieresis = 722;
          a.egrave = 444;
          a.zacute = 444;
          a.iogonek = 278;
          a.Oacute = 722;
          a.oacute = 500;
          a.amacron = 444;
          a.sacute = 389;
          a.idieresis = 278;
          a.Ocircumflex = 722;
          a.Ugrave = 722;
          a.Delta = 612;
          a.thorn = 500;
          a.twosuperior = 300;
          a.Odieresis = 722;
          a.mu = 500;
          a.igrave = 278;
          a.ohungarumlaut = 500;
          a.Eogonek = 611;
          a.dcroat = 500;
          a.threequarters = 750;
          a.Scedilla = 556;
          a.lcaron = 344;
          a.Kcommaaccent = 722;
          a.Lacute = 611;
          a.trademark = 980;
          a.edotaccent = 444;
          a.Igrave = 333;
          a.Imacron = 333;
          a.Lcaron = 611;
          a.onehalf = 750;
          a.lessequal = 549;
          a.ocircumflex = 500;
          a.ntilde = 500;
          a.Uhungarumlaut = 722;
          a.Eacute = 611;
          a.emacron = 444;
          a.gbreve = 500;
          a.onequarter = 750;
          a.Scaron = 556;
          a.Scommaaccent = 556;
          a.Ohungarumlaut = 722;
          a.degree = 400;
          a.ograve = 500;
          a.Ccaron = 667;
          a.ugrave = 500;
          a.radical = 453;
          a.Dcaron = 722;
          a.rcommaaccent = 333;
          a.Ntilde = 722;
          a.otilde = 500;
          a.Rcommaaccent = 667;
          a.Lcommaaccent = 611;
          a.Atilde = 722;
          a.Aogonek = 722;
          a.Aring = 722;
          a.Otilde = 722;
          a.zdotaccent = 444;
          a.Ecaron = 611;
          a.Iogonek = 333;
          a.kcommaaccent = 500;
          a.minus = 564;
          a.Icircumflex = 333;
          a.ncaron = 500;
          a.tcommaaccent = 278;
          a.logicalnot = 564;
          a.odieresis = 500;
          a.udieresis = 500;
          a.notequal = 549;
          a.gcommaaccent = 500;
          a.eth = 500;
          a.zcaron = 444;
          a.ncommaaccent = 500;
          a.onesuperior = 300;
          a.imacron = 278;
          a.Euro = 500;
        });
        k['Times-Bold'] = (0, a.getLookupTableFactory)(function(a) {
          a.space = 250;
          a.exclam = 333;
          a.quotedbl = 555;
          a.numbersign = 500;
          a.dollar = 500;
          a.percent = 1e3;
          a.ampersand = 833;
          a.quoteright = 333;
          a.parenleft = 333;
          a.parenright = 333;
          a.asterisk = 500;
          a.plus = 570;
          a.comma = 250;
          a.hyphen = 333;
          a.period = 250;
          a.slash = 278;
          a.zero = 500;
          a.one = 500;
          a.two = 500;
          a.three = 500;
          a.four = 500;
          a.five = 500;
          a.six = 500;
          a.seven = 500;
          a.eight = 500;
          a.nine = 500;
          a.colon = 333;
          a.semicolon = 333;
          a.less = 570;
          a.equal = 570;
          a.greater = 570;
          a.question = 500;
          a.at = 930;
          a.A = 722;
          a.B = 667;
          a.C = 722;
          a.D = 722;
          a.E = 667;
          a.F = 611;
          a.G = 778;
          a.H = 778;
          a.I = 389;
          a.J = 500;
          a.K = 778;
          a.L = 667;
          a.M = 944;
          a.N = 722;
          a.O = 778;
          a.P = 611;
          a.Q = 778;
          a.R = 722;
          a.S = 556;
          a.T = 667;
          a.U = 722;
          a.V = 722;
          a.W = 1e3;
          a.X = 722;
          a.Y = 722;
          a.Z = 667;
          a.bracketleft = 333;
          a.backslash = 278;
          a.bracketright = 333;
          a.asciicircum = 581;
          a.underscore = 500;
          a.quoteleft = 333;
          a.a = 500;
          a.b = 556;
          a.c = 444;
          a.d = 556;
          a.e = 444;
          a.f = 333;
          a.g = 500;
          a.h = 556;
          a.i = 278;
          a.j = 333;
          a.k = 556;
          a.l = 278;
          a.m = 833;
          a.n = 556;
          a.o = 500;
          a.p = 556;
          a.q = 556;
          a.r = 444;
          a.s = 389;
          a.t = 333;
          a.u = 556;
          a.v = 500;
          a.w = 722;
          a.x = 500;
          a.y = 500;
          a.z = 444;
          a.braceleft = 394;
          a.bar = 220;
          a.braceright = 394;
          a.asciitilde = 520;
          a.exclamdown = 333;
          a.cent = 500;
          a.sterling = 500;
          a.fraction = 167;
          a.yen = 500;
          a.florin = 500;
          a.section = 500;
          a.currency = 500;
          a.quotesingle = 278;
          a.quotedblleft = 500;
          a.guillemotleft = 500;
          a.guilsinglleft = 333;
          a.guilsinglright = 333;
          a.fi = 556;
          a.fl = 556;
          a.endash = 500;
          a.dagger = 500;
          a.daggerdbl = 500;
          a.periodcentered = 250;
          a.paragraph = 540;
          a.bullet = 350;
          a.quotesinglbase = 333;
          a.quotedblbase = 500;
          a.quotedblright = 500;
          a.guillemotright = 500;
          a.ellipsis = 1e3;
          a.perthousand = 1e3;
          a.questiondown = 500;
          a.grave = 333;
          a.acute = 333;
          a.circumflex = 333;
          a.tilde = 333;
          a.macron = 333;
          a.breve = 333;
          a.dotaccent = 333;
          a.dieresis = 333;
          a.ring = 333;
          a.cedilla = 333;
          a.hungarumlaut = 333;
          a.ogonek = 333;
          a.caron = 333;
          a.emdash = 1e3;
          a.AE = 1e3;
          a.ordfeminine = 300;
          a.Lslash = 667;
          a.Oslash = 778;
          a.OE = 1e3;
          a.ordmasculine = 330;
          a.ae = 722;
          a.dotlessi = 278;
          a.lslash = 278;
          a.oslash = 500;
          a.oe = 722;
          a.germandbls = 556;
          a.Idieresis = 389;
          a.eacute = 444;
          a.abreve = 500;
          a.uhungarumlaut = 556;
          a.ecaron = 444;
          a.Ydieresis = 722;
          a.divide = 570;
          a.Yacute = 722;
          a.Acircumflex = 722;
          a.aacute = 500;
          a.Ucircumflex = 722;
          a.yacute = 500;
          a.scommaaccent = 389;
          a.ecircumflex = 444;
          a.Uring = 722;
          a.Udieresis = 722;
          a.aogonek = 500;
          a.Uacute = 722;
          a.uogonek = 556;
          a.Edieresis = 667;
          a.Dcroat = 722;
          a.commaaccent = 250;
          a.copyright = 747;
          a.Emacron = 667;
          a.ccaron = 444;
          a.aring = 500;
          a.Ncommaaccent = 722;
          a.lacute = 278;
          a.agrave = 500;
          a.Tcommaaccent = 667;
          a.Cacute = 722;
          a.atilde = 500;
          a.Edotaccent = 667;
          a.scaron = 389;
          a.scedilla = 389;
          a.iacute = 278;
          a.lozenge = 494;
          a.Rcaron = 722;
          a.Gcommaaccent = 778;
          a.ucircumflex = 556;
          a.acircumflex = 500;
          a.Amacron = 722;
          a.rcaron = 444;
          a.ccedilla = 444;
          a.Zdotaccent = 667;
          a.Thorn = 611;
          a.Omacron = 778;
          a.Racute = 722;
          a.Sacute = 556;
          a.dcaron = 672;
          a.Umacron = 722;
          a.uring = 556;
          a.threesuperior = 300;
          a.Ograve = 778;
          a.Agrave = 722;
          a.Abreve = 722;
          a.multiply = 570;
          a.uacute = 556;
          a.Tcaron = 667;
          a.partialdiff = 494;
          a.ydieresis = 500;
          a.Nacute = 722;
          a.icircumflex = 278;
          a.Ecircumflex = 667;
          a.adieresis = 500;
          a.edieresis = 444;
          a.cacute = 444;
          a.nacute = 556;
          a.umacron = 556;
          a.Ncaron = 722;
          a.Iacute = 389;
          a.plusminus = 570;
          a.brokenbar = 220;
          a.registered = 747;
          a.Gbreve = 778;
          a.Idotaccent = 389;
          a.summation = 600;
          a.Egrave = 667;
          a.racute = 444;
          a.omacron = 500;
          a.Zacute = 667;
          a.Zcaron = 667;
          a.greaterequal = 549;
          a.Eth = 722;
          a.Ccedilla = 722;
          a.lcommaaccent = 278;
          a.tcaron = 416;
          a.eogonek = 444;
          a.Uogonek = 722;
          a.Aacute = 722;
          a.Adieresis = 722;
          a.egrave = 444;
          a.zacute = 444;
          a.iogonek = 278;
          a.Oacute = 778;
          a.oacute = 500;
          a.amacron = 500;
          a.sacute = 389;
          a.idieresis = 278;
          a.Ocircumflex = 778;
          a.Ugrave = 722;
          a.Delta = 612;
          a.thorn = 556;
          a.twosuperior = 300;
          a.Odieresis = 778;
          a.mu = 556;
          a.igrave = 278;
          a.ohungarumlaut = 500;
          a.Eogonek = 667;
          a.dcroat = 556;
          a.threequarters = 750;
          a.Scedilla = 556;
          a.lcaron = 394;
          a.Kcommaaccent = 778;
          a.Lacute = 667;
          a.trademark = 1e3;
          a.edotaccent = 444;
          a.Igrave = 389;
          a.Imacron = 389;
          a.Lcaron = 667;
          a.onehalf = 750;
          a.lessequal = 549;
          a.ocircumflex = 500;
          a.ntilde = 556;
          a.Uhungarumlaut = 722;
          a.Eacute = 667;
          a.emacron = 444;
          a.gbreve = 500;
          a.onequarter = 750;
          a.Scaron = 556;
          a.Scommaaccent = 556;
          a.Ohungarumlaut = 778;
          a.degree = 400;
          a.ograve = 500;
          a.Ccaron = 722;
          a.ugrave = 556;
          a.radical = 549;
          a.Dcaron = 722;
          a.rcommaaccent = 444;
          a.Ntilde = 722;
          a.otilde = 500;
          a.Rcommaaccent = 722;
          a.Lcommaaccent = 667;
          a.Atilde = 722;
          a.Aogonek = 722;
          a.Aring = 722;
          a.Otilde = 778;
          a.zdotaccent = 444;
          a.Ecaron = 667;
          a.Iogonek = 389;
          a.kcommaaccent = 556;
          a.minus = 570;
          a.Icircumflex = 389;
          a.ncaron = 556;
          a.tcommaaccent = 333;
          a.logicalnot = 570;
          a.odieresis = 500;
          a.udieresis = 556;
          a.notequal = 549;
          a.gcommaaccent = 500;
          a.eth = 500;
          a.zcaron = 444;
          a.ncommaaccent = 556;
          a.onesuperior = 300;
          a.imacron = 278;
          a.Euro = 500;
        });
        k['Times-BoldItalic'] = (0, a.getLookupTableFactory)(function(a) {
          a.space = 250;
          a.exclam = 389;
          a.quotedbl = 555;
          a.numbersign = 500;
          a.dollar = 500;
          a.percent = 833;
          a.ampersand = 778;
          a.quoteright = 333;
          a.parenleft = 333;
          a.parenright = 333;
          a.asterisk = 500;
          a.plus = 570;
          a.comma = 250;
          a.hyphen = 333;
          a.period = 250;
          a.slash = 278;
          a.zero = 500;
          a.one = 500;
          a.two = 500;
          a.three = 500;
          a.four = 500;
          a.five = 500;
          a.six = 500;
          a.seven = 500;
          a.eight = 500;
          a.nine = 500;
          a.colon = 333;
          a.semicolon = 333;
          a.less = 570;
          a.equal = 570;
          a.greater = 570;
          a.question = 500;
          a.at = 832;
          a.A = 667;
          a.B = 667;
          a.C = 667;
          a.D = 722;
          a.E = 667;
          a.F = 667;
          a.G = 722;
          a.H = 778;
          a.I = 389;
          a.J = 500;
          a.K = 667;
          a.L = 611;
          a.M = 889;
          a.N = 722;
          a.O = 722;
          a.P = 611;
          a.Q = 722;
          a.R = 667;
          a.S = 556;
          a.T = 611;
          a.U = 722;
          a.V = 667;
          a.W = 889;
          a.X = 667;
          a.Y = 611;
          a.Z = 611;
          a.bracketleft = 333;
          a.backslash = 278;
          a.bracketright = 333;
          a.asciicircum = 570;
          a.underscore = 500;
          a.quoteleft = 333;
          a.a = 500;
          a.b = 500;
          a.c = 444;
          a.d = 500;
          a.e = 444;
          a.f = 333;
          a.g = 500;
          a.h = 556;
          a.i = 278;
          a.j = 278;
          a.k = 500;
          a.l = 278;
          a.m = 778;
          a.n = 556;
          a.o = 500;
          a.p = 500;
          a.q = 500;
          a.r = 389;
          a.s = 389;
          a.t = 278;
          a.u = 556;
          a.v = 444;
          a.w = 667;
          a.x = 500;
          a.y = 444;
          a.z = 389;
          a.braceleft = 348;
          a.bar = 220;
          a.braceright = 348;
          a.asciitilde = 570;
          a.exclamdown = 389;
          a.cent = 500;
          a.sterling = 500;
          a.fraction = 167;
          a.yen = 500;
          a.florin = 500;
          a.section = 500;
          a.currency = 500;
          a.quotesingle = 278;
          a.quotedblleft = 500;
          a.guillemotleft = 500;
          a.guilsinglleft = 333;
          a.guilsinglright = 333;
          a.fi = 556;
          a.fl = 556;
          a.endash = 500;
          a.dagger = 500;
          a.daggerdbl = 500;
          a.periodcentered = 250;
          a.paragraph = 500;
          a.bullet = 350;
          a.quotesinglbase = 333;
          a.quotedblbase = 500;
          a.quotedblright = 500;
          a.guillemotright = 500;
          a.ellipsis = 1e3;
          a.perthousand = 1e3;
          a.questiondown = 500;
          a.grave = 333;
          a.acute = 333;
          a.circumflex = 333;
          a.tilde = 333;
          a.macron = 333;
          a.breve = 333;
          a.dotaccent = 333;
          a.dieresis = 333;
          a.ring = 333;
          a.cedilla = 333;
          a.hungarumlaut = 333;
          a.ogonek = 333;
          a.caron = 333;
          a.emdash = 1e3;
          a.AE = 944;
          a.ordfeminine = 266;
          a.Lslash = 611;
          a.Oslash = 722;
          a.OE = 944;
          a.ordmasculine = 300;
          a.ae = 722;
          a.dotlessi = 278;
          a.lslash = 278;
          a.oslash = 500;
          a.oe = 722;
          a.germandbls = 500;
          a.Idieresis = 389;
          a.eacute = 444;
          a.abreve = 500;
          a.uhungarumlaut = 556;
          a.ecaron = 444;
          a.Ydieresis = 611;
          a.divide = 570;
          a.Yacute = 611;
          a.Acircumflex = 667;
          a.aacute = 500;
          a.Ucircumflex = 722;
          a.yacute = 444;
          a.scommaaccent = 389;
          a.ecircumflex = 444;
          a.Uring = 722;
          a.Udieresis = 722;
          a.aogonek = 500;
          a.Uacute = 722;
          a.uogonek = 556;
          a.Edieresis = 667;
          a.Dcroat = 722;
          a.commaaccent = 250;
          a.copyright = 747;
          a.Emacron = 667;
          a.ccaron = 444;
          a.aring = 500;
          a.Ncommaaccent = 722;
          a.lacute = 278;
          a.agrave = 500;
          a.Tcommaaccent = 611;
          a.Cacute = 667;
          a.atilde = 500;
          a.Edotaccent = 667;
          a.scaron = 389;
          a.scedilla = 389;
          a.iacute = 278;
          a.lozenge = 494;
          a.Rcaron = 667;
          a.Gcommaaccent = 722;
          a.ucircumflex = 556;
          a.acircumflex = 500;
          a.Amacron = 667;
          a.rcaron = 389;
          a.ccedilla = 444;
          a.Zdotaccent = 611;
          a.Thorn = 611;
          a.Omacron = 722;
          a.Racute = 667;
          a.Sacute = 556;
          a.dcaron = 608;
          a.Umacron = 722;
          a.uring = 556;
          a.threesuperior = 300;
          a.Ograve = 722;
          a.Agrave = 667;
          a.Abreve = 667;
          a.multiply = 570;
          a.uacute = 556;
          a.Tcaron = 611;
          a.partialdiff = 494;
          a.ydieresis = 444;
          a.Nacute = 722;
          a.icircumflex = 278;
          a.Ecircumflex = 667;
          a.adieresis = 500;
          a.edieresis = 444;
          a.cacute = 444;
          a.nacute = 556;
          a.umacron = 556;
          a.Ncaron = 722;
          a.Iacute = 389;
          a.plusminus = 570;
          a.brokenbar = 220;
          a.registered = 747;
          a.Gbreve = 722;
          a.Idotaccent = 389;
          a.summation = 600;
          a.Egrave = 667;
          a.racute = 389;
          a.omacron = 500;
          a.Zacute = 611;
          a.Zcaron = 611;
          a.greaterequal = 549;
          a.Eth = 722;
          a.Ccedilla = 667;
          a.lcommaaccent = 278;
          a.tcaron = 366;
          a.eogonek = 444;
          a.Uogonek = 722;
          a.Aacute = 667;
          a.Adieresis = 667;
          a.egrave = 444;
          a.zacute = 389;
          a.iogonek = 278;
          a.Oacute = 722;
          a.oacute = 500;
          a.amacron = 500;
          a.sacute = 389;
          a.idieresis = 278;
          a.Ocircumflex = 722;
          a.Ugrave = 722;
          a.Delta = 612;
          a.thorn = 500;
          a.twosuperior = 300;
          a.Odieresis = 722;
          a.mu = 576;
          a.igrave = 278;
          a.ohungarumlaut = 500;
          a.Eogonek = 667;
          a.dcroat = 500;
          a.threequarters = 750;
          a.Scedilla = 556;
          a.lcaron = 382;
          a.Kcommaaccent = 667;
          a.Lacute = 611;
          a.trademark = 1e3;
          a.edotaccent = 444;
          a.Igrave = 389;
          a.Imacron = 389;
          a.Lcaron = 611;
          a.onehalf = 750;
          a.lessequal = 549;
          a.ocircumflex = 500;
          a.ntilde = 556;
          a.Uhungarumlaut = 722;
          a.Eacute = 667;
          a.emacron = 444;
          a.gbreve = 500;
          a.onequarter = 750;
          a.Scaron = 556;
          a.Scommaaccent = 556;
          a.Ohungarumlaut = 722;
          a.degree = 400;
          a.ograve = 500;
          a.Ccaron = 667;
          a.ugrave = 556;
          a.radical = 549;
          a.Dcaron = 722;
          a.rcommaaccent = 389;
          a.Ntilde = 722;
          a.otilde = 500;
          a.Rcommaaccent = 667;
          a.Lcommaaccent = 611;
          a.Atilde = 667;
          a.Aogonek = 667;
          a.Aring = 667;
          a.Otilde = 722;
          a.zdotaccent = 389;
          a.Ecaron = 667;
          a.Iogonek = 389;
          a.kcommaaccent = 500;
          a.minus = 606;
          a.Icircumflex = 389;
          a.ncaron = 556;
          a.tcommaaccent = 278;
          a.logicalnot = 606;
          a.odieresis = 500;
          a.udieresis = 556;
          a.notequal = 549;
          a.gcommaaccent = 500;
          a.eth = 500;
          a.zcaron = 389;
          a.ncommaaccent = 556;
          a.onesuperior = 300;
          a.imacron = 278;
          a.Euro = 500;
        });
        k['Times-Italic'] = (0, a.getLookupTableFactory)(function(a) {
          a.space = 250;
          a.exclam = 333;
          a.quotedbl = 420;
          a.numbersign = 500;
          a.dollar = 500;
          a.percent = 833;
          a.ampersand = 778;
          a.quoteright = 333;
          a.parenleft = 333;
          a.parenright = 333;
          a.asterisk = 500;
          a.plus = 675;
          a.comma = 250;
          a.hyphen = 333;
          a.period = 250;
          a.slash = 278;
          a.zero = 500;
          a.one = 500;
          a.two = 500;
          a.three = 500;
          a.four = 500;
          a.five = 500;
          a.six = 500;
          a.seven = 500;
          a.eight = 500;
          a.nine = 500;
          a.colon = 333;
          a.semicolon = 333;
          a.less = 675;
          a.equal = 675;
          a.greater = 675;
          a.question = 500;
          a.at = 920;
          a.A = 611;
          a.B = 611;
          a.C = 667;
          a.D = 722;
          a.E = 611;
          a.F = 611;
          a.G = 722;
          a.H = 722;
          a.I = 333;
          a.J = 444;
          a.K = 667;
          a.L = 556;
          a.M = 833;
          a.N = 667;
          a.O = 722;
          a.P = 611;
          a.Q = 722;
          a.R = 611;
          a.S = 500;
          a.T = 556;
          a.U = 722;
          a.V = 611;
          a.W = 833;
          a.X = 611;
          a.Y = 556;
          a.Z = 556;
          a.bracketleft = 389;
          a.backslash = 278;
          a.bracketright = 389;
          a.asciicircum = 422;
          a.underscore = 500;
          a.quoteleft = 333;
          a.a = 500;
          a.b = 500;
          a.c = 444;
          a.d = 500;
          a.e = 444;
          a.f = 278;
          a.g = 500;
          a.h = 500;
          a.i = 278;
          a.j = 278;
          a.k = 444;
          a.l = 278;
          a.m = 722;
          a.n = 500;
          a.o = 500;
          a.p = 500;
          a.q = 500;
          a.r = 389;
          a.s = 389;
          a.t = 278;
          a.u = 500;
          a.v = 444;
          a.w = 667;
          a.x = 444;
          a.y = 444;
          a.z = 389;
          a.braceleft = 400;
          a.bar = 275;
          a.braceright = 400;
          a.asciitilde = 541;
          a.exclamdown = 389;
          a.cent = 500;
          a.sterling = 500;
          a.fraction = 167;
          a.yen = 500;
          a.florin = 500;
          a.section = 500;
          a.currency = 500;
          a.quotesingle = 214;
          a.quotedblleft = 556;
          a.guillemotleft = 500;
          a.guilsinglleft = 333;
          a.guilsinglright = 333;
          a.fi = 500;
          a.fl = 500;
          a.endash = 500;
          a.dagger = 500;
          a.daggerdbl = 500;
          a.periodcentered = 250;
          a.paragraph = 523;
          a.bullet = 350;
          a.quotesinglbase = 333;
          a.quotedblbase = 556;
          a.quotedblright = 556;
          a.guillemotright = 500;
          a.ellipsis = 889;
          a.perthousand = 1e3;
          a.questiondown = 500;
          a.grave = 333;
          a.acute = 333;
          a.circumflex = 333;
          a.tilde = 333;
          a.macron = 333;
          a.breve = 333;
          a.dotaccent = 333;
          a.dieresis = 333;
          a.ring = 333;
          a.cedilla = 333;
          a.hungarumlaut = 333;
          a.ogonek = 333;
          a.caron = 333;
          a.emdash = 889;
          a.AE = 889;
          a.ordfeminine = 276;
          a.Lslash = 556;
          a.Oslash = 722;
          a.OE = 944;
          a.ordmasculine = 310;
          a.ae = 667;
          a.dotlessi = 278;
          a.lslash = 278;
          a.oslash = 500;
          a.oe = 667;
          a.germandbls = 500;
          a.Idieresis = 333;
          a.eacute = 444;
          a.abreve = 500;
          a.uhungarumlaut = 500;
          a.ecaron = 444;
          a.Ydieresis = 556;
          a.divide = 675;
          a.Yacute = 556;
          a.Acircumflex = 611;
          a.aacute = 500;
          a.Ucircumflex = 722;
          a.yacute = 444;
          a.scommaaccent = 389;
          a.ecircumflex = 444;
          a.Uring = 722;
          a.Udieresis = 722;
          a.aogonek = 500;
          a.Uacute = 722;
          a.uogonek = 500;
          a.Edieresis = 611;
          a.Dcroat = 722;
          a.commaaccent = 250;
          a.copyright = 760;
          a.Emacron = 611;
          a.ccaron = 444;
          a.aring = 500;
          a.Ncommaaccent = 667;
          a.lacute = 278;
          a.agrave = 500;
          a.Tcommaaccent = 556;
          a.Cacute = 667;
          a.atilde = 500;
          a.Edotaccent = 611;
          a.scaron = 389;
          a.scedilla = 389;
          a.iacute = 278;
          a.lozenge = 471;
          a.Rcaron = 611;
          a.Gcommaaccent = 722;
          a.ucircumflex = 500;
          a.acircumflex = 500;
          a.Amacron = 611;
          a.rcaron = 389;
          a.ccedilla = 444;
          a.Zdotaccent = 556;
          a.Thorn = 611;
          a.Omacron = 722;
          a.Racute = 611;
          a.Sacute = 500;
          a.dcaron = 544;
          a.Umacron = 722;
          a.uring = 500;
          a.threesuperior = 300;
          a.Ograve = 722;
          a.Agrave = 611;
          a.Abreve = 611;
          a.multiply = 675;
          a.uacute = 500;
          a.Tcaron = 556;
          a.partialdiff = 476;
          a.ydieresis = 444;
          a.Nacute = 667;
          a.icircumflex = 278;
          a.Ecircumflex = 611;
          a.adieresis = 500;
          a.edieresis = 444;
          a.cacute = 444;
          a.nacute = 500;
          a.umacron = 500;
          a.Ncaron = 667;
          a.Iacute = 333;
          a.plusminus = 675;
          a.brokenbar = 275;
          a.registered = 760;
          a.Gbreve = 722;
          a.Idotaccent = 333;
          a.summation = 600;
          a.Egrave = 611;
          a.racute = 389;
          a.omacron = 500;
          a.Zacute = 556;
          a.Zcaron = 556;
          a.greaterequal = 549;
          a.Eth = 722;
          a.Ccedilla = 667;
          a.lcommaaccent = 278;
          a.tcaron = 300;
          a.eogonek = 444;
          a.Uogonek = 722;
          a.Aacute = 611;
          a.Adieresis = 611;
          a.egrave = 444;
          a.zacute = 389;
          a.iogonek = 278;
          a.Oacute = 722;
          a.oacute = 500;
          a.amacron = 500;
          a.sacute = 389;
          a.idieresis = 278;
          a.Ocircumflex = 722;
          a.Ugrave = 722;
          a.Delta = 612;
          a.thorn = 500;
          a.twosuperior = 300;
          a.Odieresis = 722;
          a.mu = 500;
          a.igrave = 278;
          a.ohungarumlaut = 500;
          a.Eogonek = 611;
          a.dcroat = 500;
          a.threequarters = 750;
          a.Scedilla = 500;
          a.lcaron = 300;
          a.Kcommaaccent = 667;
          a.Lacute = 556;
          a.trademark = 980;
          a.edotaccent = 444;
          a.Igrave = 333;
          a.Imacron = 333;
          a.Lcaron = 611;
          a.onehalf = 750;
          a.lessequal = 549;
          a.ocircumflex = 500;
          a.ntilde = 500;
          a.Uhungarumlaut = 722;
          a.Eacute = 611;
          a.emacron = 444;
          a.gbreve = 500;
          a.onequarter = 750;
          a.Scaron = 500;
          a.Scommaaccent = 500;
          a.Ohungarumlaut = 722;
          a.degree = 400;
          a.ograve = 500;
          a.Ccaron = 667;
          a.ugrave = 500;
          a.radical = 453;
          a.Dcaron = 722;
          a.rcommaaccent = 389;
          a.Ntilde = 667;
          a.otilde = 500;
          a.Rcommaaccent = 611;
          a.Lcommaaccent = 556;
          a.Atilde = 611;
          a.Aogonek = 611;
          a.Aring = 611;
          a.Otilde = 722;
          a.zdotaccent = 389;
          a.Ecaron = 611;
          a.Iogonek = 333;
          a.kcommaaccent = 444;
          a.minus = 675;
          a.Icircumflex = 333;
          a.ncaron = 500;
          a.tcommaaccent = 278;
          a.logicalnot = 675;
          a.odieresis = 500;
          a.udieresis = 500;
          a.notequal = 549;
          a.gcommaaccent = 500;
          a.eth = 500;
          a.zcaron = 389;
          a.ncommaaccent = 500;
          a.onesuperior = 300;
          a.imacron = 278;
          a.Euro = 500;
        });
        k.ZapfDingbats = (0, a.getLookupTableFactory)(function(a) {
          a.space = 278;
          a.a1 = 974;
          a.a2 = 961;
          a.a202 = 974;
          a.a3 = 980;
          a.a4 = 719;
          a.a5 = 789;
          a.a119 = 790;
          a.a118 = 791;
          a.a117 = 690;
          a.a11 = 960;
          a.a12 = 939;
          a.a13 = 549;
          a.a14 = 855;
          a.a15 = 911;
          a.a16 = 933;
          a.a105 = 911;
          a.a17 = 945;
          a.a18 = 974;
          a.a19 = 755;
          a.a20 = 846;
          a.a21 = 762;
          a.a22 = 761;
          a.a23 = 571;
          a.a24 = 677;
          a.a25 = 763;
          a.a26 = 760;
          a.a27 = 759;
          a.a28 = 754;
          a.a6 = 494;
          a.a7 = 552;
          a.a8 = 537;
          a.a9 = 577;
          a.a10 = 692;
          a.a29 = 786;
          a.a30 = 788;
          a.a31 = 788;
          a.a32 = 790;
          a.a33 = 793;
          a.a34 = 794;
          a.a35 = 816;
          a.a36 = 823;
          a.a37 = 789;
          a.a38 = 841;
          a.a39 = 823;
          a.a40 = 833;
          a.a41 = 816;
          a.a42 = 831;
          a.a43 = 923;
          a.a44 = 744;
          a.a45 = 723;
          a.a46 = 749;
          a.a47 = 790;
          a.a48 = 792;
          a.a49 = 695;
          a.a50 = 776;
          a.a51 = 768;
          a.a52 = 792;
          a.a53 = 759;
          a.a54 = 707;
          a.a55 = 708;
          a.a56 = 682;
          a.a57 = 701;
          a.a58 = 826;
          a.a59 = 815;
          a.a60 = 789;
          a.a61 = 789;
          a.a62 = 707;
          a.a63 = 687;
          a.a64 = 696;
          a.a65 = 689;
          a.a66 = 786;
          a.a67 = 787;
          a.a68 = 713;
          a.a69 = 791;
          a.a70 = 785;
          a.a71 = 791;
          a.a72 = 873;
          a.a73 = 761;
          a.a74 = 762;
          a.a203 = 762;
          a.a75 = 759;
          a.a204 = 759;
          a.a76 = 892;
          a.a77 = 892;
          a.a78 = 788;
          a.a79 = 784;
          a.a81 = 438;
          a.a82 = 138;
          a.a83 = 277;
          a.a84 = 415;
          a.a97 = 392;
          a.a98 = 392;
          a.a99 = 668;
          a.a100 = 668;
          a.a89 = 390;
          a.a90 = 390;
          a.a93 = 317;
          a.a94 = 317;
          a.a91 = 276;
          a.a92 = 276;
          a.a205 = 509;
          a.a85 = 509;
          a.a206 = 410;
          a.a86 = 410;
          a.a87 = 234;
          a.a88 = 234;
          a.a95 = 334;
          a.a96 = 334;
          a.a101 = 732;
          a.a102 = 544;
          a.a103 = 544;
          a.a104 = 910;
          a.a106 = 667;
          a.a107 = 760;
          a.a108 = 760;
          a.a112 = 776;
          a.a111 = 595;
          a.a110 = 694;
          a.a109 = 626;
          a.a120 = 788;
          a.a121 = 788;
          a.a122 = 788;
          a.a123 = 788;
          a.a124 = 788;
          a.a125 = 788;
          a.a126 = 788;
          a.a127 = 788;
          a.a128 = 788;
          a.a129 = 788;
          a.a130 = 788;
          a.a131 = 788;
          a.a132 = 788;
          a.a133 = 788;
          a.a134 = 788;
          a.a135 = 788;
          a.a136 = 788;
          a.a137 = 788;
          a.a138 = 788;
          a.a139 = 788;
          a.a140 = 788;
          a.a141 = 788;
          a.a142 = 788;
          a.a143 = 788;
          a.a144 = 788;
          a.a145 = 788;
          a.a146 = 788;
          a.a147 = 788;
          a.a148 = 788;
          a.a149 = 788;
          a.a150 = 788;
          a.a151 = 788;
          a.a152 = 788;
          a.a153 = 788;
          a.a154 = 788;
          a.a155 = 788;
          a.a156 = 788;
          a.a157 = 788;
          a.a158 = 788;
          a.a159 = 788;
          a.a160 = 894;
          a.a161 = 838;
          a.a163 = 1016;
          a.a164 = 458;
          a.a196 = 748;
          a.a165 = 924;
          a.a192 = 748;
          a.a166 = 918;
          a.a167 = 927;
          a.a168 = 928;
          a.a169 = 928;
          a.a170 = 834;
          a.a171 = 873;
          a.a172 = 828;
          a.a173 = 924;
          a.a162 = 924;
          a.a174 = 917;
          a.a175 = 930;
          a.a176 = 931;
          a.a177 = 463;
          a.a178 = 883;
          a.a179 = 836;
          a.a193 = 836;
          a.a180 = 867;
          a.a199 = 867;
          a.a181 = 696;
          a.a200 = 696;
          a.a182 = 874;
          a.a201 = 874;
          a.a183 = 760;
          a.a184 = 946;
          a.a197 = 771;
          a.a185 = 865;
          a.a194 = 771;
          a.a198 = 888;
          a.a186 = 967;
          a.a195 = 888;
          a.a187 = 831;
          a.a188 = 873;
          a.a189 = 927;
          a.a190 = 970;
          a.a191 = 918;
        });
      });
      m.getMetrics = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      var a =
        'function' === typeof Symbol && 'symbol' === typeof Symbol.iterator
          ? function(a) {
              return typeof a;
            }
          : function(a) {
              return a && 'function' === typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype
                ? 'symbol'
                : typeof a;
            };
      y = (function(k) {
        function b(a) {
          this.h1 = a ? a & 4294967295 : 3285377520;
          this.h2 = a ? a & 4294967295 : 3285377520;
        }
        b.prototype = {
          update: function(b) {
            var d;
            if ('string' === typeof b) {
              var k = new Uint8Array(2 * b.length),
                m = 0;
              for (d = 0; d < b.length; d++) {
                var t = b.charCodeAt(d);
                255 >= t ? (k[m++] = t) : ((k[m++] = t >>> 8), (k[m++] = t & 255));
              }
            } else if ('object' === ('undefined' === typeof b ? 'undefined' : a(b)) && 'byteLength' in b)
              (k = b), (m = k.byteLength);
            else throw Error('Wrong data format in MurmurHash3_64_update. Input must be a string or array.');
            b = m >> 2;
            m -= 4 * b;
            t = new Uint32Array(k.buffer, 0, b);
            var v = this.h1,
              n = this.h2;
            for (d = 0; d < b; d++)
              if (d & 1) {
                var e = t[d];
                e = ((3432918353 * e) & 4294901760) | ((11601 * e) & 65535);
                e = (e << 15) | (e >>> 17);
                e = ((461845907 * e) & 4294901760) | ((13715 * e) & 65535);
                v ^= e;
                v = (v << 13) | (v >>> 19);
                v = 5 * v + 3864292196;
              } else
                (e = t[d]),
                  (e = ((3432918353 * e) & 4294901760) | ((11601 * e) & 65535)),
                  (e = (e << 15) | (e >>> 17)),
                  (e = ((461845907 * e) & 4294901760) | ((13715 * e) & 65535)),
                  (n ^= e),
                  (n = (n << 13) | (n >>> 19)),
                  (n = 5 * n + 3864292196);
            e = 0;
            switch (m) {
              case 3:
                e ^= k[4 * b + 2] << 16;
              case 2:
                e ^= k[4 * b + 1] << 8;
              case 1:
                (e ^= k[4 * b]),
                  (e = ((3432918353 * e) & 4294901760) | ((11601 * e) & 65535)),
                  (e = (e << 15) | (e >>> 17)),
                  (e = ((461845907 * e) & 4294901760) | ((13715 * e) & 65535)),
                  b & 1 ? (v ^= e) : (n ^= e);
            }
            this.h1 = v;
            this.h2 = n;
            return this;
          },
          hexdigest: function() {
            var a = this.h1,
              b = this.h2;
            a ^= b >>> 1;
            a = ((3981806797 * a) & 4294901760) | ((36045 * a) & 65535);
            b = ((4283543511 * b) & 4294901760) | (((2950163797 * ((b << 16) | (a >>> 16))) & 4294901760) >>> 16);
            a ^= b >>> 1;
            a = ((444984403 * a) & 4294901760) | ((60499 * a) & 65535);
            b = ((3301882366 * b) & 4294901760) | (((3120437893 * ((b << 16) | (a >>> 16))) & 4294901760) >>> 16);
            var k = 0;
            a = [a ^ (b >>> 1), b];
            for (b = ''; k < a.length; k++) {
              for (var m = (a[k] >>> 0).toString(16); 8 > m.length; ) m = '0' + m;
              b += m;
            }
            return b;
          },
        };
        return b;
      })();
      m.MurmurHash3_64 = y;
    },
    function(y, m, t) {
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.PDFImage = void 0;
      var a = t(0),
        k = t(3),
        b = t(1),
        v = t(17),
        d = t(61);
      y = (function() {
        function m(a, b) {
          return b && b.canDecode(a) ? b.decode(a) : Promise.resolve(a);
        }
        function t(a, b, d, h, k, m) {
          var c = k * m;
          b = 8 >= b ? new Uint8Array(c) : 16 >= b ? new Uint16Array(c) : new Uint32Array(c);
          var e = d / k;
          h /= m;
          var n = 0,
            g = new Uint16Array(k);
          for (c = 0; c < k; c++) g[c] = Math.floor(c * e);
          for (c = 0; c < m; c++) {
            var p = Math.floor(c * h) * d;
            for (e = 0; e < k; e++) {
              var l = p + g[e];
              b[n++] = a[l];
            }
          }
          return b;
        }
        function y(k, n, e, h, m, t, c) {
          this.image = e;
          h = e.dict;
          if (h.has('Filter')) {
            var p = h.get('Filter').name;
            'JPXDecode' === p
              ? ((p = new d.JpxImage()),
                p.parseImageProperties(e.stream),
                e.stream.reset(),
                (e.bitsPerComponent = p.bitsPerComponent),
                (e.numComps = p.componentsCount))
              : 'JBIG2Decode' === p && ((e.bitsPerComponent = 1), (e.numComps = 1));
          }
          this.width = h.get('Width', 'W');
          this.height = h.get('Height', 'H');
          if (1 > this.width || 1 > this.height)
            throw new a.FormatError('Invalid image width: ' + this.width + ' or ' + ('height: ' + this.height));
          this.interpolate = h.get('Interpolate', 'I') || !1;
          this.imageMask = h.get('ImageMask', 'IM') || !1;
          this.matte = h.get('Matte') || !1;
          p = e.bitsPerComponent;
          if (!p && ((p = h.get('BitsPerComponent', 'BPC')), !p))
            if (this.imageMask) p = 1;
            else throw new a.FormatError('Bits per component missing in image: ' + this.imageMask);
          this.bpc = p;
          if (!this.imageMask) {
            var u = h.get('ColorSpace', 'CS');
            if (!u)
              switch (((0, a.info)('JPX images (which do not require color spaces)'), e.numComps)) {
                case 1:
                  u = b.Name.get('DeviceGray');
                  break;
                case 3:
                  u = b.Name.get('DeviceRGB');
                  break;
                case 4:
                  u = b.Name.get('DeviceCMYK');
                  break;
                default:
                  throw Error('JPX images with ' + this.numComps + ' color components not supported.');
              }
            this.colorSpace = v.ColorSpace.parse(u, k, n);
            this.numComps = this.colorSpace.numComps;
          }
          this.decode = h.getArray('Decode', 'D');
          this.needsDecode = !1;
          if (
            this.decode &&
            ((this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode)) ||
              (c && !v.ColorSpace.isDefaultDecode(this.decode, 1)))
          )
            for (
              this.needsDecode = !0, e = (1 << p) - 1, this.decodeCoefficients = [], this.decodeAddends = [], h = c = 0;
              c < this.decode.length;
              c += 2, ++h
            )
              (p = this.decode[c]),
                (this.decodeCoefficients[h] = this.decode[c + 1] - p),
                (this.decodeAddends[h] = e * p);
          m
            ? (this.smask = new y(k, n, m, !1))
            : t &&
              ((0, b.isStream)(t)
                ? t.dict.get('ImageMask', 'IM')
                  ? (this.mask = new y(k, n, t, !1, null, null, !0))
                  : (0, a.warn)('Ignoring /Mask in image without /ImageMask.')
                : (this.mask = t));
        }
        y.buildImage = function(d, k, e, h, p, t) {
          d = m(h, t);
          var c = h.dict.get('SMask'),
            n = h.dict.get('Mask');
          c
            ? ((h = m(c, t)), (t = Promise.resolve(null)))
            : ((h = Promise.resolve(null)),
              n
                ? (0, b.isStream)(n)
                  ? (t = m(n, t))
                  : Array.isArray(n)
                  ? (t = Promise.resolve(n))
                  : ((0, a.warn)('Unsupported mask format.'), (t = Promise.resolve(null)))
                : (t = Promise.resolve(null)));
          return Promise.all([d, h, t]).then(function(a) {
            return new y(k, e, a[0], p, a[1], a[2]);
          });
        };
        y.createMask = function(a, b, d, h, k) {
          var e = ((b + 7) >> 3) * d,
            c = a.byteLength;
          if (!h || (k && e !== c))
            if (k) for (h = new Uint8Array(e), h.set(a), a = c; a < e; a++) h[a] = 255;
            else (h = new Uint8Array(c)), h.set(a);
          else h = a;
          if (k) for (a = 0; a < c; a++) h[a] ^= 255;
          return { data: h, width: b, height: d };
        };
        y.prototype = {
          get drawWidth() {
            return Math.max(this.width, (this.smask && this.smask.width) || 0, (this.mask && this.mask.width) || 0);
          },
          get drawHeight() {
            return Math.max(this.height, (this.smask && this.smask.height) || 0, (this.mask && this.mask.height) || 0);
          },
          decodeBuffer: function(a) {
            var b = this.bpc,
              d = this.numComps,
              h = this.decodeAddends,
              k = this.decodeCoefficients,
              m = (1 << b) - 1,
              c;
            if (1 === b) for (b = 0, c = a.length; b < c; b++) a[b] = +!a[b];
            else {
              var q = 0;
              b = 0;
              for (c = this.width * this.height; b < c; b++)
                for (var t = 0; t < d; t++) {
                  var g = q,
                    u = a[q];
                  u = h[t] + u * k[t];
                  a[g] = 0 > u ? 0 : u > m ? m : u;
                  q++;
                }
            }
          },
          getComponents: function(a) {
            var b = this.bpc;
            if (8 === b) return a;
            var d = this.width,
              h = this.height,
              k = this.numComps,
              m = d * h * k,
              c = 0,
              q = 8 >= b ? new Uint8Array(m) : 16 >= b ? new Uint16Array(m) : new Uint32Array(m);
            d *= k;
            var t = (1 << b) - 1;
            k = 0;
            if (1 === b)
              for (m = 0; m < h; m++) {
                t = k + (d & -8);
                for (b = k + d; k < t; ) {
                  var g = a[c++];
                  q[k] = (g >> 7) & 1;
                  q[k + 1] = (g >> 6) & 1;
                  q[k + 2] = (g >> 5) & 1;
                  q[k + 3] = (g >> 4) & 1;
                  q[k + 4] = (g >> 3) & 1;
                  q[k + 5] = (g >> 2) & 1;
                  q[k + 6] = (g >> 1) & 1;
                  q[k + 7] = g & 1;
                  k += 8;
                }
                if (k < b) for (g = a[c++], t = 128; k < b; ) (q[k++] = +!!(g & t)), (t >>= 1);
              }
            else
              for (k = g = h = 0; k < m; ++k) {
                0 === k % d && (h = g = 0);
                for (; h < b; ) (g = (g << 8) | a[c++]), (h += 8);
                h -= b;
                var u = g >> h;
                q[k] = 0 > u ? 0 : u > t ? t : u;
                g &= (1 << h) - 1;
              }
            return q;
          },
          fillOpacity: function(b, d, e, h, k) {
            var n = this.smask,
              c = this.mask,
              m;
            if (n) {
              k = n.width;
              var p = n.height;
              var g = new Uint8Array(k * p);
              n.fillGrayBuffer(g);
              if (k !== d || p !== e) g = t(g, n.bpc, k, p, d, e);
            } else if (c)
              if (c instanceof y) {
                k = c.width;
                p = c.height;
                g = new Uint8Array(k * p);
                c.numComps = 1;
                c.fillGrayBuffer(g);
                n = 0;
                for (m = k * p; n < m; ++n) g[n] = 255 - g[n];
                if (k !== d || p !== e) g = t(g, c.bpc, k, p, d, e);
              } else if (Array.isArray(c))
                for (g = new Uint8Array(d * e), p = this.numComps, n = 0, m = d * e; n < m; ++n) {
                  var u = 0,
                    l = n * p;
                  for (e = 0; e < p; ++e) {
                    var v = k[l + e],
                      f = 2 * e;
                    if (v < c[f] || v > c[f + 1]) {
                      u = 255;
                      break;
                    }
                  }
                  g[n] = u;
                }
              else throw new a.FormatError('Unknown mask format.');
            if (g) for (n = 0, e = 3, m = d * h; n < m; ++n, e += 4) b[e] = g[n];
            else for (n = 0, e = 3, m = d * h; n < m; ++n, e += 4) b[e] = 255;
          },
          undoPreblend: function(a, b, d) {
            var e = this.smask && this.smask.matte;
            if (e) {
              var k = this.colorSpace.getRgb(e, 0);
              e = k[0];
              var n = k[1];
              k = k[2];
              b = b * d * 4;
              for (d = 0; d < b; d += 4) {
                var c = a[d + 3];
                if (0 === c) (a[d] = 255), (a[d + 1] = 255), (a[d + 2] = 255);
                else {
                  var m = 255 / c;
                  c = (a[d] - e) * m + e;
                  var t = (a[d + 1] - n) * m + n;
                  m = (a[d + 2] - k) * m + k;
                  a[d] = 0 >= c ? 0 : 255 <= c ? 255 : c | 0;
                  a[d + 1] = 0 >= t ? 0 : 255 <= t ? 255 : t | 0;
                  a[d + 2] = 0 >= m ? 0 : 255 <= m ? 255 : m | 0;
                }
              }
            }
          },
          createImageData: function(b) {
            var d = this.drawWidth,
              e = this.drawHeight,
              h = { width: d, height: e },
              m = this.width,
              t = this.height,
              c = this.bpc,
              q = (m * this.numComps * c + 7) >> 3;
            if (!b) {
              if ('DeviceGray' === this.colorSpace.name && 1 === c) var u = a.ImageKind.GRAYSCALE_1BPP;
              else 'DeviceRGB' !== this.colorSpace.name || 8 !== c || this.needsDecode || (u = a.ImageKind.RGB_24BPP);
              if (u && !this.smask && !this.mask && d === m && e === t) {
                h.kind = u;
                var g = this.getImageBytes(t * q);
                this.image instanceof k.DecodeStream
                  ? (h.data = g)
                  : ((d = new Uint8Array(g.length)), d.set(g), (h.data = d));
                if (this.needsDecode)
                  for ((0, a.assert)(u === a.ImageKind.GRAYSCALE_1BPP), d = h.data, e = 0, m = d.length; e < m; e++)
                    d[e] ^= 255;
                return h;
              }
              if (
                this.image instanceof k.JpegStream &&
                !this.smask &&
                !this.mask &&
                ('DeviceGray' === this.colorSpace.name ||
                  'DeviceRGB' === this.colorSpace.name ||
                  'DeviceCMYK' === this.colorSpace.name)
              )
                return (h.kind = a.ImageKind.RGB_24BPP), (h.data = this.getImageBytes(t * q, d, e, !0)), h;
            }
            g = this.getImageBytes(t * q);
            u = 0 | (((g.length / q) * e) / t);
            g = this.getComponents(g);
            b || this.smask || this.mask
              ? ((h.kind = a.ImageKind.RGBA_32BPP),
                (h.data = new Uint8Array(d * e * 4)),
                (b = 1),
                (q = !0),
                this.fillOpacity(h.data, d, e, u, g))
              : ((h.kind = a.ImageKind.RGB_24BPP), (h.data = new Uint8Array(d * e * 3)), (b = 0), (q = !1));
            this.needsDecode && this.decodeBuffer(g);
            this.colorSpace.fillRgb(h.data, m, t, d, e, u, c, g, b);
            q && this.undoPreblend(h.data, d, u);
            return h;
          },
          fillGrayBuffer: function(b) {
            var d = this.numComps;
            if (1 !== d) throw new a.FormatError('Reading gray scale from a color image: ' + d);
            var e = this.width,
              h = this.height,
              k = this.bpc;
            d = this.getImageBytes(h * ((e * d * k + 7) >> 3));
            d = this.getComponents(d);
            if (1 === k)
              if (((e *= h), this.needsDecode)) for (k = 0; k < e; ++k) b[k] = (d[k] - 1) & 255;
              else for (k = 0; k < e; ++k) b[k] = -d[k] & 255;
            else
              for (this.needsDecode && this.decodeBuffer(d), e *= h, h = 255 / ((1 << k) - 1), k = 0; k < e; ++k)
                b[k] = (h * d[k]) | 0;
          },
          getImageBytes: function(a, b, d, h) {
            this.image.reset();
            this.image.drawWidth = b || this.width;
            this.image.drawHeight = d || this.height;
            this.image.forceRGB = !!h;
            return this.image.getBytes(a);
          },
        };
        return y;
      })();
      m.PDFImage = y;
    },
    function(y, m, t) {
      function a(a, b) {
        if (!a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !b || ('object' !== typeof b && 'function' !== typeof b) ? a : b;
      }
      function k(a, b) {
        if ('function' !== typeof b && null !== b)
          throw new TypeError('Super expression must either be null or a function, not ' + typeof b);
        a.prototype = Object.create(b && b.prototype, {
          constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 },
        });
        b && (Object.setPrototypeOf ? Object.setPrototypeOf(a, b) : (a.__proto__ = b));
      }
      function b(a, b) {
        if (!(a instanceof b)) throw new TypeError('Cannot call a class as a function');
      }
      function v(a, b, c) {
        var d = z.Util.getAxialAlignedBoundingBox(b, c);
        b = d[0];
        c = d[1];
        var e = d[2];
        d = d[3];
        if (b === e || c === d) return [1, 0, 0, 1, a[0], a[1]];
        e = (a[2] - a[0]) / (e - b);
        d = (a[3] - a[1]) / (d - c);
        return [e, 0, 0, d, a[0] - b * e, a[1] - c * d];
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.AnnotationFactory = m.AnnotationBorderStyle = m.Annotation = void 0;
      var d = function Z(a, b, c) {
          null === a && (a = Function.prototype);
          var d = Object.getOwnPropertyDescriptor(a, b);
          if (void 0 === d) {
            if (((a = Object.getPrototypeOf(a)), null !== a)) return Z(a, b, c);
          } else {
            if ('value' in d) return d.value;
            b = d.get;
            return void 0 === b ? void 0 : b.call(c);
          }
        },
        u = (function() {
          function a(a, b) {
            for (var c = 0; c < b.length; c++) {
              var d = b[c];
              d.enumerable = d.enumerable || !1;
              d.configurable = !0;
              'value' in d && (d.writable = !0);
              Object.defineProperty(a, d.key, d);
            }
          }
          return function(b, c, d) {
            c && a(b.prototype, c);
            d && a(b, d);
            return b;
          };
        })(),
        z = t(0),
        C = t(59),
        B = t(1),
        n = t(17),
        e = t(63),
        h = t(3);
      y = (function() {
        function a() {
          b(this, a);
        }
        u(a, null, [
          {
            key: 'create',
            value: function(a, b, d, e) {
              var h = a.fetchIfRef(b);
              if ((0, B.isDict)(h)) {
                var k = (0, B.isRef)(b) ? b.toString() : 'annot_' + e.createObjId();
                e = h.get('Subtype');
                e = (0, B.isName)(e) ? e.name : null;
                a = { xref: a, dict: h, ref: (0, B.isRef)(b) ? b : null, subtype: e, id: k, pdfManager: d };
                switch (e) {
                  case 'Link':
                    return new l(a);
                  case 'Text':
                    return new G(a);
                  case 'Widget':
                    h = z.Util.getInheritableProperty(h, 'FT');
                    h = (0, B.isName)(h) ? h.name : null;
                    switch (h) {
                      case 'Tx':
                        return new q(a);
                      case 'Btn':
                        return new x(a);
                      case 'Ch':
                        return new g(a);
                    }
                    (0, z.warn)('Unimplemented widget field type "' + h + '", falling back to base field type.');
                    return new c(a);
                  case 'Popup':
                    return new J(a);
                  case 'Line':
                    return new f(a);
                  case 'Square':
                    return new r(a);
                  case 'Circle':
                    return new D(a);
                  case 'PolyLine':
                    return new L(a);
                  case 'Polygon':
                    return new I(a);
                  case 'Highlight':
                    return new w(a);
                  case 'Underline':
                    return new E(a);
                  case 'Squiggly':
                    return new F(a);
                  case 'StrikeOut':
                    return new K(a);
                  case 'Stamp':
                    return new H(a);
                  case 'FileAttachment':
                    return new M(a);
                  default:
                    return (
                      e
                        ? (0, z.warn)('Unimplemented annotation type "' + e + '", falling back to base annotation.')
                        : (0, z.warn)('Annotation is missing the required /Subtype.'),
                      new p(a)
                    );
                }
              }
            },
          },
        ]);
        return a;
      })();
      var p = (function() {
          function a(c) {
            b(this, a);
            var d = c.dict;
            this.setFlags(d.get('F'));
            this.setRectangle(d.getArray('Rect'));
            this.setColor(d.getArray('C'));
            this.setBorderStyle(d);
            this.setAppearance(d);
            this.data = {
              annotationFlags: this.flags,
              borderStyle: this.borderStyle,
              color: this.color,
              hasAppearance: !!this.appearance,
              id: c.id,
              rect: this.rectangle,
              subtype: c.subtype,
            };
          }
          u(a, [
            {
              key: '_hasFlag',
              value: function(a, b) {
                return !!(a & b);
              },
            },
            {
              key: '_isViewable',
              value: function(a) {
                return (
                  !this._hasFlag(a, z.AnnotationFlag.INVISIBLE) &&
                  !this._hasFlag(a, z.AnnotationFlag.HIDDEN) &&
                  !this._hasFlag(a, z.AnnotationFlag.NOVIEW)
                );
              },
            },
            {
              key: '_isPrintable',
              value: function(a) {
                return (
                  this._hasFlag(a, z.AnnotationFlag.PRINT) &&
                  !this._hasFlag(a, z.AnnotationFlag.INVISIBLE) &&
                  !this._hasFlag(a, z.AnnotationFlag.HIDDEN)
                );
              },
            },
            {
              key: 'setFlags',
              value: function(a) {
                this.flags = Number.isInteger(a) && 0 < a ? a : 0;
              },
            },
            {
              key: 'hasFlag',
              value: function(a) {
                return this._hasFlag(this.flags, a);
              },
            },
            {
              key: 'setRectangle',
              value: function(a) {
                Array.isArray(a) && 4 === a.length
                  ? (this.rectangle = z.Util.normalizeRect(a))
                  : (this.rectangle = [0, 0, 0, 0]);
              },
            },
            {
              key: 'setColor',
              value: function(a) {
                var b = new Uint8Array(3);
                if (Array.isArray(a))
                  switch (a.length) {
                    case 0:
                      this.color = null;
                      break;
                    case 1:
                      n.ColorSpace.singletons.gray.getRgbItem(a, 0, b, 0);
                      this.color = b;
                      break;
                    case 3:
                      n.ColorSpace.singletons.rgb.getRgbItem(a, 0, b, 0);
                      this.color = b;
                      break;
                    case 4:
                      n.ColorSpace.singletons.cmyk.getRgbItem(a, 0, b, 0);
                      this.color = b;
                      break;
                    default:
                      this.color = b;
                  }
                else this.color = b;
              },
            },
            {
              key: 'setBorderStyle',
              value: function(a) {
                this.borderStyle = new A();
                if ((0, B.isDict)(a))
                  if (a.has('BS')) {
                    a = a.get('BS');
                    var b = a.get('Type');
                    if (!b || (0, B.isName)(b, 'Border'))
                      this.borderStyle.setWidth(a.get('W')),
                        this.borderStyle.setStyle(a.get('S')),
                        this.borderStyle.setDashArray(a.getArray('D'));
                  } else
                    a.has('Border')
                      ? ((a = a.getArray('Border')),
                        Array.isArray(a) &&
                          3 <= a.length &&
                          (this.borderStyle.setHorizontalCornerRadius(a[0]),
                          this.borderStyle.setVerticalCornerRadius(a[1]),
                          this.borderStyle.setWidth(a[2]),
                          4 === a.length && this.borderStyle.setDashArray(a[3])))
                      : this.borderStyle.setWidth(0);
              },
            },
            {
              key: 'setAppearance',
              value: function(a) {
                this.appearance = null;
                var b = a.get('AP');
                (0, B.isDict)(b) &&
                  ((b = b.get('N')),
                  (0, B.isStream)(b)
                    ? (this.appearance = b)
                    : (0, B.isDict)(b) &&
                      ((a = a.get('AS')), (0, B.isName)(a) && b.has(a.name) && (this.appearance = b.get(a.name))));
              },
            },
            {
              key: '_preparePopup',
              value: function(a) {
                a.has('C') || (this.data.color = null);
                this.data.hasPopup = a.has('Popup');
                this.data.title = (0, z.stringToPDFString)(a.get('T') || '');
                this.data.contents = (0, z.stringToPDFString)(a.get('Contents') || '');
              },
            },
            {
              key: 'loadResources',
              value: function(a) {
                return this.appearance.dict.getAsync('Resources').then(function(b) {
                  if (b)
                    return new C.ObjectLoader(b, a, b.xref).load().then(function() {
                      return b;
                    });
                });
              },
            },
            {
              key: 'getOperatorList',
              value: function(a, b, c) {
                var d = this;
                if (!this.appearance) return Promise.resolve(new e.OperatorList());
                var g = this.data;
                c = this.appearance.dict;
                var f = this.loadResources('ExtGState ColorSpace Pattern Shading XObject Font'.split(' ')),
                  h = c.getArray('BBox') || [0, 0, 1, 1],
                  k = c.getArray('Matrix') || [1, 0, 0, 1, 0, 0],
                  l = v(g.rect, h, k);
                return f.then(function(c) {
                  var f = new e.OperatorList();
                  f.addOp(z.OPS.beginAnnotation, [g.rect, l, k]);
                  return a
                    .getOperatorList({ stream: d.appearance, task: b, resources: c, operatorList: f })
                    .then(function() {
                      f.addOp(z.OPS.endAnnotation, []);
                      d.appearance.reset();
                      return f;
                    });
                });
              },
            },
            {
              key: 'viewable',
              get: function() {
                return 0 === this.flags ? !0 : this._isViewable(this.flags);
              },
            },
            {
              key: 'printable',
              get: function() {
                return 0 === this.flags ? !1 : this._isPrintable(this.flags);
              },
            },
          ]);
          return a;
        })(),
        A = (function() {
          function a() {
            b(this, a);
            this.width = 1;
            this.style = z.AnnotationBorderStyleType.SOLID;
            this.dashArray = [3];
            this.verticalCornerRadius = this.horizontalCornerRadius = 0;
          }
          u(a, [
            {
              key: 'setWidth',
              value: function(a) {
                Number.isInteger(a) && (this.width = a);
              },
            },
            {
              key: 'setStyle',
              value: function(a) {
                if (a)
                  switch (a.name) {
                    case 'S':
                      this.style = z.AnnotationBorderStyleType.SOLID;
                      break;
                    case 'D':
                      this.style = z.AnnotationBorderStyleType.DASHED;
                      break;
                    case 'B':
                      this.style = z.AnnotationBorderStyleType.BEVELED;
                      break;
                    case 'I':
                      this.style = z.AnnotationBorderStyleType.INSET;
                      break;
                    case 'U':
                      this.style = z.AnnotationBorderStyleType.UNDERLINE;
                  }
              },
            },
            {
              key: 'setDashArray',
              value: function(a) {
                if (Array.isArray(a) && 0 < a.length) {
                  for (var b = !0, c = !0, d = 0, e = a.length; d < e; d++) {
                    var g = a[d];
                    if (0 <= +g) 0 < g && (c = !1);
                    else {
                      b = !1;
                      break;
                    }
                  }
                  b && !c ? (this.dashArray = a) : (this.width = 0);
                } else a && (this.width = 0);
              },
            },
            {
              key: 'setHorizontalCornerRadius',
              value: function(a) {
                Number.isInteger(a) && (this.horizontalCornerRadius = a);
              },
            },
            {
              key: 'setVerticalCornerRadius',
              value: function(a) {
                Number.isInteger(a) && (this.verticalCornerRadius = a);
              },
            },
          ]);
          return a;
        })(),
        c = (function(c) {
          function g(c) {
            b(this, g);
            var d = a(this, (g.__proto__ || Object.getPrototypeOf(g)).call(this, c));
            c = c.dict;
            var e = d.data;
            e.annotationType = z.AnnotationType.WIDGET;
            e.fieldName = d._constructFieldName(c);
            e.fieldValue = z.Util.getInheritableProperty(c, 'V', !0);
            e.alternativeText = (0, z.stringToPDFString)(c.get('TU') || '');
            e.defaultAppearance = z.Util.getInheritableProperty(c, 'DA') || '';
            var f = z.Util.getInheritableProperty(c, 'FT');
            e.fieldType = (0, B.isName)(f) ? f.name : null;
            d.fieldResources = z.Util.getInheritableProperty(c, 'DR') || B.Dict.empty;
            e.fieldFlags = z.Util.getInheritableProperty(c, 'Ff');
            if (!Number.isInteger(e.fieldFlags) || 0 > e.fieldFlags) e.fieldFlags = 0;
            e.readOnly = d.hasFieldFlag(z.AnnotationFieldFlag.READONLY);
            'Sig' === e.fieldType && d.setFlags(z.AnnotationFlag.HIDDEN);
            return d;
          }
          k(g, c);
          u(g, [
            {
              key: '_constructFieldName',
              value: function(a) {
                if (!a.has('T') && !a.has('Parent'))
                  return (0, z.warn)('Unknown field name, falling back to empty field name.'), '';
                if (!a.has('Parent')) return (0, z.stringToPDFString)(a.get('T'));
                var b = [];
                for (a.has('T') && b.unshift((0, z.stringToPDFString)(a.get('T'))); a.has('Parent'); ) {
                  a = a.get('Parent');
                  if (!(0, B.isDict)(a)) break;
                  a.has('T') && b.unshift((0, z.stringToPDFString)(a.get('T')));
                }
                return b.join('.');
              },
            },
            {
              key: 'hasFieldFlag',
              value: function(a) {
                return !!(this.data.fieldFlags & a);
              },
            },
            {
              key: 'getOperatorList',
              value: function(a, b, c) {
                return c
                  ? Promise.resolve(new e.OperatorList())
                  : d(g.prototype.__proto__ || Object.getPrototypeOf(g.prototype), 'getOperatorList', this).call(
                      this,
                      a,
                      b,
                      c,
                    );
              },
            },
          ]);
          return g;
        })(p),
        q = (function(c) {
          function g(c) {
            b(this, g);
            var d = a(this, (g.__proto__ || Object.getPrototypeOf(g)).call(this, c));
            d.data.fieldValue = (0, z.stringToPDFString)(d.data.fieldValue || '');
            var e = z.Util.getInheritableProperty(c.dict, 'Q');
            if (!Number.isInteger(e) || 0 > e || 2 < e) e = null;
            d.data.textAlignment = e;
            c = z.Util.getInheritableProperty(c.dict, 'MaxLen');
            if (!Number.isInteger(c) || 0 > c) c = null;
            d.data.maxLen = c;
            d.data.multiLine = d.hasFieldFlag(z.AnnotationFieldFlag.MULTILINE);
            d.data.comb =
              d.hasFieldFlag(z.AnnotationFieldFlag.COMB) &&
              !d.hasFieldFlag(z.AnnotationFieldFlag.MULTILINE) &&
              !d.hasFieldFlag(z.AnnotationFieldFlag.PASSWORD) &&
              !d.hasFieldFlag(z.AnnotationFieldFlag.FILESELECT) &&
              null !== d.data.maxLen;
            return d;
          }
          k(g, c);
          u(g, [
            {
              key: 'getOperatorList',
              value: function(a, b, c) {
                if (c || this.appearance)
                  return d(g.prototype.__proto__ || Object.getPrototypeOf(g.prototype), 'getOperatorList', this).call(
                    this,
                    a,
                    b,
                    c,
                  );
                var f = new e.OperatorList();
                if (!this.data.defaultAppearance) return Promise.resolve(f);
                c = new h.Stream((0, z.stringToBytes)(this.data.defaultAppearance));
                return a
                  .getOperatorList({ stream: c, task: b, resources: this.fieldResources, operatorList: f })
                  .then(function() {
                    return f;
                  });
              },
            },
          ]);
          return g;
        })(c),
        x = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.checkBox =
              !e.hasFieldFlag(z.AnnotationFieldFlag.RADIO) && !e.hasFieldFlag(z.AnnotationFieldFlag.PUSHBUTTON);
            if (e.data.checkBox) {
              if (!(0, B.isName)(e.data.fieldValue)) return a(e);
              e.data.fieldValue = e.data.fieldValue.name;
            }
            e.data.radioButton =
              e.hasFieldFlag(z.AnnotationFieldFlag.RADIO) && !e.hasFieldFlag(z.AnnotationFieldFlag.PUSHBUTTON);
            if (e.data.radioButton) {
              e.data.fieldValue = e.data.buttonValue = null;
              var g = c.dict.get('Parent');
              (0, B.isDict)(g) && g.has('V') && ((g = g.get('V')), (0, B.isName)(g) && (e.data.fieldValue = g.name));
              c = c.dict.get('AP');
              if (!(0, B.isDict)(c)) return a(e);
              c = c.get('N');
              if (!(0, B.isDict)(c)) return a(e);
              c = c.getKeys();
              g = 0;
              for (var f = c.length; g < f; g++)
                if ('Off' !== c[g]) {
                  e.data.buttonValue = c[g];
                  break;
                }
            }
            return e;
          }
          k(d, c);
          return d;
        })(c),
        g = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.options = [];
            var g = z.Util.getInheritableProperty(c.dict, 'Opt');
            if (Array.isArray(g)) {
              c = c.xref;
              for (var f = 0, h = g.length; f < h; f++) {
                var k = c.fetchIfRef(g[f]),
                  l = Array.isArray(k);
                e.data.options[f] = {
                  exportValue: l ? c.fetchIfRef(k[0]) : k,
                  displayValue: l ? c.fetchIfRef(k[1]) : k,
                };
              }
            }
            Array.isArray(e.data.fieldValue) || (e.data.fieldValue = [e.data.fieldValue]);
            e.data.combo = e.hasFieldFlag(z.AnnotationFieldFlag.COMBO);
            e.data.multiSelect = e.hasFieldFlag(z.AnnotationFieldFlag.MULTISELECT);
            return e;
          }
          k(d, c);
          return d;
        })(c),
        G = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.TEXT;
            e.data.hasAppearance
              ? (e.data.name = 'NoIcon')
              : ((e.data.rect[1] = e.data.rect[3] - 22),
                (e.data.rect[2] = e.data.rect[0] + 22),
                (e.data.name = c.dict.has('Name') ? c.dict.get('Name').name : 'Note'));
            e._preparePopup(c.dict);
            return e;
          }
          k(d, c);
          return d;
        })(p),
        l = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.LINK;
            C.Catalog.parseDestDictionary({ destDict: c.dict, resultObj: e.data, docBaseUrl: c.pdfManager.docBaseUrl });
            return e;
          }
          k(d, c);
          return d;
        })(p),
        J = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.POPUP;
            c = c.dict;
            var g = c.get('Parent');
            if (!g) return (0, z.warn)('Popup annotation has a missing or invalid parent annotation.'), a(e);
            var f = g.get('Subtype');
            e.data.parentType = (0, B.isName)(f) ? f.name : null;
            e.data.parentId = c.getRaw('Parent').toString();
            e.data.title = (0, z.stringToPDFString)(g.get('T') || '');
            e.data.contents = (0, z.stringToPDFString)(g.get('Contents') || '');
            g.has('C') ? (e.setColor(g.getArray('C')), (e.data.color = e.color)) : (e.data.color = null);
            e.viewable || ((c = g.get('F')), e._isViewable(c) && e.setFlags(c));
            return e;
          }
          k(d, c);
          return d;
        })(p),
        f = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.LINE;
            c = c.dict;
            e.data.lineCoordinates = z.Util.normalizeRect(c.getArray('L'));
            e._preparePopup(c);
            return e;
          }
          k(d, c);
          return d;
        })(p),
        r = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.SQUARE;
            e._preparePopup(c.dict);
            return e;
          }
          k(d, c);
          return d;
        })(p),
        D = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.CIRCLE;
            e._preparePopup(c.dict);
            return e;
          }
          k(d, c);
          return d;
        })(p),
        L = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.POLYLINE;
            c = c.dict;
            var g = c.getArray('Vertices');
            e.data.vertices = [];
            for (var f = 0, h = g.length; f < h; f += 2) e.data.vertices.push({ x: g[f], y: g[f + 1] });
            e._preparePopup(c);
            return e;
          }
          k(d, c);
          return d;
        })(p),
        I = (function(c) {
          function d(c) {
            b(this, d);
            c = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            c.data.annotationType = z.AnnotationType.POLYGON;
            return c;
          }
          k(d, c);
          return d;
        })(L),
        w = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.HIGHLIGHT;
            e._preparePopup(c.dict);
            return e;
          }
          k(d, c);
          return d;
        })(p),
        E = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.UNDERLINE;
            e._preparePopup(c.dict);
            return e;
          }
          k(d, c);
          return d;
        })(p),
        F = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.SQUIGGLY;
            e._preparePopup(c.dict);
            return e;
          }
          k(d, c);
          return d;
        })(p),
        K = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.STRIKEOUT;
            e._preparePopup(c.dict);
            return e;
          }
          k(d, c);
          return d;
        })(p),
        H = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            e.data.annotationType = z.AnnotationType.STAMP;
            e._preparePopup(c.dict);
            return e;
          }
          k(d, c);
          return d;
        })(p),
        M = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c)),
              g = new C.FileSpec(c.dict.get('FS'), c.xref);
            e.data.annotationType = z.AnnotationType.FILEATTACHMENT;
            e.data.file = g.serializable;
            e._preparePopup(c.dict);
            return e;
          }
          k(d, c);
          return d;
        })(p);
      m.Annotation = p;
      m.AnnotationBorderStyle = A;
      m.AnnotationFactory = y;
    },
    function(y, m, t) {
      function a(a, b) {
        if (!a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !b || ('object' !== typeof b && 'function' !== typeof b) ? a : b;
      }
      function k(a, b) {
        if ('function' !== typeof b && null !== b)
          throw new TypeError('Super expression must either be null or a function, not ' + typeof b);
        a.prototype = Object.create(b && b.prototype, {
          constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 },
        });
        b && (Object.setPrototypeOf ? Object.setPrototypeOf(a, b) : (a.__proto__ = b));
      }
      function b(a, b) {
        if (!(a instanceof b)) throw new TypeError('Cannot call a class as a function');
      }
      function v(a, b) {
        return {
          protocol: a.protocol,
          auth: a.auth,
          host: a.hostname,
          port: a.port,
          path: a.path,
          method: 'GET',
          headers: b,
        };
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.PDFNodeStream = void 0;
      var d = (function() {
          function a(a, b) {
            for (var c = 0; c < b.length; c++) {
              var d = b[c];
              d.enumerable = d.enumerable || !1;
              d.configurable = !0;
              'value' in d && (d.writable = !0);
              Object.defineProperty(a, d.key, d);
            }
          }
          return function(b, c, d) {
            c && a(b.prototype, c);
            d && a(b, d);
            return b;
          };
        })(),
        u = t(0),
        z = t(36),
        C = require('fs'),
        B = require('http'),
        n = require('https'),
        e = require('url');
      y = (function() {
        function a(c) {
          b(this, a);
          this.options = c;
          this.source = c.source;
          this.url = e.parse(this.source.url);
          this.isHttp = 'http:' === this.url.protocol || 'https:' === this.url.protocol;
          this.isFsUrl = 'file:' === this.url.protocol || !this.url.host;
          this.httpHeaders = (this.isHttp && this.source.httpHeaders) || {};
          this._fullRequest = null;
          this._rangeRequestReaders = [];
        }
        d(a, [
          {
            key: 'getFullReader',
            value: function() {
              (0, u.assert)(!this._fullRequest);
              return (this._fullRequest = this.isFsUrl ? new c(this) : new p(this));
            },
          },
          {
            key: 'getRangeReader',
            value: function(a, b) {
              var c = this.isFsUrl ? new q(this, a, b) : new A(this, a, b);
              this._rangeRequestReaders.push(c);
              return c;
            },
          },
          {
            key: 'cancelAllRequests',
            value: function(a) {
              this._fullRequest && this._fullRequest.cancel(a);
              this._rangeRequestReaders.slice(0).forEach(function(b) {
                b.cancel(a);
              });
            },
          },
        ]);
        return a;
      })();
      t = (function() {
        function a(c) {
          b(this, a);
          this._url = c.url;
          this._errored = this._done = !1;
          this.onProgress = this._reason = null;
          this._contentLength = c.source.length;
          this._loaded = 0;
          this._disableRange = c.options.disableRange || !1;
          this._rangeChunkSize = c.source.rangeChunkSize;
          this._rangeChunkSize || this._disableRange || (this._disableRange = !0);
          this._isStreamingSupported = !c.source.disableStream;
          this._isRangeSupported = !c.options.disableRange;
          this._readableStream = null;
          this._readCapability = (0, u.createPromiseCapability)();
          this._headersCapability = (0, u.createPromiseCapability)();
        }
        d(a, [
          {
            key: 'read',
            value: function() {
              var a = this;
              return this._readCapability.promise.then(function() {
                if (a._done) return Promise.resolve({ value: void 0, done: !0 });
                if (a._errored) return Promise.reject(a._reason);
                var b = a._readableStream.read();
                if (null === b) return (a._readCapability = (0, u.createPromiseCapability)()), a.read();
                a._loaded += b.length;
                if (a.onProgress) a.onProgress({ loaded: a._loaded, total: a._contentLength });
                b = new Uint8Array(b).buffer;
                return Promise.resolve({ value: b, done: !1 });
              });
            },
          },
          {
            key: 'cancel',
            value: function(a) {
              this._readableStream ? this._readableStream.destroy(a) : this._error(a);
            },
          },
          {
            key: '_error',
            value: function(a) {
              this._errored = !0;
              this._reason = a;
              this._readCapability.resolve();
            },
          },
          {
            key: '_setReadableStream',
            value: function(a) {
              var b = this;
              this._readableStream = a;
              a.on('readable', function() {
                b._readCapability.resolve();
              });
              a.on('end', function() {
                a.destroy();
                b._done = !0;
                b._readCapability.resolve();
              });
              a.on('error', function(a) {
                b._error(a);
              });
              !this._isStreamingSupported &&
                this._isRangeSupported &&
                this._error(new u.AbortException('streaming is disabled'));
              this._errored && this._readableStream.destroy(this._reason);
            },
          },
          {
            key: 'headersReady',
            get: function() {
              return this._headersCapability.promise;
            },
          },
          {
            key: 'contentLength',
            get: function() {
              return this._contentLength;
            },
          },
          {
            key: 'isRangeSupported',
            get: function() {
              return this._isRangeSupported;
            },
          },
          {
            key: 'isStreamingSupported',
            get: function() {
              return this._isStreamingSupported;
            },
          },
        ]);
        return a;
      })();
      var h = (function() {
          function a(c) {
            b(this, a);
            this._url = c.url;
            this._errored = this._done = !1;
            this.onProgress = this._reason = null;
            this._loaded = 0;
            this._readableStream = null;
            this._readCapability = (0, u.createPromiseCapability)();
            this._isStreamingSupported = !c.source.disableStream;
          }
          d(a, [
            {
              key: 'read',
              value: function() {
                var a = this;
                return this._readCapability.promise.then(function() {
                  if (a._done) return Promise.resolve({ value: void 0, done: !0 });
                  if (a._errored) return Promise.reject(a._reason);
                  var b = a._readableStream.read();
                  if (null === b) return (a._readCapability = (0, u.createPromiseCapability)()), a.read();
                  a._loaded += b.length;
                  if (a.onProgress) a.onProgress({ loaded: a._loaded });
                  b = new Uint8Array(b).buffer;
                  return Promise.resolve({ value: b, done: !1 });
                });
              },
            },
            {
              key: 'cancel',
              value: function(a) {
                this._readableStream ? this._readableStream.destroy(a) : this._error(a);
              },
            },
            {
              key: '_error',
              value: function(a) {
                this._errored = !0;
                this._reason = a;
                this._readCapability.resolve();
              },
            },
            {
              key: '_setReadableStream',
              value: function(a) {
                var b = this;
                this._readableStream = a;
                a.on('readable', function() {
                  b._readCapability.resolve();
                });
                a.on('end', function() {
                  a.destroy();
                  b._done = !0;
                  b._readCapability.resolve();
                });
                a.on('error', function(a) {
                  b._error(a);
                });
                this._errored && this._readableStream.destroy(this._reason);
              },
            },
            {
              key: 'isStreamingSupported',
              get: function() {
                return this._isStreamingSupported;
              },
            },
          ]);
          return a;
        })(),
        p = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c)),
              g = function(a) {
                e._headersCapability.resolve();
                e._setReadableStream(a);
                a = (0, z.validateRangeRequestCapabilities)({
                  getResponseHeader: function(a) {
                    return e._readableStream.headers[a.toLowerCase()];
                  },
                  isHttp: c.isHttp,
                  rangeChunkSize: e._rangeChunkSize,
                  disableRange: e._disableRange,
                });
                var b = a.suggestedLength;
                a.allowRangeRequests && (e._isRangeSupported = !0);
                e._contentLength = b;
              };
            e._request = null;
            e._request =
              'http:' === e._url.protocol
                ? B.request(v(e._url, c.httpHeaders), g)
                : n.request(v(e._url, c.httpHeaders), g);
            e._request.on('error', function(a) {
              e._errored = !0;
              e._reason = a;
              e._headersCapability.reject(a);
            });
            e._request.end();
            return e;
          }
          k(d, c);
          return d;
        })(t),
        A = (function(c) {
          function d(c, e, g) {
            b(this, d);
            var f = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            f._httpHeaders = {};
            for (var h in c.httpHeaders) {
              var k = c.httpHeaders[h];
              'undefined' !== typeof k && (f._httpHeaders[h] = k);
            }
            f._httpHeaders.Range = 'bytes=' + e + '-' + (g - 1);
            f._request = null;
            f._request =
              'http:' === f._url.protocol
                ? B.request(v(f._url, f._httpHeaders), function(a) {
                    f._setReadableStream(a);
                  })
                : n.request(v(f._url, f._httpHeaders), function(a) {
                    f._setReadableStream(a);
                  });
            f._request.on('error', function(a) {
              f._errored = !0;
              f._reason = a;
            });
            f._request.end();
            return f;
          }
          k(d, c);
          return d;
        })(h),
        c = (function(c) {
          function d(c) {
            b(this, d);
            var e = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c)),
              g = decodeURI(e._url.path);
            C.lstat(g, function(a, b) {
              a
                ? ((e._errored = !0), (e._reason = a), e._headersCapability.reject(a))
                : ((e._contentLength = b.size),
                  e._setReadableStream(C.createReadStream(g)),
                  e._headersCapability.resolve());
            });
            return e;
          }
          k(d, c);
          return d;
        })(t),
        q = (function(c) {
          function d(c, e, g) {
            b(this, d);
            c = a(this, (d.__proto__ || Object.getPrototypeOf(d)).call(this, c));
            c._setReadableStream(C.createReadStream(decodeURI(c._url.path), { start: e, end: g - 1 }));
            return c;
          }
          k(d, c);
          return d;
        })(h);
      m.PDFNodeStream = y;
    },
    function(y, m, t) {
      function a(a, b) {
        if (!(a instanceof b)) throw new TypeError('Cannot call a class as a function');
      }
      function k(a, b) {
        return {
          method: 'GET',
          headers: a,
          mode: 'cors',
          credentials: b ? 'include' : 'same-origin',
          redirect: 'follow',
        };
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.PDFFetchStream = void 0;
      var b = (function() {
          function a(a, b) {
            for (var d = 0; d < b.length; d++) {
              var h = b[d];
              h.enumerable = h.enumerable || !1;
              h.configurable = !0;
              'value' in h && (h.writable = !0);
              Object.defineProperty(a, h.key, h);
            }
          }
          return function(b, d, e) {
            d && a(b.prototype, d);
            e && a(b, e);
            return b;
          };
        })(),
        v = t(0),
        d = t(36);
      y = (function() {
        function d(b) {
          a(this, d);
          this.options = b;
          this.source = b.source;
          this.httpHeaders = ((this.isHttp = /^https?:/i.test(this.source.url)) && this.source.httpHeaders) || {};
          this._fullRequestReader = null;
          this._rangeRequestReaders = [];
        }
        b(d, [
          {
            key: 'getFullReader',
            value: function() {
              (0, v.assert)(!this._fullRequestReader);
              return (this._fullRequestReader = new u(this));
            },
          },
          {
            key: 'getRangeReader',
            value: function(a, b) {
              var d = new z(this, a, b);
              this._rangeRequestReaders.push(d);
              return d;
            },
          },
          {
            key: 'cancelAllRequests',
            value: function(a) {
              this._fullRequestReader && this._fullRequestReader.cancel(a);
              this._rangeRequestReaders.slice(0).forEach(function(b) {
                b.cancel(a);
              });
            },
          },
        ]);
        return d;
      })();
      var u = (function() {
          function m(b) {
            var n = this;
            a(this, m);
            this._stream = b;
            this._reader = null;
            this._loaded = 0;
            this._withCredentials = b.source.withCredentials;
            this._contentLength = this._stream.source.length;
            this._headersCapability = (0, v.createPromiseCapability)();
            this._disableRange = this._stream.options.disableRange;
            this._rangeChunkSize = this._stream.source.rangeChunkSize;
            this._rangeChunkSize || this._disableRange || (this._disableRange = !0);
            this._isRangeSupported = !this._stream.options.disableRange;
            this._isStreamingSupported = !this._stream.source.disableStream;
            this._headers = new Headers();
            for (var e in this._stream.httpHeaders)
              (b = this._stream.httpHeaders[e]), 'undefined' !== typeof b && this._headers.append(e, b);
            var h = this._stream.source.url;
            fetch(h, k(this._headers, this._withCredentials))
              .then(function(a) {
                if (!(0, d.validateResponseStatus)(a.status)) throw (0, d.createResponseStatusError)(a.status, h);
                n._reader = a.body.getReader();
                n._headersCapability.resolve();
                var b = (0, d.validateRangeRequestCapabilities)({
                    getResponseHeader: function(b) {
                      return a.headers.get(b);
                    },
                    isHttp: n._stream.isHttp,
                    rangeChunkSize: n._rangeChunkSize,
                    disableRange: n._disableRange,
                  }),
                  c = b.allowRangeRequests;
                n._contentLength = b.suggestedLength;
                n._isRangeSupported = c;
                !n._isStreamingSupported &&
                  n._isRangeSupported &&
                  n.cancel(new v.AbortException('streaming is disabled'));
              })
              ['catch'](this._headersCapability.reject);
            this.onProgress = null;
          }
          b(m, [
            {
              key: 'read',
              value: function() {
                var a = this;
                return this._headersCapability.promise.then(function() {
                  return a._reader.read().then(function(b) {
                    var d = b.value;
                    if ((b = b.done)) return Promise.resolve({ value: d, done: b });
                    a._loaded += d.byteLength;
                    if (a.onProgress) a.onProgress({ loaded: a._loaded, total: a._contentLength });
                    d = new Uint8Array(d).buffer;
                    return Promise.resolve({ value: d, done: !1 });
                  });
                });
              },
            },
            {
              key: 'cancel',
              value: function(a) {
                this._reader && this._reader.cancel(a);
              },
            },
            {
              key: 'headersReady',
              get: function() {
                return this._headersCapability.promise;
              },
            },
            {
              key: 'contentLength',
              get: function() {
                return this._contentLength;
              },
            },
            {
              key: 'isRangeSupported',
              get: function() {
                return this._isRangeSupported;
              },
            },
            {
              key: 'isStreamingSupported',
              get: function() {
                return this._isStreamingSupported;
              },
            },
          ]);
          return m;
        })(),
        z = (function() {
          function m(b, n, e) {
            var h = this;
            a(this, m);
            this._stream = b;
            this._reader = null;
            this._loaded = 0;
            this._withCredentials = b.source.withCredentials;
            this._readCapability = (0, v.createPromiseCapability)();
            this._isStreamingSupported = !b.source.disableStream;
            this._headers = new Headers();
            for (var p in this._stream.httpHeaders)
              (b = this._stream.httpHeaders[p]), 'undefined' !== typeof b && this._headers.append(p, b);
            this._headers.append('Range', 'bytes=' + (n + '-' + (e - 1)));
            var t = this._stream.source.url;
            fetch(t, k(this._headers, this._withCredentials)).then(function(a) {
              if (!(0, d.validateResponseStatus)(a.status)) throw (0, d.createResponseStatusError)(a.status, t);
              h._readCapability.resolve();
              h._reader = a.body.getReader();
            });
            this.onProgress = null;
          }
          b(m, [
            {
              key: 'read',
              value: function() {
                var a = this;
                return this._readCapability.promise.then(function() {
                  return a._reader.read().then(function(b) {
                    var d = b.value;
                    if ((b = b.done)) return Promise.resolve({ value: d, done: b });
                    a._loaded += d.byteLength;
                    if (a.onProgress) a.onProgress({ loaded: a._loaded });
                    d = new Uint8Array(d).buffer;
                    return Promise.resolve({ value: d, done: !1 });
                  });
                });
              },
            },
            {
              key: 'cancel',
              value: function(a) {
                this._reader && this._reader.cancel(a);
              },
            },
            {
              key: 'isStreamingSupported',
              get: function() {
                return this._isStreamingSupported;
              },
            },
          ]);
          return m;
        })();
      m.PDFFetchStream = y;
    },
    function(y, m, t) {
      function a(a, b) {
        this.url = a;
        b = b || {};
        this.httpHeaders = ((this.isHttp = /^https?:/i.test(a)) && b.httpHeaders) || {};
        this.withCredentials = b.withCredentials || !1;
        this.getXhr =
          b.getXhr ||
          function() {
            return new XMLHttpRequest();
          };
        this.currXhrId = 0;
        this.pendingRequests = Object.create(null);
        this.loadedRequests = Object.create(null);
      }
      function k(a) {
        a = a.response;
        if ('string' !== typeof a) return a;
        for (var b = a.length, d = new Uint8Array(b), k = 0; k < b; k++) d[k] = a.charCodeAt(k) & 255;
        return d.buffer;
      }
      function b(b) {
        this._options = b;
        b = b.source;
        this._manager = new a(b.url, { httpHeaders: b.httpHeaders, withCredentials: b.withCredentials });
        this._rangeChunkSize = b.rangeChunkSize;
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
      }
      function v(a, b) {
        this._manager = a;
        var d = b.source,
          e = {
            onHeadersReceived: this._onHeadersReceived.bind(this),
            onProgressiveData: d.disableStream ? null : this._onProgressiveData.bind(this),
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this),
          };
        this._url = d.url;
        this._fullRequestId = a.requestFull(e);
        this._headersReceivedCapability = (0, u.createPromiseCapability)();
        this._disableRange = b.disableRange || !1;
        this._contentLength = d.length;
        this._rangeChunkSize = d.rangeChunkSize;
        this._rangeChunkSize || this._disableRange || (this._disableRange = !0);
        this._isRangeSupported = this._isStreamingSupported = !1;
        this._cachedChunks = [];
        this._requests = [];
        this._done = !1;
        this._storedError = void 0;
        this.onProgress = null;
      }
      function d(a, b, d) {
        this._manager = a;
        var e = { onDone: this._onDone.bind(this), onProgress: this._onProgress.bind(this) };
        this._requestId = a.requestRange(b, d, e);
        this._requests = [];
        this._queuedChunk = null;
        this._done = !1;
        this.onClosed = this.onProgress = null;
      }
      Object.defineProperty(m, '__esModule', { value: !0 });
      m.NetworkManager = m.PDFNetworkStream = void 0;
      var u = t(0),
        z = t(36),
        C = (y = t(11)) && y.__esModule ? y : { default: y },
        B = (function() {
          try {
            var a = new XMLHttpRequest();
            a.open('GET', C['default'].location.href);
            a.responseType = 'moz-chunked-arraybuffer';
            return 'moz-chunked-arraybuffer' === a.responseType;
          } catch (e) {
            return !1;
          }
        })();
      a.prototype = {
        requestRange: function(a, b, d) {
          a = { begin: a, end: b };
          for (var e in d) a[e] = d[e];
          return this.request(a);
        },
        requestFull: function(a) {
          return this.request(a);
        },
        request: function(a) {
          var b = this.getXhr(),
            d = this.currXhrId++,
            k = (this.pendingRequests[d] = { xhr: b });
          b.open('GET', this.url);
          b.withCredentials = this.withCredentials;
          for (var m in this.httpHeaders) {
            var c = this.httpHeaders[m];
            'undefined' !== typeof c && b.setRequestHeader(m, c);
          }
          this.isHttp && 'begin' in a && 'end' in a
            ? (b.setRequestHeader('Range', 'bytes=' + (a.begin + '-' + (a.end - 1))), (k.expectedStatus = 206))
            : (k.expectedStatus = 200);
          B && a.onProgressiveData
            ? ((b.responseType = 'moz-chunked-arraybuffer'),
              (k.onProgressiveData = a.onProgressiveData),
              (k.mozChunked = !0))
            : (b.responseType = 'arraybuffer');
          a.onError &&
            (b.onerror = function(c) {
              a.onError(b.status);
            });
          b.onreadystatechange = this.onStateChange.bind(this, d);
          b.onprogress = this.onProgress.bind(this, d);
          k.onHeadersReceived = a.onHeadersReceived;
          k.onDone = a.onDone;
          k.onError = a.onError;
          k.onProgress = a.onProgress;
          b.send(null);
          return d;
        },
        onProgress: function(a, b) {
          var d = this.pendingRequests[a];
          if (d) {
            if (d.mozChunked) {
              var e = k(d.xhr);
              d.onProgressiveData(e);
            }
            (d = d.onProgress) && d(b);
          }
        },
        onStateChange: function(a, b) {
          var d = this.pendingRequests[a];
          if (d) {
            var e = d.xhr;
            2 <= e.readyState && d.onHeadersReceived && (d.onHeadersReceived(), delete d.onHeadersReceived);
            if (4 === e.readyState && a in this.pendingRequests)
              if ((delete this.pendingRequests[a], 0 === e.status && this.isHttp)) {
                if (d.onError) d.onError(e.status);
              } else {
                var m = e.status || 200;
                if ((200 === m && 206 === d.expectedStatus) || m === d.expectedStatus) {
                  this.loadedRequests[a] = !0;
                  var c = k(e);
                  if (206 === m)
                    (e = e.getResponseHeader('Content-Range')),
                      (e = /bytes (\d+)-(\d+)\/(\d+)/.exec(e)),
                      (e = parseInt(e[1], 10)),
                      d.onDone({ begin: e, chunk: c });
                  else if (d.onProgressiveData) d.onDone(null);
                  else if (c) d.onDone({ begin: 0, chunk: c });
                  else if (d.onError) d.onError(e.status);
                } else if (d.onError) d.onError(e.status);
              }
          }
        },
        hasPendingRequests: function() {
          for (var a in this.pendingRequests) return !0;
          return !1;
        },
        getRequestXhr: function(a) {
          return this.pendingRequests[a].xhr;
        },
        isStreamingRequest: function(a) {
          return !!this.pendingRequests[a].onProgressiveData;
        },
        isPendingRequest: function(a) {
          return a in this.pendingRequests;
        },
        isLoadedRequest: function(a) {
          return a in this.loadedRequests;
        },
        abortAllRequests: function() {
          for (var a in this.pendingRequests) this.abortRequest(a | 0);
        },
        abortRequest: function(a) {
          var b = this.pendingRequests[a].xhr;
          delete this.pendingRequests[a];
          b.abort();
        },
      };
      b.prototype = {
        _onRangeRequestReaderClosed: function(a) {
          a = this._rangeRequestReaders.indexOf(a);
          0 <= a && this._rangeRequestReaders.splice(a, 1);
        },
        getFullReader: function() {
          (0, u.assert)(!this._fullRequestReader);
          return (this._fullRequestReader = new v(this._manager, this._options));
        },
        getRangeReader: function(a, b) {
          var e = new d(this._manager, a, b);
          e.onClosed = this._onRangeRequestReaderClosed.bind(this);
          this._rangeRequestReaders.push(e);
          return e;
        },
        cancelAllRequests: function(a) {
          this._fullRequestReader && this._fullRequestReader.cancel(a);
          this._rangeRequestReaders.slice(0).forEach(function(b) {
            b.cancel(a);
          });
        },
      };
      v.prototype = {
        _onHeadersReceived: function() {
          var a = this._fullRequestId,
            b = this._manager.getRequestXhr(a),
            d = (0, z.validateRangeRequestCapabilities)({
              getResponseHeader: function(a) {
                return b.getResponseHeader(a);
              },
              isHttp: this._manager.isHttp,
              rangeChunkSize: this._rangeChunkSize,
              disableRange: this._disableRange,
            }),
            k = d.allowRangeRequests;
          this._contentLength = d.suggestedLength || this._contentLength;
          k && (this._isRangeSupported = !0);
          d = this._manager;
          d.isStreamingRequest(a) ? (this._isStreamingSupported = !0) : this._isRangeSupported && d.abortRequest(a);
          this._headersReceivedCapability.resolve();
        },
        _onProgressiveData: function(a) {
          0 < this._requests.length
            ? this._requests.shift().resolve({ value: a, done: !1 })
            : this._cachedChunks.push(a);
        },
        _onDone: function(a) {
          a && this._onProgressiveData(a.chunk);
          this._done = !0;
          0 < this._cachedChunks.length ||
            (this._requests.forEach(function(a) {
              a.resolve({ value: void 0, done: !0 });
            }),
            (this._requests = []));
        },
        _onError: function(a) {
          var b = this._url,
            d = (0, z.createResponseStatusError)(a, b);
          this._storedError = d;
          this._headersReceivedCapability.reject(d);
          this._requests.forEach(function(a) {
            a.reject(d);
          });
          this._requests = [];
          this._cachedChunks = [];
        },
        _onProgress: function(a) {
          if (this.onProgress)
            this.onProgress({ loaded: a.loaded, total: a.lengthComputable ? a.total : this._contentLength });
        },
        get isRangeSupported() {
          return this._isRangeSupported;
        },
        get isStreamingSupported() {
          return this._isStreamingSupported;
        },
        get contentLength() {
          return this._contentLength;
        },
        get headersReady() {
          return this._headersReceivedCapability.promise;
        },
        read: function() {
          if (this._storedError) return Promise.reject(this._storedError);
          if (0 < this._cachedChunks.length) {
            var a = this._cachedChunks.shift();
            return Promise.resolve({ value: a, done: !1 });
          }
          if (this._done) return Promise.resolve({ value: void 0, done: !0 });
          a = (0, u.createPromiseCapability)();
          this._requests.push(a);
          return a.promise;
        },
        cancel: function(a) {
          this._done = !0;
          this._headersReceivedCapability.reject(a);
          this._requests.forEach(function(a) {
            a.resolve({ value: void 0, done: !0 });
          });
          this._requests = [];
          this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId);
          this._fullRequestReader = null;
        },
      };
      d.prototype = {
        _close: function() {
          if (this.onClosed) this.onClosed(this);
        },
        _onDone: function(a) {
          a = a.chunk;
          0 < this._requests.length ? this._requests.shift().resolve({ value: a, done: !1 }) : (this._queuedChunk = a);
          this._done = !0;
          this._requests.forEach(function(a) {
            a.resolve({ value: void 0, done: !0 });
          });
          this._requests = [];
          this._close();
        },
        _onProgress: function(a) {
          if (!this.isStreamingSupported && this.onProgress) this.onProgress({ loaded: a.loaded });
        },
        get isStreamingSupported() {
          return !1;
        },
        read: function() {
          if (null !== this._queuedChunk) {
            var a = this._queuedChunk;
            this._queuedChunk = null;
            return Promise.resolve({ value: a, done: !1 });
          }
          if (this._done) return Promise.resolve({ value: void 0, done: !0 });
          a = (0, u.createPromiseCapability)();
          this._requests.push(a);
          return a.promise;
        },
        cancel: function(a) {
          this._done = !0;
          this._requests.forEach(function(a) {
            a.resolve({ value: void 0, done: !0 });
          });
          this._requests = [];
          this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId);
          this._close();
        },
      };
      m.PDFNetworkStream = b;
      m.NetworkManager = a;
    },
  ]);
});
(function(h) {
  function d() {
    'undefined' != typeof QUnit && console.log('scrollIntoView called with ', arguments);
  }
  h = (function() {
    function c(a) {
      this.textLayerDiv = a.textLayerDiv;
      this.divContentDone = this.renderingDone = !1;
      this.pageIdx = a.pageIndex;
      this.pageNumber = this.pageIdx + 1;
      this.matches = [];
      this.viewport = a.viewport;
      this.textDivs = [];
      this.findController = a.findController || null;
      this.textLayerRenderTask = null;
      this._bindMouse();
    }
    c.prototype = {
      _finishRendering: function() {
        this.renderingDone = !0;
        var a = document.createElement('div');
        a.className = 'endOfContent';
        this.textLayerDiv.appendChild(a);
        a = document.createEvent('CustomEvent');
        a.initCustomEvent('textlayerrendered', !0, !0, { pageNumber: this.pageNumber });
        this.textLayerDiv.dispatchEvent(a);
      },
      render: function(a) {
        if (this.divContentDone && !this.renderingDone) {
          this.textLayerRenderTask && (this.textLayerRenderTask.cancel(), (this.textLayerRenderTask = null));
          this.textDivs = [];
          var b = document.createDocumentFragment();
          this.textLayerRenderTask = PDFJS.renderTextLayer({
            textContent: this.textContent,
            container: b,
            viewport: this.viewport,
            textDivs: this.textDivs,
            timeout: a,
          });
          this.textLayerRenderTask.promise.then(
            function() {
              this.textLayerDiv.appendChild(b);
              this._finishRendering();
              this.updateMatches();
            }.bind(this),
            function(a) {},
          );
        }
      },
      setTextContent: function(a) {
        this.textLayerRenderTask && (this.textLayerRenderTask.cancel(), (this.textLayerRenderTask = null));
        this.textContent = a;
        this.divContentDone = !0;
      },
      convertMatches: function(a) {
        for (
          var b = 0,
            e = 0,
            m = this.textContent.items,
            c = m.length - 1,
            f = null === this.findController ? 0 : this.findController.state.query.length,
            d = [],
            g = 0,
            p = a.length;
          g < p;
          g++
        ) {
          for (var k = a[g]; b !== c && k >= e + m[b].str.length; ) (e += m[b].str.length), b++;
          b === m.length && console.error('Could not find a matching mapping');
          var h = { begin: { divIdx: b, offset: k - e } };
          for (k += f; b !== c && k > e + m[b].str.length; ) (e += m[b].str.length), b++;
          h.end = { divIdx: b, offset: k - e };
          d.push(h);
        }
        return d;
      },
      renderMatches: function(a) {
        function b(a, b) {
          var c = a.divIdx;
          d[c].textContent = '';
          e(c, 0, a.offset, b);
        }
        function e(a, b, e, m) {
          var f = d[a];
          a = c[a].str.substring(b, e);
          a = document.createTextNode(a);
          m
            ? ((b = document.createElement('span')), (b.className = m), b.appendChild(a), f.appendChild(b))
            : f.appendChild(a);
        }
        if (0 !== a.length) {
          var c = this.textContent.items,
            d = this.textDivs,
            f = null,
            g = this.pageIdx,
            h = null === this.findController ? !1 : g === this.findController.selected.pageIdx,
            p = null === this.findController ? -1 : this.findController.selected.matchIdx,
            k = p,
            r = k + 1;
          if (null === this.findController ? 0 : this.findController.state.highlightAll) (k = 0), (r = a.length);
          else if (!h) return;
          for (; k < r; k++) {
            var n = a[k],
              l = n.begin;
            n = n.end;
            var q = h && k === p ? ' selected' : '';
            this.findController && this.findController.updateMatchPosition(g, k, d, l.divIdx, n.divIdx);
            f && l.divIdx === f.divIdx
              ? e(f.divIdx, f.offset, l.offset)
              : (null !== f && e(f.divIdx, f.offset, void 0), b(l));
            if (l.divIdx === n.divIdx) e(l.divIdx, l.offset, n.offset, 'highlight' + q);
            else {
              e(l.divIdx, l.offset, void 0, 'highlight begin' + q);
              f = l.divIdx + 1;
              for (l = n.divIdx; f < l; f++) d[f].className = 'highlight middle' + q;
              b(n, 'highlight end' + q);
            }
            f = n;
          }
          f && e(f.divIdx, f.offset, void 0);
        }
      },
      updateMatches: function() {
        if (this.renderingDone) {
          for (
            var a = this.matches, b = this.textDivs, e = this.textContent.items, c = -1, d = 0, f = a.length;
            d < f;
            d++
          ) {
            var g = a[d];
            c = Math.max(c, g.begin.divIdx);
            for (var h = g.end.divIdx; c <= h; c++) {
              var p = b[c];
              p.textContent = e[c].str;
              p.className = '';
            }
            c = g.end.divIdx + 1;
          }
          null !== this.findController &&
            this.findController.active &&
            ((this.matches = this.convertMatches(
              null === this.findController ? [] : this.findController.pageMatches[this.pageIdx] || [],
            )),
            this.renderMatches(this.matches));
        }
      },
      _bindMouse: function() {
        var a = this.textLayerDiv;
        a.addEventListener('mousedown', function(b) {
          var e = a.querySelector('.endOfContent');
          if (e) {
            var c = b.target !== a;
            if ((c = c && 'none' !== window.getComputedStyle(e).getPropertyValue('-moz-user-select')))
              (c = a.getBoundingClientRect()),
                (e.style.top = (100 * Math.max(0, (b.pageY - c.top) / c.height)).toFixed(2) + '%');
            e.classList.add('active');
          }
        });
        a.addEventListener('mouseup', function(b) {
          if ((b = a.querySelector('.endOfContent'))) (b.style.top = ''), b.classList.remove('active');
        });
      },
    };
    return c;
  })();
  var c = (function() {
    function c(a) {
      this.startedTextExtraction = !1;
      this.extractTextPromises = [];
      this.pendingFindMatches = {};
      this.active = !1;
      this.pageContents = [];
      this.pageMatches = [];
      this.matchCount = 0;
      this.selected = { pageIdx: -1, matchIdx: -1 };
      this.offset = { pageIdx: null, matchIdx: null };
      this.state = this.resumePageIdx = this.pagesToSearch = null;
      this.dirtyMatch = !1;
      this.findTimeout = null;
      this.pdfViewer = a.pdfViewer || null;
      this.integratedFind = a.integratedFind || !1;
      this.charactersToNormalize = {
        '\u2018': "'",
        '\u2019': "'",
        '\u201a': "'",
        '\u201b': "'",
        '\u201c': '"',
        '\u201d': '"',
        '\u201e': '"',
        '\u201f': '"',
        '\u00bc': '1/4',
        '\u00bd': '1/2',
        '\u00be': '3/4',
      };
      this.findBar = a.findBar || null;
      a = Object.keys(this.charactersToNormalize).join('');
      this.normalizationRegex = new RegExp('[' + a + ']', 'g');
      a = ['find', 'findagain', 'findhighlightallchange', 'findcasesensitivitychange'];
      this.firstPagePromise = new Promise(
        function(a) {
          this.resolveFirstPage = a;
        }.bind(this),
      );
      this.handleEvent = this.handleEvent.bind(this);
      for (var b = 0, c = a.length; b < c; b++) window.addEventListener(a[b], this.handleEvent);
    }
    c.prototype = {
      setFindBar: function(a) {
        this.findBar = a;
      },
      reset: function() {
        this.startedTextExtraction = !1;
        this.extractTextPromises = [];
        this.active = !1;
      },
      normalize: function(a) {
        var b = this;
        return a.replace(this.normalizationRegex, function(a) {
          return b.charactersToNormalize[a];
        });
      },
      calcFindMatch: function(a) {
        var b = this.normalize(this.pageContents[a]),
          c = this.normalize(this.state.query),
          d = c.length;
        if (0 !== d) {
          this.state.caseSensitive || ((b = b.toLowerCase()), (c = c.toLowerCase()));
          for (var g = [], f = -d; ; ) {
            f = b.indexOf(c, f + d);
            if (-1 === f) break;
            g.push(f);
          }
          this.pageMatches[a] = g;
          this.updatePage(a);
          this.resumePageIdx === a && ((this.resumePageIdx = null), this.nextPageMatch());
          0 < g.length && ((this.matchCount += g.length), this.updateUIResultsCount());
        }
      },
      extractText: function() {
        function a(c) {
          g.pdfViewer.getPageTextContent(c).then(function(e) {
            e = e.items;
            for (var d = [], f = 0, h = e.length; f < h; f++) d.push(e[f].str);
            g.pageContents.push(d.join(''));
            b[c](c);
            c + 1 < g.pdfViewer.pagesCount && a(c + 1);
          });
        }
        if (!this.startedTextExtraction) {
          this.startedTextExtraction = !0;
          this.pageContents = [];
          for (var b = [], c = this.pdfViewer.pagesCount, d = 0; d < c; d++)
            this.extractTextPromises.push(
              new Promise(function(a) {
                b.push(a);
              }),
            );
          var g = this;
          a(0);
        }
      },
      handleEvent: function(a) {
        if (null === this.state || 'findagain' !== a.type) this.dirtyMatch = !0;
        this.state = a.detail;
        this.updateUIState(3);
        this.firstPagePromise.then(
          function() {
            this.extractText();
            clearTimeout(this.findTimeout);
            'find' === a.type ? (this.findTimeout = setTimeout(this.nextMatch.bind(this), 250)) : this.nextMatch();
          }.bind(this),
        );
      },
      updatePage: function(a) {
        this.selected.pageIdx === a && this.pdfViewer.scrollPageIntoView(a + 1);
        a = this.pdfViewer.getPageView(a);
        a.textLayer && a.textLayer.updateMatches();
      },
      nextMatch: function() {
        var a = this.state.findPrevious,
          b = this.pdfViewer.currentPageNumber - 1,
          c = this.pdfViewer.pagesCount;
        this.active = !0;
        if (this.dirtyMatch) {
          this.dirtyMatch = !1;
          this.selected.pageIdx = this.selected.matchIdx = -1;
          this.offset.pageIdx = b;
          this.offset.matchIdx = null;
          this.hadMatch = !1;
          this.resumePageIdx = null;
          this.pageMatches = [];
          this.matchCount = 0;
          var d = this;
          for (b = 0; b < c; b++)
            this.updatePage(b),
              b in this.pendingFindMatches ||
                ((this.pendingFindMatches[b] = !0),
                this.extractTextPromises[b].then(function(a) {
                  delete d.pendingFindMatches[a];
                  d.calcFindMatch(a);
                }));
        }
        if ('' === this.state.query) this.updateUIState(0);
        else if (!this.resumePageIdx) {
          b = this.offset;
          this.pagesToSearch = c;
          if (null !== b.matchIdx) {
            c = this.pageMatches[b.pageIdx].length;
            if ((!a && b.matchIdx + 1 < c) || (a && 0 < b.matchIdx)) {
              this.hadMatch = !0;
              b.matchIdx = a ? b.matchIdx - 1 : b.matchIdx + 1;
              this.updateMatch(!0);
              return;
            }
            this.advanceOffsetPage(a);
          }
          this.nextPageMatch();
        }
      },
      matchesReady: function(a) {
        var b = this.offset;
        a = a.length;
        var c = this.state.findPrevious;
        if (a) return (this.hadMatch = !0), (b.matchIdx = c ? a - 1 : 0), this.updateMatch(!0), !0;
        this.advanceOffsetPage(c);
        return b.wrapped && ((b.matchIdx = null), 0 > this.pagesToSearch) ? (this.updateMatch(!1), !0) : !1;
      },
      updateMatchPosition: function(a, b, c, g, h) {
        this.selected.matchIdx === b && this.selected.pageIdx === a && d(c[g], { top: -50, left: -400 }, !0);
      },
      nextPageMatch: function() {
        null !== this.resumePageIdx && console.error('There can only be one pending page.');
        do {
          var a = this.offset.pageIdx,
            b = this.pageMatches[a];
          if (!b) {
            this.resumePageIdx = a;
            break;
          }
        } while (!this.matchesReady(b));
      },
      advanceOffsetPage: function(a) {
        var b = this.offset,
          c = this.extractTextPromises.length;
        b.pageIdx = a ? b.pageIdx - 1 : b.pageIdx + 1;
        b.matchIdx = null;
        this.pagesToSearch--;
        if (b.pageIdx >= c || 0 > b.pageIdx) (b.pageIdx = a ? c - 1 : 0), (b.wrapped = !0);
      },
      updateMatch: function(a) {
        var b = 1,
          c = this.offset.wrapped;
        this.offset.wrapped = !1;
        a &&
          ((a = this.selected.pageIdx),
          (this.selected.pageIdx = this.offset.pageIdx),
          (this.selected.matchIdx = this.offset.matchIdx),
          (b = c ? 2 : 0),
          -1 !== a && a !== this.selected.pageIdx && this.updatePage(a));
        this.updateUIState(b, this.state.findPrevious);
        -1 !== this.selected.pageIdx && this.updatePage(this.selected.pageIdx);
      },
      updateUIResultsCount: function() {
        if (null === this.findBar) throw Error('PDFFindController is not initialized with a PDFFindBar instance.');
        this.findBar.updateResultsCount(this.matchCount);
      },
      updateUIState: function(a, b) {
        if (this.integratedFind) FirefoxCom.request('updateFindControlState', { result: a, findPrevious: b });
        else {
          if (null === this.findBar) throw Error('PDFFindController is not initialized with a PDFFindBar instance.');
          this.findBar.updateUIState(a, b, this.matchCount);
        }
      },
    };
    return c;
  })();
  PDFJS.TextLayerBuilder = h;
  PDFJS.TextLayerBuilder.TEXT_LAYER_RENDER_DELAY = 200;
  PDFJS.PDFFindController = c;
})(jQuery);
jQuery(function(h) {
  h.extend(h.wowBook.wowBookConstructor.prototype, {
    pdfFindBarMethods: function(d) {
      d.updateUIState = function(c, d, a) {
        var b = '';
        1 == c && (b = 'Phrase not found');
        2 == c && (b = 'Reached ' + (d ? 'top' : 'end') + ' of document, continued from ' + (d ? 'bottom' : 'top'));
        this.toggleClass('wowbook-find-pending', 3 == c);
        this.find('.wowbook-find-msg').text(b);
        this.updateResultsCount(a);
      };
      d.updateResultsCount = function(c) {
        var g = '';
        '' != d.find('.wowbook-find-text').val() && (g = this.getMatchIndex() + ' of ' + c);
        h('.wowbook-find-count').text(g);
        h('.wowbook-find-results-count')
          .text(c || '')
          .css('display', c ? 'inline-block' : 'none');
      };
      d.getMatchIndex = function(c) {
        c || (c = this.controller.selected);
        if (!this.controller.matchCount || !c || -1 == (c && c.pageIdx)) return 0;
        for (var d = this.controller.pageMatches, a = 0, b = 0; b < c.pageIdx; b++) a += d[b].length;
        a += c.matchIdx;
        return a + 1;
      };
      this._pdfFindController && (this._pdfFindController.findBar = d);
      return d;
    },
    pdfCreateViewer: function() {
      var d = this;
      return {
        pagesCount: 0,
        findController: null,
        getPageTextContent: function(c) {
          return d.pdfDoc.getPage(c + 1).then(function(c) {
            return c.getTextContent({ normalizeWhitespace: !0 });
          });
        },
        getPageView: function(c) {
          c = d.pages[c];
          c.textLayer && !c.textLayer.findController && (c.textLayer.findController = this.findController);
          return c;
        },
        scrollPageIntoView: function(c, g) {
          d.showPage(c - 1);
        },
      };
    },
    pdfCreateFindController: function(d) {
      d || (d = this.pdfCreateViewer());
      this._pdfFindController = new PDFJS.PDFFindController({ pdfViewer: d, findBar: this._pdfFindBar });
      d.findController = this._pdfFindController;
      return (this._pdfFindController.findBar.controller = this._pdfFindController);
    },
    pdfSearch: function(d, c, g, a, b) {
      this._pdfFindController || this.pdfFindSetup();
      var e = this._pdfFindController;
      e.pdfViewer.pagesCount = this.pages.length;
      e.pdfViewer.currentPageNumber = this.currentPage + 1;
      e.handleEvent({
        type: 'find' + (b || ''),
        detail: { query: d, caseSensitive: g, highlightAll: c, findPrevious: a },
      });
    },
  });
});
